import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, forwardRef, ViewChild, ChangeDetectionStrategy, NgModule, ContentChildren, Inject, PLATFORM_ID, ViewEncapsulation, Directive, HostListener, Optional, ViewContainerRef, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule, isPlatformBrowser, DOCUMENT } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpEventType, HttpClientModule, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i2$2 from '@angular/forms';
import { UntypedFormGroup, NG_VALUE_ACCESSOR, NgControl, FormsModule, UntypedFormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import * as i1$2 from '@angular/platform-browser';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i1$3 from '@ngx-formly/core';
import { FieldArrayType, FieldType, FieldWrapper, FormlyModule } from '@ngx-formly/core';
import * as i4$7 from '@ngx-formly/core/select';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import * as i2$5 from 'ngx-editor';
import { Editor, toHTML, NgxEditorModule } from 'ngx-editor';
import * as i1$1 from 'primeng/api';
import { PrimeTemplate, SharedModule, FilterOperator, FilterMatchMode, TranslationKeys, MessageService, ConfirmationService } from 'primeng/api';
import * as i5 from 'primeng/autocomplete';
import { AutoCompleteModule } from 'primeng/autocomplete';
import * as i3$5 from 'primeng/badge';
import { BadgeModule } from 'primeng/badge';
import * as i3$4 from 'primeng/blockui';
import { BlockUIModule } from 'primeng/blockui';
import * as i6$3 from 'primeng/chip';
import { ChipModule } from 'primeng/chip';
import * as i3$1 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i3$3 from 'primeng/calendar';
import { CalendarModule } from 'primeng/calendar';
import * as i4$4 from 'primeng/card';
import { CardModule } from 'primeng/card';
import * as i9 from 'primeng/confirmdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import * as i8 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
import * as i2$3 from 'primeng/divider';
import { DividerModule } from 'primeng/divider';
import * as i3 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import * as i3$c from 'primeng/dataview';
import { DataViewModule } from 'primeng/dataview';
import * as i3$7 from 'primeng/inputmask';
import { InputMaskModule } from 'primeng/inputmask';
import * as i4 from 'primeng/inputnumber';
import { InputNumberModule } from 'primeng/inputnumber';
import * as i3$6 from 'primeng/inputswitch';
import { InputSwitchModule } from 'primeng/inputswitch';
import * as i3$2 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import * as i4$6 from 'primeng/inputtextarea';
import { InputTextareaModule } from 'primeng/inputtextarea';
import * as i4$2 from 'primeng/menu';
import { MenuModule } from 'primeng/menu';
import * as i3$8 from 'primeng/multiselect';
import { MultiSelectModule } from 'primeng/multiselect';
import * as i4$3 from 'primeng/panel';
import { PanelModule } from 'primeng/panel';
import * as i3$9 from 'primeng/password';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import * as i6$2 from 'primeng/selectbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import * as i3$b from 'primeng/avatar';
import { AvatarModule } from 'primeng/avatar';
import * as i5$1 from 'primeng/listbox';
import { ListboxModule } from 'primeng/listbox';
import * as i3$a from 'primeng/steps';
import { StepsModule } from 'primeng/steps';
import * as i7 from 'primeng/toast';
import { ToastModule } from 'primeng/toast';
import * as i7$1 from 'primeng/toolbar';
import { ToolbarModule } from 'primeng/toolbar';
import * as i9$1 from 'primeng/image';
import { ImageModule } from 'primeng/image';
import * as i2$6 from 'primeng/chart';
import { UIChart, ChartModule } from 'primeng/chart';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { of, Subject, BehaviorSubject, AsyncSubject, delay, Observable, timer, forkJoin, take as take$1, map as map$1 } from 'rxjs';
import * as _ from 'lodash';
import { cloneDeep, isObjectLike, templateSettings, template, isNumber } from 'lodash';
import { DateTime } from 'luxon';
import * as xlsx from 'xlsx';
import { take, map, mergeMap, last, filter, finalize } from 'rxjs/operators';
import { DomHandler, ConnectedOverlayScrollHandler } from 'primeng/dom';
import { UniqueComponentId, ObjectUtils, ZIndexUtils } from 'primeng/utils';
import * as i2$1 from 'primeng/tooltip';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { ArrowDownIcon } from 'primeng/icons/arrowdown';
import { ArrowUpIcon } from 'primeng/icons/arrowup';
import { CheckIcon } from 'primeng/icons/check';
import { FilterIcon } from 'primeng/icons/filter';
import { FilterSlashIcon } from 'primeng/icons/filterslash';
import { SortAltIcon } from 'primeng/icons/sortalt';
import { SortAmountDownIcon } from 'primeng/icons/sortamountdown';
import { SortAmountUpAltIcon } from 'primeng/icons/sortamountupalt';
import { SpinnerIcon } from 'primeng/icons/spinner';
import * as i4$1 from 'primeng/scroller';
import { ScrollerModule } from 'primeng/scroller';
import * as i11 from 'primeng/tristatecheckbox';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { AngleDoubleLeftIcon } from 'primeng/icons/angledoubleleft';
import { AngleDoubleRightIcon } from 'primeng/icons/angledoubleright';
import { AngleLeftIcon } from 'primeng/icons/angleleft';
import { AngleRightIcon } from 'primeng/icons/angleright';
import * as i6 from 'primeng/ripple';
import { RippleModule } from 'primeng/ripple';
import { PlusIcon } from 'primeng/icons/plus';
import { TimesIcon } from 'primeng/icons/times';
import { UploadIcon } from 'primeng/icons/upload';
import * as i6$1 from 'primeng/progressbar';
import { ProgressBarModule } from 'primeng/progressbar';
import { ExclamationTriangleIcon } from 'primeng/icons/exclamationtriangle';
import { InfoCircleIcon } from 'primeng/icons/infocircle';
import { TimesCircleIcon } from 'primeng/icons/timescircle';
import { Guid } from 'guid-typescript';
import * as i1$4 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import * as i4$5 from 'ngx-image-compress';
import { DOC_ORIENTATION } from 'ngx-image-compress';
import * as i2$4 from 'ngx-filesaver';
import * as jsdiff from 'diff';
import * as fileSaver from 'file-saver';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import * as pbi from 'powerbi-client';
import { schema } from 'ngx-editor/schema';
import ChartDataLabels from 'chartjs-plugin-datalabels';

class DspxCoreService {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class DspxCoreComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCoreComponent, selector: "lib-dspx-core", ngImport: i0, template: `
    <p>
      dspx-core works!
    </p>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-dspx-core', template: `
    <p>
      dspx-core works!
    </p>
  ` }]
        }], ctorParameters: () => [] });

class ApplicationSettings {
}

class ApplicationSettingsService {
    constructor() {
        this.appSettings = null;
    }
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/481
    //getConfig(): AppSettings {
    //  const response = this.testingDataService.getJsonViaSyncHttpGet('/assets/appsettings.json');
    //  return response as AppSettings;
    //}
    loadAppConfig() {
        const config = {
            env: {
                name: 'dev'
            },
            api: {
                baseUrl: '',
                addressApiBaseUrl: '',
                addressApiKey: '',
                addressApiSearchEndpoint: '/search',
                addressApiLgaEndpoint: '/lga',
            },
            recaptcha: {
                siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
            },
            aad: {
                authority: '',
                clientId: '',
                redirectUri: '',
                resourceUri: ''
            },
            arcGis: {
                geocodeServiceUrl: 'http://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            }
        };
        this.appSettings = this.mapToAppSettings(config);
        return this.appSettings;
    }
    loadAppConfigAsync() {
        const config = this.loadAppConfig();
        return of(config).toPromise();
    }
    mapToAppSettings(raSettings) {
        if (!raSettings) {
            throw new Error('raSettings is undefined');
        }
        const settings = new ApplicationSettings();
        settings.environment = raSettings.env.name;
        settings.apiUrl = this.getBaseUri();
        settings.addressApiBaseUrl = raSettings.api.addressApiBaseUrl;
        settings.addressApiKey = raSettings.api.addressApiKey;
        settings.addressApiSearchEndpoint = raSettings.api.addressApiSearchEndpoint;
        settings.addressApiLgaEndpoint = raSettings.api.addressApiLgaEndpoint;
        settings.recaptchaSiteKey = raSettings.recaptcha.siteKey;
        settings.arcGisGeocodeServiceUrl = raSettings.arcGis.geocodeServiceUrl;
        return settings;
    }
    getBaseUri() {
        if (document.baseURI)
            return document.baseURI;
        const base = document.getElementsByTagName('base');
        if (base.length > 0)
            return base[0].href;
        return undefined;
        //For testing purposes.
        //return 'https://localhost:5001/'
    }
    getAppSettings() {
        if (this.appSettings) {
            return this.appSettings;
        }
        throw new Error('appSettings is not defined');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ApplicationSettingsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ApplicationSettingsService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ApplicationSettingsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform',
                }]
        }], ctorParameters: () => [] });

class TestingDataService {
    getJsonViaSyncHttpGet(url) {
        const xmlRequest = new XMLHttpRequest();
        xmlRequest.open('GET', url, false);
        xmlRequest.send(null);
        return JSON.parse(xmlRequest.responseText);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TestingDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TestingDataService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TestingDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class ApiService {
    constructor(http, baseUrl) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /** url may be relative or absolute. If it's relative, it will be prefixed with baseUrl. */
    getUrl(url) {
        // If not specified, just use baseUrl
        if (!url) {
            return this.baseUrl;
        }
        // If supplied url is absolute, just use what was passed in
        if (url.startsWith("http://") || url.startsWith("https://")) {
            return url;
        }
        // If supplied URL is relative, make it absolute by combining it with baseUrl, making sure not to duplicate
        // slashes
        if (this.baseUrl.endsWith('/') || url.startsWith('/')) {
            return `${this.baseUrl}${url}`;
        }
        return `${this.baseUrl}/${url}`;
    }
    get(relativeOrAbsoluteUrl, options) {
        const url = this.getUrl(relativeOrAbsoluteUrl);
        const preparedOptions = this.prepareOptions(options);
        const response = this.http.get(url, preparedOptions);
        return response;
    }
    put(relativeOrAbsoluteUrl, body, options) {
        const url = this.getUrl(relativeOrAbsoluteUrl);
        const preparedOptions = this.prepareOptions(options);
        const response = this.http.put(url, body, preparedOptions);
        return response;
    }
    post(relativeOrAbsoluteUrl, body, options) {
        const url = this.getUrl(relativeOrAbsoluteUrl);
        const preparedOptions = this.prepareOptions(options);
        const subscription = this.http.post(url, body, preparedOptions);
        return subscription;
    }
    postAndFetch(relativeOrAbsoluteUrl, body, options) {
        const url = this.getUrl(relativeOrAbsoluteUrl);
        const preparedOptions = this.prepareOptions(options);
        const subscription = this.http.post(url, body, preparedOptions);
        return subscription;
    }
    delete(relativeOrAbsoluteUrl, options) {
        const url = this.getUrl(relativeOrAbsoluteUrl);
        const preparedOptions = this.prepareOptions(options);
        const response = this.http.delete(url, preparedOptions);
        return response;
    }
    prepareOptions(parameterOption) {
        return parameterOption;
    }
}

class TableColumn {
    constructor() {
        this.includeInExport = false;
        this.sortable = true;
        this.dataType = 'text';
        this.showFilter = false;
        this.visible = true;
        this.includeInGlobalSearch = true;
        this.hideable = false;
    }
}

class DashboardOptions {
    constructor() {
        this.key = 'id';
        this.checkboxSelection = true;
        this.rowHover = true;
        this.filterDelay = 0;
        this.globalFilterPlaceHolder = 'Search records';
        this.allowColumResize = true;
        this.paginator = true;
        this.rowsPerPageOptions = [25, 50, 100, 200];
        this.rowsPerPage = 25;
        this.showCurrentPageReport = true;
        this.currentPageReportTemplate = 'Showing {first} to {last} of {totalRecords} entries';
        this.noRecordFoundMessage = 'No records found.';
        this.allowEdit = false;
        this.allowView = false;
        this.allowPrint = false;
        this.actionButtons = [];
        this.cols = [];
        this.allowCsvExport = false;
        this.allowPdfExport = false;
        this.allowExcelExport = false;
        this.allowAdd = false;
    }
}

class Option {
}

var ButtonType;
(function (ButtonType) {
    ButtonType["new"] = "new";
    ButtonType["doubleClick"] = "doubleClick";
    ButtonType["edit"] = "edit";
    ButtonType["save"] = "save";
    ButtonType["close"] = "close";
    ButtonType["view"] = "view";
    ButtonType["print"] = "print";
    ButtonType["delete"] = "delete";
    ButtonType["deactivate"] = "deactivate";
    ButtonType["download"] = "download";
    ButtonType["payment"] = "payment";
    ButtonType["empty"] = "empty";
    ButtonType["listItem"] = "listItem";
    ButtonType["custom"] = "custom";
    ButtonType["colLink"] = "colLink";
    ButtonType["default"] = "none";
})(ButtonType || (ButtonType = {}));

class UploadedFile {
}

class OptionSetService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
    }
    setOptionSets(optionSets) {
        this._optionSets = optionSets;
    }
    getOptionSet(optionSetName, includeEmptyOption) {
        if (optionSetName !== null && optionSetName !== undefined && optionSetName !== ''
            && this._optionSets?.[optionSetName] !== undefined && this._optionSets?.[optionSetName] !== null) {
            let optionSet = this._optionSets[optionSetName];
            let optionSetCopy = cloneDeep(optionSet);
            if (includeEmptyOption && optionSet.find(os => os.code === null && os.text === ' ') === undefined) {
                optionSetCopy.unshift({ code: null, text: ' ' });
            }
            return optionSetCopy;
        }
        return [];
    }
    getOptionSetViaApi(apiEndpoint, optionSetName) {
        return this.post(apiEndpoint, { optionSetName: optionSetName });
        //For testing purposes
        //const response = this.testingDataService.getJsonViaSyncHttpGet('/assets/config/TestOptionSet.json');
        //return of(response);
    }
    getOptionText(optionSetName, code) {
        if (optionSetName && code) {
            const codes = typeof code === "string" ? [code] : code;
            if (codes.length) {
                const optionSet = this._optionSets[optionSetName];
                if (optionSet && optionSet.length) {
                    return codes
                        .map(c => optionSet.find(o => o.code === c))
                        .filter(o => o)
                        .map(o => o.text)
                        .join(', ');
                }
            }
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionSetService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionSetService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionSetService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }] });

class CoreService {
    constructor(optionSetService) {
        this.optionSetService = optionSetService;
        this.applicationTitle = '';
        this.activeFormName = '';
        this.loggedInUser = '';
    }
    setLoggedInUser(userName) {
        this.loggedInUser = userName;
    }
    getLoggedInUser() {
        return this.loggedInUser;
    }
    getCurrentDate() {
        const today = DateTime.now().reconfigure({ locale: 'en-AU' });
        return today.toFormat("dd/MM/yyyy");
    }
    getCurrentDateTime() {
        const today = DateTime.now().reconfigure({ locale: 'en-AU' });
        return today.toFormat("dd/MM/yyyy hh:mm a");
    }
    setApplicationTitle(appTitle) {
        this.applicationTitle = appTitle;
    }
    getApplicationTitle() {
        return this.applicationTitle;
    }
    setActiveFormName(formName) {
        this.activeFormName = formName;
    }
    getActiveFormName() {
        return this.activeFormName;
    }
    setFormEditable(isFormEditable) {
        this.isFormEditable = isFormEditable;
    }
    getFieldValue(field) {
        if (!field.model) {
            return null;
        }
        const key = (typeof field.key === typeof Array) ? field.key[0] : field.key;
        const value = (field.type === 'autocomplete') ? field.model[key]?.code : field.model[key];
        // TO-DO: add support for optionset with API source
        if (field.props.optionSet) {
            const optionSetName = field.props.optionSet?.dependentOptionSetName || field.props.optionSet?.name;
            return this.optionSetService.getOptionText(optionSetName, value);
        }
        return value;
    }
    /**
     * This method tries to reset the model of a control by repeating the Angular form.reset method multiple times.
     * The retries are needed when the model contains dependencies between questions (e.g. dependent dropdowns, visibility conditions, etc.),
     * to make sure all the dependencies are also updated in the model and reflected in the user interface.
     * @param control
     * The control that needs to be reset.
     * @param oldModel
     * The old model that needs to be applied to the current model.
     * @param currentModel
     * The current model that is bound to the control and needs to be reset with the values from the old model.
     * This is used to verify if the changes have not been fully applied and another form reset is needed.
     * @param onComplete
     * The callback run after the end of the method.
     * This is needed because the comparison between the old and the current model needs to run on the next execution cycle
     * (i.e. after a setTimeout with 0ms delay) in order for the current model to contain the actual values.
     * - argument "success" is false if the method failed to fully reset the model after 1 + maxRetries attempts
     * - argument "retryCount" is the number of retries that were actually performed, with a possible range of [0..maxRetries]
     * @param maxRetries
     * The maximum number of retries after which the method will give up and return success = false in the onComplete callback.
     * If not provided, this argument will default to the constant "maxResetRetries".
     * @example
     * For example, if the model contains no dependencies between questions, then only one form.reset will be run.
     * However if there are for example 2 levels of dependencies (e.g. question A depends on question B, which depends on question C),
     * then there will be 3 runs of form.reset (first run + 2 retries) in order to restore the model correctly:
     * - the first run will populate question C correctly, but still leave questions A and B empty.
     * - the second run will populate also question B, but still leave question A empty.
     * - the third run will populate also question A and the method will stop there.
     */
    resetModel(control, oldModel, currentModel, onComplete, maxRetries) {
        this.resetModelInternal(control, oldModel ?? {}, currentModel ?? {}, onComplete, maxRetries ?? CoreService.maxResetRetries, 0);
    }
    resetModelInternal(control, oldModel, currentModel, onComplete, maxRetries, retryCount) {
        control.reset(oldModel);
        setTimeout(() => {
            const success = this.isModelEqual(currentModel, oldModel);
            if (!success && retryCount < maxRetries) {
                this.resetModelInternal(control, oldModel, currentModel, onComplete, maxRetries, retryCount + 1);
            }
            else {
                onComplete?.(success, retryCount);
            }
        });
    }
    static { this.maxResetRetries = 5; }
    /**
     * Compares two JSON objects to decide whether they are functionally equivalent formly field models for the dspx framework.
     * The idea is to ignore differences when comparing models that are not relevant for the dspx framework.
     * For example a "section" formly field type might contain two non-mandatory questions "firstName" and "lastName".
     * From the dspx framework's perspective, the following two models { firstName: null, lastName: "Bloggs" } and { lastName: "Bloggs" }, are actually equivalent.
     * In general, this method performs a deep JSON comparison (like for example lodash isEqual method), but it considers any property with the following values as equivalent:
     * - undefined (or property missing altogether)
     * - null
     * - {}
     * - []
     * @param model1 one of the two model to be compared
     * @param model2 one of the two model to from the dspx framework's perspective
     * @returns true if the two model are "equal", according to the definition of "equal" outlined in the above description of this method
     */
    isModelEqual(model1, model2) {
        const isValueType = (model) => model !== undefined && model !== null && !isObjectLike(model);
        if (isValueType(model1) || isValueType(model2)) {
            return model1 === model2; // at least one of the two models is a value (i.e. string or number or boolean) => use strict equality
        }
        // get a map of object entries for both models (for entries with value undefined or null create an empty map)
        const getMap = (model) => new Map(Object.entries(model ?? {}));
        const map1 = getMap(model1);
        const map2 = getMap(model2);
        // get an array of value pairs for each respective object entries, so that they can be compared one by one
        const valuePairs = [];
        for (const [key1, value1] of map1) {
            if (!map2.has(key1)) {
                valuePairs.push([value1, null]); // value exists in object 1 but not in object 2
            }
            else {
                const value2 = map2.get(key1);
                valuePairs.push([value1, value2]); // value exists in both objects
            }
        }
        for (const [key2, value2] of map2) {
            if (!map1.has(key2)) {
                valuePairs.push([null, value2]); // value exists in object 2 but not in object 1
            }
        }
        // compare the value pairs one by one
        for (const [value1, value2] of valuePairs) {
            if (!this.isModelEqual(value1, value2)) {
                return false; // the two object have at least one different entry value => they are different models
            }
        }
        return true; // the two object have the same entries => they are equal models
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoreService, deps: [{ token: OptionSetService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoreService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: OptionSetService }] });

var MessageSeverity;
(function (MessageSeverity) {
    MessageSeverity["success"] = "success";
    MessageSeverity["info"] = "info";
    MessageSeverity["warn"] = "warn";
    MessageSeverity["error"] = "error";
})(MessageSeverity || (MessageSeverity = {}));

var NotificationType;
(function (NotificationType) {
    NotificationType["Success"] = "success";
    NotificationType["Info"] = "info";
    NotificationType["Warn"] = "warn";
    NotificationType["Error"] = "error";
    NotificationType["Custom"] = "custom";
})(NotificationType || (NotificationType = {}));

var PopupType;
(function (PopupType) {
    PopupType["confirm"] = "confirm";
    PopupType["error"] = "error";
    PopupType["warning"] = "warning";
    PopupType["custom"] = "custom";
    PopupType["info"] = "info";
})(PopupType || (PopupType = {}));

var RepeaterElementType;
(function (RepeaterElementType) {
    RepeaterElementType["AddButton"] = "A";
    RepeaterElementType["EditButton"] = "E";
    RepeaterElementType["ViewButton"] = "V";
    RepeaterElementType["RemoveButton"] = "D";
    RepeaterElementType["SaveButton"] = "S";
    RepeaterElementType["CloseButton"] = "C";
    RepeaterElementType["TopOfAddButton"] = "I";
    RepeaterElementType["TopOfItemHeader"] = "H";
    RepeaterElementType["TopOfItemContent"] = "T";
    RepeaterElementType["ItemHeaderSaveButton"] = "HS";
    RepeaterElementType["ItemHeaderCollapseButton"] = "X";
})(RepeaterElementType || (RepeaterElementType = {}));

var RepeaterItemChangeType;
(function (RepeaterItemChangeType) {
    RepeaterItemChangeType[RepeaterItemChangeType["Initialise"] = 0] = "Initialise";
    RepeaterItemChangeType[RepeaterItemChangeType["Add"] = 1] = "Add";
    RepeaterItemChangeType[RepeaterItemChangeType["Edit"] = 2] = "Edit";
    RepeaterItemChangeType[RepeaterItemChangeType["Remove"] = 3] = "Remove";
    RepeaterItemChangeType[RepeaterItemChangeType["Save"] = 4] = "Save";
    RepeaterItemChangeType[RepeaterItemChangeType["Close"] = 5] = "Close";
})(RepeaterItemChangeType || (RepeaterItemChangeType = {}));

var SupportedNavigationTargetTypes;
(function (SupportedNavigationTargetTypes) {
    SupportedNavigationTargetTypes[SupportedNavigationTargetTypes["tabs"] = 0] = "tabs";
})(SupportedNavigationTargetTypes || (SupportedNavigationTargetTypes = {}));
;

var DialogResult;
(function (DialogResult) {
    DialogResult[DialogResult["ACCEPTED"] = 0] = "ACCEPTED";
    DialogResult[DialogResult["REJECTED"] = 1] = "REJECTED";
    DialogResult[DialogResult["OTHER"] = 2] = "OTHER";
})(DialogResult || (DialogResult = {}));

var ElementType;
(function (ElementType) {
    ElementType["TAB"] = "tabs";
    ElementType["CARDSETTAB"] = "card-set-tabs";
    ElementType["CARDSETTABFLAT"] = "card-set-tabs-flat";
    ElementType["PAGE"] = "page";
    ElementType["CARDSETPAGE"] = "card-set-page";
    ElementType["PAGEREPEATING"] = "page-repeating";
    ElementType["CARDSETPAGEREPEATING"] = "card-set-page-repeating";
    ElementType["PAGESUMMARY"] = "summary-page";
    ElementType["SECTION"] = "section";
    ElementType["CARDSECTION"] = "card-section";
    ElementType["SECTIONREPEATING"] = "section-repeating";
    ElementType["CARDSECTIONREPEATING"] = "card-section-repeating";
    ElementType["SECTIONREPEATINGINFORMATION"] = "section-repeating-information";
})(ElementType || (ElementType = {}));

var NavigationKey;
(function (NavigationKey) {
    NavigationKey["TAB"] = "tabs";
    NavigationKey["PAGE"] = "page";
})(NavigationKey || (NavigationKey = {}));

var Dialogs;
(function (Dialogs) {
    Dialogs["NETWORK_ERROR"] = "networkError";
    Dialogs["DUPLICATE"] = "duplicate";
    Dialogs["CONCURRENCY"] = "concurrencyError";
    Dialogs["VALIDATION"] = "validationError";
    Dialogs["SESSION_TIMEOUT"] = "sessionTimeout";
    Dialogs["SERVER_ERROR"] = "serverError";
    Dialogs["CLIENT_ERROR"] = "clientError";
    Dialogs["UNSAVED_CHANGES"] = "changesNotSaved";
    Dialogs["UNAUTHORISED"] = "authorisationError";
    Dialogs["NO_MATCHING_RECORD"] = "noMatchingRecords";
})(Dialogs || (Dialogs = {}));

var IdVerificationStatus;
(function (IdVerificationStatus) {
    IdVerificationStatus[IdVerificationStatus["Y"] = 1] = "Y";
    IdVerificationStatus[IdVerificationStatus["N"] = 2] = "N";
    IdVerificationStatus[IdVerificationStatus["S"] = 3] = "S";
    IdVerificationStatus[IdVerificationStatus["D"] = 4] = "D";
})(IdVerificationStatus || (IdVerificationStatus = {}));

var RepeaterStandardButtonSubTypes;
(function (RepeaterStandardButtonSubTypes) {
    RepeaterStandardButtonSubTypes["add"] = "add";
    RepeaterStandardButtonSubTypes["edit"] = "edit";
    RepeaterStandardButtonSubTypes["view"] = "view";
    RepeaterStandardButtonSubTypes["remove"] = "remove";
    RepeaterStandardButtonSubTypes["save"] = "save";
    RepeaterStandardButtonSubTypes["close"] = "close";
    RepeaterStandardButtonSubTypes["itemHeaderSave"] = "itemHeaderSave";
    RepeaterStandardButtonSubTypes["itemHeaderCollapse"] = "itemHeaderCollapse";
})(RepeaterStandardButtonSubTypes || (RepeaterStandardButtonSubTypes = {}));
var RepeaterCustomButtonSubTypes;
(function (RepeaterCustomButtonSubTypes) {
    RepeaterCustomButtonSubTypes["repeater"] = "repeater";
    RepeaterCustomButtonSubTypes["itemHeader"] = "itemHeader";
    RepeaterCustomButtonSubTypes["itemContent"] = "itemContent";
})(RepeaterCustomButtonSubTypes || (RepeaterCustomButtonSubTypes = {}));
var RepeaterButtonTypes;
(function (RepeaterButtonTypes) {
    RepeaterButtonTypes["standard"] = "standard";
    RepeaterButtonTypes["custom"] = "custom";
})(RepeaterButtonTypes || (RepeaterButtonTypes = {}));
;

function markChildControlsAsTouched(control) {
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity();
    if (control['controls'] != null) {
        Object.values(control['controls']).forEach((childControl) => {
            markChildControlsAsTouched(childControl);
        });
    }
}
function getFieldVisibility(formFields, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
    let formControl = getFormControl(formFields, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
    return formControl != null;
}
function getFormControl(formFields, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
    let questionKey = questionConfig.key.toString();
    let tabsControl = formFields?.[0]?.formControl?.['controls']?.tabs?.['controls'];
    if (tabsControl == null) {
        return undefined;
    }
    let formControl;
    //Non-repeating page and section.
    if (questionConfig.props.isRepeatingPage === false && questionConfig.props.isRepeatingSection === false) {
        formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey]?.controls[questionKey];
    }
    //Else if question in repeating page only.
    else if (questionConfig.props.isRepeatingPage === true && questionConfig.props.isRepeatingSection === false) {
        formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey]?.controls[questionKey];
    }
    //Else if question in repeating section only.
    else if (questionConfig.props.isRepeatingPage === false && questionConfig.props.isRepeatingSection === true) {
        formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey]?.controls[sectionIndex]?.controls[questionKey];
    }
    //Else if question in repeating page and repeating section.
    else if (questionConfig.props.isRepeatingPage === true && questionConfig.props.isRepeatingSection === true) {
        formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey]?.controls[sectionIndex]?.controls[questionKey];
    }
    return formControl;
}
function getSectionFormControl(formFields, sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
    // let questionKey = sectionConfig.key.toString();
    //let formRootControl = this.field.parent.parent.parent.parent.formControl;
    let tabsControl = formFields[0]?.formControl['controls']?.tabs['controls'];
    let formControl;
    //Non-repeating page and section.
    if (sectionConfig.props.isRepeatingPage === null || sectionConfig.props.isRepeatingPage === undefined || sectionConfig.props.isRepeatingPage !== true) {
        formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[sectionKey];
    }
    //Else if question in repeating page only.
    else if (sectionConfig.props.isRepeatingPage === true) {
        formControl = tabsControl[tabKey]?.controls[pageKey]?.controls[pageIndex]?.controls[sectionKey];
    }
    return formControl;
}
function getPageValue(model, tabKey, pageKey, pageIndex) {
    //Repeating page.
    if (pageIndex > -1) {
        return model?.[tabKey]?.[pageKey]?.[pageIndex];
    }
    //Page is are not repeating.
    return model?.[tabKey]?.[pageKey];
}
function getSectionValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
    //Repeating section.
    if (sectionIndex > -1) {
        return getPageValue(model, tabKey, pageKey, pageIndex)?.[sectionKey]?.[sectionIndex];
    }
    //Section is not repeating.
    return getPageValue(model, tabKey, pageKey, pageIndex)?.[sectionKey];
}
function getResponseValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey) {
    return getSectionValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex)?.[questionKey];
}
function getRawResponse(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey) {
    return getResponseValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey)?.toString();
}
function setResponseValue(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey, questionValue) {
    //Repeating page only.
    if (pageIndex > -1 && sectionIndex === -1) {
        if (model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey] != null) {
            model[tabKey][pageKey][pageIndex][sectionKey][questionKey] = questionValue;
        }
    }
    //Repeating section only.
    else if (pageIndex === -1 && sectionIndex > -1) {
        if (model?.[tabKey]?.[pageKey]?.[sectionKey]?.[sectionIndex] != null) {
            model[tabKey][pageKey][sectionKey][sectionIndex][questionKey] = questionValue;
        }
    }
    //Repeating page and repeating section.
    else if (pageIndex > -1 && sectionIndex > -1) {
        if (model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.[sectionIndex] != null) {
            model[tabKey][pageKey][pageIndex][sectionKey][sectionIndex][questionKey] = questionValue;
        }
    }
    //Page and section are not repeating.
    else {
        if (model?.[tabKey]?.[pageKey]?.[sectionKey] != null) {
            return model[tabKey][pageKey][sectionKey][questionKey] = questionValue;
        }
    }
}
function getQuestionAnsweredStatus(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey) {
    if (model != null) {
        let response = getRawResponse(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey);
        return response !== null && response !== undefined && response !== '' && !isNullOrWhitespaceOnly(response);
    }
    return false;
}
function isNullOrWhitespaceOnly(input) {
    if (typeof input === 'undefined' || input == null) {
        return true;
    }
    return input.toString().replace(/\s/g, '').length < 1;
}
function findNavTabConfigs(formFields) {
    return formFields?.[0]?.fieldGroup?.[0]?.fieldGroup;
}
function findNavTabConfig(formFields, tabKey) {
    return findNavTabConfigs(formFields)?.filter(navTabConfig => navTabConfig.key === tabKey)?.[0];
}
function findPageConfigs(formFields, tabKey) {
    return findNavTabConfig(formFields, tabKey)?.fieldGroup;
}
function findPageConfig(formFields, tabKey, pageKey) {
    return findPageConfigs(formFields, tabKey)?.filter(pageConfig => pageConfig.key === pageKey)?.[0];
}
function findSectionConfigs(formFields, tabKey, pageKey) {
    const pageConfig = findPageConfig(formFields, tabKey, pageKey);
    if (pageConfig?.fieldArray != null) {
        return (pageConfig?.fieldArray).fieldGroup;
    }
    else {
        return pageConfig?.fieldGroup;
    }
}
function findSectionConfig(formFields, tabKey, pageKey, sectionCode) {
    return findSectionConfigs(formFields, tabKey, pageKey)?.filter(sectionConfig => sectionConfig.key === sectionCode)?.[0];
}
function findQuestionConfigs(formFields, tabKey, pageKey, sectionCode) {
    const sectionConfig = findSectionConfig(formFields, tabKey, pageKey, sectionCode);
    if (sectionConfig?.fieldArray != null) {
        return (sectionConfig?.fieldArray).fieldGroup;
    }
    else {
        return sectionConfig?.fieldGroup;
    }
}
function findQuestionConfig(formFields, tabKey, pageKey, sectionCode, questionCode) {
    return findQuestionConfigs(formFields, tabKey, pageKey, sectionCode)?.filter(questionConfig => questionConfig.key === questionCode)?.[0];
}
function getTabPageKeysFromPageId(pageId) {
    //Assumes that pageId is in the format <tab number>-<page number>, e.g. 8-2 for tab 8, page 2.
    return {
        tabKey: `tab${pageId.split('-')[0]}`,
        pageKey: `page${pageId.split('-')[1]}`
    };
}

class DialogService {
    constructor(confirmationService, messageService) {
        this.confirmationService = confirmationService;
        this.messageService = messageService;
        this._popups = [];
        this._notifications = [];
        this.popupRequestSource = new Subject();
        this.popupCloseRequestSource = new Subject();
        this.modelSource = new BehaviorSubject({});
        this.findPopupByCode = (popupCode) => popupCode && this._popups.find(p => p.code === popupCode);
        this.findNotificationByCode = (notificationCode) => notificationCode && this._notifications.find(n => n.code === notificationCode);
    }
    updateModel(model) {
        this.modelSource.next(model);
    }
    showSimplePopup(message, header, okButtonText, cancelButtonText) {
        var resultSource = new AsyncSubject();
        this.confirmationService.confirm({
            message: message,
            header: header,
            acceptVisible: true,
            acceptLabel: okButtonText,
            rejectVisible: !!cancelButtonText,
            rejectLabel: cancelButtonText,
            accept: () => {
                resultSource.next(DialogResult.ACCEPTED);
                resultSource.complete();
                resultSource = null;
            },
            reject: () => {
                resultSource.next(DialogResult.REJECTED);
                resultSource.complete();
                resultSource = null;
            },
            defaultFocus: 'none'
        });
        return resultSource.asObservable();
    }
    showSimpleNotification(severity, detail, isClosable = true, isSticky = true, life = 3000) {
        this.messageService.add({
            severity: severity,
            detail: detail,
            closable: isClosable,
            sticky: isSticky,
            life: life
        });
    }
    initCommonDialogs() {
        const commonPopups = [
            {
                "code": "networkError",
                "title": "Network not available",
                "text": "<p>There may be issues with your network. Check your network connection and try again.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
            {
                "code": "duplicate",
                "title": "Duplicate record",
                "text": "<p>The record already exists.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "concurrencyError",
                "title": "Record updated by another user",
                "text": "<p>Another user has edited this form whilst you were making changes. You will need to return to the dashboard and re-open this form to make changes. Any changes made since you saved this form will need to be re-entered.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
            {
                "code": "validationError",
                "title": "Data validation errors",
                "text": "<p>There are data validation errors.</p><p>Please resolve these errors and try again.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "sessionTimeout",
                "title": "Session timeout",
                "text": "<p>Your session has timed out.</p><p>Please logout and log in again to continue.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
            {
                "code": "serverError",
                "title": "Unable to continue",
                "text": "<p>An unexpected error has occurred while trying to communicate to the server.</p><p>Please try again. If the error persists then please contact the support team.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "clientError",
                "title": "Unable to continue",
                "text": "<p>An unexpected request was sent to the server.</p><p>Please try again. If the error persists then please contact the support team.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "changesNotSaved",
                "title": "Unsaved changes",
                "text": "<p>Do you want to leave this page without saving changes?</p>",
                "type": "confirm",
                "okButtonText": "Yes",
                "cancelButtonText": "No"
            },
            {
                "code": "authorisationError",
                "title": "Authorisation error",
                "text": "<p>There was a problem with the source system authorising your access. Please contact the system administrator.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
            {
                "code": "noMatchingRecords",
                "title": "No records found",
                "text": "<p>No matching records found.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
            {
                "code": "idMatched",
                "title": "ID verification",
                "text": "<p>Your identity information has been successfully verified.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
            {
                "code": "idNotMatched",
                "title": "ID verification failed",
                "text": "<p>Your identity information could not be matched. Please review the information and try again.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "idVerificationError",
                "title": "ID verification error",
                "text": "<p>There was a problem with the identity verification source system. Please choose a different identity or try again later with the same identity.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "idDocumentError",
                "title": "Identity document error",
                "text": "<p>The identity information is invalid or not captured electronically. Please use a different valid identity and try again.</p>",
                "type": "error",
                "okButtonText": "Close"
            },
            {
                "code": "confirmDocumentDeletion",
                "title": "Delete Document",
                "text": "<p>Are you sure you would like to delete this document?</p>",
                "type": "confirm",
                "okButtonText": "Yes",
                "cancelButtonText": "No"
            },
            {
                "code": "documentDeletionSuccess",
                "title": "Delete successful",
                "text": "<p>Document was successfully deleted.</p>",
                "type": "info",
                "okButtonText": "Close"
            },
        ];
        const commonNotifications = [];
        this._popups = commonPopups;
        this._notifications = commonNotifications;
    }
    setPopups(popups) {
        popups.forEach(p => {
            const popupIndex = this._popups.findIndex(popup => popup.code === p.code);
            if (popupIndex >= 0) {
                this._popups[popupIndex] = p;
            }
            else {
                this._popups.push(p);
            }
        });
    }
    setNotifications(notifications) {
        notifications.forEach(n => {
            const notificationIndex = this._notifications.findIndex(notification => notification.code === n.code);
            if (notificationIndex >= 0) {
                this._notifications[notificationIndex] = n;
            }
            else {
                this._notifications.push(n);
            }
        });
    }
    showNotification(notificationCode, data, isClosable = true, isSticky = true, life = 3000) {
        const notification = this.findNotificationByCode(notificationCode);
        if (!notification) {
            return;
        }
        const notificationMessage = this.interpolateMessage(notification.message, data);
        this.showSimpleNotification(notification.type, notificationMessage, isClosable, isSticky, life);
    }
    /**
     * This method allows to display a dialog popup (either OK or OK/Cancel) and returns the user choice (OK or Cancel) as an observable.
     * NOTE: the method name is a bit misleading but it cannot be changed, since it is public
     */
    showConfirm(popupCode, data) {
        const popup = this.findPopupByCode(popupCode);
        if (!popup) {
            return;
        }
        const popupMessage = this.interpolateMessage(popup.text, data);
        return this.showSimplePopup(popupMessage, popup.title, popup.okButtonText, popup.cancelButtonText);
    }
    /**
     * This method allows to display a dialog popup (either OK or OK/Cancel) with an optional set of questions (if the popup code is associated to a popup question configuration).
     * NOTE: the method name is a bit misleading but it cannot be changed, since it is public
     */
    showDialog(popupCode, model, data, displayCloseButton, dialogStyleClass, titleData) {
        const popup = this.findPopupByCode(popupCode);
        if (!popup) {
            return;
        }
        const popupMessage = this.interpolateMessage(popup.text, data);
        const popupTitle = titleData ? this.interpolateMessage(popup.title, titleData) : popup.title;
        const request = {
            popup: {
                type: popup.type,
                cancelButtonText: popup.cancelButtonText,
                code: popup.code,
                onCloseFocusElementId: popup.onCloseFocusElementId,
                okButtonText: popup.okButtonText,
                text: popupMessage,
                title: popupTitle,
                questions: popup.questions
            },
            model: model,
            displayCloseButton: displayCloseButton,
            dialogStyleClass: dialogStyleClass
        };
        this.popupRequestSource.next(request);
        this.modelSource.next(model);
    }
    dialogRequested() {
        return this.popupRequestSource.asObservable();
    }
    model() {
        return this.modelSource.asObservable();
    }
    closeRequested() {
        return this.popupCloseRequestSource.asObservable();
    }
    close(validate) {
        this.popupCloseRequestSource.next(validate);
    }
    updatePopupText(popupCode, newPopupText) {
        const popup = this.findPopupByCode(popupCode);
        if (popup != null) {
            popup.text = newPopupText;
        }
    }
    interpolateMessage(messageTemplate, messagePlaceholders) {
        templateSettings.interpolate = /{{([\s\S]+?)}}/g;
        const templateExecutor = template(messageTemplate);
        const interpolatedMessage = templateExecutor(messagePlaceholders);
        return interpolatedMessage;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogService, deps: [{ token: i1$1.ConfirmationService }, { token: i1$1.MessageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1$1.ConfirmationService }, { type: i1$1.MessageService }] });

class FormNavigationService {
    constructor(coreService, titleService) {
        this.coreService = coreService;
        this.titleService = titleService;
        this.navigationElements = [];
        this.activeNavigationElements = {};
        this.onNavigation$ = new Subject();
        this.tabTypes = [
            ElementType.TAB,
            ElementType.CARDSETTAB,
            ElementType.CARDSETTABFLAT
        ];
        this.pageTypes = [
            ElementType.PAGE,
            ElementType.CARDSETPAGE
        ];
        this.repeatingPageTypes = [
            ElementType.PAGEREPEATING,
            ElementType.CARDSETPAGEREPEATING
        ];
        this.sectionTypes = [
            ElementType.SECTION,
            ElementType.CARDSECTION
        ];
        this.repeatingSectionTypes = [
            ElementType.SECTIONREPEATING,
            ElementType.CARDSECTIONREPEATING,
            ElementType.SECTIONREPEATINGINFORMATION
        ];
        this.isTabType = (typeName) => this.tabTypes.includes(typeName);
        this.isPageType = (typeName) => this.pageTypes.includes(typeName);
        this.isRepeatingPageType = (typeName) => this.repeatingPageTypes.includes(typeName);
        this.isSectionType = (typeName) => this.sectionTypes.includes(typeName);
        this.isRepeatingSectionType = (typeName) => this.repeatingSectionTypes.includes(typeName);
        this.areSameType = (typeName1, typeName2) => (this.isTabType(typeName1) && this.isTabType(typeName2)) ||
            (this.isPageType(typeName1) && this.isPageType(typeName2)) ||
            (this.isRepeatingPageType(typeName1) && this.isRepeatingPageType(typeName2)) ||
            (this.isSectionType(typeName1) && this.isSectionType(typeName2)) ||
            (this.isRepeatingSectionType(typeName1) && this.isRepeatingSectionType(typeName2)) ||
            typeName1 === typeName2;
    }
    onNavigation() {
        return this.onNavigation$.asObservable();
    }
    get currentTabNumber() {
        return this.getActiveNumber(...this.tabTypes);
    }
    get currentPageNumber() {
        return this.getActiveNumber(...this.pageTypes);
    }
    get currentTabIndex() {
        return this.getActiveIndex(...this.tabTypes);
    }
    get currentPageIndex() {
        return this.getActiveIndex(...this.pageTypes);
    }
    getActiveNumber(...fieldTypes) {
        return this.getActiveIndex(...fieldTypes) + 1;
    }
    setActiveNumber(fieldType, activeNumber) {
        this.setActiveIndex(fieldType, activeNumber - 1);
    }
    sortAsc(x, y) {
        return 0 - (x > y ? -1 : 1);
    }
    sortDesc(x, y) {
        return 0 - (x > y ? 1 : -1);
    }
    addTabElement(element) {
        const existingElementIndex = this.navigationElements.findIndex(ne => this.areSameType(ne.type, element.type) &&
            ne.index === element.index &&
            ne.number === element.number);
        if (existingElementIndex < 0) {
            this.navigationElements.push(element);
        }
        else {
            this.navigationElements[existingElementIndex] = element;
        }
        if (this.navigationElements && this.navigationElements.length == 1) {
            this.setActivePageTitle();
        }
    }
    updatePageVisiblity(tabNo, pageNo, isHidden) {
        const tab = this.navigationElements.find(ne => ne.number === tabNo);
        if (tab) {
            const page = tab.children.find(p => p.number === pageNo);
            if (page) {
                page.isHidden = isHidden;
            }
        }
    }
    initialiseFormNavigation(defaultTabIndex, defaultPageIndex) {
        this.navigationElements.length = 0;
        this.setActiveIndex(ElementType.TAB, defaultTabIndex ?? 0);
        this.setActiveIndex(ElementType.PAGE, defaultPageIndex ?? 0);
        this.scrollToMainContent();
    }
    // form navigation type
    cancel() {
        this.coreService.applicationFunctions['cancel']();
    }
    moveNext() {
        const { nextTabIndexToSet, nextPageIndexToSet } = this.getNextVisiblePage(this.currentTabIndex, this.currentPageIndex);
        if (nextTabIndexToSet != -1 && nextPageIndexToSet != -1) {
            this.setActiveIndex(ElementType.TAB, nextTabIndexToSet);
            this.setActiveIndex(ElementType.PAGE, nextPageIndexToSet);
            this.scrollToMainContent();
            this.setActivePageTitle();
        }
    }
    getNextVisiblePage(tabIndex, pageIndex) {
        const nextPageIndex = this.getNextPageIndexForTab(tabIndex, pageIndex);
        if (nextPageIndex < 0 && tabIndex < this.navigationElements.length - 1) {
            //Find the first visible page from next tab 
            return this.getNextVisiblePage(tabIndex + 1, -1);
        }
        else {
            return { nextTabIndexToSet: tabIndex, nextPageIndexToSet: nextPageIndex };
        }
    }
    getNextPageIndexForTab(tabIndex, pageIndex) {
        const activeTab = this.navigationElements.filter(ne => ne.index === tabIndex);
        if (activeTab.length > 0) {
            const sortedPagesForActiveTab = activeTab[0].children.sort((x, y) => this.sortAsc(x.number, y.number));
            //Find next page which is not hidden
            let nextPageIndex = sortedPagesForActiveTab.findIndex(p => p.isHidden !== true && p.index > pageIndex &&
                (this.isPageType(p.type) || this.isRepeatingPageType(p.type) || p.type === ElementType.PAGESUMMARY));
            return nextPageIndex < 0 ? -1 : sortedPagesForActiveTab[nextPageIndex].index;
        }
        return -1;
    }
    moveBack() {
        const { previousTabIndexToSet, previousPageIndexToSet } = this.getPreviousVisiblePage(this.currentTabIndex, this.currentPageIndex);
        if (previousTabIndexToSet != -1 && previousPageIndexToSet != -1) {
            this.setActiveIndex(ElementType.TAB, previousTabIndexToSet);
            this.setActiveIndex(ElementType.PAGE, previousPageIndexToSet);
            this.scrollToMainContent();
            this.setActivePageTitle();
        }
    }
    getPreviousVisiblePage(tabIndex, pageIndex) {
        const previousPageIndex = this.getPreviousPageIndexForTab(tabIndex, pageIndex);
        if (previousPageIndex < 0 && tabIndex > 0) {
            //Find the last visible page from previous tab 
            return this.getPreviousVisiblePage(tabIndex - 1, 10000);
        }
        else {
            return { previousTabIndexToSet: tabIndex, previousPageIndexToSet: previousPageIndex };
        }
    }
    getPreviousPageIndexForTab(tabIndex, pageIndex) {
        const activeTab = this.navigationElements.filter(ne => ne.index === tabIndex);
        if (activeTab.length > 0) {
            const sortedPagesForActiveTab = activeTab[0].children.sort((x, y) => this.sortDesc(x.number, y.number));
            //Find previous page which is not hidden
            let previousPageIndex = sortedPagesForActiveTab.findIndex(p => p.isHidden !== true && p.index < pageIndex &&
                (this.isPageType(p.type) || this.isRepeatingPageType(p.type) || p.type === ElementType.PAGESUMMARY));
            return previousPageIndex < 0 ? -1 : sortedPagesForActiveTab[previousPageIndex].index;
        }
        return -1;
    }
    scrollToMainContent() {
        if (document.getElementById('main_content') != null) {
            document.getElementById('main_content').scrollIntoView();
            setTimeout(() => {
                document.getElementById('main_content').focus();
            }, 100);
        }
    }
    setActivePageTitle() {
        let tabName = '';
        let pageName = '';
        let applicationTitle = this.coreService.getApplicationTitle();
        let formName = this.coreService.getActiveFormName();
        let title = applicationTitle + ' - ' + formName;
        const currentTab = this.navigationElements.find(te => te.index === this.currentTabIndex);
        if (currentTab) {
            tabName = currentTab.title;
            const currentPage = currentTab.children.find(pe => pe.index === this.currentPageIndex);
            if (currentPage) {
                pageName = currentPage.title;
            }
            title = applicationTitle + ' - ' + formName + ' - ' + tabName + ' Tab ' + pageName + ' Page';
        }
        this.titleService.setTitle(title);
    }
    // tabs type
    getActiveIndex(...fieldTypes) {
        for (const fieldType of fieldTypes) {
            const activeIndex = this.activeNavigationElements[fieldType];
            if (activeIndex || activeIndex === 0) {
                return activeIndex;
            }
        }
        return undefined;
    }
    setActiveIndex(fieldType, activeIndex) {
        let navigationEvent = {
            elementType: fieldType,
            elementIndex: activeIndex,
            elementNumber: this.getActiveElementNumber(fieldType, activeIndex)
        };
        // this.activeNavigationElements[fieldType] = activeIndex; line below is duplicated on purpose
        // to ensure that current tab and page numbers are accessible via form navigation service when onNavigation event is hand
        if (this.isTabType(fieldType) && this.getActiveIndex(fieldType) !== activeIndex) {
            this.activeNavigationElements[fieldType] = activeIndex;
            //Find the first visible page of the tab. 
            const nextPageIndex = this.getNextPageIndexForTab(activeIndex, -1);
            this.setActiveIndex(ElementType.PAGE, nextPageIndex);
            this.setActivePageTitle();
        }
        else {
            this.activeNavigationElements[fieldType] = activeIndex;
            this.setActivePageTitle();
        }
        this.onNavigation$.next(navigationEvent);
    }
    getActiveElementNumber(fieldType, activeIndex) {
        if (this.isTabType(fieldType)) {
            let tab = this.navigationElements.find(te => te.index === activeIndex);
            if (tab !== null && tab !== undefined) {
                return tab.number;
            }
            return 1;
        }
        if (this.isPageType(fieldType) || this.isRepeatingPageType(fieldType) || fieldType === ElementType.PAGESUMMARY) {
            let tabWithPage = this.navigationElements.find(te => te.index === this.currentTabNumber - 1 &&
                te.children &&
                te.children.find(pe => (this.isPageType(pe.type) || this.isRepeatingPageType(pe.type) || pe.type === ElementType.PAGESUMMARY) &&
                    pe.index === activeIndex));
            if (tabWithPage !== null && tabWithPage !== undefined) {
                let page = tabWithPage.children.find(pe => (this.isPageType(pe.type) || this.isRepeatingPageType(pe.type) || pe.type === ElementType.PAGESUMMARY) &&
                    pe.index === activeIndex);
                if (page !== null && page !== undefined) {
                    return page.number;
                }
                return 1;
            }
            return 1;
        }
    }
    canNavigateBack() {
        const { previousTabIndexToSet, previousPageIndexToSet } = this.getPreviousVisiblePage(this.currentTabIndex, this.currentPageIndex);
        return previousTabIndexToSet != -1 && previousPageIndexToSet != -1;
    }
    canNavigateNext() {
        const { nextTabIndexToSet, nextPageIndexToSet } = this.getNextVisiblePage(this.currentTabIndex, this.currentPageIndex);
        return nextTabIndexToSet != -1 && nextPageIndexToSet != -1;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormNavigationService, deps: [{ token: CoreService }, { token: i1$2.Title }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormNavigationService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormNavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: CoreService }, { type: i1$2.Title }] });

class ReportDataService {
    constructor() {
        this.sectionSourceList = [];
    }
    setReportModel(formReportModel) {
        this.formReportModel = formReportModel.reportModel;
        this.requestConfigData = formReportModel.requestConfigData;
        this.requestResponse = formReportModel.requestResponse;
    }
    setSectionSourceList(sectionDetail) {
        let section = sectionDetail.props;
        let sectionSourceList;
        let tempSectionSourceList;
        if (sectionDetail.key && section.sources) {
            let sectionSourceSubList = [];
            //check on sources
            if (section.sources) {
                if (section.sources.indexOf(',') > -1) {
                    //split does convert into one long string instead an individual array - gotta be mapped to Number if it is not null and push by one by
                    var sourcesArray = section.sources.split(",").map(Number).filter(function (x) {
                        return !isNaN(x);
                    });
                    sourcesArray.forEach(function (num) {
                        sectionSourceSubList.push(num);
                    });
                }
                else {
                    sectionSourceSubList.push(parseInt(section.sources));
                }
            }
            tempSectionSourceList = ({
                sectionName: sectionDetail.key,
                sectionNameLabel: sectionDetail.props?.label,
                sources: sectionSourceSubList,
                detailSectionOnly: (section.detailSectionOnly ? section.detailSectionOnly : undefined),
                parentSection: (section.parentSection ? section.parentSection : undefined), reponseSection: (section.reponseSection ? section.reponseSection : undefined), isHelperCondition: (section.isHelperCondition ? section.isHelperCondition : undefined), sortByDetail: (section.sortByDetail ? section.sortByDetail : undefined), sortWithoutSource: (section.sortWithoutSource ? section.sortWithoutSource : undefined)
            });
        }
        //strip down by removing "undefined" properties within the json array
        sectionSourceList = _.pickBy(tempSectionSourceList, _.identity);
        if (sectionSourceList) {
            this.sectionSourceList.push(sectionSourceList);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportDataService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReportDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [] });

class FormConfigurationService extends ApiService {
    constructor(httpClient, appSettings, testingDataService, coreService, optionSetService, dialogService, formNavigationService, reportDataService) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
        this.testingDataService = testingDataService;
        this.coreService = coreService;
        this.optionSetService = optionSetService;
        this.dialogService = dialogService;
        this.formNavigationService = formNavigationService;
        this.reportDataService = reportDataService;
        this.formTabs = new Subject();
        this.formTabs$ = this.formTabs.asObservable();
        this.parseFunctionName = (name) => name.toString().trim().replace('();', '');
    }
    setBarContent(props, fields, tabKey, pageKey) {
        if (tabKey != null && pageKey != null) {
            const tabField = fields[0].fieldGroup[0].fieldGroup.find(tab => tab.key.toString() === tabKey);
            const pageField = tabField.fieldGroup.find(page => page.key.toString() === pageKey);
            for (const field in props) {
                if (Object.prototype.hasOwnProperty.call(props, field)) {
                    pageField.props[field] = props[field];
                }
            }
        }
        else {
            let tabFields = fields[0].fieldGroup[0].fieldGroup;
            tabFields.forEach(tab => {
                const pageFields = tab.fieldGroup;
                pageFields.forEach(page => {
                    for (const field in props) {
                        if (Object.prototype.hasOwnProperty.call(props, field)) {
                            page.props[field] = props[field];
                        }
                    }
                });
            });
        }
    }
    setStatusBar(fields, tabKey, pageKey, statusBarContent) {
        this.setBarContent({ statusBarContent }, fields, tabKey, pageKey);
    }
    setHeaderBar(fields, headerBarContent, tabKey, pageKey, headerBarSticky = true, headerBarStickySettings) {
        if (fields[0].fieldGroup[0].type === 'vertical-stepper') {
            const props = fields[0].fieldGroup[0].props;
            props.headerBarContent = headerBarContent;
            props.headerBarSticky = headerBarSticky;
            props.headerBarStickySettings = headerBarStickySettings || {};
        }
        else {
            this.setBarContent({ headerBarContent, headerBarSticky }, fields, tabKey, pageKey);
        }
    }
    mockGetConfigApiCall(mockGetConfigApiCallSettings) {
        const data = {};
        if (mockGetConfigApiCallSettings.configurationUrl) {
            data.configData = this.testingDataService.getJsonViaSyncHttpGet(mockGetConfigApiCallSettings.configurationUrl);
        }
        if (mockGetConfigApiCallSettings.responseUrl) {
            data.response = this.testingDataService.getJsonViaSyncHttpGet(mockGetConfigApiCallSettings.responseUrl);
        }
        if (mockGetConfigApiCallSettings.lastUpdatedTime) {
            data.lastUpdatedTime = mockGetConfigApiCallSettings.lastUpdatedTime;
        }
        if (mockGetConfigApiCallSettings.isFormEditable !== undefined && mockGetConfigApiCallSettings.isFormEditable !== null) {
            data.isFormEditable = mockGetConfigApiCallSettings.isFormEditable;
        }
        return of(data).pipe(delay(mockGetConfigApiCallSettings.delayMs ?? 0));
    }
    /**
    * Gets form config, with optional caching
    *
    * @param cacheTimeoutInSeconds If null, no caching is done. If specified, then config will be cached for a maximum of cacheTimeoutInSeconds seconds.
    */
    getFormConfig(request, mockGetConfigApiCallSettings, cacheTimeoutInSeconds) {
        if (mockGetConfigApiCallSettings) {
            return this.mockGetConfigApiCall(mockGetConfigApiCallSettings);
        }
        // Example of url: 'FormConfiguration/GetConfiguration'
        // When passed to ApiService, it will be appended on to the base URL, e.g. http://www.some-domain.com/api/FormConfiguration/GetConfiguration/1/0
        const url = `${this.endpoints[request.apiEndpointKey]}/${request.templateId}/${request.versionNo}`;
        if (cacheTimeoutInSeconds > 0) {
            return this.getOrSetCachedConfig(url, request, cacheTimeoutInSeconds);
        }
        else {
            return this.get(url);
        }
    }
    getFormConfigAndResponse(request, mockGetConfigApiCallSettings) {
        if (mockGetConfigApiCallSettings) {
            return this.mockGetConfigApiCall(mockGetConfigApiCallSettings);
        }
        // Example of url: 'TrappingSite/GetResponseAndConfig'
        // When passed to ApiService, it will be appended on to the base URL, e.g. http://www.some-domain.com/api/TrappingSite/GetResponseAndConfig/1/0/<EntityId>
        let url = `${this.endpoints[request.apiEndpointKey]}/${request.templateId}/${request.versionNo}`;
        if (request.entityId !== undefined && request.entityId !== null && request.entityId !== '') {
            url = `${url}/${request.entityId}`;
        }
        return this.get(url);
    }
    //Checks if cached config exist, if not fetches config using api and stores in cache.
    getOrSetCachedConfig(url, request, cacheTimeoutInSeconds) {
        return new Observable(subscriber => {
            const cachedObj = this.getCachedData(request, cacheTimeoutInSeconds);
            if (cachedObj) {
                subscriber.next(cachedObj);
                subscriber.complete();
            }
            else {
                this.get(url)
                    .subscribe(data => {
                    this.storeDataInCache(request, data);
                    subscriber.next(data);
                    subscriber.complete();
                });
            }
        });
    }
    //Get config data from cache
    getCachedData(request, cacheTimeoutInSeconds) {
        let key = this.getCacheKey(request);
        let cachedData = sessionStorage.getItem(key);
        if (cachedData) {
            let cacheObj = JSON.parse(cachedData);
            let cachedTime = DateTime.fromISO(cacheObj.cachedTime);
            if (cachedTime && cachedTime.isValid) {
                let diffMilliSeconds = DateTime.now().diff(cachedTime).toObject().milliseconds;
                if (diffMilliSeconds < (cacheTimeoutInSeconds * 1000)) {
                    return cacheObj.data;
                }
            }
        }
        return null;
    }
    //Set config data in to cache
    storeDataInCache(request, data) {
        let key = this.getCacheKey(request);
        if (key) {
            sessionStorage.removeItem(key);
            sessionStorage.setItem(key, JSON.stringify({ cachedTime: DateTime.now().toISO(), data: data }));
        }
    }
    // Gets cache key
    getCacheKey(request) {
        let entityKey = request.entityId ? (`-${request.entityId}`) : '';
        return `dspx-cache-${request.templateId}-${request.versionNo}${entityKey}`;
    }
    setupDialogs(popups, notifications) {
        this.extendPopupFieldConfig(popups);
        this.dialogService.setPopups(popups);
        this.dialogService.setNotifications(notifications);
    }
    extendPopupFieldConfig(popups) {
        popups.forEach(p => {
            if (p.questions && p.questions.length > 0) {
                for (let q = 0; q < p.questions.length; q++) {
                    // Setup a flag to indicate that these are popup questions. This is currently used for date validations
                    p.questions[q].props.isPopupQuestion = true;
                    //For questions where input is controlled by regular expressions.
                    if (p.questions[q].props.pattern) {
                        p.questions[q].props.pattern = new RegExp(p.questions[q].props.pattern.toString());
                    }
                    //For questions with option sets (including dependent option sets).
                    if (p.questions[q].props.optionSet) {
                        if (!p.questions[q].props.optionSet?.parentQuestionKey) {
                            p.questions[q].props.options = this.getOptionSet(p.questions[q]);
                            // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                            if (p.questions[q].type === 'autocomplete' && p.questions[q].props.typeaheadOptions?.showQuickSelection) {
                                p.questions[q].props.quickSelectionOptions = this.getOptionSet(p.questions[q], true);
                            }
                        }
                        else {
                            if (!p.questions[q].expressions) {
                                p.questions[q].expressions = {
                                    'props.options': (field) => {
                                        return this.getOptionSet(field);
                                    }
                                };
                                // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                                if (p.questions[q].type === 'autocomplete' && p.questions[q].props.typeaheadOptions?.showQuickSelection) {
                                    p.questions[q].expressions['props.quickSelectionOptions'] = (field) => {
                                        return this.getOptionSet(field, true);
                                    };
                                }
                            }
                        }
                    }
                    //for questions which call the filter function
                    if (p.questions[q].props?.filterFunction) {
                        p.questions[q].props.change = this.coreService.applicationFunctions[p.questions[q].props.filterFunction];
                    }
                    if (p.questions[q].type === 'filter') {
                        if (p.questions[q].fieldGroup && p.questions[q].fieldGroup.length > 0) {
                            for (let fq = 0; fq < p.questions[q].fieldGroup.length; fq++) {
                                //For questions where input is controlled by regular expressions.
                                if (p.questions[q].fieldGroup[fq].props.pattern) {
                                    p.questions[q].fieldGroup[fq].props.pattern = new RegExp(p.questions[q].fieldGroup[fq].props.pattern.toString());
                                }
                                //For questions with option sets (including dependent option sets).
                                if (p.questions[q].fieldGroup[fq].props.optionSet) {
                                    if (!p.questions[q].fieldGroup[fq].props.optionSet?.parentQuestionKey) {
                                        p.questions[q].fieldGroup[fq].props.options = this.getOptionSet(p.questions[q].fieldGroup[fq]);
                                    }
                                    else {
                                        p.questions[q].fieldGroup[fq].expressions ??= {};
                                        p.questions[q].fieldGroup[fq].expressions['props.options'] = (field) => {
                                            return this.getOptionSet(field);
                                        };
                                        // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                                        if (p.questions[q].type === 'autocomplete' && p.questions[q].props.typeaheadOptions?.showQuickSelection) {
                                            p.questions[q].expressions['props.quickSelectionOptions'] = (field) => {
                                                return this.getOptionSet(field, true);
                                            };
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }
    extendFieldConfig(fields, formModel, optionSets, isFormEditable, formReportModel, verticalNavigation, defaultNavigation = null) {
        this.coreService.setFormEditable(isFormEditable);
        if (formReportModel) {
            this.reportDataService.setReportModel(formReportModel);
        }
        this.optionSetService.setOptionSets(optionSets);
        if (defaultNavigation?.enabled !== false) {
            this.formNavigationService.initialiseFormNavigation(defaultNavigation?.defaultTabIndex, defaultNavigation?.defaultPageIndex);
        }
        let form = fields.find(f => f.key == 'form');
        let tabs;
        if (form) {
            tabs = form.fieldGroup.find(f => f.key == 'tabs');
        }
        if (tabs) {
            if (verticalNavigation?.enabled) {
                if (verticalNavigation?.type) {
                    tabs.type = verticalNavigation?.type;
                }
                else {
                    tabs.type = 'vertical-stepper';
                }
                if (verticalNavigation?.sticky) {
                    tabs.props.stickyLayout = { stack: false };
                }
                if (verticalNavigation?.pageLevel !== false && tabs.fieldGroup.length === 1) {
                    tabs.props.pageNavigationFor = tabs.fieldGroup[0].key;
                }
            }
            if (!tabs.props.navigationKey) {
                tabs.props.navigationKey = NavigationKey.TAB;
            }
            for (let t = 0; t < tabs.fieldGroup.length; t++) {
                let pages;
                let navigationElement = {
                    number: tabs.fieldGroup[t].props.number,
                    index: t,
                    title: tabs.fieldGroup[t].props.label,
                    type: tabs.fieldGroup[t].type
                };
                if (!tabs.fieldGroup[t].props.navigationKey) {
                    tabs.fieldGroup[t].props.navigationKey = NavigationKey.PAGE;
                }
                pages = tabs.fieldGroup[t].fieldGroup;
                for (let p = 0; p < pages.length; p++) {
                    if (!navigationElement.children) {
                        navigationElement.children = [];
                    }
                    navigationElement.children.push({
                        type: pages[p].type.toString(),
                        index: p,
                        title: pages[p].props.label,
                        number: pages[p].props.number
                    });
                    pages[p].expressionProperties = {
                        'props.isEditable': (model, formState, field) => {
                            return this.isPageEditable(field, isFormEditable);
                        }
                    };
                    //Attach hide expression only if conditions exist.
                    if (this.hasConditions(pages[p])) {
                        pages[p].hideExpression = (model, formState, field) => {
                            let isPageHidden = this.hideField(formModel, field);
                            this.formNavigationService.updatePageVisiblity(tabs.fieldGroup[t].props.number, pages[p].props.number, isPageHidden);
                            return isPageHidden;
                        };
                    }
                    this.extendFieldConfigForViewMode(this.coreService.pageFunctions, pages[p].props);
                    if (this.formNavigationService.isRepeatingPageType(pages[p].type.toString())) {
                        this.extendFieldConfigForRepeatingItem(this.coreService.repeatingPageFunctions, pages[p].props);
                        this.extendFieldConfigForRepeatingItemButtons(this.coreService.repeatingPageFunctions, pages[p].props.repeatingItemButtons);
                    }
                    if (pages[p].props.actionButtons) {
                        if (pages[p].props.actionButtons.onClick) {
                            const functionName = this.parseFunctionName(pages[p].props.actionButtons.onClick);
                            pages[p].props.actionButtons.onClick = this.coreService.applicationFunctions[functionName];
                        }
                        pages[p].expressionProperties['props.actionButtons.disabled'] =
                            (model, formState, field) => {
                                return !this.isPageEditable(field, isFormEditable) ? true : false;
                            };
                        if (pages[p].props.actionButtons.condition) {
                            const functionName = this.parseFunctionName(pages[p].props.actionButtons.condition);
                            pages[p].props.actionButtons.condition = this.coreService.applicationFunctions[functionName];
                        }
                        if (pages[p].props.actionButtons.buttonGroupItems) {
                            for (let i = 0; i < pages[p].props.actionButtons.buttonGroupItems.length; i++) {
                                if (pages[p].props.actionButtons.buttonGroupItems[i].command) {
                                    const functionName = this.parseFunctionName(pages[p].props.actionButtons.buttonGroupItems[i].command);
                                    pages[p].props.actionButtons.buttonGroupItems[i].command = this.coreService.applicationFunctions[functionName];
                                }
                                if (pages[p].props.actionButtons.buttonGroupItems[i].condition) {
                                    const functionName = this.parseFunctionName(pages[p].props.actionButtons.buttonGroupItems[i].condition);
                                    pages[p].props.actionButtons.buttonGroupItems[i].condition = this.coreService.applicationFunctions[functionName];
                                }
                            }
                        }
                    }
                    let sections;
                    if (tabs.fieldGroup[t].fieldGroup[p].fieldGroup) {
                        sections = tabs.fieldGroup[t].fieldGroup[p].fieldGroup;
                    }
                    else {
                        sections = tabs.fieldGroup[t].fieldGroup[p].fieldArray.fieldGroup;
                    }
                    for (let s = 0; s < sections.length; s++) {
                        sections[s].hideExpression = (model, formState, field) => {
                            return this.hideField(formModel, field);
                        };
                        if (this.formNavigationService.isRepeatingSectionType(sections[s].type.toString())) {
                            sections[s].expressionProperties = {
                                'props.isEditable': (model, formState, field) => {
                                    return this.isSectionEditable(field, isFormEditable);
                                }
                            };
                            this.extendFieldConfigForRepeatingItem(this.coreService.repeatingSectionFunctions, sections[s].props);
                            this.extendFieldConfigForRepeatingItemButtons(this.coreService.repeatingSectionFunctions, sections[s].props.repeatingItemButtons);
                        }
                        if (sections[s].props.sources) {
                            this.reportDataService.setSectionSourceList(sections[s]);
                        }
                        let questions;
                        if (sections[s].fieldGroup) {
                            questions = sections[s].fieldGroup;
                        }
                        else {
                            questions = sections[s].fieldArray.fieldGroup;
                        }
                        for (let q = 0; q < questions.length; q++) {
                            //For read-only questions.
                            questions[q].expressionProperties = {
                                'props.disabled': (model, formState, field) => {
                                    return this.disableField(field, isFormEditable);
                                }
                            };
                            //For conditional questions.
                            questions[q].hideExpression = (model, formState, field) => {
                                if (field.parent.hide) { //If the parent section is hidden, just return true.
                                    return true;
                                }
                                else {
                                    return this.hideField(formModel, field);
                                }
                            };
                            //For questions where input is controlled by regular expressions.
                            if (questions[q].props?.pattern) {
                                questions[q].props.pattern = new RegExp(questions[q].props.pattern.toString());
                            }
                            //For questions with option sets (including dependent option sets).
                            if (questions[q].props?.optionSet) {
                                if (!questions[q].props.optionSet?.parentQuestionKey) {
                                    questions[q].props.options = this.getOptionSet(questions[q]);
                                    // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                                    if (questions[q].type === 'autocomplete' && questions[q].props.typeaheadOptions?.showQuickSelection) {
                                        questions[q].props.quickSelectionOptions = this.getOptionSet(questions[q], true);
                                    }
                                }
                                else {
                                    // If the question has a dependent option set, then set the options using an expression.
                                    questions[q].expressions ??= {};
                                    questions[q].expressions['props.options'] = (field) => {
                                        return this.getOptionSet(field);
                                    };
                                    // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                                    if (questions[q].type === 'autocomplete' && questions[q].props.typeaheadOptions?.showQuickSelection) {
                                        questions[q].expressions['props.quickSelectionOptions'] = (field) => {
                                            return this.getOptionSet(field, true);
                                        };
                                    }
                                }
                            }
                            if (questions[q].props?.filterFunction) {
                                questions[q].props.change = this.coreService.applicationFunctions[questions[q].props.filterFunction];
                            }
                            if (questions[q].props?.dataImportOptions) {
                                questions[q].props.dataImportOptions.uploadWorkSheet = this.coreService.applicationFunctions[questions[q].props.dataImportOptions.uploadWorkSheet];
                                questions[q].props.dataImportOptions.downloadWorkSheet = this.coreService.applicationFunctions[questions[q].props.dataImportOptions.downloadWorkSheet];
                                if (questions[q].props?.dataImportOptions?.uploadMultipleWorkSheets) {
                                    questions[q].props.dataImportOptions.uploadMultipleWorkSheets = this.coreService.applicationFunctions[questions[q].props.dataImportOptions.uploadMultipleWorkSheets];
                                }
                            }
                            if (questions[q].props?.actionButtonFunction) {
                                questions[q].props.actionButtonClick = this.coreService.applicationFunctions[questions[q].props.actionButtonFunction];
                            }
                            if (questions[q].props?.imageOptions?.imageFunction) {
                                questions[q].props.imageFunction = this.coreService.applicationFunctions[questions[q].props.imageOptions.imageFunction];
                            }
                            if (questions[q].props?.imageOptions?.altTextFunction) {
                                questions[q].props.altTextFunction = this.coreService.applicationFunctions[questions[q].props.imageOptions.altTextFunction];
                            }
                            if (questions[q].validators?.validation) {
                                let validators = (questions[q].validators?.validation).filter(i => i.name === "custom");
                                validators.forEach(validator => {
                                    let functionName = validator?.options?.functionName;
                                    let args = validator?.options?.arguments;
                                    validator.options.function = this.coreService.applicationFunctions[functionName](args);
                                });
                            }
                            if (questions[q].defaultValue) {
                                if (questions[q].defaultValue === 'LoggedInUser') {
                                    questions[q].defaultValue = this.coreService.getLoggedInUser();
                                }
                                else if (questions[q].defaultValue === 'CurrentDateTime') {
                                    questions[q].defaultValue = this.coreService.getCurrentDateTime();
                                }
                                else if (questions[q].defaultValue === 'CurrentDate') {
                                    questions[q].defaultValue = this.coreService.getCurrentDate();
                                }
                                else if (questions[q].type === 'checkbox' && typeof questions[q].defaultValue === 'string') {
                                    if (questions[q].defaultValue.toLowerCase() === 'true') {
                                        questions[q].defaultValue = true;
                                    }
                                    else if (questions[q].defaultValue.toLowerCase() === 'false') {
                                        questions[q].defaultValue = false;
                                    }
                                }
                            }
                            // Process filter control sub questions
                            if (questions[q].type === 'filter') {
                                if (questions[q].fieldGroup && questions[q].fieldGroup.length > 0) {
                                    for (let fq = 0; fq < questions[q].fieldGroup.length; fq++) {
                                        //For questions where input is controlled by regular expressions.
                                        if (questions[q].fieldGroup[fq].props.pattern) {
                                            questions[q].fieldGroup[fq].props.pattern = new RegExp(questions[q].fieldGroup[fq].props.pattern.toString());
                                        }
                                        //For questions with option sets (including dependent option sets).
                                        if (questions[q].fieldGroup[fq].props.optionSet) {
                                            if (!questions[q].fieldGroup[fq].props.optionSet?.parentQuestionKey) {
                                                questions[q].fieldGroup[fq].props.options = this.getOptionSet(questions[q].fieldGroup[fq]);
                                                // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                                                if (questions[q].fieldGroup[fq].type === 'autocomplete' && questions[q].fieldGroup[fq].props.typeaheadOptions?.showQuickSelection) {
                                                    questions[q].fieldGroup[fq].props.quickSelectionOptions = this.getOptionSet(questions[q].fieldGroup[fq], true);
                                                }
                                            }
                                            else {
                                                questions[q].fieldGroup[fq].expressions ??= {};
                                                questions[q].fieldGroup[fq].expressions['props.options'] = (field) => {
                                                    return this.getOptionSet(field);
                                                };
                                                // If the question is an autocomplete question, and it has a quick selection option, then set the quick selection options.
                                                if (questions[q].fieldGroup[fq].type === 'autocomplete' && questions[q].fieldGroup[fq].props.typeaheadOptions?.showQuickSelection) {
                                                    questions[q].fieldGroup[fq].expressions['props.quickSelectionOptions'] = (field) => {
                                                        return this.getOptionSet(field, true);
                                                    };
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            //For sub questions in an editable table
                            if (questions[q].type === 'table-editor') {
                                let teq = questions[q].fieldArray.fieldGroup;
                                for (let i = 0; i < teq.length; i++) {
                                    //For questions where input is controlled by regular expressions.
                                    if (teq[i].props?.pattern) {
                                        teq[i].props.pattern = new RegExp(teq[i].props.pattern.toString());
                                    }
                                    //For questions with option sets (including dependent option sets).
                                    if (teq[i].props?.optionSet) {
                                        if (!teq[i].props.optionSet.parentQuestionKey) {
                                            teq[i].props.options = this.getOptionSet(teq[i]);
                                        }
                                        else {
                                            teq[i].expressionProperties['props.options'] = (model, formState, field) => {
                                                return this.getOptionSet(field);
                                            };
                                        }
                                    }
                                }
                            }
                            //For address questions.
                            if (questions[q].type === 'address') {
                                questions[q].expressionProperties ??= {};
                                questions[q].expressionProperties['props.disabled'] = (model, formState, field) => {
                                    let fieldDisabled = this.disableField(field, isFormEditable);
                                    if (!fieldDisabled && field != null && model != null) {
                                        let manualAddressCheckboxKey = `${field.key.toString()}-manualAddress`;
                                        return model[manualAddressCheckboxKey] === true;
                                    }
                                    else {
                                        return fieldDisabled;
                                    }
                                };
                            }
                            if (questions[q].key.toString().endsWith('-manualAddress')) {
                                questions[q].props.change = (field, event) => {
                                    let addressFieldKey = field.key.toString().replace('-manualAddress', '');
                                    let model = field.model;
                                    let autoStreetFieldKey = `${addressFieldKey}-autoStreetNumberName`;
                                    let autoSuburbFieldKey = `${addressFieldKey}-autoSuburb`;
                                    let autoStateFieldKey = `${addressFieldKey}-autoState`;
                                    let autoPostcodeFieldKey = `${addressFieldKey}-autoPostCode`;
                                    let autoLatitude = `${addressFieldKey}-autoLatitude`;
                                    let autoLongitude = `${addressFieldKey}-autoLongitude`;
                                    let manualStreetFieldKey = `${addressFieldKey}-streetNumberName`;
                                    let manualSuburbFieldKey = `${addressFieldKey}-suburb`;
                                    let manualStateFieldKey = `${addressFieldKey}-state`;
                                    let manualPostcodeFieldKey = `${addressFieldKey}-postCode`;
                                    if (event?.checked) {
                                        field.formControl.parent.controls[addressFieldKey].patchValue('Address not found');
                                        if (model != null) {
                                            delete model[autoStreetFieldKey];
                                            delete model[autoSuburbFieldKey];
                                            delete model[autoStateFieldKey];
                                            delete model[autoPostcodeFieldKey];
                                            delete model[autoLatitude];
                                            delete model[autoLongitude];
                                        }
                                    }
                                    else {
                                        field.formControl.parent.controls[addressFieldKey].patchValue('');
                                        if (model != null) {
                                            delete model[manualStreetFieldKey];
                                            delete model[manualSuburbFieldKey];
                                            delete model[manualStateFieldKey];
                                            delete model[manualPostcodeFieldKey];
                                        }
                                    }
                                };
                            }
                            //For questions of type 'button'.
                            if (questions[q].type === 'button') {
                                if (questions[q].props.onClick) {
                                    let functionName = questions[q].props.onClick;
                                    questions[q].props.onClick = this.coreService.applicationFunctions[functionName];
                                }
                            }
                        }
                    }
                }
                this.formNavigationService.addTabElement(navigationElement);
            }
            this.formTabs.next(tabs.fieldGroup);
        }
    }
    getProgressModel(formFields, formModel, tabFieldConfig) {
        let formProgress = [];
        let counts = { totalQuestions: 0, totalAnswered: 0, totalQuestionsInTab: 0, totalAnsweredInTab: 0 };
        let isRepeatingPage;
        let isRepeatingSection;
        let tabs;
        if (tabFieldConfig != null) {
            tabs = [tabFieldConfig]; //Just get counts for this single tab.
        }
        else {
            tabs = formFields[0].fieldGroup[0].fieldGroup;
        }
        let tabsModel = formModel?.form?.tabs;
        tabs.forEach(tab => {
            let tabKey = tab.key.toString();
            counts.totalQuestionsInTab = 0;
            counts.totalAnsweredInTab = 0;
            let pages = tab.fieldGroup;
            pages.forEach(page => {
                let pageKey = page.key.toString();
                let sections;
                if (page.fieldArray) {
                    //This is a repeating page.
                    sections = page.fieldArray.fieldGroup;
                    isRepeatingPage = true;
                }
                else {
                    sections = page.fieldGroup;
                    isRepeatingPage = false;
                }
                sections.forEach(section => {
                    let sectionKey = section.key.toString();
                    let questions;
                    if (section.fieldArray) {
                        //This is a repeating section.
                        questions = section.fieldArray.fieldGroup;
                        isRepeatingSection = true;
                    }
                    else {
                        questions = section.fieldGroup;
                        isRepeatingSection = false;
                    }
                    questions.forEach(question => {
                        if (question.props['includeInCount'] != null && question.props['includeInCount'] === true) {
                            if (isRepeatingPage === true && isRepeatingSection === true) {
                                //Question is in a repeating page AND is in a repeating section.
                                let pageInstanceCount = tabsModel?.[tabKey]?.[pageKey]?.length;
                                pageInstanceCount = pageInstanceCount == null ? 0 : pageInstanceCount;
                                for (let pageIndex = 0; pageIndex < pageInstanceCount; pageIndex++) {
                                    let sectionInstanceCount = tabsModel?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.length;
                                    sectionInstanceCount = sectionInstanceCount == null ? 0 : sectionInstanceCount;
                                    for (let sectionIndex = 0; sectionIndex < sectionInstanceCount; sectionIndex++) {
                                        counts = this.updateQuestionCounts(counts, formFields, question, tabsModel, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                                    }
                                }
                            }
                            else if (isRepeatingPage === true && isRepeatingSection === false) {
                                //Question is in a repeating page but not in a repeating section.
                                let pageInstanceCount = tabsModel?.[tabKey]?.[pageKey]?.length;
                                pageInstanceCount = pageInstanceCount == null ? 0 : pageInstanceCount;
                                for (let pageIndex = 0; pageIndex < pageInstanceCount; pageIndex++) {
                                    counts = this.updateQuestionCounts(counts, formFields, question, tabsModel, tabKey, pageKey, pageIndex, sectionKey, -1);
                                }
                            }
                            else if (isRepeatingPage === false && isRepeatingSection === true) {
                                //Question is not in a repeating page but is in a repeating section.
                                let sectionInstanceCount = tabsModel?.[tabKey]?.[pageKey]?.[sectionKey]?.length;
                                sectionInstanceCount = sectionInstanceCount == null ? 0 : sectionInstanceCount;
                                for (let sectionIndex = 0; sectionIndex < sectionInstanceCount; sectionIndex++) {
                                    counts = this.updateQuestionCounts(counts, formFields, question, tabsModel, tabKey, pageKey, -1, sectionKey, sectionIndex);
                                }
                            }
                            else {
                                //Question is not in a repeating page and not in a repeating section.
                                counts = this.updateQuestionCounts(counts, formFields, question, tabsModel, tabKey, pageKey, -1, sectionKey, -1);
                            }
                        }
                    });
                });
            });
            formProgress.push({ tab: tab.props['number'].toString(), totalQuestions: counts.totalQuestionsInTab, totalAnswered: counts.totalAnsweredInTab });
        });
        formProgress.push({ tab: '', totalQuestions: counts.totalQuestions, totalAnswered: counts.totalAnswered });
        //Example formProgress array.
        //[
        //  { tab: '1', totalQuestions: 2, totalAnswered: 1 },
        //  { tab: '2', totalQuestions: 8, totalAnswered: 4 },
        //  { tab: '', totalQuestions: 10, totalAnswered: 5 },
        //]
        return {
            formProgress: formProgress
        };
    }
    getQuestionResponse(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey) {
        return getRawResponse(model, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey);
    }
    updateQuestionCounts(counts, formFields, question, tabsModel, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let questionIsVisible = getFieldVisibility(formFields, question, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        let questionIsAnswered = getQuestionAnsweredStatus(tabsModel, tabKey, pageKey, pageIndex, sectionKey, sectionIndex, question.key.toString());
        if (questionIsVisible === true) {
            counts.totalQuestions++;
            counts.totalQuestionsInTab++;
            if (questionIsAnswered === true) {
                counts.totalAnswered++;
                counts.totalAnsweredInTab++;
            }
        }
        return counts;
    }
    extendFieldConfigForFunction(functionRegistry, parentConfig, functionProperty, functionNameProperty = `${functionProperty}FunctionName`) {
        if (functionRegistry && parentConfig?.[functionNameProperty]) {
            const functionName = this.parseFunctionName(parentConfig?.[functionNameProperty]);
            if (functionName) {
                parentConfig[functionProperty] = functionRegistry[functionName];
            }
        }
    }
    extendFieldConfigForViewMode(functionRegistry, repeatingItemProps) {
        this.extendFieldConfigForFunction(functionRegistry, repeatingItemProps, 'isViewMode');
        this.extendFieldConfigForFunction(functionRegistry, repeatingItemProps, 'isSectionIncludedInViewMode');
        this.extendFieldConfigForFunction(functionRegistry, repeatingItemProps, 'getViewModeCustomHtml');
    }
    extendFieldConfigForRepeatingItem(functionRegistry, repeatingItemProps) {
        this.extendFieldConfigForFunction(functionRegistry, repeatingItemProps, 'getCustomItemHeaderHtml');
        this.extendFieldConfigForFunction(functionRegistry, repeatingItemProps, 'getCustomItemSubHeaderHtml');
    }
    extendFieldConfigForRepeatingItemButtons(functionRegistry, buttonSettings) {
        if (functionRegistry) {
            for (const buttonSubType in RepeaterStandardButtonSubTypes) {
                const buttonConfiguration = buttonSettings?.standard?.[buttonSubType];
                this.extendFieldConfigForFunction(functionRegistry, buttonConfiguration, 'isVisible');
                this.extendFieldConfigForFunction(functionRegistry, buttonConfiguration, 'onBeforeAction');
            }
            for (const buttonSubType in RepeaterCustomButtonSubTypes) {
                for (const buttonConfiguration of buttonSettings?.custom?.[buttonSubType] ?? []) {
                    this.extendFieldConfigForFunction(functionRegistry, buttonConfiguration, 'isVisible');
                    this.extendFieldConfigForFunction(functionRegistry, buttonConfiguration, 'action');
                }
            }
        }
    }
    getChildFieldViaTopMostParentByAChildField(questionField, childKey) {
        let currentParent = questionField.parent;
        let form = currentParent;
        while (currentParent != null) {
            currentParent = currentParent.parent;
            if (currentParent) {
                form = currentParent;
            }
        }
        const formFieldGroup = form?.fieldGroup?.find(f => f?.key === "form");
        return formFieldGroup?.fieldGroup?.find(f => f?.key === childKey);
    }
    getOptionSet(questionField, isQuickSelectOptions = false) {
        let optionSetName = !isQuickSelectOptions ? questionField.props.optionSet?.name : questionField.props.quickSelectionOptionSet?.name;
        let optionSetSource = !isQuickSelectOptions ? questionField.props.optionSet?.source : questionField.props.quickSelectionOptionSet?.source;
        let optionSetApiEndpoint = !isQuickSelectOptions ? questionField.props.optionSet?.apiEndpoint : questionField.props.quickSelectionOptionSet?.apiEndpoint;
        if (optionSetName) {
            if (optionSetSource && optionSetSource === 'api' && optionSetApiEndpoint) {
                // This path is intended to retrieve the options for a particular optionSet from a separate server call (normally,
                // all needed optionSets are bundled up in the form config initially returned from the server). Currently, this code
                // doesn't work - it always returns an empty optionSet - because the empty optionSet is returned before the server
                // call has a chance to execute and populate it.
                //
                // The main challenge in fixing this is that this method (getOptionSet) is sync, but needs to issue a server call and
                // await its result, which means we have to change the method to be async. To do that, we also need to make the calls
                // to this method (and the methods they're in) async too.
                //
                // One approach to fixing this might be to move the necessary async server calls to the (already async) getFormConfig
                // and getFormConfigAndResponse methods:
                //   - here, just (synchronously) get the optionset out of this.preloadedOptionSets[optionSetName]
                //   - inside getFormConfig (and getFormConfigAndResponse), populate the needed entries in this.preloadedOptionSets
                //     by walking through the form config (the same way this.extendFieldConfig already does), looking for referenced
                //     optionSets, identifying which ones have optionSet.source == "api", issuing an (async) server call for each of,
                //     those, and storing the results in this.preloadedOptionSets[optionSetName]
                let optionSet = [];
                this.optionSetService.getOptionSetViaApi(optionSetApiEndpoint, optionSetName)
                    .subscribe(response => {
                    optionSet = response;
                });
                return optionSet;
            }
            else {
                let parentQuestionPageId = !isQuickSelectOptions ? questionField.props.optionSet?.parentQuestionPageId : questionField.props.quickSelectionOptionSet?.parentQuestionPageId;
                let parentQuestionSectionCode = !isQuickSelectOptions ? questionField.props.optionSet?.parentQuestionSectionCode : questionField.props.quickSelectionOptionSet?.parentQuestionSectionCode;
                let parentQuestionKey = !isQuickSelectOptions ? questionField.props.optionSet?.parentQuestionKey : questionField.props.quickSelectionOptionSet?.parentQuestionKey;
                let parentQuestionResponse = null;
                //Note: For dependent option set functionality, the parent question field must be either:
                // - in the same section as the child question field; or
                // - in a different section (this is not a repeating section and not part of a repeating page).
                if (parentQuestionPageId != null && parentQuestionSectionCode != null && parentQuestionKey != null) {
                    // Parent question field is in a different section to the child question field.
                    let keys = getTabPageKeysFromPageId(parentQuestionPageId);
                    const tabs = this.getChildFieldViaTopMostParentByAChildField(questionField, 'tabs');
                    let tabsModel = tabs?.model;
                    parentQuestionResponse = getRawResponse(tabsModel, keys.tabKey, keys.pageKey, -1, parentQuestionSectionCode, -1, parentQuestionKey);
                    optionSetName = optionSetName + '-' + parentQuestionKey + '-' + parentQuestionResponse;
                }
                else if (parentQuestionKey != null && questionField.model != null) {
                    // Parent question field is in the same section as the child question field.
                    parentQuestionResponse = questionField.model[parentQuestionKey];
                    optionSetName = optionSetName + '-' + parentQuestionKey + '-' + parentQuestionResponse;
                }
                if (parentQuestionKey != null) {
                    //Clear any current response to the field if the dependent option set has changed due to a change in the response to the parent question.
                    if (questionField.props.optionSet.dependentOptionSetName
                        && questionField.props.optionSet.dependentOptionSetName !== optionSetName
                        && questionField.model && questionField.model[questionField.key.toString()]) {
                        questionField.formControl.setValue(null);
                        questionField.formControl.markAsUntouched();
                        delete questionField.model[questionField.key.toString()];
                    }
                    questionField.props.optionSet['dependentOptionSetName'] = optionSetName;
                    if (isQuickSelectOptions) {
                        //Clear any current response to the field if the dependent option set has changed due to a change in the response to the parent question.
                        if (questionField.props.quickSelectionOptionSet.dependentOptionSetName
                            && questionField.props.quickSelectionOptionSet.dependentOptionSetName !== optionSetName
                            && questionField.model && questionField.model[questionField.key.toString()]) {
                            questionField.formControl.setValue(null);
                            questionField.formControl.markAsUntouched();
                            delete questionField.model[questionField.key.toString()];
                        }
                        questionField.props.quickSelectionOptionSet['dependentOptionSetName'] = optionSetName;
                    }
                }
                //When hasNoEmptyOption is true, blank option is not added to the option set
                return this.optionSetService.getOptionSet(optionSetName, (questionField.type === 'select' && questionField.props.optionSet.hasNoEmptyOption !== true));
            }
        }
        return [];
    }
    isPageEditable(pageField, isFormEditable) {
        let sections;
        if (this.formNavigationService.isRepeatingPageType(pageField.type.toString()) && pageField.fieldArray && pageField.fieldArray.fieldGroup) {
            sections = pageField.fieldArray.fieldGroup;
        }
        else {
            sections = pageField.fieldGroup;
        }
        let allSectionsDisabled = true;
        for (let s = 0; s < sections.length; s++) {
            allSectionsDisabled = allSectionsDisabled && !this.isSectionEditable(sections[s], isFormEditable);
        }
        return !allSectionsDisabled;
    }
    isSectionEditable(sectionField, isFormEditable) {
        let questions;
        if (this.formNavigationService.isRepeatingSectionType(sectionField.type.toString()) && sectionField.fieldArray && sectionField.fieldArray.fieldGroup) {
            questions = sectionField.fieldArray.fieldGroup;
        }
        else {
            questions = sectionField.fieldGroup;
        }
        let allQuestionsDisabled = true;
        for (let q = 0; q < questions.length; q++) {
            allQuestionsDisabled = allQuestionsDisabled && this.disableField(questions[q], isFormEditable);
        }
        return !allQuestionsDisabled;
    }
    getRepeatingPageIndex(questionField, questionInRepeatingSection) {
        let pageIndex;
        if (questionField.type && questionField.type.toString().includes('section')) {
            if (questionInRepeatingSection) {
                pageIndex = parseInt(questionField.parent?.parent?.key?.toString());
            }
            else {
                pageIndex = parseInt(questionField.parent?.key?.toString());
            }
        }
        else {
            if (questionInRepeatingSection) {
                pageIndex = parseInt(questionField.parent?.parent?.parent?.key?.toString());
            }
            else {
                pageIndex = parseInt(questionField.parent?.parent?.key?.toString());
            }
        }
        return pageIndex;
    }
    getRepeatingSectionIndex(questionField) {
        return parseInt(questionField.parent?.key?.toString());
    }
    disableField(questionField, isFormEditable) {
        if (isFormEditable !== null && isFormEditable === false && questionField.props.readOnlyCondition?.ignoreFormEditable !== true) {
            return true;
        }
        let parentSection = questionField.parent;
        let isVerificationQuestion = parentSection && parentSection.type === 'section-verification';
        if (isVerificationQuestion) {
            if (parentSection.model && parentSection.model[parentSection.props.statusControlId] === IdVerificationStatus.Y) {
                return true;
            }
            ;
        }
        //Get parent page.
        let isRepeatingPage = questionField.props.isRepeatingPage;
        let isRepeatingSection = questionField.props.isRepeatingSection;
        let parentPageField;
        if (isRepeatingPage && isRepeatingSection) {
            parentPageField = questionField.parent?.parent?.parent?.parent;
        }
        else if (isRepeatingPage || isRepeatingSection) {
            parentPageField = questionField.parent?.parent?.parent;
        }
        else {
            parentPageField = questionField.parent?.parent;
        }
        //Disable the question field if the parent page is not editable or the question field has read-only access.
        if ((parentPageField?.props?.isEditable != null && parentPageField?.props?.isEditable === false)
            || (questionField.props.access != null && questionField.props.access === 'R')) {
            return true;
        }
        else if (questionField.props.readOnlyCondition) {
            //If the question has a read-only condition, evaluate the result.
            let functionName = questionField.props.readOnlyCondition.functionName.toString();
            let valueRequired = questionField.props.readOnlyCondition.valueRequired;
            let pageIndex = null;
            let sectionIndex = null;
            if (isRepeatingPage) {
                pageIndex = this.getRepeatingPageIndex(questionField, isRepeatingSection);
                if (pageIndex === undefined || isNaN(pageIndex)) {
                    pageIndex = null;
                }
            }
            if (isRepeatingSection) {
                sectionIndex = this.getRepeatingSectionIndex(questionField);
                if (sectionIndex === undefined || isNaN(sectionIndex)) {
                    sectionIndex = null;
                }
            }
            let conditionEvalResult;
            if (this.coreService.conditionFunctions[functionName]) {
                conditionEvalResult = this.coreService.conditionFunctions[functionName](pageIndex, sectionIndex, questionField);
            }
            else {
                conditionEvalResult = this.coreService.coreConditionFunctions[functionName](pageIndex, sectionIndex, questionField);
            }
            if (conditionEvalResult == valueRequired) {
                return true;
            }
        }
        return false;
    }
    hasConditions(field) {
        return field.props.all || field.props.any;
    }
    hideField(model, field, pageIndex, sectionIndex) {
        const andCondition = 'and';
        const orCondition = 'or';
        let conditionOperator;
        let fieldConditions;
        if (field.props.all) {
            conditionOperator = andCondition;
            fieldConditions = field.props.all;
        }
        else {
            conditionOperator = orCondition;
            fieldConditions = field.props.any;
        }
        let defaultFieldVisibility = field.props.defaultVisibility;
        if (fieldConditions == null) {
            if (defaultFieldVisibility == null) {
                return false;
            }
            else {
                return !defaultFieldVisibility;
            }
        }
        else {
            let isRepeatingPage = field.props.isRepeatingPage;
            let isRepeatingSection = field.props.isRepeatingSection;
            let allConditionsSatisfied = true;
            let atLeastOneConditionSatisfied = false;
            for (let i = 0; i < fieldConditions.length; i++) {
                let operator = fieldConditions[i]['operator'];
                let valueRequired = fieldConditions[i]['valueRequired'];
                if (valueRequired === 'undefined') {
                    valueRequired = undefined;
                }
                else if (valueRequired === 'null') {
                    valueRequired = null;
                }
                if (isRepeatingPage) {
                    if (pageIndex == null || pageIndex == undefined) {
                        pageIndex = this.getRepeatingPageIndex(field, isRepeatingSection);
                        if (pageIndex === undefined || isNaN(pageIndex)) {
                            pageIndex = null;
                        }
                    }
                }
                if (isRepeatingSection) {
                    if (sectionIndex == null || sectionIndex == undefined) {
                        sectionIndex = this.getRepeatingSectionIndex(field);
                        if (sectionIndex === undefined || isNaN(sectionIndex)) {
                            sectionIndex = null;
                        }
                    }
                }
                if (operator.toLowerCase() === 'js') {
                    //Javascript function call to evaluate outcome.
                    let functionName = fieldConditions[i]['functionName'].toString();
                    let args = fieldConditions[i]['arguments'].toString();
                    if (args.startsWith('[')) {
                        //Arguments are an array.
                        args = args.replace('[', '').replace(']', '').replace(/\"/g, '');
                        // inject pageIndex value
                        if (pageIndex !== undefined && pageIndex !== null) {
                            args = args.replace('pageIndex', pageIndex);
                        }
                        // inject sectionIndex value
                        if (sectionIndex !== undefined && sectionIndex !== null) {
                            args = args.replace('sectionIndex', sectionIndex);
                        }
                        // inject model
                        if (model) {
                            args = args.replace('model', model);
                        }
                        // inject field
                        args = args.replace('this', field);
                        // convert from string to array
                        args = args.split(',');
                    }
                    else if (args.startsWith('\"')) {
                        //Argument is a single string.
                        args = args.replace(/\"/g, '');
                    }
                    else if (args === 'this') {
                        args = field;
                    }
                    else if (args === 'pageIndex') {
                        args = pageIndex;
                    }
                    else if (args === 'sectionIndex') {
                        args = sectionIndex;
                    }
                    else if (args === 'model') {
                        args = model;
                    }
                    let conditionEvalResult;
                    if (this.coreService.conditionFunctions[functionName]) {
                        conditionEvalResult = this.coreService.conditionFunctions[functionName](args);
                    }
                    else {
                        conditionEvalResult = this.coreService.coreConditionFunctions[functionName](args);
                    }
                    if (conditionEvalResult != valueRequired) {
                        allConditionsSatisfied = false;
                    }
                }
                else {
                    //Value-based conditions dependent on parent question response.
                    let keys = getTabPageKeysFromPageId(fieldConditions[i]['parentQuestionPageId']);
                    let tabKey = keys.tabKey;
                    let pageKey = keys.pageKey;
                    let parentQuestionSectionCode = fieldConditions[i]['parentQuestionSectionCode'];
                    let parentQuestionCode = fieldConditions[i]['parentQuestionCode'];
                    let responseFound = false;
                    let tabs = null;
                    if (model.form && model.form.tabs) {
                        tabs = model.form.tabs;
                    }
                    if (tabs
                        && tabs[tabKey]
                        && tabs[tabKey][pageKey]) {
                        let pageObject = tabs[tabKey][pageKey];
                        if (isRepeatingPage) {
                            // if (isRepeatingSection) {
                            //   pageIndex = parseInt(field.parent.parent.parent.key.toString());
                            // }
                            // else {
                            //   pageIndex = parseInt(field.parent.parent.key.toString());
                            // }
                            pageObject = tabs[tabKey][pageKey][pageIndex];
                        }
                        if (pageObject && pageObject[parentQuestionSectionCode]) {
                            let sectionObject = pageObject[parentQuestionSectionCode];
                            if (isRepeatingSection) {
                                //sectionIndex = parseInt(field.parent.key.toString());
                                sectionObject = pageObject[parentQuestionSectionCode][sectionIndex];
                            }
                            if (sectionObject) {
                                responseFound = true;
                                if (conditionOperator === andCondition && this.evaluateQuestionCondition(sectionObject[parentQuestionCode], operator, valueRequired) === false) {
                                    allConditionsSatisfied = false;
                                }
                                else if (this.evaluateQuestionCondition(sectionObject[parentQuestionCode], operator, valueRequired) === true) {
                                    atLeastOneConditionSatisfied = true;
                                }
                            }
                            else if (valueRequired === undefined && conditionOperator === orCondition) {
                                atLeastOneConditionSatisfied = true;
                            }
                        }
                    }
                    else if (valueRequired === undefined && conditionOperator === orCondition) {
                        atLeastOneConditionSatisfied = true;
                    }
                    if (!responseFound && conditionOperator === andCondition) {
                        //Parent page/section/question is missing from the model, so it's probably unanswered.
                        //Short circuit by using the field's default visibility.
                        return !defaultFieldVisibility;
                    }
                }
            }
            let hide = conditionOperator === andCondition ? !allConditionsSatisfied : !atLeastOneConditionSatisfied;
            return hide;
        }
    }
    evaluateQuestionCondition(response, operator, valueRequired) {
        if (valueRequired === 'addressNotFound') {
            return response === 'Address not found';
        }
        else {
            switch (operator.toLowerCase()) {
                case '===':
                case '==':
                    return response == valueRequired;
                case '!==':
                case '!=':
                    return response != valueRequired;
                case 'hasvalue':
                    return (response !== '' && response !== null && response !== undefined);
                case 'contains':
                    return response === null || response === undefined ? false : response.includes(valueRequired);
                case 'notcontains':
                    return !(response === null || response === undefined ? false : response.includes(valueRequired));
                default:
                    return false;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormConfigurationService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }, { token: TestingDataService }, { token: CoreService }, { token: OptionSetService }, { token: DialogService }, { token: FormNavigationService }, { token: ReportDataService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormConfigurationService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormConfigurationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }, { type: TestingDataService }, { type: CoreService }, { type: OptionSetService }, { type: DialogService }, { type: FormNavigationService }, { type: ReportDataService }], propDecorators: { endpoints: [{
                type: Input
            }] } });

class AddressService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
        this.addressApiBaseUrl = appSettings.addressApiBaseUrl;
        this.addressApiKey = appSettings.addressApiKey;
        this.addressApiSearchEndpoint = appSettings.addressApiSearchEndpoint;
        this.addressApiLgaEndpoint = appSettings.addressApiLgaEndpoint;
    }
    search(query) {
        let url = this.endpoints['addressApiSearchEndpoint'];
        return this.post(url, { searchTerm: query, maxResults: 20 });
        //For testing purposes
        //var data = [
        //  {
        //    addressDetails: {
        //      addressLine: '80 COLLINS STREET',
        //      locality: 'MELBOURNE',
        //      state: 'VIC',
        //      postcode: '3000'
        //    },
        //    display: '80 COLLINS STREET, MELBOURNE VIC 3000',
        //    location: {
        //      latitude: -1,
        //      longitude: -1
        //    }
        //  }
        //]
        //return of(data);
    }
    searchLga(latitude, longitude) {
        let url = this.endpoints['addressApiLgaEndpoint'];
        return this.post(url, { latitude: latitude, longitude: longitude });
        //For testing purposes
        //var data = {
        //  abs_lga_code: '26980',
        //  lga_code: '372',
        //  lga_name: 'WHITEHORSE',
        //  lga_official_name: 'WHITEHORSE CITY'
        //};
        //return of(data);
    }
    searchDev(query) {
        const url = `${this.addressApiBaseUrl}${this.addressApiSearchEndpoint}`;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': this.addressApiKey
            }
        };
        const body = {
            searchTerm: query,
            maxResults: 20
        };
        const subscription = this.httpClient.post(url, body, options);
        return subscription;
    }
    searchLgaDev(latitude, longitude) {
        const url = `${this.addressApiBaseUrl}${this.addressApiLgaEndpoint}`;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': this.addressApiKey
            }
        };
        const body = {
            latitude: latitude,
            longitude: longitude
        };
        const subscription = this.httpClient.post(url, body, options);
        return subscription;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }], propDecorators: { endpoints: [{
                type: Input
            }] } });

class DataService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
    }
    getList(request) {
        return this.post(request.apiEndPoint, request.filters);
    }
    saveData(apiEndpoint, request) {
        return this.post(apiEndpoint, request);
    }
    getConfigurationAndResponse(apiEndPoint, request) {
        return this.postAndFetch(apiEndPoint, request);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DataService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DataService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }] });

class UserService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
    }
    getLoggedInUser(endpoint) {
        const url = this.endpoints[endpoint];
        return this.get(url);
    }
    logout() {
        window.open('AzureAD/Account/SignOut', '_self');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }], propDecorators: { endpoints: [{
                type: Input
            }] } });

class SpinnerService {
    constructor() {
        this.spinnerChanged$ = new Subject();
        this.numberOfSpinnerRequests = 0;
    }
    /**
     * Show the spinner overlay
     * @returns returns the number of active spinner requests, including this one (the spinner displays so long as this number is >  1)
     */
    showSpinner() {
        this.numberOfSpinnerRequests++;
        if (this.numberOfSpinnerRequests === 1) {
            this.spinnerChanged$.next(true);
        }
        return this.numberOfSpinnerRequests;
    }
    /**
     * Hide the spinner overlay
     * @returns returns the number of active spinner requests, including this one (the spinner displays so long as this number is >  1)
     */
    hideSpinner() {
        this.numberOfSpinnerRequests--;
        if (this.numberOfSpinnerRequests === 0) {
            this.spinnerChanged$.next(false);
        }
        if (this.numberOfSpinnerRequests < 0) {
            console.warn('SpinnerService.hideSpinner() has been called more times than SpinnerService.showSpinner()');
        }
        //ensure that the counter never goes negative
        this.numberOfSpinnerRequests = Math.max(this.numberOfSpinnerRequests, 0);
        return this.numberOfSpinnerRequests;
    }
    spinnerRequested() {
        return this.spinnerChanged$.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SpinnerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class PowerBiService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
    }
    getEmbedToken(workspaceId, reportId) {
        return this.postAndFetch(this.endpoints['pbi-token'], { workspaceId: workspaceId, reportId: reportId });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PowerBiService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PowerBiService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PowerBiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }], propDecorators: { endpoints: [{
                type: Input
            }] } });

class BreadcrumbService {
    constructor() {
        this.crumbs = new Subject();
        this.crumbs$ = this.crumbs.asObservable();
    }
    setCrumbs(items) {
        this.crumbs.next((items || []).map(item => Object.assign({}, item, {
            routerLinkActiveOptions: { exact: true }
        })));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BreadcrumbService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [] });

class FileService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
    }
    upload(formIdentifier, file, title, fieldKey) {
        let url = this.endpoints['fileUploadEndpoint'];
        const formData = new FormData();
        formData.append('file', file, file.name);
        if (!!title) {
            return this.post(url, formData, { headers: { formIdentifier: formIdentifier, fieldKey: fieldKey, title: title } });
        }
        return this.post(url, formData, { headers: { formIdentifier: formIdentifier, fieldKey: fieldKey } });
        //For testing purposes.
        //return of('9B7DE023-3AC0-4EEC-AD5D-341A75F0F07D');
    }
    remove(formIdentifier, fileId) {
        let url = this.endpoints['fileRemoveEndpoint'];
        return this.post(url, [fileId], { headers: { formIdentifier: formIdentifier } });
        //For testing purposes.
        //return of({
        //  message: "Files have been deleted successfully",
        //  ids: [fileId]
        //});
    }
    download(formIdentifier, fileId) {
        let url = this.endpoints['fileDownloadEndpoint'];
        let options = {
            headers: new HttpHeaders().set('Authorization', ["text/plain"]),
            observe: 'response',
            responseType: 'blob',
        };
        return this.httpClient.get(url + '/' + formIdentifier + '/' + fileId, options);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }], propDecorators: { endpoints: [{
                type: Input
            }] } });

class IdVerificationService extends ApiService {
    constructor(httpClient, appSettings) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
    }
    verify(type, data) {
        let url = this.endpoints['idVerification'];
        return this.postAndFetch(url, { type: type, data: data });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IdVerificationService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IdVerificationService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: IdVerificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }], propDecorators: { endpoints: [{
                type: Input
            }] } });

/**
 * Provides functions for generic manipulation of arrays
 */
class ArrayService {
    /**
     * Splits an array into chunks of a given size and returns the chunks as an observable
     * @param inputArray input array that needs to be split into multiple array chunks
     * @param maxJsonSizeOfEachOutputArray maximum size of each output array chunk (the size is the size each output array chunk would have if they were deserialised as a JSON string)
     * @returns an Observable which produces the array chunks one by one as they are calculated
     */
    splitArrayByMaxJsonSize(inputArray, maxJsonSizeOfEachOutputArray) {
        return new Observable(subscriber => {
            try {
                if (!inputArray) {
                    throw new Error('inputArray cannot be null or undefined');
                }
                if (!maxJsonSizeOfEachOutputArray) {
                    throw new Error('maxJsonSizeOfEachOutputArray cannot be null or undefined or zero');
                }
                if (maxJsonSizeOfEachOutputArray < 0) {
                    throw new Error('maxJsonSizeOfEachOutputArray cannot be negative');
                }
                if (!Number.isInteger(maxJsonSizeOfEachOutputArray)) {
                    throw new Error('maxJsonSizeOfEachOutputArray cannot be decimal');
                }
                let cumulativeItemArray = [];
                let cumulativeJsonSize = 0;
                for (let itemIndex = 0; itemIndex < inputArray.length; itemIndex++) {
                    const item = inputArray[itemIndex];
                    const itemJsonSize = JSON.stringify(item).length + 1; // +1 is for the trailing commas of each item, i.e: [...,...,...,...]
                    if (cumulativeItemArray.length > 0) {
                        if (cumulativeJsonSize + itemJsonSize + 1 > maxJsonSizeOfEachOutputArray) { // +1 is for the 2 square brackets minus the last trailing comma, i.e: [...,...,...,...]
                            subscriber.next(cumulativeItemArray);
                            cumulativeItemArray = [];
                            cumulativeJsonSize = 0;
                        }
                    }
                    cumulativeItemArray.push(item);
                    cumulativeJsonSize += itemJsonSize;
                }
                subscriber.next(cumulativeItemArray);
                subscriber.complete();
            }
            catch (error) {
                subscriber.error(error);
            }
        });
    }
    /**
     * Returns the maximum number of columns of an array of arrays
     * @param inputArrayOrArrays input array of arrays
     * @returns the maximum number of columns of the array of arrays
     * @example inputArrayOrArrays = [[3, 1, 7], [], [10, -1]] => returns 3 (because the first row has 3 columns, which is the highest number of columns found)
     */
    getMaxColumnCount(inputArrayOrArrays) {
        if (!inputArrayOrArrays || inputArrayOrArrays.length === 0) {
            return 0;
        }
        return Math.max(...inputArrayOrArrays.map(row => row?.length ?? 0));
    }
    /**
     * Removes any empty/null/undefined row from the end of an array of arrays (the changes are made in place on the array of arrays provided)
     * @param inputArrayOrArrays input array of arrays
     * @example inputArrayOrArrays = [[3, 1, 7], [], [10, -1], null, undefined, [], []] => inputArrayOrArrays changes to [[3, 1, 7], [], [10, -1]]
     */
    removeTrailingEmptyRows(inputArrayOrArrays) {
        if (!inputArrayOrArrays || !inputArrayOrArrays.length) {
            return;
        }
        for (let index = inputArrayOrArrays.length - 1; index >= 0; index--) {
            const row = inputArrayOrArrays[index];
            if (row && row.length) {
                break;
            }
            inputArrayOrArrays.pop();
        }
    }
    /**
     * Returns an array containing the array index and the array item
     * @param inputArray input array
     * @returns output array containing the array index and the array item
     * @example inputArray = ['apple', 'banana', 'orange'] => returns [{value: 'apple', index: 0}, {value: 'banana', index: 1}, {value: 'orange', index: 2}]
     */
    toIndexedValueArray(inputArray) {
        if (!inputArray) {
            throw new Error('inputArray cannot be null or undefined');
        }
        return inputArray.map((value, index) => ({ value, index }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArrayService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArrayService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ArrayService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Provides functions for generic manipulation of Excel workbooks and worksheets
 */
class ExcelService {
    constructor(arrayService) {
        this.arrayService = arrayService;
    }
    /**
     * Parses the binary data containing an Excel (or Excel-compatible) workbook file (i.e. *.xlsx, *.xlsm, *.xls, *.csv)
     * and returns the list or worksheets contained in the workbook
     * @param workBookFileData workbook file as binary data
     * @returns an array with the names of the worksheets contained in the workbook
     * @example workBookFileData = '... some Excel workbook file as binary data...' => returns ['Instructions', 'Summary', 'Details']
     */
    getWorkSheetNames(workBookFileData) {
        // Parsing the workbook just enough to get the worksheet names
        const workBookWithOnlySheetNames = xlsx.read(workBookFileData, { type: 'binary', bookSheets: true });
        return workBookWithOnlySheetNames.SheetNames;
    }
    /**
     * Parses the binary data containing an Excel (or Excel-compatible) workbook file (i.e. *.xlsx, *.xlsm, *.xls, *.csv)
     * and returns the data contained in the specified worksheets
     * @param workBookFileData workbook file as binary data
     * @param workSheetNames name of the worksheets
     * @returns the data contained in the worksheets
     * @example workBookFileData = '... some Excel workbook file as binary data...', workSheetNames = ['Details', 'Instructions'] =>
     *          returns [{
     *            workSheetData: [[], ['Name', 'Surname', 'Age'], ['Joe', 'Bloggs'], ['Ann', 'Smith', 56]],
     *            workSheetIndexedColumns: [{value: 'A', index: 0}, {value: 'B', index: 1}, {value: 'C', index: 2}],
     *            workSheetIndexedRows: [{value: [], index: 0}, {value: ['Name', 'Surname', 'Age'], index: 1}, {value: ['Joe', 'Bloggs'], index: 2}, {value: ['Ann', 'Smith', 56], index: 3}]
     *          }, {
     *            workSheetData: [['Please fill in the Details sheet with employee's information]],
     *            workSheetIndexedColumns: [{value: 'A', index: 0}],
     *            workSheetIndexedRows: [{value: ['Please fill in the Details sheet with employee's information], index: 0}]
     *          }]
     */
    getWorkSheetContents(workBookFileData, workSheetNames) {
        if (!workBookFileData) {
            throw new Error('workBookFileData must be provided');
        }
        if (!workSheetNames || !workSheetNames.length) {
            throw new Error('workSheetNames must be provided');
        }
        // Parsing the workbook just enough to get the data from the selected worksheets
        const workBookWithSheets = xlsx.read(workBookFileData, { type: 'binary', sheets: workSheetNames, raw: true });
        return workSheetNames.map(workSheetName => {
            const workSheet = workBookWithSheets.Sheets[workSheetName];
            if (!workSheet) {
                // When the worksheet is extremely large (tens of megabytes), XLSX library quietly fails and returns an XSLX.WorkBook object with an empty lists of Sheets
                throw new Error(`Failed to load worksheet "${workSheetName}"`);
            }
            const workSheetData = xlsx.utils.sheet_to_json(workSheet, { header: 1 });
            this.arrayService.removeTrailingEmptyRows(workSheetData);
            const workSheetIndexedColumns = this.arrayService.toIndexedValueArray(this.getExcelStyleColumnNames(workSheetData));
            const workSheetIndexedRows = this.arrayService.toIndexedValueArray(workSheetData);
            return { workSheetName, workSheetData, workSheetIndexedColumns, workSheetIndexedRows };
        });
    }
    /**
     * Writes to the local file system a file containing an Excel workbook with the specified worksheets
     * @param workBookFileName name of the workbook file to be saved on the local file system
     * @param workSheetInfos array of worksheets to be included in the workbook
     * @example workBookFileName = 'Employees.xlsx',
     *          workSheetInfos = [
     *            {workSheetName: 'Instructions', workSheetData: [['Please fill in the Details sheet with employee's information]] },
     *            {workSheetName: 'Details', workSheetData: [[], ['Name', 'Surname', 'Age'], ['Joe', 'Bloggs'], ['Ann', 'Smith', 56]]}
     *          ]
     */
    writeWorkBookToFile(workBookFileName, workSheetInfos) {
        if (!workBookFileName) {
            throw new Error('workBookFileName must be provided');
        }
        if (!workSheetInfos || !workSheetInfos.length) {
            throw new Error('workSheetInfos must be provided');
        }
        const workBook = xlsx.utils.book_new();
        for (const workSheetInfo of workSheetInfos) {
            let workSheetData = workSheetInfo.workSheetData;
            if (workSheetData.length === 0) {
                // If the worksheet is completely empty, use an empty cell instead, otherwise the parsing will fail
                workSheetData = [];
            }
            const workSheet = xlsx.utils.json_to_sheet(workSheetData, { skipHeader: true });
            xlsx.utils.book_append_sheet(workBook, workSheet, workSheetInfo.workSheetName);
        }
        const zippedFileExtensions = ['xlsx', 'xlsm', 'xlsb', 'ods'];
        const compression = zippedFileExtensions.some(extension => workBookFileName.endsWith(`.${extension}`));
        xlsx.writeFile(workBook, workBookFileName, { compression });
    }
    /**
     * Returns the Excel-style column headers for a given input array of arrays
     * @param inputArrayOrArrays input array containing the worksheet data
     * @returns array containing the Excel-style column headers
     * @example inputArrayOrArrays = [['apple', 1, true], [], [2000, 1995]] => returns ['A', 'B', 'C'];
     */
    getExcelStyleColumnNames(inputArrayOrArrays) {
        const columnCount = this.arrayService.getMaxColumnCount(inputArrayOrArrays);
        return this.getExcelStyleColumnNamesFromColumnCount(columnCount);
    }
    /**
     * Returns the Excel-style column headers for a given number of columns
     * @param columnCount number of columns for which the headers are required
     * @returns array containing the Excel-style column headers
     * @example columnCount = 28 => returns ['A', 'B', 'C', ..., 'Y', 'Z', 'AA', 'AB']
     */
    getExcelStyleColumnNamesFromColumnCount(columnCount) {
        if (!Number.isInteger(columnCount)) {
            throw new Error('columnCount cannot be decimal');
        }
        if (columnCount < 0) {
            throw new Error('columnCount cannot be negative');
        }
        return Array.from({ length: columnCount }, (_, i) => this.getExcelStyleColumnNameNoValidations(i));
    }
    /**
    * Returns the Excel-style column header for a given column
    * @param columnIndex 0-based index of the column for which the header is required
    * @returns the Excel-style column header
    * @example columnIndex = 28 => returns 'AB'
    */
    getExcelStyleColumnName(columnIndex) {
        if (!Number.isInteger(columnIndex)) {
            throw new Error('columnIndex cannot be decimal');
        }
        if (columnIndex < 0) {
            throw new Error('columnIndex cannot be negative');
        }
        return this.getExcelStyleColumnNameNoValidations(columnIndex);
    }
    getExcelStyleColumnNameNoValidations(columnIndex) {
        const digits = ExcelService._excelStyleColumnDigits;
        const base = digits.length;
        let result = digits[columnIndex % base];
        columnIndex = Math.floor(columnIndex / base);
        while (columnIndex > 0) {
            result = digits[(columnIndex - 1) % base] + result;
            columnIndex = Math.floor((columnIndex - 1) / base);
        }
        return result;
    }
    static { this._excelStyleColumnDigits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''); }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExcelService, deps: [{ token: ArrayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExcelService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExcelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: ArrayService }] });

/**
 * Provides functions for generic manipulation of strings
 */
class StringService {
    /**
     * Implements an Angular-style string interpolation
     * @param templateString string containing placeholder tags in the {{..}} format (e.g.: 'Hello {{firstName}} {{lastName}}, how are you?')
     * @param data optional object containing the placeholder key-value pairs to be replaced in the templateString (e.g.: { firstName: "Joe", lastName: "Bloggs" })
     * @returns the interpolated string (e.g.: 'Hello Joe Bloggs, how are you?')
     */
    interpolate(templateString, data) {
        templateSettings.interpolate = /{{([\s\S]+?)}}/g;
        return template(templateString)(data);
    }
    /**
     * Implements a non-throwing version of JSON.parse, which returns null if the input does not contain a valid JSON token
     * @param jsonString string containing the serialised JSON to be parse (e.g.: '{ abc: "Hello"}' or 'true' or '[1, 2, 3]' etc.)
     * @returns the parsed JSON token (e.g.: { abc: "Hello"} or true or [1, 2, 3] etc.) or null if jsonString does not contain a valid JSON token
     */
    tryParseJsonToken(jsonString) {
        try {
            return JSON.parse(jsonString);
        }
        catch {
            return null;
        }
    }
    /**
     * Same as tryParseJsonToken, but it returns null also if the input is not a JSON object
     */
    tryParseJsonObject(jsonString) {
        const jsonToken = this.tryParseJsonToken(jsonString);
        return (typeof jsonToken === 'object' && !Array.isArray(jsonToken)) ? jsonToken : null;
    }
    /**
     * Same as tryParseJsonToken, but it returns null also if the input is not a JSON array
     */
    tryParseJsonArray(jsonString) {
        const jsonToken = this.tryParseJsonToken(jsonString);
        return Array.isArray(jsonToken) ? jsonToken : null;
    }
    /**
     * Same as tryParseJsonToken, but it returns null also if the input is not a JSON value
     */
    tryParseJsonValue(jsonString) {
        const jsonToken = this.tryParseJsonToken(jsonString);
        return (typeof jsonToken !== 'object') ? jsonToken : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StringService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StringService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StringService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

/**
 * Provides functions for downloading/uploading documents as generic tabular data (i.e. a 2D array of objects)
 */
class DocumentService extends ApiService {
    static { this.maxSizePerRequest = 10 * 1024 * 1024; } // 10 MBytes
    constructor(httpClient, appSettings, arrayService) {
        super(httpClient, appSettings.apiUrl + 'api');
        this.httpClient = httpClient;
        this.appSettings = appSettings;
        this.arrayService = arrayService;
    }
    /**
     * Downloads a 2D array of objects stored in the backend on the server.
     * @param event event containing the data to be uploaded
     * @returns an observable of the data of the stored document
     */
    downloadWorkSheet(event) {
        const endpoint = event.downloadDocumentEndpoint;
        const request = {
            documentId: event.workSheetId,
            documentSource: event.documentSource
        };
        return this.downloadDocument(endpoint, request)
            .pipe(take(1), map((response) => ({ workSheetId: event.workSheetId, workSheetName: response.fileName, workSheetData: response.data })));
    }
    /**
    * Uploads a 2D array of objects and stores it in the backend on the server.
    * @param event event specifying the data to be downloaded
    * @returns an observable of the ID and name of the stored document
    */
    uploadWorkSheet(event) {
        const endpoints = {
            initialise: event.initialiseDocumentUploadEndpoint,
            chunk: event.uploadDocumentChunkEndpoint,
            finalise: event.finaliseDocumentUploadEndpoint
        };
        const request = {
            fileName: event.workSheetName,
            data: event.workSheetData,
            documentSource: event.documentSource
        };
        return this.uploadDocument(endpoints, request)
            .pipe(take(1), map((response) => ({ workSheetId: response.documentId, workSheetName: event.workSheetName })));
    }
    /**
     * Downloads a 2D array of objects stored in the backend on the server.
     * @param endpoint
     * @param request
     * @returns an observable of the data of the stored document
     */
    downloadDocument(endpoint, request) {
        return this.postAndFetch(this.endpoints[endpoint], request);
    }
    /**
     * Uploads a 2D array of objects and stores it in the backend on the server.
     * This function internally calls:
     * 1. initialiseDocumentUpload
     * 2. uploadDocumentChunk (one or more times, depending on the number of data chunks)
     * 3. finaliseDocumentUpload
     * Upload is chunked (whereas download is not)
     * because application gateways usually set limits on the size of the HTTP request body,
     * but not on the size of the HTTP response body.
     * @param endpoints
     * @param request
     * @returns an observable of the ID of the stored document
     */
    uploadDocument(endpoints, request, maxSizePerRequest = DocumentService.maxSizePerRequest) {
        const { fileName, data, documentSource } = request;
        const splitArrayByMaxJsonSize = this.arrayService.splitArrayByMaxJsonSize(data, maxSizePerRequest);
        const initialiseDocumentUpload = this.initialiseDocumentUpload(endpoints.initialise, { fileName });
        const uploadDocumentChunk = (request) => this.uploadDocumentChunk(endpoints.chunk, request);
        const finaliseDocumentUpload = (request) => this.finaliseDocumentUpload(endpoints.finalise, request);
        const result = initialiseDocumentUpload
            .pipe(take(1), mergeMap(({ documentId }) => splitArrayByMaxJsonSize
            .pipe(mergeMap((chunkData, chunkIndex) => uploadDocumentChunk({ documentId, chunkIndex, data: chunkData })), last(), mergeMap(() => finaliseDocumentUpload({ documentId, documentSource })), map(() => ({ documentId })))));
        return result;
    }
    initialiseDocumentUpload(endpoint, request) {
        return this.postAndFetch(this.endpoints[endpoint], request);
    }
    uploadDocumentChunk(endpoint, request) {
        return this.postAndFetch(this.endpoints[endpoint], request);
    }
    finaliseDocumentUpload(endpoint, request) {
        return this.postAndFetch(this.endpoints[endpoint], request);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DocumentService, deps: [{ token: i1.HttpClient }, { token: ApplicationSettings }, { token: ArrayService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DocumentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DocumentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: ApplicationSettings }, { type: ArrayService }], propDecorators: { endpoints: [{
                type: Input
            }] } });

/**
 * Provides functions for the transformation of the Option and OptionSet data structures into the OptionMap and OptionMapSet data structures.
 * OptionMap and OptionMapSet facilitate the efficient lookup of Option values by Option.code, by using a hash-based search (i.e. o(1) time complexity),
 * as opposed to the linear lookup (i.e. o(N) time complexity), required to search for an item in the Option array.
 */
class OptionsSearchService {
    /**
     * Searches an input OptionSet for dependent options matching the given optionSetName and parentQuestionCode
     * and returns the array of matching option names.
     * @example
     *  PRE-CONDITIONS:
     *    optionSet = {
     *      "environment-applicationName-cgeps": [
     *        { "code": "cgeps_development", "text": "Development" },
     *        { "code": "cgeps_test",        "text": "Test"        },
     *        { "code": "cgeps_uat",         "text": "UAT"         }
     *      ],
     *      "environment-applicationName-ccmp": [
     *        { "code": "ccmp_development", "text": "Development" },
     *        { "code": "ccmp_training",    "text": "Training"    }
     *      ],
     *      "gender": [
     *        { "text": "Female", "code": "female" },
     *        { "text": "Male",   "code": "male"   }
     *      ]
     *    }
     *    optionSetName = "environment"
     *    parentQuestionCode = "applicationName"
     *  POST-CONDITIONS:
     *    return value = ["environment-applicationName-cgeps", "environment-applicationName-ccmp"]
     */
    getDependentOptionSetNames(optionSet, optionSetName, parentQuestionCode) {
        return (optionSet &&
            optionSetName &&
            parentQuestionCode &&
            Object.keys(optionSet).filter(name => name?.startsWith(`${optionSetName}-${parentQuestionCode}-`)))
            ?? [];
    }
    /**
     * Creates an optionMap object (or modifies an existing one if provided), where each item of the input options array corresponds to a property of the optionMap object.
     * The optionMap property key is the option.code and the value is the uppercase option.text.
     * The optional transform parameter can be used to implement a different transformation from the option item into the value of the optionMap property.
     * @example
     *  PRE-CONDITIONS:
     *    optionMap = {}
     *    options = [
     *      { "code": "604a0c18-cc62-47c8-934a-94e636e98620", "text": "CgepsAdministrator"        },
     *      { "code": "1cfeb6aa-7f2f-4ab3-a126-15859cf6a776", "text": "CgepsStandardUser"         },
     *      { "code": "bddafcbc-46eb-40a1-931d-18472c7b652b", "text": "DefinedEntityStandardUser" }
     *    ]
     *  POST-CONDITIONS:
     *    return value = optionMap = {
     *      "604a0c18-cc62-47c8-934a-94e636e98620": "CGEPSADMINISTRATOR",
     *      "1cfeb6aa-7f2f-4ab3-a126-15859cf6a776": "CGEPSSTANDARDUSER",
     *      "bddafcbc-46eb-40a1-931d-18472c7b652b": "DEFINEDENTITYSTANDARDUSER"
     *    }
     */
    setOptionMapFromOptions(optionMap, options, transform = (o) => o.text?.toUpperCase()) {
        return this.setOptionMapFromOptionsWithMerge(optionMap, [options], transform);
    }
    /**
     * Performs a similar transformation as getDependentOptionSetNames, but it merges multiple options into a single output ObjectMap.
     * This is useful to handle multiple dependent options as a single OptionMap lookup.
     * @example
     *  PRE-CONDITIONS:
     *    optionMap = {}
     *    optionsArray = [
     *      [
     *        { "code": "cgeps_development", "text": "Development" },
     *        { "code": "cgeps_test",        "text": "Test"        },
     *        { "code": "cgeps_uat",         "text": "UAT"         }
     *      ],
     *      [
     *        { "code": "ccmp_development", "text": "Development" },
     *        { "code": "ccmp_training",    "text": "Training"    }
     *      ]
     *    }
     *  POST-CONDITIONS:
     *    return value = optionMap = {
     *      "cgeps_development": "DEVELOPMENT",
     *      "cgeps_test":        "TEST",
     *      "cgeps_uat":         "UAT",
     *      "ccmp_development":  "DEVELOPMENT",
     *      "ccmp_training":     "TRAINING"
     *    }
     */
    setOptionMapFromOptionsWithMerge(optionMap, optionsArray, transform = (o) => o.text?.toUpperCase()) {
        optionMap = optionMap ?? {};
        for (const options of optionsArray ?? []) {
            for (const option of options ?? []) {
                optionMap[option.code] = transform(option);
            }
        }
        return optionMap;
    }
    /**
     * Creates an optionMapSet object (or modifies an existing one if provided), containing the OptionMap properties
     * specified in the optionSetNames array and found in the optionSet object.
     * @example
     *  PRE-CONDITIONS:
     *    optionMapSet = {}
     *    optionSet = {
     *      "environment": [
     *        { "code": "development", "text": "Development" },
     *        { "code": "test",        "text": "Test"        },
     *        { "code": "uat",         "text": "UAT"         }
     *      ],
     *      "applicationrole": [
     *        { "code": "604a0c18-cc62-47c8-934a-94e636e98620", "text": "CgepsAdministrator"        },
     *        { "code": "1cfeb6aa-7f2f-4ab3-a126-15859cf6a776", "text": "CgepsStandardUser"         },
     *        { "code": "bddafcbc-46eb-40a1-931d-18472c7b652b", "text": "DefinedEntityStandardUser" }
     *      ],
     *      "gender": [
     *        { "text": "Female", "code": "female" },
     *        { "text": "Male",   "code": "male"   }
     *      ]
     *    }
     *    optionSetNames = ["environment", "applicationrole"]
     *  POST-CONDITIONS:
     *    return value = optionMapSet = {
     *      "environment": {
     *        "development": "DEVELOPMENT",
     *        "test":        "TEST",
     *        "uat":         "UAT"
     *      },
     *      "applicationrole": {
     *        "604a0c18-cc62-47c8-934a-94e636e98620": "CGEPSADMINISTRATOR",
     *        "1cfeb6aa-7f2f-4ab3-a126-15859cf6a776": "CGEPSSTANDARDUSER",
     *        "bddafcbc-46eb-40a1-931d-18472c7b652b": "DEFINEDENTITYSTANDARDUSER"
     *      }
     *    }
     */
    setOptionMapSetFromOptionSet(optionMapSet, optionSet, optionSetNames) {
        return this.setOptionMapSetFromOptionSetWithMerge(optionMapSet, optionSet, optionSetNames.map(name => ({ in: [name], out: name })));
    }
    /**
     * Performs a similar transformation as setOptionMapSetFromOptionSet, but it merges multiple options into a single output ObjectMap.
     * This is useful to handle multiple dependent options as a single OptionMap lookup.
     * @example
     *  PRE-CONDITIONS:
     *    optionMapSet = {}
     *    optionSet = {
     *      "environment-applicationName-cgeps": [
     *        { "code": "cgeps_development", "text": "Development" },
     *        { "code": "cgeps_test",        "text": "Test"        },
     *        { "code": "cgeps_uat",         "text": "UAT"         }
     *      ],
     *      "environment-applicationName-ccmp": [
     *        { "code": "ccmp_development", "text": "Development" },
     *        { "code": "ccmp_training",    "text": "Training"    }
     *      ],
     *      "applicationrole": [
     *        { "code": "604a0c18-cc62-47c8-934a-94e636e98620", "text": "CgepsAdministrator"        },
     *        { "code": "1cfeb6aa-7f2f-4ab3-a126-15859cf6a776", "text": "CgepsStandardUser"         },
     *        { "code": "bddafcbc-46eb-40a1-931d-18472c7b652b", "text": "DefinedEntityStandardUser" }
     *      ],
     *      "gender": [
     *        { "text": "Female", "code": "female" },
     *        { "text": "Male",   "code": "male"   }
     *      ]
     *    }
     *    optionSetNameMappings = [
     *      { "in": ["environment-applicationName-cgeps", "environment-applicationName-ccmp"], out: "environment" },
     *      { "in": ["applicationrole"],                                                       out: "role"        }
     *    ]
     *  POST-CONDITIONS:
     *    return value = optionMapSet = {
     *      "environment": {
     *        "cgeps_development": "DEVELOPMENT",
     *        "cgeps_test":        "TEST",
     *        "cgeps_uat":         "UAT",
     *        "ccmp_development":  "DEVELOPMENT",
     *        "ccmp_training":     "TRAINING"
     *      },
     *      "role": {
     *        "604a0c18-cc62-47c8-934a-94e636e98620": "CGEPSADMINISTRATOR",
     *        "1cfeb6aa-7f2f-4ab3-a126-15859cf6a776": "CGEPSSTANDARDUSER",
     *        "bddafcbc-46eb-40a1-931d-18472c7b652b": "DEFINEDENTITYSTANDARDUSER"
     *      }
     *    }
     */
    setOptionMapSetFromOptionSetWithMerge(optionMapSet, optionSet, optionSetNameMappings) {
        optionMapSet = optionMapSet ?? {};
        for (const mapping of optionSetNameMappings ?? []) {
            optionMapSet[mapping.out] = this.setOptionMapFromOptionsWithMerge(optionMapSet[mapping.out], mapping.in.map(name => optionSet?.[name]).filter(o => o));
        }
        return optionMapSet;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionsSearchService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionsSearchService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionsSearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class CardSetTransformationService {
    extractMenuConfigFromFormConfig(fields, commandCallback) {
        const menuConfig = {
            items: []
        };
        const navTabs = fields?.[0]?.fieldGroup?.[0]?.fieldGroup ?? [];
        for (const navTab of navTabs) {
            const menuItem = {
                label: navTab?.props?.label,
                icon: navTab?.props?.cardSetLayoutOptions?.icon,
                visible: !navTab?.props?.cardSetLayoutOptions?.hideInCardSetMenu,
                routerLink: navTab?.props?.cardSetLayoutOptions?.route,
                items: []
            };
            const pages = navTab?.fieldGroup ?? [];
            for (const page of pages) {
                const menuSubItem = {
                    label: page?.props?.label,
                    icon: page?.props?.cardSetLayoutOptions?.icon,
                    visible: !page?.props?.cardSetLayoutOptions?.hideInCardSetMenu,
                    routerLink: page?.props?.cardSetLayoutOptions?.route,
                    url: page?.props?.cardSetLayoutOptions?.url,
                    target: page?.props?.cardSetLayoutOptions?.target,
                    command: () => commandCallback?.(navTab, page)
                };
                menuItem.items.push(menuSubItem);
            }
            menuConfig.items.push(menuItem);
        }
        return menuConfig;
    }
    static { this.getCardSetFieldTypeReplacements = (tabType) => [
        { old: 'tabs', new: tabType },
        { old: 'page', new: 'card-set-page' },
        { old: 'page-repeating', new: 'card-set-page-repeating' },
        { old: 'page-info', new: 'card-set-page-info' },
        { old: 'page-list', new: 'card-set-page-list' },
        { old: 'page-overview', new: 'card-set-page-overview' },
        { old: 'section', new: 'card-section' },
        { old: 'section-repeating', new: 'card-section-repeating' },
        { old: 'section-overview', new: 'card-section-overview' }
    ]; }
    static { this.cardSetFieldTypeReplacements = CardSetTransformationService.getCardSetFieldTypeReplacements('card-set-tabs'); }
    static { this.cardSetWithFlatTabsFieldTypeReplacements = CardSetTransformationService.getCardSetFieldTypeReplacements('card-set-tabs-flat'); }
    static replaceFieldType(fields, ...tokens) {
        if (fields?.length && tokens?.length) {
            for (const field of fields) {
                for (const token of tokens) {
                    if (field?.type === token.old) {
                        field.type = token.new;
                    }
                }
                this.replaceFieldType(field?.fieldGroup, ...tokens);
                if (field?.fieldArray != null) {
                    this.replaceFieldType((field?.fieldArray).fieldGroup, ...tokens);
                }
            }
        }
        return fields;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTransformationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTransformationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTransformationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class RepeaterRegistryService {
    constructor() {
        // We are using the FormArray object itself as the key rather than any simpler string unique identifier (like the formly key or the angular form id, etc.)
        // because I could not find one that was reliably unique, especially for complex scenarios where you have a FormArray object having underneath multiple FormArray objects
        // (for example, when there are one or more repeating sections inside a repeating page).
        this.registry = new Map();
        this.register = (formArray, repeaterInstance) => {
            if (formArray && repeaterInstance) {
                this.registry.set(formArray, repeaterInstance);
            }
        };
        this.unregister = (formArray) => {
            if (formArray) {
                this.registry.delete(formArray);
            }
        };
        this.get = (formArray) => this.registry.get(formArray);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RepeaterRegistryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RepeaterRegistryService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RepeaterRegistryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class RepeaterService {
    constructor() {
        this.getSectionRepeaterExtraSettings = () => ({
            getIncludeInRepeatingItemHeader: props => props.includeInRepeatingSectionHeader,
            getRepeatingItemHeaderOrder: props => props.repeatingSectionHeaderOrder,
            getIncludeInRepeatingItemSubHeader: props => props.includeInRepeatingSectionSubHeader,
            getRepeatingItemSubHeaderOrder: props => props.repeatingSectionSubHeaderOrder,
            getAllQuestionConfigs: itemConfig => itemConfig.fieldGroup,
            getAllFieldArrayQuestionConfigs: repeaterConfig => repeaterConfig.fieldArray.fieldGroup
        });
        this.getPageRepeaterExtraSettings = () => ({
            getIncludeInRepeatingItemHeader: props => props.includeInRepeatingPageHeader,
            getRepeatingItemHeaderOrder: props => props.repeatingPageHeaderOrder,
            getIncludeInRepeatingItemSubHeader: props => props.includeInRepeatingPageSubHeader,
            getRepeatingItemSubHeaderOrder: props => props.repeatingPageSubHeaderOrder,
            getAllQuestionConfigs: itemConfig => itemConfig.fieldGroup
                .filter(sectionConfig => !sectionConfig.fieldArray) // exclude repeating sections
                .map(sectionConfig => sectionConfig.fieldGroup)
                .reduce((previousQuestionConfigs, currentQuestionConfigs) => previousQuestionConfigs.concat(currentQuestionConfigs), []),
            getAllFieldArrayQuestionConfigs: repeaterConfig => repeaterConfig.fieldArray.fieldGroup
                .filter(sectionConfig => !sectionConfig.fieldArray) // exclude repeating sections
                .map(sectionConfig => sectionConfig.fieldGroup)
                .reduce((previousQuestionConfigs, currentQuestionConfigs) => previousQuestionConfigs.concat(currentQuestionConfigs), [])
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RepeaterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RepeaterService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RepeaterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class MenuService {
    constructor() {
        this.menuSource = new Subject();
        this.resetSource = new Subject();
        this.menuLoaded = new Subject();
        this.menuSource$ = this.menuSource.asObservable();
        this.resetSource$ = this.resetSource.asObservable();
        this.menuLoaded$ = this.menuLoaded.asObservable();
    }
    onMenuStateChange(key) {
        this.menuSource.next(key);
    }
    reset() {
        this.resetSource.next();
    }
    onMenuLoad(menuConfig) {
        this.menuLoaded.next(menuConfig);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class StyleConfigService {
    constructor() {
        this.layoutMode = 'static'; /*'overlay';*/ /*'horizontal';*/ /*'slim';*/
        this.layoutColor = 'dark'; /*'light';*/
        this.darkMenu = true; /*false;*/
        this.ripple = true; /*false;*/
        this.inputStyle = 'filled'; /*'outlined';*/
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StyleConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StyleConfigService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StyleConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class MenuConfigService {
    constructor(primengConfig, menuService, styleConfigService) {
        this.primengConfig = primengConfig;
        this.menuService = menuService;
        this.styleConfigService = styleConfigService;
    }
    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.activeTopbarItemIndex = null;
            this.topbarMenuActive = false;
        }
        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.menuService.reset();
            }
            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }
            this.menuHoverActive = false;
        }
        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }
        this.configClick = false;
        this.topbarItemClick = false;
        this.menuClick = false;
    }
    onMenuButtonClick(event) {
        this.menuClick = true;
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        if (this.styleConfigService.layoutMode === 'overlay') {
            this.overlayMenuActive = !this.overlayMenuActive;
        }
        else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            }
            else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }
        event.preventDefault();
    }
    isMenuActive() {
        if (this.styleConfigService.layoutMode === 'overlay') {
            return !!this.overlayMenuActive;
        }
        else {
            if (this.isDesktop()) {
                return !this.staticMenuDesktopInactive;
            }
            else {
                return !!this.staticMenuMobileActive;
            }
        }
    }
    onMenuClick(event) {
        this.menuClick = true;
    }
    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;
        this.hideOverlayMenu();
        event.preventDefault();
    }
    onTopbarItemClick(event, item, itemIndex, customCallback) {
        this.topbarItemClick = true;
        if (this.activeTopbarItem === item && this.activeTopbarItemIndex === itemIndex) {
            this.activeTopbarItem = null;
            this.activeTopbarItemIndex = null;
        }
        else {
            this.activeTopbarItem = item;
            this.activeTopbarItemIndex = itemIndex;
        }
        customCallback?.(event);
        event.preventDefault();
    }
    onTopbarSubItemClick(event, customCallback) {
        customCallback?.(event);
        event.preventDefault();
    }
    onConfigClick(event) {
        this.configClick = true;
    }
    onRippleChange(event) {
        this.styleConfigService.ripple = event['checked'];
        this.primengConfig = event['checked'];
    }
    hideOverlayMenu() {
        this.rotateMenuButton = false;
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }
    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }
    isDesktop() {
        return window.innerWidth > 1024;
    }
    isMobile() {
        return window.innerWidth <= 640;
    }
    isStatic() {
        return this.styleConfigService.layoutMode === 'static';
    }
    isOverlay() {
        return this.styleConfigService.layoutMode === 'overlay';
    }
    isHorizontal() {
        return this.styleConfigService.layoutMode === 'horizontal';
    }
    isSlim() {
        return this.styleConfigService.layoutMode === 'slim';
    }
    onClickStopPropagation(event, customCallback) {
        customCallback?.(event);
        event.stopPropagation();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuConfigService, deps: [{ token: i1$1.PrimeNGConfig }, { token: MenuService }, { token: StyleConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuConfigService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MenuConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: i1$1.PrimeNGConfig }, { type: MenuService }, { type: StyleConfigService }] });

class HeaderService {
    constructor() {
        this.headerUpdated = new Subject();
        this.headerUpdated$ = this.headerUpdated.asObservable();
    }
    onHeaderUpdated(headerConfig) {
        this.headerUpdated.next(headerConfig);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class StickyElementService {
    constructor() {
        this.elements = [];
    }
    register(el) {
        this.elements.push(el);
    }
    getOffset(el) {
        let idx = this.elements.indexOf(el);
        return this.elements.slice(0, idx).filter(x => x.stack).reduce((p, v) => p + v.stickyEl.clientHeight + v.offset, 0);
    }
    getZIndex(el) {
        let idx = this.elements.indexOf(el);
        return el.over ? el.zIndex : el.zIndex - idx;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StickyElementService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StickyElementService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StickyElementService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }] });

class FeatureUpdate {
}
class MapService {
    constructor() {
        this.featuresSource = new BehaviorSubject(null);
    }
    features() {
        return this.featuresSource.asObservable();
    }
    updateFeatures(featureUpdate) {
        this.featuresSource.next(featureUpdate);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MapService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MapService, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MapService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [] });

class DspxBaseFormCommonComponent {
    constructor(formConfigurationService) {
        this.formConfigurationService = formConfigurationService;
        this.fetchOnlyConfig = false;
        this.configCacheTimeoutInSeconds = 0;
        this.onButtonClick = new EventEmitter();
        this.onActionButtonClick = new EventEmitter();
        this.onDialogSubmit = new EventEmitter();
        this.onFilter = new EventEmitter();
        this.onFormLoad = new EventEmitter();
        this.onModelChange = new EventEmitter();
        this.onSave = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.form = new UntypedFormGroup({});
    }
    dialogSubmitted(event) {
        this.onDialogSubmit.emit(event);
    }
    modelChanged() {
        this.onModelChange.emit({ progressModel: this.getProgressModel() });
    }
    markAllFieldsAsTouched() {
        this.fields.forEach(field => markChildControlsAsTouched(field.formControl));
    }
    showValidationSummary(visible) {
        this.fields[0].fieldGroup[0].fieldGroup.forEach(tab => tab.fieldGroup.forEach(page => page.props.showValidationSummary = visible));
    }
    setStatusBar(tabKey, pageKey, statusBarContent) {
        this.formConfigurationService.setStatusBar(this.fields, tabKey, pageKey, statusBarContent);
    }
    getProgressModel() {
        return this.formConfigurationService.getProgressModel(this.fields, this.model, null);
    }
    getModelAsString() {
        return JSON.stringify(this.model);
    }
    getSaveFormEvent(isSubmit, closeFormAfterSaving) {
        return {
            isFormValid: this.form.valid,
            model: this.getModelAsString(),
            progressModel: this.getProgressModel(),
            lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
            isSubmit,
            closeFormAfterSaving
        };
    }
    convertToCardSetFieldTypes(fields) {
        const tokenReplacements = this.fieldTypeReplacements ?? CardSetTransformationService.cardSetFieldTypeReplacements;
        return CardSetTransformationService.replaceFieldType(fields, ...tokenReplacements);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBaseFormCommonComponent, deps: [{ token: FormConfigurationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxBaseFormCommonComponent, selector: "ng-component", inputs: { mockGetConfigApiCallSettings: "mockGetConfigApiCallSettings", verticalNavigationSettings: "verticalNavigationSettings", fieldTypeReplacements: "fieldTypeReplacements", formServiceEndpoint: "formServiceEndpoint", templateId: "templateId", versionNo: "versionNo", entityId: "entityId", model: "model", formName: "formName", fetchOnlyConfig: "fetchOnlyConfig", configCacheTimeoutInSeconds: "configCacheTimeoutInSeconds" }, outputs: { onButtonClick: "onButtonClick", onActionButtonClick: "onActionButtonClick", onDialogSubmit: "onDialogSubmit", onFilter: "onFilter", onFormLoad: "onFormLoad", onModelChange: "onModelChange", onSave: "onSave", onCancel: "onCancel" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBaseFormCommonComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: () => [{ type: FormConfigurationService }], propDecorators: { mockGetConfigApiCallSettings: [{
                type: Input
            }], verticalNavigationSettings: [{
                type: Input
            }], fieldTypeReplacements: [{
                type: Input
            }], formServiceEndpoint: [{
                type: Input
            }], templateId: [{
                type: Input
            }], versionNo: [{
                type: Input
            }], entityId: [{
                type: Input
            }], model: [{
                type: Input
            }], formName: [{
                type: Input
            }], fetchOnlyConfig: [{
                type: Input
            }], configCacheTimeoutInSeconds: [{
                type: Input
            }], onButtonClick: [{
                type: Output
            }], onActionButtonClick: [{
                type: Output
            }], onDialogSubmit: [{
                type: Output
            }], onFilter: [{
                type: Output
            }], onFormLoad: [{
                type: Output
            }], onModelChange: [{
                type: Output
            }], onSave: [{
                type: Output
            }], onCancel: [{
                type: Output
            }] } });

const RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioButton),
    multi: true
};
class RadioControlRegistry {
    constructor() {
        this.accessors = [];
    }
    add(control, accessor) {
        this.accessors.push([control, accessor]);
    }
    remove(accessor) {
        this.accessors = this.accessors.filter((c) => {
            return c[1] !== accessor;
        });
    }
    select(accessor) {
        this.accessors.forEach((c) => {
            if (this.isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].writeValue(accessor.value);
            }
        });
    }
    isSameGroup(controlPair, accessor) {
        if (!controlPair[0].control) {
            return false;
        }
        return controlPair[0].control.root === accessor.control.control.root && controlPair[1].name === accessor.name;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioControlRegistry, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioControlRegistry, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioControlRegistry, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });
/**
 * RadioButton is an extension to standard radio button element with theming.
 * @group Components
 */
class RadioButton {
    constructor(cd, injector, registry) {
        this.cd = cd;
        this.injector = injector;
        this.registry = registry;
        /**
         * Callback to invoke on radio button click.
         * @param {RadioButtonClickEvent} event - Custom click event.
         * @group Emits
         */
        this.onClick = new EventEmitter();
        /**
         * Callback to invoke when the receives focus.
         * @param {Event} event - Browser event.
         * @group Emits
         */
        this.onFocus = new EventEmitter();
        /**
         * Callback to invoke when the loses focus.
         * @param {Event} event - Browser event.
         * @group Emits
         */
        this.onBlur = new EventEmitter();
        this.onModelChange = () => { };
        this.onModelTouched = () => { };
    }
    ngOnInit() {
        this.control = this.injector.get(NgControl);
        this.checkName();
        this.registry.add(this.control, this);
    }
    handleClick(event, radioButton, focus) {
        event.preventDefault();
        if (this.disabled) {
            return;
        }
        this.select(event);
        if (focus) {
            radioButton.focus();
        }
    }
    select(event) {
        if (!this.disabled) {
            this.inputViewChild.nativeElement.checked = true;
            this.checked = true;
            this.onModelChange(this.value);
            this.registry.select(this);
            this.onClick.emit({ originalEvent: event, value: this.value });
        }
    }
    writeValue(value) {
        this.checked = value == this.value;
        if (this.inputViewChild && this.inputViewChild.nativeElement) {
            this.inputViewChild.nativeElement.checked = this.checked;
        }
        this.cd.markForCheck();
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    setDisabledState(val) {
        this.disabled = val;
        this.cd.markForCheck();
    }
    onInputFocus(event) {
        this.focused = true;
        this.onFocus.emit(event);
    }
    onInputBlur(event) {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }
    /**
     * Applies focus to input field.
     * @group Method
     */
    focus() {
        this.inputViewChild.nativeElement.focus();
    }
    ngOnDestroy() {
        this.registry.remove(this);
    }
    checkName() {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this.throwNameError();
        }
        if (!this.name && this.formControlName) {
            this.name = this.formControlName;
        }
    }
    throwNameError() {
        throw new Error(`
          If you define both a name and a formControlName attribute on your radio button, their values
          must match. Ex: <p-radioButton formControlName="food" name="food"></p-radioButton>
        `);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButton, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Injector }, { token: RadioControlRegistry }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RadioButton, selector: "p-radioButton", inputs: { value: "value", formControlName: "formControlName", name: "name", disabled: "disabled", label: "label", tabindex: "tabindex", inputId: "inputId", ariaLabelledBy: "ariaLabelledBy", ariaLabel: "ariaLabel", style: "style", styleClass: "styleClass", labelStyleClass: "labelStyleClass" }, outputs: { onClick: "onClick", onFocus: "onFocus", onBlur: "onBlur" }, host: { classAttribute: "p-element" }, providers: [RADIO_VALUE_ACCESSOR], viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<div [ngStyle]=\"style\"\r\n     [ngClass]=\"{ 'p-radiobutton p-component': true, 'p-radiobutton-checked': checked, 'p-radiobutton-disabled': disabled, 'p-radiobutton-focused': focused }\"\r\n     [class]=\"styleClass\"\r\n     [attr.data-pc-name]=\"'radiobutton'\"\r\n     [attr.data-pc-section]=\"'root'\"\r\n     (click)=\"handleClick($event, input, true)\">\r\n  <div class=\"p-hidden-accessible\" [attr.data-pc-section]=\"'hiddenInputWrapper'\">\r\n    <input #input\r\n           [attr.id]=\"inputId\"\r\n           type=\"radio\"\r\n           [attr.name]=\"name\"\r\n           [checked]=\"checked\"\r\n           [disabled]=\"disabled\"\r\n           [value]=\"value\"\r\n           [attr.aria-labelledby]=\"ariaLabelledBy\"\r\n           [attr.aria-label]=\"ariaLabel\"\r\n           [attr.tabindex]=\"tabindex\"\r\n           [attr.aria-checked]=\"checked\"\r\n           (focus)=\"onInputFocus($event)\"\r\n           (blur)=\"onInputBlur($event)\"\r\n           [attr.data-pc-section]=\"'hiddenInput'\" />\r\n  </div>\r\n  <div [ngClass]=\"{ 'p-radiobutton-box': true, 'p-highlight': checked, 'p-disabled': disabled, 'p-focus': focused }\" [attr.data-pc-section]=\"'input'\">\r\n    <span class=\"p-radiobutton-icon\" [attr.data-pc-section]=\"'icon'\"></span>\r\n  </div>\r\n</div>\r\n<label (click)=\"select($event)\"\r\n       [class]=\"labelStyleClass\"\r\n       [ngClass]=\"{ 'p-radiobutton-label': true, 'p-radiobutton-label-active': input.checked, 'p-disabled': disabled, 'p-radiobutton-label-focus': focused }\"\r\n       *ngIf=\"label\"\r\n       [attr.for]=\"inputId\"\r\n       [attr.data-pc-section]=\"'label'\">{{ label }}</label>\r\n", styles: ["@layer primeng{.p-radiobutton{display:inline-flex;cursor:pointer;-webkit-user-select:none;user-select:none;vertical-align:bottom;position:relative}.p-radiobutton-box{display:flex;justify-content:center;align-items:center}.p-radiobutton-icon{-webkit-backface-visibility:hidden;backface-visibility:hidden;transform:translateZ(0) scale(.1);border-radius:50%;visibility:hidden}.p-radiobutton-box.p-highlight .p-radiobutton-icon{transform:translateZ(0) scale(1);visibility:visible}p-radiobutton{display:inline-flex;vertical-align:bottom;align-items:center}.p-radiobutton-label{line-height:1}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButton, decorators: [{
            type: Component,
            args: [{ selector: 'p-radioButton', providers: [RADIO_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        'class': 'p-element'
                    }, template: "<div [ngStyle]=\"style\"\r\n     [ngClass]=\"{ 'p-radiobutton p-component': true, 'p-radiobutton-checked': checked, 'p-radiobutton-disabled': disabled, 'p-radiobutton-focused': focused }\"\r\n     [class]=\"styleClass\"\r\n     [attr.data-pc-name]=\"'radiobutton'\"\r\n     [attr.data-pc-section]=\"'root'\"\r\n     (click)=\"handleClick($event, input, true)\">\r\n  <div class=\"p-hidden-accessible\" [attr.data-pc-section]=\"'hiddenInputWrapper'\">\r\n    <input #input\r\n           [attr.id]=\"inputId\"\r\n           type=\"radio\"\r\n           [attr.name]=\"name\"\r\n           [checked]=\"checked\"\r\n           [disabled]=\"disabled\"\r\n           [value]=\"value\"\r\n           [attr.aria-labelledby]=\"ariaLabelledBy\"\r\n           [attr.aria-label]=\"ariaLabel\"\r\n           [attr.tabindex]=\"tabindex\"\r\n           [attr.aria-checked]=\"checked\"\r\n           (focus)=\"onInputFocus($event)\"\r\n           (blur)=\"onInputBlur($event)\"\r\n           [attr.data-pc-section]=\"'hiddenInput'\" />\r\n  </div>\r\n  <div [ngClass]=\"{ 'p-radiobutton-box': true, 'p-highlight': checked, 'p-disabled': disabled, 'p-focus': focused }\" [attr.data-pc-section]=\"'input'\">\r\n    <span class=\"p-radiobutton-icon\" [attr.data-pc-section]=\"'icon'\"></span>\r\n  </div>\r\n</div>\r\n<label (click)=\"select($event)\"\r\n       [class]=\"labelStyleClass\"\r\n       [ngClass]=\"{ 'p-radiobutton-label': true, 'p-radiobutton-label-active': input.checked, 'p-disabled': disabled, 'p-radiobutton-label-focus': focused }\"\r\n       *ngIf=\"label\"\r\n       [attr.for]=\"inputId\"\r\n       [attr.data-pc-section]=\"'label'\">{{ label }}</label>\r\n", styles: ["@layer primeng{.p-radiobutton{display:inline-flex;cursor:pointer;-webkit-user-select:none;user-select:none;vertical-align:bottom;position:relative}.p-radiobutton-box{display:flex;justify-content:center;align-items:center}.p-radiobutton-icon{-webkit-backface-visibility:hidden;backface-visibility:hidden;transform:translateZ(0) scale(.1);border-radius:50%;visibility:hidden}.p-radiobutton-box.p-highlight .p-radiobutton-icon{transform:translateZ(0) scale(1);visibility:visible}p-radiobutton{display:inline-flex;vertical-align:bottom;align-items:center}.p-radiobutton-label{line-height:1}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: RadioControlRegistry }], propDecorators: { value: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], inputId: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], labelStyleClass: [{
                type: Input
            }], onClick: [{
                type: Output
            }], onFocus: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], inputViewChild: [{
                type: ViewChild,
                args: ['input']
            }] } });
class RadioButtonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, declarations: [RadioButton], imports: [CommonModule], exports: [RadioButton] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [RadioButton],
                    declarations: [RadioButton]
                }]
        }] });

/**
 * TabPanel is a helper component for TabView component.
 * @group Components
 */
class TabPanel {
    /**
     * Inline style of the tab header.
     * @group Props
     */
    get headerStyle() {
        return this._headerStyle;
    }
    set headerStyle(headerStyle) {
        this._headerStyle = headerStyle;
        this.tabView.cd.markForCheck();
    }
    /**
     * Style class of the tab header.
     * @group Props
     */
    get headerStyleClass() {
        return this._headerStyleClass;
    }
    set headerStyleClass(headerStyleClass) {
        this._headerStyleClass = headerStyleClass;
        this.tabView.cd.markForCheck();
    }
    /**
     * Defines if tab is active.
     * @defaultValue false
     * @group Props
     */
    get selected() {
        return !!this._selected;
    }
    set selected(val) {
        this._selected = val;
        if (!this.loaded) {
            this.cd.detectChanges();
        }
        if (val)
            this.loaded = true;
    }
    /**
     * When true, tab cannot be activated.
     * @defaultValue false
     * @group Props
     */
    get disabled() {
        return !!this._disabled;
    }
    set disabled(disabled) {
        this._disabled = disabled;
        this.tabView.cd.markForCheck();
    }
    /**
     * Title of the tabPanel.
     * @group Props
     */
    get header() {
        return this._header;
    }
    set header(header) {
        this._header = header;
        // We have to wait for the rendering and then retrieve the actual size element from the DOM.
        // in future `Promise.resolve` can be changed to `queueMicrotask` (if ie11 support will be dropped)
        Promise.resolve().then(() => {
            this.tabView.updateInkBar();
            this.tabView.cd.markForCheck();
        });
    }
    /**
     * Left icon of the tabPanel.
     * @group Props
     * @deprecated since v15.4.2, use `lefticon` template instead.
     */
    get leftIcon() {
        return this._leftIcon;
    }
    set leftIcon(leftIcon) {
        this._leftIcon = leftIcon;
        this.tabView.cd.markForCheck();
    }
    /**
     * Left icon of the tabPanel.
     * @group Props
     * @deprecated since v15.4.2, use `righticon` template instead.
     */
    get rightIcon() {
        return this._rightIcon;
    }
    set rightIcon(rightIcon) {
        this._rightIcon = rightIcon;
        this.tabView.cd.markForCheck();
    }
    // dspx-core customisation made, please merge carefully when updating this with the latest from PrimeNg's GitHub.
    get includeInProgress() {
        return this._includeInProgress;
    }
    // dspx-core customisation made, please merge carefully when updating this with the latest from PrimeNg's GitHub.
    set includeInProgress(val) {
        this._includeInProgress = val;
        this.cd.detectChanges();
    }
    constructor(tabView, el, viewContainer, cd) {
        this.el = el;
        this.viewContainer = viewContainer;
        this.cd = cd;
        /**
         * Defines if tab can be removed.
         * @group Props
         */
        this.closable = false;
        /**
         * Whether a lazy loaded panel should avoid getting loaded again on reselection.
         * @group Props
         */
        this.cache = true;
        /**
         * Position of the tooltip.
         * @group Props
         */
        this.tooltipPosition = 'top';
        /**
         * Type of CSS position.
         * @group Props
         */
        this.tooltipPositionStyle = 'absolute';
        this.closed = false;
        this.view = null;
        this._rightIcon = undefined;
        this.loaded = false;
        this.tabView = tabView;
        this.id = UniqueComponentId();
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'header':
                    this.headerTemplate = item.template;
                    break;
                case 'content':
                    this.contentTemplate = item.template;
                    break;
                case 'righticon':
                    this.rightIconTemplate = item.template;
                    break;
                case 'lefticon':
                    this.leftIconTemplate = item.template;
                    break;
                case 'closeicon':
                    this.closeIconTemplate = item.template;
                    break;
                default:
                    this.contentTemplate = item.template;
                    break;
            }
        });
    }
    ngOnDestroy() {
        this.view = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabPanel, deps: [{ token: forwardRef(() => TabView) }, { token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TabPanel, selector: "p-tabPanel", inputs: { closable: "closable", headerStyle: "headerStyle", headerStyleClass: "headerStyleClass", cache: "cache", tooltip: "tooltip", tooltipPosition: "tooltipPosition", tooltipPositionStyle: "tooltipPositionStyle", tooltipStyleClass: "tooltipStyleClass", selected: "selected", disabled: "disabled", header: "header", leftIcon: "leftIcon", rightIcon: "rightIcon", includeInProgress: "includeInProgress" }, host: { classAttribute: "p-element" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], ngImport: i0, template: `
        <div
            *ngIf="!closed"
            class="p-tabview-panel"
            role="tabpanel"
            [hidden]="!selected"
            [attr.id]="tabView.getTabContentId(id)"
            [attr.aria-hidden]="!selected"
            [attr.aria-labelledby]="tabView.getTabHeaderActionId(id)"
            [attr.data-pc-name]="'tabpanel'"
        >
        <ng-content></ng-content>
        <ng-container *ngIf="contentTemplate && (cache ? loaded : selected)">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </ng-container>
    </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabPanel, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-tabPanel',
                    template: `
        <div
            *ngIf="!closed"
            class="p-tabview-panel"
            role="tabpanel"
            [hidden]="!selected"
            [attr.id]="tabView.getTabContentId(id)"
            [attr.aria-hidden]="!selected"
            [attr.aria-labelledby]="tabView.getTabHeaderActionId(id)"
            [attr.data-pc-name]="'tabpanel'"
        >
        <ng-content></ng-content>
        <ng-container *ngIf="contentTemplate && (cache ? loaded : selected)">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </ng-container>
    </div>
    `,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: TabView, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TabView)]
                }] }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }], propDecorators: { closable: [{
                type: Input
            }], headerStyle: [{
                type: Input
            }], headerStyleClass: [{
                type: Input
            }], cache: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], tooltipPosition: [{
                type: Input
            }], tooltipPositionStyle: [{
                type: Input
            }], tooltipStyleClass: [{
                type: Input
            }], selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], header: [{
                type: Input
            }], leftIcon: [{
                type: Input
            }], rightIcon: [{
                type: Input
            }], includeInProgress: [{
                type: Input
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }] } });
/**
 * TabView is a container component to group content with tabs.
 * @group Components
 */
class TabView {
    /**
     * Index of the active tab to change selected tab programmatically.
     * @group Props
     */
    get activeIndex() {
        return this._activeIndex;
    }
    set activeIndex(val) {
        this._activeIndex = val;
        if (this.preventActiveIndexPropagation) {
            this.preventActiveIndexPropagation = false;
            return;
        }
        if (this.tabs && this.tabs.length && this._activeIndex != null && this.tabs.length > this._activeIndex) {
            this.findSelectedTab().selected = false;
            this.tabs[this._activeIndex].selected = true;
            this.tabChanged = true;
            this.updateScrollBar(val);
        }
    }
    constructor(platformId, el, cd, renderer) {
        this.platformId = platformId;
        this.el = el;
        this.cd = cd;
        this.renderer = renderer;
        /**
         * When enabled, the focused tab is activated.
         * @group Props
         */
        this.selectOnFocus = false;
        /**
         * When activated, navigation buttons will automatically hide or show based on the available space within the container.
         * @group Props
         */
        this.autoHideButtons = true;
        /**
         * Index of the element in tabbing order.
         * @group Props
         */
        this.tabindex = 0;
        // dspx-core customisation made, please merge carefully when updating this with the latest from PrimeNg's GitHub.
        this.hasVisibleChildren = true;
        /**
         * Callback to invoke on tab change.
         * @param {TabViewChangeEvent} event - Custom tab change event
         * @group Emits
         */
        this.onChange = new EventEmitter();
        /**
         * Callback to invoke on tab close.
         * @param {TabViewCloseEvent} event - Custom tab close event
         * @group Emits
         */
        this.onClose = new EventEmitter();
        /**
         * Callback to invoke on the active tab change.
         * @param {number} index - New active index
         * @group Emits
         */
        this.activeIndexChange = new EventEmitter();
        this.backwardIsDisabled = true;
        this.forwardIsDisabled = false;
    }
    ngAfterContentInit() {
        this.initTabs();
        this.tabChangesSubscription = this.tabPanels.changes.subscribe((_) => {
            this.initTabs();
        });
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'previousicon':
                    this.previousIconTemplate = item.template;
                    break;
                case 'nexticon':
                    this.nextIconTemplate = item.template;
                    break;
            }
        });
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            if (this.autoHideButtons) {
                this.bindResizeObserver();
            }
        }
    }
    bindResizeObserver() {
        this.container = DomHandler.findSingle(this.el.nativeElement, '[data-pc-section="navcontent"]');
        this.list = DomHandler.findSingle(this.el.nativeElement, '[data-pc-section="nav"]');
        this.resizeObserver = new ResizeObserver(() => {
            if (this.list.offsetWidth > this.container.offsetWidth) {
                this.buttonVisible = true;
            }
            else {
                this.buttonVisible = false;
            }
            this.updateButtonState();
            this.cd.detectChanges();
        });
        this.resizeObserver.observe(this.container);
    }
    unbindResizeObserver() {
        this.resizeObserver.unobserve(this.elementToObserve.nativeElement);
        this.resizeObserver = null;
    }
    ngAfterViewChecked() {
        if (isPlatformBrowser(this.platformId)) {
            if (this.tabChanged) {
                this.updateInkBar();
                this.tabChanged = false;
            }
        }
    }
    ngOnDestroy() {
        if (this.tabChangesSubscription) {
            this.tabChangesSubscription.unsubscribe();
        }
        if (this.resizeObserver) {
            this.unbindResizeObserver();
        }
    }
    getTabHeaderActionId(tabId) {
        return `${tabId}_header_action`;
    }
    getTabContentId(tabId) {
        return `${tabId}_content`;
    }
    initTabs() {
        this.tabs = this.tabPanels.toArray();
        let selectedTab = this.findSelectedTab();
        if (!selectedTab && this.tabs.length) {
            if (this.activeIndex != null && this.tabs.length > this.activeIndex)
                this.tabs[this.activeIndex].selected = true;
            else
                this.tabs[0].selected = true;
            this.tabChanged = true;
        }
        this.cd.markForCheck();
    }
    onTabKeyDown(event, tab) {
        switch (event.code) {
            case 'ArrowLeft':
                this.onTabArrowLeftKey(event);
                break;
            case 'ArrowRight':
                this.onTabArrowRightKey(event);
                break;
            case 'Home':
                this.onTabHomeKey(event);
                break;
            case 'End':
                this.onTabEndKey(event);
                break;
            case 'PageDown':
                this.onTabEndKey(event);
                break;
            case 'PageUp':
                this.onTabHomeKey(event);
                break;
            case 'Enter':
            case 'Space':
                this.open(event, tab);
                break;
            default:
                break;
        }
    }
    onTabArrowLeftKey(event) {
        const prevHeaderAction = this.findPrevHeaderAction(event.target.parentElement);
        const index = DomHandler.getAttribute(prevHeaderAction, 'data-pc-index');
        prevHeaderAction ? this.changeFocusedTab(event, prevHeaderAction, index) : this.onTabEndKey(event);
        event.preventDefault();
    }
    onTabArrowRightKey(event) {
        const nextHeaderAction = this.findNextHeaderAction(event.target.parentElement);
        const index = DomHandler.getAttribute(nextHeaderAction, 'data-pc-index');
        nextHeaderAction ? this.changeFocusedTab(event, nextHeaderAction, index) : this.onTabHomeKey(event);
        event.preventDefault();
    }
    onTabHomeKey(event) {
        const firstHeaderAction = this.findFirstHeaderAction();
        const index = DomHandler.getAttribute(firstHeaderAction, 'data-pc-index');
        this.changeFocusedTab(event, firstHeaderAction, index);
        event.preventDefault();
    }
    onTabEndKey(event) {
        const lastHeaderAction = this.findLastHeaderAction();
        const index = DomHandler.getAttribute(lastHeaderAction, 'data-pc-index');
        this.changeFocusedTab(event, lastHeaderAction, index);
        event.preventDefault();
    }
    changeFocusedTab(event, element, index) {
        if (element) {
            DomHandler.focus(element);
            element.scrollIntoView({ block: 'nearest' });
            if (this.selectOnFocus) {
                const tab = this.tabs[index];
                this.open(event, tab);
            }
        }
    }
    findNextHeaderAction(tabElement, selfCheck = false) {
        const headerElement = selfCheck ? tabElement : tabElement.nextElementSibling;
        return headerElement
            ? DomHandler.getAttribute(headerElement, 'data-p-disabled') || DomHandler.getAttribute(headerElement, 'data-pc-section') === 'inkbar'
                ? this.findNextHeaderAction(headerElement)
                : DomHandler.findSingle(headerElement, '[data-pc-section="headeraction"]')
            : null;
    }
    findPrevHeaderAction(tabElement, selfCheck = false) {
        const headerElement = selfCheck ? tabElement : tabElement.previousElementSibling;
        return headerElement
            ? DomHandler.getAttribute(headerElement, 'data-p-disabled') || DomHandler.getAttribute(headerElement, 'data-pc-section') === 'inkbar'
                ? this.findPrevHeaderAction(headerElement)
                : DomHandler.findSingle(headerElement, '[data-pc-section="headeraction"]')
            : null;
    }
    findFirstHeaderAction() {
        const firstEl = this.navbar.nativeElement.firstElementChild;
        return this.findNextHeaderAction(firstEl, true);
    }
    findLastHeaderAction() {
        const lastEl = this.navbar.nativeElement.lastElementChild;
        const lastHeaderAction = DomHandler.getAttribute(lastEl, 'data-pc-section') === 'inkbar' ? lastEl.previousElementSibling : lastEl;
        return this.findPrevHeaderAction(lastHeaderAction, true);
    }
    open(event, tab) {
        if (tab.disabled) {
            if (event) {
                event.preventDefault();
            }
            return;
        }
        if (!tab.selected) {
            let selectedTab = this.findSelectedTab();
            if (selectedTab) {
                selectedTab.selected = false;
            }
            this.tabChanged = true;
            tab.selected = true;
            let selectedTabIndex = this.findTabIndex(tab);
            this.preventActiveIndexPropagation = true;
            this.activeIndexChange.emit(selectedTabIndex);
            this.onChange.emit({ originalEvent: event, index: selectedTabIndex });
            this.updateScrollBar(selectedTabIndex);
        }
        if (event) {
            event.preventDefault();
        }
    }
    close(event, tab) {
        if (this.controlClose) {
            this.onClose.emit({
                originalEvent: event,
                index: this.findTabIndex(tab),
                close: () => {
                    this.closeTab(tab);
                }
            });
        }
        else {
            this.closeTab(tab);
            this.onClose.emit({
                originalEvent: event,
                index: this.findTabIndex(tab)
            });
        }
    }
    closeTab(tab) {
        if (tab.disabled) {
            return;
        }
        if (tab.selected) {
            this.tabChanged = true;
            tab.selected = false;
            for (let i = 0; i < this.tabs.length; i++) {
                let tabPanel = this.tabs[i];
                if (!tabPanel.closed && !tab.disabled) {
                    tabPanel.selected = true;
                    break;
                }
            }
        }
        tab.closed = true;
    }
    findSelectedTab() {
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].selected) {
                return this.tabs[i];
            }
        }
        return null;
    }
    findTabIndex(tab) {
        let index = -1;
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i] == tab) {
                index = i;
                break;
            }
        }
        return index;
    }
    getBlockableElement() {
        return this.el.nativeElement.children[0];
    }
    updateInkBar() {
        if (isPlatformBrowser(this.platformId)) {
            if (this.navbar) {
                const tabHeader = DomHandler.findSingle(this.navbar.nativeElement, 'li.p-highlight');
                if (!tabHeader) {
                    return;
                }
                this.inkbar.nativeElement.style.width = DomHandler.getWidth(tabHeader) + 'px';
                this.inkbar.nativeElement.style.left = DomHandler.getOffset(tabHeader).left - DomHandler.getOffset(this.navbar.nativeElement).left + 'px';
            }
        }
    }
    updateScrollBar(index) {
        let tabHeader = this.navbar.nativeElement.children[index];
        tabHeader.scrollIntoView({ block: 'nearest' });
    }
    updateButtonState() {
        const content = this.content.nativeElement;
        const { scrollLeft, scrollWidth } = content;
        const width = DomHandler.getWidth(content);
        this.backwardIsDisabled = scrollLeft === 0;
        this.forwardIsDisabled = scrollLeft === scrollWidth - width;
    }
    onScroll(event) {
        this.scrollable && this.updateButtonState();
        event.preventDefault();
    }
    getVisibleButtonWidths() {
        return [this.prevBtn?.nativeElement, this.nextBtn?.nativeElement].reduce((acc, el) => (el ? acc + DomHandler.getWidth(el) : acc), 0);
    }
    navBackward() {
        const content = this.content.nativeElement;
        const width = DomHandler.getWidth(content) - this.getVisibleButtonWidths();
        const pos = content.scrollLeft - width;
        content.scrollLeft = pos <= 0 ? 0 : pos;
    }
    navForward() {
        const content = this.content.nativeElement;
        const width = DomHandler.getWidth(content) - this.getVisibleButtonWidths();
        const pos = content.scrollLeft + width;
        const lastPos = content.scrollWidth - width;
        content.scrollLeft = pos >= lastPos ? lastPos : pos;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabView, deps: [{ token: PLATFORM_ID }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TabView, selector: "p-tabView", inputs: { style: "style", styleClass: "styleClass", controlClose: "controlClose", scrollable: "scrollable", activeIndex: "activeIndex", selectOnFocus: "selectOnFocus", nextButtonAriaLabel: "nextButtonAriaLabel", prevButtonAriaLabel: "prevButtonAriaLabel", autoHideButtons: "autoHideButtons", tabindex: "tabindex", hasVisibleChildren: "hasVisibleChildren" }, outputs: { onChange: "onChange", onClose: "onClose", activeIndexChange: "activeIndexChange" }, host: { classAttribute: "p-element" }, queries: [{ propertyName: "tabPanels", predicate: TabPanel }, { propertyName: "templates", predicate: PrimeTemplate }], viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }, { propertyName: "navbar", first: true, predicate: ["navbar"], descendants: true }, { propertyName: "prevBtn", first: true, predicate: ["prevBtn"], descendants: true }, { propertyName: "nextBtn", first: true, predicate: ["nextBtn"], descendants: true }, { propertyName: "inkbar", first: true, predicate: ["inkbar"], descendants: true }, { propertyName: "elementToObserve", first: true, predicate: ["elementToObserve"], descendants: true }], ngImport: i0, template: "<div [ngClass]=\"{ 'p-tabview p-component': true, 'p-tabview-scrollable': scrollable }\" [ngStyle]=\"style\" [class]=\"styleClass\" [attr.data-pc-name]=\"'tabview'\">\r\n  <div #elementToObserve class=\"p-tabview-nav-container\">\r\n    <button *ngIf=\"scrollable && !backwardIsDisabled && autoHideButtons\"\r\n            #prevBtn\r\n            class=\"p-tabview-nav-prev p-tabview-nav-btn p-link\"\r\n            (click)=\"navBackward()\"\r\n            [attr.tabindex]=\"tabindex\"\r\n            [attr.aria-label]=\"prevButtonAriaLabel\"\r\n            type=\"button\"\r\n            pRipple>\r\n      <ChevronLeftIcon *ngIf=\"!previousIconTemplate\" [attr.aria-hidden]=\"true\" />\r\n      <ng-template *ngTemplateOutlet=\"previousIconTemplate\"></ng-template>\r\n    </button>\r\n    <div #content class=\"p-tabview-nav-content\" (scroll)=\"onScroll($event)\" [attr.data-pc-section]=\"'navcontent'\">\r\n      <ul #navbar class=\"p-tabview-nav\" role=\"tablist\" [attr.data-pc-section]=\"'nav'\">\r\n        <ng-template ngFor let-tab [ngForOf]=\"tabs\" let-i=\"index\">\r\n          <li role=\"presentation\" [ngClass]=\"{ 'p-highlight': tab.selected, 'p-disabled': tab.disabled }\" [hidden]=\"!tab.includeInProgress\" [attr.data-p-disabled]=\"tab.disabled\" [ngStyle]=\"tab.headerStyle\" [class]=\"tab.headerStyleClass\" *ngIf=\"!tab.closed\">\r\n            <a role=\"tab\"\r\n               class=\"p-tabview-nav-link\"\r\n               [pTooltip]=\"tab.tooltip\"\r\n               [tooltipPosition]=\"tab.tooltipPosition\"\r\n               [positionStyle]=\"tab.tooltipPositionStyle\"\r\n               [tooltipStyleClass]=\"tab.tooltipStyleClass\"\r\n               [attr.id]=\"getTabHeaderActionId(tab.id)\"\r\n               [attr.aria-controls]=\"getTabContentId(tab.id)\"\r\n               [attr.aria-selected]=\"tab.selected\"\r\n               [attr.tabindex]=\"tab.disabled || !tab.selected ? '-1' : tabindex\"\r\n               [attr.aria-disabled]=\"tab.disabled\"\r\n               [attr.data-pc-index]=\"i\"\r\n               [attr.data-pc-section]=\"'headeraction'\"\r\n               (click)=\"open($event, tab)\"\r\n               (keydown)=\"onTabKeyDown($event, tab)\"\r\n               pRipple>\r\n              <ng-container *ngIf=\"!tab.headerTemplate\">\r\n                <span class=\"p-tabview-left-icon\" [ngClass]=\"tab.leftIcon\" *ngIf=\"tab.leftIcon && !tab.leftIconTemplate\"></span>\r\n                <span *ngIf=\"tab.leftIconTemplate\" class=\"p-tabview-left-icon\">\r\n                  <ng-template *ngTemplateOutlet=\"tab.leftIconTemplate\"></ng-template>\r\n                </span>\r\n                <span class=\"p-tabview-title\">{{tab.header}}</span>\r\n                <span class=\"p-tabview-right-icon\" [ngClass]=\"tab.rightIcon\" *ngIf=\"tab.rightIcon && !tab.rightIconTemplate\"></span>\r\n                <span *ngIf=\"tab.rightIconTemplate\" class=\"p-tabview-right-icon\">\r\n                  <ng-template *ngTemplateOutlet=\"tab.rightIconTemplate\"></ng-template>\r\n                </span>\r\n              </ng-container>\r\n              <ng-container *ngTemplateOutlet=\"tab.headerTemplate\"></ng-container>\r\n              <ng-container *ngIf=\"tab.closable\">\r\n                <TimesIcon *ngIf=\"!tab.closeIconTemplate\" [styleClass]=\"'p-tabview-close'\" (click)=\"close($event, tab)\" />\r\n                <span class=\"tab.closeIconTemplate\" *ngIf=\"tab.closeIconTemplate\"></span>\r\n                <ng-template *ngTemplateOutlet=\"tab.closeIconTemplate\"></ng-template>\r\n              </ng-container>\r\n            </a>\r\n          </li>\r\n        </ng-template>\r\n        <li #inkbar class=\"p-tabview-ink-bar\" [ngClass]=\"{'display-none': !hasVisibleChildren}\" role=\"presentation\" aria-hidden=\"true\" [attr.data-pc-section]=\"'inkbar'\"></li>\r\n      </ul>\r\n    </div>\r\n    <button *ngIf=\"scrollable && !forwardIsDisabled && buttonVisible\"\r\n            #nextBtn\r\n            [attr.tabindex]=\"tabindex\"\r\n            [attr.aria-label]=\"nextButtonAriaLabel\"\r\n            class=\"p-tabview-nav-next p-tabview-nav-btn p-link\"\r\n            (click)=\"navForward()\"\r\n            type=\"button\"\r\n            pRipple>\r\n      <ChevronRightIcon *ngIf=\"!nextIconTemplate\" [attr.aria-hidden]=\"true\" />\r\n      <ng-template *ngTemplateOutlet=\"nextIconTemplate\"></ng-template>\r\n    </button>\r\n  </div>\r\n  <div class=\"p-tabview-panels\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: ["@layer primeng{.p-tabview-nav-container{position:relative}.p-tabview-scrollable .p-tabview-nav-container{overflow:hidden}.p-tabview-nav-content{overflow-x:auto;overflow-y:hidden;scroll-behavior:smooth;scrollbar-width:none;overscroll-behavior:contain auto}.p-tabview-nav{display:inline-flex;min-width:100%;margin:0;padding:0;list-style-type:none;flex:1 1 auto;flex-wrap:wrap}.p-tabview-nav-link{cursor:pointer;-webkit-user-select:none;user-select:none;display:flex;align-items:center;position:relative;text-decoration:none;overflow:hidden}.p-tabview-ink-bar{display:none;z-index:1}.p-tabview-nav-link:focus{z-index:1}.p-tabview-title{line-height:1;white-space:nowrap}.p-tabview-nav-btn{position:absolute;top:0;z-index:2;height:100%;display:flex;align-items:center;justify-content:center}.p-tabview-nav-prev{left:0}.p-tabview-nav-next{right:0}.p-tabview-nav-content::-webkit-scrollbar{display:none}.p-tabview-close{z-index:1}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$1.Tooltip, selector: "[pTooltip]", inputs: ["tooltipPosition", "tooltipEvent", "appendTo", "positionStyle", "tooltipStyleClass", "tooltipZIndex", "escape", "showDelay", "hideDelay", "life", "positionTop", "positionLeft", "autoHide", "fitContent", "hideOnEscape", "pTooltip", "tooltipDisabled", "tooltipOptions"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabView, decorators: [{
            type: Component,
            args: [{ selector: 'p-tabView', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: {
                        class: 'p-element'
                    }, template: "<div [ngClass]=\"{ 'p-tabview p-component': true, 'p-tabview-scrollable': scrollable }\" [ngStyle]=\"style\" [class]=\"styleClass\" [attr.data-pc-name]=\"'tabview'\">\r\n  <div #elementToObserve class=\"p-tabview-nav-container\">\r\n    <button *ngIf=\"scrollable && !backwardIsDisabled && autoHideButtons\"\r\n            #prevBtn\r\n            class=\"p-tabview-nav-prev p-tabview-nav-btn p-link\"\r\n            (click)=\"navBackward()\"\r\n            [attr.tabindex]=\"tabindex\"\r\n            [attr.aria-label]=\"prevButtonAriaLabel\"\r\n            type=\"button\"\r\n            pRipple>\r\n      <ChevronLeftIcon *ngIf=\"!previousIconTemplate\" [attr.aria-hidden]=\"true\" />\r\n      <ng-template *ngTemplateOutlet=\"previousIconTemplate\"></ng-template>\r\n    </button>\r\n    <div #content class=\"p-tabview-nav-content\" (scroll)=\"onScroll($event)\" [attr.data-pc-section]=\"'navcontent'\">\r\n      <ul #navbar class=\"p-tabview-nav\" role=\"tablist\" [attr.data-pc-section]=\"'nav'\">\r\n        <ng-template ngFor let-tab [ngForOf]=\"tabs\" let-i=\"index\">\r\n          <li role=\"presentation\" [ngClass]=\"{ 'p-highlight': tab.selected, 'p-disabled': tab.disabled }\" [hidden]=\"!tab.includeInProgress\" [attr.data-p-disabled]=\"tab.disabled\" [ngStyle]=\"tab.headerStyle\" [class]=\"tab.headerStyleClass\" *ngIf=\"!tab.closed\">\r\n            <a role=\"tab\"\r\n               class=\"p-tabview-nav-link\"\r\n               [pTooltip]=\"tab.tooltip\"\r\n               [tooltipPosition]=\"tab.tooltipPosition\"\r\n               [positionStyle]=\"tab.tooltipPositionStyle\"\r\n               [tooltipStyleClass]=\"tab.tooltipStyleClass\"\r\n               [attr.id]=\"getTabHeaderActionId(tab.id)\"\r\n               [attr.aria-controls]=\"getTabContentId(tab.id)\"\r\n               [attr.aria-selected]=\"tab.selected\"\r\n               [attr.tabindex]=\"tab.disabled || !tab.selected ? '-1' : tabindex\"\r\n               [attr.aria-disabled]=\"tab.disabled\"\r\n               [attr.data-pc-index]=\"i\"\r\n               [attr.data-pc-section]=\"'headeraction'\"\r\n               (click)=\"open($event, tab)\"\r\n               (keydown)=\"onTabKeyDown($event, tab)\"\r\n               pRipple>\r\n              <ng-container *ngIf=\"!tab.headerTemplate\">\r\n                <span class=\"p-tabview-left-icon\" [ngClass]=\"tab.leftIcon\" *ngIf=\"tab.leftIcon && !tab.leftIconTemplate\"></span>\r\n                <span *ngIf=\"tab.leftIconTemplate\" class=\"p-tabview-left-icon\">\r\n                  <ng-template *ngTemplateOutlet=\"tab.leftIconTemplate\"></ng-template>\r\n                </span>\r\n                <span class=\"p-tabview-title\">{{tab.header}}</span>\r\n                <span class=\"p-tabview-right-icon\" [ngClass]=\"tab.rightIcon\" *ngIf=\"tab.rightIcon && !tab.rightIconTemplate\"></span>\r\n                <span *ngIf=\"tab.rightIconTemplate\" class=\"p-tabview-right-icon\">\r\n                  <ng-template *ngTemplateOutlet=\"tab.rightIconTemplate\"></ng-template>\r\n                </span>\r\n              </ng-container>\r\n              <ng-container *ngTemplateOutlet=\"tab.headerTemplate\"></ng-container>\r\n              <ng-container *ngIf=\"tab.closable\">\r\n                <TimesIcon *ngIf=\"!tab.closeIconTemplate\" [styleClass]=\"'p-tabview-close'\" (click)=\"close($event, tab)\" />\r\n                <span class=\"tab.closeIconTemplate\" *ngIf=\"tab.closeIconTemplate\"></span>\r\n                <ng-template *ngTemplateOutlet=\"tab.closeIconTemplate\"></ng-template>\r\n              </ng-container>\r\n            </a>\r\n          </li>\r\n        </ng-template>\r\n        <li #inkbar class=\"p-tabview-ink-bar\" [ngClass]=\"{'display-none': !hasVisibleChildren}\" role=\"presentation\" aria-hidden=\"true\" [attr.data-pc-section]=\"'inkbar'\"></li>\r\n      </ul>\r\n    </div>\r\n    <button *ngIf=\"scrollable && !forwardIsDisabled && buttonVisible\"\r\n            #nextBtn\r\n            [attr.tabindex]=\"tabindex\"\r\n            [attr.aria-label]=\"nextButtonAriaLabel\"\r\n            class=\"p-tabview-nav-next p-tabview-nav-btn p-link\"\r\n            (click)=\"navForward()\"\r\n            type=\"button\"\r\n            pRipple>\r\n      <ChevronRightIcon *ngIf=\"!nextIconTemplate\" [attr.aria-hidden]=\"true\" />\r\n      <ng-template *ngTemplateOutlet=\"nextIconTemplate\"></ng-template>\r\n    </button>\r\n  </div>\r\n  <div class=\"p-tabview-panels\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n", styles: ["@layer primeng{.p-tabview-nav-container{position:relative}.p-tabview-scrollable .p-tabview-nav-container{overflow:hidden}.p-tabview-nav-content{overflow-x:auto;overflow-y:hidden;scroll-behavior:smooth;scrollbar-width:none;overscroll-behavior:contain auto}.p-tabview-nav{display:inline-flex;min-width:100%;margin:0;padding:0;list-style-type:none;flex:1 1 auto;flex-wrap:wrap}.p-tabview-nav-link{cursor:pointer;-webkit-user-select:none;user-select:none;display:flex;align-items:center;position:relative;text-decoration:none;overflow:hidden}.p-tabview-ink-bar{display:none;z-index:1}.p-tabview-nav-link:focus{z-index:1}.p-tabview-title{line-height:1;white-space:nowrap}.p-tabview-nav-btn{position:absolute;top:0;z-index:2;height:100%;display:flex;align-items:center;justify-content:center}.p-tabview-nav-prev{left:0}.p-tabview-nav-next{right:0}.p-tabview-nav-content::-webkit-scrollbar{display:none}.p-tabview-close{z-index:1}}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }], propDecorators: { style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], controlClose: [{
                type: Input
            }], scrollable: [{
                type: Input
            }], activeIndex: [{
                type: Input
            }], selectOnFocus: [{
                type: Input
            }], nextButtonAriaLabel: [{
                type: Input
            }], prevButtonAriaLabel: [{
                type: Input
            }], autoHideButtons: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], hasVisibleChildren: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onClose: [{
                type: Output
            }], activeIndexChange: [{
                type: Output
            }], content: [{
                type: ViewChild,
                args: ['content']
            }], navbar: [{
                type: ViewChild,
                args: ['navbar']
            }], prevBtn: [{
                type: ViewChild,
                args: ['prevBtn']
            }], nextBtn: [{
                type: ViewChild,
                args: ['nextBtn']
            }], inkbar: [{
                type: ViewChild,
                args: ['inkbar']
            }], tabPanels: [{
                type: ContentChildren,
                args: [TabPanel]
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }], elementToObserve: [{
                type: ViewChild,
                args: ['elementToObserve']
            }] } });

const CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Checkbox),
    multi: true
};
class Checkbox {
    constructor(cd) {
        this.cd = cd;
        /**
         * Icon class of the checkbox icon.
         * @group Props
         */
        this.checkboxIcon = 'fas fa-check';
        /**
         * Value in checked state.
         * @group Props
         */
        this.trueValue = true;
        /**
         * Value in unchecked state.
         * @group Props
         */
        this.falseValue = false;
        /**
         * Callback to invoke on value change.
         * @param {CheckboxChangeEvent} event - Custom value change event.
         * @group Emits
         */
        this.onChange = new EventEmitter();
        /**
         * Callback to invoke when the receives focus.
         * @param {Event} event - Browser event.
         * @group Emits
         */
        this.onFocus = new EventEmitter();
        /**
         * Callback to invoke when the loses focus.
         * @param {Event} event - Browser event.
         * @group Emits
         */
        this.onBlur = new EventEmitter();
        this.onModelChange = () => { };
        this.onModelTouched = () => { };
        this.focused = false;
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'icon':
                    this.checkboxIconTemplate = item.template;
                    break;
            }
        });
    }
    onClick(event) {
        // dspx-core customisation made, please do not remove the line below when updating this with the latest from PrimeNg's GitHub.
        event.preventDefault();
        if (!this.disabled && !this.readonly) {
            this.inputViewChild.nativeElement.focus();
            let newModelValue;
            if (!this.binary) {
                if (this.checked())
                    newModelValue = this.model.filter((val) => !ObjectUtils.equals(val, this.value));
                else
                    newModelValue = this.model ? [...this.model, this.value] : [this.value];
                this.onModelChange(newModelValue);
                this.model = newModelValue;
                if (this.formControl) {
                    this.formControl.setValue(newModelValue);
                }
            }
            else {
                newModelValue = this.checked() ? this.falseValue : this.trueValue;
                this.model = newModelValue;
                this.onModelChange(newModelValue);
            }
            this.onChange.emit({ checked: newModelValue, originalEvent: event });
        }
    }
    onInputFocus(event) {
        this.focused = true;
        this.onFocus.emit(event);
    }
    onInputBlur(event) {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }
    writeValue(model) {
        this.model = model;
        this.cd.markForCheck();
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    setDisabledState(val) {
        this.disabled = val;
        this.cd.markForCheck();
    }
    checked() {
        return this.binary ? this.model === this.trueValue : ObjectUtils.contains(this.value, this.model);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Checkbox, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: Checkbox, selector: "p-checkbox", inputs: { value: "value", name: "name", disabled: "disabled", binary: "binary", label: "label", ariaLabelledBy: "ariaLabelledBy", ariaLabel: "ariaLabel", tabindex: "tabindex", inputId: "inputId", style: "style", styleClass: "styleClass", labelStyleClass: "labelStyleClass", formControl: "formControl", checkboxIcon: "checkboxIcon", readonly: "readonly", required: "required", trueValue: "trueValue", falseValue: "falseValue" }, outputs: { onChange: "onChange", onFocus: "onFocus", onBlur: "onBlur" }, host: { classAttribute: "p-element" }, providers: [CHECKBOX_VALUE_ACCESSOR], queries: [{ propertyName: "templates", predicate: PrimeTemplate }], viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<div [ngStyle]=\"style\"\r\n     [ngClass]=\"{ 'p-checkbox p-component': true, 'p-checkbox-checked': checked(), 'p-checkbox-disabled': disabled, 'p-checkbox-focused': focused }\"\r\n     [class]=\"styleClass\"\r\n     [attr.data-pc-name]=\"'checkbox'\"\r\n     [attr.data-pc-section]=\"'root'\"\r\n     (click)=\"onClick($event)\">\r\n  <div class=\"p-hidden-accessible\" [attr.data-pc-section]=\"'hiddenInputWrapper'\" [attr.data-p-hidden-accessible]=\"true\">\r\n    <input #input\r\n           [attr.id]=\"inputId\"\r\n           type=\"checkbox\"\r\n           [value]=\"value\"\r\n           [attr.name]=\"name\"\r\n           [checked]=\"checked()\"\r\n           [attr.tabindex]=\"tabindex\"\r\n           [disabled]=\"disabled\"\r\n           [readonly]=\"readonly\"\r\n           [attr.required]=\"required\"\r\n           [attr.aria-labelledby]=\"ariaLabelledBy\"\r\n           [attr.aria-label]=\"ariaLabel\"\r\n           [attr.aria-checked]=\"checked()\"\r\n           (focus)=\"onInputFocus($event)\"\r\n           (blur)=\"onInputBlur($event)\"\r\n           [attr.data-pc-section]=\"'hiddenInput'\" />\r\n  </div>\r\n  <div class=\"p-checkbox-box\"\r\n       [ngClass]=\"{ 'p-highlight': checked(), 'p-disabled': disabled, 'p-focus': focused }\"\r\n       [attr.data-p-highlight]=\"checked()\"\r\n       [attr.data-p-disabled]=\"disabled\"\r\n       [attr.data-p-focused]=\"focused\"\r\n       [attr.data-pc-section]=\"'input'\">\r\n    <ng-container *ngIf=\"checked()\">\r\n      <ng-container *ngIf=\"!checkboxIconTemplate\">\r\n        <span *ngIf=\"checkboxIcon\" class=\"p-checkbox-icon\" [ngClass]=\"checkboxIcon\" [attr.data-pc-section]=\"'icon'\"></span>\r\n        <CheckIcon *ngIf=\"!checkboxIcon\" [styleClass]=\"'p-checkbox-icon'\" [attr.data-pc-section]=\"'icon'\" />\r\n      </ng-container>\r\n      <span *ngIf=\"checkboxIconTemplate\" class=\"p-checkbox-icon\" [attr.data-pc-section]=\"'icon'\">\r\n        <ng-template *ngTemplateOutlet=\"checkboxIconTemplate\"></ng-template>\r\n      </span>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n<label (click)=\"onClick($event)\"\r\n       [class]=\"labelStyleClass\"\r\n       [ngClass]=\"{'p-checkbox-label': true, 'p-checkbox-label-active':checked(), 'p-disabled':disabled, 'p-checkbox-label-focus':focused}\"\r\n       *ngIf=\"label\"\r\n       [attr.for]=\"inputId\"\r\n       [attr.data-pc-section]=\"'label'\">\r\n  {{label}}\r\n</label>\r\n", styles: [".p-checkbox{display:inline-flex;cursor:pointer;-webkit-user-select:none;user-select:none;vertical-align:bottom;position:relative}.p-checkbox-disabled{cursor:default!important;pointer-events:none}.p-checkbox-box{display:flex;justify-content:center;align-items:center}p-checkbox{display:inline-flex;vertical-align:bottom;align-items:center}.p-checkbox-label{line-height:1}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Checkbox, decorators: [{
            type: Component,
            args: [{ selector: 'p-checkbox', providers: [CHECKBOX_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: {
                        'class': 'p-element'
                    }, template: "<div [ngStyle]=\"style\"\r\n     [ngClass]=\"{ 'p-checkbox p-component': true, 'p-checkbox-checked': checked(), 'p-checkbox-disabled': disabled, 'p-checkbox-focused': focused }\"\r\n     [class]=\"styleClass\"\r\n     [attr.data-pc-name]=\"'checkbox'\"\r\n     [attr.data-pc-section]=\"'root'\"\r\n     (click)=\"onClick($event)\">\r\n  <div class=\"p-hidden-accessible\" [attr.data-pc-section]=\"'hiddenInputWrapper'\" [attr.data-p-hidden-accessible]=\"true\">\r\n    <input #input\r\n           [attr.id]=\"inputId\"\r\n           type=\"checkbox\"\r\n           [value]=\"value\"\r\n           [attr.name]=\"name\"\r\n           [checked]=\"checked()\"\r\n           [attr.tabindex]=\"tabindex\"\r\n           [disabled]=\"disabled\"\r\n           [readonly]=\"readonly\"\r\n           [attr.required]=\"required\"\r\n           [attr.aria-labelledby]=\"ariaLabelledBy\"\r\n           [attr.aria-label]=\"ariaLabel\"\r\n           [attr.aria-checked]=\"checked()\"\r\n           (focus)=\"onInputFocus($event)\"\r\n           (blur)=\"onInputBlur($event)\"\r\n           [attr.data-pc-section]=\"'hiddenInput'\" />\r\n  </div>\r\n  <div class=\"p-checkbox-box\"\r\n       [ngClass]=\"{ 'p-highlight': checked(), 'p-disabled': disabled, 'p-focus': focused }\"\r\n       [attr.data-p-highlight]=\"checked()\"\r\n       [attr.data-p-disabled]=\"disabled\"\r\n       [attr.data-p-focused]=\"focused\"\r\n       [attr.data-pc-section]=\"'input'\">\r\n    <ng-container *ngIf=\"checked()\">\r\n      <ng-container *ngIf=\"!checkboxIconTemplate\">\r\n        <span *ngIf=\"checkboxIcon\" class=\"p-checkbox-icon\" [ngClass]=\"checkboxIcon\" [attr.data-pc-section]=\"'icon'\"></span>\r\n        <CheckIcon *ngIf=\"!checkboxIcon\" [styleClass]=\"'p-checkbox-icon'\" [attr.data-pc-section]=\"'icon'\" />\r\n      </ng-container>\r\n      <span *ngIf=\"checkboxIconTemplate\" class=\"p-checkbox-icon\" [attr.data-pc-section]=\"'icon'\">\r\n        <ng-template *ngTemplateOutlet=\"checkboxIconTemplate\"></ng-template>\r\n      </span>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n<label (click)=\"onClick($event)\"\r\n       [class]=\"labelStyleClass\"\r\n       [ngClass]=\"{'p-checkbox-label': true, 'p-checkbox-label-active':checked(), 'p-disabled':disabled, 'p-checkbox-label-focus':focused}\"\r\n       *ngIf=\"label\"\r\n       [attr.for]=\"inputId\"\r\n       [attr.data-pc-section]=\"'label'\">\r\n  {{label}}\r\n</label>\r\n", styles: [".p-checkbox{display:inline-flex;cursor:pointer;-webkit-user-select:none;user-select:none;vertical-align:bottom;position:relative}.p-checkbox-disabled{cursor:default!important;pointer-events:none}.p-checkbox-box{display:flex;justify-content:center;align-items:center}p-checkbox{display:inline-flex;vertical-align:bottom;align-items:center}.p-checkbox-label{line-height:1}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { value: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], binary: [{
                type: Input
            }], label: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], inputId: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], labelStyleClass: [{
                type: Input
            }], formControl: [{
                type: Input
            }], checkboxIcon: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], trueValue: [{
                type: Input
            }], falseValue: [{
                type: Input
            }], onChange: [{
                type: Output
            }], onFocus: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], inputViewChild: [{
                type: ViewChild,
                args: ['input']
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }] } });

/**
 * Paginator is a generic component to display content in paged format.
 * @group Components
 */
class Paginator {
    /**
     * Zero-relative number of the first row to be displayed.
     * @group Props
     */
    get first() {
        return this._first;
    }
    set first(val) {
        this._first = val;
    }
    constructor(cd, config) {
        this.cd = cd;
        this.config = config;
        /**
         * Number of page links to display.
         * @group Props
         */
        this.pageLinkSize = 5;
        /**
         * Whether to show it even there is only one page.
         * @group Props
         */
        this.alwaysShow = true;
        /**
         * Dropdown height of the viewport in pixels, a scrollbar is defined if height of list exceeds this value.
         * @group Props
         */
        this.dropdownScrollHeight = '200px';
        /**
         * Template of the current page report element. Available placeholders are {currentPage},{totalPages},{rows},{first},{last} and {totalRecords}
         * @group Props
         */
        this.currentPageReportTemplate = '{currentPage} of {totalPages}';
        /**
         * When enabled, icons are displayed on paginator to go first and last page.
         * @group Props
         */
        this.showFirstLastIcon = true;
        /**
         * Number of total records.
         * @group Props
         */
        this.totalRecords = 0;
        /**
         * Data count to display per page.
         * @group Props
         */
        this.rows = 0;
        /**
         * Whether to show page links.
         * @group Props
         */
        this.showPageLinks = true;
        /**
         * Callback to invoke when page changes, the event object contains information about the new state.
         * @param {PaginatorState} event - Paginator state.
         * @group Emits
         */
        this.onPageChange = new EventEmitter();
        this._first = 0;
        this._page = 0;
    }
    ngOnInit() {
        this.updatePaginatorState();
    }
    getAriaLabel(labelType) {
        return this.config.translation.aria ? this.config.translation.aria[labelType] : undefined;
    }
    getPageAriaLabel(value) {
        return this.config.translation.aria ? this.config.translation.aria.pageLabel.replace(/{page}/g, `Page ${value}`) : undefined;
    }
    getLocalization(digit) {
        const numerals = [...new Intl.NumberFormat(this.locale, { useGrouping: false }).format(9876543210)].reverse();
        const index = new Map(numerals.map((d, i) => [i, d]));
        if (digit > 9) {
            const numbers = String(digit).split('');
            return numbers.map((number) => index.get(Number(number))).join('');
        }
        else {
            return index.get(digit);
        }
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'firstpagelinkicon':
                    this.firstPageLinkIconTemplate = item.template;
                    break;
                case 'previouspagelinkicon':
                    this.previousPageLinkIconTemplate = item.template;
                    break;
                case 'lastpagelinkicon':
                    this.lastPageLinkIconTemplate = item.template;
                    break;
                case 'nextpagelinkicon':
                    this.nextPageLinkIconTemplate = item.template;
                    break;
            }
        });
    }
    ngOnChanges(simpleChange) {
        if (simpleChange.totalRecords) {
            this.updatePageLinks();
            this.updatePaginatorState();
            this.updateFirst();
            this.updateRowsPerPageOptions();
        }
        if (simpleChange.first) {
            this._first = simpleChange.first.currentValue;
            this.updatePageLinks();
            this.updatePaginatorState();
        }
        if (simpleChange.rows) {
            this.updatePageLinks();
            this.updatePaginatorState();
        }
        if (simpleChange.rowsPerPageOptions) {
            this.updateRowsPerPageOptions();
        }
    }
    updateRowsPerPageOptions() {
        if (this.rowsPerPageOptions) {
            this.rowsPerPageItems = [];
            for (let opt of this.rowsPerPageOptions) {
                if (typeof opt == 'object' && opt['showAll']) {
                    this.rowsPerPageItems.unshift({ label: opt['showAll'], value: this.totalRecords });
                }
                else {
                    this.rowsPerPageItems.push({ label: String(this.getLocalization(opt)), value: opt });
                }
            }
        }
    }
    isFirstPage() {
        return this.getPage() === 0;
    }
    isLastPage() {
        return this.getPage() === this.getPageCount() - 1;
    }
    getPageCount() {
        return Math.ceil(this.totalRecords / this.rows);
    }
    calculatePageLinkBoundaries() {
        let numberOfPages = this.getPageCount(), visiblePages = Math.min(this.pageLinkSize, numberOfPages);
        //calculate range, keep current in middle if necessary
        let start = Math.max(0, Math.ceil(this.getPage() - visiblePages / 2)), end = Math.min(numberOfPages - 1, start + visiblePages - 1);
        //check when approaching to last page
        var delta = this.pageLinkSize - (end - start + 1);
        start = Math.max(0, start - delta);
        return [start, end];
    }
    updatePageLinks() {
        this.pageLinks = [];
        let boundaries = this.calculatePageLinkBoundaries(), start = boundaries[0], end = boundaries[1];
        for (let i = start; i <= end; i++) {
            this.pageLinks.push(i + 1);
        }
        if (this.showJumpToPageDropdown) {
            this.pageItems = [];
            for (let i = 0; i < this.getPageCount(); i++) {
                this.pageItems.push({ label: String(i + 1), value: i });
            }
        }
    }
    changePage(p) {
        var pc = this.getPageCount();
        if (p >= 0 && p < pc) {
            this._first = this.rows * p;
            var state = {
                page: p,
                first: this.first,
                rows: this.rows,
                pageCount: pc
            };
            this.updatePageLinks();
            this.onPageChange.emit(state);
            this.updatePaginatorState();
        }
    }
    updateFirst() {
        const page = this.getPage();
        if (page > 0 && this.totalRecords && this.first >= this.totalRecords) {
            Promise.resolve(null).then(() => this.changePage(page - 1));
        }
    }
    getPage() {
        return Math.floor(this.first / this.rows);
    }
    changePageToFirst(event) {
        if (!this.isFirstPage()) {
            this.changePage(0);
        }
        event.preventDefault();
    }
    changePageToPrev(event) {
        this.changePage(this.getPage() - 1);
        event.preventDefault();
    }
    changePageToNext(event) {
        this.changePage(this.getPage() + 1);
        event.preventDefault();
    }
    changePageToLast(event) {
        if (!this.isLastPage()) {
            this.changePage(this.getPageCount() - 1);
        }
        event.preventDefault();
    }
    onPageLinkClick(event, page) {
        this.changePage(page);
        event.preventDefault();
    }
    onRppChange(event) {
        this.changePage(this.getPage());
    }
    onPageDropdownChange(event) {
        this.changePage(event.value);
    }
    updatePaginatorState() {
        this.paginatorState = {
            page: this.getPage(),
            pageCount: this.getPageCount(),
            rows: this.rows,
            first: this.first,
            totalRecords: this.totalRecords
        };
    }
    empty() {
        return this.getPageCount() === 0;
    }
    currentPage() {
        return this.getPageCount() > 0 ? this.getPage() + 1 : 0;
    }
    get currentPageReport() {
        return this.currentPageReportTemplate
            .replace('{currentPage}', String(this.currentPage()))
            .replace('{totalPages}', String(this.getPageCount()))
            .replace('{first}', String(this.totalRecords > 0 ? this._first + 1 : 0))
            .replace('{last}', String(Math.min(this._first + this.rows, this.totalRecords)))
            .replace('{rows}', String(this.rows))
            .replace('{totalRecords}', String(this.totalRecords));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Paginator, deps: [{ token: i0.ChangeDetectorRef }, { token: i1$1.PrimeNGConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: Paginator, selector: "p-paginator", inputs: { pageLinkSize: "pageLinkSize", style: "style", styleClass: "styleClass", alwaysShow: "alwaysShow", dropdownAppendTo: "dropdownAppendTo", templateLeft: "templateLeft", templateRight: "templateRight", appendTo: "appendTo", dropdownScrollHeight: "dropdownScrollHeight", currentPageReportTemplate: "currentPageReportTemplate", showCurrentPageReport: "showCurrentPageReport", showFirstLastIcon: "showFirstLastIcon", totalRecords: "totalRecords", rows: "rows", rowsPerPageOptions: "rowsPerPageOptions", showJumpToPageDropdown: "showJumpToPageDropdown", showJumpToPageInput: "showJumpToPageInput", showPageLinks: "showPageLinks", locale: "locale", dropdownItemTemplate: "dropdownItemTemplate", first: "first" }, outputs: { onPageChange: "onPageChange" }, host: { classAttribute: "p-element" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"styleClass\" [ngStyle]=\"style\" [ngClass]=\"'p-paginator p-component'\" *ngIf=\"alwaysShow ? true : pageLinks && pageLinks.length > 1\" [attr.data-pc-section]=\"'paginator'\" [attr.data-pc-section]=\"'root'\">\r\n  <div class=\"p-paginator-left-content\" *ngIf=\"templateLeft\" [attr.data-pc-section]=\"'start'\">\r\n    <ng-container *ngTemplateOutlet=\"templateLeft; context: { $implicit: paginatorState }\"></ng-container>\r\n  </div>\r\n  <span class=\"p-paginator-current\" *ngIf=\"showCurrentPageReport\">{{currentPageReport}}</span>\r\n  <button *ngIf=\"showFirstLastIcon\"\r\n          type=\"button\"\r\n          [disabled]=\"isFirstPage() || empty()\"\r\n          (click)=\"changePageToFirst($event)\"\r\n          pRipple\r\n          class=\"p-paginator-first p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isFirstPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('firstPageLabel')\">\r\n    <AngleDoubleLeftIcon *ngIf=\"!firstPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"firstPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"firstPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <button type=\"button\"\r\n          [disabled]=\"isFirstPage() || empty()\"\r\n          (click)=\"changePageToPrev($event)\"\r\n          pRipple\r\n          class=\"p-paginator-prev p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isFirstPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('prevPageLabel')\">\r\n    <AngleLeftIcon *ngIf=\"!previousPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"previousPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"previousPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <span class=\"p-paginator-pages\" *ngIf=\"showPageLinks\">\r\n    <button type=\"button\"\r\n            *ngFor=\"let pageLink of pageLinks\"\r\n            class=\"p-paginator-page p-paginator-element p-link\"\r\n            [ngClass]=\"{ 'p-highlight': pageLink - 1 == getPage() }\"\r\n            [attr.aria-label]=\"getPageAriaLabel(pageLink)\"\r\n            [attr.aria-current]=\"pageLink - 1 == getPage() ? 'page' : undefined\"\r\n            (click)=\"onPageLinkClick($event, pageLink - 1)\"\r\n            pRipple>\r\n      {{ getLocalization(pageLink) }}\r\n    </button>\r\n  </span>\r\n  <p-dropdown [options]=\"pageItems\"\r\n              [ngModel]=\"getPage()\"\r\n              *ngIf=\"showJumpToPageDropdown\"\r\n              [disabled]=\"empty()\"\r\n              [attr.aria-label]=\"getAriaLabel('jumpToPageDropdownLabel')\"\r\n              styleClass=\"p-paginator-page-options\"\r\n              (onChange)=\"onPageDropdownChange($event)\"\r\n              [appendTo]=\"dropdownAppendTo\"\r\n              [scrollHeight]=\"dropdownScrollHeight\">\r\n    <ng-template pTemplate=\"selectedItem\">{{currentPageReport}}</ng-template>\r\n  </p-dropdown>\r\n  <button type=\"button\"\r\n          [disabled]=\"isLastPage() || empty()\"\r\n          (click)=\"changePageToNext($event)\"\r\n          pRipple\r\n          class=\"p-paginator-next p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isLastPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('nextPageLabel')\">\r\n    <AngleRightIcon *ngIf=\"!nextPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"nextPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"nextPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <button *ngIf=\"showFirstLastIcon\"\r\n          type=\"button\"\r\n          [disabled]=\"isLastPage() || empty()\"\r\n          (click)=\"changePageToLast($event)\"\r\n          pRipple\r\n          class=\"p-paginator-last p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isLastPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('lastPageLabel')\">\r\n    <AngleDoubleRightIcon *ngIf=\"!lastPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"lastPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"lastPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <p-inputNumber *ngIf=\"showJumpToPageInput\" [ngModel]=\"currentPage()\" class=\"p-paginator-page-input\" [disabled]=\"empty()\" (ngModelChange)=\"changePage($event - 1)\"></p-inputNumber>\r\n  <p-dropdown [options]=\"rowsPerPageItems\"\r\n              [(ngModel)]=\"rows\"\r\n              *ngIf=\"rowsPerPageOptions\"\r\n              styleClass=\"p-paginator-rpp-options\"\r\n              [disabled]=\"empty()\"\r\n              (onChange)=\"onRppChange($event)\"\r\n              [appendTo]=\"dropdownAppendTo\"\r\n              [scrollHeight]=\"dropdownScrollHeight\"\r\n              [ariaLabel]=\"getAriaLabel('rowsPerPageLabel')\">\r\n    <ng-container *ngIf=\"dropdownItemTemplate\">\r\n      <ng-template let-item pTemplate=\"item\">\r\n        <ng-container *ngTemplateOutlet=\"dropdownItemTemplate; context: { $implicit: item }\"> </ng-container>\r\n      </ng-template>\r\n    </ng-container>\r\n  </p-dropdown>\r\n  <div class=\"p-paginator-right-content\" *ngIf=\"templateRight\" [attr.data-pc-section]=\"'end'\">\r\n    <ng-container *ngTemplateOutlet=\"templateRight; context: { $implicit: paginatorState }\"></ng-container>\r\n  </div>\r\n</div>\r\n", styles: ["@layer primeng{.p-paginator{display:flex;align-items:center;justify-content:center;flex-wrap:wrap}.p-paginator-left-content{margin-right:auto}.p-paginator-right-content{margin-left:auto}.p-paginator-page,.p-paginator-next,.p-paginator-last,.p-paginator-first,.p-paginator-prev,.p-paginator-current{cursor:pointer;display:inline-flex;align-items:center;justify-content:center;line-height:1;-webkit-user-select:none;user-select:none;overflow:hidden;position:relative}.p-paginator-element:focus{z-index:1;position:relative}}\n"], dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgForOf), selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgStyle), selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i0.forwardRef(() => i3.Dropdown), selector: "p-dropdown", inputs: ["id", "scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "loadingIcon", "filterPlaceholder", "filterLocale", "variant", "inputId", "dataKey", "filterBy", "filterFields", "autofocus", "resetFilterOnHide", "checkmark", "dropdownIcon", "loading", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "ariaLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "focusOnHover", "selectOnFocus", "autoOptionFocus", "autofocusFilter", "autoShowPanelOnPrintableCharacterKeyDown", "disabled", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "filterValue", "options"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear", "onLazyLoad"] }, { kind: "directive", type: i0.forwardRef(() => i1$1.PrimeTemplate), selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i0.forwardRef(() => i4.InputNumber), selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabelledBy", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "variant", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "showClear", "autofocus", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown", "onClear"] }, { kind: "directive", type: i0.forwardRef(() => i2$2.NgControlStatus), selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i0.forwardRef(() => i2$2.NgModel), selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i0.forwardRef(() => i6.Ripple), selector: "[pRipple]" }, { kind: "component", type: i0.forwardRef(() => AngleDoubleLeftIcon), selector: "AngleDoubleLeftIcon" }, { kind: "component", type: i0.forwardRef(() => AngleDoubleRightIcon), selector: "AngleDoubleRightIcon" }, { kind: "component", type: i0.forwardRef(() => AngleLeftIcon), selector: "AngleLeftIcon" }, { kind: "component", type: i0.forwardRef(() => AngleRightIcon), selector: "AngleRightIcon" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Paginator, decorators: [{
            type: Component,
            args: [{ selector: 'p-paginator', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: {
                        'class': 'p-element'
                    }, template: "<div [class]=\"styleClass\" [ngStyle]=\"style\" [ngClass]=\"'p-paginator p-component'\" *ngIf=\"alwaysShow ? true : pageLinks && pageLinks.length > 1\" [attr.data-pc-section]=\"'paginator'\" [attr.data-pc-section]=\"'root'\">\r\n  <div class=\"p-paginator-left-content\" *ngIf=\"templateLeft\" [attr.data-pc-section]=\"'start'\">\r\n    <ng-container *ngTemplateOutlet=\"templateLeft; context: { $implicit: paginatorState }\"></ng-container>\r\n  </div>\r\n  <span class=\"p-paginator-current\" *ngIf=\"showCurrentPageReport\">{{currentPageReport}}</span>\r\n  <button *ngIf=\"showFirstLastIcon\"\r\n          type=\"button\"\r\n          [disabled]=\"isFirstPage() || empty()\"\r\n          (click)=\"changePageToFirst($event)\"\r\n          pRipple\r\n          class=\"p-paginator-first p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isFirstPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('firstPageLabel')\">\r\n    <AngleDoubleLeftIcon *ngIf=\"!firstPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"firstPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"firstPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <button type=\"button\"\r\n          [disabled]=\"isFirstPage() || empty()\"\r\n          (click)=\"changePageToPrev($event)\"\r\n          pRipple\r\n          class=\"p-paginator-prev p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isFirstPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('prevPageLabel')\">\r\n    <AngleLeftIcon *ngIf=\"!previousPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"previousPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"previousPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <span class=\"p-paginator-pages\" *ngIf=\"showPageLinks\">\r\n    <button type=\"button\"\r\n            *ngFor=\"let pageLink of pageLinks\"\r\n            class=\"p-paginator-page p-paginator-element p-link\"\r\n            [ngClass]=\"{ 'p-highlight': pageLink - 1 == getPage() }\"\r\n            [attr.aria-label]=\"getPageAriaLabel(pageLink)\"\r\n            [attr.aria-current]=\"pageLink - 1 == getPage() ? 'page' : undefined\"\r\n            (click)=\"onPageLinkClick($event, pageLink - 1)\"\r\n            pRipple>\r\n      {{ getLocalization(pageLink) }}\r\n    </button>\r\n  </span>\r\n  <p-dropdown [options]=\"pageItems\"\r\n              [ngModel]=\"getPage()\"\r\n              *ngIf=\"showJumpToPageDropdown\"\r\n              [disabled]=\"empty()\"\r\n              [attr.aria-label]=\"getAriaLabel('jumpToPageDropdownLabel')\"\r\n              styleClass=\"p-paginator-page-options\"\r\n              (onChange)=\"onPageDropdownChange($event)\"\r\n              [appendTo]=\"dropdownAppendTo\"\r\n              [scrollHeight]=\"dropdownScrollHeight\">\r\n    <ng-template pTemplate=\"selectedItem\">{{currentPageReport}}</ng-template>\r\n  </p-dropdown>\r\n  <button type=\"button\"\r\n          [disabled]=\"isLastPage() || empty()\"\r\n          (click)=\"changePageToNext($event)\"\r\n          pRipple\r\n          class=\"p-paginator-next p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isLastPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('nextPageLabel')\">\r\n    <AngleRightIcon *ngIf=\"!nextPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"nextPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"nextPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <button *ngIf=\"showFirstLastIcon\"\r\n          type=\"button\"\r\n          [disabled]=\"isLastPage() || empty()\"\r\n          (click)=\"changePageToLast($event)\"\r\n          pRipple\r\n          class=\"p-paginator-last p-paginator-element p-link\"\r\n          [ngClass]=\"{ 'p-disabled': isLastPage() || empty() }\"\r\n          [attr.aria-label]=\"getAriaLabel('lastPageLabel')\">\r\n    <AngleDoubleRightIcon *ngIf=\"!lastPageLinkIconTemplate\" [styleClass]=\"'p-paginator-icon'\" />\r\n    <span class=\"p-paginator-icon\" *ngIf=\"lastPageLinkIconTemplate\">\r\n      <ng-template *ngTemplateOutlet=\"lastPageLinkIconTemplate\"></ng-template>\r\n    </span>\r\n  </button>\r\n  <p-inputNumber *ngIf=\"showJumpToPageInput\" [ngModel]=\"currentPage()\" class=\"p-paginator-page-input\" [disabled]=\"empty()\" (ngModelChange)=\"changePage($event - 1)\"></p-inputNumber>\r\n  <p-dropdown [options]=\"rowsPerPageItems\"\r\n              [(ngModel)]=\"rows\"\r\n              *ngIf=\"rowsPerPageOptions\"\r\n              styleClass=\"p-paginator-rpp-options\"\r\n              [disabled]=\"empty()\"\r\n              (onChange)=\"onRppChange($event)\"\r\n              [appendTo]=\"dropdownAppendTo\"\r\n              [scrollHeight]=\"dropdownScrollHeight\"\r\n              [ariaLabel]=\"getAriaLabel('rowsPerPageLabel')\">\r\n    <ng-container *ngIf=\"dropdownItemTemplate\">\r\n      <ng-template let-item pTemplate=\"item\">\r\n        <ng-container *ngTemplateOutlet=\"dropdownItemTemplate; context: { $implicit: item }\"> </ng-container>\r\n      </ng-template>\r\n    </ng-container>\r\n  </p-dropdown>\r\n  <div class=\"p-paginator-right-content\" *ngIf=\"templateRight\" [attr.data-pc-section]=\"'end'\">\r\n    <ng-container *ngTemplateOutlet=\"templateRight; context: { $implicit: paginatorState }\"></ng-container>\r\n  </div>\r\n</div>\r\n", styles: ["@layer primeng{.p-paginator{display:flex;align-items:center;justify-content:center;flex-wrap:wrap}.p-paginator-left-content{margin-right:auto}.p-paginator-right-content{margin-left:auto}.p-paginator-page,.p-paginator-next,.p-paginator-last,.p-paginator-first,.p-paginator-prev,.p-paginator-current{cursor:pointer;display:inline-flex;align-items:center;justify-content:center;line-height:1;-webkit-user-select:none;user-select:none;overflow:hidden;position:relative}.p-paginator-element:focus{z-index:1;position:relative}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i1$1.PrimeNGConfig }], propDecorators: { pageLinkSize: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], alwaysShow: [{
                type: Input
            }], dropdownAppendTo: [{
                type: Input
            }], templateLeft: [{
                type: Input
            }], templateRight: [{
                type: Input
            }], appendTo: [{
                type: Input
            }], dropdownScrollHeight: [{
                type: Input
            }], currentPageReportTemplate: [{
                type: Input
            }], showCurrentPageReport: [{
                type: Input
            }], showFirstLastIcon: [{
                type: Input
            }], totalRecords: [{
                type: Input
            }], rows: [{
                type: Input
            }], rowsPerPageOptions: [{
                type: Input
            }], showJumpToPageDropdown: [{
                type: Input
            }], showJumpToPageInput: [{
                type: Input
            }], showPageLinks: [{
                type: Input
            }], locale: [{
                type: Input
            }], dropdownItemTemplate: [{
                type: Input
            }], first: [{
                type: Input
            }], onPageChange: [{
                type: Output
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }] } });
class PaginatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PaginatorModule, declarations: [Paginator], imports: [CommonModule, DropdownModule, InputNumberModule, FormsModule, SharedModule, RippleModule, AngleDoubleLeftIcon, AngleDoubleRightIcon, AngleLeftIcon, AngleRightIcon], exports: [Paginator, DropdownModule, InputNumberModule, FormsModule, SharedModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginatorModule, imports: [CommonModule, DropdownModule, InputNumberModule, FormsModule, SharedModule, RippleModule, AngleDoubleLeftIcon, AngleDoubleRightIcon, AngleLeftIcon, AngleRightIcon, DropdownModule, InputNumberModule, FormsModule, SharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PaginatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, DropdownModule, InputNumberModule, FormsModule, SharedModule, RippleModule, AngleDoubleLeftIcon, AngleDoubleRightIcon, AngleLeftIcon, AngleRightIcon],
                    exports: [Paginator, DropdownModule, InputNumberModule, FormsModule, SharedModule],
                    declarations: [Paginator]
                }]
        }] });

class TableService {
    constructor() {
        this.sortSource = new Subject();
        this.selectionSource = new Subject();
        this.contextMenuSource = new Subject();
        this.valueSource = new Subject();
        this.totalRecordsSource = new Subject();
        this.columnsSource = new Subject();
        this.sortSource$ = this.sortSource.asObservable();
        this.selectionSource$ = this.selectionSource.asObservable();
        this.contextMenuSource$ = this.contextMenuSource.asObservable();
        this.valueSource$ = this.valueSource.asObservable();
        this.totalRecordsSource$ = this.totalRecordsSource.asObservable();
        this.columnsSource$ = this.columnsSource.asObservable();
    }
    onSort(sortMeta) {
        this.sortSource.next(sortMeta);
    }
    onSelectionChange() {
        this.selectionSource.next(null);
    }
    onContextMenu(data) {
        this.contextMenuSource.next(data);
    }
    onValueChange(value) {
        this.valueSource.next(value);
    }
    onTotalRecordsChange(value) {
        this.totalRecordsSource.next(value);
    }
    onColumnsChange(columns) {
        this.columnsSource.next(columns);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableService, decorators: [{
            type: Injectable
        }] });
/**
 * Table displays data in tabular format.
 * @group Components
 */
class Table {
    /**
     * Defines if the table is responsive.
     * @group Props
     * @deprecated table is always responsive with scrollable behavior.
     */
    get responsive() {
        return this._responsive;
    }
    set responsive(val) {
        this._responsive = val;
        console.warn('responsive property is deprecated as table is always responsive with scrollable behavior.');
    }
    /**
     * An array of objects to display.
     * @group Props
     */
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
    }
    /**
     * An array of objects to represent dynamic columns.
     * @group Props
     */
    get columns() {
        return this._columns;
    }
    set columns(cols) {
        this._columns = cols;
    }
    /**
     * Index of the first row to be displayed.
     * @group Props
     */
    get first() {
        return this._first;
    }
    set first(val) {
        this._first = val;
    }
    /**
     * Number of rows to display per page.
     * @group Props
     */
    get rows() {
        return this._rows;
    }
    set rows(val) {
        this._rows = val;
    }
    /**
     * Number of total records, defaults to length of value when not defined.
     * @group Props
     */
    get totalRecords() {
        return this._totalRecords;
    }
    set totalRecords(val) {
        this._totalRecords = val;
        this.tableService.onTotalRecordsChange(this._totalRecords);
    }
    /**
     * Name of the field to sort data by default.
     * @group Props
     */
    get sortField() {
        return this._sortField;
    }
    set sortField(val) {
        this._sortField = val;
    }
    /**
     * Order to sort when default sorting is enabled.
     * @group Props
     */
    get sortOrder() {
        return this._sortOrder;
    }
    set sortOrder(val) {
        this._sortOrder = val;
    }
    /**
     * An array of SortMeta objects to sort the data by default in multiple sort mode.
     * @group Props
     */
    get multiSortMeta() {
        return this._multiSortMeta;
    }
    set multiSortMeta(val) {
        this._multiSortMeta = val;
    }
    /**
     * Selected row in single mode or an array of values in multiple mode.
     * @group Props
     */
    get selection() {
        return this._selection;
    }
    set selection(val) {
        this._selection = val;
    }
    /**
     * Whether all data is selected.
     * @group Props
     */
    get selectAll() {
        return this._selection;
    }
    set selectAll(val) {
        this._selection = val;
    }
    /**
     * Indicates the height of rows to be scrolled.
     * @group Props
     * @deprecated use virtualScrollItemSize property instead.
     */
    get virtualRowHeight() {
        return this._virtualRowHeight;
    }
    set virtualRowHeight(val) {
        this._virtualRowHeight = val;
        console.warn('The virtualRowHeight property is deprecated.');
    }
    constructor(document, platformId, renderer, el, zone, tableService, cd, filterService, overlayService, config) {
        this.document = document;
        this.platformId = platformId;
        this.renderer = renderer;
        this.el = el;
        this.zone = zone;
        this.tableService = tableService;
        this.cd = cd;
        this.filterService = filterService;
        this.overlayService = overlayService;
        this.config = config;
        /**
         * Number of page links to display in paginator.
         * @group Props
         */
        this.pageLinks = 5;
        /**
         * Whether to show it even there is only one page.
         * @group Props
         */
        this.alwaysShowPaginator = true;
        /**
         * Position of the paginator, options are "top", "bottom" or "both".
         * @group Props
         */
        this.paginatorPosition = 'bottom';
        /**
         * Paginator dropdown height of the viewport in pixels, a scrollbar is defined if height of list exceeds this value.
         * @group Props
         */
        this.paginatorDropdownScrollHeight = '200px';
        /**
         * Template of the current page report element. Available placeholders are {currentPage},{totalPages},{rows},{first},{last} and {totalRecords}
         * @group Props
         */
        this.currentPageReportTemplate = '{currentPage} of {totalPages}';
        /**
         * When enabled, icons are displayed on paginator to go first and last page.
         * @group Props
         */
        this.showFirstLastIcon = true;
        /**
         * Whether to show page links.
         * @group Props
         */
        this.showPageLinks = true;
        /**
         * Sort order to use when an unsorted column gets sorted by user interaction.
         * @group Props
         */
        this.defaultSortOrder = 1;
        /**
         * Defines whether sorting works on single column or on multiple columns.
         * @group Props
         */
        this.sortMode = 'single';
        /**
         * When true, resets paginator to first page after sorting. Available only when sortMode is set to single.
         * @group Props
         */
        this.resetPageOnSort = true;
        /**
         * Callback to invoke on context menu selection change.
         * @param {*} object - row data.
         * @group Emits
         */
        this.contextMenuSelectionChange = new EventEmitter();
        /**
         *  Defines the behavior of context menu selection, in "separate" mode context menu updates contextMenuSelection property whereas in joint mode selection property is used instead so that when row selection is enabled, both row selection and context menu selection use the same property.
         * @group Props
         */
        this.contextMenuSelectionMode = 'separate';
        /**
         * Defines whether metaKey should be considered for the selection. On touch enabled devices, metaKeySelection is turned off automatically.
         * @group Props
         */
        this.metaKeySelection = false;
        /**
         * Function to optimize the dom operations by delegating to ngForTrackBy, default algorithm checks for object identity.
         * @group Props
         */
        this.rowTrackBy = (index, item) => item;
        /**
         * Defines if data is loaded and interacted with in lazy manner.
         * @group Props
         */
        this.lazy = false;
        /**
         * Whether to call lazy loading on initialization.
         * @group Props
         */
        this.lazyLoadOnInit = true;
        /**
         * Algorithm to define if a row is selected, valid values are "equals" that compares by reference and "deepEquals" that compares all fields.
         * @group Props
         */
        this.compareSelectionBy = 'deepEquals';
        /**
         * Character to use as the csv separator.
         * @group Props
         */
        this.csvSeparator = ',';
        /**
         * Name of the exported file.
         * @group Props
         */
        this.exportFilename = 'download';
        /**
         * An array of FilterMetadata objects to provide external filters.
         * @group Props
         */
        this.filters = {};
        /**
         * Delay in milliseconds before filtering the data.
         * @group Props
         */
        this.filterDelay = 300;
        /**
         * Map instance to keep the expanded rows where key of the map is the data key of the row.
         * @group Props
         */
        this.expandedRowKeys = {};
        /**
         * Map instance to keep the rows being edited where key of the map is the data key of the row.
         * @group Props
         */
        this.editingRowKeys = {};
        /**
         * Whether multiple rows can be expanded at any time. Valid values are "multiple" and "single".
         * @group Props
         */
        this.rowExpandMode = 'multiple';
        /**
         * Orientation of the scrolling, options are "vertical", "horizontal" and "both".
         * @group Props
         * @deprecated Property is obselete since v14.2.0.
         */
        this.scrollDirection = 'vertical';
        /**
         * Threshold in milliseconds to delay lazy loading during scrolling.
         * @group Props
         */
        this.virtualScrollDelay = 250;
        /**
         * Defines whether the overall table width should change on column resize, valid values are "fit" and "expand".
         * @group Props
         */
        this.columnResizeMode = 'fit';
        /**
         * The icon to show while indicating data load is in progress.
         * @group Props
         */
        this.loadingIcon = 'pi pi-spin pi-spinner';
        /**
         * Whether to show the loading mask when loading property is true.
         * @group Props
         */
        this.showLoader = true;
        /**
         * Whether to use the initial sort badge or not.
         * @group Props
         */
        this.showInitialSortBadge = true;
        /**
         * Defines where a stateful table keeps its state, valid values are "session" for sessionStorage and "local" for localStorage.
         * @group Props
         */
        this.stateStorage = 'session';
        /**
         * Defines the editing mode, valid values are "cell" and "row".
         * @group Props
         */
        this.editMode = 'cell';
        /**
         * Order to sort when default row grouping is enabled.
         * @group Props
         */
        this.groupRowsByOrder = 1;
        /**
         * Defines the responsive mode, valid options are "stack" and "scroll".
         * @group Props
         */
        this.responsiveLayout = 'scroll';
        /**
         * The breakpoint to define the maximum width boundary when using stack responsive layout.
         * @group Props
         */
        this.breakpoint = '960px';
        /**
         * Emits when the all of the items selected or unselected.
         * @param {TableSelectAllChangeEvent} event - custom  all selection change event.
         * @group Emits
         */
        this.selectAllChange = new EventEmitter();
        /**
         * Callback to invoke on selection changed.
         * @param {any | null} value - selected data.
         * @group Emits
         */
        this.selectionChange = new EventEmitter();
        /**
         * Callback to invoke when a row is selected.
         * @param {TableRowSelectEvent} event - custom select event.
         * @group Emits
         */
        this.onRowSelect = new EventEmitter();
        /**
         * Callback to invoke when a row is unselected.
         * @param {TableRowUnSelectEvent} event - custom unselect event.
         * @group Emits
         */
        this.onRowUnselect = new EventEmitter();
        /**
         * Callback to invoke when pagination occurs.
         * @param {TablePageEvent} event - custom pagination event.
         * @group Emits
         */
        this.onPage = new EventEmitter();
        /**
         * Callback to invoke when a column gets sorted.
         * @param {Object} object - sort meta.
         * @group Emits
         */
        this.onSort = new EventEmitter();
        /**
         * Callback to invoke when data is filtered.
         * @param {TableFilterEvent} event - custom filtering event.
         * @group Emits
         */
        this.onFilter = new EventEmitter();
        /**
         * Callback to invoke when paging, sorting or filtering happens in lazy mode.
         * @param {TableLazyLoadEvent} event - custom lazy loading event.
         * @group Emits
         */
        this.onLazyLoad = new EventEmitter();
        /**
         * Callback to invoke when a row is expanded.
         * @param {TableRowExpandEvent} event - custom row expand event.
         * @group Emits
         */
        this.onRowExpand = new EventEmitter();
        /**
         * Callback to invoke when a row is collapsed.
         * @param {TableRowCollapseEvent} event - custom row collapse event.
         * @group Emits
         */
        this.onRowCollapse = new EventEmitter();
        /**
         * Callback to invoke when a row is selected with right click.
         * @param {TableContextMenuSelectEvent} event - custom context menu select event.
         * @group Emits
         */
        this.onContextMenuSelect = new EventEmitter();
        /**
         * Callback to invoke when a column is resized.
         * @param {TableColResizeEvent} event - custom column resize event.
         * @group Emits
         */
        this.onColResize = new EventEmitter();
        /**
         * Callback to invoke when a column is reordered.
         * @param {TableColumnReorderEvent} event - custom column reorder event.
         * @group Emits
         */
        this.onColReorder = new EventEmitter();
        /**
         * Callback to invoke when a row is reordered.
         * @param {TableRowReorderEvent} event - custom row reorder event.
         * @group Emits
         */
        this.onRowReorder = new EventEmitter();
        /**
         * Callback to invoke when a cell switches to edit mode.
         * @param {TableEditInitEvent} event - custom edit init event.
         * @group Emits
         */
        this.onEditInit = new EventEmitter();
        /**
         * Callback to invoke when cell edit is completed.
         * @param {TableEditCompleteEvent} event - custom edit complete event.
         * @group Emits
         */
        this.onEditComplete = new EventEmitter();
        /**
         * Callback to invoke when cell edit is cancelled with escape key.
         * @param {TableEditCancelEvent} event - custom edit cancel event.
         * @group Emits
         */
        this.onEditCancel = new EventEmitter();
        /**
         * Callback to invoke when state of header checkbox changes.
         * @param {TableHeaderCheckboxToggleEvent} event - custom header checkbox event.
         * @group Emits
         */
        this.onHeaderCheckboxToggle = new EventEmitter();
        /**
         * A function to implement custom sorting, refer to sorting section for details.
         * @param {any} any - sort meta.
         * @group Emits
         */
        this.sortFunction = new EventEmitter();
        /**
         * Callback to invoke on pagination.
         * @param {number} number - first element.
         * @group Emits
         */
        this.firstChange = new EventEmitter();
        /**
         * Callback to invoke on rows change.
         * @param {number} number - Row count.
         * @group Emits
         */
        this.rowsChange = new EventEmitter();
        /**
         * Callback to invoke table state is saved.
         * @param {TableState} object - table state.
         * @group Emits
         */
        this.onStateSave = new EventEmitter();
        /**
         * Callback to invoke table state is restored.
         * @param {TableState} object - table state.
         * @group Emits
         */
        this.onStateRestore = new EventEmitter();
        this._virtualRowHeight = 28;
        this._value = [];
        this._totalRecords = 0;
        this._first = 0;
        this.selectionKeys = {};
        this._sortOrder = 1;
        this._selectAll = null;
        this.columnResizing = false;
        this.rowGroupHeaderStyleObject = {};
        this.id = UniqueComponentId();
        this.window = this.document.defaultView;
    }
    ngOnInit() {
        if (this.lazy && this.lazyLoadOnInit) {
            if (!this.virtualScroll) {
                this.onLazyLoad.emit(this.createLazyLoadMetadata());
            }
            if (this.restoringFilter) {
                this.restoringFilter = false;
            }
        }
        if (this.responsiveLayout === 'stack' && !this.scrollable) {
            this.createResponsiveStyle();
        }
        this.initialized = true;
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'caption':
                    this.captionTemplate = item.template;
                    break;
                case 'header':
                    this.headerTemplate = item.template;
                    break;
                case 'headergrouped':
                    this.headerGroupedTemplate = item.template;
                    break;
                case 'body':
                    this.bodyTemplate = item.template;
                    break;
                case 'loadingbody':
                    this.loadingBodyTemplate = item.template;
                    break;
                case 'footer':
                    this.footerTemplate = item.template;
                    break;
                case 'footergrouped':
                    this.footerGroupedTemplate = item.template;
                    break;
                case 'summary':
                    this.summaryTemplate = item.template;
                    break;
                case 'colgroup':
                    this.colGroupTemplate = item.template;
                    break;
                case 'rowexpansion':
                    this.expandedRowTemplate = item.template;
                    break;
                case 'groupheader':
                    this.groupHeaderTemplate = item.template;
                    break;
                case 'groupfooter':
                    this.groupFooterTemplate = item.template;
                    break;
                case 'frozenheader':
                    this.frozenHeaderTemplate = item.template;
                    break;
                case 'frozenbody':
                    this.frozenBodyTemplate = item.template;
                    break;
                case 'frozenfooter':
                    this.frozenFooterTemplate = item.template;
                    break;
                case 'frozencolgroup':
                    this.frozenColGroupTemplate = item.template;
                    break;
                case 'frozenrowexpansion':
                    this.frozenExpandedRowTemplate = item.template;
                    break;
                case 'emptymessage':
                    this.emptyMessageTemplate = item.template;
                    break;
                case 'paginatorleft':
                    this.paginatorLeftTemplate = item.template;
                    break;
                case 'paginatorright':
                    this.paginatorRightTemplate = item.template;
                    break;
                case 'paginatordropdownitem':
                    this.paginatorDropdownItemTemplate = item.template;
                    break;
                case 'paginatorfirstpagelinkicon':
                    this.paginatorFirstPageLinkIconTemplate = item.template;
                    break;
                case 'paginatorlastpagelinkicon':
                    this.paginatorLastPageLinkIconTemplate = item.template;
                    break;
                case 'paginatorpreviouspagelinkicon':
                    this.paginatorPreviousPageLinkIconTemplate = item.template;
                    break;
                case 'paginatornextpagelinkicon':
                    this.paginatorNextPageLinkIconTemplate = item.template;
                    break;
                case 'loadingicon':
                    this.loadingIconTemplate = item.template;
                    break;
                case 'reorderindicatorupicon':
                    this.reorderIndicatorUpIconTemplate = item.template;
                    break;
                case 'reorderindicatordownicon':
                    this.reorderIndicatorDownIconTemplate = item.template;
                    break;
                case 'sorticon':
                    this.sortIconTemplate = item.template;
                    break;
                case 'checkboxicon':
                    this.checkboxIconTemplate = item.template;
                    break;
                case 'headercheckboxicon':
                    this.headerCheckboxIconTemplate = item.template;
                    break;
            }
        });
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            if (this.isStateful() && this.resizableColumns) {
                this.restoreColumnWidths();
            }
        }
    }
    ngOnChanges(simpleChange) {
        if (simpleChange.value) {
            if (this.isStateful() && !this.stateRestored && isPlatformBrowser(this.platformId)) {
                this.restoreState();
            }
            this._value = simpleChange.value.currentValue;
            if (!this.lazy) {
                this.totalRecords = this._value ? this._value.length : 0;
                if (this.sortMode == 'single' && (this.sortField || this.groupRowsBy))
                    this.sortSingle();
                else if (this.sortMode == 'multiple' && (this.multiSortMeta || this.groupRowsBy))
                    this.sortMultiple();
                else if (this.hasFilter())
                    //sort already filters
                    this._filter();
            }
            this.tableService.onValueChange(simpleChange.value.currentValue);
        }
        if (simpleChange.columns) {
            this._columns = simpleChange.columns.currentValue;
            this.tableService.onColumnsChange(simpleChange.columns.currentValue);
            if (this._columns && this.isStateful() && this.reorderableColumns && !this.columnOrderStateRestored) {
                this.restoreColumnOrder();
            }
        }
        if (simpleChange.sortField) {
            this._sortField = simpleChange.sortField.currentValue;
            //avoid triggering lazy load prior to lazy initialization at onInit
            if (!this.lazy || this.initialized) {
                if (this.sortMode === 'single') {
                    this.sortSingle();
                }
            }
        }
        if (simpleChange.groupRowsBy) {
            //avoid triggering lazy load prior to lazy initialization at onInit
            if (!this.lazy || this.initialized) {
                if (this.sortMode === 'single') {
                    this.sortSingle();
                }
            }
        }
        if (simpleChange.sortOrder) {
            this._sortOrder = simpleChange.sortOrder.currentValue;
            //avoid triggering lazy load prior to lazy initialization at onInit
            if (!this.lazy || this.initialized) {
                if (this.sortMode === 'single') {
                    this.sortSingle();
                }
            }
        }
        if (simpleChange.groupRowsByOrder) {
            //avoid triggering lazy load prior to lazy initialization at onInit
            if (!this.lazy || this.initialized) {
                if (this.sortMode === 'single') {
                    this.sortSingle();
                }
            }
        }
        if (simpleChange.multiSortMeta) {
            this._multiSortMeta = simpleChange.multiSortMeta.currentValue;
            if (this.sortMode === 'multiple' && (this.initialized || (!this.lazy && !this.virtualScroll))) {
                this.sortMultiple();
            }
        }
        if (simpleChange.selection) {
            this._selection = simpleChange.selection.currentValue;
            if (!this.preventSelectionSetterPropagation) {
                this.updateSelectionKeys();
                this.tableService.onSelectionChange();
            }
            this.preventSelectionSetterPropagation = false;
        }
        if (simpleChange.selectAll) {
            this._selectAll = simpleChange.selectAll.currentValue;
            if (!this.preventSelectionSetterPropagation) {
                this.updateSelectionKeys();
                this.tableService.onSelectionChange();
                if (this.isStateful()) {
                    this.saveState();
                }
            }
            this.preventSelectionSetterPropagation = false;
        }
    }
    get processedData() {
        return this.filteredValue || this.value || [];
    }
    dataToRender(data) {
        const _data = data || this.processedData;
        if (_data && this.paginator) {
            const first = this.lazy ? 0 : this.first;
            return _data.slice(first, first + this.rows);
        }
        return _data;
    }
    updateSelectionKeys() {
        if (this.dataKey && this._selection) {
            this.selectionKeys = {};
            if (Array.isArray(this._selection)) {
                for (let data of this._selection) {
                    this.selectionKeys[String(ObjectUtils.resolveFieldData(data, this.dataKey))] = 1;
                }
            }
            else {
                this.selectionKeys[String(ObjectUtils.resolveFieldData(this._selection, this.dataKey))] = 1;
            }
        }
    }
    onPageChange(event) {
        this.first = event.first;
        this.rows = event.rows;
        this.onPage.emit({
            first: this.first,
            rows: this.rows
        });
        if (this.lazy) {
            this.onLazyLoad.emit(this.createLazyLoadMetadata());
        }
        this.firstChange.emit(this.first);
        this.rowsChange.emit(this.rows);
        this.tableService.onValueChange(this.value);
        if (this.isStateful()) {
            this.saveState();
        }
        this.anchorRowIndex = null;
        if (this.scrollable) {
            this.resetScrollTop();
        }
    }
    sort(event) {
        let originalEvent = event.originalEvent;
        if (this.sortMode === 'single') {
            this._sortOrder = this.sortField === event.field ? this.sortOrder * -1 : this.defaultSortOrder;
            this._sortField = event.field;
            if (this.resetPageOnSort) {
                this._first = 0;
                this.firstChange.emit(this._first);
                if (this.scrollable) {
                    this.resetScrollTop();
                }
            }
            this.sortSingle();
        }
        if (this.sortMode === 'multiple') {
            let metaKey = originalEvent.metaKey || originalEvent.ctrlKey;
            let sortMeta = this.getSortMeta(event.field);
            if (sortMeta) {
                if (!metaKey) {
                    this._multiSortMeta = [{ field: event.field, order: sortMeta.order * -1 }];
                    if (this.resetPageOnSort) {
                        this._first = 0;
                        this.firstChange.emit(this._first);
                        if (this.scrollable) {
                            this.resetScrollTop();
                        }
                    }
                }
                else {
                    sortMeta.order = sortMeta.order * -1;
                }
            }
            else {
                if (!metaKey || !this.multiSortMeta) {
                    this._multiSortMeta = [];
                    if (this.resetPageOnSort) {
                        this._first = 0;
                        this.firstChange.emit(this._first);
                    }
                }
                this._multiSortMeta.push({ field: event.field, order: this.defaultSortOrder });
            }
            this.sortMultiple();
        }
        if (this.isStateful()) {
            this.saveState();
        }
        this.anchorRowIndex = null;
    }
    sortSingle() {
        let field = this.sortField || this.groupRowsBy;
        let order = this.sortField ? this.sortOrder : this.groupRowsByOrder;
        if (this.groupRowsBy && this.sortField && this.groupRowsBy !== this.sortField) {
            this._multiSortMeta = [this.getGroupRowsMeta(), { field: this.sortField, order: this.sortOrder }];
            this.sortMultiple();
            return;
        }
        if (field && order) {
            if (this.restoringSort) {
                this.restoringSort = false;
            }
            if (this.lazy) {
                this.onLazyLoad.emit(this.createLazyLoadMetadata());
            }
            else if (this.value) {
                if (this.customSort) {
                    this.sortFunction.emit({
                        data: this.value,
                        mode: this.sortMode,
                        field: field,
                        order: order
                    });
                }
                else {
                    this.value.sort((data1, data2) => {
                        let value1 = ObjectUtils.resolveFieldData(data1, field);
                        let value2 = ObjectUtils.resolveFieldData(data2, field);
                        let result = null;
                        if (value1 == null && value2 != null)
                            result = -1;
                        else if (value1 != null && value2 == null)
                            result = 1;
                        else if (value1 == null && value2 == null)
                            result = 0;
                        else if (typeof value1 === 'string' && typeof value2 === 'string')
                            result = value1.localeCompare(value2);
                        else
                            result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                        return order * result;
                    });
                    this._value = [...this.value];
                }
                if (this.hasFilter()) {
                    this._filter();
                }
            }
            let sortMeta = {
                field: field,
                order: order
            };
            this.onSort.emit(sortMeta);
            this.tableService.onSort(sortMeta);
        }
    }
    sortMultiple() {
        if (this.groupRowsBy) {
            if (!this._multiSortMeta)
                this._multiSortMeta = [this.getGroupRowsMeta()];
            else if (this.multiSortMeta[0].field !== this.groupRowsBy)
                this._multiSortMeta = [this.getGroupRowsMeta(), ...this._multiSortMeta];
        }
        if (this.multiSortMeta) {
            if (this.lazy) {
                this.onLazyLoad.emit(this.createLazyLoadMetadata());
            }
            else if (this.value) {
                if (this.customSort) {
                    this.sortFunction.emit({
                        data: this.value,
                        mode: this.sortMode,
                        multiSortMeta: this.multiSortMeta
                    });
                }
                else {
                    this.value.sort((data1, data2) => {
                        return this.multisortField(data1, data2, this.multiSortMeta, 0);
                    });
                    this._value = [...this.value];
                }
                if (this.hasFilter()) {
                    this._filter();
                }
            }
            this.onSort.emit({
                multisortmeta: this.multiSortMeta
            });
            this.tableService.onSort(this.multiSortMeta);
        }
    }
    multisortField(data1, data2, multiSortMeta, index) {
        const value1 = ObjectUtils.resolveFieldData(data1, multiSortMeta[index].field);
        const value2 = ObjectUtils.resolveFieldData(data2, multiSortMeta[index].field);
        if (ObjectUtils.compare(value1, value2, this.filterLocale) === 0) {
            return multiSortMeta.length - 1 > index ? this.multisortField(data1, data2, multiSortMeta, index + 1) : 0;
        }
        return this.compareValuesOnSort(value1, value2, multiSortMeta[index].order);
    }
    compareValuesOnSort(value1, value2, order) {
        return ObjectUtils.sort(value1, value2, order, this.filterLocale, this.sortOrder);
    }
    getSortMeta(field) {
        if (this.multiSortMeta && this.multiSortMeta.length) {
            for (let i = 0; i < this.multiSortMeta.length; i++) {
                if (this.multiSortMeta[i].field === field) {
                    return this.multiSortMeta[i];
                }
            }
        }
        return null;
    }
    isSorted(field) {
        if (this.sortMode === 'single') {
            return this.sortField && this.sortField === field;
        }
        else if (this.sortMode === 'multiple') {
            let sorted = false;
            if (this.multiSortMeta) {
                for (let i = 0; i < this.multiSortMeta.length; i++) {
                    if (this.multiSortMeta[i].field == field) {
                        sorted = true;
                        break;
                    }
                }
            }
            return sorted;
        }
    }
    handleRowClick(event) {
        let target = event.originalEvent.target;
        let targetNode = target.nodeName;
        let parentNode = target.parentElement && target.parentElement.nodeName;
        if (targetNode == 'INPUT' || targetNode == 'BUTTON' || targetNode == 'A' || parentNode == 'INPUT' || parentNode == 'BUTTON' || parentNode == 'A' || DomHandler.hasClass(event.originalEvent.target, 'p-clickable')) {
            return;
        }
        if (this.selectionMode) {
            let rowData = event.rowData;
            let rowIndex = event.rowIndex;
            this.preventSelectionSetterPropagation = true;
            if (this.isMultipleSelectionMode() && event.originalEvent.shiftKey && this.anchorRowIndex != null) {
                DomHandler.clearSelection();
                if (this.rangeRowIndex != null) {
                    this.clearSelectionRange(event.originalEvent);
                }
                this.rangeRowIndex = rowIndex;
                this.selectRange(event.originalEvent, rowIndex);
            }
            else {
                let selected = this.isSelected(rowData);
                if (!selected && !this.isRowSelectable(rowData, rowIndex)) {
                    return;
                }
                let metaSelection = this.rowTouched ? false : this.metaKeySelection;
                let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rowData, this.dataKey)) : null;
                this.anchorRowIndex = rowIndex;
                this.rangeRowIndex = rowIndex;
                if (metaSelection) {
                    let metaKey = event.originalEvent.metaKey || event.originalEvent.ctrlKey;
                    if (selected && metaKey) {
                        if (this.isSingleSelectionMode()) {
                            this._selection = null;
                            this.selectionKeys = {};
                            this.selectionChange.emit(null);
                        }
                        else {
                            let selectionIndex = this.findIndexInSelection(rowData);
                            this._selection = this.selection.filter((val, i) => i != selectionIndex);
                            this.selectionChange.emit(this.selection);
                            if (dataKeyValue) {
                                delete this.selectionKeys[dataKeyValue];
                            }
                        }
                        this.onRowUnselect.emit({ originalEvent: event.originalEvent, data: rowData, type: 'row' });
                    }
                    else {
                        if (this.isSingleSelectionMode()) {
                            this._selection = rowData;
                            this.selectionChange.emit(rowData);
                            if (dataKeyValue) {
                                this.selectionKeys = {};
                                this.selectionKeys[dataKeyValue] = 1;
                            }
                        }
                        else if (this.isMultipleSelectionMode()) {
                            if (metaKey) {
                                this._selection = this.selection || [];
                            }
                            else {
                                this._selection = [];
                                this.selectionKeys = {};
                            }
                            this._selection = [...this.selection, rowData];
                            this.selectionChange.emit(this.selection);
                            if (dataKeyValue) {
                                this.selectionKeys[dataKeyValue] = 1;
                            }
                        }
                        this.onRowSelect.emit({ originalEvent: event.originalEvent, data: rowData, type: 'row', index: rowIndex });
                    }
                }
                else {
                    if (this.selectionMode === 'single') {
                        if (selected) {
                            this._selection = null;
                            this.selectionKeys = {};
                            this.selectionChange.emit(this.selection);
                            this.onRowUnselect.emit({ originalEvent: event.originalEvent, data: rowData, type: 'row', index: rowIndex });
                        }
                        else {
                            this._selection = rowData;
                            this.selectionChange.emit(this.selection);
                            this.onRowSelect.emit({ originalEvent: event.originalEvent, data: rowData, type: 'row', index: rowIndex });
                            if (dataKeyValue) {
                                this.selectionKeys = {};
                                this.selectionKeys[dataKeyValue] = 1;
                            }
                        }
                    }
                    else if (this.selectionMode === 'multiple') {
                        if (selected) {
                            let selectionIndex = this.findIndexInSelection(rowData);
                            this._selection = this.selection.filter((val, i) => i != selectionIndex);
                            this.selectionChange.emit(this.selection);
                            this.onRowUnselect.emit({ originalEvent: event.originalEvent, data: rowData, type: 'row', index: rowIndex });
                            if (dataKeyValue) {
                                delete this.selectionKeys[dataKeyValue];
                            }
                        }
                        else {
                            this._selection = this.selection ? [...this.selection, rowData] : [rowData];
                            this.selectionChange.emit(this.selection);
                            this.onRowSelect.emit({ originalEvent: event.originalEvent, data: rowData, type: 'row', index: rowIndex });
                            if (dataKeyValue) {
                                this.selectionKeys[dataKeyValue] = 1;
                            }
                        }
                    }
                }
            }
            this.tableService.onSelectionChange();
            if (this.isStateful()) {
                this.saveState();
            }
        }
        this.rowTouched = false;
    }
    handleRowTouchEnd(event) {
        this.rowTouched = true;
    }
    handleRowRightClick(event) {
        if (this.contextMenu) {
            const rowData = event.rowData;
            const rowIndex = event.rowIndex;
            if (this.contextMenuSelectionMode === 'separate') {
                this.contextMenuSelection = rowData;
                this.contextMenuSelectionChange.emit(rowData);
                this.onContextMenuSelect.emit({ originalEvent: event.originalEvent, data: rowData, index: event.rowIndex });
                this.contextMenu.show(event.originalEvent);
                this.tableService.onContextMenu(rowData);
            }
            else if (this.contextMenuSelectionMode === 'joint') {
                this.preventSelectionSetterPropagation = true;
                let selected = this.isSelected(rowData);
                let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rowData, this.dataKey)) : null;
                if (!selected) {
                    if (!this.isRowSelectable(rowData, rowIndex)) {
                        return;
                    }
                    if (this.isSingleSelectionMode()) {
                        this.selection = rowData;
                        this.selectionChange.emit(rowData);
                        if (dataKeyValue) {
                            this.selectionKeys = {};
                            this.selectionKeys[dataKeyValue] = 1;
                        }
                    }
                    else if (this.isMultipleSelectionMode()) {
                        this._selection = this.selection ? [...this.selection, rowData] : [rowData];
                        this.selectionChange.emit(this.selection);
                        if (dataKeyValue) {
                            this.selectionKeys[dataKeyValue] = 1;
                        }
                    }
                }
                this.tableService.onSelectionChange();
                this.contextMenu.show(event.originalEvent);
                this.onContextMenuSelect.emit({ originalEvent: event, data: rowData, index: event.rowIndex });
            }
        }
    }
    selectRange(event, rowIndex) {
        let rangeStart, rangeEnd;
        if (this.anchorRowIndex > rowIndex) {
            rangeStart = rowIndex;
            rangeEnd = this.anchorRowIndex;
        }
        else if (this.anchorRowIndex < rowIndex) {
            rangeStart = this.anchorRowIndex;
            rangeEnd = rowIndex;
        }
        else {
            rangeStart = rowIndex;
            rangeEnd = rowIndex;
        }
        if (this.lazy && this.paginator) {
            rangeStart -= this.first;
            rangeEnd -= this.first;
        }
        let rangeRowsData = [];
        for (let i = rangeStart; i <= rangeEnd; i++) {
            let rangeRowData = this.filteredValue ? this.filteredValue[i] : this.value[i];
            if (!this.isSelected(rangeRowData)) {
                if (!this.isRowSelectable(rangeRowData, rowIndex)) {
                    continue;
                }
                rangeRowsData.push(rangeRowData);
                this._selection = [...this.selection, rangeRowData];
                let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rangeRowData, this.dataKey)) : null;
                if (dataKeyValue) {
                    this.selectionKeys[dataKeyValue] = 1;
                }
            }
        }
        this.selectionChange.emit(this.selection);
        this.onRowSelect.emit({ originalEvent: event, data: rangeRowsData, type: 'row' });
    }
    clearSelectionRange(event) {
        let rangeStart, rangeEnd;
        let rangeRowIndex = this.rangeRowIndex;
        let anchorRowIndex = this.anchorRowIndex;
        if (rangeRowIndex > anchorRowIndex) {
            rangeStart = this.anchorRowIndex;
            rangeEnd = this.rangeRowIndex;
        }
        else if (rangeRowIndex < anchorRowIndex) {
            rangeStart = this.rangeRowIndex;
            rangeEnd = this.anchorRowIndex;
        }
        else {
            rangeStart = this.rangeRowIndex;
            rangeEnd = this.rangeRowIndex;
        }
        for (let i = rangeStart; i <= rangeEnd; i++) {
            let rangeRowData = this.value[i];
            let selectionIndex = this.findIndexInSelection(rangeRowData);
            this._selection = this.selection.filter((val, i) => i != selectionIndex);
            let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rangeRowData, this.dataKey)) : null;
            if (dataKeyValue) {
                delete this.selectionKeys[dataKeyValue];
            }
            this.onRowUnselect.emit({ originalEvent: event, data: rangeRowData, type: 'row' });
        }
    }
    isSelected(rowData) {
        if (rowData && this.selection) {
            if (this.dataKey) {
                return this.selectionKeys[ObjectUtils.resolveFieldData(rowData, this.dataKey)] !== undefined;
            }
            else {
                if (Array.isArray(this.selection))
                    return this.findIndexInSelection(rowData) > -1;
                else
                    return this.equals(rowData, this.selection);
            }
        }
        return false;
    }
    findIndexInSelection(rowData) {
        let index = -1;
        if (this.selection && this.selection.length) {
            for (let i = 0; i < this.selection.length; i++) {
                if (this.equals(rowData, this.selection[i])) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }
    isRowSelectable(data, index) {
        if (this.rowSelectable && !this.rowSelectable({ data, index })) {
            return false;
        }
        return true;
    }
    toggleRowWithRadio(event, rowData) {
        this.preventSelectionSetterPropagation = true;
        if (this.selection != rowData) {
            if (!this.isRowSelectable(rowData, event.rowIndex)) {
                return;
            }
            this._selection = rowData;
            this.selectionChange.emit(this.selection);
            this.onRowSelect.emit({ originalEvent: event.originalEvent, index: event.rowIndex, data: rowData, type: 'radiobutton' });
            if (this.dataKey) {
                this.selectionKeys = {};
                this.selectionKeys[String(ObjectUtils.resolveFieldData(rowData, this.dataKey))] = 1;
            }
        }
        else {
            this._selection = null;
            this.selectionChange.emit(this.selection);
            this.onRowUnselect.emit({ originalEvent: event.originalEvent, index: event.rowIndex, data: rowData, type: 'radiobutton' });
        }
        this.tableService.onSelectionChange();
        if (this.isStateful()) {
            this.saveState();
        }
    }
    toggleRowWithCheckbox(event, rowData) {
        this.selection = this.selection || [];
        let selected = this.isSelected(rowData);
        let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rowData, this.dataKey)) : null;
        this.preventSelectionSetterPropagation = true;
        if (selected) {
            let selectionIndex = this.findIndexInSelection(rowData);
            this._selection = this.selection.filter((val, i) => i != selectionIndex);
            this.selectionChange.emit(this.selection);
            this.onRowUnselect.emit({ originalEvent: event.originalEvent, index: event.rowIndex, data: rowData, type: 'checkbox' });
            if (dataKeyValue) {
                delete this.selectionKeys[dataKeyValue];
            }
        }
        else {
            if (!this.isRowSelectable(rowData, event.rowIndex)) {
                return;
            }
            this._selection = this.selection ? [...this.selection, rowData] : [rowData];
            this.selectionChange.emit(this.selection);
            this.onRowSelect.emit({ originalEvent: event.originalEvent, index: event.rowIndex, data: rowData, type: 'checkbox' });
            if (dataKeyValue) {
                this.selectionKeys[dataKeyValue] = 1;
            }
        }
        this.tableService.onSelectionChange();
        if (this.isStateful()) {
            this.saveState();
        }
    }
    toggleRowsWithCheckbox(event, check) {
        if (this._selectAll !== null) {
            this.selectAllChange.emit({ originalEvent: event, checked: check });
        }
        else {
            const data = this.selectionPageOnly ? this.dataToRender(this.processedData) : this.processedData;
            let selection = this.selectionPageOnly && this._selection ? this._selection.filter((s) => !data.some((d) => this.equals(s, d))) : [];
            if (check) {
                selection = this.frozenValue ? [...selection, ...this.frozenValue, ...data] : [...selection, ...data];
                selection = this.rowSelectable ? selection.filter((data, index) => this.rowSelectable({ data, index })) : selection;
            }
            this._selection = selection;
            this.preventSelectionSetterPropagation = true;
            this.updateSelectionKeys();
            this.selectionChange.emit(this._selection);
            this.tableService.onSelectionChange();
            this.onHeaderCheckboxToggle.emit({ originalEvent: event, checked: check });
            if (this.isStateful()) {
                this.saveState();
            }
        }
    }
    equals(data1, data2) {
        return this.compareSelectionBy === 'equals' ? data1 === data2 : ObjectUtils.equals(data1, data2, this.dataKey);
    }
    /* Legacy Filtering for custom elements */
    filter(value, field, matchMode) {
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }
        if (!this.isFilterBlank(value)) {
            this.filters[field] = field == 'global' ? { value: value, matchMode: matchMode } : [{ value: value, matchMode: matchMode }];
        }
        else if (this.filters[field]) {
            delete this.filters[field];
        }
        this.filterTimeout = setTimeout(() => {
            this._filter();
            this.filterTimeout = null;
        }, this.filterDelay);
        this.anchorRowIndex = null;
    }
    filterGlobal(value, matchMode) {
        this.filter(value, 'global', matchMode);
    }
    isFilterBlank(filter) {
        if (filter !== null && filter !== undefined) {
            if ((typeof filter === 'string' && filter.trim().length == 0) || (Array.isArray(filter) && filter.length == 0))
                return true;
            else
                return false;
        }
        return true;
    }
    _filter() {
        if (!this.restoringFilter) {
            this.first = 0;
            this.firstChange.emit(this.first);
        }
        if (this.lazy) {
            this.onLazyLoad.emit(this.createLazyLoadMetadata());
        }
        else {
            if (!this.value) {
                return;
            }
            if (!this.hasFilter()) {
                this.filteredValue = null;
                if (this.paginator) {
                    this.totalRecords = this.value ? this.value.length : 0;
                }
            }
            else {
                let globalFilterFieldsArray;
                if (this.filters['global']) {
                    if (!this.columns && !this.globalFilterFields)
                        throw new Error('Global filtering requires dynamic columns or globalFilterFields to be defined.');
                    else
                        globalFilterFieldsArray = this.globalFilterFields || this.columns;
                }
                this.filteredValue = [];
                for (let i = 0; i < this.value.length; i++) {
                    let localMatch = true;
                    let globalMatch = false;
                    let localFiltered = false;
                    for (let prop in this.filters) {
                        if (this.filters.hasOwnProperty(prop) && prop !== 'global') {
                            localFiltered = true;
                            let filterField = prop;
                            let filterMeta = this.filters[filterField];
                            if (Array.isArray(filterMeta)) {
                                for (let meta of filterMeta) {
                                    localMatch = this.executeLocalFilter(filterField, this.value[i], meta);
                                    if ((meta.operator === FilterOperator.OR && localMatch) || (meta.operator === FilterOperator.AND && !localMatch)) {
                                        break;
                                    }
                                }
                            }
                            else {
                                localMatch = this.executeLocalFilter(filterField, this.value[i], filterMeta);
                            }
                            if (!localMatch) {
                                break;
                            }
                        }
                    }
                    if (this.filters['global'] && !globalMatch && globalFilterFieldsArray) {
                        for (let j = 0; j < globalFilterFieldsArray.length; j++) {
                            let globalFilterField = globalFilterFieldsArray[j].field || globalFilterFieldsArray[j];
                            globalMatch = this.filterService.filters[this.filters['global'].matchMode](ObjectUtils.resolveFieldData(this.value[i], globalFilterField), this.filters['global'].value, this.filterLocale);
                            if (globalMatch) {
                                break;
                            }
                        }
                    }
                    let matches;
                    if (this.filters['global']) {
                        matches = localFiltered ? localFiltered && localMatch && globalMatch : globalMatch;
                    }
                    else {
                        matches = localFiltered && localMatch;
                    }
                    if (matches) {
                        this.filteredValue.push(this.value[i]);
                    }
                }
                if (this.filteredValue.length === this.value.length) {
                    this.filteredValue = null;
                }
                if (this.paginator) {
                    this.totalRecords = this.filteredValue ? this.filteredValue.length : this.value ? this.value.length : 0;
                }
            }
        }
        this.onFilter.emit({
            filters: this.filters,
            filteredValue: this.filteredValue || this.value
        });
        this.tableService.onValueChange(this.value);
        if (this.isStateful() && !this.restoringFilter) {
            this.saveState();
        }
        if (this.restoringFilter) {
            this.restoringFilter = false;
        }
        this.cd.markForCheck();
        if (this.scrollable) {
            this.resetScrollTop();
        }
    }
    executeLocalFilter(field, rowData, filterMeta) {
        let filterValue = filterMeta.value;
        let filterMatchMode = filterMeta.matchMode || FilterMatchMode.STARTS_WITH;
        let dataFieldValue = ObjectUtils.resolveFieldData(rowData, field);
        let filterConstraint = this.filterService.filters[filterMatchMode];
        return filterConstraint(dataFieldValue, filterValue, this.filterLocale);
    }
    hasFilter() {
        let empty = true;
        for (let prop in this.filters) {
            if (this.filters.hasOwnProperty(prop)) {
                empty = false;
                break;
            }
        }
        return !empty;
    }
    createLazyLoadMetadata() {
        return {
            first: this.first,
            rows: this.rows,
            sortField: this.sortField,
            sortOrder: this.sortOrder,
            filters: this.filters,
            globalFilter: this.filters && this.filters['global'] ? this.filters['global'].value : null,
            multiSortMeta: this.multiSortMeta,
            forceUpdate: () => this.cd.detectChanges()
        };
    }
    clear() {
        this._sortField = null;
        this._sortOrder = this.defaultSortOrder;
        this._multiSortMeta = null;
        this.tableService.onSort(null);
        this.clearFilterValues();
        this.filteredValue = null;
        this.first = 0;
        this.firstChange.emit(this.first);
        if (this.lazy) {
            this.onLazyLoad.emit(this.createLazyLoadMetadata());
        }
        else {
            this.totalRecords = this._value ? this._value.length : 0;
        }
    }
    clearFilterValues() {
        for (const [, filterMetadata] of Object.entries(this.filters)) {
            if (Array.isArray(filterMetadata)) {
                for (let filter of filterMetadata) {
                    filter.value = null;
                }
            }
            else if (filterMetadata) {
                filterMetadata.value = null;
            }
        }
    }
    reset() {
        this.clear();
    }
    getExportHeader(column) {
        return column[this.exportHeader] || column.header || column.field;
    }
    /**
     * Data export method.
     * @param {ExportCSVOptions} object - Export options.
     * @group Method
     */
    exportCSV(options) {
        let data;
        let csv = '';
        let columns = this.columns;
        if (options && options.selectionOnly) {
            data = this.selection || [];
        }
        else if (options && options.allValues) {
            data = this.value || [];
        }
        else {
            data = this.filteredValue || this.value;
            if (this.frozenValue) {
                data = data ? [...this.frozenValue, ...data] : this.frozenValue;
            }
        }
        const exportableColumns = columns.filter((column) => column.exportable !== false && column.field);
        //headers
        csv += exportableColumns.map((column) => '"' + this.getExportHeader(column) + '"').join(this.csvSeparator);
        //body
        const body = data
            .map((record) => exportableColumns
            .map((column) => {
            let cellData = ObjectUtils.resolveFieldData(record, column.field);
            if (cellData != null) {
                if (this.exportFunction) {
                    cellData = this.exportFunction({
                        data: cellData,
                        field: column.field
                    });
                }
                else
                    cellData = String(cellData).replace(/"/g, '""');
            }
            else
                cellData = '';
            return '"' + cellData + '"';
        })
            .join(this.csvSeparator))
            .join('\n');
        if (body.length) {
            csv += '\n' + body;
        }
        let blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });
        let link = this.renderer.createElement('a');
        link.style.display = 'none';
        this.renderer.appendChild(this.document.body, link);
        if (link.download !== undefined) {
            link.setAttribute('href', URL.createObjectURL(blob));
            link.setAttribute('download', this.exportFilename + '.csv');
            link.click();
        }
        else {
            csv = 'data:text/csv;charset=utf-8,' + csv;
            this.window.open(encodeURI(csv));
        }
        this.renderer.removeChild(this.document.body, link);
    }
    onLazyItemLoad(event) {
        this.onLazyLoad.emit({
            ...this.createLazyLoadMetadata(),
            ...event,
            rows: event.last - event.first
        });
    }
    /**
     * Resets scroll to top.
     * @group Method
     */
    resetScrollTop() {
        if (this.virtualScroll)
            this.scrollToVirtualIndex(0);
        else
            this.scrollTo({ top: 0 });
    }
    /**
     * Scrolls to given index when using virtual scroll.
     * @param {number} index - index of the element.
     * @group Method
     */
    scrollToVirtualIndex(index) {
        this.scroller && this.scroller.scrollToIndex(index);
    }
    /**
     * Scrolls to given index.
     * @param {ScrollToOptions} options - scroll options.
     * @group Method
     */
    scrollTo(options) {
        if (this.virtualScroll) {
            this.scroller?.scrollTo(options);
        }
        else if (this.wrapperViewChild && this.wrapperViewChild.nativeElement) {
            if (this.wrapperViewChild.nativeElement.scrollTo) {
                this.wrapperViewChild.nativeElement.scrollTo(options);
            }
            else {
                this.wrapperViewChild.nativeElement.scrollLeft = options.left;
                this.wrapperViewChild.nativeElement.scrollTop = options.top;
            }
        }
    }
    updateEditingCell(cell, data, field, index) {
        this.editingCell = cell;
        this.editingCellData = data;
        this.editingCellField = field;
        this.editingCellRowIndex = index;
        this.bindDocumentEditListener();
    }
    isEditingCellValid() {
        return this.editingCell && DomHandler.find(this.editingCell, '.ng-invalid.ng-dirty').length === 0;
    }
    bindDocumentEditListener() {
        if (!this.documentEditListener) {
            this.documentEditListener = this.renderer.listen(this.document, 'click', (event) => {
                if (this.editingCell && !this.selfClick && this.isEditingCellValid()) {
                    DomHandler.removeClass(this.editingCell, 'p-cell-editing');
                    this.editingCell = null;
                    this.onEditComplete.emit({ field: this.editingCellField, data: this.editingCellData, originalEvent: event, index: this.editingCellRowIndex });
                    this.editingCellField = null;
                    this.editingCellData = null;
                    this.editingCellRowIndex = null;
                    this.unbindDocumentEditListener();
                    this.cd.markForCheck();
                    if (this.overlaySubscription) {
                        this.overlaySubscription.unsubscribe();
                    }
                }
                this.selfClick = false;
            });
        }
    }
    unbindDocumentEditListener() {
        if (this.documentEditListener) {
            this.documentEditListener();
            this.documentEditListener = null;
        }
    }
    initRowEdit(rowData) {
        let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
        this.editingRowKeys[dataKeyValue] = true;
    }
    saveRowEdit(rowData, rowElement) {
        if (DomHandler.find(rowElement, '.ng-invalid.ng-dirty').length === 0) {
            let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
            delete this.editingRowKeys[dataKeyValue];
        }
    }
    cancelRowEdit(rowData) {
        let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
        delete this.editingRowKeys[dataKeyValue];
    }
    toggleRow(rowData, event) {
        if (!this.dataKey) {
            throw new Error('dataKey must be defined to use row expansion');
        }
        let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
        if (this.expandedRowKeys[dataKeyValue] != null) {
            delete this.expandedRowKeys[dataKeyValue];
            this.onRowCollapse.emit({
                originalEvent: event,
                data: rowData
            });
        }
        else {
            if (this.rowExpandMode === 'single') {
                this.expandedRowKeys = {};
            }
            this.expandedRowKeys[dataKeyValue] = true;
            this.onRowExpand.emit({
                originalEvent: event,
                data: rowData
            });
            //When this method is called on page load rather than a click event,
            //Change Detection does not recognise that this.expandedRows has changed
            //and an ExpressionChangedAfterItHasBeenCheckedError is thrown
            //So force change detection here.
            this.cd.detectChanges();
        }
        if (event) {
            event.preventDefault();
        }
        if (this.isStateful()) {
            this.saveState();
        }
    }
    isRowExpanded(rowData) {
        return this.expandedRowKeys[String(ObjectUtils.resolveFieldData(rowData, this.dataKey))] === true;
    }
    isRowEditing(rowData) {
        return this.editingRowKeys[String(ObjectUtils.resolveFieldData(rowData, this.dataKey))] === true;
    }
    isSingleSelectionMode() {
        return this.selectionMode === 'single';
    }
    isMultipleSelectionMode() {
        return this.selectionMode === 'multiple';
    }
    onColumnResizeBegin(event) {
        let containerLeft = DomHandler.getOffset(this.containerViewChild?.nativeElement).left;
        this.resizeColumnElement = event.target.parentElement;
        this.columnResizing = true;
        this.lastResizerHelperX = event.pageX - containerLeft + this.containerViewChild?.nativeElement.scrollLeft;
        this.onColumnResize(event);
        event.preventDefault();
    }
    onColumnResize(event) {
        let containerLeft = DomHandler.getOffset(this.containerViewChild?.nativeElement).left;
        DomHandler.addClass(this.containerViewChild?.nativeElement, 'p-unselectable-text');
        this.resizeHelperViewChild.nativeElement.style.height = this.containerViewChild?.nativeElement.offsetHeight + 'px';
        this.resizeHelperViewChild.nativeElement.style.top = 0 + 'px';
        this.resizeHelperViewChild.nativeElement.style.left = event.pageX - containerLeft + this.containerViewChild?.nativeElement.scrollLeft + 'px';
        this.resizeHelperViewChild.nativeElement.style.display = 'block';
    }
    onColumnResizeEnd() {
        let delta = this.resizeHelperViewChild?.nativeElement.offsetLeft - this.lastResizerHelperX;
        let columnWidth = this.resizeColumnElement.offsetWidth;
        let newColumnWidth = columnWidth + delta;
        let minWidth = this.resizeColumnElement.style.minWidth.replace(/[^\d.]/g, '') || 15;
        if (newColumnWidth >= minWidth) {
            if (this.columnResizeMode === 'fit') {
                let nextColumn = this.resizeColumnElement.nextElementSibling;
                let nextColumnWidth = nextColumn.offsetWidth - delta;
                if (newColumnWidth > 15 && nextColumnWidth > 15) {
                    this.resizeTableCells(newColumnWidth, nextColumnWidth);
                }
            }
            else if (this.columnResizeMode === 'expand') {
                this._initialColWidths = this._totalTableWidth();
                let tableWidth = this.tableViewChild?.nativeElement.offsetWidth + delta;
                this.setResizeTableWidth(tableWidth + 'px');
                this.resizeTableCells(newColumnWidth, null);
            }
            this.onColResize.emit({
                element: this.resizeColumnElement,
                delta: delta
            });
            if (this.isStateful()) {
                this.saveState();
            }
        }
        this.resizeHelperViewChild.nativeElement.style.display = 'none';
        DomHandler.removeClass(this.containerViewChild?.nativeElement, 'p-unselectable-text');
    }
    _totalTableWidth() {
        let widths = [];
        const tableHead = DomHandler.findSingle(this.containerViewChild.nativeElement, '.p-datatable-thead');
        let headers = DomHandler.find(tableHead, 'tr > th');
        headers.forEach((header) => widths.push(DomHandler.getOuterWidth(header)));
        return widths;
    }
    onColumnDragStart(event, columnElement) {
        this.reorderIconWidth = DomHandler.getHiddenElementOuterWidth(this.reorderIndicatorUpViewChild?.nativeElement);
        this.reorderIconHeight = DomHandler.getHiddenElementOuterHeight(this.reorderIndicatorDownViewChild?.nativeElement);
        this.draggedColumn = columnElement;
        event.dataTransfer.setData('text', 'b'); // For firefox
    }
    onColumnDragEnter(event, dropHeader) {
        if (this.reorderableColumns && this.draggedColumn && dropHeader) {
            event.preventDefault();
            let containerOffset = DomHandler.getOffset(this.containerViewChild?.nativeElement);
            let dropHeaderOffset = DomHandler.getOffset(dropHeader);
            if (this.draggedColumn != dropHeader) {
                let dragIndex = DomHandler.indexWithinGroup(this.draggedColumn, 'preorderablecolumn');
                let dropIndex = DomHandler.indexWithinGroup(dropHeader, 'preorderablecolumn');
                let targetLeft = dropHeaderOffset.left - containerOffset.left;
                let targetTop = containerOffset.top - dropHeaderOffset.top;
                let columnCenter = dropHeaderOffset.left + dropHeader.offsetWidth / 2;
                this.reorderIndicatorUpViewChild.nativeElement.style.top = dropHeaderOffset.top - containerOffset.top - (this.reorderIconHeight - 1) + 'px';
                this.reorderIndicatorDownViewChild.nativeElement.style.top = dropHeaderOffset.top - containerOffset.top + dropHeader.offsetHeight + 'px';
                if (event.pageX > columnCenter) {
                    this.reorderIndicatorUpViewChild.nativeElement.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(this.reorderIconWidth / 2) + 'px';
                    this.reorderIndicatorDownViewChild.nativeElement.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(this.reorderIconWidth / 2) + 'px';
                    this.dropPosition = 1;
                }
                else {
                    this.reorderIndicatorUpViewChild.nativeElement.style.left = targetLeft - Math.ceil(this.reorderIconWidth / 2) + 'px';
                    this.reorderIndicatorDownViewChild.nativeElement.style.left = targetLeft - Math.ceil(this.reorderIconWidth / 2) + 'px';
                    this.dropPosition = -1;
                }
                this.reorderIndicatorUpViewChild.nativeElement.style.display = 'block';
                this.reorderIndicatorDownViewChild.nativeElement.style.display = 'block';
            }
            else {
                event.dataTransfer.dropEffect = 'none';
            }
        }
    }
    onColumnDragLeave(event) {
        if (this.reorderableColumns && this.draggedColumn) {
            event.preventDefault();
        }
    }
    onColumnDrop(event, dropColumn) {
        event.preventDefault();
        if (this.draggedColumn) {
            let dragIndex = DomHandler.indexWithinGroup(this.draggedColumn, 'preorderablecolumn');
            let dropIndex = DomHandler.indexWithinGroup(dropColumn, 'preorderablecolumn');
            let allowDrop = dragIndex != dropIndex;
            if (allowDrop && ((dropIndex - dragIndex == 1 && this.dropPosition === -1) || (dragIndex - dropIndex == 1 && this.dropPosition === 1))) {
                allowDrop = false;
            }
            if (allowDrop && dropIndex < dragIndex && this.dropPosition === 1) {
                dropIndex = dropIndex + 1;
            }
            if (allowDrop && dropIndex > dragIndex && this.dropPosition === -1) {
                dropIndex = dropIndex - 1;
            }
            if (allowDrop) {
                ObjectUtils.reorderArray(this.columns, dragIndex, dropIndex);
                this.onColReorder.emit({
                    dragIndex: dragIndex,
                    dropIndex: dropIndex,
                    columns: this.columns
                });
                if (this.isStateful()) {
                    this.zone.runOutsideAngular(() => {
                        setTimeout(() => {
                            this.saveState();
                        });
                    });
                }
            }
            if (this.resizableColumns && this.resizeColumnElement) {
                let width = this.columnResizeMode === 'expand' ? this._initialColWidths : this._totalTableWidth();
                ObjectUtils.reorderArray(width, dragIndex + 1, dropIndex + 1);
                this.updateStyleElement(width, dragIndex, null, null);
            }
            this.reorderIndicatorUpViewChild.nativeElement.style.display = 'none';
            this.reorderIndicatorDownViewChild.nativeElement.style.display = 'none';
            this.draggedColumn.draggable = false;
            this.draggedColumn = null;
            this.dropPosition = null;
        }
    }
    resizeTableCells(newColumnWidth, nextColumnWidth) {
        let colIndex = DomHandler.index(this.resizeColumnElement);
        let width = this.columnResizeMode === 'expand' ? this._initialColWidths : this._totalTableWidth();
        this.updateStyleElement(width, colIndex, newColumnWidth, nextColumnWidth);
    }
    updateStyleElement(width, colIndex, newColumnWidth, nextColumnWidth) {
        this.destroyStyleElement();
        this.createStyleElement();
        let innerHTML = '';
        width.forEach((width, index) => {
            let colWidth = index === colIndex ? newColumnWidth : nextColumnWidth && index === colIndex + 1 ? nextColumnWidth : width;
            let style = `width: ${colWidth}px !important; max-width: ${colWidth}px !important;`;
            innerHTML += `
                #${this.id}-table > .p-datatable-thead > tr > th:nth-child(${index + 1}),
                #${this.id}-table > .p-datatable-tbody > tr > td:nth-child(${index + 1}),
                #${this.id}-table > .p-datatable-tfoot > tr > td:nth-child(${index + 1}) {
                    ${style}
                }
            `;
        });
        this.renderer.setProperty(this.styleElement, 'innerHTML', innerHTML);
    }
    onRowDragStart(event, index) {
        this.rowDragging = true;
        this.draggedRowIndex = index;
        event.dataTransfer.setData('text', 'b'); // For firefox
    }
    onRowDragOver(event, index, rowElement) {
        if (this.rowDragging && this.draggedRowIndex !== index) {
            let rowY = DomHandler.getOffset(rowElement).top;
            let pageY = event.pageY;
            let rowMidY = rowY + DomHandler.getOuterHeight(rowElement) / 2;
            let prevRowElement = rowElement.previousElementSibling;
            if (pageY < rowMidY) {
                DomHandler.removeClass(rowElement, 'p-datatable-dragpoint-bottom');
                this.droppedRowIndex = index;
                if (prevRowElement)
                    DomHandler.addClass(prevRowElement, 'p-datatable-dragpoint-bottom');
                else
                    DomHandler.addClass(rowElement, 'p-datatable-dragpoint-top');
            }
            else {
                if (prevRowElement)
                    DomHandler.removeClass(prevRowElement, 'p-datatable-dragpoint-bottom');
                else
                    DomHandler.addClass(rowElement, 'p-datatable-dragpoint-top');
                this.droppedRowIndex = index + 1;
                DomHandler.addClass(rowElement, 'p-datatable-dragpoint-bottom');
            }
        }
    }
    onRowDragLeave(event, rowElement) {
        let prevRowElement = rowElement.previousElementSibling;
        if (prevRowElement) {
            DomHandler.removeClass(prevRowElement, 'p-datatable-dragpoint-bottom');
        }
        DomHandler.removeClass(rowElement, 'p-datatable-dragpoint-bottom');
        DomHandler.removeClass(rowElement, 'p-datatable-dragpoint-top');
    }
    onRowDragEnd(event) {
        this.rowDragging = false;
        this.draggedRowIndex = null;
        this.droppedRowIndex = null;
    }
    onRowDrop(event, rowElement) {
        if (this.droppedRowIndex != null) {
            let dropIndex = this.draggedRowIndex > this.droppedRowIndex ? this.droppedRowIndex : this.droppedRowIndex === 0 ? 0 : this.droppedRowIndex - 1;
            ObjectUtils.reorderArray(this.value, this.draggedRowIndex, dropIndex);
            if (this.virtualScroll) {
                // TODO: Check
                this._value = [...this._value];
            }
            this.onRowReorder.emit({
                dragIndex: this.draggedRowIndex,
                dropIndex: dropIndex
            });
        }
        //cleanup
        this.onRowDragLeave(event, rowElement);
        this.onRowDragEnd(event);
    }
    isEmpty() {
        let data = this.filteredValue || this.value;
        return data == null || data.length == 0;
    }
    getBlockableElement() {
        return this.el.nativeElement.children[0];
    }
    getStorage() {
        if (isPlatformBrowser(this.platformId)) {
            switch (this.stateStorage) {
                case 'local':
                    return window.localStorage;
                case 'session':
                    return window.sessionStorage;
                default:
                    throw new Error(this.stateStorage + ' is not a valid value for the state storage, supported values are "local" and "session".');
            }
        }
        else {
            throw new Error('Browser storage is not available in the server side.');
        }
    }
    isStateful() {
        return this.stateKey != null;
    }
    saveState() {
        const storage = this.getStorage();
        let state = {};
        if (this.paginator) {
            state.first = this.first;
            state.rows = this.rows;
        }
        if (this.sortField) {
            state.sortField = this.sortField;
            state.sortOrder = this.sortOrder;
        }
        if (this.multiSortMeta) {
            state.multiSortMeta = this.multiSortMeta;
        }
        if (this.hasFilter()) {
            state.filters = this.filters;
        }
        if (this.resizableColumns) {
            this.saveColumnWidths(state);
        }
        if (this.reorderableColumns) {
            this.saveColumnOrder(state);
        }
        if (this.selection) {
            state.selection = this.selection;
        }
        if (Object.keys(this.expandedRowKeys).length) {
            state.expandedRowKeys = this.expandedRowKeys;
        }
        storage.setItem(this.stateKey, JSON.stringify(state));
        this.onStateSave.emit(state);
    }
    clearState() {
        const storage = this.getStorage();
        if (this.stateKey) {
            storage.removeItem(this.stateKey);
        }
    }
    restoreState() {
        const storage = this.getStorage();
        const stateString = storage.getItem(this.stateKey);
        const dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
        const reviver = function (key, value) {
            if (typeof value === 'string' && dateFormat.test(value)) {
                return new Date(value);
            }
            return value;
        };
        if (stateString) {
            let state = JSON.parse(stateString, reviver);
            if (this.paginator) {
                if (this.first !== undefined) {
                    this.first = state.first;
                    this.firstChange.emit(this.first);
                }
                if (this.rows !== undefined) {
                    this.rows = state.rows;
                    this.rowsChange.emit(this.rows);
                }
            }
            if (state.sortField) {
                this.restoringSort = true;
                this._sortField = state.sortField;
                this._sortOrder = state.sortOrder;
            }
            if (state.multiSortMeta) {
                this.restoringSort = true;
                this._multiSortMeta = state.multiSortMeta;
            }
            if (state.filters) {
                this.restoringFilter = true;
                this.filters = state.filters;
            }
            if (this.resizableColumns) {
                this.columnWidthsState = state.columnWidths;
                this.tableWidthState = state.tableWidth;
            }
            if (state.expandedRowKeys) {
                this.expandedRowKeys = state.expandedRowKeys;
            }
            if (state.selection) {
                Promise.resolve(null).then(() => this.selectionChange.emit(state.selection));
            }
            this.stateRestored = true;
            this.onStateRestore.emit(state);
        }
    }
    saveColumnWidths(state) {
        let widths = [];
        let headers = DomHandler.find(this.containerViewChild?.nativeElement, '.p-datatable-thead > tr > th');
        headers.forEach((header) => widths.push(DomHandler.getOuterWidth(header)));
        state.columnWidths = widths.join(',');
        if (this.columnResizeMode === 'expand') {
            state.tableWidth = DomHandler.getOuterWidth(this.tableViewChild?.nativeElement);
        }
    }
    setResizeTableWidth(width) {
        this.tableViewChild.nativeElement.style.width = width;
        this.tableViewChild.nativeElement.style.minWidth = width;
    }
    restoreColumnWidths() {
        if (this.columnWidthsState) {
            let widths = this.columnWidthsState.split(',');
            if (this.columnResizeMode === 'expand' && this.tableWidthState) {
                this.setResizeTableWidth(this.tableWidthState + 'px');
            }
            if (ObjectUtils.isNotEmpty(widths)) {
                this.createStyleElement();
                let innerHTML = '';
                widths.forEach((width, index) => {
                    let style = `width: ${width}px !important; max-width: ${width}px !important`;
                    innerHTML += `
                        #${this.id}-table > .p-datatable-thead > tr > th:nth-child(${index + 1}),
                        #${this.id}-table > .p-datatable-tbody > tr > td:nth-child(${index + 1}),
                        #${this.id}-table > .p-datatable-tfoot > tr > td:nth-child(${index + 1}) {
                            ${style}
                        }
                    `;
                });
                this.styleElement.innerHTML = innerHTML;
            }
        }
    }
    saveColumnOrder(state) {
        if (this.columns) {
            let columnOrder = [];
            this.columns.map((column) => {
                columnOrder.push(column.field || column.key);
            });
            state.columnOrder = columnOrder;
        }
    }
    restoreColumnOrder() {
        const storage = this.getStorage();
        const stateString = storage.getItem(this.stateKey);
        if (stateString) {
            let state = JSON.parse(stateString);
            let columnOrder = state.columnOrder;
            if (columnOrder) {
                let reorderedColumns = [];
                columnOrder.map((key) => {
                    let col = this.findColumnByKey(key);
                    if (col) {
                        reorderedColumns.push(col);
                    }
                });
                this.columnOrderStateRestored = true;
                this.columns = reorderedColumns;
            }
        }
    }
    findColumnByKey(key) {
        if (this.columns) {
            for (let col of this.columns) {
                if (col.key === key || col.field === key)
                    return col;
                else
                    continue;
            }
        }
        else {
            return null;
        }
    }
    createStyleElement() {
        this.styleElement = this.renderer.createElement('style');
        this.styleElement.type = 'text/css';
        this.renderer.appendChild(this.document.head, this.styleElement);
    }
    getGroupRowsMeta() {
        return { field: this.groupRowsBy, order: this.groupRowsByOrder };
    }
    createResponsiveStyle() {
        if (isPlatformBrowser(this.platformId)) {
            if (!this.responsiveStyleElement) {
                this.responsiveStyleElement = this.renderer.createElement('style');
                this.responsiveStyleElement.type = 'text/css';
                this.renderer.appendChild(this.document.head, this.responsiveStyleElement);
                let innerHTML = `
@media screen and (max-width: ${this.breakpoint}) {
        #${this.id}-table > .p-datatable-thead > tr > th,
        #${this.id}-table > .p-datatable-tfoot > tr > td {
        /*display: none !important; // dspx-core customisation made, please merge carefully when updating this with the latest from PrimeNg's GitHub.*/
    }

        #${this.id}-table > .p-datatable-tbody > tr > td {
        /*display: flex; // dspx-core customisation made, please merge carefully when updating this with the latest from PrimeNg's GitHub.*/
        width: 100% !important;
        align-items: center;
        justify-content: space-between;
    }

        #${this.id}-table > .p-datatable-tbody > tr > td:not(:last-child) {
        border: 0 none;
    }

        #${this.id}.p-datatable-gridlines > .p-datatable-wrapper > .p-datatable-table > .p-datatable-tbody > tr > td:last-child {
        border-top: 0;
        border-right: 0;
        border-left: 0;
    }

        #${this.id}-table > .p-datatable-tbody > tr > td > .p-column-title {
        display: block;
    }
}
`;
                this.renderer.setProperty(this.responsiveStyleElement, 'innerHTML', innerHTML);
            }
        }
    }
    destroyResponsiveStyle() {
        if (this.responsiveStyleElement) {
            this.renderer.removeChild(this.document.head, this.responsiveStyleElement);
            this.responsiveStyleElement = null;
        }
    }
    destroyStyleElement() {
        if (this.styleElement) {
            this.renderer.removeChild(this.document.head, this.styleElement);
            this.styleElement = null;
        }
    }
    ngOnDestroy() {
        this.unbindDocumentEditListener();
        this.editingCell = null;
        this.initialized = null;
        this.destroyStyleElement();
        this.destroyResponsiveStyle();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Table, deps: [{ token: DOCUMENT }, { token: PLATFORM_ID }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: TableService }, { token: i0.ChangeDetectorRef }, { token: i1$1.FilterService }, { token: i1$1.OverlayService }, { token: i1$1.PrimeNGConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: Table, selector: "p-table", inputs: { frozenColumns: "frozenColumns", frozenValue: "frozenValue", style: "style", styleClass: "styleClass", tableStyle: "tableStyle", tableStyleClass: "tableStyleClass", paginator: "paginator", pageLinks: "pageLinks", rowsPerPageOptions: "rowsPerPageOptions", alwaysShowPaginator: "alwaysShowPaginator", paginatorPosition: "paginatorPosition", paginatorStyleClass: "paginatorStyleClass", paginatorDropdownAppendTo: "paginatorDropdownAppendTo", paginatorDropdownScrollHeight: "paginatorDropdownScrollHeight", currentPageReportTemplate: "currentPageReportTemplate", showCurrentPageReport: "showCurrentPageReport", showJumpToPageDropdown: "showJumpToPageDropdown", showJumpToPageInput: "showJumpToPageInput", showFirstLastIcon: "showFirstLastIcon", showPageLinks: "showPageLinks", defaultSortOrder: "defaultSortOrder", sortMode: "sortMode", resetPageOnSort: "resetPageOnSort", selectionMode: "selectionMode", selectionPageOnly: "selectionPageOnly", contextMenuSelection: "contextMenuSelection", contextMenuSelectionMode: "contextMenuSelectionMode", dataKey: "dataKey", metaKeySelection: "metaKeySelection", rowSelectable: "rowSelectable", rowTrackBy: "rowTrackBy", lazy: "lazy", lazyLoadOnInit: "lazyLoadOnInit", compareSelectionBy: "compareSelectionBy", csvSeparator: "csvSeparator", exportFilename: "exportFilename", filters: "filters", globalFilterFields: "globalFilterFields", filterDelay: "filterDelay", filterLocale: "filterLocale", expandedRowKeys: "expandedRowKeys", editingRowKeys: "editingRowKeys", rowExpandMode: "rowExpandMode", scrollable: "scrollable", scrollDirection: "scrollDirection", rowGroupMode: "rowGroupMode", scrollHeight: "scrollHeight", virtualScroll: "virtualScroll", virtualScrollItemSize: "virtualScrollItemSize", virtualScrollOptions: "virtualScrollOptions", virtualScrollDelay: "virtualScrollDelay", frozenWidth: "frozenWidth", responsive: "responsive", contextMenu: "contextMenu", resizableColumns: "resizableColumns", columnResizeMode: "columnResizeMode", reorderableColumns: "reorderableColumns", loading: "loading", loadingIcon: "loadingIcon", showLoader: "showLoader", rowHover: "rowHover", customSort: "customSort", showInitialSortBadge: "showInitialSortBadge", autoLayout: "autoLayout", exportFunction: "exportFunction", exportHeader: "exportHeader", stateKey: "stateKey", stateStorage: "stateStorage", editMode: "editMode", groupRowsBy: "groupRowsBy", groupRowsByOrder: "groupRowsByOrder", responsiveLayout: "responsiveLayout", breakpoint: "breakpoint", paginatorLocale: "paginatorLocale", value: "value", columns: "columns", first: "first", rows: "rows", totalRecords: "totalRecords", sortField: "sortField", sortOrder: "sortOrder", multiSortMeta: "multiSortMeta", selection: "selection", selectAll: "selectAll", virtualRowHeight: "virtualRowHeight" }, outputs: { contextMenuSelectionChange: "contextMenuSelectionChange", selectAllChange: "selectAllChange", selectionChange: "selectionChange", onRowSelect: "onRowSelect", onRowUnselect: "onRowUnselect", onPage: "onPage", onSort: "onSort", onFilter: "onFilter", onLazyLoad: "onLazyLoad", onRowExpand: "onRowExpand", onRowCollapse: "onRowCollapse", onContextMenuSelect: "onContextMenuSelect", onColResize: "onColResize", onColReorder: "onColReorder", onRowReorder: "onRowReorder", onEditInit: "onEditInit", onEditComplete: "onEditComplete", onEditCancel: "onEditCancel", onHeaderCheckboxToggle: "onHeaderCheckboxToggle", sortFunction: "sortFunction", firstChange: "firstChange", rowsChange: "rowsChange", onStateSave: "onStateSave", onStateRestore: "onStateRestore" }, host: { classAttribute: "p-element" }, providers: [TableService], queries: [{ propertyName: "templates", predicate: PrimeTemplate }], viewQueries: [{ propertyName: "containerViewChild", first: true, predicate: ["container"], descendants: true }, { propertyName: "resizeHelperViewChild", first: true, predicate: ["resizeHelper"], descendants: true }, { propertyName: "reorderIndicatorUpViewChild", first: true, predicate: ["reorderIndicatorUp"], descendants: true }, { propertyName: "reorderIndicatorDownViewChild", first: true, predicate: ["reorderIndicatorDown"], descendants: true }, { propertyName: "wrapperViewChild", first: true, predicate: ["wrapper"], descendants: true }, { propertyName: "tableViewChild", first: true, predicate: ["table"], descendants: true }, { propertyName: "tableHeaderViewChild", first: true, predicate: ["thead"], descendants: true }, { propertyName: "tableFooterViewChild", first: true, predicate: ["tfoot"], descendants: true }, { propertyName: "scroller", first: true, predicate: ["scroller"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #container\r\n     [ngStyle]=\"style\"\r\n     [class]=\"styleClass\"\r\n     [ngClass]=\"{ 'p-datatable p-component': true, 'p-datatable-hoverable-rows': rowHover || selectionMode, 'p-datatable-scrollable': scrollable, 'p-datatable-flex-scrollable': scrollable && scrollHeight === 'flex' }\"\r\n     [attr.id]=\"id\">\r\n  <div class=\"p-datatable-loading-overlay p-component-overlay\" *ngIf=\"loading && showLoader\">\r\n    <i *ngIf=\"loadingIcon\" [class]=\"'p-datatable-loading-icon ' + loadingIcon\"></i>\r\n    <ng-container *ngIf=\"!loadingIcon\">\r\n      <SpinnerIcon *ngIf=\"!loadingIconTemplate\" [spin]=\"true\" [styleClass]=\"'p-datatable-loading-icon'\" />\r\n      <span *ngIf=\"loadingIconTemplate\" class=\"p-datatable-loading-icon\">\r\n        <ng-template *ngTemplateOutlet=\"loadingIconTemplate\"></ng-template>\r\n      </span>\r\n    </ng-container>\r\n  </div>\r\n  <div *ngIf=\"captionTemplate\" class=\"p-datatable-header\">\r\n    <ng-container *ngTemplateOutlet=\"captionTemplate\"></ng-container>\r\n  </div>\r\n  <p-paginator [rows]=\"rows\"\r\n               [first]=\"first\"\r\n               [totalRecords]=\"totalRecords\"\r\n               [pageLinkSize]=\"pageLinks\"\r\n               styleClass=\"p-paginator-top\"\r\n               [alwaysShow]=\"alwaysShowPaginator\"\r\n               (onPageChange)=\"onPageChange($event)\"\r\n               [rowsPerPageOptions]=\"rowsPerPageOptions\"\r\n               *ngIf=\"paginator && (paginatorPosition === 'top' || paginatorPosition == 'both')\"\r\n               [templateLeft]=\"paginatorLeftTemplate\"\r\n               [templateRight]=\"paginatorRightTemplate\"\r\n               [dropdownAppendTo]=\"paginatorDropdownAppendTo\"\r\n               [dropdownScrollHeight]=\"paginatorDropdownScrollHeight\"\r\n               [currentPageReportTemplate]=\"currentPageReportTemplate\"\r\n               [showFirstLastIcon]=\"showFirstLastIcon\"\r\n               [dropdownItemTemplate]=\"paginatorDropdownItemTemplate\"\r\n               [showCurrentPageReport]=\"showCurrentPageReport\"\r\n               [showJumpToPageDropdown]=\"showJumpToPageDropdown\"\r\n               [showJumpToPageInput]=\"showJumpToPageInput\"\r\n               [showPageLinks]=\"showPageLinks\"\r\n               [styleClass]=\"paginatorStyleClass\"\r\n               [locale]=\"paginatorLocale\">\r\n    <ng-template pTemplate=\"firstpagelinkicon\" *ngIf=\"paginatorFirstPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorFirstPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"previouspagelinkicon\" *ngIf=\"paginatorPreviousPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorPreviousPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"lastpagelinkicon\" *ngIf=\"paginatorLastPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorLastPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"nextpagelinkicon\" *ngIf=\"paginatorNextPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorNextPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n  </p-paginator>\r\n\r\n  <div #wrapper class=\"p-datatable-wrapper\" [ngStyle]=\"{ maxHeight: virtualScroll ? '' : scrollHeight }\">\r\n    <p-scroller #scroller\r\n                *ngIf=\"virtualScroll\"\r\n                [items]=\"processedData\"\r\n                [columns]=\"columns\"\r\n                [style]=\"{ height: scrollHeight !== 'flex' ? scrollHeight : undefined }\"\r\n                [scrollHeight]=\"scrollHeight !== 'flex' ? undefined : '100%'\"\r\n                [itemSize]=\"virtualScrollItemSize || _virtualRowHeight\"\r\n                [step]=\"rows\"\r\n                [delay]=\"lazy ? virtualScrollDelay : 0\"\r\n                [inline]=\"true\"\r\n                [lazy]=\"lazy\"\r\n                (onLazyLoad)=\"onLazyItemLoad($event)\"\r\n                [loaderDisabled]=\"true\"\r\n                [showSpacer]=\"false\"\r\n                [showLoader]=\"loadingBodyTemplate\"\r\n                [options]=\"virtualScrollOptions\"\r\n                [autoSize]=\"true\">\r\n      <ng-template pTemplate=\"content\" let-items let-scrollerOptions=\"options\">\r\n        <ng-container *ngTemplateOutlet=\"buildInTable; context: { $implicit: items, options: scrollerOptions }\"></ng-container>\r\n      </ng-template>\r\n    </p-scroller>\r\n    <ng-container *ngIf=\"!virtualScroll\">\r\n      <ng-container *ngTemplateOutlet=\"buildInTable; context: { $implicit: processedData, options: { columns } }\"></ng-container>\r\n    </ng-container>\r\n\r\n    <ng-template #buildInTable let-items let-scrollerOptions=\"options\">\r\n      <table #table\r\n             role=\"table\"\r\n             [ngClass]=\"{ 'p-datatable-table': true, 'p-datatable-scrollable-table': scrollable, 'p-datatable-resizable-table': resizableColumns, 'p-datatable-resizable-table-fit': resizableColumns && columnResizeMode === 'fit' }\"\r\n             [class]=\"tableStyleClass\"\r\n             [style]=\"tableStyle\"\r\n             [attr.id]=\"id + '-table'\">\r\n        <ng-container *ngTemplateOutlet=\"colGroupTemplate; context: { $implicit: scrollerOptions.columns }\"></ng-container>\r\n        <thead role=\"rowgroup\" #thead class=\"p-datatable-thead\">\r\n          <ng-container *ngTemplateOutlet=\"headerGroupedTemplate || headerTemplate; context: { $implicit: scrollerOptions.columns }\"></ng-container>\r\n        </thead>\r\n        <tbody role=\"rowgroup\"\r\n               class=\"p-datatable-tbody p-datatable-frozen-tbody\"\r\n               *ngIf=\"frozenValue || frozenBodyTemplate\"\r\n               [value]=\"frozenValue\"\r\n               [frozenRows]=\"true\"\r\n               [pTableBody]=\"scrollerOptions.columns\"\r\n               [pTableBodyTemplate]=\"frozenBodyTemplate\"\r\n               [frozen]=\"true\"></tbody>\r\n        <tbody role=\"rowgroup\"\r\n               class=\"p-datatable-tbody\"\r\n               [ngClass]=\"scrollerOptions.contentStyleClass\"\r\n               [style]=\"scrollerOptions.contentStyle\"\r\n               [value]=\"dataToRender(scrollerOptions.rows)\"\r\n               [pTableBody]=\"scrollerOptions.columns\"\r\n               [pTableBodyTemplate]=\"bodyTemplate\"\r\n               [scrollerOptions]=\"scrollerOptions\"></tbody>\r\n        <tbody role=\"rowgroup\"\r\n               *ngIf=\"scrollerOptions.spacerStyle\"\r\n               [style]=\"'height: calc(' + scrollerOptions.spacerStyle.height + ' - ' + scrollerOptions.rows.length * scrollerOptions.itemSize + 'px);'\"\r\n               class=\"p-datatable-scroller-spacer\"></tbody>\r\n        <tfoot role=\"rowgroup\" *ngIf=\"footerGroupedTemplate || footerTemplate\" #tfoot class=\"p-datatable-tfoot\">\r\n          <ng-container *ngTemplateOutlet=\"footerGroupedTemplate || footerTemplate; context: { $implicit: scrollerOptions.columns }\"></ng-container>\r\n        </tfoot>\r\n      </table>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <p-paginator [rows]=\"rows\"\r\n               [first]=\"first\"\r\n               [totalRecords]=\"totalRecords\"\r\n               [pageLinkSize]=\"pageLinks\"\r\n               styleClass=\"p-paginator-bottom\"\r\n               [alwaysShow]=\"alwaysShowPaginator\"\r\n               (onPageChange)=\"onPageChange($event)\"\r\n               [rowsPerPageOptions]=\"rowsPerPageOptions\"\r\n               *ngIf=\"paginator && (paginatorPosition === 'bottom' || paginatorPosition == 'both')\"\r\n               [templateLeft]=\"paginatorLeftTemplate\"\r\n               [templateRight]=\"paginatorRightTemplate\"\r\n               [dropdownAppendTo]=\"paginatorDropdownAppendTo\"\r\n               [dropdownScrollHeight]=\"paginatorDropdownScrollHeight\"\r\n               [currentPageReportTemplate]=\"currentPageReportTemplate\"\r\n               [showFirstLastIcon]=\"showFirstLastIcon\"\r\n               [dropdownItemTemplate]=\"paginatorDropdownItemTemplate\"\r\n               [showCurrentPageReport]=\"showCurrentPageReport\"\r\n               [showJumpToPageDropdown]=\"showJumpToPageDropdown\"\r\n               [showJumpToPageInput]=\"showJumpToPageInput\"\r\n               [showPageLinks]=\"showPageLinks\"\r\n               [styleClass]=\"paginatorStyleClass\"\r\n               [locale]=\"paginatorLocale\">\r\n    <ng-template pTemplate=\"firstpagelinkicon\" *ngIf=\"paginatorFirstPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorFirstPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"previouspagelinkicon\" *ngIf=\"paginatorPreviousPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorPreviousPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"lastpagelinkicon\" *ngIf=\"paginatorLastPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorLastPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"nextpagelinkicon\" *ngIf=\"paginatorNextPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorNextPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n  </p-paginator>\r\n\r\n  <div *ngIf=\"summaryTemplate\" class=\"p-datatable-footer\">\r\n    <ng-container *ngTemplateOutlet=\"summaryTemplate\"></ng-container>\r\n  </div>\r\n\r\n  <div #resizeHelper class=\"p-column-resizer-helper\" style=\"display:none\" *ngIf=\"resizableColumns\"></div>\r\n  <span #reorderIndicatorUp class=\"p-datatable-reorder-indicator-up\" style=\"display: none;\" *ngIf=\"reorderableColumns\">\r\n    <ArrowDownIcon *ngIf=\"!reorderIndicatorUpIconTemplate\" />\r\n    <ng-template *ngTemplateOutlet=\"reorderIndicatorUpIconTemplate\"></ng-template>\r\n  </span>\r\n  <span #reorderIndicatorDown class=\"p-datatable-reorder-indicator-down\" style=\"display: none;\" *ngIf=\"reorderableColumns\">\r\n    <ArrowUpIcon *ngIf=\"!reorderIndicatorDownIconTemplate\" />\r\n    <ng-template *ngTemplateOutlet=\"reorderIndicatorDownIconTemplate\"></ng-template>\r\n  </span>\r\n</div>\r\n", styles: ["@layer primeng{.p-datatable{position:relative}.p-datatable>.p-datatable-wrapper{overflow:auto}.p-datatable-table{border-spacing:0px;width:100%}.p-datatable .p-sortable-column{cursor:pointer;-webkit-user-select:none;user-select:none}.p-datatable .p-sortable-column .p-column-title,.p-datatable .p-sortable-column .p-sortable-column-icon,.p-datatable .p-sortable-column .p-sortable-column-badge{vertical-align:middle}.p-datatable .p-sortable-column .p-icon-wrapper{display:inline}.p-datatable .p-sortable-column .p-sortable-column-badge{display:inline-flex;align-items:center;justify-content:center}.p-datatable-hoverable-rows .p-selectable-row{cursor:pointer}.p-datatable-scrollable>.p-datatable-wrapper{position:relative}.p-datatable-scrollable-table>.p-datatable-thead{position:sticky;top:0;z-index:2}.p-datatable-scrollable-table>.p-datatable-frozen-tbody{position:sticky;z-index:1}.p-datatable-scrollable-table>.p-datatable-tfoot{position:sticky;bottom:0;z-index:1}.p-datatable-scrollable .p-frozen-column{position:sticky;background:inherit;z-index:1}.p-datatable-scrollable th.p-frozen-column{z-index:1}.p-datatable-flex-scrollable{display:flex;flex-direction:column;height:100%}.p-datatable-flex-scrollable>.p-datatable-wrapper{display:flex;flex-direction:column;flex:1;height:100%}.p-datatable-scrollable-table>.p-datatable-tbody>.p-rowgroup-header{position:sticky;z-index:2}.p-datatable-resizable-table>.p-datatable-thead>tr>th,.p-datatable-resizable-table>.p-datatable-tfoot>tr>td,.p-datatable-resizable-table>.p-datatable-tbody>tr>td{overflow:hidden;white-space:nowrap}.p-datatable-resizable-table>.p-datatable-thead>tr>th.p-resizable-column:not(.p-frozen-column){background-clip:padding-box;position:relative}.p-datatable-resizable-table-fit>.p-datatable-thead>tr>th.p-resizable-column:last-child .p-column-resizer{display:none}.p-datatable .p-column-resizer{display:block;position:absolute!important;top:0;right:0;margin:0;width:.5rem;height:100%;padding:0;cursor:col-resize;border:1px solid transparent}.p-datatable .p-column-resizer-helper{width:1px;position:absolute;z-index:10;display:none}.p-datatable .p-row-editor-init,.p-datatable .p-row-editor-save,.p-datatable .p-row-editor-cancel,.p-datatable .p-row-toggler{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-datatable-reorder-indicator-up,.p-datatable-reorder-indicator-down{position:absolute}.p-datatable-reorderablerow-handle,[pReorderableColumn]{cursor:move}.p-datatable .p-datatable-loading-overlay{position:absolute;display:flex;align-items:center;justify-content:center;z-index:3}.p-column-filter-row{display:flex;align-items:center;width:100%}.p-column-filter-menu{display:inline-flex}.p-column-filter-row .p-inputtext,.p-column-filter-row .p-fluid .p-calendar .p-inputtext{width:auto}}.p-column-filter-menu-button,.p-column-filter-clear-button{display:inline-flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;overflow:hidden;position:relative}.p-column-filter-overlay{position:absolute;top:0;left:0}.p-column-filter-row-items{margin:0;padding:0;list-style:none}.p-column-filter-row-item{cursor:pointer}.p-column-filter-add-button,.p-column-filter-remove-button{justify-content:center}.p-column-filter-add-button .p-button-label,.p-column-filter-remove-button .p-button-label{flex-grow:0}.p-column-filter-buttonbar{display:flex;align-items:center;justify-content:space-between}.p-column-filter-buttonbar .p-button{width:auto}.p-datatable-tbody>tr>td>.p-column-title{display:none}.p-datatable-scroller-spacer{display:flex}.p-datatable .p-scroller .p-scroller-loading{transform:none!important;min-height:0;position:sticky;top:0;left:0}\n"], dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgStyle), selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i0.forwardRef(() => Paginator), selector: "p-paginator", inputs: ["pageLinkSize", "style", "styleClass", "alwaysShow", "dropdownAppendTo", "templateLeft", "templateRight", "appendTo", "dropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showFirstLastIcon", "totalRecords", "rows", "rowsPerPageOptions", "showJumpToPageDropdown", "showJumpToPageInput", "showPageLinks", "locale", "dropdownItemTemplate", "first"], outputs: ["onPageChange"] }, { kind: "directive", type: i0.forwardRef(() => i1$1.PrimeTemplate), selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i0.forwardRef(() => i4$1.Scroller), selector: "p-scroller", inputs: ["id", "style", "styleClass", "tabindex", "items", "itemSize", "scrollHeight", "scrollWidth", "orientation", "step", "delay", "resizeDelay", "appendOnly", "inline", "lazy", "disabled", "loaderDisabled", "columns", "showSpacer", "showLoader", "numToleratedItems", "loading", "autoSize", "trackBy", "options"], outputs: ["onLazyLoad", "onScroll", "onScrollIndexChange"] }, { kind: "component", type: i0.forwardRef(() => ArrowDownIcon), selector: "ArrowDownIcon" }, { kind: "component", type: i0.forwardRef(() => ArrowUpIcon), selector: "ArrowUpIcon" }, { kind: "component", type: i0.forwardRef(() => SpinnerIcon), selector: "SpinnerIcon" }, { kind: "component", type: i0.forwardRef(() => TableBody), selector: "[pTableBody]", inputs: ["pTableBody", "pTableBodyTemplate", "value", "frozen", "frozenRows", "scrollerOptions"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Table, decorators: [{
            type: Component,
            args: [{ selector: 'p-table', providers: [TableService], changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, host: {
                        class: 'p-element'
                    }, template: "<div #container\r\n     [ngStyle]=\"style\"\r\n     [class]=\"styleClass\"\r\n     [ngClass]=\"{ 'p-datatable p-component': true, 'p-datatable-hoverable-rows': rowHover || selectionMode, 'p-datatable-scrollable': scrollable, 'p-datatable-flex-scrollable': scrollable && scrollHeight === 'flex' }\"\r\n     [attr.id]=\"id\">\r\n  <div class=\"p-datatable-loading-overlay p-component-overlay\" *ngIf=\"loading && showLoader\">\r\n    <i *ngIf=\"loadingIcon\" [class]=\"'p-datatable-loading-icon ' + loadingIcon\"></i>\r\n    <ng-container *ngIf=\"!loadingIcon\">\r\n      <SpinnerIcon *ngIf=\"!loadingIconTemplate\" [spin]=\"true\" [styleClass]=\"'p-datatable-loading-icon'\" />\r\n      <span *ngIf=\"loadingIconTemplate\" class=\"p-datatable-loading-icon\">\r\n        <ng-template *ngTemplateOutlet=\"loadingIconTemplate\"></ng-template>\r\n      </span>\r\n    </ng-container>\r\n  </div>\r\n  <div *ngIf=\"captionTemplate\" class=\"p-datatable-header\">\r\n    <ng-container *ngTemplateOutlet=\"captionTemplate\"></ng-container>\r\n  </div>\r\n  <p-paginator [rows]=\"rows\"\r\n               [first]=\"first\"\r\n               [totalRecords]=\"totalRecords\"\r\n               [pageLinkSize]=\"pageLinks\"\r\n               styleClass=\"p-paginator-top\"\r\n               [alwaysShow]=\"alwaysShowPaginator\"\r\n               (onPageChange)=\"onPageChange($event)\"\r\n               [rowsPerPageOptions]=\"rowsPerPageOptions\"\r\n               *ngIf=\"paginator && (paginatorPosition === 'top' || paginatorPosition == 'both')\"\r\n               [templateLeft]=\"paginatorLeftTemplate\"\r\n               [templateRight]=\"paginatorRightTemplate\"\r\n               [dropdownAppendTo]=\"paginatorDropdownAppendTo\"\r\n               [dropdownScrollHeight]=\"paginatorDropdownScrollHeight\"\r\n               [currentPageReportTemplate]=\"currentPageReportTemplate\"\r\n               [showFirstLastIcon]=\"showFirstLastIcon\"\r\n               [dropdownItemTemplate]=\"paginatorDropdownItemTemplate\"\r\n               [showCurrentPageReport]=\"showCurrentPageReport\"\r\n               [showJumpToPageDropdown]=\"showJumpToPageDropdown\"\r\n               [showJumpToPageInput]=\"showJumpToPageInput\"\r\n               [showPageLinks]=\"showPageLinks\"\r\n               [styleClass]=\"paginatorStyleClass\"\r\n               [locale]=\"paginatorLocale\">\r\n    <ng-template pTemplate=\"firstpagelinkicon\" *ngIf=\"paginatorFirstPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorFirstPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"previouspagelinkicon\" *ngIf=\"paginatorPreviousPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorPreviousPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"lastpagelinkicon\" *ngIf=\"paginatorLastPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorLastPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"nextpagelinkicon\" *ngIf=\"paginatorNextPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorNextPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n  </p-paginator>\r\n\r\n  <div #wrapper class=\"p-datatable-wrapper\" [ngStyle]=\"{ maxHeight: virtualScroll ? '' : scrollHeight }\">\r\n    <p-scroller #scroller\r\n                *ngIf=\"virtualScroll\"\r\n                [items]=\"processedData\"\r\n                [columns]=\"columns\"\r\n                [style]=\"{ height: scrollHeight !== 'flex' ? scrollHeight : undefined }\"\r\n                [scrollHeight]=\"scrollHeight !== 'flex' ? undefined : '100%'\"\r\n                [itemSize]=\"virtualScrollItemSize || _virtualRowHeight\"\r\n                [step]=\"rows\"\r\n                [delay]=\"lazy ? virtualScrollDelay : 0\"\r\n                [inline]=\"true\"\r\n                [lazy]=\"lazy\"\r\n                (onLazyLoad)=\"onLazyItemLoad($event)\"\r\n                [loaderDisabled]=\"true\"\r\n                [showSpacer]=\"false\"\r\n                [showLoader]=\"loadingBodyTemplate\"\r\n                [options]=\"virtualScrollOptions\"\r\n                [autoSize]=\"true\">\r\n      <ng-template pTemplate=\"content\" let-items let-scrollerOptions=\"options\">\r\n        <ng-container *ngTemplateOutlet=\"buildInTable; context: { $implicit: items, options: scrollerOptions }\"></ng-container>\r\n      </ng-template>\r\n    </p-scroller>\r\n    <ng-container *ngIf=\"!virtualScroll\">\r\n      <ng-container *ngTemplateOutlet=\"buildInTable; context: { $implicit: processedData, options: { columns } }\"></ng-container>\r\n    </ng-container>\r\n\r\n    <ng-template #buildInTable let-items let-scrollerOptions=\"options\">\r\n      <table #table\r\n             role=\"table\"\r\n             [ngClass]=\"{ 'p-datatable-table': true, 'p-datatable-scrollable-table': scrollable, 'p-datatable-resizable-table': resizableColumns, 'p-datatable-resizable-table-fit': resizableColumns && columnResizeMode === 'fit' }\"\r\n             [class]=\"tableStyleClass\"\r\n             [style]=\"tableStyle\"\r\n             [attr.id]=\"id + '-table'\">\r\n        <ng-container *ngTemplateOutlet=\"colGroupTemplate; context: { $implicit: scrollerOptions.columns }\"></ng-container>\r\n        <thead role=\"rowgroup\" #thead class=\"p-datatable-thead\">\r\n          <ng-container *ngTemplateOutlet=\"headerGroupedTemplate || headerTemplate; context: { $implicit: scrollerOptions.columns }\"></ng-container>\r\n        </thead>\r\n        <tbody role=\"rowgroup\"\r\n               class=\"p-datatable-tbody p-datatable-frozen-tbody\"\r\n               *ngIf=\"frozenValue || frozenBodyTemplate\"\r\n               [value]=\"frozenValue\"\r\n               [frozenRows]=\"true\"\r\n               [pTableBody]=\"scrollerOptions.columns\"\r\n               [pTableBodyTemplate]=\"frozenBodyTemplate\"\r\n               [frozen]=\"true\"></tbody>\r\n        <tbody role=\"rowgroup\"\r\n               class=\"p-datatable-tbody\"\r\n               [ngClass]=\"scrollerOptions.contentStyleClass\"\r\n               [style]=\"scrollerOptions.contentStyle\"\r\n               [value]=\"dataToRender(scrollerOptions.rows)\"\r\n               [pTableBody]=\"scrollerOptions.columns\"\r\n               [pTableBodyTemplate]=\"bodyTemplate\"\r\n               [scrollerOptions]=\"scrollerOptions\"></tbody>\r\n        <tbody role=\"rowgroup\"\r\n               *ngIf=\"scrollerOptions.spacerStyle\"\r\n               [style]=\"'height: calc(' + scrollerOptions.spacerStyle.height + ' - ' + scrollerOptions.rows.length * scrollerOptions.itemSize + 'px);'\"\r\n               class=\"p-datatable-scroller-spacer\"></tbody>\r\n        <tfoot role=\"rowgroup\" *ngIf=\"footerGroupedTemplate || footerTemplate\" #tfoot class=\"p-datatable-tfoot\">\r\n          <ng-container *ngTemplateOutlet=\"footerGroupedTemplate || footerTemplate; context: { $implicit: scrollerOptions.columns }\"></ng-container>\r\n        </tfoot>\r\n      </table>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <p-paginator [rows]=\"rows\"\r\n               [first]=\"first\"\r\n               [totalRecords]=\"totalRecords\"\r\n               [pageLinkSize]=\"pageLinks\"\r\n               styleClass=\"p-paginator-bottom\"\r\n               [alwaysShow]=\"alwaysShowPaginator\"\r\n               (onPageChange)=\"onPageChange($event)\"\r\n               [rowsPerPageOptions]=\"rowsPerPageOptions\"\r\n               *ngIf=\"paginator && (paginatorPosition === 'bottom' || paginatorPosition == 'both')\"\r\n               [templateLeft]=\"paginatorLeftTemplate\"\r\n               [templateRight]=\"paginatorRightTemplate\"\r\n               [dropdownAppendTo]=\"paginatorDropdownAppendTo\"\r\n               [dropdownScrollHeight]=\"paginatorDropdownScrollHeight\"\r\n               [currentPageReportTemplate]=\"currentPageReportTemplate\"\r\n               [showFirstLastIcon]=\"showFirstLastIcon\"\r\n               [dropdownItemTemplate]=\"paginatorDropdownItemTemplate\"\r\n               [showCurrentPageReport]=\"showCurrentPageReport\"\r\n               [showJumpToPageDropdown]=\"showJumpToPageDropdown\"\r\n               [showJumpToPageInput]=\"showJumpToPageInput\"\r\n               [showPageLinks]=\"showPageLinks\"\r\n               [styleClass]=\"paginatorStyleClass\"\r\n               [locale]=\"paginatorLocale\">\r\n    <ng-template pTemplate=\"firstpagelinkicon\" *ngIf=\"paginatorFirstPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorFirstPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"previouspagelinkicon\" *ngIf=\"paginatorPreviousPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorPreviousPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"lastpagelinkicon\" *ngIf=\"paginatorLastPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorLastPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template pTemplate=\"nextpagelinkicon\" *ngIf=\"paginatorNextPageLinkIconTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"paginatorNextPageLinkIconTemplate\"></ng-container>\r\n    </ng-template>\r\n  </p-paginator>\r\n\r\n  <div *ngIf=\"summaryTemplate\" class=\"p-datatable-footer\">\r\n    <ng-container *ngTemplateOutlet=\"summaryTemplate\"></ng-container>\r\n  </div>\r\n\r\n  <div #resizeHelper class=\"p-column-resizer-helper\" style=\"display:none\" *ngIf=\"resizableColumns\"></div>\r\n  <span #reorderIndicatorUp class=\"p-datatable-reorder-indicator-up\" style=\"display: none;\" *ngIf=\"reorderableColumns\">\r\n    <ArrowDownIcon *ngIf=\"!reorderIndicatorUpIconTemplate\" />\r\n    <ng-template *ngTemplateOutlet=\"reorderIndicatorUpIconTemplate\"></ng-template>\r\n  </span>\r\n  <span #reorderIndicatorDown class=\"p-datatable-reorder-indicator-down\" style=\"display: none;\" *ngIf=\"reorderableColumns\">\r\n    <ArrowUpIcon *ngIf=\"!reorderIndicatorDownIconTemplate\" />\r\n    <ng-template *ngTemplateOutlet=\"reorderIndicatorDownIconTemplate\"></ng-template>\r\n  </span>\r\n</div>\r\n", styles: ["@layer primeng{.p-datatable{position:relative}.p-datatable>.p-datatable-wrapper{overflow:auto}.p-datatable-table{border-spacing:0px;width:100%}.p-datatable .p-sortable-column{cursor:pointer;-webkit-user-select:none;user-select:none}.p-datatable .p-sortable-column .p-column-title,.p-datatable .p-sortable-column .p-sortable-column-icon,.p-datatable .p-sortable-column .p-sortable-column-badge{vertical-align:middle}.p-datatable .p-sortable-column .p-icon-wrapper{display:inline}.p-datatable .p-sortable-column .p-sortable-column-badge{display:inline-flex;align-items:center;justify-content:center}.p-datatable-hoverable-rows .p-selectable-row{cursor:pointer}.p-datatable-scrollable>.p-datatable-wrapper{position:relative}.p-datatable-scrollable-table>.p-datatable-thead{position:sticky;top:0;z-index:2}.p-datatable-scrollable-table>.p-datatable-frozen-tbody{position:sticky;z-index:1}.p-datatable-scrollable-table>.p-datatable-tfoot{position:sticky;bottom:0;z-index:1}.p-datatable-scrollable .p-frozen-column{position:sticky;background:inherit;z-index:1}.p-datatable-scrollable th.p-frozen-column{z-index:1}.p-datatable-flex-scrollable{display:flex;flex-direction:column;height:100%}.p-datatable-flex-scrollable>.p-datatable-wrapper{display:flex;flex-direction:column;flex:1;height:100%}.p-datatable-scrollable-table>.p-datatable-tbody>.p-rowgroup-header{position:sticky;z-index:2}.p-datatable-resizable-table>.p-datatable-thead>tr>th,.p-datatable-resizable-table>.p-datatable-tfoot>tr>td,.p-datatable-resizable-table>.p-datatable-tbody>tr>td{overflow:hidden;white-space:nowrap}.p-datatable-resizable-table>.p-datatable-thead>tr>th.p-resizable-column:not(.p-frozen-column){background-clip:padding-box;position:relative}.p-datatable-resizable-table-fit>.p-datatable-thead>tr>th.p-resizable-column:last-child .p-column-resizer{display:none}.p-datatable .p-column-resizer{display:block;position:absolute!important;top:0;right:0;margin:0;width:.5rem;height:100%;padding:0;cursor:col-resize;border:1px solid transparent}.p-datatable .p-column-resizer-helper{width:1px;position:absolute;z-index:10;display:none}.p-datatable .p-row-editor-init,.p-datatable .p-row-editor-save,.p-datatable .p-row-editor-cancel,.p-datatable .p-row-toggler{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-datatable-reorder-indicator-up,.p-datatable-reorder-indicator-down{position:absolute}.p-datatable-reorderablerow-handle,[pReorderableColumn]{cursor:move}.p-datatable .p-datatable-loading-overlay{position:absolute;display:flex;align-items:center;justify-content:center;z-index:3}.p-column-filter-row{display:flex;align-items:center;width:100%}.p-column-filter-menu{display:inline-flex}.p-column-filter-row .p-inputtext,.p-column-filter-row .p-fluid .p-calendar .p-inputtext{width:auto}}.p-column-filter-menu-button,.p-column-filter-clear-button{display:inline-flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;overflow:hidden;position:relative}.p-column-filter-overlay{position:absolute;top:0;left:0}.p-column-filter-row-items{margin:0;padding:0;list-style:none}.p-column-filter-row-item{cursor:pointer}.p-column-filter-add-button,.p-column-filter-remove-button{justify-content:center}.p-column-filter-add-button .p-button-label,.p-column-filter-remove-button .p-button-label{flex-grow:0}.p-column-filter-buttonbar{display:flex;align-items:center;justify-content:space-between}.p-column-filter-buttonbar .p-button{width:auto}.p-datatable-tbody>tr>td>.p-column-title{display:none}.p-datatable-scroller-spacer{display:flex}.p-datatable .p-scroller .p-scroller-loading{transform:none!important;min-height:0;position:sticky;top:0;left:0}\n"] }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: TableService }, { type: i0.ChangeDetectorRef }, { type: i1$1.FilterService }, { type: i1$1.OverlayService }, { type: i1$1.PrimeNGConfig }], propDecorators: { frozenColumns: [{
                type: Input
            }], frozenValue: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], tableStyle: [{
                type: Input
            }], tableStyleClass: [{
                type: Input
            }], paginator: [{
                type: Input
            }], pageLinks: [{
                type: Input
            }], rowsPerPageOptions: [{
                type: Input
            }], alwaysShowPaginator: [{
                type: Input
            }], paginatorPosition: [{
                type: Input
            }], paginatorStyleClass: [{
                type: Input
            }], paginatorDropdownAppendTo: [{
                type: Input
            }], paginatorDropdownScrollHeight: [{
                type: Input
            }], currentPageReportTemplate: [{
                type: Input
            }], showCurrentPageReport: [{
                type: Input
            }], showJumpToPageDropdown: [{
                type: Input
            }], showJumpToPageInput: [{
                type: Input
            }], showFirstLastIcon: [{
                type: Input
            }], showPageLinks: [{
                type: Input
            }], defaultSortOrder: [{
                type: Input
            }], sortMode: [{
                type: Input
            }], resetPageOnSort: [{
                type: Input
            }], selectionMode: [{
                type: Input
            }], selectionPageOnly: [{
                type: Input
            }], contextMenuSelection: [{
                type: Input
            }], contextMenuSelectionChange: [{
                type: Output
            }], contextMenuSelectionMode: [{
                type: Input
            }], dataKey: [{
                type: Input
            }], metaKeySelection: [{
                type: Input
            }], rowSelectable: [{
                type: Input
            }], rowTrackBy: [{
                type: Input
            }], lazy: [{
                type: Input
            }], lazyLoadOnInit: [{
                type: Input
            }], compareSelectionBy: [{
                type: Input
            }], csvSeparator: [{
                type: Input
            }], exportFilename: [{
                type: Input
            }], filters: [{
                type: Input
            }], globalFilterFields: [{
                type: Input
            }], filterDelay: [{
                type: Input
            }], filterLocale: [{
                type: Input
            }], expandedRowKeys: [{
                type: Input
            }], editingRowKeys: [{
                type: Input
            }], rowExpandMode: [{
                type: Input
            }], scrollable: [{
                type: Input
            }], scrollDirection: [{
                type: Input
            }], rowGroupMode: [{
                type: Input
            }], scrollHeight: [{
                type: Input
            }], virtualScroll: [{
                type: Input
            }], virtualScrollItemSize: [{
                type: Input
            }], virtualScrollOptions: [{
                type: Input
            }], virtualScrollDelay: [{
                type: Input
            }], frozenWidth: [{
                type: Input
            }], responsive: [{
                type: Input
            }], contextMenu: [{
                type: Input
            }], resizableColumns: [{
                type: Input
            }], columnResizeMode: [{
                type: Input
            }], reorderableColumns: [{
                type: Input
            }], loading: [{
                type: Input
            }], loadingIcon: [{
                type: Input
            }], showLoader: [{
                type: Input
            }], rowHover: [{
                type: Input
            }], customSort: [{
                type: Input
            }], showInitialSortBadge: [{
                type: Input
            }], autoLayout: [{
                type: Input
            }], exportFunction: [{
                type: Input
            }], exportHeader: [{
                type: Input
            }], stateKey: [{
                type: Input
            }], stateStorage: [{
                type: Input
            }], editMode: [{
                type: Input
            }], groupRowsBy: [{
                type: Input
            }], groupRowsByOrder: [{
                type: Input
            }], responsiveLayout: [{
                type: Input
            }], breakpoint: [{
                type: Input
            }], paginatorLocale: [{
                type: Input
            }], value: [{
                type: Input
            }], columns: [{
                type: Input
            }], first: [{
                type: Input
            }], rows: [{
                type: Input
            }], totalRecords: [{
                type: Input
            }], sortField: [{
                type: Input
            }], sortOrder: [{
                type: Input
            }], multiSortMeta: [{
                type: Input
            }], selection: [{
                type: Input
            }], selectAll: [{
                type: Input
            }], selectAllChange: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], onRowSelect: [{
                type: Output
            }], onRowUnselect: [{
                type: Output
            }], onPage: [{
                type: Output
            }], onSort: [{
                type: Output
            }], onFilter: [{
                type: Output
            }], onLazyLoad: [{
                type: Output
            }], onRowExpand: [{
                type: Output
            }], onRowCollapse: [{
                type: Output
            }], onContextMenuSelect: [{
                type: Output
            }], onColResize: [{
                type: Output
            }], onColReorder: [{
                type: Output
            }], onRowReorder: [{
                type: Output
            }], onEditInit: [{
                type: Output
            }], onEditComplete: [{
                type: Output
            }], onEditCancel: [{
                type: Output
            }], onHeaderCheckboxToggle: [{
                type: Output
            }], sortFunction: [{
                type: Output
            }], firstChange: [{
                type: Output
            }], rowsChange: [{
                type: Output
            }], onStateSave: [{
                type: Output
            }], onStateRestore: [{
                type: Output
            }], containerViewChild: [{
                type: ViewChild,
                args: ['container']
            }], resizeHelperViewChild: [{
                type: ViewChild,
                args: ['resizeHelper']
            }], reorderIndicatorUpViewChild: [{
                type: ViewChild,
                args: ['reorderIndicatorUp']
            }], reorderIndicatorDownViewChild: [{
                type: ViewChild,
                args: ['reorderIndicatorDown']
            }], wrapperViewChild: [{
                type: ViewChild,
                args: ['wrapper']
            }], tableViewChild: [{
                type: ViewChild,
                args: ['table']
            }], tableHeaderViewChild: [{
                type: ViewChild,
                args: ['thead']
            }], tableFooterViewChild: [{
                type: ViewChild,
                args: ['tfoot']
            }], scroller: [{
                type: ViewChild,
                args: ['scroller']
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }], virtualRowHeight: [{
                type: Input
            }] } });
class TableBody {
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        if (this.frozenRows) {
            this.updateFrozenRowStickyPosition();
        }
        if (this.dt.scrollable && this.dt.rowGroupMode === 'subheader') {
            this.updateFrozenRowGroupHeaderStickyPosition();
        }
    }
    ngAfterViewInit() {
        if (this.frozenRows) {
            this.updateFrozenRowStickyPosition();
        }
        if (this.dt.scrollable && this.dt.rowGroupMode === 'subheader') {
            this.updateFrozenRowGroupHeaderStickyPosition();
        }
    }
    constructor(dt, tableService, cd, el) {
        this.dt = dt;
        this.tableService = tableService;
        this.cd = cd;
        this.el = el;
        this.subscription = this.dt.tableService.valueSource$.subscribe(() => {
            if (this.dt.virtualScroll) {
                this.cd.detectChanges();
            }
        });
    }
    shouldRenderRowGroupHeader(value, rowData, i) {
        let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
        let prevRowData = value[i - 1];
        if (prevRowData) {
            let previousRowFieldData = ObjectUtils.resolveFieldData(prevRowData, this.dt.groupRowsBy);
            return currentRowFieldData !== previousRowFieldData;
        }
        else {
            return true;
        }
    }
    shouldRenderRowGroupFooter(value, rowData, i) {
        let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
        let nextRowData = value[i + 1];
        if (nextRowData) {
            let nextRowFieldData = ObjectUtils.resolveFieldData(nextRowData, this.dt.groupRowsBy);
            return currentRowFieldData !== nextRowFieldData;
        }
        else {
            return true;
        }
    }
    shouldRenderRowspan(value, rowData, i) {
        let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
        let prevRowData = value[i - 1];
        if (prevRowData) {
            let previousRowFieldData = ObjectUtils.resolveFieldData(prevRowData, this.dt.groupRowsBy);
            return currentRowFieldData !== previousRowFieldData;
        }
        else {
            return true;
        }
    }
    calculateRowGroupSize(value, rowData, index) {
        let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
        let nextRowFieldData = currentRowFieldData;
        let groupRowSpan = 0;
        while (currentRowFieldData === nextRowFieldData) {
            groupRowSpan++;
            let nextRowData = value[++index];
            if (nextRowData) {
                nextRowFieldData = ObjectUtils.resolveFieldData(nextRowData, this.dt.groupRowsBy);
            }
            else {
                break;
            }
        }
        return groupRowSpan === 1 ? null : groupRowSpan;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    updateFrozenRowStickyPosition() {
        this.el.nativeElement.style.top = DomHandler.getOuterHeight(this.el.nativeElement.previousElementSibling) + 'px';
    }
    updateFrozenRowGroupHeaderStickyPosition() {
        if (this.el.nativeElement.previousElementSibling) {
            let tableHeaderHeight = DomHandler.getOuterHeight(this.el.nativeElement.previousElementSibling);
            this.dt.rowGroupHeaderStyleObject.top = tableHeaderHeight + 'px';
        }
    }
    getScrollerOption(option, options) {
        if (this.dt.virtualScroll) {
            options = options || this.scrollerOptions;
            return options ? options[option] : null;
        }
        return null;
    }
    getRowIndex(rowIndex) {
        const index = this.dt.paginator ? this.dt.first + rowIndex : rowIndex;
        const getItemOptions = this.getScrollerOption('getItemOptions');
        return getItemOptions ? getItemOptions(index).index : index;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableBody, deps: [{ token: Table }, { token: TableService }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableBody, selector: "[pTableBody]", inputs: { columns: ["pTableBody", "columns"], template: ["pTableBodyTemplate", "template"], value: "value", frozen: "frozen", frozenRows: "frozenRows", scrollerOptions: "scrollerOptions" }, host: { classAttribute: "p-element" }, ngImport: i0, template: `
        <ng-container *ngIf="!dt.expandedRowTemplate">
            <ng-template ngFor let-rowData let-rowIndex="index" [ngForOf]="value" [ngForTrackBy]="dt.rowTrackBy">
                <ng-container *ngIf="dt.groupHeaderTemplate && !dt.virtualScroll && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupHeader(value, rowData, rowIndex)" role="row">
                    <ng-container
                        *ngTemplateOutlet="dt.groupHeaderTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.rowGroupMode !== 'rowspan'">
                    <ng-container
                        *ngTemplateOutlet="rowData ? template : dt.loadingBodyTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.rowGroupMode === 'rowspan'">
                    <ng-container
                        *ngTemplateOutlet="
                            rowData ? template : dt.loadingBodyTemplate;
                            context: {
                                $implicit: rowData,
                                rowIndex: getRowIndex(rowIndex),
                                columns: columns,
                                editing: dt.editMode === 'row' && dt.isRowEditing(rowData),
                                frozen: frozen,
                                rowgroup: shouldRenderRowspan(value, rowData, rowIndex),
                                rowspan: calculateRowGroupSize(value, rowData, rowIndex)
                            }
                        "
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.groupFooterTemplate && !dt.virtualScroll && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupFooter(value, rowData, rowIndex)" role="row">
                    <ng-container
                        *ngTemplateOutlet="dt.groupFooterTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
        </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="dt.expandedRowTemplate && !(frozen && dt.frozenExpandedRowTemplate)">
            <ng-template ngFor let-rowData let-rowIndex="index" [ngForOf]="value" [ngForTrackBy]="dt.rowTrackBy">
                <ng-container *ngIf="!dt.groupHeaderTemplate">
                    <ng-container
                        *ngTemplateOutlet="template; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.groupHeaderTemplate && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupHeader(value, rowData, getRowIndex(rowIndex))" role="row">
                    <ng-container
                        *ngTemplateOutlet="
                            dt.groupHeaderTemplate;
                            context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }
                        "
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.isRowExpanded(rowData)">
                    <ng-container *ngTemplateOutlet="dt.expandedRowTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, frozen: frozen }"></ng-container>
                    <ng-container *ngIf="dt.groupFooterTemplate && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupFooter(value, rowData, getRowIndex(rowIndex))" role="row">
                        <ng-container
                            *ngTemplateOutlet="
                                dt.groupFooterTemplate;
                                context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }
                            "
                        ></ng-container>
                    </ng-container>
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="dt.frozenExpandedRowTemplate && frozen">
            <ng-template ngFor let-rowData let-rowIndex="index" [ngForOf]="value" [ngForTrackBy]="dt.rowTrackBy">
                <ng-container
                    *ngTemplateOutlet="template; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                ></ng-container>
                <ng-container *ngIf="dt.isRowExpanded(rowData)">
                    <ng-container *ngTemplateOutlet="dt.frozenExpandedRowTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, frozen: frozen }"></ng-container>
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="dt.loading">
            <ng-container *ngTemplateOutlet="dt.loadingBodyTemplate; context: { $implicit: columns, frozen: frozen }"></ng-container>
        </ng-container>
        <ng-container *ngIf="dt.isEmpty() && !dt.loading">
            <ng-container *ngTemplateOutlet="dt.emptyMessageTemplate; context: { $implicit: columns, frozen: frozen }"></ng-container>
        </ng-container>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableBody, decorators: [{
            type: Component,
            args: [{
                    selector: '[pTableBody]',
                    template: `
        <ng-container *ngIf="!dt.expandedRowTemplate">
            <ng-template ngFor let-rowData let-rowIndex="index" [ngForOf]="value" [ngForTrackBy]="dt.rowTrackBy">
                <ng-container *ngIf="dt.groupHeaderTemplate && !dt.virtualScroll && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupHeader(value, rowData, rowIndex)" role="row">
                    <ng-container
                        *ngTemplateOutlet="dt.groupHeaderTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.rowGroupMode !== 'rowspan'">
                    <ng-container
                        *ngTemplateOutlet="rowData ? template : dt.loadingBodyTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.rowGroupMode === 'rowspan'">
                    <ng-container
                        *ngTemplateOutlet="
                            rowData ? template : dt.loadingBodyTemplate;
                            context: {
                                $implicit: rowData,
                                rowIndex: getRowIndex(rowIndex),
                                columns: columns,
                                editing: dt.editMode === 'row' && dt.isRowEditing(rowData),
                                frozen: frozen,
                                rowgroup: shouldRenderRowspan(value, rowData, rowIndex),
                                rowspan: calculateRowGroupSize(value, rowData, rowIndex)
                            }
                        "
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.groupFooterTemplate && !dt.virtualScroll && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupFooter(value, rowData, rowIndex)" role="row">
                    <ng-container
                        *ngTemplateOutlet="dt.groupFooterTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
        </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="dt.expandedRowTemplate && !(frozen && dt.frozenExpandedRowTemplate)">
            <ng-template ngFor let-rowData let-rowIndex="index" [ngForOf]="value" [ngForTrackBy]="dt.rowTrackBy">
                <ng-container *ngIf="!dt.groupHeaderTemplate">
                    <ng-container
                        *ngTemplateOutlet="template; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.groupHeaderTemplate && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupHeader(value, rowData, getRowIndex(rowIndex))" role="row">
                    <ng-container
                        *ngTemplateOutlet="
                            dt.groupHeaderTemplate;
                            context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }
                        "
                    ></ng-container>
                </ng-container>
                <ng-container *ngIf="dt.isRowExpanded(rowData)">
                    <ng-container *ngTemplateOutlet="dt.expandedRowTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, frozen: frozen }"></ng-container>
                    <ng-container *ngIf="dt.groupFooterTemplate && dt.rowGroupMode === 'subheader' && shouldRenderRowGroupFooter(value, rowData, getRowIndex(rowIndex))" role="row">
                        <ng-container
                            *ngTemplateOutlet="
                                dt.groupFooterTemplate;
                                context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }
                            "
                        ></ng-container>
                    </ng-container>
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="dt.frozenExpandedRowTemplate && frozen">
            <ng-template ngFor let-rowData let-rowIndex="index" [ngForOf]="value" [ngForTrackBy]="dt.rowTrackBy">
                <ng-container
                    *ngTemplateOutlet="template; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, expanded: dt.isRowExpanded(rowData), editing: dt.editMode === 'row' && dt.isRowEditing(rowData), frozen: frozen }"
                ></ng-container>
                <ng-container *ngIf="dt.isRowExpanded(rowData)">
                    <ng-container *ngTemplateOutlet="dt.frozenExpandedRowTemplate; context: { $implicit: rowData, rowIndex: getRowIndex(rowIndex), columns: columns, frozen: frozen }"></ng-container>
                </ng-container>
            </ng-template>
        </ng-container>
        <ng-container *ngIf="dt.loading">
            <ng-container *ngTemplateOutlet="dt.loadingBodyTemplate; context: { $implicit: columns, frozen: frozen }"></ng-container>
        </ng-container>
        <ng-container *ngIf="dt.isEmpty() && !dt.loading">
            <ng-container *ngTemplateOutlet="dt.emptyMessageTemplate; context: { $implicit: columns, frozen: frozen }"></ng-container>
        </ng-container>
    `,
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: TableService }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }], propDecorators: { columns: [{
                type: Input,
                args: ['pTableBody']
            }], template: [{
                type: Input,
                args: ['pTableBodyTemplate']
            }], value: [{
                type: Input
            }], frozen: [{
                type: Input
            }], frozenRows: [{
                type: Input
            }], scrollerOptions: [{
                type: Input
            }] } });
class RowGroupHeader {
    constructor(dt) {
        this.dt = dt;
    }
    get getFrozenRowGroupHeaderStickyPosition() {
        return this.dt.rowGroupHeaderStyleObject ? this.dt.rowGroupHeaderStyleObject.top : '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RowGroupHeader, deps: [{ token: Table }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: RowGroupHeader, selector: "[pRowGroupHeader]", host: { properties: { "style.top": "getFrozenRowGroupHeaderStickyPosition" }, classAttribute: "p-rowgroup-header p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RowGroupHeader, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pRowGroupHeader]',
                    host: {
                        class: 'p-rowgroup-header p-element',
                        '[style.top]': 'getFrozenRowGroupHeaderStickyPosition'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }] });
class FrozenColumn {
    get frozen() {
        return this._frozen;
    }
    set frozen(val) {
        this._frozen = val;
        Promise.resolve(null).then(() => this.updateStickyPosition());
    }
    constructor(el) {
        this.el = el;
        this.alignFrozen = 'left';
        this._frozen = true;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.updateStickyPosition();
        }, 1000);
    }
    updateStickyPosition() {
        if (this._frozen) {
            if (this.alignFrozen === 'right') {
                let right = 0;
                let next = this.el.nativeElement.nextElementSibling;
                if (next) {
                    right = DomHandler.getOuterWidth(next) + (parseFloat(next.style.right) || 0);
                }
                this.el.nativeElement.style.right = right + 'px';
            }
            else {
                let left = 0;
                let prev = this.el.nativeElement.previousElementSibling;
                if (prev) {
                    left = DomHandler.getOuterWidth(prev) + (parseFloat(prev.style.left) || 0);
                }
                this.el.nativeElement.style.left = left + 'px';
            }
            const filterRow = this.el.nativeElement?.parentElement?.nextElementSibling;
            if (filterRow) {
                let index = DomHandler.index(this.el.nativeElement);
                if (filterRow.children && filterRow.children[index]) {
                    filterRow.children[index].style.left = this.el.nativeElement.style.left;
                    filterRow.children[index].style.right = this.el.nativeElement.style.right;
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenColumn, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FrozenColumn, selector: "[pFrozenColumn]", inputs: { frozen: "frozen", alignFrozen: "alignFrozen" }, host: { properties: { "class.p-frozen-column": "frozen" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FrozenColumn, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pFrozenColumn]',
                    host: {
                        class: 'p-element',
                        '[class.p-frozen-column]': 'frozen'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { frozen: [{
                type: Input
            }], alignFrozen: [{
                type: Input
            }] } });
class SortableColumn {
    constructor(dt) {
        this.dt = dt;
        if (this.isEnabled()) {
            this.subscription = this.dt.tableService.sortSource$.subscribe((sortMeta) => {
                this.updateSortState();
            });
        }
    }
    ngOnInit() {
        if (this.isEnabled()) {
            this.updateSortState();
        }
    }
    updateSortState() {
        this.sorted = this.dt.isSorted(this.field);
        this.sortOrder = this.sorted ? (this.dt.sortOrder === 1 ? 'ascending' : 'descending') : 'none';
    }
    onClick(event) {
        if (this.isEnabled() && !this.isFilterElement(event.target)) {
            this.updateSortState();
            this.dt.sort({
                originalEvent: event,
                field: this.field
            });
            DomHandler.clearSelection();
        }
    }
    onEnterKey(event) {
        this.onClick(event);
        event.preventDefault();
    }
    isEnabled() {
        return this.pSortableColumnDisabled !== true;
    }
    isFilterElement(element) {
        return this.isFilterElementIconOrButton(element) || this.isFilterElementIconOrButton(element?.parentElement?.parentElement);
    }
    isFilterElementIconOrButton(element) {
        return DomHandler.hasClass(element, 'pi-filter-icon') || DomHandler.hasClass(element, 'p-column-filter-menu-button');
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableColumn, deps: [{ token: Table }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SortableColumn, selector: "[pSortableColumn]", inputs: { field: ["pSortableColumn", "field"], pSortableColumnDisabled: "pSortableColumnDisabled" }, host: { listeners: { "click": "onClick($event)", "keydown.space": "onEnterKey($event)", "keydown.enter": "onEnterKey($event)" }, properties: { "class.p-sortable-column": "isEnabled()", "class.p-highlight": "sorted", "attr.tabindex": "isEnabled() ? \"0\" : null", "attr.role": "\"columnheader\"", "attr.aria-sort": "sortOrder" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortableColumn, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pSortableColumn]',
                    host: {
                        class: 'p-element',
                        '[class.p-sortable-column]': 'isEnabled()',
                        '[class.p-highlight]': 'sorted',
                        '[attr.tabindex]': 'isEnabled() ? "0" : null',
                        '[attr.role]': '"columnheader"',
                        '[attr.aria-sort]': 'sortOrder'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }], propDecorators: { field: [{
                type: Input,
                args: ['pSortableColumn']
            }], pSortableColumnDisabled: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onEnterKey: [{
                type: HostListener,
                args: ['keydown.space', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }] } });
class SortIcon {
    constructor(dt, cd) {
        this.dt = dt;
        this.cd = cd;
        this.subscription = this.dt.tableService.sortSource$.subscribe((sortMeta) => {
            this.updateSortState();
        });
    }
    ngOnInit() {
        this.updateSortState();
    }
    onClick(event) {
        event.preventDefault();
    }
    updateSortState() {
        if (this.dt.sortMode === 'single') {
            this.sortOrder = this.dt.isSorted(this.field) ? this.dt.sortOrder : 0;
        }
        else if (this.dt.sortMode === 'multiple') {
            let sortMeta = this.dt.getSortMeta(this.field);
            this.sortOrder = sortMeta ? sortMeta.order : 0;
        }
        this.cd.markForCheck();
    }
    getMultiSortMetaIndex() {
        let multiSortMeta = this.dt._multiSortMeta;
        let index = -1;
        if (multiSortMeta && this.dt.sortMode === 'multiple' && this.dt.showInitialSortBadge && multiSortMeta.length > 1) {
            for (let i = 0; i < multiSortMeta.length; i++) {
                let meta = multiSortMeta[i];
                if (meta.field === this.field || meta.field === this.field) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }
    getBadgeValue() {
        let index = this.getMultiSortMetaIndex();
        return this.dt.groupRowsBy && index > -1 ? index : index + 1;
    }
    isMultiSorted() {
        return this.dt.sortMode === 'multiple' && this.getMultiSortMetaIndex() > -1;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortIcon, deps: [{ token: Table }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SortIcon, selector: "p-sortIcon", inputs: { field: "field" }, host: { classAttribute: "p-element" }, ngImport: i0, template: `
        <ng-container *ngIf="!dt.sortIconTemplate">
            <SortAltIcon [styleClass]="'p-sortable-column-icon'" *ngIf="sortOrder === 0" />
            <SortAmountUpAltIcon [styleClass]="'p-sortable-column-icon'" *ngIf="sortOrder === 1" />
            <SortAmountDownIcon [styleClass]="'p-sortable-column-icon'" *ngIf="sortOrder === -1" />
        </ng-container>
        <span *ngIf="dt.sortIconTemplate" class="p-sortable-column-icon">
            <ng-template *ngTemplateOutlet="dt.sortIconTemplate; context: { $implicit: sortOrder }"></ng-template>
        </span>
        <span *ngIf="isMultiSorted()" class="p-sortable-column-badge">{{ getBadgeValue() }}</span>
    `, isInline: true, dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i0.forwardRef(() => SortAltIcon), selector: "SortAltIcon" }, { kind: "component", type: i0.forwardRef(() => SortAmountUpAltIcon), selector: "SortAmountUpAltIcon" }, { kind: "component", type: i0.forwardRef(() => SortAmountDownIcon), selector: "SortAmountDownIcon" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SortIcon, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-sortIcon',
                    template: `
        <ng-container *ngIf="!dt.sortIconTemplate">
            <SortAltIcon [styleClass]="'p-sortable-column-icon'" *ngIf="sortOrder === 0" />
            <SortAmountUpAltIcon [styleClass]="'p-sortable-column-icon'" *ngIf="sortOrder === 1" />
            <SortAmountDownIcon [styleClass]="'p-sortable-column-icon'" *ngIf="sortOrder === -1" />
        </ng-container>
        <span *ngIf="dt.sortIconTemplate" class="p-sortable-column-icon">
            <ng-template *ngTemplateOutlet="dt.sortIconTemplate; context: { $implicit: sortOrder }"></ng-template>
        </span>
        <span *ngIf="isMultiSorted()" class="p-sortable-column-badge">{{ getBadgeValue() }}</span>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        'class': 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: i0.ChangeDetectorRef }], propDecorators: { field: [{
                type: Input
            }] } });
class SelectableRow {
    constructor(dt, tableService, el) {
        this.dt = dt;
        this.tableService = tableService;
        this.el = el;
        if (this.isEnabled()) {
            this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
                this.selected = this.dt.isSelected(this.data);
            });
        }
    }
    setRowTabIndex() {
        if (this.dt.selectionMode === 'single' || this.dt.selectionMode === 'multiple') {
            return !this.dt.selection ? 0 : this.dt.anchorRowIndex === this.index ? 0 : -1;
        }
    }
    ngOnInit() {
        if (this.isEnabled()) {
            this.selected = this.dt.isSelected(this.data);
        }
    }
    onClick(event) {
        if (this.isEnabled()) {
            this.dt.handleRowClick({
                originalEvent: event,
                rowData: this.data,
                rowIndex: this.index
            });
        }
    }
    onTouchEnd(event) {
        if (this.isEnabled()) {
            this.dt.handleRowTouchEnd(event);
        }
    }
    onKeyDown(event) {
        switch (event.code) {
            case 'ArrowDown':
                this.onArrowDownKey(event);
                break;
            case 'ArrowUp':
                this.onArrowUpKey(event);
                break;
            case 'Home':
                this.onHomeKey(event);
                break;
            case 'End':
                this.onEndKey(event);
                break;
            case 'Space':
                this.onSpaceKey(event);
                break;
            case 'Enter':
                this.onEnterKey(event);
                break;
            default:
                if (event.code === 'KeyA' && (event.metaKey || event.ctrlKey)) {
                    const data = this.dt.dataToRender(this.dt.rows);
                    this.dt.selection = [...data];
                    this.dt.selectRange(event, data.length - 1);
                    event.preventDefault();
                }
                break;
        }
    }
    onArrowDownKey(event) {
        if (!this.isEnabled()) {
            return;
        }
        const row = event.currentTarget;
        const nextRow = this.findNextSelectableRow(row);
        if (nextRow) {
            nextRow.focus();
        }
        event.preventDefault();
    }
    onArrowUpKey(event) {
        if (!this.isEnabled()) {
            return;
        }
        const row = event.currentTarget;
        const prevRow = this.findPrevSelectableRow(row);
        if (prevRow) {
            prevRow.focus();
        }
        event.preventDefault();
    }
    onEnterKey(event) {
        if (!this.isEnabled()) {
            return;
        }
        this.dt.handleRowClick({
            originalEvent: event,
            rowData: this.data,
            rowIndex: this.index
        });
    }
    onEndKey(event) {
        const lastRow = this.findLastSelectableRow();
        lastRow && this.focusRowChange(this.el.nativeElement, lastRow);
        if (event.ctrlKey && event.shiftKey) {
            const data = this.dt.dataToRender(this.dt.rows);
            const lastSelectableRowIndex = DomHandler.getAttribute(lastRow, 'index');
            this.dt.anchorRowIndex = lastSelectableRowIndex;
            this.dt.selection = data.slice(this.index, data.length);
            this.dt.selectRange(event, this.index);
        }
        event.preventDefault();
    }
    onHomeKey(event) {
        const firstRow = this.findFirstSelectableRow();
        firstRow && this.focusRowChange(this.el.nativeElement, firstRow);
        if (event.ctrlKey && event.shiftKey) {
            const data = this.dt.dataToRender(this.dt.rows);
            const firstSelectableRowIndex = DomHandler.getAttribute(firstRow, 'index');
            this.dt.anchorRowIndex = this.dt.anchorRowIndex || firstSelectableRowIndex;
            this.dt.selection = data.slice(0, this.index + 1);
            this.dt.selectRange(event, this.index);
        }
        event.preventDefault();
    }
    onSpaceKey(event) {
        this.onEnterKey(event);
        if (event.shiftKey && this.dt.selection !== null) {
            const data = this.dt.dataToRender(this.dt.rows);
            let index;
            if (ObjectUtils.isNotEmpty(this.dt.selection) && this.dt.selection.length > 0) {
                let firstSelectedRowIndex, lastSelectedRowIndex;
                firstSelectedRowIndex = ObjectUtils.findIndexInList(this.dt.selection[0], data);
                lastSelectedRowIndex = ObjectUtils.findIndexInList(this.dt.selection[this.dt.selection.length - 1], data);
                index = this.index <= firstSelectedRowIndex ? lastSelectedRowIndex : firstSelectedRowIndex;
            }
            else {
                index = ObjectUtils.findIndexInList(this.dt.selection, data);
            }
            this.dt.anchorRowIndex = index;
            this.dt.selection = index !== this.index ? data.slice(Math.min(index, this.index), Math.max(index, this.index) + 1) : [this.data];
            this.dt.selectRange(event, this.index);
        }
        event.preventDefault();
    }
    focusRowChange(firstFocusableRow, currentFocusedRow) {
        firstFocusableRow.tabIndex = '-1';
        currentFocusedRow.tabIndex = '0';
        DomHandler.focus(currentFocusedRow);
    }
    findLastSelectableRow() {
        const rows = DomHandler.find(this.dt.el.nativeElement, '.p-selectable-row');
        return rows ? rows[rows.length - 1] : null;
    }
    findFirstSelectableRow() {
        const firstRow = DomHandler.findSingle(this.dt.el.nativeElement, '.p-selectable-row');
        return firstRow;
    }
    findNextSelectableRow(row) {
        let nextRow = row.nextElementSibling;
        if (nextRow) {
            if (DomHandler.hasClass(nextRow, 'p-selectable-row'))
                return nextRow;
            else
                return this.findNextSelectableRow(nextRow);
        }
        else {
            return null;
        }
    }
    findPrevSelectableRow(row) {
        let prevRow = row.previousElementSibling;
        if (prevRow) {
            if (DomHandler.hasClass(prevRow, 'p-selectable-row'))
                return prevRow;
            else
                return this.findPrevSelectableRow(prevRow);
        }
        else {
            return null;
        }
    }
    isEnabled() {
        return this.pSelectableRowDisabled !== true;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectableRow, deps: [{ token: Table }, { token: TableService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SelectableRow, selector: "[pSelectableRow]", inputs: { data: ["pSelectableRow", "data"], index: ["pSelectableRowIndex", "index"], pSelectableRowDisabled: "pSelectableRowDisabled" }, host: { listeners: { "click": "onClick($event)", "touchend": "onTouchEnd($event)", "keydown": "onKeyDown($event)" }, properties: { "class.p-selectable-row": "isEnabled()", "class.p-highlight": "selected", "attr.tabindex": "setRowTabIndex()", "attr.data-p-highlight": "selected", "attr.data-p-selectable-row": "true" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectableRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pSelectableRow]',
                    host: {
                        class: 'p-element',
                        '[class.p-selectable-row]': 'isEnabled()',
                        '[class.p-highlight]': 'selected',
                        '[attr.tabindex]': 'setRowTabIndex()',
                        '[attr.data-p-highlight]': 'selected',
                        '[attr.data-p-selectable-row]': 'true'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: TableService }, { type: i0.ElementRef }], propDecorators: { data: [{
                type: Input,
                args: ['pSelectableRow']
            }], index: [{
                type: Input,
                args: ['pSelectableRowIndex']
            }], pSelectableRowDisabled: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onTouchEnd: [{
                type: HostListener,
                args: ['touchend', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });
class SelectableRowDblClick {
    constructor(dt, tableService) {
        this.dt = dt;
        this.tableService = tableService;
        if (this.isEnabled()) {
            this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
                this.selected = this.dt.isSelected(this.data);
            });
        }
    }
    ngOnInit() {
        if (this.isEnabled()) {
            this.selected = this.dt.isSelected(this.data);
        }
    }
    onClick(event) {
        if (this.isEnabled()) {
            this.dt.handleRowClick({
                originalEvent: event,
                rowData: this.data,
                rowIndex: this.index
            });
        }
    }
    isEnabled() {
        return this.pSelectableRowDisabled !== true;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectableRowDblClick, deps: [{ token: Table }, { token: TableService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SelectableRowDblClick, selector: "[pSelectableRowDblClick]", inputs: { data: ["pSelectableRowDblClick", "data"], index: ["pSelectableRowIndex", "index"], pSelectableRowDisabled: "pSelectableRowDisabled" }, host: { listeners: { "dblclick": "onClick($event)" }, properties: { "class.p-selectable-row": "isEnabled()", "class.p-highlight": "selected" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectableRowDblClick, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pSelectableRowDblClick]',
                    host: {
                        class: 'p-element',
                        '[class.p-selectable-row]': 'isEnabled()',
                        '[class.p-highlight]': 'selected'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: TableService }], propDecorators: { data: [{
                type: Input,
                args: ['pSelectableRowDblClick']
            }], index: [{
                type: Input,
                args: ['pSelectableRowIndex']
            }], pSelectableRowDisabled: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['dblclick', ['$event']]
            }] } });
class ContextMenuRow {
    constructor(dt, tableService, el) {
        this.dt = dt;
        this.tableService = tableService;
        this.el = el;
        if (this.isEnabled()) {
            this.subscription = this.dt.tableService.contextMenuSource$.subscribe((data) => {
                this.selected = this.dt.equals(this.data, data);
            });
        }
    }
    onContextMenu(event) {
        if (this.isEnabled()) {
            this.dt.handleRowRightClick({
                originalEvent: event,
                rowData: this.data,
                rowIndex: this.index
            });
            this.el.nativeElement.focus();
            event.preventDefault();
        }
    }
    isEnabled() {
        return this.pContextMenuRowDisabled !== true;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContextMenuRow, deps: [{ token: Table }, { token: TableService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ContextMenuRow, selector: "[pContextMenuRow]", inputs: { data: ["pContextMenuRow", "data"], index: ["pContextMenuRowIndex", "index"], pContextMenuRowDisabled: "pContextMenuRowDisabled" }, host: { listeners: { "contextmenu": "onContextMenu($event)" }, properties: { "class.p-highlight-contextmenu": "selected", "attr.tabindex": "isEnabled() ? 0 : undefined" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContextMenuRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pContextMenuRow]',
                    host: {
                        class: 'p-element',
                        '[class.p-highlight-contextmenu]': 'selected',
                        '[attr.tabindex]': 'isEnabled() ? 0 : undefined'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: TableService }, { type: i0.ElementRef }], propDecorators: { data: [{
                type: Input,
                args: ['pContextMenuRow']
            }], index: [{
                type: Input,
                args: ['pContextMenuRowIndex']
            }], pContextMenuRowDisabled: [{
                type: Input
            }], onContextMenu: [{
                type: HostListener,
                args: ['contextmenu', ['$event']]
            }] } });
class RowToggler {
    constructor(dt) {
        this.dt = dt;
    }
    onClick(event) {
        if (this.isEnabled()) {
            this.dt.toggleRow(this.data, event);
            event.preventDefault();
        }
    }
    isEnabled() {
        return this.pRowTogglerDisabled !== true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RowToggler, deps: [{ token: Table }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: RowToggler, selector: "[pRowToggler]", inputs: { data: ["pRowToggler", "data"], pRowTogglerDisabled: "pRowTogglerDisabled" }, host: { listeners: { "click": "onClick($event)" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RowToggler, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pRowToggler]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }], propDecorators: { data: [{
                type: Input,
                args: ['pRowToggler']
            }], pRowTogglerDisabled: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class ResizableColumn {
    constructor(document, platformId, renderer, dt, el, zone) {
        this.document = document;
        this.platformId = platformId;
        this.renderer = renderer;
        this.dt = dt;
        this.el = el;
        this.zone = zone;
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            if (this.isEnabled()) {
                DomHandler.addClass(this.el.nativeElement, 'p-resizable-column');
                this.resizer = this.renderer.createElement('span');
                this.renderer.addClass(this.resizer, 'p-column-resizer');
                this.renderer.appendChild(this.el.nativeElement, this.resizer);
                this.zone.runOutsideAngular(() => {
                    this.resizerMouseDownListener = this.renderer.listen(this.resizer, 'mousedown', this.onMouseDown.bind(this));
                });
            }
        }
    }
    bindDocumentEvents() {
        this.zone.runOutsideAngular(() => {
            this.documentMouseMoveListener = this.renderer.listen(this.document, 'mousemove', this.onDocumentMouseMove.bind(this));
            this.documentMouseUpListener = this.renderer.listen(this.document, 'mouseup', this.onDocumentMouseUp.bind(this));
        });
    }
    unbindDocumentEvents() {
        if (this.documentMouseMoveListener) {
            this.documentMouseMoveListener();
            this.documentMouseMoveListener = null;
        }
        if (this.documentMouseUpListener) {
            this.documentMouseUpListener();
            this.documentMouseUpListener = null;
        }
    }
    onMouseDown(event) {
        if (event.which === 1) {
            this.dt.onColumnResizeBegin(event);
            this.bindDocumentEvents();
        }
    }
    onDocumentMouseMove(event) {
        this.dt.onColumnResize(event);
    }
    onDocumentMouseUp(event) {
        this.dt.onColumnResizeEnd();
        this.unbindDocumentEvents();
    }
    isEnabled() {
        return this.pResizableColumnDisabled !== true;
    }
    ngOnDestroy() {
        if (this.resizerMouseDownListener) {
            this.resizerMouseDownListener();
            this.resizerMouseDownListener = null;
        }
        this.unbindDocumentEvents();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ResizableColumn, deps: [{ token: DOCUMENT }, { token: PLATFORM_ID }, { token: i0.Renderer2 }, { token: Table }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ResizableColumn, selector: "[pResizableColumn]", inputs: { pResizableColumnDisabled: "pResizableColumnDisabled" }, host: { classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ResizableColumn, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pResizableColumn]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.Renderer2 }, { type: Table }, { type: i0.ElementRef }, { type: i0.NgZone }], propDecorators: { pResizableColumnDisabled: [{
                type: Input
            }] } });
class ReorderableColumn {
    constructor(platformId, renderer, dt, el, zone) {
        this.platformId = platformId;
        this.renderer = renderer;
        this.dt = dt;
        this.el = el;
        this.zone = zone;
    }
    ngAfterViewInit() {
        if (this.isEnabled()) {
            this.bindEvents();
        }
    }
    bindEvents() {
        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                this.mouseDownListener = this.renderer.listen(this.el.nativeElement, 'mousedown', this.onMouseDown.bind(this));
                this.dragStartListener = this.renderer.listen(this.el.nativeElement, 'dragstart', this.onDragStart.bind(this));
                this.dragOverListener = this.renderer.listen(this.el.nativeElement, 'dragover', this.onDragOver.bind(this));
                this.dragEnterListener = this.renderer.listen(this.el.nativeElement, 'dragenter', this.onDragEnter.bind(this));
                this.dragLeaveListener = this.renderer.listen(this.el.nativeElement, 'dragleave', this.onDragLeave.bind(this));
            });
        }
    }
    unbindEvents() {
        if (this.mouseDownListener) {
            this.mouseDownListener();
            this.mouseDownListener = null;
        }
        if (this.dragStartListener) {
            this.dragStartListener();
            this.dragStartListener = null;
        }
        if (this.dragOverListener) {
            this.dragOverListener();
            this.dragOverListener = null;
        }
        if (this.dragEnterListener) {
            this.dragEnterListener();
            this.dragEnterListener = null;
        }
        if (this.dragLeaveListener) {
            this.dragLeaveListener();
            this.dragLeaveListener = null;
        }
    }
    onMouseDown(event) {
        if (event.target.nodeName === 'INPUT' || event.target.nodeName === 'TEXTAREA' || DomHandler.hasClass(event.target, 'p-column-resizer'))
            this.el.nativeElement.draggable = false;
        else
            this.el.nativeElement.draggable = true;
    }
    onDragStart(event) {
        this.dt.onColumnDragStart(event, this.el.nativeElement);
    }
    onDragOver(event) {
        event.preventDefault();
    }
    onDragEnter(event) {
        this.dt.onColumnDragEnter(event, this.el.nativeElement);
    }
    onDragLeave(event) {
        this.dt.onColumnDragLeave(event);
    }
    onDrop(event) {
        if (this.isEnabled()) {
            this.dt.onColumnDrop(event, this.el.nativeElement);
        }
    }
    isEnabled() {
        return this.pReorderableColumnDisabled !== true;
    }
    ngOnDestroy() {
        this.unbindEvents();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReorderableColumn, deps: [{ token: PLATFORM_ID }, { token: i0.Renderer2 }, { token: Table }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ReorderableColumn, selector: "[pReorderableColumn]", inputs: { pReorderableColumnDisabled: "pReorderableColumnDisabled" }, host: { listeners: { "drop": "onDrop($event)" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReorderableColumn, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pReorderableColumn]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.Renderer2 }, { type: Table }, { type: i0.ElementRef }, { type: i0.NgZone }], propDecorators: { pReorderableColumnDisabled: [{
                type: Input
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });
class EditableColumn {
    constructor(dt, el, zone) {
        this.dt = dt;
        this.el = el;
        this.zone = zone;
    }
    ngOnChanges({ data }) {
        if (this.el.nativeElement && !data.firstChange) {
            this.dt.updateEditingCell(this.el.nativeElement, this.data, this.field, this.rowIndex);
        }
    }
    ngAfterViewInit() {
        if (this.isEnabled()) {
            DomHandler.addClass(this.el.nativeElement, 'p-editable-column');
        }
    }
    onClick(event) {
        if (this.isEnabled()) {
            this.dt.selfClick = true;
            if (this.dt.editingCell) {
                if (this.dt.editingCell !== this.el.nativeElement) {
                    if (!this.dt.isEditingCellValid()) {
                        return;
                    }
                    this.closeEditingCell(true, event);
                    this.openCell();
                }
            }
            else {
                this.openCell();
            }
        }
    }
    openCell() {
        this.dt.updateEditingCell(this.el.nativeElement, this.data, this.field, this.rowIndex);
        DomHandler.addClass(this.el.nativeElement, 'p-cell-editing');
        this.dt.onEditInit.emit({ field: this.field, data: this.data, index: this.rowIndex });
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                let focusCellSelector = this.pFocusCellSelector || 'input, textarea, select';
                let focusableElement = DomHandler.findSingle(this.el.nativeElement, focusCellSelector);
                if (focusableElement) {
                    focusableElement.focus();
                }
            }, 50);
        });
        this.overlayEventListener = (e) => {
            if (this.el && this.el.nativeElement.contains(e.target)) {
                this.dt.selfClick = true;
            }
        };
        this.dt.overlaySubscription = this.dt.overlayService.clickObservable.subscribe(this.overlayEventListener);
    }
    closeEditingCell(completed, event) {
        const eventData = { field: this.dt.editingCellField, data: this.dt.editingCellData, originalEvent: event, index: this.dt.editingCellRowIndex };
        if (completed) {
            this.dt.onEditComplete.emit(eventData);
        }
        else {
            this.dt.onEditCancel.emit(eventData);
            this.dt.value.forEach((element) => {
                if (element[this.dt.editingCellField] === this.data) {
                    element[this.dt.editingCellField] = this.dt.editingCellData;
                }
            });
        }
        DomHandler.removeClass(this.dt.editingCell, 'p-cell-editing');
        this.dt.editingCell = null;
        this.dt.editingCellData = null;
        this.dt.editingCellField = null;
        this.dt.unbindDocumentEditListener();
        if (this.dt.overlaySubscription) {
            this.dt.overlaySubscription.unsubscribe();
        }
    }
    onEnterKeyDown(event) {
        if (this.isEnabled() && !event.shiftKey) {
            if (this.dt.isEditingCellValid()) {
                this.closeEditingCell(true, event);
            }
            event.preventDefault();
        }
    }
    onTabKeyDown(event) {
        if (this.isEnabled()) {
            if (this.dt.isEditingCellValid()) {
                this.closeEditingCell(true, event);
            }
            event.preventDefault();
        }
    }
    onEscapeKeyDown(event) {
        if (this.isEnabled()) {
            if (this.dt.isEditingCellValid()) {
                this.closeEditingCell(false, event);
            }
            event.preventDefault();
        }
    }
    onShiftKeyDown(event) {
        if (this.isEnabled()) {
            if (event.shiftKey)
                this.moveToPreviousCell(event);
            else {
                this.moveToNextCell(event);
            }
        }
    }
    onArrowDown(event) {
        if (this.isEnabled()) {
            let currentCell = this.findCell(event.target);
            if (currentCell) {
                let cellIndex = DomHandler.index(currentCell);
                let targetCell = this.findNextEditableColumnByIndex(currentCell, cellIndex);
                if (targetCell) {
                    if (this.dt.isEditingCellValid()) {
                        this.closeEditingCell(true, event);
                    }
                    DomHandler.invokeElementMethod(event.target, 'blur');
                    DomHandler.invokeElementMethod(targetCell, 'click');
                }
                event.preventDefault();
            }
        }
    }
    onArrowUp(event) {
        if (this.isEnabled()) {
            let currentCell = this.findCell(event.target);
            if (currentCell) {
                let cellIndex = DomHandler.index(currentCell);
                let targetCell = this.findPrevEditableColumnByIndex(currentCell, cellIndex);
                if (targetCell) {
                    if (this.dt.isEditingCellValid()) {
                        this.closeEditingCell(true, event);
                    }
                    DomHandler.invokeElementMethod(event.target, 'blur');
                    DomHandler.invokeElementMethod(targetCell, 'click');
                }
                event.preventDefault();
            }
        }
    }
    onArrowLeft(event) {
        if (this.isEnabled()) {
            this.moveToPreviousCell(event);
        }
    }
    onArrowRight(event) {
        if (this.isEnabled()) {
            this.moveToNextCell(event);
        }
    }
    findCell(element) {
        if (element) {
            let cell = element;
            while (cell && !DomHandler.hasClass(cell, 'p-cell-editing')) {
                cell = cell.parentElement;
            }
            return cell;
        }
        else {
            return null;
        }
    }
    moveToPreviousCell(event) {
        let currentCell = this.findCell(event.target);
        if (currentCell) {
            let targetCell = this.findPreviousEditableColumn(currentCell);
            if (targetCell) {
                if (this.dt.isEditingCellValid()) {
                    this.closeEditingCell(true, event);
                }
                DomHandler.invokeElementMethod(event.target, 'blur');
                DomHandler.invokeElementMethod(targetCell, 'click');
                event.preventDefault();
            }
        }
    }
    moveToNextCell(event) {
        let currentCell = this.findCell(event.target);
        if (currentCell) {
            let targetCell = this.findNextEditableColumn(currentCell);
            if (targetCell) {
                if (this.dt.isEditingCellValid()) {
                    this.closeEditingCell(true, event);
                }
                DomHandler.invokeElementMethod(event.target, 'blur');
                DomHandler.invokeElementMethod(targetCell, 'click');
                event.preventDefault();
            }
            else {
                if (this.dt.isEditingCellValid()) {
                    this.closeEditingCell(true, event);
                }
            }
        }
    }
    findPreviousEditableColumn(cell) {
        let prevCell = cell.previousElementSibling;
        if (!prevCell) {
            let previousRow = cell.parentElement?.previousElementSibling;
            if (previousRow) {
                prevCell = previousRow.lastElementChild;
            }
        }
        if (prevCell) {
            if (DomHandler.hasClass(prevCell, 'p-editable-column'))
                return prevCell;
            else
                return this.findPreviousEditableColumn(prevCell);
        }
        else {
            return null;
        }
    }
    findNextEditableColumn(cell) {
        let nextCell = cell.nextElementSibling;
        if (!nextCell) {
            let nextRow = cell.parentElement?.nextElementSibling;
            if (nextRow) {
                nextCell = nextRow.firstElementChild;
            }
        }
        if (nextCell) {
            if (DomHandler.hasClass(nextCell, 'p-editable-column'))
                return nextCell;
            else
                return this.findNextEditableColumn(nextCell);
        }
        else {
            return null;
        }
    }
    findNextEditableColumnByIndex(cell, index) {
        let nextRow = cell.parentElement?.nextElementSibling;
        if (nextRow) {
            let nextCell = nextRow.children[index];
            if (nextCell && DomHandler.hasClass(nextCell, 'p-editable-column')) {
                return nextCell;
            }
            return null;
        }
        else {
            return null;
        }
    }
    findPrevEditableColumnByIndex(cell, index) {
        let prevRow = cell.parentElement?.previousElementSibling;
        if (prevRow) {
            let prevCell = prevRow.children[index];
            if (prevCell && DomHandler.hasClass(prevCell, 'p-editable-column')) {
                return prevCell;
            }
            return null;
        }
        else {
            return null;
        }
    }
    isEnabled() {
        return this.pEditableColumnDisabled !== true;
    }
    ngOnDestroy() {
        if (this.dt.overlaySubscription) {
            this.dt.overlaySubscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditableColumn, deps: [{ token: Table }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: EditableColumn, selector: "[pEditableColumn]", inputs: { data: ["pEditableColumn", "data"], field: ["pEditableColumnField", "field"], rowIndex: ["pEditableColumnRowIndex", "rowIndex"], pEditableColumnDisabled: "pEditableColumnDisabled", pFocusCellSelector: "pFocusCellSelector" }, host: { listeners: { "click": "onClick($event)", "keydown.enter": "onEnterKeyDown($event)", "keydown.tab": "onShiftKeyDown($event)", "keydown.escape": "onEscapeKeyDown($event)", "keydown.shift.tab": "onShiftKeyDown($event)", "keydown.meta.tab": "onShiftKeyDown($event)", "keydown.arrowdown": "onArrowDown($event)", "keydown.arrowup": "onArrowUp($event)", "keydown.arrowleft": "onArrowLeft($event)", "keydown.arrowright": "onArrowRight($event)" }, classAttribute: "p-element" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditableColumn, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pEditableColumn]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: i0.ElementRef }, { type: i0.NgZone }], propDecorators: { data: [{
                type: Input,
                args: ['pEditableColumn']
            }], field: [{
                type: Input,
                args: ['pEditableColumnField']
            }], rowIndex: [{
                type: Input,
                args: ['pEditableColumnRowIndex']
            }], pEditableColumnDisabled: [{
                type: Input
            }], pFocusCellSelector: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onEnterKeyDown: [{
                type: HostListener,
                args: ['keydown.enter', ['$event']]
            }], onTabKeyDown: [{
                type: HostListener,
                args: ['keydown.tab', ['$event']]
            }], onEscapeKeyDown: [{
                type: HostListener,
                args: ['keydown.escape', ['$event']]
            }], onShiftKeyDown: [{
                type: HostListener,
                args: ['keydown.tab', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.shift.tab', ['$event']]
            }, {
                type: HostListener,
                args: ['keydown.meta.tab', ['$event']]
            }], onArrowDown: [{
                type: HostListener,
                args: ['keydown.arrowdown', ['$event']]
            }], onArrowUp: [{
                type: HostListener,
                args: ['keydown.arrowup', ['$event']]
            }], onArrowLeft: [{
                type: HostListener,
                args: ['keydown.arrowleft', ['$event']]
            }], onArrowRight: [{
                type: HostListener,
                args: ['keydown.arrowright', ['$event']]
            }] } });
class EditableRow {
    constructor(el) {
        this.el = el;
    }
    isEnabled() {
        return this.pEditableRowDisabled !== true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditableRow, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: EditableRow, selector: "[pEditableRow]", inputs: { data: ["pEditableRow", "data"], pEditableRowDisabled: "pEditableRowDisabled" }, host: { classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditableRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pEditableRow]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { data: [{
                type: Input,
                args: ['pEditableRow']
            }], pEditableRowDisabled: [{
                type: Input
            }] } });
class InitEditableRow {
    constructor(dt, editableRow) {
        this.dt = dt;
        this.editableRow = editableRow;
    }
    onClick(event) {
        this.dt.initRowEdit(this.editableRow.data);
        event.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InitEditableRow, deps: [{ token: Table }, { token: EditableRow }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: InitEditableRow, selector: "[pInitEditableRow]", host: { listeners: { "click": "onClick($event)" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InitEditableRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pInitEditableRow]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: EditableRow }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class SaveEditableRow {
    constructor(dt, editableRow) {
        this.dt = dt;
        this.editableRow = editableRow;
    }
    onClick(event) {
        this.dt.saveRowEdit(this.editableRow.data, this.editableRow.el.nativeElement);
        event.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SaveEditableRow, deps: [{ token: Table }, { token: EditableRow }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SaveEditableRow, selector: "[pSaveEditableRow]", host: { listeners: { "click": "onClick($event)" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SaveEditableRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pSaveEditableRow]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: EditableRow }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class CancelEditableRow {
    constructor(dt, editableRow) {
        this.dt = dt;
        this.editableRow = editableRow;
    }
    onClick(event) {
        this.dt.cancelRowEdit(this.editableRow.data);
        event.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CancelEditableRow, deps: [{ token: Table }, { token: EditableRow }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CancelEditableRow, selector: "[pCancelEditableRow]", host: { listeners: { "click": "onClick($event)" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CancelEditableRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pCancelEditableRow]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: EditableRow }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });
class CellEditor {
    constructor(dt, editableColumn, editableRow) {
        this.dt = dt;
        this.editableColumn = editableColumn;
        this.editableRow = editableRow;
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'input':
                    this.inputTemplate = item.template;
                    break;
                case 'output':
                    this.outputTemplate = item.template;
                    break;
            }
        });
    }
    get editing() {
        return (this.dt.editingCell && this.editableColumn && this.dt.editingCell === this.editableColumn.el.nativeElement) || (this.editableRow && this.dt.editMode === 'row' && this.dt.isRowEditing(this.editableRow.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CellEditor, deps: [{ token: Table }, { token: EditableColumn, optional: true }, { token: EditableRow, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CellEditor, selector: "p-cellEditor", host: { classAttribute: "p-element" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], ngImport: i0, template: `
        <ng-container *ngIf="editing">
            <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!editing">
            <ng-container *ngTemplateOutlet="outputTemplate"></ng-container>
        </ng-container>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CellEditor, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-cellEditor',
                    template: `
        <ng-container *ngIf="editing">
            <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!editing">
            <ng-container *ngTemplateOutlet="outputTemplate"></ng-container>
        </ng-container>
    `,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: EditableColumn, decorators: [{
                    type: Optional
                }] }, { type: EditableRow, decorators: [{
                    type: Optional
                }] }], propDecorators: { templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }] } });
class TableRadioButton {
    constructor(dt, cd) {
        this.dt = dt;
        this.cd = cd;
        this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
            this.checked = this.dt.isSelected(this.value);
            this.ariaLabel = this.ariaLabel || this.dt.config.translation.aria ? (this.checked ? this.dt.config.translation.aria.selectRow : this.dt.config.translation.aria.unselectRow) : undefined;
            this.cd.markForCheck();
        });
    }
    ngOnInit() {
        this.checked = this.dt.isSelected(this.value);
    }
    onClick(event) {
        if (!this.disabled) {
            this.dt.toggleRowWithRadio({
                originalEvent: event,
                rowIndex: this.index
            }, this.value);
            this.inputViewChild?.nativeElement?.focus();
        }
        DomHandler.clearSelection();
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableRadioButton, deps: [{ token: Table }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableRadioButton, selector: "p-tableRadioButton", inputs: { disabled: "disabled", value: "value", index: "index", inputId: "inputId", name: "name", ariaLabel: "ariaLabel" }, host: { classAttribute: "p-element" }, viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["rb"], descendants: true }], ngImport: i0, template: `
        <div class="p-radiobutton p-component" [ngClass]="{ 'p-radiobutton-focused': focused, 'p-radiobutton-checked': checked, 'p-radiobutton-disabled': disabled }" (click)="onClick($event)">
            <div class="p-hidden-accessible">
                <input #rb type="radio" [attr.id]="inputId" [attr.name]="name" [checked]="checked" (focus)="onFocus()" (blur)="onBlur()" [disabled]="disabled" [attr.aria-label]="ariaLabel" [tabindex]="disabled ? null : '0'" />
            </div>
            <div #box [ngClass]="{ 'p-radiobutton-box p-component': true, 'p-highlight': checked, 'p-focus': focused, 'p-disabled': disabled }">
                <div class="p-radiobutton-icon"></div>
            </div>
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableRadioButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-tableRadioButton',
                    template: `
        <div class="p-radiobutton p-component" [ngClass]="{ 'p-radiobutton-focused': focused, 'p-radiobutton-checked': checked, 'p-radiobutton-disabled': disabled }" (click)="onClick($event)">
            <div class="p-hidden-accessible">
                <input #rb type="radio" [attr.id]="inputId" [attr.name]="name" [checked]="checked" (focus)="onFocus()" (blur)="onBlur()" [disabled]="disabled" [attr.aria-label]="ariaLabel" [tabindex]="disabled ? null : '0'" />
            </div>
            <div #box [ngClass]="{ 'p-radiobutton-box p-component': true, 'p-highlight': checked, 'p-focus': focused, 'p-disabled': disabled }">
                <div class="p-radiobutton-icon"></div>
            </div>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: i0.ChangeDetectorRef }], propDecorators: { disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], index: [{
                type: Input
            }], inputId: [{
                type: Input
            }], name: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], inputViewChild: [{
                type: ViewChild,
                args: ['rb']
            }] } });
class TableCheckbox {
    constructor(dt, tableService, cd) {
        this.dt = dt;
        this.tableService = tableService;
        this.cd = cd;
        this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
            this.checked = this.dt.isSelected(this.value);
            this.ariaLabel = this.ariaLabel || this.dt.config.translation.aria ? (this.checked ? this.dt.config.translation.aria.selectRow : this.dt.config.translation.aria.unselectRow) : undefined;
            this.cd.markForCheck();
        });
    }
    ngOnInit() {
        this.checked = this.dt.isSelected(this.value);
    }
    onClick(event) {
        if (!this.disabled) {
            this.dt.toggleRowWithCheckbox({
                originalEvent: event,
                rowIndex: this.index
            }, this.value);
        }
        DomHandler.clearSelection();
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableCheckbox, deps: [{ token: Table }, { token: TableService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableCheckbox, selector: "p-tableCheckbox", inputs: { disabled: "disabled", value: "value", index: "index", inputId: "inputId", name: "name", required: "required", ariaLabel: "ariaLabel" }, host: { classAttribute: "p-element" }, ngImport: i0, template: `
        <div class="p-checkbox p-component" [ngClass]="{ 'p-checkbox-focused': focused, 'p-checkbox-disabled': disabled }" (click)="onClick($event)">
            <div class="p-hidden-accessible">
                <input
                    type="checkbox"
                    [attr.id]="inputId"
                    [attr.name]="name"
                    [checked]="checked"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                    [disabled]="disabled"
                    [attr.required]="required"
                    [attr.aria-label]="ariaLabel"
                    [tabindex]="disabled ? null : '0'"
                />
            </div>
            <div #box [ngClass]="{ 'p-checkbox-box p-component': true, 'p-highlight': checked, 'p-focus': focused, 'p-disabled': disabled }">
                <ng-container *ngIf="!dt.checkboxIconTemplate">
                    <CheckIcon [styleClass]="'p-checkbox-icon'" *ngIf="checked" />
                </ng-container>
                <span *ngIf="dt.checkboxIconTemplate">
                    <ng-template *ngTemplateOutlet="dt.checkboxIconTemplate; context: { $implicit: checked }"></ng-template>
                </span>
            </div>
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i0.forwardRef(() => CheckIcon), selector: "CheckIcon" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableCheckbox, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-tableCheckbox',
                    template: `
        <div class="p-checkbox p-component" [ngClass]="{ 'p-checkbox-focused': focused, 'p-checkbox-disabled': disabled }" (click)="onClick($event)">
            <div class="p-hidden-accessible">
                <input
                    type="checkbox"
                    [attr.id]="inputId"
                    [attr.name]="name"
                    [checked]="checked"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                    [disabled]="disabled"
                    [attr.required]="required"
                    [attr.aria-label]="ariaLabel"
                    [tabindex]="disabled ? null : '0'"
                />
            </div>
            <div #box [ngClass]="{ 'p-checkbox-box p-component': true, 'p-highlight': checked, 'p-focus': focused, 'p-disabled': disabled }">
                <ng-container *ngIf="!dt.checkboxIconTemplate">
                    <CheckIcon [styleClass]="'p-checkbox-icon'" *ngIf="checked" />
                </ng-container>
                <span *ngIf="dt.checkboxIconTemplate">
                    <ng-template *ngTemplateOutlet="dt.checkboxIconTemplate; context: { $implicit: checked }"></ng-template>
                </span>
            </div>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: TableService }, { type: i0.ChangeDetectorRef }], propDecorators: { disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], index: [{
                type: Input
            }], inputId: [{
                type: Input
            }], name: [{
                type: Input
            }], required: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }] } });
class TableHeaderCheckbox {
    constructor(dt, tableService, cd) {
        this.dt = dt;
        this.tableService = tableService;
        this.cd = cd;
        const getAriaLabel = () => (this.ariaLabel || this.dt.config.translation.aria)
            ? (this.checked ? this.dt.config.translation.aria.selectAll : this.dt.config.translation.aria.unselectAll)
            : undefined;
        this.valueChangeSubscription = this.dt.tableService.valueSource$.subscribe(() => {
            this.checked = this.updateCheckedState();
            this.ariaLabel = getAriaLabel();
        });
        this.selectionChangeSubscription = this.dt.tableService.selectionSource$.subscribe(() => {
            this.checked = this.updateCheckedState();
            this.ariaLabel = getAriaLabel();
        });
    }
    ngOnInit() {
        this.checked = this.updateCheckedState();
    }
    onClick(event) {
        if (!this.disabled) {
            if (this.dt.value && this.dt.value.length > 0) {
                this.dt.toggleRowsWithCheckbox(event, !this.checked);
            }
        }
        DomHandler.clearSelection();
    }
    onFocus() {
        this.focused = true;
    }
    onBlur() {
        this.focused = false;
    }
    isDisabled() {
        return this.disabled || !this.dt.value || !this.dt.value.length;
    }
    ngOnDestroy() {
        if (this.selectionChangeSubscription) {
            this.selectionChangeSubscription.unsubscribe();
        }
        if (this.valueChangeSubscription) {
            this.valueChangeSubscription.unsubscribe();
        }
    }
    updateCheckedState() {
        this.cd.markForCheck();
        if (this.dt._selectAll !== null) {
            return this.dt._selectAll;
        }
        else {
            const data = this.dt.selectionPageOnly ? this.dt.dataToRender(this.dt.processedData) : this.dt.processedData;
            const val = this.dt.frozenValue ? [...this.dt.frozenValue, ...data] : data;
            const selectableVal = this.dt.rowSelectable ? val.filter((data, index) => this.dt.rowSelectable({ data, index })) : val;
            return ObjectUtils.isNotEmpty(selectableVal) && ObjectUtils.isNotEmpty(this.dt.selection) && selectableVal.every((v) => this.dt.selection.some((s) => this.dt.equals(v, s)));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHeaderCheckbox, deps: [{ token: Table }, { token: TableService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableHeaderCheckbox, selector: "p-tableHeaderCheckbox", inputs: { disabled: "disabled", inputId: "inputId", name: "name", ariaLabel: "ariaLabel" }, host: { classAttribute: "p-element" }, ngImport: i0, template: `
        <div class="p-checkbox p-component" [ngClass]="{ 'p-checkbox-focused': focused, 'p-checkbox-disabled': isDisabled() }" (click)="onClick($event)">
            <div class="p-hidden-accessible">
                <input #cb type="checkbox" [tabindex]="disabled ? null : '0'" [attr.id]="inputId" [attr.name]="name" [checked]="checked" (focus)="onFocus()" (blur)="onBlur()" [disabled]="isDisabled()" [attr.aria-label]="ariaLabel" />
            </div>
            <div #box [ngClass]="{ 'p-checkbox-box': true, 'p-highlight': checked, 'p-focus': focused, 'p-disabled': isDisabled() }">
                <ng-container *ngIf="!dt.headerCheckboxIconTemplate">
                    <CheckIcon *ngIf="checked" [styleClass]="'p-checkbox-icon'" />
                </ng-container>
                <span class="p-checkbox-icon" *ngIf="dt.headerCheckboxIconTemplate">
                    <ng-template *ngTemplateOutlet="dt.headerCheckboxIconTemplate; context: { $implicit: checked }"></ng-template>
                </span>
            </div>
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i0.forwardRef(() => CheckIcon), selector: "CheckIcon" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableHeaderCheckbox, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-tableHeaderCheckbox',
                    template: `
        <div class="p-checkbox p-component" [ngClass]="{ 'p-checkbox-focused': focused, 'p-checkbox-disabled': isDisabled() }" (click)="onClick($event)">
            <div class="p-hidden-accessible">
                <input #cb type="checkbox" [tabindex]="disabled ? null : '0'" [attr.id]="inputId" [attr.name]="name" [checked]="checked" (focus)="onFocus()" (blur)="onBlur()" [disabled]="isDisabled()" [attr.aria-label]="ariaLabel" />
            </div>
            <div #box [ngClass]="{ 'p-checkbox-box': true, 'p-highlight': checked, 'p-focus': focused, 'p-disabled': isDisabled() }">
                <ng-container *ngIf="!dt.headerCheckboxIconTemplate">
                    <CheckIcon *ngIf="checked" [styleClass]="'p-checkbox-icon'" />
                </ng-container>
                <span class="p-checkbox-icon" *ngIf="dt.headerCheckboxIconTemplate">
                    <ng-template *ngTemplateOutlet="dt.headerCheckboxIconTemplate; context: { $implicit: checked }"></ng-template>
                </span>
            </div>
        </div>
    `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: TableService }, { type: i0.ChangeDetectorRef }], propDecorators: { disabled: [{
                type: Input
            }], inputId: [{
                type: Input
            }], name: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }] } });
class ReorderableRowHandle {
    constructor(el) {
        this.el = el;
    }
    ngAfterViewInit() {
        DomHandler.addClass(this.el.nativeElement, 'p-datatable-reorderablerow-handle');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReorderableRowHandle, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ReorderableRowHandle, selector: "[pReorderableRowHandle]", host: { classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReorderableRowHandle, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pReorderableRowHandle]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }] });
class ReorderableRow {
    constructor(renderer, dt, el, zone) {
        this.renderer = renderer;
        this.dt = dt;
        this.el = el;
        this.zone = zone;
    }
    ngAfterViewInit() {
        if (this.isEnabled()) {
            this.el.nativeElement.droppable = true;
            this.bindEvents();
        }
    }
    bindEvents() {
        this.zone.runOutsideAngular(() => {
            this.mouseDownListener = this.renderer.listen(this.el.nativeElement, 'mousedown', this.onMouseDown.bind(this));
            this.dragStartListener = this.renderer.listen(this.el.nativeElement, 'dragstart', this.onDragStart.bind(this));
            this.dragEndListener = this.renderer.listen(this.el.nativeElement, 'dragend', this.onDragEnd.bind(this));
            this.dragOverListener = this.renderer.listen(this.el.nativeElement, 'dragover', this.onDragOver.bind(this));
            this.dragLeaveListener = this.renderer.listen(this.el.nativeElement, 'dragleave', this.onDragLeave.bind(this));
        });
    }
    unbindEvents() {
        if (this.mouseDownListener) {
            this.mouseDownListener();
            this.mouseDownListener = null;
        }
        if (this.dragStartListener) {
            this.dragStartListener();
            this.dragStartListener = null;
        }
        if (this.dragEndListener) {
            this.dragEndListener();
            this.dragEndListener = null;
        }
        if (this.dragOverListener) {
            this.dragOverListener();
            this.dragOverListener = null;
        }
        if (this.dragLeaveListener) {
            this.dragLeaveListener();
            this.dragLeaveListener = null;
        }
    }
    onMouseDown(event) {
        if (DomHandler.hasClass(event.target, 'p-datatable-reorderablerow-handle'))
            this.el.nativeElement.draggable = true;
        else
            this.el.nativeElement.draggable = false;
    }
    onDragStart(event) {
        this.dt.onRowDragStart(event, this.index);
    }
    onDragEnd(event) {
        this.dt.onRowDragEnd(event);
        this.el.nativeElement.draggable = false;
    }
    onDragOver(event) {
        this.dt.onRowDragOver(event, this.index, this.el.nativeElement);
        event.preventDefault();
    }
    onDragLeave(event) {
        this.dt.onRowDragLeave(event, this.el.nativeElement);
    }
    isEnabled() {
        return this.pReorderableRowDisabled !== true;
    }
    onDrop(event) {
        if (this.isEnabled() && this.dt.rowDragging) {
            this.dt.onRowDrop(event, this.el.nativeElement);
        }
        event.preventDefault();
    }
    ngOnDestroy() {
        this.unbindEvents();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReorderableRow, deps: [{ token: i0.Renderer2 }, { token: Table }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ReorderableRow, selector: "[pReorderableRow]", inputs: { index: ["pReorderableRow", "index"], pReorderableRowDisabled: "pReorderableRowDisabled" }, host: { listeners: { "drop": "onDrop($event)" }, classAttribute: "p-element" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ReorderableRow, decorators: [{
            type: Directive,
            args: [{
                    selector: '[pReorderableRow]',
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: Table }, { type: i0.ElementRef }, { type: i0.NgZone }], propDecorators: { index: [{
                type: Input,
                args: ['pReorderableRow']
            }], pReorderableRowDisabled: [{
                type: Input
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });
/**
 * Column Filter element of Table.
 * @group Components
 */
class ColumnFilter {
    get fieldConstraints() {
        return this.dt.filters ? this.dt.filters[this.field] : null;
    }
    get showRemoveIcon() {
        return this.fieldConstraints ? this.fieldConstraints.length > 1 : false;
    }
    get showMenuButton() {
        return this.showMenu && (this.display === 'row' ? this.type !== 'boolean' : true);
    }
    get isShowOperator() {
        return this.showOperator && this.type !== 'boolean';
    }
    get isShowAddConstraint() {
        return this.showAddButton && this.type !== 'boolean' && this.fieldConstraints && this.fieldConstraints.length < this.maxConstraints;
    }
    get applyButtonLabel() {
        return this.config.getTranslation(TranslationKeys.APPLY);
    }
    get clearButtonLabel() {
        return this.config.getTranslation(TranslationKeys.CLEAR);
    }
    get addRuleButtonLabel() {
        return this.config.getTranslation(TranslationKeys.ADD_RULE);
    }
    get removeRuleButtonLabel() {
        return this.config.getTranslation(TranslationKeys.REMOVE_RULE);
    }
    get noFilterLabel() {
        return this.config.getTranslation(TranslationKeys.NO_FILTER);
    }
    get filterMenuButtonAriaLabel() {
        return this.config.translation ? (this.overlayVisible ? this.config.translation.aria.showFilterMenu : this.config.translation.aria.hideFilterMenu) : undefined;
    }
    get removeRuleButtonAriaLabel() {
        return this.config.translation ? this.config.translation.removeRule : undefined;
    }
    get filterOperatorAriaLabel() {
        return this.config.translation ? this.config.translation.aria.filterOperator : undefined;
    }
    get filterConstraintAriaLabel() {
        return this.config.translation ? this.config.translation.aria.filterConstraint : undefined;
    }
    constructor(document, el, dt, renderer, config, overlayService, cd) {
        this.document = document;
        this.el = el;
        this.dt = dt;
        this.renderer = renderer;
        this.config = config;
        this.overlayService = overlayService;
        this.cd = cd;
        /**
         * Type of the input.
         * @group Props
         */
        this.type = 'text';
        /**
         * Filter display.
         * @group Props
         */
        this.display = 'row';
        /**
         * Decides whether to display filter menu popup.
         * @group Props
         */
        this.showMenu = true;
        /**
         * Filter operator.
         * @defaultValue 'AND'
         * @group Props
         */
        this.operator = FilterOperator.AND;
        /**
         * Decides whether to display filter operator.
         * @group Props
         */
        this.showOperator = true;
        /**
         * aria-label for the filter button (when filter is not applied).
         * @defaultValue 'Filter'
         * @group Props
         */
        this.showMenuButtonAriaLabel = 'Filter';
        /**
           * aria-label for the filter button (when filter is applied).
           * @defaultValue 'Filter applied'
           * @group Props
           */
        this.showMenuButtonWhenFilterAppliedAriaLabel = 'Filter applied';
        /**
         * Decides whether to display clear filter button.
         * @group Props
         */
        this.showClearButton = true;
        /**
         * Decides whether to display apply filter button.
         * @group Props
         */
        this.showApplyButton = true;
        /**
         * Decides whether to display filter match modes.
         * @group Props
         */
        this.showMatchModes = true;
        /**
         * Decides whether to display add filter button.
         * @group Props
         */
        this.showAddButton = true;
        /**
         * Decides whether to close popup on clear button click.
         * @group Props
         */
        this.hideOnClear = false;
        /**
         * Defines maximum amount of constraints.
         * @group Props
         */
        this.maxConstraints = 2;
        /**
         * Defines if filter grouping will be enabled.
         * @group Props
         */
        this.useGrouping = true;
        /**
         * Defines the visibility of buttons.
         * @group Props
         */
        this.showButtons = true;
        this.window = this.document.defaultView;
    }
    ngOnInit() {
        this.overlayId = UniqueComponentId();
        if (!this.dt.filters[this.field]) {
            this.initFieldFilterConstraint();
        }
        this.translationSubscription = this.config.translationObserver.subscribe(() => {
            this.generateMatchModeOptions();
            this.generateOperatorOptions();
        });
        this.generateMatchModeOptions();
        this.generateOperatorOptions();
    }
    generateMatchModeOptions() {
        this.matchModes =
            this.matchModeOptions ||
                this.config.filterMatchModeOptions[this.type]?.map((key) => {
                    return { label: this.config.getTranslation(key), value: key };
                });
    }
    generateOperatorOptions() {
        this.operatorOptions = [
            { label: this.config.getTranslation(TranslationKeys.MATCH_ALL), value: FilterOperator.AND },
            { label: this.config.getTranslation(TranslationKeys.MATCH_ANY), value: FilterOperator.OR }
        ];
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'header':
                    this.headerTemplate = item.template;
                    break;
                case 'filter':
                    this.filterTemplate = item.template;
                    break;
                case 'footer':
                    this.footerTemplate = item.template;
                    break;
                case 'filtericon':
                    this.filterIconTemplate = item.template;
                    break;
                case 'clearfiltericon':
                    this.clearFilterIconTemplate = item.template;
                    break;
                case 'removeruleicon':
                    this.removeRuleIconTemplate = item.template;
                    break;
                case 'addruleicon':
                    this.addRuleIconTemplate = item.template;
                    break;
                default:
                    this.filterTemplate = item.template;
                    break;
            }
        });
    }
    initFieldFilterConstraint() {
        let defaultMatchMode = this.getDefaultMatchMode();
        this.dt.filters[this.field] = this.display == 'row' ? { value: null, matchMode: defaultMatchMode } : [{ value: null, matchMode: defaultMatchMode, operator: this.operator }];
    }
    onMenuMatchModeChange(value, filterMeta) {
        filterMeta.matchMode = value;
        if (!this.showApplyButton) {
            this.dt._filter();
        }
    }
    onRowMatchModeChange(matchMode) {
        this.dt.filters[this.field].matchMode = matchMode;
        this.dt._filter();
        this.hide();
    }
    onRowMatchModeKeyDown(event) {
        let item = event.target;
        switch (event.key) {
            case 'ArrowDown':
                var nextItem = this.findNextItem(item);
                if (nextItem) {
                    item.removeAttribute('tabindex');
                    nextItem.tabIndex = '0';
                    nextItem.focus();
                }
                event.preventDefault();
                break;
            case 'ArrowUp':
                var prevItem = this.findPrevItem(item);
                if (prevItem) {
                    item.removeAttribute('tabindex');
                    prevItem.tabIndex = '0';
                    prevItem.focus();
                }
                event.preventDefault();
                break;
        }
    }
    onRowClearItemClick() {
        this.clearFilter();
        this.hide();
    }
    isRowMatchModeSelected(matchMode) {
        return this.dt.filters[this.field].matchMode === matchMode;
    }
    addConstraint() {
        this.dt.filters[this.field].push({ value: null, matchMode: this.getDefaultMatchMode(), operator: this.getDefaultOperator() });
        DomHandler.focus(this.clearButtonViewChild.nativeElement);
    }
    removeConstraint(filterMeta) {
        this.dt.filters[this.field] = this.dt.filters[this.field].filter((meta) => meta !== filterMeta);
        this.dt._filter();
        DomHandler.focus(this.clearButtonViewChild.nativeElement);
    }
    onOperatorChange(value) {
        this.dt.filters[this.field].forEach((filterMeta) => {
            filterMeta.operator = value;
            this.operator = value;
        });
        if (!this.showApplyButton) {
            this.dt._filter();
        }
    }
    toggleMenu() {
        this.overlayVisible = !this.overlayVisible;
    }
    onToggleButtonKeyDown(event) {
        switch (event.key) {
            case 'Escape':
            case 'Tab':
                this.overlayVisible = false;
                break;
            case 'ArrowDown':
                if (this.overlayVisible) {
                    let focusable = DomHandler.getFocusableElements(this.overlay);
                    if (focusable) {
                        focusable[0].focus();
                    }
                    event.preventDefault();
                }
                else if (event.altKey) {
                    this.overlayVisible = true;
                    event.preventDefault();
                }
                break;
            case ' ':
            case 'Enter':
                if (!this.overlayVisible) {
                    this.overlayVisible = true;
                    event.preventDefault();
                }
                break;
        }
    }
    onEscape() {
        this.overlayVisible = false;
        this.icon?.nativeElement.focus();
    }
    findNextItem(item) {
        let nextItem = item.nextElementSibling;
        if (nextItem)
            return DomHandler.hasClass(nextItem, 'p-column-filter-separator') ? this.findNextItem(nextItem) : nextItem;
        else
            return item.parentElement?.firstElementChild;
    }
    findPrevItem(item) {
        let prevItem = item.previousElementSibling;
        if (prevItem)
            return DomHandler.hasClass(prevItem, 'p-column-filter-separator') ? this.findPrevItem(prevItem) : prevItem;
        else
            return item.parentElement?.lastElementChild;
    }
    onContentClick() {
        this.selfClick = true;
    }
    onOverlayAnimationStart(event) {
        switch (event.toState) {
            case 'visible':
                this.overlay = event.element;
                this.renderer.appendChild(this.document.body, this.overlay);
                ZIndexUtils.set('overlay', this.overlay, this.config.zIndex.overlay);
                DomHandler.absolutePosition(this.overlay, this.icon?.nativeElement);
                this.bindDocumentClickListener();
                this.bindDocumentResizeListener();
                this.bindScrollListener();
                this.overlayEventListener = (e) => {
                    if (this.overlay && this.overlay.contains(e.target)) {
                        this.selfClick = true;
                    }
                };
                this.overlaySubscription = this.overlayService.clickObservable.subscribe(this.overlayEventListener);
                break;
            case 'void':
                this.onOverlayHide();
                if (this.overlaySubscription) {
                    this.overlaySubscription.unsubscribe();
                }
                break;
        }
    }
    onOverlayAnimationEnd(event) {
        switch (event.toState) {
            case 'visible':
                this.focusOnFirstElement();
                break;
            case 'void':
                ZIndexUtils.clear(event.element);
                break;
        }
    }
    focusOnFirstElement() {
        if (this.overlay) {
            DomHandler.focus(DomHandler.getFirstFocusableElement(this.overlay, ''));
        }
    }
    getDefaultMatchMode() {
        if (this.matchMode) {
            return this.matchMode;
        }
        else {
            if (this.type === 'text')
                return FilterMatchMode.STARTS_WITH;
            else if (this.type === 'numeric')
                return FilterMatchMode.EQUALS;
            else if (this.type === 'date')
                return FilterMatchMode.DATE_IS;
            else
                return FilterMatchMode.CONTAINS;
        }
    }
    getDefaultOperator() {
        return this.dt.filters ? this.dt.filters[this.field][0].operator : this.operator;
    }
    hasRowFilter() {
        return this.dt.filters[this.field] && !this.dt.isFilterBlank(this.dt.filters[this.field].value);
    }
    hasFilter() {
        let fieldFilter = this.dt.filters[this.field];
        if (fieldFilter) {
            if (Array.isArray(fieldFilter))
                return !this.dt.isFilterBlank(fieldFilter[0].value);
            else
                return !this.dt.isFilterBlank(fieldFilter.value);
        }
        return false;
    }
    isOutsideClicked(event) {
        return !(this.overlay?.isSameNode(event.target) ||
            this.overlay?.contains(event.target) ||
            this.icon?.nativeElement.isSameNode(event.target) ||
            this.icon?.nativeElement.contains(event.target) ||
            DomHandler.hasClass(event.target, 'p-column-filter-add-button') ||
            DomHandler.hasClass(event.target.parentElement, 'p-column-filter-add-button') ||
            DomHandler.hasClass(event.target, 'p-column-filter-remove-button') ||
            DomHandler.hasClass(event.target.parentElement, 'p-column-filter-remove-button'));
    }
    bindDocumentClickListener() {
        if (!this.documentClickListener) {
            const documentTarget = this.el ? this.el.nativeElement.ownerDocument : 'document';
            this.documentClickListener = this.renderer.listen(documentTarget, 'mousedown', (event) => {
                if (this.overlayVisible && !this.selfClick && this.isOutsideClicked(event)) {
                    this.hide();
                }
                this.selfClick = false;
            });
        }
    }
    unbindDocumentClickListener() {
        if (this.documentClickListener) {
            this.documentClickListener();
            this.documentClickListener = null;
            this.selfClick = false;
        }
    }
    bindDocumentResizeListener() {
        if (!this.documentResizeListener) {
            this.documentResizeListener = this.renderer.listen(this.window, 'resize', (event) => {
                if (this.overlayVisible && !DomHandler.isTouchDevice()) {
                    this.hide();
                }
            });
        }
    }
    unbindDocumentResizeListener() {
        if (this.documentResizeListener) {
            this.documentResizeListener();
            this.documentResizeListener = null;
        }
    }
    bindScrollListener() {
        if (!this.scrollHandler) {
            this.scrollHandler = new ConnectedOverlayScrollHandler(this.icon?.nativeElement, () => {
                if (this.overlayVisible) {
                    this.hide();
                }
            });
        }
        this.scrollHandler.bindScrollListener();
    }
    unbindScrollListener() {
        if (this.scrollHandler) {
            this.scrollHandler.unbindScrollListener();
        }
    }
    hide() {
        this.overlayVisible = false;
        this.cd.markForCheck();
    }
    onOverlayHide() {
        this.unbindDocumentClickListener();
        this.unbindDocumentResizeListener();
        this.unbindScrollListener();
        this.overlay = null;
    }
    clearFilter() {
        this.initFieldFilterConstraint();
        this.dt._filter();
        if (this.hideOnClear)
            this.hide();
    }
    applyFilter() {
        this.dt._filter();
        this.hide();
    }
    ngOnDestroy() {
        if (this.overlay) {
            this.renderer.appendChild(this.el.nativeElement, this.overlay);
            ZIndexUtils.clear(this.overlay);
            this.onOverlayHide();
        }
        if (this.translationSubscription) {
            this.translationSubscription.unsubscribe();
        }
        if (this.resetSubscription) {
            this.resetSubscription.unsubscribe();
        }
        if (this.overlaySubscription) {
            this.overlaySubscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ColumnFilter, deps: [{ token: DOCUMENT }, { token: i0.ElementRef }, { token: Table }, { token: i0.Renderer2 }, { token: i1$1.PrimeNGConfig }, { token: i1$1.OverlayService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ColumnFilter, selector: "p-columnFilter", inputs: { field: "field", type: "type", display: "display", showMenu: "showMenu", matchMode: "matchMode", operator: "operator", showOperator: "showOperator", showMenuButtonAriaLabel: "showMenuButtonAriaLabel", showMenuButtonWhenFilterAppliedAriaLabel: "showMenuButtonWhenFilterAppliedAriaLabel", showClearButton: "showClearButton", showApplyButton: "showApplyButton", showMatchModes: "showMatchModes", showAddButton: "showAddButton", hideOnClear: "hideOnClear", placeholder: "placeholder", matchModeOptions: "matchModeOptions", maxConstraints: "maxConstraints", minFractionDigits: "minFractionDigits", maxFractionDigits: "maxFractionDigits", prefix: "prefix", suffix: "suffix", locale: "locale", localeMatcher: "localeMatcher", currency: "currency", currencyDisplay: "currencyDisplay", useGrouping: "useGrouping", showButtons: "showButtons" }, host: { classAttribute: "p-element" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], viewQueries: [{ propertyName: "icon", first: true, predicate: ["icon"], descendants: true }, { propertyName: "clearButtonViewChild", first: true, predicate: ["clearBtn"], descendants: true }], ngImport: i0, template: `
        <div class="p-column-filter" [ngClass]="{ 'p-column-filter-row': display === 'row', 'p-column-filter-menu': display === 'menu' }">
            <p-columnFilterFormElement
                *ngIf="display === 'row'"
                class="p-fluid"
                [type]="type"
                [field]="field"
                [filterConstraint]="dt.filters[field]"
                [filterTemplate]="filterTemplate"
                [placeholder]="placeholder"
                [minFractionDigits]="minFractionDigits"
                [maxFractionDigits]="maxFractionDigits"
                [prefix]="prefix"
                [suffix]="suffix"
                [locale]="locale"
                [localeMatcher]="localeMatcher"
                [currency]="currency"
                [currencyDisplay]="currencyDisplay"
                [useGrouping]="useGrouping"
                [showButtons]="showButtons"
            ></p-columnFilterFormElement>
            <button
                #icon
                *ngIf="showMenuButton"
                type="button"
                class="p-column-filter-menu-button p-link"
                aria-haspopup="true"
                [attr.aria-label]="hasFilter() ? showMenuButtonWhenFilterAppliedAriaLabel : showMenuButtonAriaLabel"
                [attr.aria-controls]="overlayId"
                [attr.aria-expanded]="overlayVisible"
                [ngClass]="{ 'p-column-filter-menu-button-open': overlayVisible, 'p-column-filter-menu-button-active': hasFilter() }"
                (click)="toggleMenu()"
                (keydown)="onToggleButtonKeyDown($event)"
            >
                <FilterIcon [styleClass]="'pi-filter-icon'" *ngIf="!filterIconTemplate" />
                <span class="pi-filter-icon" *ngIf="filterIconTemplate">
                    <ng-template *ngTemplateOutlet="filterIconTemplate"></ng-template>
                </span>
            </button>
            <button #icon *ngIf="showClearButton && display === 'row'" [ngClass]="{ 'p-hidden-space': !hasRowFilter() }" type="button" class="p-column-filter-clear-button p-link" (click)="clearFilter()" [attr.aria-label]="clearButtonLabel">
                <FilterSlashIcon *ngIf="!clearFilterIconTemplate" />
                <ng-template *ngTemplateOutlet="clearFilterIconTemplate"></ng-template>
            </button>
            <div
                *ngIf="showMenu && overlayVisible"
                [ngClass]="{ 'p-column-filter-overlay p-component p-fluid': true, 'p-column-filter-overlay-menu': display === 'menu' }"
                [id]="overlayId"
                [attr.aria-modal]="true"
                role="dialog"
                [attr.aria-label]="'Filter by ' + field"
                (click)="onContentClick()"
                [@overlayAnimation]="'visible'"
                (@overlayAnimation.start)="onOverlayAnimationStart($event)"
                (@overlayAnimation.done)="onOverlayAnimationEnd($event)"
                (keydown.escape)="onEscape()"
            >
                <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: field }"></ng-container>
                <ul *ngIf="display === 'row'; else menu" class="p-column-filter-row-items">
                    <li
                        class="p-column-filter-row-item"
                        *ngFor="let matchMode of matchModes; let i = index"
                        (click)="onRowMatchModeChange(matchMode.value)"
                        (keydown)="onRowMatchModeKeyDown($event)"
                        (keydown.enter)="this.onRowMatchModeChange(matchMode.value)"
                        [ngClass]="{ 'p-highlight': isRowMatchModeSelected(matchMode.value) }"
                        [attr.tabindex]="i === 0 ? '0' : null"
                    >
                        {{ matchMode.label }}
                    </li>
                    <li class="p-column-filter-separator"></li>
                    <li class="p-column-filter-row-item" (click)="onRowClearItemClick()" (keydown)="onRowMatchModeKeyDown($event)" (keydown.enter)="onRowClearItemClick()">{{ noFilterLabel }}</li>
                </ul>
                <ng-template #menu>
                    <div class="p-column-filter-operator" *ngIf="isShowOperator">
                        <p-dropdown [options]="operatorOptions" [ngModel]="operator" (ngModelChange)="onOperatorChange($event)" styleClass="p-column-filter-operator-dropdown"></p-dropdown>
                    </div>
                    <div class="p-column-filter-constraints">
                        <div *ngFor="let fieldConstraint of fieldConstraints; let i = index" class="p-column-filter-constraint">
                            <p-dropdown
                                *ngIf="showMatchModes && matchModes"
                                [options]="matchModes"
                                [ngModel]="fieldConstraint.matchMode"
                                (ngModelChange)="onMenuMatchModeChange($event, fieldConstraint)"
                                styleClass="p-column-filter-matchmode-dropdown"
                            ></p-dropdown>
                            <p-columnFilterFormElement
                                [type]="type"
                                [field]="field"
                                [filterConstraint]="fieldConstraint"
                                [filterTemplate]="filterTemplate"
                                [placeholder]="placeholder"
                                [minFractionDigits]="minFractionDigits"
                                [maxFractionDigits]="maxFractionDigits"
                                [prefix]="prefix"
                                [suffix]="suffix"
                                [locale]="locale"
                                [localeMatcher]="localeMatcher"
                                [currency]="currency"
                                [currencyDisplay]="currencyDisplay"
                                [useGrouping]="useGrouping"
                            ></p-columnFilterFormElement>
                            <div>
                                <button
                                    *ngIf="showRemoveIcon"
                                    type="button"
                                    pButton
                                    class="p-column-filter-remove-button p-button-text p-button-danger p-button-sm"
                                    (click)="removeConstraint(fieldConstraint)"
                                    pRipple
                                    [attr.aria-label]="removeRuleButtonLabel"
                                    [label]="removeRuleButtonLabel"
                                >
                                    <TrashIcon *ngIf="!removeRuleIconTemplate" />
                                    <ng-template *ngTemplateOutlet="removeRuleIconTemplate"></ng-template>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="p-column-filter-add-rule" *ngIf="isShowAddConstraint">
                        <button type="button" pButton [label]="addRuleButtonLabel" [attr.aria-label]="addRuleButtonLabel" class="p-column-filter-add-button p-button-text p-button-sm" (click)="addConstraint()" pRipple>
                            <PlusIcon *ngIf="!addRuleIconTemplate" />
                            <ng-template *ngTemplateOutlet="addRuleIconTemplate"></ng-template>
                        </button>
                    </div>
                    <div class="p-column-filter-buttonbar">
                        <button #clearBtn *ngIf="showClearButton" type="button" pButton class="p-button-outlined p-button-sm" (click)="clearFilter()" [attr.aria-label]="clearButtonLabel" [label]="clearButtonLabel" pRipple></button>
                        <button *ngIf="showApplyButton" type="button" pButton (click)="applyFilter()" class="p-button-sm" [label]="applyButtonLabel" pRipple [attr.aria-label]="applyButtonLabel"></button>
                    </div>
                </ng-template>
                <ng-container *ngTemplateOutlet="footerTemplate; context: { $implicit: field }"></ng-container>
            </div>
        </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgForOf), selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i0.forwardRef(() => i3.Dropdown), selector: "p-dropdown", inputs: ["id", "scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "loadingIcon", "filterPlaceholder", "filterLocale", "variant", "inputId", "dataKey", "filterBy", "filterFields", "autofocus", "resetFilterOnHide", "checkmark", "dropdownIcon", "loading", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "ariaLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "focusOnHover", "selectOnFocus", "autoOptionFocus", "autofocusFilter", "autoShowPanelOnPrintableCharacterKeyDown", "disabled", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "filterValue", "options"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear", "onLazyLoad"] }, { kind: "directive", type: i0.forwardRef(() => i2$2.NgControlStatus), selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i0.forwardRef(() => i2$2.NgModel), selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i0.forwardRef(() => i3$1.ButtonDirective), selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i0.forwardRef(() => FilterIcon), selector: "FilterIcon" }, { kind: "component", type: i0.forwardRef(() => FilterSlashIcon), selector: "FilterSlashIcon" }, { kind: "component", type: i0.forwardRef(() => ColumnFilterFormElement), selector: "p-columnFilterFormElement", inputs: ["field", "type", "filterConstraint", "filterTemplate", "placeholder", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping"] }], animations: [trigger('overlayAnimation', [transition(':enter', [style({ opacity: 0, transform: 'scaleY(0.8)' }), animate('.12s cubic-bezier(0, 0, 0.2, 1)')]), transition(':leave', [animate('.1s linear', style({ opacity: 0 }))])])], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ColumnFilter, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-columnFilter',
                    template: `
        <div class="p-column-filter" [ngClass]="{ 'p-column-filter-row': display === 'row', 'p-column-filter-menu': display === 'menu' }">
            <p-columnFilterFormElement
                *ngIf="display === 'row'"
                class="p-fluid"
                [type]="type"
                [field]="field"
                [filterConstraint]="dt.filters[field]"
                [filterTemplate]="filterTemplate"
                [placeholder]="placeholder"
                [minFractionDigits]="minFractionDigits"
                [maxFractionDigits]="maxFractionDigits"
                [prefix]="prefix"
                [suffix]="suffix"
                [locale]="locale"
                [localeMatcher]="localeMatcher"
                [currency]="currency"
                [currencyDisplay]="currencyDisplay"
                [useGrouping]="useGrouping"
                [showButtons]="showButtons"
            ></p-columnFilterFormElement>
            <button
                #icon
                *ngIf="showMenuButton"
                type="button"
                class="p-column-filter-menu-button p-link"
                aria-haspopup="true"
                [attr.aria-label]="hasFilter() ? showMenuButtonWhenFilterAppliedAriaLabel : showMenuButtonAriaLabel"
                [attr.aria-controls]="overlayId"
                [attr.aria-expanded]="overlayVisible"
                [ngClass]="{ 'p-column-filter-menu-button-open': overlayVisible, 'p-column-filter-menu-button-active': hasFilter() }"
                (click)="toggleMenu()"
                (keydown)="onToggleButtonKeyDown($event)"
            >
                <FilterIcon [styleClass]="'pi-filter-icon'" *ngIf="!filterIconTemplate" />
                <span class="pi-filter-icon" *ngIf="filterIconTemplate">
                    <ng-template *ngTemplateOutlet="filterIconTemplate"></ng-template>
                </span>
            </button>
            <button #icon *ngIf="showClearButton && display === 'row'" [ngClass]="{ 'p-hidden-space': !hasRowFilter() }" type="button" class="p-column-filter-clear-button p-link" (click)="clearFilter()" [attr.aria-label]="clearButtonLabel">
                <FilterSlashIcon *ngIf="!clearFilterIconTemplate" />
                <ng-template *ngTemplateOutlet="clearFilterIconTemplate"></ng-template>
            </button>
            <div
                *ngIf="showMenu && overlayVisible"
                [ngClass]="{ 'p-column-filter-overlay p-component p-fluid': true, 'p-column-filter-overlay-menu': display === 'menu' }"
                [id]="overlayId"
                [attr.aria-modal]="true"
                role="dialog"
                [attr.aria-label]="'Filter by ' + field"
                (click)="onContentClick()"
                [@overlayAnimation]="'visible'"
                (@overlayAnimation.start)="onOverlayAnimationStart($event)"
                (@overlayAnimation.done)="onOverlayAnimationEnd($event)"
                (keydown.escape)="onEscape()"
            >
                <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: field }"></ng-container>
                <ul *ngIf="display === 'row'; else menu" class="p-column-filter-row-items">
                    <li
                        class="p-column-filter-row-item"
                        *ngFor="let matchMode of matchModes; let i = index"
                        (click)="onRowMatchModeChange(matchMode.value)"
                        (keydown)="onRowMatchModeKeyDown($event)"
                        (keydown.enter)="this.onRowMatchModeChange(matchMode.value)"
                        [ngClass]="{ 'p-highlight': isRowMatchModeSelected(matchMode.value) }"
                        [attr.tabindex]="i === 0 ? '0' : null"
                    >
                        {{ matchMode.label }}
                    </li>
                    <li class="p-column-filter-separator"></li>
                    <li class="p-column-filter-row-item" (click)="onRowClearItemClick()" (keydown)="onRowMatchModeKeyDown($event)" (keydown.enter)="onRowClearItemClick()">{{ noFilterLabel }}</li>
                </ul>
                <ng-template #menu>
                    <div class="p-column-filter-operator" *ngIf="isShowOperator">
                        <p-dropdown [options]="operatorOptions" [ngModel]="operator" (ngModelChange)="onOperatorChange($event)" styleClass="p-column-filter-operator-dropdown"></p-dropdown>
                    </div>
                    <div class="p-column-filter-constraints">
                        <div *ngFor="let fieldConstraint of fieldConstraints; let i = index" class="p-column-filter-constraint">
                            <p-dropdown
                                *ngIf="showMatchModes && matchModes"
                                [options]="matchModes"
                                [ngModel]="fieldConstraint.matchMode"
                                (ngModelChange)="onMenuMatchModeChange($event, fieldConstraint)"
                                styleClass="p-column-filter-matchmode-dropdown"
                            ></p-dropdown>
                            <p-columnFilterFormElement
                                [type]="type"
                                [field]="field"
                                [filterConstraint]="fieldConstraint"
                                [filterTemplate]="filterTemplate"
                                [placeholder]="placeholder"
                                [minFractionDigits]="minFractionDigits"
                                [maxFractionDigits]="maxFractionDigits"
                                [prefix]="prefix"
                                [suffix]="suffix"
                                [locale]="locale"
                                [localeMatcher]="localeMatcher"
                                [currency]="currency"
                                [currencyDisplay]="currencyDisplay"
                                [useGrouping]="useGrouping"
                            ></p-columnFilterFormElement>
                            <div>
                                <button
                                    *ngIf="showRemoveIcon"
                                    type="button"
                                    pButton
                                    class="p-column-filter-remove-button p-button-text p-button-danger p-button-sm"
                                    (click)="removeConstraint(fieldConstraint)"
                                    pRipple
                                    [attr.aria-label]="removeRuleButtonLabel"
                                    [label]="removeRuleButtonLabel"
                                >
                                    <TrashIcon *ngIf="!removeRuleIconTemplate" />
                                    <ng-template *ngTemplateOutlet="removeRuleIconTemplate"></ng-template>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="p-column-filter-add-rule" *ngIf="isShowAddConstraint">
                        <button type="button" pButton [label]="addRuleButtonLabel" [attr.aria-label]="addRuleButtonLabel" class="p-column-filter-add-button p-button-text p-button-sm" (click)="addConstraint()" pRipple>
                            <PlusIcon *ngIf="!addRuleIconTemplate" />
                            <ng-template *ngTemplateOutlet="addRuleIconTemplate"></ng-template>
                        </button>
                    </div>
                    <div class="p-column-filter-buttonbar">
                        <button #clearBtn *ngIf="showClearButton" type="button" pButton class="p-button-outlined p-button-sm" (click)="clearFilter()" [attr.aria-label]="clearButtonLabel" [label]="clearButtonLabel" pRipple></button>
                        <button *ngIf="showApplyButton" type="button" pButton (click)="applyFilter()" class="p-button-sm" [label]="applyButtonLabel" pRipple [attr.aria-label]="applyButtonLabel"></button>
                    </div>
                </ng-template>
                <ng-container *ngTemplateOutlet="footerTemplate; context: { $implicit: field }"></ng-container>
            </div>
        </div>
    `,
                    animations: [trigger('overlayAnimation', [transition(':enter', [style({ opacity: 0, transform: 'scaleY(0.8)' }), animate('.12s cubic-bezier(0, 0, 0.2, 1)')]), transition(':leave', [animate('.1s linear', style({ opacity: 0 }))])])],
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }, { type: Table }, { type: i0.Renderer2 }, { type: i1$1.PrimeNGConfig }, { type: i1$1.OverlayService }, { type: i0.ChangeDetectorRef }], propDecorators: { field: [{
                type: Input
            }], type: [{
                type: Input
            }], display: [{
                type: Input
            }], showMenu: [{
                type: Input
            }], matchMode: [{
                type: Input
            }], operator: [{
                type: Input
            }], showOperator: [{
                type: Input
            }], showMenuButtonAriaLabel: [{
                type: Input
            }], showMenuButtonWhenFilterAppliedAriaLabel: [{
                type: Input
            }], showClearButton: [{
                type: Input
            }], showApplyButton: [{
                type: Input
            }], showMatchModes: [{
                type: Input
            }], showAddButton: [{
                type: Input
            }], hideOnClear: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], matchModeOptions: [{
                type: Input
            }], maxConstraints: [{
                type: Input
            }], minFractionDigits: [{
                type: Input
            }], maxFractionDigits: [{
                type: Input
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }], locale: [{
                type: Input
            }], localeMatcher: [{
                type: Input
            }], currency: [{
                type: Input
            }], currencyDisplay: [{
                type: Input
            }], useGrouping: [{
                type: Input
            }], showButtons: [{
                type: Input
            }], icon: [{
                type: ViewChild,
                args: ['icon']
            }], clearButtonViewChild: [{
                type: ViewChild,
                args: ['clearBtn']
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }] } });
class ColumnFilterFormElement {
    get showButtons() {
        return this.colFilter.showButtons;
    }
    constructor(dt, colFilter) {
        this.dt = dt;
        this.colFilter = colFilter;
        this.useGrouping = true;
    }
    ngOnInit() {
        this.filterCallback = (value) => {
            this.filterConstraint.value = value;
            this.dt._filter();
        };
    }
    onModelChange(value) {
        this.filterConstraint.value = value;
        if (this.type === 'date' || this.type === 'boolean' || value === '') {
            this.dt._filter();
        }
    }
    onTextInputEnterKeyDown(event) {
        this.dt._filter();
        event.preventDefault();
    }
    onNumericInputKeyDown(event) {
        if (event.key === 'Enter') {
            this.dt._filter();
            event.preventDefault();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ColumnFilterFormElement, deps: [{ token: Table }, { token: ColumnFilter }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ColumnFilterFormElement, selector: "p-columnFilterFormElement", inputs: { field: "field", type: "type", filterConstraint: "filterConstraint", filterTemplate: "filterTemplate", placeholder: "placeholder", minFractionDigits: "minFractionDigits", maxFractionDigits: "maxFractionDigits", prefix: "prefix", suffix: "suffix", locale: "locale", localeMatcher: "localeMatcher", currency: "currency", currencyDisplay: "currencyDisplay", useGrouping: "useGrouping" }, host: { classAttribute: "p-element" }, ngImport: i0, template: `
        <ng-container *ngIf="filterTemplate; else builtInElement">
            <ng-container
                *ngTemplateOutlet="
                    filterTemplate;
                    context: {
                        $implicit: filterConstraint.value,
                        filterCallback: filterCallback,
                        type: type,
                        field: field,
                        filterConstraint: filterConstraint,
                        placeholder: placeholder,
                        minFractionDigits: minFractionDigits,
                        maxFractionDigits: maxFractionDigits,
                        prefix: prefix,
                        suffix: suffix,
                        locale: locale,
                        localeMatcher: localeMatcher,
                        currency: currency,
                        currencyDisplay: currencyDisplay,
                        useGrouping: useGrouping,
                        showButtons: showButtons
                    }
                "
            ></ng-container>
        </ng-container>
        <ng-template #builtInElement>
            <ng-container [ngSwitch]="type">
                <input *ngSwitchCase="'text'" type="text" pInputText [value]="filterConstraint?.value" (input)="onModelChange($event.target.value)" (keydown.enter)="onTextInputEnterKeyDown($event)" [attr.placeholder]="placeholder" aria-label="Filter text" />
                <p-inputNumber
                    *ngSwitchCase="'numeric'"
                    [ngModel]="filterConstraint?.value"
                    (ngModelChange)="onModelChange($event)"
                    (onKeyDown)="onNumericInputKeyDown($event)"
                    [showButtons]="showButtons"
                    [minFractionDigits]="minFractionDigits"
                    [maxFractionDigits]="maxFractionDigits"
                    [prefix]="prefix"
                    [suffix]="suffix"
                    [placeholder]="placeholder"
                    [mode]="currency ? 'currency' : 'decimal'"
                    [locale]="locale"
                    [localeMatcher]="localeMatcher"
                    [currency]="currency"
                    [currencyDisplay]="currencyDisplay"
                    [useGrouping]="useGrouping"
                    [ariaLabel]="'Filter number'"
                ></p-inputNumber>
                <p-triStateCheckbox *ngSwitchCase="'boolean'" [ngModel]="filterConstraint?.value" (ngModelChange)="onModelChange($event)" [ariaLabel]="'Filter value'"></p-triStateCheckbox>
                <p-calendar *ngSwitchCase="'date'" [placeholder]="placeholder" [ngModel]="filterConstraint?.value" (ngModelChange)="onModelChange($event)" [ariaLabel]="'Filter date'"></p-calendar>
            </ng-container>
        </ng-template>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: i4.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabelledBy", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "variant", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "showClear", "autofocus", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown", "onClear"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$2.InputText, selector: "[pInputText]", inputs: ["variant"] }, { kind: "component", type: i3$3.Calendar, selector: "p-calendar", inputs: ["iconDisplay", "style", "styleClass", "inputStyle", "inputId", "name", "inputStyleClass", "placeholder", "ariaLabelledBy", "ariaLabel", "iconAriaLabel", "disabled", "dateFormat", "multipleSeparator", "rangeSeparator", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "monthNavigator", "yearNavigator", "hourFormat", "timeOnly", "stepYearPicker", "stepHour", "stepMinute", "stepSecond", "showSeconds", "required", "showOnFocus", "showWeek", "startWeekFromFirstDayOfYear", "showClear", "dataType", "selectionMode", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "autofocus", "autoZIndex", "baseZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "touchUI", "timeSeparator", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "tabindex", "variant", "minDate", "maxDate", "disabledDates", "disabledDays", "yearRange", "showTime", "responsiveOptions", "numberOfMonths", "firstDayOfWeek", "locale", "view", "defaultDate"], outputs: ["onFocus", "onBlur", "onClose", "onSelect", "onClear", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange", "onClickOutside", "onShow"] }, { kind: "component", type: i11.TriStateCheckbox, selector: "p-triStateCheckbox", inputs: ["disabled", "name", "ariaLabel", "ariaLabelledBy", "variant", "tabindex", "inputId", "style", "styleClass", "label", "readonly", "checkboxTrueIcon", "checkboxFalseIcon", "autofocus"], outputs: ["onChange"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ColumnFilterFormElement, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-columnFilterFormElement',
                    template: `
        <ng-container *ngIf="filterTemplate; else builtInElement">
            <ng-container
                *ngTemplateOutlet="
                    filterTemplate;
                    context: {
                        $implicit: filterConstraint.value,
                        filterCallback: filterCallback,
                        type: type,
                        field: field,
                        filterConstraint: filterConstraint,
                        placeholder: placeholder,
                        minFractionDigits: minFractionDigits,
                        maxFractionDigits: maxFractionDigits,
                        prefix: prefix,
                        suffix: suffix,
                        locale: locale,
                        localeMatcher: localeMatcher,
                        currency: currency,
                        currencyDisplay: currencyDisplay,
                        useGrouping: useGrouping,
                        showButtons: showButtons
                    }
                "
            ></ng-container>
        </ng-container>
        <ng-template #builtInElement>
            <ng-container [ngSwitch]="type">
                <input *ngSwitchCase="'text'" type="text" pInputText [value]="filterConstraint?.value" (input)="onModelChange($event.target.value)" (keydown.enter)="onTextInputEnterKeyDown($event)" [attr.placeholder]="placeholder" aria-label="Filter text" />
                <p-inputNumber
                    *ngSwitchCase="'numeric'"
                    [ngModel]="filterConstraint?.value"
                    (ngModelChange)="onModelChange($event)"
                    (onKeyDown)="onNumericInputKeyDown($event)"
                    [showButtons]="showButtons"
                    [minFractionDigits]="minFractionDigits"
                    [maxFractionDigits]="maxFractionDigits"
                    [prefix]="prefix"
                    [suffix]="suffix"
                    [placeholder]="placeholder"
                    [mode]="currency ? 'currency' : 'decimal'"
                    [locale]="locale"
                    [localeMatcher]="localeMatcher"
                    [currency]="currency"
                    [currencyDisplay]="currencyDisplay"
                    [useGrouping]="useGrouping"
                    [ariaLabel]="'Filter number'"
                ></p-inputNumber>
                <p-triStateCheckbox *ngSwitchCase="'boolean'" [ngModel]="filterConstraint?.value" (ngModelChange)="onModelChange($event)" [ariaLabel]="'Filter value'"></p-triStateCheckbox>
                <p-calendar *ngSwitchCase="'date'" [placeholder]="placeholder" [ngModel]="filterConstraint?.value" (ngModelChange)="onModelChange($event)" [ariaLabel]="'Filter date'"></p-calendar>
            </ng-container>
        </ng-template>
    `,
                    encapsulation: ViewEncapsulation.None,
                    host: {
                        class: 'p-element'
                    }
                }]
        }], ctorParameters: () => [{ type: Table }, { type: ColumnFilter }], propDecorators: { field: [{
                type: Input
            }], type: [{
                type: Input
            }], filterConstraint: [{
                type: Input
            }], filterTemplate: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], minFractionDigits: [{
                type: Input
            }], maxFractionDigits: [{
                type: Input
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }], locale: [{
                type: Input
            }], localeMatcher: [{
                type: Input
            }], currency: [{
                type: Input
            }], currencyDisplay: [{
                type: Input
            }], useGrouping: [{
                type: Input
            }] } });
class TableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: TableModule, declarations: [Table, SortableColumn, FrozenColumn, RowGroupHeader, SelectableRow, RowToggler, ContextMenuRow, ResizableColumn, ReorderableColumn, EditableColumn, CellEditor, TableBody, SortIcon, TableRadioButton, TableCheckbox, TableHeaderCheckbox, ReorderableRowHandle, ReorderableRow, SelectableRowDblClick, EditableRow, InitEditableRow, SaveEditableRow, CancelEditableRow, ColumnFilter, ColumnFilterFormElement], imports: [CommonModule,
            PaginatorModule,
            InputTextModule,
            DropdownModule,
            FormsModule,
            ButtonModule,
            SelectButtonModule,
            CalendarModule,
            InputNumberModule,
            TriStateCheckboxModule,
            ScrollerModule,
            ArrowDownIcon,
            ArrowUpIcon,
            SpinnerIcon,
            SortAltIcon,
            SortAmountUpAltIcon,
            SortAmountDownIcon,
            CheckIcon,
            FilterIcon,
            FilterSlashIcon], exports: [Table, SharedModule, SortableColumn, FrozenColumn, RowGroupHeader, SelectableRow, RowToggler, ContextMenuRow, ResizableColumn, ReorderableColumn, EditableColumn, CellEditor, SortIcon, TableRadioButton, TableCheckbox, TableHeaderCheckbox, ReorderableRowHandle, ReorderableRow, SelectableRowDblClick, EditableRow, InitEditableRow, SaveEditableRow, CancelEditableRow, ColumnFilter, ColumnFilterFormElement, ScrollerModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableModule, imports: [CommonModule,
            PaginatorModule,
            InputTextModule,
            DropdownModule,
            FormsModule,
            ButtonModule,
            SelectButtonModule,
            CalendarModule,
            InputNumberModule,
            TriStateCheckboxModule,
            ScrollerModule,
            ArrowDownIcon,
            ArrowUpIcon,
            SpinnerIcon,
            SortAltIcon,
            SortAmountUpAltIcon,
            SortAmountDownIcon,
            CheckIcon,
            FilterIcon,
            FilterSlashIcon, SharedModule,
            ScrollerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        PaginatorModule,
                        InputTextModule,
                        DropdownModule,
                        FormsModule,
                        ButtonModule,
                        SelectButtonModule,
                        CalendarModule,
                        InputNumberModule,
                        TriStateCheckboxModule,
                        ScrollerModule,
                        ArrowDownIcon,
                        ArrowUpIcon,
                        SpinnerIcon,
                        SortAltIcon,
                        SortAmountUpAltIcon,
                        SortAmountDownIcon,
                        CheckIcon,
                        FilterIcon,
                        FilterSlashIcon
                    ],
                    exports: [
                        Table,
                        SharedModule,
                        SortableColumn,
                        FrozenColumn,
                        RowGroupHeader,
                        SelectableRow,
                        RowToggler,
                        ContextMenuRow,
                        ResizableColumn,
                        ReorderableColumn,
                        EditableColumn,
                        CellEditor,
                        SortIcon,
                        TableRadioButton,
                        TableCheckbox,
                        TableHeaderCheckbox,
                        ReorderableRowHandle,
                        ReorderableRow,
                        SelectableRowDblClick,
                        EditableRow,
                        InitEditableRow,
                        SaveEditableRow,
                        CancelEditableRow,
                        ColumnFilter,
                        ColumnFilterFormElement,
                        ScrollerModule
                    ],
                    declarations: [
                        Table,
                        SortableColumn,
                        FrozenColumn,
                        RowGroupHeader,
                        SelectableRow,
                        RowToggler,
                        ContextMenuRow,
                        ResizableColumn,
                        ReorderableColumn,
                        EditableColumn,
                        CellEditor,
                        TableBody,
                        SortIcon,
                        TableRadioButton,
                        TableCheckbox,
                        TableHeaderCheckbox,
                        ReorderableRowHandle,
                        ReorderableRow,
                        SelectableRowDblClick,
                        EditableRow,
                        InitEditableRow,
                        SaveEditableRow,
                        CancelEditableRow,
                        ColumnFilter,
                        ColumnFilterFormElement
                    ]
                }]
        }] });

class Messages {
    /**
     * An array of messages to display.
     * @group Props
     */
    set value(messages) {
        this.messages = messages;
        this.startMessageLifes(this.messages);
    }
    constructor(messageService, el, cd, config) {
        this.messageService = messageService;
        this.el = el;
        this.cd = cd;
        this.config = config;
        /**
         * Defines if message box can be closed by the click icon.
         * @group Props
         */
        this.closable = true;
        /**
         * Whether displaying services messages are enabled.
         * @group Props
         */
        this.enableService = true;
        /**
         * Whether displaying messages would be escaped or not.
         * @group Props
         */
        this.escape = true;
        /**
         * Transition options of the show animation.
         * @group Props
         */
        this.showTransitionOptions = '300ms ease-out';
        /**
         * Transition options of the hide animation.
         * @group Props
         */
        this.hideTransitionOptions = '200ms cubic-bezier(0.86, 0, 0.07, 1)';
        /**
         * This function is executed when the value changes.
         * @param {Message[]} value - messages value.
         * @group Emits
         */
        this.valueChange = new EventEmitter();
        this.timerSubscriptions = [];
    }
    ngAfterContentInit() {
        this.templates?.forEach((item) => {
            switch (item.getType()) {
                case 'content':
                    this.contentTemplate = item.template;
                    break;
                default:
                    this.contentTemplate = item.template;
                    break;
            }
        });
        if (this.messageService && this.enableService && !this.contentTemplate) {
            this.messageSubscription = this.messageService.messageObserver.subscribe((messages) => {
                if (messages) {
                    if (!Array.isArray(messages)) {
                        messages = [messages];
                    }
                    const filteredMessages = messages.filter((m) => this.key === m.key);
                    this.messages = this.messages ? [...this.messages, ...filteredMessages] : [...filteredMessages];
                    this.startMessageLifes(filteredMessages);
                    this.cd.markForCheck();
                }
            });
            this.clearSubscription = this.messageService.clearObserver.subscribe((key) => {
                if (key) {
                    if (this.key === key) {
                        this.messages = null;
                    }
                }
                else {
                    this.messages = null;
                }
                this.cd.markForCheck();
            });
        }
    }
    hasMessages() {
        let parentEl = this.el.nativeElement.parentElement;
        if (parentEl && parentEl.offsetParent) {
            return this.contentTemplate != null || (this.messages && this.messages.length > 0);
        }
        return false;
    }
    clear() {
        this.messages = [];
        this.valueChange.emit(this.messages);
    }
    removeMessage(i) {
        this.messages = this.messages?.filter((msg, index) => index !== i);
        this.valueChange.emit(this.messages);
    }
    get icon() {
        const severity = this.severity || (this.hasMessages() ? this.messages[0].severity : null);
        if (this.hasMessages()) {
            switch (severity) {
                case 'success':
                    return 'pi-check';
                case 'info':
                    return 'pi-info-circle';
                case 'error':
                    return 'pi-times';
                case 'warn':
                    return 'pi-exclamation-triangle';
                default:
                    return 'pi-info-circle';
            }
        }
        return null;
    }
    get closeAriaLabel() {
        return this.config.translation.aria ? this.config.translation.aria.close : undefined;
    }
    ngOnDestroy() {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }
        if (this.clearSubscription) {
            this.clearSubscription.unsubscribe();
        }
        this.timerSubscriptions?.forEach((subscription) => subscription.unsubscribe());
    }
    startMessageLifes(messages) {
        messages?.forEach((message) => message.life && this.startMessageLife(message));
    }
    startMessageLife(message) {
        const timerSubsctiption = timer(message.life).subscribe(() => {
            this.messages = this.messages?.filter((msgEl) => msgEl !== message);
            this.timerSubscriptions = this.timerSubscriptions?.filter((timerEl) => timerEl !== timerSubsctiption);
            this.valueChange.emit(this.messages);
            this.cd.markForCheck();
        });
        this.timerSubscriptions.push(timerSubsctiption);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Messages, deps: [{ token: i1$1.MessageService, optional: true }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.PrimeNGConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: Messages, selector: "p-messages", inputs: { value: "value", closable: "closable", style: "style", styleClass: "styleClass", enableService: "enableService", key: "key", escape: "escape", severity: "severity", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions" }, outputs: { valueChange: "valueChange" }, host: { classAttribute: "p-element" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], ngImport: i0, template: "<div class=\"p-messages p-component\" role=\"alert\" [ngStyle]=\"style\" [class]=\"styleClass\" [attr.aria-atomic]=\"true\" [attr.aria-live]=\"'assertive'\" [attr.data-pc-name]=\"'message'\">\r\n  <ng-container *ngIf=\"!contentTemplate; else staticMessage\">\r\n    <div *ngFor=\"let msg of messages; let i = index\"\r\n         [class]=\"'p-message p-message-' + msg.severity\"\r\n         role=\"alert\"\r\n         [@messageAnimation]=\"{ value: 'visible', params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions } }\">\r\n      <div class=\"p-message-wrapper\" [attr.data-pc-section]=\"'wrapper'\">\r\n        <span *ngIf=\"msg.icon\" [class]=\"'p-message-icon pi ' + msg.icon\" [attr.data-pc-section]=\"'icon'\"> </span>\r\n        <span class=\"p-message-icon\" *ngIf=\"!msg.icon\">\r\n          <ng-container>\r\n            <CheckIcon *ngIf=\"msg.severity === 'success'\" [attr.data-pc-section]=\"'icon'\" />\r\n            <InfoCircleIcon *ngIf=\"msg.severity === 'info'\" [attr.data-pc-section]=\"'icon'\" />\r\n            <TimesCircleIcon *ngIf=\"msg.severity === 'error'\" [attr.data-pc-section]=\"'icon'\" />\r\n            <ExclamationTriangleIcon *ngIf=\"msg.severity === 'warn'\" [attr.data-pc-section]=\"'icon'\" />\r\n          </ng-container>\r\n        </span>\r\n        <ng-container *ngIf=\"!escape; else escapeOut\">\r\n          <span *ngIf=\"msg.summary\" class=\"p-message-summary\" [innerHTML]=\"msg.summary\" [attr.data-pc-section]=\"'summary'\"></span>\r\n          <span *ngIf=\"msg.detail\" class=\"p-message-detail\" [innerHTML]=\"msg.detail\" [attr.data-pc-section]=\"'detail'\"></span>\r\n        </ng-container>\r\n        <ng-template #escapeOut>\r\n          <span *ngIf=\"msg.summary\" class=\"p-message-summary\" [attr.data-pc-section]=\"'summary'\">{{ msg.summary }}</span>\r\n          <span *ngIf=\"msg.detail\" class=\"p-message-detail\" [attr.data-pc-section]=\"'detail'\">{{ msg.detail }}</span>\r\n        </ng-template>\r\n        <button class=\"p-message-close p-link\" (click)=\"removeMessage(i)\" *ngIf=\"closable\" type=\"button\" pRipple [attr.aria-label]=\"closeAriaLabel\" [attr.data-pc-section]=\"'closebutton'\">\r\n          <TimesIcon [styleClass]=\"'p-message-close-icon'\" [attr.data-pc-section]=\"'closeicon'\" />\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #staticMessage>\r\n    <div [ngClass]=\"'p-message p-message-' + severity\" role=\"alert\">\r\n      <div class=\"p-message-wrapper\">\r\n        <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: ["@layer primeng{.p-message-wrapper{display:flex;align-items:center}.p-message-close{display:flex;align-items:center;justify-content:center;flex:none}.p-message-close.p-link{margin-left:auto;overflow:hidden;position:relative}.p-messages .p-message.ng-animating{overflow:hidden}}\n"], dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgForOf), selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgStyle), selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i0.forwardRef(() => i6.Ripple), selector: "[pRipple]" }, { kind: "component", type: i0.forwardRef(() => CheckIcon), selector: "CheckIcon" }, { kind: "component", type: i0.forwardRef(() => InfoCircleIcon), selector: "InfoCircleIcon" }, { kind: "component", type: i0.forwardRef(() => TimesCircleIcon), selector: "TimesCircleIcon" }, { kind: "component", type: i0.forwardRef(() => ExclamationTriangleIcon), selector: "ExclamationTriangleIcon" }, { kind: "component", type: i0.forwardRef(() => TimesIcon), selector: "TimesIcon" }], animations: [
            trigger('messageAnimation', [
                transition(':enter', [style({ opacity: 0, transform: 'translateY(-25%)' }), animate('{{showTransitionParams}}')]),
                transition(':leave', [animate('{{hideTransitionParams}}', style({ height: 0, marginTop: 0, marginBottom: 0, marginLeft: 0, marginRight: 0, opacity: 0 }))])
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: Messages, decorators: [{
            type: Component,
            args: [{ selector: 'p-messages', animations: [
                        trigger('messageAnimation', [
                            transition(':enter', [style({ opacity: 0, transform: 'translateY(-25%)' }), animate('{{showTransitionParams}}')]),
                            transition(':leave', [animate('{{hideTransitionParams}}', style({ height: 0, marginTop: 0, marginBottom: 0, marginLeft: 0, marginRight: 0, opacity: 0 }))])
                        ])
                    ], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, host: {
                        'class': 'p-element'
                    }, template: "<div class=\"p-messages p-component\" role=\"alert\" [ngStyle]=\"style\" [class]=\"styleClass\" [attr.aria-atomic]=\"true\" [attr.aria-live]=\"'assertive'\" [attr.data-pc-name]=\"'message'\">\r\n  <ng-container *ngIf=\"!contentTemplate; else staticMessage\">\r\n    <div *ngFor=\"let msg of messages; let i = index\"\r\n         [class]=\"'p-message p-message-' + msg.severity\"\r\n         role=\"alert\"\r\n         [@messageAnimation]=\"{ value: 'visible', params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions } }\">\r\n      <div class=\"p-message-wrapper\" [attr.data-pc-section]=\"'wrapper'\">\r\n        <span *ngIf=\"msg.icon\" [class]=\"'p-message-icon pi ' + msg.icon\" [attr.data-pc-section]=\"'icon'\"> </span>\r\n        <span class=\"p-message-icon\" *ngIf=\"!msg.icon\">\r\n          <ng-container>\r\n            <CheckIcon *ngIf=\"msg.severity === 'success'\" [attr.data-pc-section]=\"'icon'\" />\r\n            <InfoCircleIcon *ngIf=\"msg.severity === 'info'\" [attr.data-pc-section]=\"'icon'\" />\r\n            <TimesCircleIcon *ngIf=\"msg.severity === 'error'\" [attr.data-pc-section]=\"'icon'\" />\r\n            <ExclamationTriangleIcon *ngIf=\"msg.severity === 'warn'\" [attr.data-pc-section]=\"'icon'\" />\r\n          </ng-container>\r\n        </span>\r\n        <ng-container *ngIf=\"!escape; else escapeOut\">\r\n          <span *ngIf=\"msg.summary\" class=\"p-message-summary\" [innerHTML]=\"msg.summary\" [attr.data-pc-section]=\"'summary'\"></span>\r\n          <span *ngIf=\"msg.detail\" class=\"p-message-detail\" [innerHTML]=\"msg.detail\" [attr.data-pc-section]=\"'detail'\"></span>\r\n        </ng-container>\r\n        <ng-template #escapeOut>\r\n          <span *ngIf=\"msg.summary\" class=\"p-message-summary\" [attr.data-pc-section]=\"'summary'\">{{ msg.summary }}</span>\r\n          <span *ngIf=\"msg.detail\" class=\"p-message-detail\" [attr.data-pc-section]=\"'detail'\">{{ msg.detail }}</span>\r\n        </ng-template>\r\n        <button class=\"p-message-close p-link\" (click)=\"removeMessage(i)\" *ngIf=\"closable\" type=\"button\" pRipple [attr.aria-label]=\"closeAriaLabel\" [attr.data-pc-section]=\"'closebutton'\">\r\n          <TimesIcon [styleClass]=\"'p-message-close-icon'\" [attr.data-pc-section]=\"'closeicon'\" />\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #staticMessage>\r\n    <div [ngClass]=\"'p-message p-message-' + severity\" role=\"alert\">\r\n      <div class=\"p-message-wrapper\">\r\n        <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: ["@layer primeng{.p-message-wrapper{display:flex;align-items:center}.p-message-close{display:flex;align-items:center;justify-content:center;flex:none}.p-message-close.p-link{margin-left:auto;overflow:hidden;position:relative}.p-messages .p-message.ng-animating{overflow:hidden}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.MessageService, decorators: [{
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.PrimeNGConfig }], propDecorators: { value: [{
                type: Input
            }], closable: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], enableService: [{
                type: Input
            }], key: [{
                type: Input
            }], escape: [{
                type: Input
            }], severity: [{
                type: Input
            }], showTransitionOptions: [{
                type: Input
            }], hideTransitionOptions: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }] } });
class MessagesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MessagesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: MessagesModule, declarations: [Messages], imports: [CommonModule, RippleModule, CheckIcon, InfoCircleIcon, TimesCircleIcon, ExclamationTriangleIcon, TimesIcon], exports: [Messages] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MessagesModule, imports: [CommonModule, RippleModule, CheckIcon, InfoCircleIcon, TimesCircleIcon, ExclamationTriangleIcon, TimesIcon] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MessagesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, RippleModule, CheckIcon, InfoCircleIcon, TimesCircleIcon, ExclamationTriangleIcon, TimesIcon],
                    exports: [Messages],
                    declarations: [Messages]
                }]
        }] });

/**
 * FileUpload is an advanced uploader with dragdrop support, multi file uploads, auto uploading, progress tracking and validations.
 * @group Components
 */
class FileUpload {
    set files(files) {
        this._files = [];
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (this.validate(file)) {
                if (this.isImage(file)) {
                    file.objectURL = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(files[i]));
                }
                this._files.push(files[i]);
            }
        }
    }
    get files() {
        return this._files;
    }
    get basicButtonLabel() {
        if (this.auto || !this.hasFiles()) {
            return this.chooseLabel;
        }
        return this.uploadLabel ?? this.files[0].name;
    }
    constructor(document, platformId, renderer, el, sanitizer, zone, http, cd, config) {
        this.document = document;
        this.platformId = platformId;
        this.renderer = renderer;
        this.el = el;
        this.sanitizer = sanitizer;
        this.zone = zone;
        this.http = http;
        this.cd = cd;
        this.config = config;
        /**
         * HTTP method to send the files to the url such as "post" and "put".
         * @group Props
         */
        this.method = 'post';
        /**
         * Summary message of the invalid file size.
         * @group Props
         */
        this.invalidFileSizeMessageSummary = '{0}: Invalid file size, ';
        /**
         * Detail message of the invalid file size.
         * @group Props
         */
        this.invalidFileSizeMessageDetail = 'maximum upload size is {0}.';
        /**
         * Summary message of the invalid file type.
         * @group Props
         */
        this.invalidFileTypeMessageSummary = '{0}: Invalid file type, ';
        /**
         * Detail message of the invalid file type.
         * @group Props
         */
        this.invalidFileTypeMessageDetail = 'allowed file types: {0}.';
        /**
         * Detail message of the invalid file type.
         * @group Props
         */
        this.invalidFileLimitMessageDetail = 'limit is {0} at most.';
        /**
         * Summary message of the invalid file type.
         * @group Props
         */
        this.invalidFileLimitMessageSummary = 'Maximum number of files exceeded, ';
        /**
         * Width of the image thumbnail in pixels.
         * @group Props
         */
        this.previewWidth = 50;
        /**
         * Icon of the choose button.
         * @group Props
         */
        this.chooseIcon = 'fas fa-plus';
        /**
         * Icon of the upload button.
         * @group Props
         */
        this.uploadIcon = 'fas fa-upload';
        /**
         * Icon of the cancel button.
         * @group Props
         */
        this.cancelIcon = 'fas fa-times';
        /**
         * Whether to show the upload button.
         * @group Props
         */
        this.showUploadButton = true;
        /**
         * Whether to show the cancel button.
         * @group Props
         */
        this.showCancelButton = true;
        /**
         * Defines the UI of the component.
         * @group Props
         */
        this.mode = 'advanced';
        // dspx-core customisation made, please merge carefully when updating this with the latest from PrimeNg's GitHub.
        this.uploadedFiles = [];
        /**
         * Callback to invoke before file upload is initialized.
         * @param {FileBeforeUploadEvent} event - Custom upload event.
         * @group Emits
         */
        this.onBeforeUpload = new EventEmitter();
        /**
         * An event indicating that the request was sent to the server. Useful when a request may be retried multiple times, to distinguish between retries on the final event stream.
         * @param {FileSendEvent} event - Custom send event.
         * @group Emits
         */
        this.onSend = new EventEmitter();
        /**
         * Callback to invoke when file upload is complete.
         * @param {FileUploadEvent} event - Custom upload event.
         * @group Emits
         */
        this.onUpload = new EventEmitter();
        /**
         * Callback to invoke if file upload fails.
         * @param {FileUploadErrorEvent} event - Custom error event.
         * @group Emits
         */
        this.onError = new EventEmitter();
        /**
         * Callback to invoke when files in queue are removed without uploading using clear all button.
         * @param {Event} event - Browser event.
         * @group Emits
         */
        this.onClear = new EventEmitter();
        /**
         * Callback to invoke when a file is removed without uploading using clear button of a file.
         * @param {FileRemoveEvent} event - Remove event.
         * @group Emits
         */
        this.onRemove = new EventEmitter();
        /**
         * Callback to invoke when files are selected.
         * @param {FileSelectEvent} event - Select event.
         * @group Emits
         */
        this.onSelect = new EventEmitter();
        /**
         * Callback to invoke when files are being uploaded.
         * @param {FileProgressEvent} event - Progress event.
         * @group Emits
         */
        this.onProgress = new EventEmitter();
        /**
         * Callback to invoke in custom upload mode to upload the files manually.
         * @param {FileUploadHandlerEvent} event - Upload handler event.
         * @group Emits
         */
        this.uploadHandler = new EventEmitter();
        /**
         * This event is triggered if an error occurs while loading an image file.
         * @param {Event} event - Browser event.
         * @group Emits
         */
        this.onImageError = new EventEmitter();
        this._files = [];
        this.progress = 0;
        this.uploadedFileCount = 0;
    }
    ngAfterContentInit() {
        this.templates?.forEach((item) => {
            switch (item.getType()) {
                case 'file':
                    this.fileTemplate = item.template;
                    break;
                case 'content':
                    this.contentTemplate = item.template;
                    break;
                case 'toolbar':
                    this.toolbarTemplate = item.template;
                    break;
                case 'chooseicon':
                    this.chooseIconTemplate = item.template;
                    break;
                case 'uploadicon':
                    this.uploadIconTemplate = item.template;
                    break;
                case 'cancelicon':
                    this.cancelIconTemplate = item.template;
                    break;
                default:
                    this.fileTemplate = item.template;
                    break;
            }
        });
    }
    ngOnInit() {
        this.translationSubscription = this.config.translationObserver.subscribe(() => {
            this.cd.markForCheck();
        });
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            if (this.mode === 'advanced') {
                this.zone.runOutsideAngular(() => {
                    if (this.content) {
                        this.dragOverListener = this.renderer.listen(this.content.nativeElement, 'dragover', this.onDragOver.bind(this));
                    }
                });
            }
        }
    }
    getTranslation(option) {
        return this.config.getTranslation(option);
    }
    choose() {
        this.advancedFileInput?.nativeElement.click();
    }
    onFileSelect(event) {
        if (event.type !== 'drop' && this.isIE11() && this.duplicateIEEvent) {
            this.duplicateIEEvent = false;
            return;
        }
        this.msgs = [];
        if (!this.multiple) {
            this.files = [];
        }
        let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        // Update this.files based on the file selection event that just fired.
        // For each file mentioned in the file selection event
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            // If the file isn't already present in this.files (based on name, type and size only - content doesn't matter!?)
            // This looks a bit odd, but I'm sticking to this behaviour as part of reverting Danish's June change (which 
            // forced a timestamp onto the start of every uploaded file's name, with no support for opt-out to preserve old
            // behaviour)
            if (!this.isFileSelected(file)) {
                if (this.validate(file)) {
                    if (this.isImage(file)) {
                        file.objectURL = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(files[i]));
                    }
                    // Add it to this.files
                    this.files.push(files[i]);
                }
            }
        }
        this.onSelect.emit({ originalEvent: event, files: files, currentFiles: this.files });
        if (this.fileLimit) {
            // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
            this.checkFileLimit(this.files.length);
        }
        // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
        let fileLimitExceeded = this.isFileLimitExceeded(this.files.length);
        if (this.hasFiles() && this.auto && (!(this.mode === 'advanced') || !fileLimitExceeded)) {
            this.upload();
        }
        else if (fileLimitExceeded) {
            this.files = [];
            this.clearInputElement();
        }
        if (event.type !== 'drop' && this.isIE11()) {
            this.clearIEInput();
        }
        else {
            this.clearInputElement();
        }
    }
    isFileSelected(file) {
        for (let sFile of this.files) {
            if (sFile.name + sFile.type + sFile.size === file.name + file.type + file.size) {
                return true;
            }
        }
        return false;
    }
    isIE11() {
        if (isPlatformBrowser(this.platformId)) {
            return !!this.document.defaultView['MSInputMethodContext'] && !!this.document['documentMode'];
        }
    }
    validate(file) {
        this.msgs = this.msgs || [];
        if (this.accept && !this.isFileTypeValid(file)) {
            this.msgs.push({
                severity: 'error',
                summary: this.invalidFileTypeMessageSummary.replace('{0}', file.name),
                detail: this.invalidFileTypeMessageDetail.replace('{0}', this.accept)
            });
            return false;
        }
        if (this.maxFileSize && file.size > this.maxFileSize) {
            this.msgs.push({
                severity: 'error',
                summary: this.invalidFileSizeMessageSummary.replace('{0}', file.name),
                detail: this.invalidFileSizeMessageDetail.replace('{0}', this.formatSize(this.maxFileSize))
            });
            return false;
        }
        // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
        if (this.isFileDuplicate(file)) {
            this.msgs.push({
                severity: 'error',
                summary: 'Duplicate file,',
                detail: `File named '${file.name}' already uploaded.`
            });
            return false;
        }
        return true;
    }
    isFileTypeValid(file) {
        let acceptableTypes = this.accept?.split(',').map((type) => type.trim());
        for (let type of acceptableTypes) {
            let acceptable = this.isWildcard(type) ? this.getTypeClass(file.type) === this.getTypeClass(type) : file.type == type || this.getFileExtension(file).toLowerCase() === type.toLowerCase();
            if (acceptable) {
                return true;
            }
        }
        return false;
    }
    // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
    isFileDuplicate(file) {
        if (this.uploadedFiles.find(f => f.name === file.name)) {
            return true;
        }
        return false;
    }
    getTypeClass(fileType) {
        return fileType.substring(0, fileType.indexOf('/'));
    }
    isWildcard(fileType) {
        return fileType.indexOf('*') !== -1;
    }
    getFileExtension(file) {
        return '.' + file.name.split('.').pop();
    }
    isImage(file) {
        return /^image\//.test(file.type);
    }
    onImageLoad(img) {
        window.URL.revokeObjectURL(img.src);
    }
    /**
     * Uploads the selected files.
     * @group Method
     */
    upload() {
        if (this.customUpload) {
            if (this.fileLimit) {
                this.uploadedFileCount += this.files.length;
            }
            this.uploadHandler.emit({
                files: this.files
            });
            this.cd.markForCheck();
            this.clear(); // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
        }
        else {
            this.uploading = true;
            this.msgs = [];
            let formData = new FormData();
            this.onBeforeUpload.emit({
                formData: formData
            });
            for (let i = 0; i < this.files.length; i++) {
                formData.append(this.name, this.files[i], this.files[i].name);
            }
            this.http
                .request(this.method, this.url, {
                body: formData,
                headers: this.headers,
                reportProgress: true,
                observe: 'events',
                withCredentials: this.withCredentials
            })
                .subscribe((event) => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        this.onSend.emit({
                            originalEvent: event,
                            formData: formData
                        });
                        break;
                    case HttpEventType.Response:
                        this.uploading = false;
                        this.progress = 0;
                        if (event['status'] >= 200 && event['status'] < 300) {
                            if (this.fileLimit) {
                                this.uploadedFileCount += this.files.length;
                            }
                            this.onUpload.emit({ originalEvent: event, files: this.files });
                        }
                        else {
                            this.onError.emit({ files: this.files });
                        }
                        this.clear();
                        break;
                    case HttpEventType.UploadProgress: {
                        if (event['loaded']) {
                            this.progress = Math.round((event['loaded'] * 100) / event['total']);
                        }
                        this.onProgress.emit({ originalEvent: event, progress: this.progress });
                        break;
                    }
                }
                this.cd.markForCheck();
            }, (error) => {
                this.uploading = false;
                this.onError.emit({ files: this.files, error: error });
            });
        }
    }
    /**
     * Clears the files list.
     * @group Method
     */
    clear() {
        this.msgs = []; // dspx-core customisation made on this line, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
        this.files = [];
        this.uploadedFileCount = 0;
        this.onClear.emit();
        this.clearInputElement();
        this.cd.markForCheck();
    }
    remove(event, index) {
        this.clearInputElement();
        this.onRemove.emit({ originalEvent: event, file: this.files[index] });
        this.files.splice(index, 1);
    }
    // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
    isFileLimitExceeded(numFilesToBeUploaded) {
        let numFilesAlreadyUploaded = this.uploadedFiles.length;
        let fileLimitExceeded = this.fileLimit
            && (this.fileLimit <= numFilesAlreadyUploaded
                || this.fileLimit < numFilesAlreadyUploaded + numFilesToBeUploaded);
        if (fileLimitExceeded && this.focus) {
            this.focus = false;
        }
        return fileLimitExceeded;
    }
    // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
    isChooseDisabled() {
        return this.fileLimit && this.fileLimit <= this.uploadedFiles.length;
    }
    // dspx-core customisation made, please merge carefully when updating this method's source with the latest from PrimeNg's GitHub.
    checkFileLimit(numFilesToBeUploaded) {
        this.msgs ??= [];
        if (this.isFileLimitExceeded(numFilesToBeUploaded)) {
            this.msgs.push({
                severity: 'error',
                summary: this.invalidFileLimitMessageSummary.replace('{0}', this.fileLimit.toString()),
                detail: this.invalidFileLimitMessageDetail.replace('{0}', this.fileLimit.toString())
            });
        }
    }
    clearInputElement() {
        if (this.advancedFileInput && this.advancedFileInput.nativeElement) {
            this.advancedFileInput.nativeElement.value = '';
        }
        if (this.basicFileInput && this.basicFileInput.nativeElement) {
            this.basicFileInput.nativeElement.value = '';
        }
    }
    clearIEInput() {
        if (this.advancedFileInput && this.advancedFileInput.nativeElement) {
            this.duplicateIEEvent = true; //IE11 fix to prevent onFileChange trigger again
            this.advancedFileInput.nativeElement.value = '';
        }
    }
    hasFiles() {
        return this.files && this.files.length > 0;
    }
    onDragEnter(e) {
        if (!this.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    onDragOver(e) {
        if (!this.disabled) {
            DomHandler.addClass(this.content?.nativeElement, 'p-fileupload-highlight');
            this.dragHighlight = true;
            e.stopPropagation();
            e.preventDefault();
        }
    }
    onDragLeave(event) {
        if (!this.disabled) {
            DomHandler.removeClass(this.content?.nativeElement, 'p-fileupload-highlight');
        }
    }
    onDrop(event) {
        if (!this.disabled) {
            DomHandler.removeClass(this.content?.nativeElement, 'p-fileupload-highlight');
            event.stopPropagation();
            event.preventDefault();
            let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
            let allowDrop = this.multiple || (files && files.length === 1);
            if (allowDrop) {
                this.onFileSelect(event);
            }
        }
    }
    onFocus() {
        this.focus = true;
    }
    onBlur() {
        this.focus = false;
    }
    formatSize(bytes) {
        const k = 1024;
        const dm = 3;
        const sizes = this.getTranslation(TranslationKeys.FILE_SIZE_TYPES);
        if (bytes === 0) {
            return `0 ${sizes[0]}`;
        }
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const formattedSize = (bytes / Math.pow(k, i)).toFixed(dm);
        return `${formattedSize} ${sizes[i]}`;
    }
    onBasicUploaderClick() {
        if (this.hasFiles())
            this.upload();
        else
            this.basicFileInput?.nativeElement.click();
    }
    onBasicKeydown(event) {
        switch (event.code) {
            case 'Space':
            case 'Enter':
                this.onBasicUploaderClick();
                event.preventDefault();
                break;
        }
    }
    imageError(event) {
        this.onImageError.emit(event);
    }
    getBlockableElement() {
        return this.el.nativeElement.children[0];
    }
    get chooseButtonLabel() {
        return this.chooseLabel || this.config.getTranslation(TranslationKeys.CHOOSE);
    }
    get uploadButtonLabel() {
        return this.uploadLabel || this.config.getTranslation(TranslationKeys.UPLOAD);
    }
    get cancelButtonLabel() {
        return this.cancelLabel || this.config.getTranslation(TranslationKeys.CANCEL);
    }
    ngOnDestroy() {
        if (this.content && this.content.nativeElement) {
            if (this.dragOverListener) {
                this.dragOverListener();
                this.dragOverListener = null;
            }
        }
        if (this.translationSubscription) {
            this.translationSubscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUpload, deps: [{ token: DOCUMENT }, { token: PLATFORM_ID }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1$2.DomSanitizer }, { token: i0.NgZone }, { token: i1.HttpClient }, { token: i0.ChangeDetectorRef }, { token: i1$1.PrimeNGConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FileUpload, selector: "p-fileUpload", inputs: { name: "name", url: "url", method: "method", multiple: "multiple", accept: "accept", disabled: "disabled", auto: "auto", withCredentials: "withCredentials", maxFileSize: "maxFileSize", invalidFileSizeMessageSummary: "invalidFileSizeMessageSummary", invalidFileSizeMessageDetail: "invalidFileSizeMessageDetail", invalidFileTypeMessageSummary: "invalidFileTypeMessageSummary", invalidFileTypeMessageDetail: "invalidFileTypeMessageDetail", invalidFileLimitMessageDetail: "invalidFileLimitMessageDetail", invalidFileLimitMessageSummary: "invalidFileLimitMessageSummary", style: "style", styleClass: "styleClass", previewWidth: "previewWidth", chooseLabel: "chooseLabel", uploadLabel: "uploadLabel", cancelLabel: "cancelLabel", chooseIcon: "chooseIcon", uploadIcon: "uploadIcon", cancelIcon: "cancelIcon", showUploadButton: "showUploadButton", showCancelButton: "showCancelButton", mode: "mode", headers: "headers", customUpload: "customUpload", fileLimit: "fileLimit", uploadStyleClass: "uploadStyleClass", cancelStyleClass: "cancelStyleClass", removeStyleClass: "removeStyleClass", chooseStyleClass: "chooseStyleClass", uploadedFiles: "uploadedFiles", files: "files" }, outputs: { onBeforeUpload: "onBeforeUpload", onSend: "onSend", onUpload: "onUpload", onError: "onError", onClear: "onClear", onRemove: "onRemove", onSelect: "onSelect", onProgress: "onProgress", uploadHandler: "uploadHandler", onImageError: "onImageError" }, host: { classAttribute: "p-element" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], viewQueries: [{ propertyName: "advancedFileInput", first: true, predicate: ["advancedfileinput"], descendants: true }, { propertyName: "basicFileInput", first: true, predicate: ["basicfileinput"], descendants: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: "<div [ngClass]=\"'p-fileupload p-fileupload-advanced p-component'\" [ngStyle]=\"style\" [class]=\"styleClass\" *ngIf=\"mode === 'advanced'\" [attr.data-pc-name]=\"'fileupload'\" [attr.data-pc-section]=\"'root'\">\r\n  <div class=\"p-fileupload-buttonbar\" [attr.data-pc-section]=\"'buttonbar'\">\r\n    <span class=\"p-button p-component p-fileupload-choose\"\r\n          [ngClass]=\"{ 'p-focus': focus, 'p-disabled': disabled || isChooseDisabled() }\"\r\n          (focus)=\"onFocus()\"\r\n          (blur)=\"onBlur()\"\r\n          pRipple\r\n          (click)=\"choose()\"\r\n          (keydown.enter)=\"choose()\"\r\n          tabindex=\"0\"\r\n          [class]=\"chooseStyleClass\"\r\n          [attr.data-pc-section]=\"'choosebutton'\">\r\n      <input #advancedfileinput type=\"file\" (change)=\"onFileSelect($event)\" [multiple]=\"multiple\" [accept]=\"accept\" [disabled]=\"disabled || isChooseDisabled()\" [attr.title]=\"''\" [attr.data-pc-section]=\"'input'\" />\r\n      <span *ngIf=\"chooseIcon\" [ngClass]=\"'p-button-icon p-button-icon-left'\" [class]=\"chooseIcon\" [attr.aria-label]=\"true\" [attr.data-pc-section]=\"'chooseicon'\"></span>\r\n      <ng-container *ngIf=\"!chooseIcon\">\r\n        <PlusIcon *ngIf=\"!chooseIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" [attr.aria-label]=\"true\" [attr.data-pc-section]=\"'chooseicon'\" />\r\n        <span *ngIf=\"chooseIconTemplate\" class=\"p-button-icon p-button-icon-left\" [attr.aria-label]=\"true\" [attr.data-pc-section]=\"'chooseicon'\">\r\n          <ng-template *ngTemplateOutlet=\"chooseIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n      <span class=\"p-button-label\" [attr.data-pc-section]=\"'choosebuttonlabel'\">{{ chooseButtonLabel }}</span>\r\n    </span>\r\n\r\n    <p-button *ngIf=\"!auto && showUploadButton\" type=\"button\" [label]=\"uploadButtonLabel\" (onClick)=\"upload()\" [disabled]=\"!hasFiles() || isFileLimitExceeded()\" [styleClass]=\"uploadStyleClass\">\r\n      <span *ngIf=\"uploadIcon\" [ngClass]=\"uploadIcon\" [attr.aria-hidden]=\"true\" class=\"p-button-icon p-button-icon-left\"></span>\r\n      <ng-container *ngIf=\"!uploadIcon\">\r\n        <UploadIcon *ngIf=\"!uploadIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" />\r\n        <span *ngIf=\"uploadIconTemplate\" class=\"p-button-icon p-button-icon-left\" [attr.aria-hidden]=\"true\">\r\n          <ng-template *ngTemplateOutlet=\"uploadIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </p-button>\r\n    <p-button *ngIf=\"!auto && showCancelButton\" type=\"button\" [label]=\"cancelButtonLabel\" (onClick)=\"clear()\" [disabled]=\"!hasFiles() || uploading\" [styleClass]=\"cancelStyleClass\">\r\n      <span *ngIf=\"cancelIcon\" [ngClass]=\"cancelIcon\" class=\"p-button-icon p-button-icon-left\"></span>\r\n      <ng-container *ngIf=\"!cancelIcon\">\r\n        <TimesIcon *ngIf=\"!cancelIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" [attr.aria-hidden]=\"true\" />\r\n        <span *ngIf=\"cancelIconTemplate\" class=\"p-button-icon p-button-icon-left\" [attr.aria-hidden]=\"true\">\r\n          <ng-template *ngTemplateOutlet=\"cancelIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </p-button>\r\n\r\n    <ng-container *ngTemplateOutlet=\"toolbarTemplate\"></ng-container>\r\n  </div>\r\n  <div #content class=\"p-fileupload-content\" (dragenter)=\"onDragEnter($event)\" (dragleave)=\"onDragLeave($event)\" (drop)=\"onDrop($event)\" [attr.data-pc-section]=\"'content'\">\r\n    <p-progressBar [value]=\"progress\" [showValue]=\"false\" *ngIf=\"hasFiles()\"></p-progressBar>\r\n\r\n    <p-messages [value]=\"msgs\" [enableService]=\"false\"></p-messages>\r\n\r\n    <div class=\"p-fileupload-files\" *ngIf=\"hasFiles()\">\r\n      <div *ngIf=\"!fileTemplate\">\r\n        <div class=\"p-fileupload-row\" *ngFor=\"let file of files; let i = index\">\r\n          <div><img [src]=\"file.objectURL\" *ngIf=\"isImage(file)\" [width]=\"previewWidth\" (error)=\"imageError($event)\" /></div>\r\n          <div class=\"p-fileupload-filename\">{{file.name}}</div>\r\n          <div>{{ formatSize(file.size) }}</div>\r\n          <div>\r\n            <button type=\"button\" pButton (click)=\"remove($event, i)\" [disabled]=\"uploading\" class=\"p-button-icon-only\" [class]=\"removeStyleClass\" aria-label=\"Remove attachment\">\r\n              <TimesIcon *ngIf=\"!cancelIconTemplate\" />\r\n              <ng-template *ngTemplateOutlet=\"cancelIconTemplate\"></ng-template>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"fileTemplate\">\r\n        <ng-template ngFor [ngForOf]=\"files\" [ngForTemplate]=\"fileTemplate\"></ng-template>\r\n      </div>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate; context: { $implicit: files }\"></ng-container>\r\n  </div>\r\n</div>\r\n<div class=\"p-fileupload p-fileupload-basic p-component\" *ngIf=\"mode === 'basic'\" [attr.data-pc-name]=\"'fileupload'\">\r\n  <p-messages [value]=\"msgs\" [enableService]=\"false\"></p-messages>\r\n  <span [ngClass]=\"{ 'p-button p-component p-fileupload-choose': true, 'p-button-icon-only': !basicButtonLabel, 'p-fileupload-choose-selected': hasFiles(), 'p-focus': focus, 'p-disabled': disabled }\"\r\n        [ngStyle]=\"style\"\r\n        [class]=\"styleClass\"\r\n        (click)=\"onBasicUploaderClick()\"\r\n        (keydown)=\"onBasicKeydown($event)\"\r\n        tabindex=\"0\"\r\n        pRipple\r\n        [attr.data-pc-section]=\"'choosebutton'\">\r\n    <ng-container *ngIf=\"hasFiles() && !auto; else chooseSection\">\r\n      <span *ngIf=\"uploadIcon\" class=\"p-button-icon p-button-icon-left\" [ngClass]=\"uploadIcon\"></span>\r\n      <ng-container *ngIf=\"!uploadIcon\">\r\n        <UploadIcon *ngIf=\"!uploadIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" />\r\n        <span *ngIf=\"uploadIconTemplate\" class=\"p-button-icon p-button-icon-left\">\r\n          <ng-template *ngTemplateOutlet=\"uploadIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </ng-container>\r\n    <ng-template #chooseSection>\r\n      <span *ngIf=\"chooseIcon\" class=\"p-button-icon p-button-icon-left pi\" [ngClass]=\"chooseIcon\"></span>\r\n      <ng-container *ngIf=\"!chooseIcon\">\r\n        <PlusIcon [styleClass]=\"'p-button-icon p-button-icon-left pi'\" *ngIf=\"!chooseIconTemplate\" [attr.aria-hidden]=\"true\" [attr.data-pc-section]=\"'uploadicon'\" />\r\n        <span *ngIf=\"chooseIconTemplate\" class=\"p-button-icon p-button-icon-left pi\" [attr.aria-hidden]=\"true\" [attr.data-pc-section]=\"'uploadicon'\">\r\n          <ng-template *ngTemplateOutlet=\"chooseIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </ng-template>\r\n    <span *ngIf=\"basicButtonLabel\" class=\"p-button-label\" [attr.data-pc-section]=\"'label'\">{{ basicButtonLabel }}</span>\r\n    <input #basicfileinput type=\"file\" [accept]=\"accept\" [multiple]=\"multiple\" [disabled]=\"disabled\" (change)=\"onFileSelect($event)\" *ngIf=\"!hasFiles()\" (focus)=\"onFocus()\" (blur)=\"onBlur()\" [attr.data-pc-section]=\"'input'\" />\r\n  </span>\r\n</div>\r\n", styles: ["@layer primeng{.p-fileupload-content{position:relative}.p-fileupload-row{display:flex;align-items:center}.p-fileupload-row>div{flex:1 1 auto;width:25%}.p-fileupload-row>div:last-child{text-align:right}.p-fileupload-content .p-progressbar{width:100%;position:absolute;top:0;left:0}.p-button.p-fileupload-choose{position:relative;overflow:hidden}.p-button.p-fileupload-choose input[type=file],.p-fileupload-choose.p-fileupload-choose-selected input[type=file]{display:none}.p-fluid .p-fileupload .p-button{width:auto}.p-fileupload-filename{word-break:break-all}}\n"], dependencies: [{ kind: "directive", type: i0.forwardRef(() => i2.NgClass), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgForOf), selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgTemplateOutlet), selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i0.forwardRef(() => i2.NgStyle), selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i0.forwardRef(() => i3$1.ButtonDirective), selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i0.forwardRef(() => i3$1.Button), selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "component", type: i0.forwardRef(() => i6$1.ProgressBar), selector: "p-progressBar", inputs: ["value", "showValue", "styleClass", "style", "unit", "mode", "color"] }, { kind: "component", type: i0.forwardRef(() => Messages), selector: "p-messages", inputs: ["value", "closable", "style", "styleClass", "enableService", "key", "escape", "severity", "showTransitionOptions", "hideTransitionOptions"], outputs: ["valueChange"] }, { kind: "directive", type: i0.forwardRef(() => i6.Ripple), selector: "[pRipple]" }, { kind: "component", type: i0.forwardRef(() => PlusIcon), selector: "PlusIcon" }, { kind: "component", type: i0.forwardRef(() => UploadIcon), selector: "UploadIcon" }, { kind: "component", type: i0.forwardRef(() => TimesIcon), selector: "TimesIcon" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUpload, decorators: [{
            type: Component,
            args: [{ selector: 'p-fileUpload', changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, host: {
                        'class': 'p-element'
                    }, template: "<div [ngClass]=\"'p-fileupload p-fileupload-advanced p-component'\" [ngStyle]=\"style\" [class]=\"styleClass\" *ngIf=\"mode === 'advanced'\" [attr.data-pc-name]=\"'fileupload'\" [attr.data-pc-section]=\"'root'\">\r\n  <div class=\"p-fileupload-buttonbar\" [attr.data-pc-section]=\"'buttonbar'\">\r\n    <span class=\"p-button p-component p-fileupload-choose\"\r\n          [ngClass]=\"{ 'p-focus': focus, 'p-disabled': disabled || isChooseDisabled() }\"\r\n          (focus)=\"onFocus()\"\r\n          (blur)=\"onBlur()\"\r\n          pRipple\r\n          (click)=\"choose()\"\r\n          (keydown.enter)=\"choose()\"\r\n          tabindex=\"0\"\r\n          [class]=\"chooseStyleClass\"\r\n          [attr.data-pc-section]=\"'choosebutton'\">\r\n      <input #advancedfileinput type=\"file\" (change)=\"onFileSelect($event)\" [multiple]=\"multiple\" [accept]=\"accept\" [disabled]=\"disabled || isChooseDisabled()\" [attr.title]=\"''\" [attr.data-pc-section]=\"'input'\" />\r\n      <span *ngIf=\"chooseIcon\" [ngClass]=\"'p-button-icon p-button-icon-left'\" [class]=\"chooseIcon\" [attr.aria-label]=\"true\" [attr.data-pc-section]=\"'chooseicon'\"></span>\r\n      <ng-container *ngIf=\"!chooseIcon\">\r\n        <PlusIcon *ngIf=\"!chooseIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" [attr.aria-label]=\"true\" [attr.data-pc-section]=\"'chooseicon'\" />\r\n        <span *ngIf=\"chooseIconTemplate\" class=\"p-button-icon p-button-icon-left\" [attr.aria-label]=\"true\" [attr.data-pc-section]=\"'chooseicon'\">\r\n          <ng-template *ngTemplateOutlet=\"chooseIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n      <span class=\"p-button-label\" [attr.data-pc-section]=\"'choosebuttonlabel'\">{{ chooseButtonLabel }}</span>\r\n    </span>\r\n\r\n    <p-button *ngIf=\"!auto && showUploadButton\" type=\"button\" [label]=\"uploadButtonLabel\" (onClick)=\"upload()\" [disabled]=\"!hasFiles() || isFileLimitExceeded()\" [styleClass]=\"uploadStyleClass\">\r\n      <span *ngIf=\"uploadIcon\" [ngClass]=\"uploadIcon\" [attr.aria-hidden]=\"true\" class=\"p-button-icon p-button-icon-left\"></span>\r\n      <ng-container *ngIf=\"!uploadIcon\">\r\n        <UploadIcon *ngIf=\"!uploadIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" />\r\n        <span *ngIf=\"uploadIconTemplate\" class=\"p-button-icon p-button-icon-left\" [attr.aria-hidden]=\"true\">\r\n          <ng-template *ngTemplateOutlet=\"uploadIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </p-button>\r\n    <p-button *ngIf=\"!auto && showCancelButton\" type=\"button\" [label]=\"cancelButtonLabel\" (onClick)=\"clear()\" [disabled]=\"!hasFiles() || uploading\" [styleClass]=\"cancelStyleClass\">\r\n      <span *ngIf=\"cancelIcon\" [ngClass]=\"cancelIcon\" class=\"p-button-icon p-button-icon-left\"></span>\r\n      <ng-container *ngIf=\"!cancelIcon\">\r\n        <TimesIcon *ngIf=\"!cancelIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" [attr.aria-hidden]=\"true\" />\r\n        <span *ngIf=\"cancelIconTemplate\" class=\"p-button-icon p-button-icon-left\" [attr.aria-hidden]=\"true\">\r\n          <ng-template *ngTemplateOutlet=\"cancelIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </p-button>\r\n\r\n    <ng-container *ngTemplateOutlet=\"toolbarTemplate\"></ng-container>\r\n  </div>\r\n  <div #content class=\"p-fileupload-content\" (dragenter)=\"onDragEnter($event)\" (dragleave)=\"onDragLeave($event)\" (drop)=\"onDrop($event)\" [attr.data-pc-section]=\"'content'\">\r\n    <p-progressBar [value]=\"progress\" [showValue]=\"false\" *ngIf=\"hasFiles()\"></p-progressBar>\r\n\r\n    <p-messages [value]=\"msgs\" [enableService]=\"false\"></p-messages>\r\n\r\n    <div class=\"p-fileupload-files\" *ngIf=\"hasFiles()\">\r\n      <div *ngIf=\"!fileTemplate\">\r\n        <div class=\"p-fileupload-row\" *ngFor=\"let file of files; let i = index\">\r\n          <div><img [src]=\"file.objectURL\" *ngIf=\"isImage(file)\" [width]=\"previewWidth\" (error)=\"imageError($event)\" /></div>\r\n          <div class=\"p-fileupload-filename\">{{file.name}}</div>\r\n          <div>{{ formatSize(file.size) }}</div>\r\n          <div>\r\n            <button type=\"button\" pButton (click)=\"remove($event, i)\" [disabled]=\"uploading\" class=\"p-button-icon-only\" [class]=\"removeStyleClass\" aria-label=\"Remove attachment\">\r\n              <TimesIcon *ngIf=\"!cancelIconTemplate\" />\r\n              <ng-template *ngTemplateOutlet=\"cancelIconTemplate\"></ng-template>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"fileTemplate\">\r\n        <ng-template ngFor [ngForOf]=\"files\" [ngForTemplate]=\"fileTemplate\"></ng-template>\r\n      </div>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate; context: { $implicit: files }\"></ng-container>\r\n  </div>\r\n</div>\r\n<div class=\"p-fileupload p-fileupload-basic p-component\" *ngIf=\"mode === 'basic'\" [attr.data-pc-name]=\"'fileupload'\">\r\n  <p-messages [value]=\"msgs\" [enableService]=\"false\"></p-messages>\r\n  <span [ngClass]=\"{ 'p-button p-component p-fileupload-choose': true, 'p-button-icon-only': !basicButtonLabel, 'p-fileupload-choose-selected': hasFiles(), 'p-focus': focus, 'p-disabled': disabled }\"\r\n        [ngStyle]=\"style\"\r\n        [class]=\"styleClass\"\r\n        (click)=\"onBasicUploaderClick()\"\r\n        (keydown)=\"onBasicKeydown($event)\"\r\n        tabindex=\"0\"\r\n        pRipple\r\n        [attr.data-pc-section]=\"'choosebutton'\">\r\n    <ng-container *ngIf=\"hasFiles() && !auto; else chooseSection\">\r\n      <span *ngIf=\"uploadIcon\" class=\"p-button-icon p-button-icon-left\" [ngClass]=\"uploadIcon\"></span>\r\n      <ng-container *ngIf=\"!uploadIcon\">\r\n        <UploadIcon *ngIf=\"!uploadIconTemplate\" [styleClass]=\"'p-button-icon p-button-icon-left'\" />\r\n        <span *ngIf=\"uploadIconTemplate\" class=\"p-button-icon p-button-icon-left\">\r\n          <ng-template *ngTemplateOutlet=\"uploadIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </ng-container>\r\n    <ng-template #chooseSection>\r\n      <span *ngIf=\"chooseIcon\" class=\"p-button-icon p-button-icon-left pi\" [ngClass]=\"chooseIcon\"></span>\r\n      <ng-container *ngIf=\"!chooseIcon\">\r\n        <PlusIcon [styleClass]=\"'p-button-icon p-button-icon-left pi'\" *ngIf=\"!chooseIconTemplate\" [attr.aria-hidden]=\"true\" [attr.data-pc-section]=\"'uploadicon'\" />\r\n        <span *ngIf=\"chooseIconTemplate\" class=\"p-button-icon p-button-icon-left pi\" [attr.aria-hidden]=\"true\" [attr.data-pc-section]=\"'uploadicon'\">\r\n          <ng-template *ngTemplateOutlet=\"chooseIconTemplate\"></ng-template>\r\n        </span>\r\n      </ng-container>\r\n    </ng-template>\r\n    <span *ngIf=\"basicButtonLabel\" class=\"p-button-label\" [attr.data-pc-section]=\"'label'\">{{ basicButtonLabel }}</span>\r\n    <input #basicfileinput type=\"file\" [accept]=\"accept\" [multiple]=\"multiple\" [disabled]=\"disabled\" (change)=\"onFileSelect($event)\" *ngIf=\"!hasFiles()\" (focus)=\"onFocus()\" (blur)=\"onBlur()\" [attr.data-pc-section]=\"'input'\" />\r\n  </span>\r\n</div>\r\n", styles: ["@layer primeng{.p-fileupload-content{position:relative}.p-fileupload-row{display:flex;align-items:center}.p-fileupload-row>div{flex:1 1 auto;width:25%}.p-fileupload-row>div:last-child{text-align:right}.p-fileupload-content .p-progressbar{width:100%;position:absolute;top:0;left:0}.p-button.p-fileupload-choose{position:relative;overflow:hidden}.p-button.p-fileupload-choose input[type=file],.p-fileupload-choose.p-fileupload-choose-selected input[type=file]{display:none}.p-fluid .p-fileupload .p-button{width:auto}.p-fileupload-filename{word-break:break-all}}\n"] }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1$2.DomSanitizer }, { type: i0.NgZone }, { type: i1.HttpClient }, { type: i0.ChangeDetectorRef }, { type: i1$1.PrimeNGConfig }], propDecorators: { name: [{
                type: Input
            }], url: [{
                type: Input
            }], method: [{
                type: Input
            }], multiple: [{
                type: Input
            }], accept: [{
                type: Input
            }], disabled: [{
                type: Input
            }], auto: [{
                type: Input
            }], withCredentials: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], invalidFileSizeMessageSummary: [{
                type: Input
            }], invalidFileSizeMessageDetail: [{
                type: Input
            }], invalidFileTypeMessageSummary: [{
                type: Input
            }], invalidFileTypeMessageDetail: [{
                type: Input
            }], invalidFileLimitMessageDetail: [{
                type: Input
            }], invalidFileLimitMessageSummary: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], previewWidth: [{
                type: Input
            }], chooseLabel: [{
                type: Input
            }], uploadLabel: [{
                type: Input
            }], cancelLabel: [{
                type: Input
            }], chooseIcon: [{
                type: Input
            }], uploadIcon: [{
                type: Input
            }], cancelIcon: [{
                type: Input
            }], showUploadButton: [{
                type: Input
            }], showCancelButton: [{
                type: Input
            }], mode: [{
                type: Input
            }], headers: [{
                type: Input
            }], customUpload: [{
                type: Input
            }], fileLimit: [{
                type: Input
            }], uploadStyleClass: [{
                type: Input
            }], cancelStyleClass: [{
                type: Input
            }], removeStyleClass: [{
                type: Input
            }], chooseStyleClass: [{
                type: Input
            }], uploadedFiles: [{
                type: Input
            }], onBeforeUpload: [{
                type: Output
            }], onSend: [{
                type: Output
            }], onUpload: [{
                type: Output
            }], onError: [{
                type: Output
            }], onClear: [{
                type: Output
            }], onRemove: [{
                type: Output
            }], onSelect: [{
                type: Output
            }], onProgress: [{
                type: Output
            }], uploadHandler: [{
                type: Output
            }], onImageError: [{
                type: Output
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }], advancedFileInput: [{
                type: ViewChild,
                args: ['advancedfileinput']
            }], basicFileInput: [{
                type: ViewChild,
                args: ['basicfileinput']
            }], content: [{
                type: ViewChild,
                args: ['content']
            }], files: [{
                type: Input
            }] } });
class FileUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, declarations: [FileUpload], imports: [CommonModule, HttpClientModule, SharedModule, ButtonModule, ProgressBarModule, MessagesModule, RippleModule, PlusIcon, UploadIcon, TimesIcon], exports: [FileUpload, SharedModule, ButtonModule, ProgressBarModule, MessagesModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, imports: [CommonModule, HttpClientModule, SharedModule, ButtonModule, ProgressBarModule, MessagesModule, RippleModule, PlusIcon, UploadIcon, TimesIcon, SharedModule, ButtonModule, ProgressBarModule, MessagesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, HttpClientModule, SharedModule, ButtonModule, ProgressBarModule, MessagesModule, RippleModule, PlusIcon, UploadIcon, TimesIcon],
                    exports: [FileUpload, SharedModule, ButtonModule, ProgressBarModule, MessagesModule],
                    declarations: [FileUpload]
                }]
        }] });

class GridDataHelpers {
    // This function works through the config and model, discovering grids and then updating any fields in the data for
    // those grids. Specifically: any fields whose data type is "date" are converted from the string format returned from
    // the server into a javascript Date object. This is to ensure that dates in grids are sortable, filterable and can be
    // displayed in the requested format.
    static ParseDatesInGrids(configData, model) {
        if (!model)
            return;
        this.parseDatesInGridsUnderConfigNode(configData.config, model[configData.config.key]);
    }
    static parseDatesInGridsUnderConfigNode(configNode, modelNode) {
        // If there's nothing in the model corresponding to the field group we're about to look at, there's no need to
        // continue - there's no data there to prepare.
        if (!modelNode)
            return;
        if (configNode.type == "data-grid") {
            // Found a data grid.
            this.parseDatesInGrid(configNode, modelNode);
        }
        else {
            // Recursively process children, if any
            if (configNode.fieldGroup) {
                for (var i = 0; i < configNode.fieldGroup.length; i++) {
                    var nextFg = configNode.fieldGroup[i];
                    this.parseDatesInGridsUnderConfigNode(nextFg, modelNode[nextFg.key]);
                }
            }
        }
    }
    static parseDatesInGrid(gridNode, modelNode) {
        // First, check whether we've opted out of the new date parsing behaviour
        if (gridNode?.props?.dashboardOptions?.forceGridToTreatDatesAsStrings) {
            return;
        }
        // Check for date columns
        var cols = gridNode?.props?.dashboardOptions?.cols;
        if (cols) {
            for (var i = 0; i < cols.length; i++) {
                var col = cols[i];
                if (col.dataType == "date") {
                    // We found a date column inside a grid.
                    // Process all rows of the grid, parsing all occurrences of that field
                    var rows = modelNode;
                    for (var j = 0; j < rows.length; j++) {
                        var row = rows[j];
                        // Parse that column from a string into a Date
                        var val = row[col.field];
                        if (val) {
                            row[col.field] = this.parseBackEndDateString(val);
                        }
                    }
                }
            }
        }
    }
    static parseBackEndDateString(dateString) {
        if (!dateString)
            return null;
        // Handle yyyy-MM-ddTHH:mm:ss - e.g. 2023-09-21T12:07:38.5633333
        if (dateString.match(/\d{4}-\d{2}-\d{2}T\d{2}\:\d{2}\:\d{2}/)) {
            var year = parseInt(dateString.substring(0, 4));
            var month = parseInt(dateString.substring(5, 7));
            var day = parseInt(dateString.substring(8, 10));
            var hour = parseInt(dateString.substring(11, 13));
            var minute = parseInt(dateString.substring(14, 16));
            var second = parseInt(dateString.substring(17, 19));
            // Javascript Date() constructor wants zero-based months!
            return new Date(year, month - 1, day, hour, minute, second);
        }
        // Handle yyyy-MM-dd
        if (dateString.match(/\d{4}-\d{2}-\d{2}/)) {
            var year = parseInt(dateString.substring(0, 4));
            var month = parseInt(dateString.substring(5, 7));
            var day = parseInt(dateString.substring(8, 10));
            // Javascript Date() constructor wants zero-based months!
            return new Date(year, month - 1, day);
        }
        throw `GridDataHelper encountered raw data for a date field that was in unsupported date format '${dateString}' (expecting yyyy-MM-dd)`;
    }
}

var FieldTypes;
(function (FieldTypes) {
    FieldTypes["SEARCH"] = "search";
    FieldTypes["SELECT"] = "select";
})(FieldTypes || (FieldTypes = {}));

class DspxDialogComponent {
    constructor(dialogService, coreService, confirmationService) {
        this.dialogService = dialogService;
        this.coreService = coreService;
        this.confirmationService = confirmationService;
        this.display = false;
        this.dialogClass = "dialog";
        this.displayCloseButton = false;
        this.form = new UntypedFormGroup({});
        this.model = {};
        this.subs = [];
        this.onSubmit = new EventEmitter();
    }
    ngOnDestroy() {
        this.subs?.forEach(s => s.unsubscribe());
    }
    ngOnInit() {
        this.model = {};
        this.subs.push(this.dialogService.model().subscribe(model => this.model = { ...this.model, ...model }));
        this.subs.push(this.dialogService.dialogRequested().subscribe((request) => {
            this.model = request.model || {};
            this.dialog = request.popup;
            if (request.dialogStyleClass) {
                this.dialogClass = request.dialogStyleClass;
            }
            else {
                this.dialogClass = "dialog";
            }
            this.displayCloseButton = (request.displayCloseButton == true);
            this.display = true;
            if (this.hasQuestions()) {
                for (var q = 0; q < this.dialog.questions.length; q++) {
                    if (this.dialog.questions[q].props?.actionButtonFunction) {
                        this.dialog.questions[q].props.actionButtonClick =
                            this.coreService.applicationFunctions[this.dialog.questions[q].props.actionButtonFunction];
                    }
                    if (this.dialog.questions[q].props?.filterFunction) {
                        this.dialog.questions[q].props.change =
                            this.coreService.applicationFunctions[this.dialog.questions[q].props.filterFunction];
                    }
                }
            }
        }));
        this.subs.push(this.confirmationService.requireConfirmation$.subscribe(request => {
            this.confirmHeader = request.header;
        }));
        this.subs.push(this.dialogService.closeRequested().subscribe(validate => {
            if (validate) {
                this.validateAndClose();
            }
            else {
                this.close();
            }
        }));
    }
    showDialog(dialog, model) {
        this.model = model && model !== null && model !== undefined ? model : {};
        if (dialog?.type === PopupType.confirm) {
            return;
        }
        this.dialog = dialog;
        this.display = true;
    }
    hasQuestions() {
        return this.dialog && this.dialog.questions && this.dialog.questions.length > 0;
    }
    validateAndClose() {
        if (this.hasQuestions()) {
            if (this.form.valid) {
                this.display = false;
                this.onSubmit.emit(this.model);
                this.model = {};
            }
            else {
                markChildControlsAsTouched(this.form);
            }
        }
        else {
            this.display = false;
            const elementToFocus = document.getElementById(this.dialog.onCloseFocusElementId);
            if (elementToFocus) {
                elementToFocus.focus();
            }
            this.onSubmit.emit(null);
        }
    }
    close() {
        this.display = false;
        const elementToFocus = document.getElementById(this.dialog.onCloseFocusElementId);
        if (elementToFocus) {
            elementToFocus.focus();
        }
        if (this.hasQuestions()) {
            this.form.reset();
        }
    }
    isNullOrWhitespaceOnly(input) {
        return isNullOrWhitespaceOnly(input);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxDialogComponent, deps: [{ token: DialogService }, { token: CoreService }, { token: i1$1.ConfirmationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxDialogComponent, selector: "dspx-dialog", outputs: { onSubmit: "onSubmit" }, ngImport: i0, template: "<p-dialog #d *ngIf=\"dialog && display\"\r\n  [(visible)]=\"display\"\r\n  modal = \"true\"\r\n  [styleClass]=\"dialogClass\"\r\n  [baseZIndex]=\"10000\"\r\n  focusTrap=\"true\"\r\n  [closeOnEscape]=\"true\"\r\n  [closable]=\"displayCloseButton\"\r\n  closeAriaLabel=\"Close\"\r\n  [attr.aria-labelledby]=\"'dialogHeading'\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 id=\"dialogHeading\" class=\"p-dialog-title\" tabindex=\"-1\" autofocus>{{ dialog.title }}</h2>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"content\">\r\n    <p [innerHtml]=\"dialog.text\"></p>\r\n    <div *ngIf=\"hasQuestions()\" class=\"dialog-form\" >\r\n      <form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\">\r\n        <formly-form [form]=\"form\" [fields]=\"dialog.questions\" [model]=\"model\"></formly-form>\r\n      </form>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"footer\">\r\n    <p-button *ngIf=\"!isNullOrWhitespaceOnly(dialog.okButtonText)\" (click)=\"validateAndClose()\" [label]=\"dialog.okButtonText\" [title]=\"dialog.okButtonText\" styleClass=\"p-button-conversion\"></p-button>\r\n    <p-button *ngIf=\"(isNullOrWhitespaceOnly(dialog.okButtonText) && isNullOrWhitespaceOnly(dialog.cancelButtonText)) || !isNullOrWhitespaceOnly(dialog.cancelButtonText)\" (click)=\"close()\" [label]=\"isNullOrWhitespaceOnly(dialog.cancelButtonText) ? 'Close dialog' : dialog.cancelButtonText\" [title]=\"isNullOrWhitespaceOnly(dialog.cancelButtonText) ? 'Close dialog' : dialog.cancelButtonText\" styleClass=\"p-button-secondary\"></p-button>\r\n  </ng-template>\r\n</p-dialog>\r\n\r\n<p-confirmDialog\r\n  [styleClass]=\"dialogClass\"\r\n  acceptButtonStyleClass=\"p-button-conversion\"\r\n  rejectButtonStyleClass=\"p-button-secondary\"\r\n  [closable]=\"false\"\r\n  [closeOnEscape]=\"true\"\r\n  acceptIcon=\"pi pi-check\"\r\n  rejectIcon=\"pi pi-times\"\r\n  [attr.aria-labelledby]=\"'confirmDialogHeading'\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 id=\"confirmDialogHeading\" class=\"p-dialog-title\" tabindex=\"-1\">{{confirmHeader}}</h2>\r\n  </ng-template>\r\n</p-confirmDialog>\r\n\r\n<p-toast position=\"bottom-center\" aria-live=\"polite\" aria-atomic=\"true\"></p-toast>\r\n", styles: [".p-confirm-dialog-accept i,.p-confirm-dialog-reject i{margin-right:.2rem}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3$1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "component", type: i7.Toast, selector: "p-toast", inputs: ["key", "autoZIndex", "baseZIndex", "life", "style", "styleClass", "position", "preventOpenDuplicates", "preventDuplicates", "showTransformOptions", "hideTransformOptions", "showTransitionOptions", "hideTransitionOptions", "breakpoints"], outputs: ["onClose"] }, { kind: "component", type: i8.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "maskStyle", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }, { kind: "component", type: i9.ConfirmDialog, selector: "p-confirmDialog", inputs: ["header", "icon", "message", "style", "styleClass", "maskStyleClass", "acceptIcon", "acceptLabel", "closeAriaLabel", "acceptAriaLabel", "acceptVisible", "rejectIcon", "rejectLabel", "rejectAriaLabel", "rejectVisible", "acceptButtonStyleClass", "rejectButtonStyleClass", "closeOnEscape", "dismissableMask", "blockScroll", "rtl", "closable", "appendTo", "key", "autoZIndex", "baseZIndex", "transitionOptions", "focusTrap", "defaultFocus", "breakpoints", "visible", "position"], outputs: ["onHide"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-dialog', encapsulation: ViewEncapsulation.None, template: "<p-dialog #d *ngIf=\"dialog && display\"\r\n  [(visible)]=\"display\"\r\n  modal = \"true\"\r\n  [styleClass]=\"dialogClass\"\r\n  [baseZIndex]=\"10000\"\r\n  focusTrap=\"true\"\r\n  [closeOnEscape]=\"true\"\r\n  [closable]=\"displayCloseButton\"\r\n  closeAriaLabel=\"Close\"\r\n  [attr.aria-labelledby]=\"'dialogHeading'\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 id=\"dialogHeading\" class=\"p-dialog-title\" tabindex=\"-1\" autofocus>{{ dialog.title }}</h2>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"content\">\r\n    <p [innerHtml]=\"dialog.text\"></p>\r\n    <div *ngIf=\"hasQuestions()\" class=\"dialog-form\" >\r\n      <form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\">\r\n        <formly-form [form]=\"form\" [fields]=\"dialog.questions\" [model]=\"model\"></formly-form>\r\n      </form>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"footer\">\r\n    <p-button *ngIf=\"!isNullOrWhitespaceOnly(dialog.okButtonText)\" (click)=\"validateAndClose()\" [label]=\"dialog.okButtonText\" [title]=\"dialog.okButtonText\" styleClass=\"p-button-conversion\"></p-button>\r\n    <p-button *ngIf=\"(isNullOrWhitespaceOnly(dialog.okButtonText) && isNullOrWhitespaceOnly(dialog.cancelButtonText)) || !isNullOrWhitespaceOnly(dialog.cancelButtonText)\" (click)=\"close()\" [label]=\"isNullOrWhitespaceOnly(dialog.cancelButtonText) ? 'Close dialog' : dialog.cancelButtonText\" [title]=\"isNullOrWhitespaceOnly(dialog.cancelButtonText) ? 'Close dialog' : dialog.cancelButtonText\" styleClass=\"p-button-secondary\"></p-button>\r\n  </ng-template>\r\n</p-dialog>\r\n\r\n<p-confirmDialog\r\n  [styleClass]=\"dialogClass\"\r\n  acceptButtonStyleClass=\"p-button-conversion\"\r\n  rejectButtonStyleClass=\"p-button-secondary\"\r\n  [closable]=\"false\"\r\n  [closeOnEscape]=\"true\"\r\n  acceptIcon=\"pi pi-check\"\r\n  rejectIcon=\"pi pi-times\"\r\n  [attr.aria-labelledby]=\"'confirmDialogHeading'\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 id=\"confirmDialogHeading\" class=\"p-dialog-title\" tabindex=\"-1\">{{confirmHeader}}</h2>\r\n  </ng-template>\r\n</p-confirmDialog>\r\n\r\n<p-toast position=\"bottom-center\" aria-live=\"polite\" aria-atomic=\"true\"></p-toast>\r\n", styles: [".p-confirm-dialog-accept i,.p-confirm-dialog-reject i{margin-right:.2rem}\n"] }]
        }], ctorParameters: () => [{ type: DialogService }, { type: CoreService }, { type: i1$1.ConfirmationService }], propDecorators: { onSubmit: [{
                type: Output
            }] } });

class DspxSpinnerComponent {
    constructor(spinnerService) {
        this.spinnerService = spinnerService;
        this.showSpinner = false;
        this.readyToBlock = true;
    }
    ngOnInit() {
        this.subscription = this.spinnerService.spinnerRequested().subscribe(spinnerStatus => {
            this.readyToBlock = false;
            this.showSpinner = spinnerStatus;
            setTimeout(() => {
                this.readyToBlock = true;
            }, 100);
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSpinnerComponent, deps: [{ token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxSpinnerComponent, selector: "dspx-spinner", ngImport: i0, template: "<div role=\"alert\">\r\n  <div *ngIf=\"showSpinner\" >\r\n    <p-blockUI [blocked]=\"showSpinner && readyToBlock\" class=\"spinner-overlay\">\r\n      <span class=\"spinner-ui\">\r\n        Please wait\r\n        <div class=\"loading-icon\">\r\n          <span class=\"dot first\"></span>\r\n          <span class=\"dot second\"></span>\r\n          <span class=\"dot third\"></span>\r\n          <span class=\"dot fourth\"></span>\r\n          <span class=\"dot fifth\"></span>\r\n        </div>\r\n      </span>\r\n    </p-blockUI>\r\n    <span class=\"sr-only\">\r\n      Page busy\r\n    </span>\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$4.BlockUI, selector: "p-blockUI", inputs: ["target", "autoZIndex", "baseZIndex", "styleClass", "blocked"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-spinner', encapsulation: ViewEncapsulation.None, template: "<div role=\"alert\">\r\n  <div *ngIf=\"showSpinner\" >\r\n    <p-blockUI [blocked]=\"showSpinner && readyToBlock\" class=\"spinner-overlay\">\r\n      <span class=\"spinner-ui\">\r\n        Please wait\r\n        <div class=\"loading-icon\">\r\n          <span class=\"dot first\"></span>\r\n          <span class=\"dot second\"></span>\r\n          <span class=\"dot third\"></span>\r\n          <span class=\"dot fourth\"></span>\r\n          <span class=\"dot fifth\"></span>\r\n        </div>\r\n      </span>\r\n    </p-blockUI>\r\n    <span class=\"sr-only\">\r\n      Page busy\r\n    </span>\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: SpinnerService }] });

class DspxDashboardComponent {
    constructor(formConfigurationService, coreService, spinnerService) {
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.form = new UntypedFormGroup({});
        this.onActionButtonClick = new EventEmitter();
        this.onDialogSubmit = new EventEmitter();
        this.onFilter = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.onFormLoad = new EventEmitter();
    }
    ngOnInit() {
        this.coreService.applicationFunctions['filterData'] =
            (field, event) => {
                var filters = [];
                field.parent.fieldGroup.forEach(f => {
                    if (f.type && (f.type === FieldTypes.SEARCH || f.type === FieldTypes.SELECT)) {
                        filters.push({
                            name: f.key.toString(),
                            value: f.formControl.value
                        });
                    }
                });
                var filterEvent = {
                    action: event?.action,
                    field: field,
                    filters: filters
                };
                this.onFilter.emit(filterEvent);
            };
        this.coreService.applicationFunctions['actionButtonClicked'] =
            (field, event) => {
                let actionButtonEvent = {
                    field: field,
                    event: event
                };
                this.onActionButtonClick.emit(actionButtonEvent);
            };
        this.coreService.applicationFunctions['cancel'] =
            () => {
                this.onCancel.emit();
            };
        this.coreService.setActiveFormName(this.formName);
        if (!this.fields) {
            let request = {
                apiEndpointKey: this.formServiceEndpoint,
                templateId: this.templateId,
                versionNo: this.versionNo,
                entityId: this.entityId
            };
            this.formConfigurationService
                .getFormConfigAndResponse(request, this.mockGetConfigApiCallSettings)
                .pipe(take(1))
                .subscribe(data => {
                this.spinnerService.showSpinner();
                this.fields = [data.configData.config];
                this.optionSets = data.configData.optionSets;
                this.model = data.response;
                this.popups = data.configData.popups;
                this.notifications = data.configData.notifications;
                this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, true);
                this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                this.onFormLoad.emit(data);
                this.spinnerService.hideSpinner();
            });
        }
    }
    dialogSubmitted($event) {
        this.onDialogSubmit.emit($event);
    }
    onSubmit() {
    }
    setStatusBar(tabKey, pageKey, statusBarContent) {
        this.formConfigurationService.setStatusBar(this.fields, tabKey, pageKey, statusBarContent);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxDashboardComponent, deps: [{ token: FormConfigurationService }, { token: CoreService }, { token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxDashboardComponent, selector: "dspx-dashboard", inputs: { mockGetConfigApiCallSettings: "mockGetConfigApiCallSettings", formServiceEndpoint: "formServiceEndpoint", templateId: "templateId", versionNo: "versionNo", entityId: "entityId", model: "model", formName: "formName" }, outputs: { onActionButtonClick: "onActionButtonClick", onDialogSubmit: "onDialogSubmit", onFilter: "onFilter", onCancel: "onCancel", onFormLoad: "onFormLoad" }, ngImport: i0, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n  <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\"></formly-form>\r\n</form>\r\n", styles: [""], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: DspxDialogComponent, selector: "dspx-dialog", outputs: ["onSubmit"] }, { kind: "component", type: DspxSpinnerComponent, selector: "dspx-spinner" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxDashboardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-dashboard', template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n  <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\"></formly-form>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: CoreService }, { type: SpinnerService }], propDecorators: { mockGetConfigApiCallSettings: [{
                type: Input
            }], formServiceEndpoint: [{
                type: Input
            }], templateId: [{
                type: Input
            }], versionNo: [{
                type: Input
            }], entityId: [{
                type: Input
            }], model: [{
                type: Input
            }], formName: [{
                type: Input
            }], onActionButtonClick: [{
                type: Output
            }], onDialogSubmit: [{
                type: Output
            }], onFilter: [{
                type: Output
            }], onCancel: [{
                type: Output
            }], onFormLoad: [{
                type: Output
            }] } });

class DspxMobileMenuTriggerComponent {
    constructor(formConfigurationService) {
        this.formConfigurationService = formConfigurationService;
    }
    ngOnInit() {
        this.showButton = false;
        this.formTabsSubscription = this.formConfigurationService.formTabs$.subscribe((tabs) => {
            this.showButton = tabs.length ? true : false;
        });
    }
    ngOnDestroy() {
        this.formTabsSubscription.unsubscribe();
    }
    handleMobileMenuBtnClick() {
        this.toggleMobileMenu();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxMobileMenuTriggerComponent, deps: [{ token: FormConfigurationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxMobileMenuTriggerComponent, selector: "dspx-mobile-menu-trigger", inputs: { text: "text", menuOpen: "menuOpen", toggleMobileMenu: "toggleMobileMenu" }, ngImport: i0, template: "<button pButton pRipple type=\"button\"\r\n    *ngIf=\"showButton\"\r\n    [title]=\"'Display the mobile menu'\"\r\n    [attr.aria-label]=\"'Display the mobile menu'\"\r\n    [attr.aria-expanded]=\"menuOpen\"\r\n    class=\"mobile-menu-btn p-button-text\"\r\n    (click)=\"handleMobileMenuBtnClick()\">\r\n    <i [ngClass]=\"menuOpen ? 'fas fa-times' : 'fas fa-bars'\"></i>\r\n    {{text}}\r\n</button>", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxMobileMenuTriggerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-mobile-menu-trigger', template: "<button pButton pRipple type=\"button\"\r\n    *ngIf=\"showButton\"\r\n    [title]=\"'Display the mobile menu'\"\r\n    [attr.aria-label]=\"'Display the mobile menu'\"\r\n    [attr.aria-expanded]=\"menuOpen\"\r\n    class=\"mobile-menu-btn p-button-text\"\r\n    (click)=\"handleMobileMenuBtnClick()\">\r\n    <i [ngClass]=\"menuOpen ? 'fas fa-times' : 'fas fa-bars'\"></i>\r\n    {{text}}\r\n</button>" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }], propDecorators: { text: [{
                type: Input
            }], menuOpen: [{
                type: Input
            }], toggleMobileMenu: [{
                type: Input
            }] } });

class DspxMobileMenuComponent {
    constructor(formNavigationService, formConfigurationService) {
        this.formNavigationService = formNavigationService;
        this.formConfigurationService = formConfigurationService;
    }
    ngOnInit() {
        this.formTabsSubscription = this.formConfigurationService.formTabs$.subscribe(tabs => {
            this.tabs = tabs;
            this.subMenuOpen = [];
            this.tabs.forEach(() => {
                this.subMenuOpen.push(false);
            });
        });
    }
    ngOnDestroy() {
        this.formTabsSubscription.unsubscribe();
    }
    calculateMenuHeight() {
        let noOfTabs = 0;
        if (this.tabs != null) {
            this.tabs.forEach(tab => {
                noOfTabs++;
                if (tab.fieldGroup && tab.fieldGroup.length > 1) {
                    tab.fieldGroup.forEach(() => {
                        noOfTabs++;
                    });
                }
            });
        }
        return `${noOfTabs * 50}px`;
    }
    toggle(index) {
        this.subMenuOpen[index] = !this.subMenuOpen[index];
    }
    isTabActive(index) {
        return this.formNavigationService.currentTabIndex === index;
    }
    isSubTabActive(index, subIndex) {
        if (this.isTabActive(index)) {
            return this.formNavigationService.currentPageIndex === subIndex;
        }
        return false;
    }
    goToLink(index, subIndex, isTopTab) {
        if ((isTopTab && this.isTabActive(index)) ||
            (!isTopTab && this.isTabActive(index) && this.isSubTabActive(index, subIndex))) {
            return false;
        }
        this.formNavigationService.setActiveIndex(ElementType.TAB, index);
        this.formNavigationService.setActiveIndex(ElementType.PAGE, subIndex);
        this.formNavigationService.setActivePageTitle();
        window.scrollTo(0, 0);
        setTimeout(() => {
            this.toggleMobileMenu();
        }, 400);
    }
    getTabProgress(tab) {
        if (tab.key.toString() !== 'tabs' && tab.parent?.parent?.parent?.fieldGroup != null) {
            const rootFieldGroup = tab.parent.parent.parent.fieldGroup; //FieldGroup containing all the tabs.
            const formModel = tab.parent.parent.parent.model;
            const progressModel = this.formConfigurationService.getProgressModel(rootFieldGroup, formModel, tab);
            return `${progressModel.formProgress[0]?.totalAnswered} / ${progressModel.formProgress[0]?.totalQuestions}`;
        }
        else {
            return '';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxMobileMenuComponent, deps: [{ token: FormNavigationService }, { token: FormConfigurationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxMobileMenuComponent, selector: "dspx-mobile-menu", inputs: { menuOpen: "menuOpen", toggleMobileMenu: "toggleMobileMenu" }, ngImport: i0, template: "<div class=\"mobile-menu\"\r\n     [ngClass]=\"menuOpen ? '' : 'closed'\"\r\n     [ngStyle]=\"{'max-height': calculateMenuHeight()}\"\r\n     [attr.aria-expanded]=\"menuOpen\">\r\n\r\n    <ng-container *ngFor=\"let tab of tabs; index as i\">\r\n        <div class=\"menu-item\" *ngIf=\"tab.props.includeInProgress\">\r\n            <div class=\"menu-item-header\">\r\n                <a role=\"button\"\r\n                   [ngClass]=\"isTabActive(i) ? 'active' : ''\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"goToLink(i, 0, true)\"\r\n                   (keyup.enter)=\"goToLink(i, 0, true)\">\r\n                    {{ tab.props.label }}\r\n                    <p-badge *ngIf=\"tab.props.includeCount\" [value]=\"getTabProgress(tab)\"></p-badge>\r\n                </a>\r\n                <a role=\"button\"\r\n                   class=\"toggle\"\r\n                   aria-expanded=\"subMenuOpen[i] ? 'true' : 'false'\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"toggle(i)\"\r\n                   (keyup.enter)=\"toggle(i)\"\r\n                   *ngIf=\"tab.fieldGroup.length > 1\"\r\n                   aria-label=\"Sub-menu toggle\">\r\n                    <i [ngClass]=\"subMenuOpen[i] ? 'fas fa-minus' : 'fas fa-plus'\" aria-hidden=\"true\"></i>\r\n                </a>\r\n            </div>\r\n\r\n            <div class=\"sub-menu\"\r\n                 [ngClass]=\"subMenuOpen[i] ? '' : 'closed'\"\r\n                 *ngIf=\"tab.fieldGroup.length > 1\"\r\n                 [ngStyle]=\"{'max-height': (tab.fieldGroup.length * 50) + 'px'}\"\r\n                 [attr.aria-expanded]=\"subMenuOpen[i]\">\r\n\r\n                <ng-container *ngFor=\"let subTab of tab.fieldGroup; index as j\">\r\n                    <div class=\"menu-item\" *ngIf=\"subTab.props.includeInProgress\">\r\n                        <div class=\"menu-item-header\">\r\n                            <a role=\"button\"\r\n                               [ngClass]=\"isSubTabActive(i, j) ? 'active' : ''\"\r\n                               tabindex=\"0\"\r\n                               (click)=\"goToLink(i, j, false)\"\r\n                               (keyup.enter)=\"goToLink(i, j, false)\">\r\n                                {{ subTab.props.label }}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n\r\n        </div>\r\n    </ng-container>\r\n\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i3$5.Badge, selector: "p-badge", inputs: ["styleClass", "style", "badgeSize", "severity", "value", "badgeDisabled", "size"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxMobileMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-mobile-menu', encapsulation: ViewEncapsulation.None, template: "<div class=\"mobile-menu\"\r\n     [ngClass]=\"menuOpen ? '' : 'closed'\"\r\n     [ngStyle]=\"{'max-height': calculateMenuHeight()}\"\r\n     [attr.aria-expanded]=\"menuOpen\">\r\n\r\n    <ng-container *ngFor=\"let tab of tabs; index as i\">\r\n        <div class=\"menu-item\" *ngIf=\"tab.props.includeInProgress\">\r\n            <div class=\"menu-item-header\">\r\n                <a role=\"button\"\r\n                   [ngClass]=\"isTabActive(i) ? 'active' : ''\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"goToLink(i, 0, true)\"\r\n                   (keyup.enter)=\"goToLink(i, 0, true)\">\r\n                    {{ tab.props.label }}\r\n                    <p-badge *ngIf=\"tab.props.includeCount\" [value]=\"getTabProgress(tab)\"></p-badge>\r\n                </a>\r\n                <a role=\"button\"\r\n                   class=\"toggle\"\r\n                   aria-expanded=\"subMenuOpen[i] ? 'true' : 'false'\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"toggle(i)\"\r\n                   (keyup.enter)=\"toggle(i)\"\r\n                   *ngIf=\"tab.fieldGroup.length > 1\"\r\n                   aria-label=\"Sub-menu toggle\">\r\n                    <i [ngClass]=\"subMenuOpen[i] ? 'fas fa-minus' : 'fas fa-plus'\" aria-hidden=\"true\"></i>\r\n                </a>\r\n            </div>\r\n\r\n            <div class=\"sub-menu\"\r\n                 [ngClass]=\"subMenuOpen[i] ? '' : 'closed'\"\r\n                 *ngIf=\"tab.fieldGroup.length > 1\"\r\n                 [ngStyle]=\"{'max-height': (tab.fieldGroup.length * 50) + 'px'}\"\r\n                 [attr.aria-expanded]=\"subMenuOpen[i]\">\r\n\r\n                <ng-container *ngFor=\"let subTab of tab.fieldGroup; index as j\">\r\n                    <div class=\"menu-item\" *ngIf=\"subTab.props.includeInProgress\">\r\n                        <div class=\"menu-item-header\">\r\n                            <a role=\"button\"\r\n                               [ngClass]=\"isSubTabActive(i, j) ? 'active' : ''\"\r\n                               tabindex=\"0\"\r\n                               (click)=\"goToLink(i, j, false)\"\r\n                               (keyup.enter)=\"goToLink(i, j, false)\">\r\n                                {{ subTab.props.label }}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n\r\n        </div>\r\n    </ng-container>\r\n\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: FormNavigationService }, { type: FormConfigurationService }], propDecorators: { menuOpen: [{
                type: Input
            }], toggleMobileMenu: [{
                type: Input
            }] } });

class DspxHeaderComponent {
    constructor(coreService, formNavigationService) {
        this.coreService = coreService;
        this.formNavigationService = formNavigationService;
        this.userMenuItems = []; //Note: If you assign menu items to this input variable, you do not need to assign anything to the 'links' input variable.
        this.toggleMobileMenu = () => {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        };
    }
    ngOnInit() {
        this.applicationTitle = this.config && this.config.applicationTitle && this.config.applicationTitle !== '' ? this.config.applicationTitle : 'Department of Health';
        this.applicationSubTitle = this.config && this.config.applicationSubTitle && this.config.applicationSubTitle !== '' ? this.config.applicationSubTitle : 'Digital Platform';
        this.applicationTitleUrl = this.config && this.config.applicationTitleUrl && this.config.applicationTitleUrl !== '' ? this.config.applicationTitleUrl : '';
        this.applicationSubTitleUrl = this.config && this.config.applicationSubTitleUrl && this.config.applicationSubTitleUrl !== '' ? this.config.applicationSubTitleUrl : '';
        this.applicationLogoLabel = this.config && this.config.applicationLogoLabel && this.config.applicationLogoLabel !== '' ? this.config.applicationLogoLabel : this.applicationTitle;
        this.applicationLogoTitle = this.config && this.config.applicationLogoTitle && this.config.applicationLogoTitle !== '' ? this.config.applicationLogoTitle : this.applicationTitle;
        this.mobileMenuOpen = false;
        this.dashboardLink = 'dashboard';
        this.coreService.setApplicationTitle(this.applicationTitle + ' - ' + this.applicationSubTitle);
        this.formNavigationService.setActivePageTitle();
        if (this.links != null && this.links.length > 0) {
            this.userMenuItems.push(this.links);
        }
        if (this.showLogout === undefined || this.showLogout === null || this.showLogout === true) {
            this.userMenuItems.push({
                label: 'Navigate',
                items: [
                    {
                        label: 'Logout',
                        icon: 'pi pi-sign-out',
                        routerLink: 'logout'
                    }
                ]
            });
        }
    }
    menuRequired() {
        let menuRequired = this.showMenu === undefined || this.showMenu === null || this.showMenu === true;
        return menuRequired;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxHeaderComponent, deps: [{ token: CoreService }, { token: FormNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxHeaderComponent, selector: "dspx-header", inputs: { config: "config", userMenuItems: "userMenuItems", links: "links", showMenu: "showMenu", showLogout: "showLogout" }, ngImport: i0, template: "<header class=\"header\">\r\n  <div class=\"skipnav\"><a href=\"javascript:void(0)\" onclick=\"document.getElementById('main_content').focus();\" aria-label=\"Skip to main content\" role=\"button\">Skip to main content</a></div>\r\n  <div class=\"header__topbar\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <div class=\"header__topbar-navigation col\">\r\n          <div *ngIf=\"menuRequired()\">\r\n            <button type=\"button\" pButton class=\"p-button-text\" icon=\"fas fa-chevron-down\"\r\n              label=\"{{config.userName}}\"\r\n              title=\"{{config.userName}}\"\r\n              [attr.aria-label]=\"config.userName\"\r\n              (click)=\"menu.toggle($event)\"></button>\r\n            <p-menu #menu [popup]=\"true\" [model]=\"userMenuItems\"></p-menu>\r\n          </div>\r\n          <dspx-mobile-menu-trigger text=\"Menu\" [menuOpen]=\"mobileMenuOpen\" [toggleMobileMenu]=\"toggleMobileMenu\"></dspx-mobile-menu-trigger>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"header__content\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <div class=\"col-1\">\r\n          <div><a class=\"header_content-logo\" [attr.href]=\"applicationTitleUrl ? applicationTitleUrl : null\" target=\"_blank\" [attr.title]=\"applicationLogoTitle\" [attr.aria-label]=\"applicationLogoLabel\" ></a></div>\r\n        </div>\r\n        <div class=\"col-11\">\r\n          <div><a class=\"header_content-title\" [attr.href]=\"applicationTitleUrl ? applicationTitleUrl : null\" target=\"_blank\">{{applicationTitle}}</a></div>\r\n          <div><a class=\"header_content-subtitle\" [attr.href]=\"applicationSubTitleUrl ? applicationSubTitleUrl : null\">{{applicationSubTitle}}</a></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"header__background\" focusable=\"false\" aria-hidden=\"true\"></div>\r\n  </div>\r\n\r\n  <dspx-mobile-menu [menuOpen]=\"mobileMenuOpen\" [toggleMobileMenu]=\"toggleMobileMenu\"></dspx-mobile-menu>\r\n</header>\r\n<div id=\"main_content\" tabindex=\"-2\"></div>\r\n", styles: [".skipnav a{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;color:#fff}.skipnav a:focus,.skipnav a:active{left:0;width:auto;height:auto;overflow:visible;z-index:9999}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i4$2.Menu, selector: "p-menu", inputs: ["model", "popup", "style", "styleClass", "appendTo", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "id", "tabindex"], outputs: ["onShow", "onHide", "onBlur", "onFocus"] }, { kind: "component", type: DspxMobileMenuTriggerComponent, selector: "dspx-mobile-menu-trigger", inputs: ["text", "menuOpen", "toggleMobileMenu"] }, { kind: "component", type: DspxMobileMenuComponent, selector: "dspx-mobile-menu", inputs: ["menuOpen", "toggleMobileMenu"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-header', encapsulation: ViewEncapsulation.None, template: "<header class=\"header\">\r\n  <div class=\"skipnav\"><a href=\"javascript:void(0)\" onclick=\"document.getElementById('main_content').focus();\" aria-label=\"Skip to main content\" role=\"button\">Skip to main content</a></div>\r\n  <div class=\"header__topbar\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <div class=\"header__topbar-navigation col\">\r\n          <div *ngIf=\"menuRequired()\">\r\n            <button type=\"button\" pButton class=\"p-button-text\" icon=\"fas fa-chevron-down\"\r\n              label=\"{{config.userName}}\"\r\n              title=\"{{config.userName}}\"\r\n              [attr.aria-label]=\"config.userName\"\r\n              (click)=\"menu.toggle($event)\"></button>\r\n            <p-menu #menu [popup]=\"true\" [model]=\"userMenuItems\"></p-menu>\r\n          </div>\r\n          <dspx-mobile-menu-trigger text=\"Menu\" [menuOpen]=\"mobileMenuOpen\" [toggleMobileMenu]=\"toggleMobileMenu\"></dspx-mobile-menu-trigger>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"header__content\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <div class=\"col-1\">\r\n          <div><a class=\"header_content-logo\" [attr.href]=\"applicationTitleUrl ? applicationTitleUrl : null\" target=\"_blank\" [attr.title]=\"applicationLogoTitle\" [attr.aria-label]=\"applicationLogoLabel\" ></a></div>\r\n        </div>\r\n        <div class=\"col-11\">\r\n          <div><a class=\"header_content-title\" [attr.href]=\"applicationTitleUrl ? applicationTitleUrl : null\" target=\"_blank\">{{applicationTitle}}</a></div>\r\n          <div><a class=\"header_content-subtitle\" [attr.href]=\"applicationSubTitleUrl ? applicationSubTitleUrl : null\">{{applicationSubTitle}}</a></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"header__background\" focusable=\"false\" aria-hidden=\"true\"></div>\r\n  </div>\r\n\r\n  <dspx-mobile-menu [menuOpen]=\"mobileMenuOpen\" [toggleMobileMenu]=\"toggleMobileMenu\"></dspx-mobile-menu>\r\n</header>\r\n<div id=\"main_content\" tabindex=\"-2\"></div>\r\n", styles: [".skipnav a{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;color:#fff}.skipnav a:focus,.skipnav a:active{left:0;width:auto;height:auto;overflow:visible;z-index:9999}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: FormNavigationService }], propDecorators: { config: [{
                type: Input
            }], userMenuItems: [{
                type: Input
            }], links: [{
                type: Input
            }], showMenu: [{
                type: Input
            }], showLogout: [{
                type: Input
            }] } });

class DspxFooterComponent {
    constructor() {
        this.departmentName = 'Department of Health';
        this.governmentName = 'State Government of Victoria, Australia';
        this.year = (new Date()).getFullYear().toString();
    }
    ngOnInit() {
        if (this.config == null) {
            this.config = {
                departmentName: this.departmentName,
                governmentName: this.governmentName,
                year: this.year
            };
        }
        else {
            if (this.config.departmentName == null || this.config.departmentName === '') {
                this.config.departmentName = this.departmentName;
            }
            if (this.config.governmentName == null || this.config.governmentName === '') {
                this.config.governmentName = this.governmentName;
            }
            this.config.year = this.year;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxFooterComponent, selector: "dspx-footer", inputs: { config: "config", linkColumns: "linkColumns" }, ngImport: i0, template: "<footer class=\"footer\">\r\n  <div class=\"footer--main\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <ng-container *ngFor=\"let column of linkColumns; index as i\">\r\n          <div *ngIf=\"i < 3\" class=\"col-12 sm:col-6 md:col-5 lg:col-4\">\r\n            <ul class=\"footer--link-list\">\r\n              <li class=\"footer--link-list-header\">{{ column.heading }}</li>\r\n              <li *ngFor=\"let link of column.links; index as j\">\r\n                <a href=\"{{ link.url }}\" title=\"{{ link.altText }}\" target=\"_blank\">{{ link.label }}</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </ng-container>\r\n        <div class=\"grid col-12\">\r\n          <div class=\"acknowledgement flex\">\r\n            <div focusable=\"false\" role=\"img\" aria-label=\"Aboriginal flag\" class=\"col-1 a--flag\"></div>\r\n            <div focusable=\"false\" role=\"img\" aria-label=\"Torres Strait Island flag\" class=\"col-1 t--flag\"></div>\r\n            <div focusable=\"false\" role=\"img\" aria-label=\"Progressive Pride flag\" class=\"col-1 p--flag\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"grid col-12\">\r\n          <div class=\"acknowledgement-text\">\r\n            <p class=\"small\">\r\n              The Victorian Government acknowledges Aboriginal and Torres Strait Islander people as the Traditional Custodians of the land and acknowledges and pays respect to their Elders, past and present.\r\n              <br>\r\n              The {{ config.departmentName }} celebrates, values and includes people of all backgrounds, genders, sexualities, cultures, bodies and abilities.\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"footer--bottom\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <div class=\"col-12\">\r\n          <div class=\"footer--logo\" focusable=\"false\" role=\"img\" aria-label=\"Victorian government logo\"></div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n          <p class=\"small\">\r\n            {{ config.departmentName }}<br />\r\n            {{ config.governmentName }}<br />\r\n            &copy; {{ config.year }}\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-footer', encapsulation: ViewEncapsulation.None, template: "<footer class=\"footer\">\r\n  <div class=\"footer--main\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <ng-container *ngFor=\"let column of linkColumns; index as i\">\r\n          <div *ngIf=\"i < 3\" class=\"col-12 sm:col-6 md:col-5 lg:col-4\">\r\n            <ul class=\"footer--link-list\">\r\n              <li class=\"footer--link-list-header\">{{ column.heading }}</li>\r\n              <li *ngFor=\"let link of column.links; index as j\">\r\n                <a href=\"{{ link.url }}\" title=\"{{ link.altText }}\" target=\"_blank\">{{ link.label }}</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </ng-container>\r\n        <div class=\"grid col-12\">\r\n          <div class=\"acknowledgement flex\">\r\n            <div focusable=\"false\" role=\"img\" aria-label=\"Aboriginal flag\" class=\"col-1 a--flag\"></div>\r\n            <div focusable=\"false\" role=\"img\" aria-label=\"Torres Strait Island flag\" class=\"col-1 t--flag\"></div>\r\n            <div focusable=\"false\" role=\"img\" aria-label=\"Progressive Pride flag\" class=\"col-1 p--flag\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"grid col-12\">\r\n          <div class=\"acknowledgement-text\">\r\n            <p class=\"small\">\r\n              The Victorian Government acknowledges Aboriginal and Torres Strait Islander people as the Traditional Custodians of the land and acknowledges and pays respect to their Elders, past and present.\r\n              <br>\r\n              The {{ config.departmentName }} celebrates, values and includes people of all backgrounds, genders, sexualities, cultures, bodies and abilities.\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"footer--bottom\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid grid-nogutter\">\r\n        <div class=\"col-12\">\r\n          <div class=\"footer--logo\" focusable=\"false\" role=\"img\" aria-label=\"Victorian government logo\"></div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n          <p class=\"small\">\r\n            {{ config.departmentName }}<br />\r\n            {{ config.governmentName }}<br />\r\n            &copy; {{ config.year }}\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { config: [{
                type: Input
            }], linkColumns: [{
                type: Input
            }] } });

class StickyElementDirective {
    constructor(el, stickyService) {
        this.el = el;
        this.stickyService = stickyService;
        this.zIndex = 100;
        this.position = 'top';
        this.offset = 0;
        this.over = false;
        this.stack = true;
        this.includePadding = false;
        this.initialised = false;
    }
    ngAfterViewChecked() {
        if (!this.stickyElement)
            return;
        if (this.initialised)
            return;
        const { zIndex, position, offset, container, target, over, stack, includePadding } = this.stickyElement;
        this.zIndex = zIndex || this.zIndex;
        this.position = position || this.position;
        this.offset = offset || this.offset;
        this.over = over || this.over;
        this.stack = typeof stack === 'undefined' ? this.stack : stack;
        this.stickyEl = this.el.nativeElement;
        this.includePadding = typeof includePadding === 'undefined' ? this.includePadding : includePadding;
        if (typeof container === 'string') {
            var els = [];
            var el = this.stickyEl;
            while (el) {
                if (el.matches(container))
                    break;
                els.push(el);
                el = el.parentElement;
            }
            this.stickyEl = els.pop();
        }
        else if (typeof target === 'string') {
            this.stickyEl = this.stickyEl.querySelector(target);
        }
        if (this.includePadding) {
            this.offset += Number.parseFloat(window.getComputedStyle(this.stickyEl, null).getPropertyValue('padding-top'));
        }
        this.stickyService.register(this);
        this.stick();
        this.initialised = true;
    }
    stick() {
        this.stickyEl.style.display = 'block';
        this.stickyEl.style.position = 'sticky';
        this.stickyEl.style.zIndex = this.stickyService.getZIndex(this).toString();
        let offset = this.stickyService.getOffset(this) + this.offset;
        this.stickyEl.style[this.position] = (offset > 0 ? (offset - 1) : offset) + 'px';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StickyElementDirective, deps: [{ token: i0.ElementRef }, { token: StickyElementService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: StickyElementDirective, selector: "[stickyElement]", inputs: { stickyElement: "stickyElement" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StickyElementDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[stickyElement]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: StickyElementService }], propDecorators: { stickyElement: [{
                type: Input,
                args: ['stickyElement']
            }] } });

class DspxHeaderBarComponent {
    constructor() {
        this.stickySettings = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxHeaderBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxHeaderBarComponent, selector: "dspx-header-bar", inputs: { content: "content", sticky: "sticky", stickySettings: "stickySettings" }, ngImport: i0, template: "<div class=\"header-bar\" [stickyElement]=\"sticky ? stickySettings : false\">\r\n  <div class=\"grid\">\r\n    <div class=\"col\">\r\n      <div [innerHTML]=\"content\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".header-bar{padding:0 2.5rem}.header-bar .grid{margin-top:0}\n"], dependencies: [{ kind: "directive", type: StickyElementDirective, selector: "[stickyElement]", inputs: ["stickyElement"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxHeaderBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-header-bar', encapsulation: ViewEncapsulation.None, template: "<div class=\"header-bar\" [stickyElement]=\"sticky ? stickySettings : false\">\r\n  <div class=\"grid\">\r\n    <div class=\"col\">\r\n      <div [innerHTML]=\"content\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".header-bar{padding:0 2.5rem}.header-bar .grid{margin-top:0}\n"] }]
        }], propDecorators: { content: [{
                type: Input
            }], sticky: [{
                type: Input
            }], stickySettings: [{
                type: Input
            }] } });

class DspxHeadingComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxHeadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxHeadingComponent, selector: "dspx-heading", inputs: { heading: "heading", level: "level" }, ngImport: i0, template: "<div *ngIf=\"level === 1 && heading && heading !== ''\">\r\n    <h1>{{heading}}</h1>\r\n</div>\r\n<div *ngIf=\"level === 2 && heading && heading !== ''\">\r\n    <h2>{{heading}}</h2>\r\n</div>\r\n<div *ngIf=\"level === 3 && heading && heading !== ''\">\r\n    <h3>{{heading}}</h3>\r\n</div>\r\n<div *ngIf=\"level === 4 && heading && heading !== ''\">\r\n  <h4>{{heading}}</h4>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxHeadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-heading', template: "<div *ngIf=\"level === 1 && heading && heading !== ''\">\r\n    <h1>{{heading}}</h1>\r\n</div>\r\n<div *ngIf=\"level === 2 && heading && heading !== ''\">\r\n    <h2>{{heading}}</h2>\r\n</div>\r\n<div *ngIf=\"level === 3 && heading && heading !== ''\">\r\n    <h3>{{heading}}</h3>\r\n</div>\r\n<div *ngIf=\"level === 4 && heading && heading !== ''\">\r\n  <h4>{{heading}}</h4>\r\n</div>\r\n" }]
        }], propDecorators: { heading: [{
                type: Input
            }], level: [{
                type: Input
            }] } });

class DspxSecondaryNavigationComponent {
    constructor() { }
    ngOnInit() {
        this.menuItems = [
            {
                key: "tab1",
                type: "tabs",
                props: {
                    label: "Who?",
                    number: 1,
                    includeInProgress: true
                },
                fieldGroup: [
                    {
                        key: "page1",
                        type: "page",
                        props: {
                            label: "Who?",
                            includeInProgress: false
                        }
                    }
                ]
            },
            {
                key: "tab2",
                type: "tabs",
                props: {
                    label: "When?",
                    number: 2,
                    includeInProgress: true
                },
                fieldGroup: [
                    {
                        key: "page1",
                        type: "page",
                        props: {
                            label: "When?",
                            includeInProgress: true
                        }
                    }
                ]
            },
            {
                key: "tab3",
                type: "tabs",
                props: {
                    label: "Where?",
                    number: 3,
                    includeInProgress: true
                },
                fieldGroup: [
                    {
                        key: "page1",
                        type: "page",
                        props: {
                            label: "At Home",
                            includeInProgress: true
                        }
                    },
                    {
                        key: "page2",
                        type: "page",
                        props: {
                            label: "At Work",
                            includeInProgress: true
                        }
                    },
                    {
                        key: "page3",
                        type: "page",
                        props: {
                            label: "At University",
                            includeInProgress: true
                        }
                    }
                ]
            },
            {
                key: "tab4",
                type: "tabs",
                props: {
                    label: "What?",
                    number: 4,
                    includeInProgress: true
                },
                fieldGroup: [
                    {
                        key: "page1",
                        type: "page",
                        props: {
                            label: "What?",
                            includeInProgress: true
                        }
                    }
                ]
            },
            {
                key: "tab5",
                type: "tabs",
                props: {
                    label: "How & Why?",
                    number: 5,
                    includeInProgress: true
                },
                fieldGroup: [
                    {
                        key: "page1",
                        type: "page",
                        props: {
                            label: "How & Why?",
                            includeInProgress: true
                        }
                    }
                ]
            },
            {
                key: "tab6",
                type: "tabs",
                props: {
                    label: "WorkSafe",
                    number: 6,
                    includeInProgress: true
                },
                fieldGroup: [
                    {
                        key: "page1",
                        type: "page",
                        props: {
                            label: "Actions",
                            "includeInProgress": true
                        }
                    },
                    {
                        key: "page2",
                        type: "page",
                        props: {
                            label: "Reports",
                            "includeInProgress": true
                        }
                    }
                ]
            }
        ];
        this.subMenuOpen = [];
        this.menuItems.forEach(() => {
            this.subMenuOpen.push(false);
        });
    }
    toggle(index) {
        this.subMenuOpen[index] = !this.subMenuOpen[index];
    }
    isItemActive(index) {
        return index === 0 ? true : false;
    }
    isSubItemActive(index, subIndex) {
        if (this.isItemActive(index)) {
            return subIndex === 0 ? true : false;
        }
        return false;
    }
    goToLink(index, subIndex, isTopItem) {
        if (isTopItem) {
            alert(`You clicked on menu item ${index + 1}`);
        }
        else {
            alert(`You clicked on sub-item ${subIndex + 1} of menu item ${index + 1}`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSecondaryNavigationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxSecondaryNavigationComponent, selector: "dspx-secondary-navigation", ngImport: i0, template: "<div class=\"secondary-menu\">\r\n    <ng-container *ngFor=\"let item of menuItems; index as i\">\r\n        <div class=\"menu-item\" *ngIf=\"item.props.includeInProgress\">\r\n            <div class=\"menu-item-header\" [ngClass]=\"isItemActive(i) ? 'active' : ''\">\r\n                <a role=\"button\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"goToLink(i, 0, true)\"\r\n                   (keyup.enter)=\"goToLink(i, 0, true)\">\r\n                    {{ item.props.label }}\r\n                </a>\r\n                <a role=\"button\"\r\n                   class=\"toggle\"\r\n                   aria-expanded=\"subMenuOpen[i] ? 'true' : 'false'\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"toggle(i)\"\r\n                   (keyup.enter)=\"toggle(i)\"\r\n                   *ngIf=\"item.fieldGroup.length > 1\"\r\n                   aria-label=\"Sub-menu toggle\">\r\n                    <i [ngClass]=\"subMenuOpen[i] ? 'fas fa-minus' : 'fas fa-plus'\" aria-hidden=\"true\"></i>\r\n                </a>\r\n            </div>\r\n\r\n            <div class=\"sub-menu\"\r\n                 [ngClass]=\"subMenuOpen[i] ? '' : 'closed'\"\r\n                 *ngIf=\"item.fieldGroup.length > 1\"\r\n                 [ngStyle]=\"{'max-height': (item.fieldGroup.length * 55) + 'px'}\"\r\n                 [attr.aria-expanded]=\"subMenuOpen[i]\">\r\n\r\n                <ng-container *ngFor=\"let subItem of item.fieldGroup; index as j\">\r\n                    <div class=\"menu-item\" *ngIf=\"subItem.props.includeInProgress\">\r\n                        <div class=\"menu-item-header\" [ngClass]=\"isSubItemActive(i, j) ? 'active' : ''\">\r\n                            <a role=\"button\"\r\n                               tabindex=\"0\"\r\n                               (click)=\"goToLink(i, j, false)\"\r\n                               (keyup.enter)=\"goToLink(i, j, false)\">\r\n                                {{ subItem.props.label }}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n\r\n        </div>\r\n    </ng-container>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSecondaryNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-secondary-navigation', encapsulation: ViewEncapsulation.None, template: "<div class=\"secondary-menu\">\r\n    <ng-container *ngFor=\"let item of menuItems; index as i\">\r\n        <div class=\"menu-item\" *ngIf=\"item.props.includeInProgress\">\r\n            <div class=\"menu-item-header\" [ngClass]=\"isItemActive(i) ? 'active' : ''\">\r\n                <a role=\"button\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"goToLink(i, 0, true)\"\r\n                   (keyup.enter)=\"goToLink(i, 0, true)\">\r\n                    {{ item.props.label }}\r\n                </a>\r\n                <a role=\"button\"\r\n                   class=\"toggle\"\r\n                   aria-expanded=\"subMenuOpen[i] ? 'true' : 'false'\"\r\n                   tabindex=\"0\"\r\n                   (click)=\"toggle(i)\"\r\n                   (keyup.enter)=\"toggle(i)\"\r\n                   *ngIf=\"item.fieldGroup.length > 1\"\r\n                   aria-label=\"Sub-menu toggle\">\r\n                    <i [ngClass]=\"subMenuOpen[i] ? 'fas fa-minus' : 'fas fa-plus'\" aria-hidden=\"true\"></i>\r\n                </a>\r\n            </div>\r\n\r\n            <div class=\"sub-menu\"\r\n                 [ngClass]=\"subMenuOpen[i] ? '' : 'closed'\"\r\n                 *ngIf=\"item.fieldGroup.length > 1\"\r\n                 [ngStyle]=\"{'max-height': (item.fieldGroup.length * 55) + 'px'}\"\r\n                 [attr.aria-expanded]=\"subMenuOpen[i]\">\r\n\r\n                <ng-container *ngFor=\"let subItem of item.fieldGroup; index as j\">\r\n                    <div class=\"menu-item\" *ngIf=\"subItem.props.includeInProgress\">\r\n                        <div class=\"menu-item-header\" [ngClass]=\"isSubItemActive(i, j) ? 'active' : ''\">\r\n                            <a role=\"button\"\r\n                               tabindex=\"0\"\r\n                               (click)=\"goToLink(i, j, false)\"\r\n                               (keyup.enter)=\"goToLink(i, j, false)\">\r\n                                {{ subItem.props.label }}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n\r\n        </div>\r\n    </ng-container>\r\n</div>\r\n" }]
        }], ctorParameters: () => [] });

let idx = 0;
class DspxSequentialNavigationPanelComponent {
    constructor(SequentialNavigation, viewContainer, cd) {
        this.viewContainer = viewContainer;
        this.cd = cd;
        this.cache = true;
        this.tooltipPosition = 'top';
        this.tooltipPositionStyle = 'absolute';
        this.id = `dspx-sequential-navigation-panel-${idx++}`;
        this.seqNav = SequentialNavigation;
    }
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'header':
                    this.headerTemplate = item.template;
                    break;
                case 'content':
                    this.contentTemplate = item.template;
                    break;
                default:
                    this.contentTemplate = item.template;
                    break;
            }
        });
    }
    get includeInProgress() {
        return this._includeInProgress;
    }
    set includeInProgress(val) {
        this._includeInProgress = val;
        this.cd.detectChanges();
    }
    get selected() {
        return this._selected;
    }
    set selected(val) {
        this._selected = val;
        if (!this.loaded) {
            this.cd.detectChanges();
        }
        if (val)
            this.loaded = true;
    }
    get disabled() {
        return this._disabled;
    }
    ;
    set disabled(disabled) {
        this._disabled = disabled;
        this.seqNav.cd.markForCheck();
    }
    get header() {
        return this._header;
    }
    set header(header) {
        this._header = header;
        this.seqNav.cd.markForCheck();
    }
    get leftIcon() {
        return this._leftIcon;
    }
    set leftIcon(leftIcon) {
        this._leftIcon = leftIcon;
        this.seqNav.cd.markForCheck();
    }
    get rightIcon() {
        return this._rightIcon;
    }
    set rightIcon(rightIcon) {
        this._rightIcon = rightIcon;
        this.seqNav.cd.markForCheck();
    }
    ngOnDestroy() {
        this.view = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSequentialNavigationPanelComponent, deps: [{ token: forwardRef(() => DspxSequentialNavigationComponent) }, { token: i0.ViewContainerRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxSequentialNavigationPanelComponent, selector: "dspx-sequential-navigation-panel", inputs: { closable: "closable", headerStyle: "headerStyle", headerStyleClass: "headerStyleClass", cache: "cache", tooltip: "tooltip", tooltipPosition: "tooltipPosition", tooltipPositionStyle: "tooltipPositionStyle", tooltipStyleClass: "tooltipStyleClass", includeInProgress: "includeInProgress", selected: "selected", disabled: "disabled", header: "header", leftIcon: "leftIcon", rightIcon: "rightIcon" }, queries: [{ propertyName: "templates", predicate: PrimeTemplate }], ngImport: i0, template: `
    <div [attr.id]="id" class="p-tabview-panel" [hidden]="!selected"
         [attr.aria-hidden]="!selected" *ngIf="!closed">
        <ng-content></ng-content>
        <ng-container *ngIf="contentTemplate && (cache ? loaded : selected)">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </ng-container>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSequentialNavigationPanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dspx-sequential-navigation-panel',
                    template: `
    <div [attr.id]="id" class="p-tabview-panel" [hidden]="!selected"
         [attr.aria-hidden]="!selected" *ngIf="!closed">
        <ng-content></ng-content>
        <ng-container *ngIf="contentTemplate && (cache ? loaded : selected)">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </ng-container>
    </div>
  `
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => DspxSequentialNavigationComponent)]
                }] }, { type: i0.ViewContainerRef }, { type: i0.ChangeDetectorRef }], propDecorators: { closable: [{
                type: Input
            }], headerStyle: [{
                type: Input
            }], headerStyleClass: [{
                type: Input
            }], cache: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], tooltipPosition: [{
                type: Input
            }], tooltipPositionStyle: [{
                type: Input
            }], tooltipStyleClass: [{
                type: Input
            }], templates: [{
                type: ContentChildren,
                args: [PrimeTemplate]
            }], includeInProgress: [{
                type: Input
            }], selected: [{
                type: Input
            }], disabled: [{
                type: Input
            }], header: [{
                type: Input
            }], leftIcon: [{
                type: Input
            }], rightIcon: [{
                type: Input
            }] } });
class DspxSequentialNavigationComponent {
    constructor(el, cd, formNavigationService, formConfigurationService) {
        this.el = el;
        this.cd = cd;
        this.formNavigationService = formNavigationService;
        this.formConfigurationService = formConfigurationService;
        this.menuItems = [];
        this.hasVisibleChildren = true;
        this.isVerticalNavigation = true;
        this.onChange = new EventEmitter();
        this.onClose = new EventEmitter();
        this.activeIndexChange = new EventEmitter();
        this.activeTabNumber = 1;
        this.activePageNumber = 1;
    }
    getTabsConfig() {
        let config = this.tabsConfig;
        if (this.pageNavigationForTab) {
            config = this.tabsConfig.fieldGroup.find(x => x.key === this.pageNavigationForTab);
        }
        return config;
    }
    ngOnInit() {
        this.formNavigationService.onNavigation().subscribe(fne => {
            if (this.pageNavigationForTab) {
                this.activeTabNumber = this.formNavigationService.currentPageNumber;
            }
            else {
                this.activeTabNumber = this.formNavigationService.currentTabNumber;
                this.activePageNumber = this.formNavigationService.currentPageNumber;
            }
            this.cd.markForCheck();
        });
    }
    ngAfterContentInit() {
        this.initTabs();
        this.navPanels.changes.subscribe(_ => {
            this.initTabs();
        });
    }
    ngAfterViewChecked() {
        if (this.tabChanged) {
            this.tabChanged = false;
        }
    }
    initTabs() {
        this.tabs = this.navPanels.toArray();
        let selectedTab = this.findSelectedTab();
        if (!selectedTab && this.tabs.length) {
            if (this.activeIndex != null && this.tabs.length > this.activeIndex)
                this.tabs[this.activeIndex].selected = true;
            else
                this.tabs[0].selected = true;
            this.tabChanged = true;
        }
        this.cd.markForCheck();
    }
    isStepCompleted(tab) {
        return !!this.isValid(tab);
    }
    isValid(field) {
        if (field.key) {
            return field.formControl.valid;
        }
        return field.fieldGroup.every((f) => this.isValid(f));
    }
    isSubStepCompleted(tab, page) {
        return !!this.isValid(page);
    }
    isActive(tab, isPage, page) {
        return isPage
            ? (this.activeTabNumber === tab.props.number
                && this.activePageNumber === page.props.number)
            : (this.activeTabNumber === tab.props.number);
    }
    goToPage(tab, page) {
        // Skip Validation when user is navigating back via nav menu
        let navigationBack = false;
        if (this.pageNavigationForTab) {
            // no pages information when pageNavigationForTab as Navigation is only at Tab level
            navigationBack = (this.activeTabNumber > tab.props.number);
        }
        else {
            if (this.activeTabNumber === tab.props.number) {
                navigationBack = (this.activePageNumber > page.props.number);
            }
            else {
                navigationBack = (this.activeTabNumber > tab.props.number);
            }
        }
        let currentPage = this.getCurrentPage();
        if (!navigationBack && currentPage.props['navigateWithoutValidation'] === false
            && currentPage.formControl.valid === false
            && currentPage.props['isEditable'] === true) {
            markChildControlsAsTouched(currentPage.formControl);
            currentPage.props.showValidationSummary = true;
            if (currentPage.formControl.valid === false) {
                var validationErrorElementId = `validation-error-${currentPage.parent.key.toString()}-${currentPage.key.toString()}`;
                setTimeout(() => {
                    if (document.getElementById(validationErrorElementId) != null) {
                        document.getElementById(validationErrorElementId).scrollIntoView();
                        document.getElementById(validationErrorElementId).focus();
                    }
                }, 200);
            }
            else if (currentPage.formControl.valid) {
                this.navigateToPage(tab, page);
            }
        }
        else {
            this.navigateToPage(tab, page);
        }
    }
    getCurrentPage() {
        if (this.pageNavigationForTab) {
            return this.tabsConfig
                .fieldGroup.find(x => x.key === this.pageNavigationForTab)
                .fieldGroup.find(x => x.key === `page${this.activeTabNumber}`);
        }
        else {
            return this.tabsConfig
                .fieldGroup.find(x => x.key === `tab${this.activeTabNumber}`)
                .fieldGroup.find(x => x.key === `page${this.activePageNumber}`);
        }
    }
    navigateToPage(tab, page) {
        if (this.pageNavigationForTab) {
            page = tab;
            tab = this.tabsConfig.fieldGroup.find(x => x.key === this.pageNavigationForTab);
        }
        this.formNavigationService.setActiveNumber(ElementType.TAB, tab.props.number);
        if (page) {
            this.formNavigationService.setActiveNumber(ElementType.PAGE, page.props.number);
        }
    }
    open(event, tab) {
        if (tab.disabled) {
            if (event) {
                event.preventDefault();
            }
            return;
        }
        if (!tab.selected) {
            let selectedTab = this.findSelectedTab();
            if (selectedTab) {
                selectedTab.selected = false;
            }
            this.tabChanged = true;
            tab.selected = true;
            let selectedTabIndex = this.findTabIndex(tab);
            this.preventActiveIndexPropagation = true;
            this.activeIndexChange.emit(selectedTabIndex);
            this.onChange.emit({ originalEvent: event, index: selectedTabIndex });
        }
        if (event) {
            event.preventDefault();
        }
    }
    close(event, tab) {
        if (this.controlClose) {
            this.onClose.emit({
                originalEvent: event,
                index: this.findTabIndex(tab),
                close: () => {
                    this.closeTab(tab);
                }
            });
        }
        else {
            this.closeTab(tab);
            this.onClose.emit({
                originalEvent: event,
                index: this.findTabIndex(tab)
            });
        }
        event.stopPropagation();
    }
    closeTab(tab) {
        if (tab.disabled) {
            return;
        }
        if (tab.selected) {
            this.tabChanged = true;
            tab.selected = false;
            for (let i = 0; i < this.tabs.length; i++) {
                let tabPanel = this.tabs[i];
                if (!tabPanel.closed && !tab.disabled) {
                    tabPanel.selected = true;
                    break;
                }
            }
        }
        tab.closed = true;
    }
    findSelectedTab() {
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].selected) {
                return this.tabs[i];
            }
        }
        return null;
    }
    findTabIndex(tab) {
        let index = -1;
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i] == tab) {
                index = i;
                break;
            }
        }
        return index;
    }
    getBlockableElement() {
        return this.el.nativeElement.children[0];
    }
    get activeIndex() {
        return this._activeIndex;
    }
    set activeIndex(val) {
        this._activeIndex = val;
        if (this.preventActiveIndexPropagation) {
            this.preventActiveIndexPropagation = false;
            return;
        }
        if (this.tabs && this.tabs.length && this._activeIndex != null && this.tabs.length > this._activeIndex) {
            this.findSelectedTab().selected = false;
            this.tabs[this._activeIndex].selected = true;
            this.tabChanged = true;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSequentialNavigationComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: FormNavigationService }, { token: FormConfigurationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxSequentialNavigationComponent, selector: "dspx-sequential-navigation", inputs: { sticky: "sticky", tabsConfig: "tabsConfig", pageNavigationForTab: "pageNavigationForTab", controlClose: "controlClose", hasVisibleChildren: "hasVisibleChildren", isVerticalNavigation: "isVerticalNavigation", headerBarContent: "headerBarContent", headerBarSticky: "headerBarSticky", headerBarStickySettings: "headerBarStickySettings", activeIndex: "activeIndex" }, outputs: { onChange: "onChange", onClose: "onClose", activeIndexChange: "activeIndexChange" }, host: { classAttribute: "p-component" }, queries: [{ propertyName: "navPanels", predicate: DspxSequentialNavigationPanelComponent }], ngImport: i0, template: "<dspx-header-bar *ngIf=\"headerBarContent\" [content]=\"headerBarContent\" [sticky]=\"headerBarSticky\" [stickySettings]=\"headerBarStickySettings\"></dspx-header-bar>\r\n<div *ngIf=\"isVerticalNavigation else horizontalNavigation\">\r\n  <div class=\"grid\">\r\n    <div class=\"md:col-3 col-12\">\r\n      <nav class=\"sequential-navigation\" [stickyElement]=\"sticky\">\r\n          <ng-container role=\"list\" *ngFor=\"let item of getTabsConfig().fieldGroup; index as i\">\r\n              <!-- <div class=\"menu-item\" [ngClass]=\"stepsCompleted[i] || isActive(i, false, null) ? 'active' : ''\" *ngIf=\"item.props.includeInProgress\"> -->\r\n                <div class=\"menu-item\"\r\n                  [ngClass]=\"{'active': isActive(item, false, null) , 'completed': !isActive(item, false, null) && isStepCompleted(item)}\"\r\n                  *ngIf=\"item.props.includeInProgress && item.hide !== true\">\r\n                  <div class=\"indicator\">\r\n                      <span class=\"connector\"></span>\r\n                      <span class=\"marker\">\r\n                          <i class=\"fas fa-check\" *ngIf=\"isStepCompleted(item); else elseBlock\"></i>\r\n                          <ng-template #elseBlock>\r\n                              <span>{{i + 1}}</span>\r\n                          </ng-template>\r\n                      </span>\r\n                      <span class=\"connector\"></span>\r\n                  </div>\r\n                  <a class=\"label\" (click)=\"goToPage(item,null)\" (keydown.enter)=\"goToPage(item,null)\" tabindex=\"0\" title=\"{{item.props.label}}\">\r\n                      {{item.props.label}}\r\n                  </a>\r\n              </div>\r\n              <ng-container *ngIf=\"hasVisibleChildren && isActive(item, false, null) && item.fieldGroup.length > 1\">\r\n                  <ng-container role=\"listitem\" *ngFor=\"let subItem of item.fieldGroup; index as j\">\r\n                      <!-- <div class=\"menu-item sub-item\" [ngClass]=\"subStepsCompleted[i][j] || isActive(i, true, j) ? 'active' : ''\" *ngIf=\"subItem.props.includeInProgress\"> -->\r\n                        <div class=\"menu-item sub-item\"\r\n                        [ngClass]=\"{'active': isActive(item, true, subItem) , 'completed': !isActive(item, true, subItem) && isSubStepCompleted(item, subItem)}\"\r\n                        *ngIf=\"subItem.props.includeInProgress && subItem.hide !== true\">\r\n                          <div class=\"indicator\">\r\n                              <span class=\"connector\"></span>\r\n                              <span class=\"marker\">\r\n                                  <i class=\"fas fa-check\" *ngIf=\"isSubStepCompleted(item, subItem)\"></i>\r\n                              </span>\r\n                              <span class=\"connector\"></span>\r\n                          </div>\r\n                          <a class=\"label\" (click)=\"goToPage(item,subItem)\" (keydown.enter)=\"goToPage(item,subItem)\" tabindex=\"0\" title=\"{{subItem.props.label}}\">\r\n                              {{subItem.props.label}}\r\n                          </a>\r\n                      </div>\r\n                  </ng-container>\r\n              </ng-container>\r\n          </ng-container>\r\n        </nav>\r\n    </div>\r\n    <div class=\"md:col-9 col-12\">\r\n      <ng-container *ngIf=\"!pageNavigationForTab; else pageLevel\">\r\n        <ng-container *ngFor=\"let tab of tabsConfig.fieldGroup\">\r\n          <ng-container *ngFor=\"let page of tab.fieldGroup\">\r\n            <div [hidden]=\"!isActive(tab,true,page)\">\r\n              <!-- <pre>{{page.fieldGroup | json}}</pre> -->\r\n              <formly-field [field]=\"page\"></formly-field>\r\n\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-template #pageLevel>\r\n        <ng-container *ngFor=\"let page of getTabsConfig().fieldGroup\">\r\n            <div [hidden]=\"!isActive(page,false,null)\">\r\n              <!-- <pre>{{page.fieldGroup | json}}</pre> -->\r\n              <formly-field [field]=\"page\"></formly-field>\r\n            </div>\r\n        </ng-container>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #horizontalNavigation>\r\n    <div class=\"surface-card p-4 border-round shadow-1\">\r\n      <div class=\"px-4 py-5 md:px-6 lg:px-8\">\r\n        <div class=\"flex flex-column md:flex-row lg:gap-5\">\r\n          <ng-container *ngFor=\"let item of getTabsConfig().fieldGroup; index as i\">\r\n              <ng-container *ngFor=\"let subItem of item.fieldGroup; index as j\">\r\n                <div *ngIf=\"item.props.includeInProgress && item.hide !== true\"\r\n                [ngClass]=\"{'border-primary': isSubStepCompleted(item, subItem), 'surface-border':!isSubStepCompleted(item, subItem)}\"\r\n                class=\"flex-auto border-left-3 border-top-none md:border-left-none md:border-top-3 pl-3 py-3\"\r\n                [attr.aria-label]=\"isSubStepCompleted(item, subItem)===true ? item.props.label + ' Completed' : item.props.label + ' In Progress'\"\r\n                role=\"navigation\">\r\n                  <a  class=\"pointer\"\r\n                    (click)=\"goToPage(item,subItem)\" (keydown.enter)=\"goToPage(item,subItem)\" tabindex=\"0\" title=\"{{subItem.props.label}}\">\r\n                    <div *ngIf=\"item.props.number >= 0\" class=\"font-bold mb-2\" [ngClass]=\"{'text-primary': isSubStepCompleted(item, subItem), 'text-600':!isSubStepCompleted(item, subItem)}\">STEP {{item.props.number}}</div>\r\n                    <span class=\"text-900 font-medium\">{{item.props.label}}</span>\r\n                  </a>\r\n                </div>\r\n              </ng-container>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  <ng-container *ngFor=\"let page of getTabsConfig().fieldGroup\">\r\n    <div [hidden]=\"!isActive(page,false,null)\">\r\n      <formly-field [field]=\"page\"></formly-field>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n", styles: [".pointer{cursor:pointer}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxHeaderBarComponent, selector: "dspx-header-bar", inputs: ["content", "sticky", "stickySettings"] }, { kind: "directive", type: StickyElementDirective, selector: "[stickyElement]", inputs: ["stickyElement"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSequentialNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-sequential-navigation', encapsulation: ViewEncapsulation.None, host: {
                        class: 'p-component'
                    }, template: "<dspx-header-bar *ngIf=\"headerBarContent\" [content]=\"headerBarContent\" [sticky]=\"headerBarSticky\" [stickySettings]=\"headerBarStickySettings\"></dspx-header-bar>\r\n<div *ngIf=\"isVerticalNavigation else horizontalNavigation\">\r\n  <div class=\"grid\">\r\n    <div class=\"md:col-3 col-12\">\r\n      <nav class=\"sequential-navigation\" [stickyElement]=\"sticky\">\r\n          <ng-container role=\"list\" *ngFor=\"let item of getTabsConfig().fieldGroup; index as i\">\r\n              <!-- <div class=\"menu-item\" [ngClass]=\"stepsCompleted[i] || isActive(i, false, null) ? 'active' : ''\" *ngIf=\"item.props.includeInProgress\"> -->\r\n                <div class=\"menu-item\"\r\n                  [ngClass]=\"{'active': isActive(item, false, null) , 'completed': !isActive(item, false, null) && isStepCompleted(item)}\"\r\n                  *ngIf=\"item.props.includeInProgress && item.hide !== true\">\r\n                  <div class=\"indicator\">\r\n                      <span class=\"connector\"></span>\r\n                      <span class=\"marker\">\r\n                          <i class=\"fas fa-check\" *ngIf=\"isStepCompleted(item); else elseBlock\"></i>\r\n                          <ng-template #elseBlock>\r\n                              <span>{{i + 1}}</span>\r\n                          </ng-template>\r\n                      </span>\r\n                      <span class=\"connector\"></span>\r\n                  </div>\r\n                  <a class=\"label\" (click)=\"goToPage(item,null)\" (keydown.enter)=\"goToPage(item,null)\" tabindex=\"0\" title=\"{{item.props.label}}\">\r\n                      {{item.props.label}}\r\n                  </a>\r\n              </div>\r\n              <ng-container *ngIf=\"hasVisibleChildren && isActive(item, false, null) && item.fieldGroup.length > 1\">\r\n                  <ng-container role=\"listitem\" *ngFor=\"let subItem of item.fieldGroup; index as j\">\r\n                      <!-- <div class=\"menu-item sub-item\" [ngClass]=\"subStepsCompleted[i][j] || isActive(i, true, j) ? 'active' : ''\" *ngIf=\"subItem.props.includeInProgress\"> -->\r\n                        <div class=\"menu-item sub-item\"\r\n                        [ngClass]=\"{'active': isActive(item, true, subItem) , 'completed': !isActive(item, true, subItem) && isSubStepCompleted(item, subItem)}\"\r\n                        *ngIf=\"subItem.props.includeInProgress && subItem.hide !== true\">\r\n                          <div class=\"indicator\">\r\n                              <span class=\"connector\"></span>\r\n                              <span class=\"marker\">\r\n                                  <i class=\"fas fa-check\" *ngIf=\"isSubStepCompleted(item, subItem)\"></i>\r\n                              </span>\r\n                              <span class=\"connector\"></span>\r\n                          </div>\r\n                          <a class=\"label\" (click)=\"goToPage(item,subItem)\" (keydown.enter)=\"goToPage(item,subItem)\" tabindex=\"0\" title=\"{{subItem.props.label}}\">\r\n                              {{subItem.props.label}}\r\n                          </a>\r\n                      </div>\r\n                  </ng-container>\r\n              </ng-container>\r\n          </ng-container>\r\n        </nav>\r\n    </div>\r\n    <div class=\"md:col-9 col-12\">\r\n      <ng-container *ngIf=\"!pageNavigationForTab; else pageLevel\">\r\n        <ng-container *ngFor=\"let tab of tabsConfig.fieldGroup\">\r\n          <ng-container *ngFor=\"let page of tab.fieldGroup\">\r\n            <div [hidden]=\"!isActive(tab,true,page)\">\r\n              <!-- <pre>{{page.fieldGroup | json}}</pre> -->\r\n              <formly-field [field]=\"page\"></formly-field>\r\n\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-template #pageLevel>\r\n        <ng-container *ngFor=\"let page of getTabsConfig().fieldGroup\">\r\n            <div [hidden]=\"!isActive(page,false,null)\">\r\n              <!-- <pre>{{page.fieldGroup | json}}</pre> -->\r\n              <formly-field [field]=\"page\"></formly-field>\r\n            </div>\r\n        </ng-container>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #horizontalNavigation>\r\n    <div class=\"surface-card p-4 border-round shadow-1\">\r\n      <div class=\"px-4 py-5 md:px-6 lg:px-8\">\r\n        <div class=\"flex flex-column md:flex-row lg:gap-5\">\r\n          <ng-container *ngFor=\"let item of getTabsConfig().fieldGroup; index as i\">\r\n              <ng-container *ngFor=\"let subItem of item.fieldGroup; index as j\">\r\n                <div *ngIf=\"item.props.includeInProgress && item.hide !== true\"\r\n                [ngClass]=\"{'border-primary': isSubStepCompleted(item, subItem), 'surface-border':!isSubStepCompleted(item, subItem)}\"\r\n                class=\"flex-auto border-left-3 border-top-none md:border-left-none md:border-top-3 pl-3 py-3\"\r\n                [attr.aria-label]=\"isSubStepCompleted(item, subItem)===true ? item.props.label + ' Completed' : item.props.label + ' In Progress'\"\r\n                role=\"navigation\">\r\n                  <a  class=\"pointer\"\r\n                    (click)=\"goToPage(item,subItem)\" (keydown.enter)=\"goToPage(item,subItem)\" tabindex=\"0\" title=\"{{subItem.props.label}}\">\r\n                    <div *ngIf=\"item.props.number >= 0\" class=\"font-bold mb-2\" [ngClass]=\"{'text-primary': isSubStepCompleted(item, subItem), 'text-600':!isSubStepCompleted(item, subItem)}\">STEP {{item.props.number}}</div>\r\n                    <span class=\"text-900 font-medium\">{{item.props.label}}</span>\r\n                  </a>\r\n                </div>\r\n              </ng-container>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  <ng-container *ngFor=\"let page of getTabsConfig().fieldGroup\">\r\n    <div [hidden]=\"!isActive(page,false,null)\">\r\n      <formly-field [field]=\"page\"></formly-field>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n", styles: [".pointer{cursor:pointer}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: FormNavigationService }, { type: FormConfigurationService }], propDecorators: { sticky: [{
                type: Input
            }], tabsConfig: [{
                type: Input
            }], pageNavigationForTab: [{
                type: Input
            }], controlClose: [{
                type: Input
            }], hasVisibleChildren: [{
                type: Input
            }], isVerticalNavigation: [{
                type: Input
            }], headerBarContent: [{
                type: Input
            }], headerBarSticky: [{
                type: Input
            }], headerBarStickySettings: [{
                type: Input
            }], navPanels: [{
                type: ContentChildren,
                args: [DspxSequentialNavigationPanelComponent]
            }], onChange: [{
                type: Output
            }], onClose: [{
                type: Output
            }], activeIndexChange: [{
                type: Output
            }], activeIndex: [{
                type: Input
            }] } });

class DspxBaseFormComponent extends DspxBaseFormCommonComponent {
    constructor(formConfigurationService, coreService, spinnerService) {
        super(formConfigurationService);
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.title = 'DHHS Solutions Platform v1';
    }
    ngOnInit() {
        this.coreService.applicationFunctions['buttonClicked'] =
            (field, event) => {
                let buttonClickEvent = {
                    isFormValid: this.form.valid,
                    type: field,
                    event: event,
                    data: JSON.stringify(this.model)
                };
                this.onButtonClick.emit(buttonClickEvent);
            };
        this.coreService.applicationFunctions['save'] =
            () => {
                const saveFormEvent = {
                    isFormValid: this.form.valid,
                    model: JSON.stringify(this.model),
                    progressModel: this.getProgressModel(),
                    lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
                    isSubmit: false,
                    closeFormAfterSaving: false
                };
                this.onSave.emit(saveFormEvent);
            };
        this.coreService.applicationFunctions['submit'] =
            () => {
                const saveFormEvent = {
                    isFormValid: this.form.valid,
                    model: JSON.stringify(this.model),
                    progressModel: this.getProgressModel(),
                    lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
                    isSubmit: true,
                    closeFormAfterSaving: true
                };
                this.onSave.emit(saveFormEvent);
            };
        this.coreService.applicationFunctions['saveandclose'] =
            () => {
                const saveFormEvent = {
                    isFormValid: this.form.valid,
                    model: JSON.stringify(this.model),
                    progressModel: this.getProgressModel(),
                    lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
                    isSubmit: false,
                    closeFormAfterSaving: true
                };
                this.onSave.emit(saveFormEvent);
            };
        this.coreService.applicationFunctions['cancel'] =
            () => {
                this.onCancel.emit();
            };
        this.coreService.applicationFunctions['actionButtonClicked'] =
            (field, event) => {
                let actionButtonEvent = {
                    field: field,
                    event: event,
                    model: JSON.stringify(this.model)
                };
                this.onActionButtonClick.emit(actionButtonEvent);
            };
        //TO-DO: Add a generic button clicked function and relevant event if required to support custom buttons and commands
        this.coreService.setActiveFormName(this.formName);
        if (!this.fields) {
            let request = {
                apiEndpointKey: this.formServiceEndpoint,
                templateId: this.templateId,
                versionNo: this.versionNo,
                entityId: this.entityId
            };
            if (request.entityId !== undefined && request.entityId !== null && request.entityId !== '') {
                this.formConfigurationService
                    .getFormConfigAndResponse(request, this.mockGetConfigApiCallSettings)
                    .pipe(take(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = [data.configData.config];
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response;
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, undefined, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = data.formIdentifier;
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
            else {
                this.formConfigurationService
                    .getFormConfig(request, this.mockGetConfigApiCallSettings)
                    .pipe(take(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = [data.configData.config];
                    this.optionSets = data.configData.optionSets;
                    if (data.response) {
                        this.model = data.response;
                    }
                    else {
                        this.model = {};
                    }
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, true, undefined, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = Guid.create().toString();
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
        }
    }
    setHeaderBar(headerBarContent, tabKey, pageKey, sticky = true, stickySettings = {}) {
        this.formConfigurationService.setHeaderBar(this.fields, headerBarContent, tabKey, pageKey, sticky, stickySettings);
    }
    onSubmit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBaseFormComponent, deps: [{ token: FormConfigurationService }, { token: CoreService }, { token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxBaseFormComponent, selector: "dspx-base-form", usesInheritance: true, ngImport: i0, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n\r\n<form id=\"dspx-form\" [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" class=\"baseform\">\r\n  <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n", styles: [""], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: DspxDialogComponent, selector: "dspx-dialog", outputs: ["onSubmit"] }, { kind: "component", type: DspxSpinnerComponent, selector: "dspx-spinner" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBaseFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-base-form', template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n\r\n<form id=\"dspx-form\" [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" class=\"baseform\">\r\n  <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: CoreService }, { type: SpinnerService }] });

class DspxBaseFormReportComponent extends DspxBaseFormCommonComponent {
    constructor(formConfigurationService, coreService, spinnerService) {
        super(formConfigurationService);
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.title = 'DHHS Solutions Platform v1';
    }
    ngOnInit() {
        this.coreService.applicationFunctions['buttonClicked'] =
            (field, event) => {
                let buttonClickEvent = {
                    isFormValid: this.form.valid,
                    type: field,
                    event: event,
                    data: JSON.stringify(this.model)
                };
                this.onButtonClick.emit(buttonClickEvent);
            };
        this.coreService.applicationFunctions['save'] =
            () => {
                const saveFormEvent = {
                    isFormValid: this.form.valid,
                    model: JSON.stringify(this.model),
                    progressModel: this.getProgressModel(),
                    lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
                    isSubmit: false,
                    closeFormAfterSaving: false
                };
                this.onSave.emit(saveFormEvent);
            };
        this.coreService.applicationFunctions['submit'] =
            () => {
                const saveFormEvent = {
                    isFormValid: this.form.valid,
                    model: JSON.stringify(this.model),
                    progressModel: this.getProgressModel(),
                    lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
                    isSubmit: true,
                    closeFormAfterSaving: true
                };
                this.onSave.emit(saveFormEvent);
            };
        this.coreService.applicationFunctions['saveandclose'] =
            () => {
                const saveFormEvent = {
                    isFormValid: this.form.valid,
                    model: JSON.stringify(this.model),
                    progressModel: this.getProgressModel(),
                    lastUpdatedTime: (this.lastUpdatedTime != null && this.lastUpdatedTime !== '') ? this.lastUpdatedTime : null,
                    isSubmit: false,
                    closeFormAfterSaving: true
                };
                this.onSave.emit(saveFormEvent);
            };
        this.coreService.applicationFunctions['cancel'] =
            () => {
                this.onCancel.emit();
            };
        this.coreService.applicationFunctions['actionButtonClicked'] =
            (field, event) => {
                let actionButtonEvent = {
                    field: field,
                    event: event,
                    model: JSON.stringify(this.model)
                };
                this.onActionButtonClick.emit(actionButtonEvent);
            };
        //TO-DO: Add a generic button clicked function and relevant event if required to support custom buttons and commands
        this.coreService.setActiveFormName(this.formName);
        if (this.responseAndConfigs) {
            this.spinnerService.showSpinner();
            this.fields = this.responseAndConfigs.configData.config;
            this.optionSets = this.responseAndConfigs.configData.optionSets;
            this.model = this.responseAndConfigs.response;
            this.popups = this.responseAndConfigs.configData.popups;
            this.notifications = this.responseAndConfigs.configData.notifications;
            this.lastUpdatedTime = this.responseAndConfigs.lastUpdatedTime;
            this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, this.responseAndConfigs.isFormEditable, this.reportModel);
            this.formConfigurationService.setupDialogs(this.popups, this.notifications);
            GridDataHelpers.ParseDatesInGrids(this.responseAndConfigs.configData, this.model);
            this.onFormLoad.emit(this.responseAndConfigs);
            this.spinnerService.hideSpinner();
        }
        if (!this.fields) {
            let request = {
                apiEndpointKey: this.formServiceEndpoint,
                templateId: this.templateId,
                versionNo: this.versionNo,
                entityId: this.entityId
            };
            if (request.entityId !== undefined && request.entityId !== null && request.entityId !== '') {
                this.formConfigurationService
                    .getFormConfigAndResponse(request, this.mockGetConfigApiCallSettings)
                    .pipe(take(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = [data.configData.config];
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response;
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, this.reportModel);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
            else {
                this.formConfigurationService
                    .getFormConfig(request, this.mockGetConfigApiCallSettings)
                    .pipe(take(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = [data.configData.config];
                    this.optionSets = data.configData.optionSets;
                    if (data.response) {
                        this.model = data.response;
                    }
                    else {
                        this.model = {};
                    }
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, true);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
        }
    }
    setStatusBar(tabKey, pageKey, statusBarContent) {
        if (tabKey != null && pageKey != null) {
            let tabField = this.fields[0].fieldGroup[0].fieldGroup.find(tab => tab.key.toString() === tabKey);
            let pageField = tabField.fieldGroup.find(page => page.key.toString() === pageKey);
            pageField.props.statusBarContent = statusBarContent;
        }
        else {
            let tabFields = this.fields[0].fieldGroup[0].fieldGroup;
            tabFields.forEach(tab => {
                let pageFields = tab.fieldGroup;
                pageFields.forEach(page => {
                    page.props.statusBarContent = statusBarContent;
                });
            });
        }
    }
    onSubmit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBaseFormReportComponent, deps: [{ token: FormConfigurationService }, { token: CoreService }, { token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxBaseFormReportComponent, selector: "dspx-base-form-report", inputs: { reportModel: "reportModel", responseAndConfigs: "responseAndConfigs" }, usesInheritance: true, ngImport: i0, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n\r\n<form id=\"dspx-form\" [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" class=\"baseform\">\r\n  <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n", styles: [""], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: DspxDialogComponent, selector: "dspx-dialog", outputs: ["onSubmit"] }, { kind: "component", type: DspxSpinnerComponent, selector: "dspx-spinner" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBaseFormReportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-base-form-report', template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n\r\n<form id=\"dspx-form\" [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" class=\"baseform\">\r\n  <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: CoreService }, { type: SpinnerService }], propDecorators: { reportModel: [{
                type: Input
            }], responseAndConfigs: [{
                type: Input
            }] } });

class DspxBreadcrumbComponent {
    constructor(breadcrumbService) {
        this.breadcrumbService = breadcrumbService;
        this.items = [];
    }
    ngOnInit() {
        this.breadcrumbService.crumbs$
            .subscribe(crumbs => {
            this.items = crumbs;
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBreadcrumbComponent, deps: [{ token: BreadcrumbService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxBreadcrumbComponent, selector: "dspx-breadcrumb", ngImport: i0, template: "<div class=\"breadcrumb\" aria-label=\"Breadcrumb navigation\">\r\n    <ng-container *ngFor=\"let item of items; index as i\">\r\n        <ng-container *ngIf=\"i === items.length - 2\">\r\n            <a class=\"label backIcon\" [attr.href]=\"item.url ?? item.url\" tabindex=\"0\" role=\"link\"><i\r\n                    class=\"pi pi-angle-left\"></i></a>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"i !== 0\">\r\n            <ng-container *ngIf=\"item.separatorIcon; else defaultSeparator\">\r\n                <i class=\"{{item.separatorIcon}} separator\" role=\"presentation\"></i>\r\n            </ng-container>\r\n            <ng-template #defaultSeparator>\r\n                <span class=\"separator\" role=\"presentation\">/</span>\r\n            </ng-template>\r\n        </ng-container>\r\n        <div [attr.class]=\"i === items.length - 1 ? 'lastBreadcrumb' : 'regularBreadcrumb'\">\r\n            <ng-container *ngIf=\"item.url; else noUrl\">\r\n                <a class=\"label\" [attr.href]=\"item.url\" tabindex=\"0\" role=\"link\">{{item.label}}</a>\r\n            </ng-container>\r\n            <ng-template #noUrl>\r\n                <span class=\"label noUrl\">{{item.label}}</span>\r\n            </ng-template>\r\n        </div>\r\n    </ng-container>\r\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-breadcrumb', encapsulation: ViewEncapsulation.None, template: "<div class=\"breadcrumb\" aria-label=\"Breadcrumb navigation\">\r\n    <ng-container *ngFor=\"let item of items; index as i\">\r\n        <ng-container *ngIf=\"i === items.length - 2\">\r\n            <a class=\"label backIcon\" [attr.href]=\"item.url ?? item.url\" tabindex=\"0\" role=\"link\"><i\r\n                    class=\"pi pi-angle-left\"></i></a>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"i !== 0\">\r\n            <ng-container *ngIf=\"item.separatorIcon; else defaultSeparator\">\r\n                <i class=\"{{item.separatorIcon}} separator\" role=\"presentation\"></i>\r\n            </ng-container>\r\n            <ng-template #defaultSeparator>\r\n                <span class=\"separator\" role=\"presentation\">/</span>\r\n            </ng-template>\r\n        </ng-container>\r\n        <div [attr.class]=\"i === items.length - 1 ? 'lastBreadcrumb' : 'regularBreadcrumb'\">\r\n            <ng-container *ngIf=\"item.url; else noUrl\">\r\n                <a class=\"label\" [attr.href]=\"item.url\" tabindex=\"0\" role=\"link\">{{item.label}}</a>\r\n            </ng-container>\r\n            <ng-template #noUrl>\r\n                <span class=\"label noUrl\">{{item.label}}</span>\r\n            </ng-template>\r\n        </div>\r\n    </ng-container>\r\n</div>" }]
        }], ctorParameters: () => [{ type: BreadcrumbService }] });

class DspxLogoutComponent {
    constructor(userService) {
        this.userService = userService;
    }
    ngOnInit() {
        this.userService.logout();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxLogoutComponent, deps: [{ token: UserService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxLogoutComponent, selector: "dspx-logout", ngImport: i0, template: "<p>Logging out...</p>\r\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxLogoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-logout', template: "<p>Logging out...</p>\r\n" }]
        }], ctorParameters: () => [{ type: UserService }] });

class DspxEnvironmentBannerComponent {
    constructor() {
        this.topDividerDisplay = 'never';
        this.bottomDividerDisplay = 'never';
    }
    ngOnInit() {
        if (this.bgcolor == null || this.bgcolor == '') {
            this.bgcolor = '#B30000';
        }
        if (this.color == null || this.color == '') {
            this.color = '#FFFFFF';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxEnvironmentBannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxEnvironmentBannerComponent, selector: "dspx-environment-banner", inputs: { message: "message", bgcolor: "bgcolor", color: "color", topDividerDisplay: "topDividerDisplay", bottomDividerDisplay: "bottomDividerDisplay" }, ngImport: i0, template: "<p-divider *ngIf=\"topDividerDisplay === 'always' || (topDividerDisplay === 'auto' && message)\"></p-divider>\r\n<div *ngIf=\"message\" class=\"environment-banner\" [style.background-color]=\"bgcolor\" [style.color]=\"color\">\r\n  {{message}}\r\n</div>\r\n<p-divider *ngIf=\"bottomDividerDisplay === 'always' || (bottomDividerDisplay === 'auto' && message)\"></p-divider>\r\n", styles: [".environment-banner{position:relative;padding:1rem;font-weight:700;font-size:large;text-align:center}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.Divider, selector: "p-divider", inputs: ["style", "styleClass", "layout", "type", "align"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxEnvironmentBannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-environment-banner', encapsulation: ViewEncapsulation.None, template: "<p-divider *ngIf=\"topDividerDisplay === 'always' || (topDividerDisplay === 'auto' && message)\"></p-divider>\r\n<div *ngIf=\"message\" class=\"environment-banner\" [style.background-color]=\"bgcolor\" [style.color]=\"color\">\r\n  {{message}}\r\n</div>\r\n<p-divider *ngIf=\"bottomDividerDisplay === 'always' || (bottomDividerDisplay === 'auto' && message)\"></p-divider>\r\n", styles: [".environment-banner{position:relative;padding:1rem;font-weight:700;font-size:large;text-align:center}\n"] }]
        }], ctorParameters: () => [], propDecorators: { message: [{
                type: Input
            }], bgcolor: [{
                type: Input
            }], color: [{
                type: Input
            }], topDividerDisplay: [{
                type: Input
            }], bottomDividerDisplay: [{
                type: Input
            }] } });

const DefaultErrorSummaryMap = {
    // ServerValidationErrorType
    headerNotFound: 'Invalid header found in worksheet "{{workSheetName}}"',
    headerPartiallyMissing: 'Invalid header found in worksheet "{{workSheetName}}"',
    headerValueNotFound: 'Invalid header found in worksheet "{{workSheetName}}"',
    noDataRowsFound: 'No values found in worksheet "{{workSheetName}}"',
    noDataValuesFound: 'No values found in worksheet "{{workSheetName}}"',
    noDataValueFound: 'Missing value in worksheet "{{workSheetName}}"',
    invalidDataValueFound: 'Invalid value in worksheet "{{workSheetName}}"',
    custom: 'An error occurred while validating worksheet "{{workSheetName}}"',
    // ClientValidationErrorType
    expectedWorkSheetNotFound: 'Failed to match worksheet name, expected worksheet name: "{{workSheetName}}"',
    failedToReadWorkSheetNamesFromFile: 'Failed to read the worksheet names from Excel file "{{fileName}}"',
    failedToReadWorkSheetContent: 'Failed to read the content of worksheet "{{workSheetName}}"',
    failedToDownloadWorkSheet: 'Failed to download worksheet "{{workSheetName}}"'
};
class DspxExcelFileUploadComponent {
    constructor(spinnerService, excelService, stringService, changeDetector) {
        this.spinnerService = spinnerService;
        this.excelService = excelService;
        this.stringService = stringService;
        this.changeDetector = changeDetector;
        this.messages = [];
        // Note conversion to lower-case - later on we do a case-insensitive comparison between the uploaded file's extension,
        // so we want to be sure these are in lower-case.
        this.validFileExtensions = ['txt', 'csv', 'xlsm', 'xlsx', 'xls'].map(x => x.toLowerCase());
        this.fileAcceptCommaSeparatedList = this.validFileExtensions.map(extension => `.${extension}`).join(',');
        this.filesOnFileUploadControl = [];
        this.file = null;
        this.fileAsBinaryString = null;
        this.workSheetNames = null;
        this.workSheetName = null;
        this.workSheetData = null;
        this.workSheetIndexedColumns = null;
        this.workSheetIndexedRows = null;
        this.fileInfoSeparator1 = '|'; // Not used but kept it here for consistency with backend
        this.fileInfoSeparator2 = ':';
        // TODO: think about moving these methods to the SpinnerService or at least a separate service
        this.spinnerStackLevel = 0;
    }
    set modelContainer(value) {
        this._modelContainer = value ?? {};
    }
    set model(model) {
        this._modelContainer[this.id] = model;
    }
    get model() {
        return this._modelContainer[this.id];
    }
    get selectedWorkSheetName() {
        return this.model.split(this.fileInfoSeparator2)[0];
    }
    get selectedWorkSheetId() {
        return this.model.split(this.fileInfoSeparator2)[1];
    }
    isAutomaticUpload() {
        return this.expectedWorkSheetName && !this.previewEnabled;
    }
    onFileUploadChange(files) {
        this.clearMessages();
        this.execute(() => {
            if (!files) {
                throw new Error('Invalid input');
            }
            if (files.length === 0) {
                return; // no entry selected
            }
            if (files.length !== 1) {
                throw new Error('Cannot use multiple files');
            }
            this.file = files[0];
            // Note case-insensitive comparison (we ensured this.validFileExtensions was all lower-case when we initialised it)
            if (this.file && this.file.name && !this.validFileExtensions.includes(this.getFileExtension(this.file.name.toLowerCase()))) {
                // In this scenario the underlying file upload control has already aborted and issued an error message,
                // therefore there is no need to proceed further nor to issue an error message
                return;
            }
            const reader = new FileReader();
            reader.onload = (progressEvent) => {
                this.execute(() => {
                    this.onFileUploadClear();
                    this.fileAsBinaryString = progressEvent.target.result;
                    this.useSpinnerForSyncAction(() => this.excelService.getWorkSheetNames(this.fileAsBinaryString), result => {
                        this.workSheetNames = result;
                        if (this.expectedWorkSheetName) {
                            if (this.expectedWorkSheetName.indexOf('|') > 0) {
                                const sheetsForUpload = this.expectedWorkSheetName.split('|');
                                if (_.intersection(sheetsForUpload, result).length === sheetsForUpload.length) {
                                    this.onWorkSheetNameChange(this.expectedWorkSheetName);
                                }
                                else {
                                    this.handleError(`No worksheet named "${this.expectedWorkSheetName}" was found in the file`, this.getErrorSummary('expectedWorkSheetNotFound', { workSheetName: this.expectedWorkSheetName }));
                                    return;
                                }
                            }
                            else {
                                if (this.workSheetNames.indexOf(this.expectedWorkSheetName) > -1) {
                                    this.onWorkSheetNameChange(this.expectedWorkSheetName);
                                }
                                else {
                                    this.handleError(`No worksheet named "${this.expectedWorkSheetName}" was found in the file`, this.getErrorSummary('expectedWorkSheetNotFound', { workSheetName: this.expectedWorkSheetName }));
                                    return;
                                }
                            }
                        }
                    }, error => {
                        this.handleError(error, this.getErrorSummary('failedToReadWorkSheetNamesFromFile', { fileName: this.file.name }));
                    });
                });
            };
            reader.onabort = reader.onerror = () => {
                this.execute(() => {
                    throw new Error(`Failed to load file "${this.file?.name}"`);
                });
            };
            reader.readAsBinaryString(this.file);
        });
    }
    onFileUploadClear() {
        this.clearMessages();
        this.model = null;
        this.fileAsBinaryString = null;
        this.workSheetNames = null;
        this.onWorkSheetDataClear();
    }
    onWorkSheetNameChange(value) {
        this.clearMessages();
        this.execute(() => {
            if (!value) {
                this.onWorkSheetDataClear();
                return; // no entry selected
            }
            // check if the value is multi-sheet format 'Sheet1|Sheet2'
            if (value.indexOf('|') > 0) {
                // support multiple sheet upload in a single upload slot
                const configuredSheets = value.split('|');
                // assuming that the documentSource input binding would follow a similar 1-1 mapping between sheet and documentSource
                const documentSources = this.documentSource.split('|');
                this.useSpinnerForSyncAction(() => this.excelService.getWorkSheetContents(this.fileAsBinaryString, configuredSheets), (result) => {
                    const doWork = (val, indexOfSheet) => {
                        // start to show the progress indicator
                        this.showSpinner();
                        return this.uploadWorkSheet({
                            initialiseDocumentUploadEndpoint: this.initialiseDocumentUploadEndpoint,
                            uploadDocumentChunkEndpoint: this.uploadDocumentChunkEndpoint,
                            finaliseDocumentUploadEndpoint: this.finaliseDocumentUploadEndpoint,
                            documentSource: documentSources[indexOfSheet],
                            workSheetName: val.workSheetName,
                            workSheetData: val.workSheetData
                        });
                    };
                    const process = [];
                    result.forEach((sheetContent, indexOfSheet) => {
                        process.push(doWork(sheetContent, indexOfSheet));
                    });
                    forkJoin(process)
                        .subscribe((details) => {
                        this.uploadMultipleWorkSheets(details);
                        this.changeDetector.markForCheck();
                    }, error => {
                        this.handleError(error, null, { workSheetName: this.workSheetName });
                        this.hideSpinner();
                    }, () => {
                        this.hideSpinner();
                    });
                }, error => {
                    this.handleError(error, this.getErrorSummary('failedToReadWorkSheetContent', { workSheetName: this.workSheetName }));
                });
            }
            else {
                this.workSheetName = value;
                this.useSpinnerForSyncAction(() => this.excelService.getWorkSheetContents(this.fileAsBinaryString, [this.workSheetName]), result => {
                    const [{ workSheetData, workSheetIndexedColumns, workSheetIndexedRows }] = result;
                    this.workSheetData = workSheetData;
                    this.workSheetIndexedColumns = workSheetIndexedColumns;
                    this.workSheetIndexedRows = workSheetIndexedRows;
                    if (!this.previewEnabled && this.expectedWorkSheetName && this.expectedWorkSheetName === this.workSheetName) {
                        this.onWorkSheetUpload();
                    }
                }, error => {
                    this.handleError(error, this.getErrorSummary('failedToReadWorkSheetContent', { workSheetName: this.workSheetName }));
                });
            }
        });
    }
    onWorkSheetUpload() {
        this.clearMessages();
        this.useSpinner(() => this.uploadWorkSheet({
            initialiseDocumentUploadEndpoint: this.initialiseDocumentUploadEndpoint,
            uploadDocumentChunkEndpoint: this.uploadDocumentChunkEndpoint,
            finaliseDocumentUploadEndpoint: this.finaliseDocumentUploadEndpoint,
            documentSource: this.documentSource,
            workSheetName: this.workSheetName,
            workSheetData: this.workSheetData
        }), result => {
            this.filesOnFileUploadControl = []; // This has the effect of removing the file from the list in the p-file-upload control
            this.onFileUploadClear();
            this.model = `${result.workSheetName}${this.fileInfoSeparator2}${result.workSheetId}`;
            this.changeDetector.markForCheck();
        }, error => {
            this.handleError(error, null, { workSheetName: this.workSheetName });
        });
    }
    onWorkSheetDownload() {
        this.clearMessages();
        this.useSpinner(() => this.downloadWorkSheet({
            downloadDocumentEndpoint: this.downloadDocumentEndpoint,
            documentSource: this.documentSource,
            workSheetId: this.selectedWorkSheetId
        }), result => {
            this.execute(() => {
                const { workSheetId, workSheetName, workSheetData } = result;
                this.excelService.writeWorkBookToFile(`${workSheetId}.xlsx`, [{ workSheetName, workSheetData }]);
            });
        }, error => {
            this.handleError(error, this.getErrorSummary('failedToDownloadWorkSheet', { workSheetName: this.selectedWorkSheetName }));
        });
    }
    onWorkSheetRemove() {
        this.clearMessages();
        this.onFileUploadClear();
    }
    onWorkSheetDataClear() {
        this.workSheetName = null;
        this.workSheetData = null;
        this.workSheetIndexedColumns = null;
        this.workSheetIndexedRows = null;
    }
    getErrorSummaryStringTemplate(errorType = null) {
        if (!errorType) {
            return null;
        }
        const customErrorSummaryMap = this.stringService.tryParseJsonObject(this.customErrorSummaries);
        const errorSummaryStringTemplate = customErrorSummaryMap[errorType] ?? DefaultErrorSummaryMap[errorType];
        if (!errorSummaryStringTemplate) {
            return null;
        }
        return errorSummaryStringTemplate;
    }
    getErrorSummary(errorType = null, data = {}) {
        if (!errorType) {
            return null;
        }
        const errorSummaryStringTemplate = this.getErrorSummaryStringTemplate(errorType);
        if (!errorSummaryStringTemplate) {
            return null;
        }
        const errorSummary = this.stringService.interpolate(errorSummaryStringTemplate, data);
        if (!errorSummary) {
            return null;
        }
        return errorSummary;
    }
    parseError(error = '') {
        if (error instanceof HttpErrorResponse) {
            const errorAsString = error?.error?.message;
            const errorAsJson = this.stringService.tryParseJsonObject(errorAsString);
            return (errorAsJson && errorAsJson.errorType && errorAsJson.message)
                ? { errorType: errorAsJson.errorType, detail: errorAsJson.message }
                : { errorType: null, detail: errorAsString ?? error?.message ?? error.toString() };
        }
        else {
            return { errorType: null, detail: error?.toString() };
        }
    }
    handleError(error = null, errorSummary = null, errorSummaryData = {}) {
        const { errorType, detail } = this.parseError(error);
        const summary = this.getErrorSummary(errorType, errorSummaryData) ?? errorSummary ?? 'An unexpected error occurred';
        this.setMessages([{ severity: 'error', summary, detail }]);
        console.error(error);
        this.changeDetector.detectChanges();
    }
    setMessages(messages) {
        this.messages = messages;
    }
    clearMessages() {
        this.setMessages([]);
    }
    execute(action) {
        try {
            return action();
        }
        catch (error) {
            this.handleError(error);
        }
    }
    getFileExtension(fileName) {
        const lastDotIndex = fileName?.lastIndexOf('.');
        return typeof lastDotIndex === 'undefined'
            ? null
            : lastDotIndex < 0
                ? ''
                : fileName.substring(lastDotIndex + 1);
    }
    // TODO: think about moving these methods to the SpinnerService or at least a separate service
    showSpinner() {
        if (this.spinnerStackLevel++ === 0) {
            this.spinnerService.showSpinner();
        }
    }
    // TODO: think about moving these methods to the SpinnerService or at least a separate service
    hideSpinner() {
        if (--this.spinnerStackLevel === 0) {
            this.spinnerService.hideSpinner();
        }
    }
    // TODO: think about moving these methods to the SpinnerService or at least a separate service
    useSpinner(action, onNext, onError) {
        this.showSpinner();
        action()
            .subscribe({
            next: onNext,
            error: error => {
                onError(error);
                this.hideSpinner();
            },
            complete: () => {
                this.hideSpinner();
            }
        });
    }
    // TODO: think about moving these methods to the SpinnerService or at least a separate service
    useSpinnerForSyncAction(action, onNext, onError) {
        const spinnerDelayMs = 150; // This is to ensure the spinner does appear (it needs to exceed the 100ms of delay implemented by the spinner service)
        this.useSpinner(() => timer(spinnerDelayMs).pipe(map(action)), onNext, onError);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxExcelFileUploadComponent, deps: [{ token: SpinnerService }, { token: ExcelService }, { token: StringService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxExcelFileUploadComponent, selector: "dspx-excel-file-upload-component", inputs: { id: "id", modelContainer: "modelContainer", uploadWorkSheet: "uploadWorkSheet", downloadWorkSheet: "downloadWorkSheet", uploadMultipleWorkSheets: "uploadMultipleWorkSheets", previewEnabled: "previewEnabled", expectedWorkSheetName: "expectedWorkSheetName", documentSource: "documentSource", initialiseDocumentUploadEndpoint: "initialiseDocumentUploadEndpoint", uploadDocumentChunkEndpoint: "uploadDocumentChunkEndpoint", finaliseDocumentUploadEndpoint: "finaliseDocumentUploadEndpoint", downloadDocumentEndpoint: "downloadDocumentEndpoint", customErrorSummaries: "customErrorSummaries", disabled: "disabled" }, ngImport: i0, template: "<div class=\"field\" *ngIf=\"!model\">\r\n  <p-fileUpload id=\"excelFileUpload\"\r\n                [accept]=\"fileAcceptCommaSeparatedList\"\r\n                invalidFileTypeMessageDetail=\"Supported file types are MS Excel Workbooks.\"\r\n                maxFileSize=\"104857600\"\r\n                invalidFileLimitMessageDetail=\"1\"\r\n                customUpload=\"true\"\r\n                auto=\"true\"\r\n                [disabled]=\"disabled\"\r\n                chooseLabel=\"Choose an Excel file\"\r\n                [files]=\"filesOnFileUploadControl\"\r\n                (onSelect)=\"onFileUploadChange($event.files)\"\r\n                (onRemove)=\"onFileUploadClear()\">\r\n  </p-fileUpload>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"workSheetNames && !expectedWorkSheetName\">\r\n  <p-dropdown id=\"workSheetNameDropdown\"\r\n              placeholder=\"Select a worksheet\"\r\n              [options]=\"workSheetNames\"\r\n              [showClear]=\"true\"\r\n              (onChange)=\"onWorkSheetNameChange($event.value)\">\r\n  </p-dropdown>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"workSheetName && previewEnabled\">\r\n  <p-table id=\"workSheetDataTable\"\r\n           [columns]=\"workSheetIndexedColumns\"\r\n           [value]=\"workSheetIndexedRows\"\r\n           paginator=\"true\"\r\n           rows=\"5\"\r\n           [rowsPerPageOptions]=\"[5, 10, 25, 50, 100, 200]\">\r\n    <ng-template pTemplate=\"header\" let-columns>\r\n      <tr>\r\n        <th></th>\r\n        <th *ngFor=\"let column of columns\">{{column.value}}</th>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-row let-columns=\"columns\">\r\n      <tr>\r\n        <td>{{row.index + 1}}</td>\r\n        <td *ngFor=\"let column of columns\">{{row.value[column.index]}}</td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"emptymessage\">\r\n      <tr>\r\n        <td>No data found</td>\r\n      </tr>\r\n    </ng-template>\r\n  </p-table>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"workSheetName && !isAutomaticUpload()\">\r\n  <p-button id=\"workSheetUploadButton\"\r\n            type=\"button\"\r\n            label=\"Upload\"\r\n            icon=\"pi pi-upload\"\r\n            [disabled]=\"disabled\"\r\n            (click)=\"onWorkSheetUpload()\">\r\n  </p-button>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"model\">\r\n  <div class=\"grid\">\r\n    <div class=\"col-12 lg:col-8\">\r\n      <input id=\"uploadedWorkSheetName\" type=\"text\" pInputText readonly disabled value=\"{{selectedWorkSheetName}}\" />\r\n    </div>\r\n    <div class=\"col-12 lg:col-4\">\r\n      <div class=\"grid\">\r\n        <div class=\"col-fixed\">\r\n          <p-button id=\"workSheetDownloadButton\"\r\n                    type=\"button\"\r\n                    label=\"Download\"\r\n                    icon=\"pi pi-download\"\r\n                    (click)=\"onWorkSheetDownload()\">\r\n          </p-button>\r\n        </div>\r\n        <div class=\"col-fixed\">\r\n          <p-button id=\"workSheetRemoveButton\"\r\n                    type=\"button\"\r\n                    label=\"Remove\"\r\n                    icon=\"pi pi-times\"\r\n                    [disabled]=\"disabled\"\r\n                    (click)=\"onWorkSheetRemove()\">\r\n          </p-button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<p-messages [value]=\"messages\" [enableService]=\"false\"></p-messages>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.InputText, selector: "[pInputText]", inputs: ["variant"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i3$1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "component", type: i3.Dropdown, selector: "p-dropdown", inputs: ["id", "scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "loadingIcon", "filterPlaceholder", "filterLocale", "variant", "inputId", "dataKey", "filterBy", "filterFields", "autofocus", "resetFilterOnHide", "checkmark", "dropdownIcon", "loading", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "ariaLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "focusOnHover", "selectOnFocus", "autoOptionFocus", "autofocusFilter", "autoShowPanelOnPrintableCharacterKeyDown", "disabled", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "filterValue", "options"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear", "onLazyLoad"] }, { kind: "component", type: FileUpload, selector: "p-fileUpload", inputs: ["name", "url", "method", "multiple", "accept", "disabled", "auto", "withCredentials", "maxFileSize", "invalidFileSizeMessageSummary", "invalidFileSizeMessageDetail", "invalidFileTypeMessageSummary", "invalidFileTypeMessageDetail", "invalidFileLimitMessageDetail", "invalidFileLimitMessageSummary", "style", "styleClass", "previewWidth", "chooseLabel", "uploadLabel", "cancelLabel", "chooseIcon", "uploadIcon", "cancelIcon", "showUploadButton", "showCancelButton", "mode", "headers", "customUpload", "fileLimit", "uploadStyleClass", "cancelStyleClass", "removeStyleClass", "chooseStyleClass", "uploadedFiles", "files"], outputs: ["onBeforeUpload", "onSend", "onUpload", "onError", "onClear", "onRemove", "onSelect", "onProgress", "uploadHandler", "onImageError"] }, { kind: "component", type: Messages, selector: "p-messages", inputs: ["value", "closable", "style", "styleClass", "enableService", "key", "escape", "severity", "showTransitionOptions", "hideTransitionOptions"], outputs: ["valueChange"] }, { kind: "component", type: Table, selector: "p-table", inputs: ["frozenColumns", "frozenValue", "style", "styleClass", "tableStyle", "tableStyleClass", "paginator", "pageLinks", "rowsPerPageOptions", "alwaysShowPaginator", "paginatorPosition", "paginatorStyleClass", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showFirstLastIcon", "showPageLinks", "defaultSortOrder", "sortMode", "resetPageOnSort", "selectionMode", "selectionPageOnly", "contextMenuSelection", "contextMenuSelectionMode", "dataKey", "metaKeySelection", "rowSelectable", "rowTrackBy", "lazy", "lazyLoadOnInit", "compareSelectionBy", "csvSeparator", "exportFilename", "filters", "globalFilterFields", "filterDelay", "filterLocale", "expandedRowKeys", "editingRowKeys", "rowExpandMode", "scrollable", "scrollDirection", "rowGroupMode", "scrollHeight", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "frozenWidth", "responsive", "contextMenu", "resizableColumns", "columnResizeMode", "reorderableColumns", "loading", "loadingIcon", "showLoader", "rowHover", "customSort", "showInitialSortBadge", "autoLayout", "exportFunction", "exportHeader", "stateKey", "stateStorage", "editMode", "groupRowsBy", "groupRowsByOrder", "responsiveLayout", "breakpoint", "paginatorLocale", "value", "columns", "first", "rows", "totalRecords", "sortField", "sortOrder", "multiSortMeta", "selection", "selectAll", "virtualRowHeight"], outputs: ["contextMenuSelectionChange", "selectAllChange", "selectionChange", "onRowSelect", "onRowUnselect", "onPage", "onSort", "onFilter", "onLazyLoad", "onRowExpand", "onRowCollapse", "onContextMenuSelect", "onColResize", "onColReorder", "onRowReorder", "onEditInit", "onEditComplete", "onEditCancel", "onHeaderCheckboxToggle", "sortFunction", "firstChange", "rowsChange", "onStateSave", "onStateRestore"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxExcelFileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-excel-file-upload-component', encapsulation: ViewEncapsulation.None, template: "<div class=\"field\" *ngIf=\"!model\">\r\n  <p-fileUpload id=\"excelFileUpload\"\r\n                [accept]=\"fileAcceptCommaSeparatedList\"\r\n                invalidFileTypeMessageDetail=\"Supported file types are MS Excel Workbooks.\"\r\n                maxFileSize=\"104857600\"\r\n                invalidFileLimitMessageDetail=\"1\"\r\n                customUpload=\"true\"\r\n                auto=\"true\"\r\n                [disabled]=\"disabled\"\r\n                chooseLabel=\"Choose an Excel file\"\r\n                [files]=\"filesOnFileUploadControl\"\r\n                (onSelect)=\"onFileUploadChange($event.files)\"\r\n                (onRemove)=\"onFileUploadClear()\">\r\n  </p-fileUpload>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"workSheetNames && !expectedWorkSheetName\">\r\n  <p-dropdown id=\"workSheetNameDropdown\"\r\n              placeholder=\"Select a worksheet\"\r\n              [options]=\"workSheetNames\"\r\n              [showClear]=\"true\"\r\n              (onChange)=\"onWorkSheetNameChange($event.value)\">\r\n  </p-dropdown>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"workSheetName && previewEnabled\">\r\n  <p-table id=\"workSheetDataTable\"\r\n           [columns]=\"workSheetIndexedColumns\"\r\n           [value]=\"workSheetIndexedRows\"\r\n           paginator=\"true\"\r\n           rows=\"5\"\r\n           [rowsPerPageOptions]=\"[5, 10, 25, 50, 100, 200]\">\r\n    <ng-template pTemplate=\"header\" let-columns>\r\n      <tr>\r\n        <th></th>\r\n        <th *ngFor=\"let column of columns\">{{column.value}}</th>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-row let-columns=\"columns\">\r\n      <tr>\r\n        <td>{{row.index + 1}}</td>\r\n        <td *ngFor=\"let column of columns\">{{row.value[column.index]}}</td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"emptymessage\">\r\n      <tr>\r\n        <td>No data found</td>\r\n      </tr>\r\n    </ng-template>\r\n  </p-table>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"workSheetName && !isAutomaticUpload()\">\r\n  <p-button id=\"workSheetUploadButton\"\r\n            type=\"button\"\r\n            label=\"Upload\"\r\n            icon=\"pi pi-upload\"\r\n            [disabled]=\"disabled\"\r\n            (click)=\"onWorkSheetUpload()\">\r\n  </p-button>\r\n</div>\r\n\r\n<div class=\"field\" *ngIf=\"model\">\r\n  <div class=\"grid\">\r\n    <div class=\"col-12 lg:col-8\">\r\n      <input id=\"uploadedWorkSheetName\" type=\"text\" pInputText readonly disabled value=\"{{selectedWorkSheetName}}\" />\r\n    </div>\r\n    <div class=\"col-12 lg:col-4\">\r\n      <div class=\"grid\">\r\n        <div class=\"col-fixed\">\r\n          <p-button id=\"workSheetDownloadButton\"\r\n                    type=\"button\"\r\n                    label=\"Download\"\r\n                    icon=\"pi pi-download\"\r\n                    (click)=\"onWorkSheetDownload()\">\r\n          </p-button>\r\n        </div>\r\n        <div class=\"col-fixed\">\r\n          <p-button id=\"workSheetRemoveButton\"\r\n                    type=\"button\"\r\n                    label=\"Remove\"\r\n                    icon=\"pi pi-times\"\r\n                    [disabled]=\"disabled\"\r\n                    (click)=\"onWorkSheetRemove()\">\r\n          </p-button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<p-messages [value]=\"messages\" [enableService]=\"false\"></p-messages>\r\n" }]
        }], ctorParameters: () => [{ type: SpinnerService }, { type: ExcelService }, { type: StringService }, { type: i0.ChangeDetectorRef }], propDecorators: { id: [{
                type: Input
            }], modelContainer: [{
                type: Input
            }], uploadWorkSheet: [{
                type: Input
            }], downloadWorkSheet: [{
                type: Input
            }], uploadMultipleWorkSheets: [{
                type: Input
            }], previewEnabled: [{
                type: Input
            }], expectedWorkSheetName: [{
                type: Input
            }], documentSource: [{
                type: Input
            }], initialiseDocumentUploadEndpoint: [{
                type: Input
            }], uploadDocumentChunkEndpoint: [{
                type: Input
            }], finaliseDocumentUploadEndpoint: [{
                type: Input
            }], downloadDocumentEndpoint: [{
                type: Input
            }], customErrorSummaries: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });

class DspxBaseRepeaterComponent extends FieldArrayType {
    static { this.focusTimeoutMs = 200; }
    get repeaterProperties() { return this.field?.props; }
    get buttonSettings() { return this._buttonSettings ??= this.getButtonSettings(); }
    ;
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, extraSettings, changeDetector) {
        super();
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.extraSettings = extraSettings;
        this.changeDetector = changeDetector;
        this.oldValue = {};
        this.isItemHeaderExpanded = (itemIndex) => {
            const isItemHeaderExpanded = this.getItemModel(itemIndex).isItemHeaderExpanded;
            if (isItemHeaderExpanded === undefined || isItemHeaderExpanded === null) {
                this.getItemModel(itemIndex).isItemHeaderExpanded = true;
            }
            return !!this.getItemModel(itemIndex).isItemHeaderExpanded;
        };
        this.toggleItemHeaderExpansion = (itemIndex) => { this.getItemModel(itemIndex).isItemHeaderExpanded = !this.getItemModel(itemIndex).isItemHeaderExpanded; };
        this.isEditingItem = (itemIndex) => !!this.getItemModel(itemIndex).isEditing;
        this.canAddItem = () => this.repeaterProperties.isEditable &&
            (this.getModel()?.length ?? 0) < this.repeaterProperties.repeatingLimit &&
            (!this.getModel()?.some((item, i) => item.isEditing && this.isNewItem(i)) ?? false); // only allow one new item being added at any given time
        this.canEditItem = (itemIndex) => this.coreService.isFormEditable && !this.isEditingItem(itemIndex);
        this.canViewItem = (itemIndex) => !this.repeaterProperties.isEditable && !this.isEditingItem(itemIndex);
        this.canRemoveItem = (itemIndex) => this.repeaterProperties.isEditable &&
            (this.repeaterProperties.canRemoveItemInEditMode || !this.isEditingItem(itemIndex)) &&
            !(this.repeaterProperties.repeatingItemRequired && (this.getModel()?.length ?? 0) === 1); // prevent removal of the only mandatory item
        this.canCloseItem = () => !(this.repeaterProperties.repeatingItemRequired && (this.getModel()?.length ?? 0) === 1 && this.isNewItem(0)); // prevent closing of the only mandatory item
        this.canSaveItem = () => this.repeaterProperties.isEditable;
        this.RepeaterElementType = RepeaterElementType; // workaround to make the enum accessible from the Angular HTML template
        this.getElementId = (elementType, itemIndex) => (itemIndex !== null && itemIndex !== undefined)
            ? `${this.field.id}_${elementType}_${itemIndex}`
            : `${this.field.id}_${elementType}`;
        this.getButtonTitle = (label, itemIndex) => `${label} ${this.getHeaderTextOrDefault(itemIndex)}`;
        this.getHeaderText = (itemIndex) => this.getHeaderQuestionWithValues(itemIndex)
            .map(questionWithValue => questionWithValue.value)
            .filter(value => value !== '--')
            .join(' ');
        this.getHeaderTextOrDefault = (itemIndex) => this.getHeaderText(itemIndex) || "New";
        this.getHeaderQuestionWithValues = (itemIndex) => this.getViewModelQuestionWithValues(this.viewModels.header, itemIndex);
        this.getSubHeaderQuestionWithValues = (itemIndex) => this.getViewModelQuestionWithValues(this.viewModels.subHeader, itemIndex);
        this.getAllQuestionConfigsInHeader = (itemConfig) => this.getQuestionConfigs(itemConfig, props => this.extraSettings.getIncludeInRepeatingItemHeader(props), props => this.extraSettings.getRepeatingItemHeaderOrder(props));
        this.getAllQuestionConfigsInSubHeader = (itemConfig) => this.getQuestionConfigs(itemConfig, props => this.extraSettings.getIncludeInRepeatingItemSubHeader(props), props => this.extraSettings.getRepeatingItemSubHeaderOrder(props));
        this.getAllFieldArrayQuestionConfigsInHeader = () => this.getFieldArrayQuestionConfigs(this.field, props => this.extraSettings.getIncludeInRepeatingItemHeader(props), props => this.extraSettings.getRepeatingItemHeaderOrder(props));
        this.getAllFieldArrayQuestionConfigsInSubHeader = () => this.getFieldArrayQuestionConfigs(this.field, props => this.extraSettings.getIncludeInRepeatingItemSubHeader(props), props => this.extraSettings.getRepeatingItemSubHeaderOrder(props));
        this.isNewItem = (itemIndex) => !this.oldValue[itemIndex];
        this.getButtonSettings = () => {
            if (!this.repeaterProperties) {
                return null; // for example, if this method gets called by mistake before OnInit, the lazy evaluation will not happen
            }
            const repeatingItemButtons = this.repeaterProperties?.repeatingItemButtons;
            const defaultOnBeforeActionCallback = (itemIndex, onComplete) => onComplete(false);
            const defaultActionCallback = itemIndex => { };
            const defaultIsVisibleCallback = itemIndex => true;
            const optionalBtnDefaultIsVisibleCallback = itemIndex => false;
            const isVisibleCallbackForView = itemIndex => !this.repeaterProperties.isEditable;
            // these buttons only show up if they are added in button config otherwise hide
            const getDefaultOptionalStandardButton = (config, defaultLabel, defaultIcon) => ({
                onBeforeAction: config?.onBeforeAction ?? defaultOnBeforeActionCallback,
                isVisible: (!config) ? optionalBtnDefaultIsVisibleCallback : (config?.isVisible ?? defaultIsVisibleCallback),
                label: config?.label ?? defaultLabel,
                icon: config?.icon ?? defaultIcon,
                title: (config?.label === undefined || config?.label === '') ? defaultLabel : config?.label
            });
            const getDefaultStandardButton = (config, defaultLabel, defaultIcon, isVisibleCallback = null) => ({
                onBeforeAction: config?.onBeforeAction ?? defaultOnBeforeActionCallback,
                isVisible: config?.isVisible ?? isVisibleCallback ?? defaultIsVisibleCallback,
                label: config?.label ?? defaultLabel,
                icon: config?.icon ?? defaultIcon,
                title: (config?.label === undefined || config?.label === '') ? defaultLabel : config?.label
            });
            const getDefaultCustomButtons = (configs) => configs
                ?.filter(config => config)
                ?.map(config => ({
                action: config?.action ?? defaultActionCallback,
                isVisible: config?.isVisible ?? defaultIsVisibleCallback,
                label: config?.label ?? '',
                icon: config?.icon ?? '',
                title: config?.icon ?? ''
            }))
                ?? [];
            const buttonSettings = {
                standard: {
                    add: getDefaultStandardButton(repeatingItemButtons?.standard?.add, this.repeaterProperties.addButtonText ?? 'Add', 'fas fa-plus'),
                    edit: getDefaultStandardButton(repeatingItemButtons?.standard?.edit, 'Edit', 'fas fa-pen'),
                    view: getDefaultStandardButton(repeatingItemButtons?.standard?.view, 'View', 'fas fa-eye', isVisibleCallbackForView),
                    remove: getDefaultStandardButton(repeatingItemButtons?.standard?.remove, 'Delete', 'fas fa-trash-alt'),
                    save: getDefaultStandardButton(repeatingItemButtons?.standard?.save, 'Save', 'fas fa-check'),
                    close: getDefaultStandardButton(repeatingItemButtons?.standard?.close, 'Close', 'fas fa-times'),
                    itemHeaderSave: getDefaultOptionalStandardButton(repeatingItemButtons?.standard?.itemHeaderSave, 'Save', 'fas fa-check'),
                    itemHeaderCollapse: getDefaultOptionalStandardButton(repeatingItemButtons?.standard?.itemHeaderCollapse, 'Collapse Expand', ''),
                },
                custom: {
                    repeater: getDefaultCustomButtons(repeatingItemButtons?.custom?.repeater),
                    itemHeader: getDefaultCustomButtons(repeatingItemButtons?.custom?.itemHeader),
                    itemContent: getDefaultCustomButtons(repeatingItemButtons?.custom?.itemContent)
                }
            };
            return buttonSettings;
        };
        this.getHeaderViewModelOrderedQuestions = () => this.getViewModelOrderedQuestions(this.getAllFieldArrayQuestionConfigsInHeader());
        this.getSubHeaderViewModelOrderedQuestions = () => this.getViewModelOrderedQuestions(this.getAllFieldArrayQuestionConfigsInSubHeader());
        this.getViewModelOrderedQuestions = (orderedFieldArrayQuestionConfigs) => orderedFieldArrayQuestionConfigs
            .map(fieldArrayQuestionConfig => ({ key: this.getKey(fieldArrayQuestionConfig), label: fieldArrayQuestionConfig.props.label }));
        this.updateHeaderViewModel = (itemIndex, changeType) => this.updateViewModel(this.viewModels.header.model, (itemConfig) => this.getAllQuestionConfigsInHeader(itemConfig), itemIndex, changeType);
        this.updateSubHeaderViewModel = (itemIndex, changeType) => this.updateViewModel(this.viewModels.subHeader.model, (itemConfig) => this.getAllQuestionConfigsInSubHeader(itemConfig), itemIndex, changeType);
        this.getKey = (config) => config?.key;
        this.getControl = () => this.field?.formControl;
        this.getItemControl = (itemIndex) => this.getControl()?.controls?.[itemIndex];
        this.getModel = () => this.field?.model;
        this.getItemModel = (itemIndex) => this.getModel()?.[itemIndex];
        this.getItemConfigs = () => this.field?.fieldGroup;
        this.getItemConfig = (itemIndex) => this.getItemConfigs()?.[itemIndex];
        // NOTE: we are not inheriting from interface IRepeater because we want the interface members to be protected since they are only used by the repeater instances themselves
        this.asIRepeater = () => ({
            getKey: () => this.getKey(this.field),
            resetChildRepeaters: (itemIndex) => this.resetChildRepeaters(itemIndex),
            resetAllItemModels: (oldModel) => this.resetAllItemModels(oldModel)
        });
        this.getQuestionConfigs = (itemConfig, filter, order) => this.extraSettings.getAllQuestionConfigs(itemConfig)
            .filter(f => filter(f.props))
            .sort((f1, f2) => order(f1.props) - order(f2.props));
        this.getFieldArrayQuestionConfigs = (itemConfig, filter, order) => this.extraSettings.getAllFieldArrayQuestionConfigs(itemConfig)
            .filter(f => filter(f.props))
            .sort((f1, f2) => order(f1.props) - order(f2.props));
        this.getViewModelQuestionWithValues = (viewModel, itemIndex) => viewModel.orderedQuestions
            .map(question => ({ ...question, value: this.formatNullOrUndefined(viewModel.model[itemIndex][question.key]) }));
        this.formatNullOrUndefined = (value) => (!!value) ? value : '--';
    }
    executeCustomAction(buttonConfiguration, itemIndex) {
        buttonConfiguration?.action?.(itemIndex);
    }
    addItem() {
        const itemIndex = this.getModel()?.length ?? 0; // we are always inserting at the end because, with any other position, dependent dropdowns of subsequent items would break
        this.buttonSettings.standard.add.onBeforeAction(itemIndex, cancel => {
            if (!cancel) {
                this.addItemWithoutValidations(itemIndex);
                this.setFocusToTopOfItemContent(itemIndex);
            }
        });
    }
    removeItem(itemIndex) {
        this.buttonSettings.standard.remove.onBeforeAction(itemIndex, cancel => {
            if (!cancel) {
                this.removeItemWithoutValidations(itemIndex);
            }
        });
    }
    closeItem(itemIndex) {
        if (this.isNewItem(itemIndex)) {
            this.removeItemWithoutValidations(itemIndex);
        }
        else {
            this.buttonSettings.standard.close.onBeforeAction(itemIndex, cancel => {
                if (!cancel) {
                    this.closeItemWithoutValidations(itemIndex);
                }
            });
        }
    }
    saveItem(itemIndex) {
        const itemControl = this.getItemControl(itemIndex);
        markChildControlsAsTouched(itemControl);
        if (itemControl.valid) {
            this.buttonSettings.standard.save.onBeforeAction(itemIndex, cancel => {
                if (!cancel) {
                    this.saveItemWithoutValidations(itemIndex);
                }
            });
        }
        else {
            this.setFocusToTopOfItemContent(itemIndex);
        }
    }
    editItem(itemIndex) {
        this.buttonSettings.standard.edit.onBeforeAction(itemIndex, cancel => {
            if (!cancel) {
                this.editItemWithoutValidations(itemIndex);
            }
        });
    }
    initialise() {
        if (!this.viewModels) {
            this.initialiseViewModels();
        }
        if (this.repeaterProperties.repeatingItemRequired && (this.getModel()?.length ?? 0) === 0) {
            this.addItemWithoutValidations(0);
        }
        this.repeaterRegistryService.register(this.getControl(), this.asIRepeater());
    }
    destroy() {
        this.repeaterRegistryService.unregister(this.getControl());
    }
    setFocusToTopOfAddButton() {
        this.setFocusToHtmlElement(() => this.getElementId(RepeaterElementType.TopOfAddButton));
    }
    setFocusToTopOfItemHeader(itemIndex) {
        this.setFocusToHtmlElement(() => this.getElementId(RepeaterElementType.TopOfItemHeader, itemIndex));
    }
    setFocusToTopOfItemContent(itemIndex) {
        this.setFocusToHtmlElement(() => this.getElementId(RepeaterElementType.TopOfItemContent, itemIndex));
    }
    setFocusToHtmlElement(getElementId) {
        setTimeout(() => {
            const elementId = getElementId();
            if (elementId) {
                const element = document.getElementById(elementId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    element.focus({ preventScroll: true });
                }
            }
        }, DspxBaseRepeaterComponent.focusTimeoutMs);
    }
    shiftOldValues(itemIndex) {
        for (let i = (this.getModel()?.length ?? 0) - 1; i >= itemIndex; i--) {
            this.oldValue[i + 1] = this.oldValue[i];
            delete this.oldValue[i];
        }
    }
    unshiftOldValues(itemIndex) {
        for (let i = itemIndex; i < (this.getModel()?.length ?? 0) - 1; i++) {
            this.oldValue[i] = this.oldValue[i + 1];
            delete this.oldValue[i + 1];
        }
    }
    itemModelChanged(itemIndex, changeType) {
        this.updateHeaderViewModel(itemIndex, changeType);
        this.updateSubHeaderViewModel(itemIndex, changeType);
        if (changeType === RepeaterItemChangeType.Add ||
            changeType === RepeaterItemChangeType.Edit ||
            changeType === RepeaterItemChangeType.Save ||
            changeType === RepeaterItemChangeType.Close) {
            this.onItemEditingStatusChanged?.(itemIndex);
        }
        if (changeType === RepeaterItemChangeType.Initialise && this.isEditingItem(itemIndex)) {
            this.oldValue[itemIndex] = cloneDeep(this.getItemModel(itemIndex));
            this.onItemEditingStatusChanged?.(itemIndex);
        }
        this.onItemModelChanged?.(itemIndex, changeType);
    }
    initialiseViewModels() {
        this.viewModels = {
            header: { model: [], orderedQuestions: this.getHeaderViewModelOrderedQuestions() },
            subHeader: { model: [], orderedQuestions: this.getSubHeaderViewModelOrderedQuestions() }
        };
        for (let itemIndex = 0; itemIndex < this.getModel()?.length ?? 0; itemIndex++) {
            this.itemModelChanged(itemIndex, RepeaterItemChangeType.Initialise);
        }
        this.onViewModelsInitialised?.();
    }
    updateViewModel(viewModel, getQuestionConfigs, itemIndex, changeType) {
        const getItemViewModel = () => {
            const itemConfig = this.getItemConfig(itemIndex);
            const questionConfigs = getQuestionConfigs(itemConfig);
            const itemViewModel = viewModel[itemIndex] ?? {
                $repeaterItemViewModelId: Guid.create().toString(),
                $repeaterItemViewModelIndex: itemIndex
            };
            for (const questionConfig of questionConfigs) {
                itemViewModel[this.getKey(questionConfig)] = this.coreService.getFieldValue(questionConfig);
            }
            return itemViewModel;
        };
        switch (changeType) {
            case RepeaterItemChangeType.Initialise: {
                const itemViewModel = getItemViewModel();
                viewModel.push(itemViewModel);
                break;
            }
            case RepeaterItemChangeType.Add: {
                const itemViewModel = getItemViewModel();
                viewModel.splice(itemIndex, 0, itemViewModel);
                for (let i = itemIndex + 1; i < viewModel.length; i++) {
                    viewModel[i].$repeaterItemViewModelIndex++;
                }
                break;
            }
            case RepeaterItemChangeType.Edit: {
                // Nothing to do here (this change type does not affect the item view model)
                break;
            }
            case RepeaterItemChangeType.Remove: {
                for (let i = itemIndex + 1; i < viewModel.length; i++) {
                    viewModel[i].$repeaterItemViewModelIndex--;
                }
                viewModel.splice(itemIndex, 1);
                break;
            }
            case RepeaterItemChangeType.Save: {
                const itemViewModel = getItemViewModel();
                viewModel[itemIndex] = itemViewModel;
                break;
            }
            case RepeaterItemChangeType.Close: {
                // Nothing to do here (this change type does not affect the item view model)
                break;
            }
        }
    }
    addItemWithoutValidations(itemIndex) {
        this.shiftOldValues(itemIndex);
        this.add(itemIndex, { isEditing: true }, { markAsDirty: true });
        this.itemModelChanged(itemIndex, RepeaterItemChangeType.Add);
    }
    editItemWithoutValidations(itemIndex) {
        const itemModel = this.getItemModel(itemIndex);
        itemModel.isEditing = true;
        this.oldValue[itemIndex] = cloneDeep(itemModel);
        this.itemModelChanged(itemIndex, RepeaterItemChangeType.Edit);
        this.setFocusToTopOfItemContent(itemIndex);
    }
    removeItemWithoutValidations(itemIndex) {
        this.unshiftOldValues(itemIndex);
        this.remove(itemIndex);
        this.itemModelChanged(itemIndex, RepeaterItemChangeType.Remove);
    }
    saveItemWithoutValidations(itemIndex) {
        const isNewItem = this.isNewItem(itemIndex); // must be called *before* updating this.oldValue[itemIndex]
        this.getItemModel(itemIndex).isEditing = false;
        delete this.oldValue[itemIndex];
        this.itemModelChanged(itemIndex, RepeaterItemChangeType.Save);
        if (isNewItem) {
            this.setFocusToTopOfAddButton();
        }
        else {
            this.setFocusToTopOfItemHeader(itemIndex);
        }
    }
    closeItemWithoutValidations(itemIndex) {
        this.spinnerService.showSpinner();
        this.resetItemModel(itemIndex, () => {
            this.spinnerService.hideSpinner();
            this.getItemModel(itemIndex).isEditing = false;
            delete this.oldValue[itemIndex];
            this.itemModelChanged(itemIndex, RepeaterItemChangeType.Close);
            this.setFocusToTopOfItemHeader(itemIndex);
            this.changeDetector.detectChanges();
        });
    }
    // This method resets the repeating item control, including the recursive reset of any child repeater controls down the hierarchy of repeaters.
    // It works recursively, so that it supports an indefinite hiearachy of repeaters, even though we currently have only up to two levels (page => section).
    //
    // For example, you might have a repeating page which contains one or more repeating sections.
    // Resetting an item in the repeating page requires also the resetting of all items within the underlying repeating sections.
    //
    // How it works:
    //
    // - For the repeating item control (which is a FormGroup angular object, and is mapped to a FieldType formly object),
    //   the resetting is done by calling FormGroup.reset() repeatedly until all dependent questions are fully reset (see method CoreService.resetModel() for more details).
    //
    // - For any underlying child repeater control (which is a FormArray angular object, and is mapped to a FieldArrayType formly object),
    //   calling FormArray.reset() does not work, even if you repeat it: you end up instead with a different number of items with incorrect values.
    //   What I found that works is to simply call FieldArrayType.remove() for each existing item and then call FieldArrayType.add() for each item required to be reset.
    //   This trick, unlike using FormArray.remove() and FormArray.add(), also takes care of dependent questions and does not require any repetition because it uses the formly methods,
    //   and not the angular methods, so it is aware of any question dependency.
    //   The problem with this approach is that it requires getting the FieldArrayType instances of the underlying child repeater controls,
    //   and this is not possible by simply inspecting the parent FieldArrayType instance, because from there you can only traverse the hierarchy of FormGroup/FormArray angular objects,
    //   and not the mapped FieldType/FieldArrayType formly objects.
    //   To work around this problem, I have defined a registry of FieldArrayType instances in a separate service (RepeaterRegistryService), so that each repeater control
    //   registers itself on OnInit and unregisters itself on OnDestroy, making it possible to map a FormArray angular object to its corresponding FieldArrayType formly object.
    //
    resetItemModel(itemIndex, onComplete) {
        const itemControl = this.getItemControl(itemIndex);
        const oldItemModel = this.oldValue[itemIndex];
        const itemModel = this.getItemModel(itemIndex);
        const onAfterFirstReset = () => {
            // Step 2: full reset of any repeater control inside this repeater item (e.g. all the repeating sections under a repeating page);
            this.resetChildRepeaters(itemIndex);
            // Step 3: second reset of the repeating item control (to ensure any dependent questions within the item are correctly reset)
            this.coreService.resetModel(itemControl, oldItemModel, itemModel, () => onComplete());
        };
        // Step 1: first reset of the repeater item control (to ensure any child repeater control is at least partially reset, even though it may still have the wrong items)
        this.coreService.resetModel(itemControl, oldItemModel, itemModel, onAfterFirstReset, 0);
    }
    resetChildRepeaters(itemIndex) {
        for (const childRepeater of this.getChildRepeaters(itemIndex)) {
            const childRepeaterOldModel = this.getChildRepeaterOldModel(itemIndex, childRepeater);
            childRepeater.resetAllItemModels(childRepeaterOldModel);
            if (childRepeaterOldModel) {
                for (let childRepeaterItemIndex = 0; childRepeaterItemIndex < childRepeaterOldModel?.length; childRepeaterItemIndex++) {
                    childRepeater.resetChildRepeaters(childRepeaterItemIndex);
                }
            }
        }
    }
    resetAllItemModels(oldModel) {
        while ((this.getModel()?.length ?? 0) > 0) {
            this.remove(0);
        }
        if (oldModel) {
            for (let itemIndex = 0; itemIndex < oldModel.length; itemIndex++) {
                this.add(itemIndex, oldModel[itemIndex], { markAsDirty: true });
            }
        }
    }
    getChildRepeaters(itemIndex) {
        const childControlKeys = this.getItemConfig(itemIndex)?.fieldGroup // get the formly config of the child controls
            ?.map(childControlConfig => this.getKey(childControlConfig)) // get the formly key of the child control, like for example the section code (e.g. "clientDetails") under a repeating page
            ?? [];
        const childRepeaterControls = childControlKeys
            .map(childControlKey => this.getItemControl(itemIndex)?.controls?.[childControlKey]) // get the FormGroup or FormArray child control using the formly key
            .filter(childControl => childControl instanceof UntypedFormArray); // exclude any non-repeating child control (e.g. a non-repeating section under a repeating page)
        const childRepeaters = childRepeaterControls
            .map(childRepeaterControl => this.repeaterRegistryService.get(childRepeaterControl)) // get the registered IRepeater instance from the child control (if it exists)
            .filter(childRepeater => childRepeater); // exclude any FormArray child control that is not a registered IRepeater (e.g. a question control like data-grid, etc.)
        return childRepeaters;
    }
    getChildRepeaterOldModel(itemIndex, childRepeater) {
        const oldModel = this.oldValue[itemIndex];
        const childRepeaterKey = childRepeater.getKey();
        const childRepeaterOldModel = oldModel[childRepeaterKey];
        return childRepeaterOldModel;
    }
}

class DspxBasePanelRepeaterComponent extends DspxBaseRepeaterComponent {
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, extraSettings, changeDetector) {
        super(coreService, spinnerService, repeaterRegistryService, repeaterService, extraSettings, changeDetector);
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.extraSettings = extraSettings;
        this.changeDetector = changeDetector;
        // This is an override of the base class unimplemented method
        this.onViewModelsInitialised = () => {
            this.basePanelRepeater = {
                headerViewModel: this.viewModels.header,
                subHeaderViewModel: this.viewModels.subHeader,
                buttonSettings: this.buttonSettings,
                getElementId: (elementType, itemIndex) => this.getElementId(elementType, itemIndex),
                getButtonTitle: (label, itemIndex) => this.getButtonTitle(label, itemIndex),
                getItemConfigs: () => this.getItemConfigs(),
                getCustomItemHeaderHtml: this.repeaterProperties.getCustomItemHeaderHtml && ((itemConfig, itemIndex) => this.repeaterProperties.getCustomItemHeaderHtml(itemConfig, itemIndex)),
                getCustomItemSubHeaderHtml: this.repeaterProperties.getCustomItemSubHeaderHtml && ((itemConfig, itemIndex) => this.repeaterProperties.getCustomItemSubHeaderHtml(itemConfig, itemIndex)),
                getHeaderTextOrDefault: itemIndex => this.getHeaderTextOrDefault(itemIndex),
                getSubHeaderQuestionWithValues: itemIndex => this.getSubHeaderQuestionWithValues(itemIndex),
                isEditingItem: itemIndex => this.isEditingItem(itemIndex),
                isItemHeaderExpanded: itemIndex => this.isItemHeaderExpanded(itemIndex),
                canAddItem: () => this.canAddItem(),
                canViewItem: itemIndex => this.canViewItem(itemIndex),
                canEditItem: itemIndex => this.canEditItem(itemIndex),
                canRemoveItem: itemIndex => this.canRemoveItem(itemIndex),
                canSaveItem: () => this.canSaveItem(),
                canCloseItem: () => this.canCloseItem(),
                addItem: () => this.addItem(),
                editItem: itemIndex => this.editItem(itemIndex),
                removeItem: itemIndex => this.removeItem(itemIndex),
                saveItem: itemIndex => this.saveItem(itemIndex),
                closeItem: itemIndex => this.closeItem(itemIndex),
                toggleItemHeaderExpansion: itemIndex => this.toggleItemHeaderExpansion(itemIndex),
                executeCustomAction: (buttonConfiguration, itemIndex) => this.executeCustomAction(buttonConfiguration, itemIndex)
            };
        };
    }
    get repeaterHeadingLevelBase() {
        return this.props.useHeadingLevel ? this.props.headingLevel + 1 : this.htmlHeadingLevelBase;
    }
}

class DspxBaseTableRepeaterComponent extends DspxBaseRepeaterComponent {
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, extraSettings, changeDetector) {
        super(coreService, spinnerService, repeaterRegistryService, repeaterService, extraSettings, changeDetector);
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.extraSettings = extraSettings;
        this.changeDetector = changeDetector;
        // This is an override of the base class unimplemented method
        this.onViewModelsInitialised = () => {
            this.baseTableRepeater = {
                viewModel: this.viewModels.header,
                buttonSettings: this.buttonSettings,
                getCustomItemHeaderHtml: this.repeaterProperties.getCustomItemHeaderHtml && ((itemConfig, itemIndex) => this.repeaterProperties.getCustomItemHeaderHtml(itemConfig, itemIndex)),
                getCustomItemSubHeaderHtml: this.repeaterProperties.getCustomItemSubHeaderHtml && ((itemConfig, itemIndex) => this.repeaterProperties.getCustomItemSubHeaderHtml(itemConfig, itemIndex)),
                getHeaderTextOrDefault: itemIndex => this.getHeaderTextOrDefault(itemIndex),
                getSubHeaderQuestionWithValues: itemIndex => this.getSubHeaderQuestionWithValues(itemIndex),
                isEditingItem: itemIndex => this.isEditingItem(itemIndex),
                isItemHeaderExpanded: itemIndex => this.isItemHeaderExpanded(itemIndex),
                getElementId: (elementType, itemIndex) => this.getElementId(elementType, itemIndex),
                getButtonTitle: (label, itemIndex) => this.getButtonTitle(label, itemIndex),
                getItemConfig: itemIndex => this.getItemConfig(itemIndex),
                canAddItem: () => this.canAddItem(),
                canEditItem: itemIndex => this.canEditItem(itemIndex),
                canViewItem: itemIndex => this.canViewItem(itemIndex),
                canRemoveItem: itemIndex => this.canRemoveItem(itemIndex),
                canSaveItem: () => this.canSaveItem(),
                canCloseItem: () => this.canCloseItem(),
                addItem: () => this.addItem(),
                editItem: itemIndex => this.editItem(itemIndex),
                removeItem: itemIndex => this.removeItem(itemIndex),
                saveItem: itemIndex => this.saveItem(itemIndex),
                closeItem: itemIndex => this.closeItem(itemIndex),
                executeCustomAction: (buttonConfiguration, itemIndex) => this.executeCustomAction(buttonConfiguration, itemIndex)
            };
        };
        // This is an override of the base class unimplemented method
        this.onItemEditingStatusChanged = (itemIndex) => {
            this.toggleItemEditingStatus(itemIndex);
        };
        // This is an override of the base class unimplemented method
        this.onItemModelChanged = (itemIndex, changeType) => {
            if (changeType === RepeaterItemChangeType.Add) {
                this.clearSearch();
            }
            else if (changeType === RepeaterItemChangeType.Remove ||
                changeType === RepeaterItemChangeType.Save) {
                this.reapplySearch();
            }
        };
        this.toggleItemEditingStatus = (itemIndex) => {
            this.tableRepeater?.toggleItemEditingStatus(this.viewModels.header.model[itemIndex]);
        };
        this.reapplySearch = () => this.tableRepeater?.reapplySearch();
        this.clearSearch = () => this.tableRepeater?.clearSearch();
    }
    onTableRepeaterInitialised(tableRepeater) {
        this.tableRepeater = tableRepeater;
        setTimeout(() => this.ensureInitialisationOfItemEditingStatuses());
    }
    ensureInitialisationOfItemEditingStatuses() {
        for (let itemHeaderViewModel of this.viewModels.header.model) {
            if (this.tableRepeater.isEditingItem(itemHeaderViewModel) !== this.isEditingItem(itemHeaderViewModel.$repeaterItemViewModelIndex)) {
                this.toggleItemEditingStatus(itemHeaderViewModel.$repeaterItemViewModelIndex);
            }
        }
    }
}

class DspxPanelRepeaterComponent {
    constructor() {
        this.RepeaterElementType = RepeaterElementType; // workaround to make the enum accessible from the Angular HTML template
        this.getInnerHtmlWrappedByHeading = (htmlHeadingLevelOffset, innerHtml) => {
            const htmlHeadingLevel = this.htmlHeadingLevelBase + htmlHeadingLevelOffset;
            return `<h${htmlHeadingLevel}>${innerHtml}</h${htmlHeadingLevel}>`;
        };
        this.getQuestionLayoutStyleClass = (question) => {
            return (question.props.columnLayout && question.props.columnLayout == 'split') ? 'col-6 md:col-6' :
                (question.props.columnLayout != null ? question.props.columnLayout : 'col-12 md:col-12');
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxPanelRepeaterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxPanelRepeaterComponent, selector: "dspx-panel-repeater", inputs: { repeater: "repeater", cssClassName: "cssClassName", htmlHeadingLevelBase: "htmlHeadingLevelBase" }, ngImport: i0, template: "<div [id]=\"repeater.getElementId(RepeaterElementType.TopOfAddButton)\"></div>\r\n<button *ngIf=\"repeater.buttonSettings.standard.add.isVisible()\"\r\n        pButton\r\n        type=\"button\"\r\n        iconPos=\"left\"\r\n        [disabled]=\"!repeater.canAddItem()\"\r\n        [id]=\"repeater.getElementId(RepeaterElementType.AddButton)\"\r\n        [label]=\"repeater.buttonSettings.standard.add.label\"\r\n        [title]=\"repeater.buttonSettings.standard.add.label\"\r\n        [icon]=\"repeater.buttonSettings.standard.add.icon\"\r\n        (click)=\"repeater.addItem()\">\r\n</button>\r\n<ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.repeater\">\r\n  <button *ngIf=\"customButton.isVisible()\"\r\n          pButton\r\n          type=\"button\"\r\n          iconPos=\"left\"\r\n          [label]=\"customButton.label\"\r\n          [title]=\"customButton.label\"\r\n          [icon]=\"customButton.icon\"\r\n          (click)=\"repeater.executeCustomAction(customButton)\">\r\n  </button>\r\n</ng-container>\r\n<div [class]=\"cssClassName\" class=\"mt-3 mb-6\" *ngFor=\"let itemConfig of repeater.getItemConfigs(); let itemIndex = index\">\r\n  <p-panel>\r\n    <ng-template pTemplate=\"header\">\r\n      <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemIndex)\"></div>\r\n      <ng-container *ngIf=\"repeater.getCustomItemHeaderHtml; then customHeader; else defaultHeader\"></ng-container>\r\n      <ng-template #customHeader>\r\n        <div [innerHtml]=\"repeater.getCustomItemHeaderHtml(itemConfig, itemIndex)\"></div>\r\n      </ng-template>\r\n      <ng-template #defaultHeader>\r\n        <div [innerHtml]=\"getInnerHtmlWrappedByHeading(0, repeater.getHeaderTextOrDefault(itemIndex))\"></div>\r\n      </ng-template>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"icons\">\r\n      <button *ngIf=\"repeater.isEditingItem(itemIndex) && repeater.buttonSettings.standard.itemHeaderSave.isVisible(itemIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-link\"\r\n                    [disabled]=\"!repeater.canSaveItem()\"\r\n                    [id]=\"repeater.getElementId(repeater.buttonSettings.standard.itemHeaderSave.label, itemIndex)\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.itemHeaderSave.title, itemIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.itemHeaderSave.icon\"\r\n                    (click)=\"repeater.saveItem(itemIndex)\">\r\n      </button>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.view.isVisible(itemIndex)\"\r\n            pButton\r\n            pRipple\r\n            type=\"button\"\r\n            class=\"p-button-link\"\r\n            [disabled]=\"!repeater.canViewItem(itemIndex)\"\r\n            [id]=\"repeater.getElementId(RepeaterElementType.ViewButton, itemIndex)\"\r\n            [label]=\"repeater.buttonSettings.standard.view.label\"\r\n            [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemIndex)\"\r\n            [icon]=\"repeater.buttonSettings.standard.view.icon\"\r\n            (click)=\"repeater.editItem(itemIndex)\">\r\n      </button>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.edit.isVisible(itemIndex)\"\r\n              pButton\r\n              pRipple\r\n              type=\"button\"\r\n              class=\"p-button-link\"\r\n              [disabled]=\"!repeater.canEditItem(itemIndex)\"\r\n              [id]=\"repeater.getElementId(RepeaterElementType.EditButton, itemIndex)\"\r\n              [label]=\"repeater.buttonSettings.standard.edit.label\"\r\n              [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.edit.title, itemIndex)\"\r\n              [icon]=\"repeater.buttonSettings.standard.edit.icon\"\r\n              (click)=\"repeater.editItem(itemIndex)\">\r\n      </button>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.remove.isVisible(itemIndex)\"\r\n              pButton\r\n              pRipple\r\n              type=\"button\"\r\n              class=\"p-button-link\"\r\n              [disabled]=\"!repeater.canRemoveItem(itemIndex)\"\r\n              [id]=\"repeater.getElementId(RepeaterElementType.RemoveButton, itemIndex)\"\r\n              [label]=\"repeater.buttonSettings.standard.remove.label\"\r\n              [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.remove.title, itemIndex)\"\r\n              [icon]=\"repeater.buttonSettings.standard.remove.icon\"\r\n              (click)=\"repeater.removeItem(itemIndex)\">\r\n      </button>\r\n      <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemHeader\">\r\n        <button *ngIf=\"customButton.isVisible(itemIndex)\"\r\n                pButton\r\n                pRipple\r\n                type=\"button\"\r\n                class=\"p-button-link\"\r\n                [label]=\"customButton.label\"\r\n                [title]=\"repeater.getButtonTitle(customButton.title, itemIndex)\"\r\n                [icon]=\"customButton.icon\"\r\n                (click)=\"repeater.executeCustomAction(customButton, itemIndex)\">\r\n        </button>\r\n      </ng-container>\r\n      <button\r\n          *ngIf=\"!repeater.isEditingItem(itemIndex) && repeater.buttonSettings.standard.itemHeaderCollapse.isVisible(itemIndex)\"\r\n          pButton\r\n          pRipple\r\n          type=\"button\"\r\n          class=\"p-button-link\"\r\n          [id]=\"repeater.getElementId(RepeaterElementType.ItemHeaderCollapseButton, itemIndex)\"\r\n          [label]=\"repeater.buttonSettings.standard.itemHeaderCollapse.label\"\r\n          [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.itemHeaderCollapse.title, itemIndex)\"\r\n          [icon]=\"repeater.isItemHeaderExpanded(itemIndex) ? 'pi pi-chevron-down' : 'pi pi-chevron-up'\"\r\n          (click)=\"repeater.toggleItemHeaderExpansion(itemIndex)\">\r\n      </button>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"content\">\r\n      <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemIndex)\"></div>\r\n      <ng-container *ngIf=\"!repeater.isEditingItem(itemIndex); then itemSubHeaderTemplate; else itemContentTemplate\"></ng-container>\r\n      <ng-template #itemSubHeaderTemplate>\r\n        <div class=\"grid\" [ngClass]=\"repeater.isItemHeaderExpanded(itemIndex) ? 'showOverflow' : 'hideOverflow'\">\r\n          <ng-container *ngIf=\"repeater.getCustomItemSubHeaderHtml; then customSubHeader; else defaultSubHeader\"></ng-container>\r\n          <ng-template #customSubHeader>\r\n            <div [innerHtml]=\"repeater.getCustomItemSubHeaderHtml(itemConfig, itemIndex)\" class=\"col-12\"></div>\r\n          </ng-template>\r\n          <ng-template #defaultSubHeader>\r\n            <div *ngFor=\"let questionWithValue of repeater.getSubHeaderQuestionWithValues(itemIndex)\" class=\"col-6\">\r\n              <div [innerHtml]=\"getInnerHtmlWrappedByHeading(1, questionWithValue.label)\"></div>\r\n              <div>{{questionWithValue.value}}</div>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template #itemContentTemplate>\r\n        <div>\r\n          <div *ngIf=\"cssClassName == 'repeating-section' ;else pageRepeater\">\r\n            <div class=\"grid\">\r\n              <ng-container *ngFor=\"let item of itemConfig.fieldGroup\">\r\n                <ng-container *ngIf=\"item.hide != true && item.type != null; else noStyle\">\r\n                  <div class=\"{{getQuestionLayoutStyleClass(item)}}\" >                                 \r\n                  <formly-field [field]=\"item\"></formly-field>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-template #noStyle>\r\n                  <formly-field [field]=\"question\"></formly-field>\r\n              </ng-template>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n\r\n          <ng-template #pageRepeater>\r\n            <formly-field class=\"col\" [field]=\"itemConfig\"></formly-field>\r\n          </ng-template>\r\n\r\n          <div class=\"flex justify-content-between\">\r\n            <button *ngIf=\"repeater.buttonSettings.standard.close.isVisible(itemIndex)\"\r\n                    pButton\r\n                    type=\"button\"\r\n                    class=\"p-button-secondary\"\r\n                    [disabled]=\"!repeater.canCloseItem()\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.CloseButton, itemIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.close.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.close.title, itemIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.close.icon\"\r\n                    (click)=\"repeater.closeItem(itemIndex)\">\r\n              </button>\r\n            <button *ngIf=\"repeater.buttonSettings.standard.save.isVisible(itemIndex)\"\r\n                    pButton\r\n                    type=\"button\"\r\n                    [disabled]=\"!repeater.canSaveItem()\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.SaveButton, itemIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.save.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.save.title, itemIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.save.icon\"\r\n                    (click)=\"repeater.saveItem(itemIndex)\">\r\n            </button>\r\n            <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemContent\">\r\n              <button *ngIf=\"customButton.isVisible(itemIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      [label]=\"customButton.label\"\r\n                      [title]=\"repeater.getButtonTitle(customButton.title, itemIndex)\"\r\n                      [icon]=\"customButton.icon\"\r\n                      (click)=\"repeater.executeCustomAction(customButton, itemIndex)\">\r\n              </button>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </ng-template>\r\n  </p-panel>\r\n</div>\r\n\r\n", styles: [".hideOverflow{overflow:hidden;text-overflow:ellipsis;max-height:0px}.showOverflow{overflow:visible}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxPanelRepeaterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-panel-repeater', template: "<div [id]=\"repeater.getElementId(RepeaterElementType.TopOfAddButton)\"></div>\r\n<button *ngIf=\"repeater.buttonSettings.standard.add.isVisible()\"\r\n        pButton\r\n        type=\"button\"\r\n        iconPos=\"left\"\r\n        [disabled]=\"!repeater.canAddItem()\"\r\n        [id]=\"repeater.getElementId(RepeaterElementType.AddButton)\"\r\n        [label]=\"repeater.buttonSettings.standard.add.label\"\r\n        [title]=\"repeater.buttonSettings.standard.add.label\"\r\n        [icon]=\"repeater.buttonSettings.standard.add.icon\"\r\n        (click)=\"repeater.addItem()\">\r\n</button>\r\n<ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.repeater\">\r\n  <button *ngIf=\"customButton.isVisible()\"\r\n          pButton\r\n          type=\"button\"\r\n          iconPos=\"left\"\r\n          [label]=\"customButton.label\"\r\n          [title]=\"customButton.label\"\r\n          [icon]=\"customButton.icon\"\r\n          (click)=\"repeater.executeCustomAction(customButton)\">\r\n  </button>\r\n</ng-container>\r\n<div [class]=\"cssClassName\" class=\"mt-3 mb-6\" *ngFor=\"let itemConfig of repeater.getItemConfigs(); let itemIndex = index\">\r\n  <p-panel>\r\n    <ng-template pTemplate=\"header\">\r\n      <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemIndex)\"></div>\r\n      <ng-container *ngIf=\"repeater.getCustomItemHeaderHtml; then customHeader; else defaultHeader\"></ng-container>\r\n      <ng-template #customHeader>\r\n        <div [innerHtml]=\"repeater.getCustomItemHeaderHtml(itemConfig, itemIndex)\"></div>\r\n      </ng-template>\r\n      <ng-template #defaultHeader>\r\n        <div [innerHtml]=\"getInnerHtmlWrappedByHeading(0, repeater.getHeaderTextOrDefault(itemIndex))\"></div>\r\n      </ng-template>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"icons\">\r\n      <button *ngIf=\"repeater.isEditingItem(itemIndex) && repeater.buttonSettings.standard.itemHeaderSave.isVisible(itemIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-link\"\r\n                    [disabled]=\"!repeater.canSaveItem()\"\r\n                    [id]=\"repeater.getElementId(repeater.buttonSettings.standard.itemHeaderSave.label, itemIndex)\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.itemHeaderSave.title, itemIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.itemHeaderSave.icon\"\r\n                    (click)=\"repeater.saveItem(itemIndex)\">\r\n      </button>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.view.isVisible(itemIndex)\"\r\n            pButton\r\n            pRipple\r\n            type=\"button\"\r\n            class=\"p-button-link\"\r\n            [disabled]=\"!repeater.canViewItem(itemIndex)\"\r\n            [id]=\"repeater.getElementId(RepeaterElementType.ViewButton, itemIndex)\"\r\n            [label]=\"repeater.buttonSettings.standard.view.label\"\r\n            [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemIndex)\"\r\n            [icon]=\"repeater.buttonSettings.standard.view.icon\"\r\n            (click)=\"repeater.editItem(itemIndex)\">\r\n      </button>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.edit.isVisible(itemIndex)\"\r\n              pButton\r\n              pRipple\r\n              type=\"button\"\r\n              class=\"p-button-link\"\r\n              [disabled]=\"!repeater.canEditItem(itemIndex)\"\r\n              [id]=\"repeater.getElementId(RepeaterElementType.EditButton, itemIndex)\"\r\n              [label]=\"repeater.buttonSettings.standard.edit.label\"\r\n              [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.edit.title, itemIndex)\"\r\n              [icon]=\"repeater.buttonSettings.standard.edit.icon\"\r\n              (click)=\"repeater.editItem(itemIndex)\">\r\n      </button>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.remove.isVisible(itemIndex)\"\r\n              pButton\r\n              pRipple\r\n              type=\"button\"\r\n              class=\"p-button-link\"\r\n              [disabled]=\"!repeater.canRemoveItem(itemIndex)\"\r\n              [id]=\"repeater.getElementId(RepeaterElementType.RemoveButton, itemIndex)\"\r\n              [label]=\"repeater.buttonSettings.standard.remove.label\"\r\n              [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.remove.title, itemIndex)\"\r\n              [icon]=\"repeater.buttonSettings.standard.remove.icon\"\r\n              (click)=\"repeater.removeItem(itemIndex)\">\r\n      </button>\r\n      <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemHeader\">\r\n        <button *ngIf=\"customButton.isVisible(itemIndex)\"\r\n                pButton\r\n                pRipple\r\n                type=\"button\"\r\n                class=\"p-button-link\"\r\n                [label]=\"customButton.label\"\r\n                [title]=\"repeater.getButtonTitle(customButton.title, itemIndex)\"\r\n                [icon]=\"customButton.icon\"\r\n                (click)=\"repeater.executeCustomAction(customButton, itemIndex)\">\r\n        </button>\r\n      </ng-container>\r\n      <button\r\n          *ngIf=\"!repeater.isEditingItem(itemIndex) && repeater.buttonSettings.standard.itemHeaderCollapse.isVisible(itemIndex)\"\r\n          pButton\r\n          pRipple\r\n          type=\"button\"\r\n          class=\"p-button-link\"\r\n          [id]=\"repeater.getElementId(RepeaterElementType.ItemHeaderCollapseButton, itemIndex)\"\r\n          [label]=\"repeater.buttonSettings.standard.itemHeaderCollapse.label\"\r\n          [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.itemHeaderCollapse.title, itemIndex)\"\r\n          [icon]=\"repeater.isItemHeaderExpanded(itemIndex) ? 'pi pi-chevron-down' : 'pi pi-chevron-up'\"\r\n          (click)=\"repeater.toggleItemHeaderExpansion(itemIndex)\">\r\n      </button>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"content\">\r\n      <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemIndex)\"></div>\r\n      <ng-container *ngIf=\"!repeater.isEditingItem(itemIndex); then itemSubHeaderTemplate; else itemContentTemplate\"></ng-container>\r\n      <ng-template #itemSubHeaderTemplate>\r\n        <div class=\"grid\" [ngClass]=\"repeater.isItemHeaderExpanded(itemIndex) ? 'showOverflow' : 'hideOverflow'\">\r\n          <ng-container *ngIf=\"repeater.getCustomItemSubHeaderHtml; then customSubHeader; else defaultSubHeader\"></ng-container>\r\n          <ng-template #customSubHeader>\r\n            <div [innerHtml]=\"repeater.getCustomItemSubHeaderHtml(itemConfig, itemIndex)\" class=\"col-12\"></div>\r\n          </ng-template>\r\n          <ng-template #defaultSubHeader>\r\n            <div *ngFor=\"let questionWithValue of repeater.getSubHeaderQuestionWithValues(itemIndex)\" class=\"col-6\">\r\n              <div [innerHtml]=\"getInnerHtmlWrappedByHeading(1, questionWithValue.label)\"></div>\r\n              <div>{{questionWithValue.value}}</div>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template #itemContentTemplate>\r\n        <div>\r\n          <div *ngIf=\"cssClassName == 'repeating-section' ;else pageRepeater\">\r\n            <div class=\"grid\">\r\n              <ng-container *ngFor=\"let item of itemConfig.fieldGroup\">\r\n                <ng-container *ngIf=\"item.hide != true && item.type != null; else noStyle\">\r\n                  <div class=\"{{getQuestionLayoutStyleClass(item)}}\" >                                 \r\n                  <formly-field [field]=\"item\"></formly-field>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-template #noStyle>\r\n                  <formly-field [field]=\"question\"></formly-field>\r\n              </ng-template>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n\r\n          <ng-template #pageRepeater>\r\n            <formly-field class=\"col\" [field]=\"itemConfig\"></formly-field>\r\n          </ng-template>\r\n\r\n          <div class=\"flex justify-content-between\">\r\n            <button *ngIf=\"repeater.buttonSettings.standard.close.isVisible(itemIndex)\"\r\n                    pButton\r\n                    type=\"button\"\r\n                    class=\"p-button-secondary\"\r\n                    [disabled]=\"!repeater.canCloseItem()\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.CloseButton, itemIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.close.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.close.title, itemIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.close.icon\"\r\n                    (click)=\"repeater.closeItem(itemIndex)\">\r\n              </button>\r\n            <button *ngIf=\"repeater.buttonSettings.standard.save.isVisible(itemIndex)\"\r\n                    pButton\r\n                    type=\"button\"\r\n                    [disabled]=\"!repeater.canSaveItem()\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.SaveButton, itemIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.save.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.save.title, itemIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.save.icon\"\r\n                    (click)=\"repeater.saveItem(itemIndex)\">\r\n            </button>\r\n            <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemContent\">\r\n              <button *ngIf=\"customButton.isVisible(itemIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      [label]=\"customButton.label\"\r\n                      [title]=\"repeater.getButtonTitle(customButton.title, itemIndex)\"\r\n                      [icon]=\"customButton.icon\"\r\n                      (click)=\"repeater.executeCustomAction(customButton, itemIndex)\">\r\n              </button>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </ng-template>\r\n  </p-panel>\r\n</div>\r\n\r\n", styles: [".hideOverflow{overflow:hidden;text-overflow:ellipsis;max-height:0px}.showOverflow{overflow:visible}\n"] }]
        }], propDecorators: { repeater: [{
                type: Input
            }], cssClassName: [{
                type: Input
            }], htmlHeadingLevelBase: [{
                type: Input
            }] } });

class DspxTableRepeaterComponent {
    constructor() {
        this.repeaterLayout = 'plain';
        this.onInitialiseCompleted = new EventEmitter();
        this.RepeaterElementType = RepeaterElementType; // workaround to make the enum accessible from the Angular HTML template
    }
    ngOnInit() {
        this.headerQuestions = this.repeater.viewModel.orderedQuestions.map(question => ({ field: question.key, header: question.label }));
    }
    ngAfterViewInit() {
        this.onInitialiseCompleted.emit({
            isEditingItem: itemHeaderViewModel => this.table.isRowExpanded(itemHeaderViewModel),
            toggleItemEditingStatus: itemHeaderViewModel => this.table.toggleRow(itemHeaderViewModel),
            reapplySearch: () => this.onExecuteSearch(this.searchInput),
            clearSearch: () => this.onClearSearch(this.searchInput)
        });
    }
    onClearSearch(searchInput) {
        if (searchInput) {
            searchInput.value = '';
            this.onExecuteSearch(searchInput);
        }
    }
    onClearSearchViaKeyboard(event, searchInput) {
        this.onClearSearch(searchInput);
        event.preventDefault();
    }
    onExecuteSearch(searchInput) {
        if (searchInput) {
            this.searchInput = searchInput;
            const searchInputValue = this.searchInput.value?.trim();
            if (!searchInputValue) {
                this.table?.clear();
            }
            else {
                this.table?.filterGlobal(searchInputValue, 'contains');
            }
        }
    }
    getHeaderHtml(itemIndex) {
        if (this.repeater.getCustomItemHeaderHtml) {
            return this.repeater.getCustomItemHeaderHtml(this.repeater.getItemConfig(itemIndex), itemIndex);
        }
        return "";
    }
    getSubHeaderHtml(itemIndex) {
        if (this.repeater.getCustomItemSubHeaderHtml) {
            return this.repeater.getCustomItemSubHeaderHtml(this.repeater.getItemConfig(itemIndex), itemIndex);
        }
        return "";
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxTableRepeaterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: DspxTableRepeaterComponent, selector: "dspx-table-repeater", inputs: { repeater: "repeater", renderItemsAsSeparateFieldTypes: "renderItemsAsSeparateFieldTypes", repeaterLayout: "repeaterLayout" }, outputs: { onInitialiseCompleted: "onInitialiseCompleted" }, viewQueries: [{ propertyName: "table", first: true, predicate: Table, descendants: true }], ngImport: i0, template: "<div class=\"card\">\r\n  <p-toolbar>\r\n    <div class=\"p-toolbar-group-start\">\r\n      <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfAddButton)\"></div>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.add.isVisible()\"\r\n              pButton\r\n              type=\"button\"\r\n              iconPos=\"left\"\r\n              [disabled]=\"!repeater.canAddItem()\"\r\n              [id]=\"repeater.getElementId(RepeaterElementType.AddButton)\"\r\n              [label]=\"repeater.buttonSettings.standard.add.label\"\r\n              [title]=\"repeater.buttonSettings.standard.add.label\"\r\n              [icon]=\"repeater.buttonSettings.standard.add.icon\"\r\n              (click)=\"repeater.addItem()\">\r\n      </button>\r\n      <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.repeater\">\r\n        <button *ngIf=\"customButton.isVisible()\"\r\n                pButton\r\n                type=\"button\"\r\n                iconPos=\"left\"\r\n                [label]=\"customButton.label\"\r\n                [title]=\"customButton.label\"\r\n                [icon]=\"customButton.icon\"\r\n                (click)=\"repeater.executeCustomAction(customButton)\">\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"p-toolbar-group-end\">\r\n      <span class=\"p-input-icon-left\">\r\n        @if (searchInput?.value) {\r\n          <i class=\"pi pi-times\" tabindex=\"0\" role=\"button\" aria-label=\"Clear search\"\r\n             (click)=\"onClearSearch(searchInput)\"\r\n             (keydown.enter)=\"onClearSearchViaKeyboard($event, searchInput)\"\r\n             (keydown.space)=\"onClearSearchViaKeyboard($event, searchInput)\">\r\n          </i>\r\n        }\r\n        @else {\r\n          <i class=\"pi pi-search\" aria-hidden=\"true\"></i>\r\n        }\r\n        <input #searchInput type=\"text\" pInputText placeholder=\"Search\" aria-label=\"Search\" (input)=\"onExecuteSearch(searchInput)\">\r\n      </span>\r\n    </div>\r\n  </p-toolbar>\r\n</div>\r\n<p-table [columns]=\"headerQuestions\" [value]=\"repeater.viewModel.model\" dataKey=\"$repeaterItemViewModelId\">\r\n  <ng-template pTemplate=\"header\" let-tableColumns>\r\n\r\n    <ng-container *ngIf=\"repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate\"></ng-container>\r\n\r\n    <ng-template #defaultLayoutTemplate>\r\n      <tr>\r\n        <!--\r\n          NOTE:\r\n          Sorting is intentionally disabled on all columns, via [pSortableColumnDisabled]=\"true\",\r\n          because it currently causes an issue: after you sort any column, the row expansion stops working when adding new items.\r\n          Until we fix the root cause of the problem, the sorting is disabled by default, since there are no known requirements of\r\n          being able to sort the columns of repeating items.\r\n        -->\r\n        <th *ngFor=\"let tableColumn of tableColumns\"\r\n        [pSortableColumn]=\"tableColumn.field\" [pSortableColumnDisabled]=\"true\">\r\n          {{tableColumn.header}} <p-sortIcon [field]=\"tableColumn.field\"></p-sortIcon>\r\n        </th>\r\n        <th></th>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template #cardLayoutTemplate>\r\n      <div class=\"mt-2\"></div>\r\n    </ng-template>\r\n\r\n  </ng-template>\r\n  <ng-template pTemplate=\"body\" let-itemHeaderViewModel let-tableColumns=\"columns\">\r\n    <ng-container *ngIf=\"repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate\"></ng-container>\r\n\r\n    <ng-template #defaultLayoutTemplate>\r\n      <tr>\r\n        <td *ngFor=\"let tableColumn of tableColumns\">\r\n          {{itemHeaderViewModel[tableColumn.field]}}\r\n        </td>\r\n        <td>\r\n          <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n          <button *ngIf=\"repeater.buttonSettings.standard.edit.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  class=\"p-button-link\"\r\n                  [disabled]=\"!repeater.canEditItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [id]=\"repeater.getElementId(RepeaterElementType.EditButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [label]=\"repeater.buttonSettings.standard.edit.label\"\r\n                  [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.edit.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [icon]=\"repeater.buttonSettings.standard.edit.icon\"\r\n                  (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n          </button>\r\n          <button *ngIf=\"repeater.buttonSettings.standard.view.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-link\"\r\n                    [disabled]=\"!repeater.canViewItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.ViewButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.view.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.view.icon\"\r\n                    (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n          <button *ngIf=\"repeater.buttonSettings.standard.remove.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  class=\"p-button-link\"\r\n                  [disabled]=\"!repeater.canRemoveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [id]=\"repeater.getElementId(RepeaterElementType.RemoveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [label]=\"repeater.buttonSettings.standard.remove.label\"\r\n                  [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.remove.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [icon]=\"repeater.buttonSettings.standard.remove.icon\"\r\n                  (click)=\"repeater.removeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n          </button>\r\n          <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemHeader\">\r\n            <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-link\"\r\n                    [label]=\"customButton.label\"\r\n                    [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [icon]=\"customButton.icon\"\r\n                    (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n            </button>\r\n          </ng-container>\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template #cardLayoutTemplate>\r\n      <tr>\r\n        <td>\r\n          <div class=\"card widget-messages repeater-card\" style=\"height: 100%\" *ngIf=\" table && !table.isRowExpanded(itemHeaderViewModel)\">\r\n          <div class=\"flex align-items-center justify-content-between\">\r\n            <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              <div [innerHtml]=\"getHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n            </div>\r\n            <div>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.edit.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      pRipple\r\n                      type=\"button\"\r\n                      class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                      [disabled]=\"!repeater.canEditItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.EditButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.edit.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.edit.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.edit.icon\"\r\n                      (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.view.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                    [disabled]=\"!repeater.canViewItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.ViewButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.view.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.view.icon\"\r\n                    (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.remove.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      pRipple\r\n                      type=\"button\"\r\n                      class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                      [disabled]=\"!repeater.canRemoveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.RemoveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.remove.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.remove.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.remove.icon\"\r\n                      (click)=\"repeater.removeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemHeader\">\r\n                <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        pButton\r\n                        pRipple\r\n                        type=\"button\"\r\n                        class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                        [label]=\"customButton.label\"\r\n                        [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        [icon]=\"customButton.icon\"\r\n                        (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n          <div class=\"mb-4\" [innerHtml]=\"getSubHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n          </div>\r\n          <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n          <div class=\"grid\">\r\n            <div class=\"col-12 md:col-6 lg:col-4\" *ngFor=\"let tableColumn of tableColumns\">\r\n              <div class=\"message-text\">{{tableColumn.header}}</div>\r\n              <div class=\"message\">{{itemHeaderViewModel[tableColumn.field]}}</div>\r\n            </div>\r\n          </div>\r\n          </div>\r\n          <div class=\"card widget-messages repeater-card\" style=\"height: 100%\" *ngIf=\"table && table.isRowExpanded(itemHeaderViewModel)\">\r\n            <div class=\"flex align-items-center justify-content-between\">\r\n              <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                <div [innerHtml]=\"getHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n              </div>\r\n            </div>\r\n            <div [innerHtml]=\"getSubHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n            </div>\r\n            <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n              <ng-container *ngIf=\"renderItemsAsSeparateFieldTypes; then separateFieldTypeItemTemplate; else singleFieldTypeItemTemplate\"></ng-container>\r\n                  <ng-template #separateFieldTypeItemTemplate>\r\n                    <div class=\"grid\">\r\n                      <div [class]=\"itemConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let itemConfig of repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex).fieldGroup\">\r\n                          <formly-field class=\"col\" [field]=\"itemConfig\"></formly-field>\r\n                      </div>\r\n                    </div>\r\n                  </ng-template>\r\n                  <ng-template #singleFieldTypeItemTemplate>\r\n                    <formly-field class=\"col\" [field]=\"repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></formly-field>\r\n                  </ng-template>\r\n\r\n            <div class=\"flex justify-content-between\">\r\n              <button *ngIf=\"repeater.buttonSettings.standard.close.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      class=\"p-button-secondary\"\r\n                      [disabled]=\"!repeater.canCloseItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.CloseButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.close.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.close.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.close.icon\"\r\n                      (click)=\"repeater.closeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.save.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      [disabled]=\"!repeater.canSaveItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.SaveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.save.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.save.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.save.icon\"\r\n                      (click)=\"repeater.saveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemContent\">\r\n                <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        pButton\r\n                        type=\"button\"\r\n                        [label]=\"customButton.label\"\r\n                        [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        [icon]=\"customButton.icon\"\r\n                        (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"rowexpansion\" let-itemHeaderViewModel let-tableColumns=\"columns\">\r\n    <ng-container *ngIf=\"repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate\"></ng-container>\r\n\r\n    <ng-template #defaultLayoutTemplate>\r\n      <tr>\r\n        <td [attr.colspan]=\"tableColumns.length + 1\">\r\n          <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n          <div>\r\n            <ng-container *ngIf=\"renderItemsAsSeparateFieldTypes; then separateFieldTypeItemTemplate; else singleFieldTypeItemTemplate\"></ng-container>\r\n            <ng-template #separateFieldTypeItemTemplate>\r\n              <div class=\"grid\">\r\n                <div [class]=\"itemConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let itemConfig of repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex).fieldGroup\">\r\n                    <formly-field class=\"col\" [field]=\"itemConfig\"></formly-field>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n            <ng-template #singleFieldTypeItemTemplate>\r\n              <formly-field class=\"col\" [field]=\"repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></formly-field>\r\n            </ng-template>\r\n            <div class=\"flex justify-content-between\">\r\n              <button *ngIf=\"repeater.buttonSettings.standard.close.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      class=\"p-button-secondary\"\r\n                      [disabled]=\"!repeater.canCloseItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.CloseButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.close.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.close.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.close.icon\"\r\n                      (click)=\"repeater.closeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.save.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      [disabled]=\"!repeater.canSaveItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.SaveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.save.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.save.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.save.icon\"\r\n                      (click)=\"repeater.saveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemContent\">\r\n                <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        pButton\r\n                        type=\"button\"\r\n                        [label]=\"customButton.label\"\r\n                        [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        [icon]=\"customButton.icon\"\r\n                        (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template #cardLayoutTemplate>\r\n      <div class=\"clearfix\"></div>\r\n    </ng-template>\r\n\r\n  </ng-template>\r\n</p-table>\r\n", styles: [".repeater-card{border:1px solid var(--surface-border)}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.InputText, selector: "[pInputText]", inputs: ["variant"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: Table, selector: "p-table", inputs: ["frozenColumns", "frozenValue", "style", "styleClass", "tableStyle", "tableStyleClass", "paginator", "pageLinks", "rowsPerPageOptions", "alwaysShowPaginator", "paginatorPosition", "paginatorStyleClass", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showFirstLastIcon", "showPageLinks", "defaultSortOrder", "sortMode", "resetPageOnSort", "selectionMode", "selectionPageOnly", "contextMenuSelection", "contextMenuSelectionMode", "dataKey", "metaKeySelection", "rowSelectable", "rowTrackBy", "lazy", "lazyLoadOnInit", "compareSelectionBy", "csvSeparator", "exportFilename", "filters", "globalFilterFields", "filterDelay", "filterLocale", "expandedRowKeys", "editingRowKeys", "rowExpandMode", "scrollable", "scrollDirection", "rowGroupMode", "scrollHeight", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "frozenWidth", "responsive", "contextMenu", "resizableColumns", "columnResizeMode", "reorderableColumns", "loading", "loadingIcon", "showLoader", "rowHover", "customSort", "showInitialSortBadge", "autoLayout", "exportFunction", "exportHeader", "stateKey", "stateStorage", "editMode", "groupRowsBy", "groupRowsByOrder", "responsiveLayout", "breakpoint", "paginatorLocale", "value", "columns", "first", "rows", "totalRecords", "sortField", "sortOrder", "multiSortMeta", "selection", "selectAll", "virtualRowHeight"], outputs: ["contextMenuSelectionChange", "selectAllChange", "selectionChange", "onRowSelect", "onRowUnselect", "onPage", "onSort", "onFilter", "onLazyLoad", "onRowExpand", "onRowCollapse", "onContextMenuSelect", "onColResize", "onColReorder", "onRowReorder", "onEditInit", "onEditComplete", "onEditCancel", "onHeaderCheckboxToggle", "sortFunction", "firstChange", "rowsChange", "onStateSave", "onStateRestore"] }, { kind: "directive", type: SortableColumn, selector: "[pSortableColumn]", inputs: ["pSortableColumn", "pSortableColumnDisabled"] }, { kind: "component", type: SortIcon, selector: "p-sortIcon", inputs: ["field"] }, { kind: "component", type: i7$1.Toolbar, selector: "p-toolbar", inputs: ["style", "styleClass", "ariaLabelledBy"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxTableRepeaterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-table-repeater', template: "<div class=\"card\">\r\n  <p-toolbar>\r\n    <div class=\"p-toolbar-group-start\">\r\n      <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfAddButton)\"></div>\r\n      <button *ngIf=\"repeater.buttonSettings.standard.add.isVisible()\"\r\n              pButton\r\n              type=\"button\"\r\n              iconPos=\"left\"\r\n              [disabled]=\"!repeater.canAddItem()\"\r\n              [id]=\"repeater.getElementId(RepeaterElementType.AddButton)\"\r\n              [label]=\"repeater.buttonSettings.standard.add.label\"\r\n              [title]=\"repeater.buttonSettings.standard.add.label\"\r\n              [icon]=\"repeater.buttonSettings.standard.add.icon\"\r\n              (click)=\"repeater.addItem()\">\r\n      </button>\r\n      <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.repeater\">\r\n        <button *ngIf=\"customButton.isVisible()\"\r\n                pButton\r\n                type=\"button\"\r\n                iconPos=\"left\"\r\n                [label]=\"customButton.label\"\r\n                [title]=\"customButton.label\"\r\n                [icon]=\"customButton.icon\"\r\n                (click)=\"repeater.executeCustomAction(customButton)\">\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"p-toolbar-group-end\">\r\n      <span class=\"p-input-icon-left\">\r\n        @if (searchInput?.value) {\r\n          <i class=\"pi pi-times\" tabindex=\"0\" role=\"button\" aria-label=\"Clear search\"\r\n             (click)=\"onClearSearch(searchInput)\"\r\n             (keydown.enter)=\"onClearSearchViaKeyboard($event, searchInput)\"\r\n             (keydown.space)=\"onClearSearchViaKeyboard($event, searchInput)\">\r\n          </i>\r\n        }\r\n        @else {\r\n          <i class=\"pi pi-search\" aria-hidden=\"true\"></i>\r\n        }\r\n        <input #searchInput type=\"text\" pInputText placeholder=\"Search\" aria-label=\"Search\" (input)=\"onExecuteSearch(searchInput)\">\r\n      </span>\r\n    </div>\r\n  </p-toolbar>\r\n</div>\r\n<p-table [columns]=\"headerQuestions\" [value]=\"repeater.viewModel.model\" dataKey=\"$repeaterItemViewModelId\">\r\n  <ng-template pTemplate=\"header\" let-tableColumns>\r\n\r\n    <ng-container *ngIf=\"repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate\"></ng-container>\r\n\r\n    <ng-template #defaultLayoutTemplate>\r\n      <tr>\r\n        <!--\r\n          NOTE:\r\n          Sorting is intentionally disabled on all columns, via [pSortableColumnDisabled]=\"true\",\r\n          because it currently causes an issue: after you sort any column, the row expansion stops working when adding new items.\r\n          Until we fix the root cause of the problem, the sorting is disabled by default, since there are no known requirements of\r\n          being able to sort the columns of repeating items.\r\n        -->\r\n        <th *ngFor=\"let tableColumn of tableColumns\"\r\n        [pSortableColumn]=\"tableColumn.field\" [pSortableColumnDisabled]=\"true\">\r\n          {{tableColumn.header}} <p-sortIcon [field]=\"tableColumn.field\"></p-sortIcon>\r\n        </th>\r\n        <th></th>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template #cardLayoutTemplate>\r\n      <div class=\"mt-2\"></div>\r\n    </ng-template>\r\n\r\n  </ng-template>\r\n  <ng-template pTemplate=\"body\" let-itemHeaderViewModel let-tableColumns=\"columns\">\r\n    <ng-container *ngIf=\"repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate\"></ng-container>\r\n\r\n    <ng-template #defaultLayoutTemplate>\r\n      <tr>\r\n        <td *ngFor=\"let tableColumn of tableColumns\">\r\n          {{itemHeaderViewModel[tableColumn.field]}}\r\n        </td>\r\n        <td>\r\n          <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n          <button *ngIf=\"repeater.buttonSettings.standard.edit.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  class=\"p-button-link\"\r\n                  [disabled]=\"!repeater.canEditItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [id]=\"repeater.getElementId(RepeaterElementType.EditButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [label]=\"repeater.buttonSettings.standard.edit.label\"\r\n                  [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.edit.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [icon]=\"repeater.buttonSettings.standard.edit.icon\"\r\n                  (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n          </button>\r\n          <button *ngIf=\"repeater.buttonSettings.standard.view.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-link\"\r\n                    [disabled]=\"!repeater.canViewItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.ViewButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.view.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.view.icon\"\r\n                    (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n          <button *ngIf=\"repeater.buttonSettings.standard.remove.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  class=\"p-button-link\"\r\n                  [disabled]=\"!repeater.canRemoveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [id]=\"repeater.getElementId(RepeaterElementType.RemoveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [label]=\"repeater.buttonSettings.standard.remove.label\"\r\n                  [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.remove.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                  [icon]=\"repeater.buttonSettings.standard.remove.icon\"\r\n                  (click)=\"repeater.removeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n          </button>\r\n          <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemHeader\">\r\n            <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-link\"\r\n                    [label]=\"customButton.label\"\r\n                    [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [icon]=\"customButton.icon\"\r\n                    (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n            </button>\r\n          </ng-container>\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template #cardLayoutTemplate>\r\n      <tr>\r\n        <td>\r\n          <div class=\"card widget-messages repeater-card\" style=\"height: 100%\" *ngIf=\" table && !table.isRowExpanded(itemHeaderViewModel)\">\r\n          <div class=\"flex align-items-center justify-content-between\">\r\n            <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              <div [innerHtml]=\"getHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n            </div>\r\n            <div>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.edit.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      pRipple\r\n                      type=\"button\"\r\n                      class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                      [disabled]=\"!repeater.canEditItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.EditButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.edit.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.edit.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.edit.icon\"\r\n                      (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.view.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                    [disabled]=\"!repeater.canViewItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [id]=\"repeater.getElementId(RepeaterElementType.ViewButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [label]=\"repeater.buttonSettings.standard.view.label\"\r\n                    [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.view.title, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                    [icon]=\"repeater.buttonSettings.standard.view.icon\"\r\n                    (click)=\"repeater.editItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.remove.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      pRipple\r\n                      type=\"button\"\r\n                      class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                      [disabled]=\"!repeater.canRemoveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.RemoveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.remove.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.remove.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.remove.icon\"\r\n                      (click)=\"repeater.removeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemHeader\">\r\n                <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        pButton\r\n                        pRipple\r\n                        type=\"button\"\r\n                        class=\"p-button-rounded p-button-outlined p-button-sm\"\r\n                        [label]=\"customButton.label\"\r\n                        [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        [icon]=\"customButton.icon\"\r\n                        (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n          <div class=\"mb-4\" [innerHtml]=\"getSubHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n          </div>\r\n          <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n          <div class=\"grid\">\r\n            <div class=\"col-12 md:col-6 lg:col-4\" *ngFor=\"let tableColumn of tableColumns\">\r\n              <div class=\"message-text\">{{tableColumn.header}}</div>\r\n              <div class=\"message\">{{itemHeaderViewModel[tableColumn.field]}}</div>\r\n            </div>\r\n          </div>\r\n          </div>\r\n          <div class=\"card widget-messages repeater-card\" style=\"height: 100%\" *ngIf=\"table && table.isRowExpanded(itemHeaderViewModel)\">\r\n            <div class=\"flex align-items-center justify-content-between\">\r\n              <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemHeader, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                <div [innerHtml]=\"getHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n              </div>\r\n            </div>\r\n            <div [innerHtml]=\"getSubHeaderHtml(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n            </div>\r\n            <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n              <ng-container *ngIf=\"renderItemsAsSeparateFieldTypes; then separateFieldTypeItemTemplate; else singleFieldTypeItemTemplate\"></ng-container>\r\n                  <ng-template #separateFieldTypeItemTemplate>\r\n                    <div class=\"grid\">\r\n                      <div [class]=\"itemConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let itemConfig of repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex).fieldGroup\">\r\n                          <formly-field class=\"col\" [field]=\"itemConfig\"></formly-field>\r\n                      </div>\r\n                    </div>\r\n                  </ng-template>\r\n                  <ng-template #singleFieldTypeItemTemplate>\r\n                    <formly-field class=\"col\" [field]=\"repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></formly-field>\r\n                  </ng-template>\r\n\r\n            <div class=\"flex justify-content-between\">\r\n              <button *ngIf=\"repeater.buttonSettings.standard.close.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      class=\"p-button-secondary\"\r\n                      [disabled]=\"!repeater.canCloseItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.CloseButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.close.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.close.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.close.icon\"\r\n                      (click)=\"repeater.closeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.save.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      [disabled]=\"!repeater.canSaveItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.SaveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.save.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.save.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.save.icon\"\r\n                      (click)=\"repeater.saveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemContent\">\r\n                <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        pButton\r\n                        type=\"button\"\r\n                        [label]=\"customButton.label\"\r\n                        [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        [icon]=\"customButton.icon\"\r\n                        (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"rowexpansion\" let-itemHeaderViewModel let-tableColumns=\"columns\">\r\n    <ng-container *ngIf=\"repeaterLayout === 'card' then cardLayoutTemplate; else defaultLayoutTemplate\"></ng-container>\r\n\r\n    <ng-template #defaultLayoutTemplate>\r\n      <tr>\r\n        <td [attr.colspan]=\"tableColumns.length + 1\">\r\n          <div [id]=\"repeater.getElementId(RepeaterElementType.TopOfItemContent, itemHeaderViewModel.$repeaterItemViewModelIndex)\"></div>\r\n          <div>\r\n            <ng-container *ngIf=\"renderItemsAsSeparateFieldTypes; then separateFieldTypeItemTemplate; else singleFieldTypeItemTemplate\"></ng-container>\r\n            <ng-template #separateFieldTypeItemTemplate>\r\n              <div class=\"grid\">\r\n                <div [class]=\"itemConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let itemConfig of repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex).fieldGroup\">\r\n                    <formly-field class=\"col\" [field]=\"itemConfig\"></formly-field>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n            <ng-template #singleFieldTypeItemTemplate>\r\n              <formly-field class=\"col\" [field]=\"repeater.getItemConfig(itemHeaderViewModel.$repeaterItemViewModelIndex)\"></formly-field>\r\n            </ng-template>\r\n            <div class=\"flex justify-content-between\">\r\n              <button *ngIf=\"repeater.buttonSettings.standard.close.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      class=\"p-button-secondary\"\r\n                      [disabled]=\"!repeater.canCloseItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.CloseButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.close.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.close.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.close.icon\"\r\n                      (click)=\"repeater.closeItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <button *ngIf=\"repeater.buttonSettings.standard.save.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      pButton\r\n                      type=\"button\"\r\n                      [disabled]=\"!repeater.canSaveItem()\"\r\n                      [id]=\"repeater.getElementId(RepeaterElementType.SaveButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [label]=\"repeater.buttonSettings.standard.save.label\"\r\n                      [title]=\"repeater.getButtonTitle(repeater.buttonSettings.standard.save.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                      [icon]=\"repeater.buttonSettings.standard.save.icon\"\r\n                      (click)=\"repeater.saveItem(itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n              </button>\r\n              <ng-container *ngFor=\"let customButton of repeater.buttonSettings.custom.itemContent\">\r\n                <button *ngIf=\"customButton.isVisible(itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        pButton\r\n                        type=\"button\"\r\n                        [label]=\"customButton.label\"\r\n                        [title]=\"repeater.getButtonTitle(customButton.label, itemHeaderViewModel.$repeaterItemViewModelIndex)\"\r\n                        [icon]=\"customButton.icon\"\r\n                        (click)=\"repeater.executeCustomAction(customButton, itemHeaderViewModel.$repeaterItemViewModelIndex)\">\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template #cardLayoutTemplate>\r\n      <div class=\"clearfix\"></div>\r\n    </ng-template>\r\n\r\n  </ng-template>\r\n</p-table>\r\n", styles: [".repeater-card{border:1px solid var(--surface-border)}\n"] }]
        }], propDecorators: { repeater: [{
                type: Input
            }], renderItemsAsSeparateFieldTypes: [{
                type: Input
            }], repeaterLayout: [{
                type: Input
            }], onInitialiseCompleted: [{
                type: Output
            }], table: [{
                type: ViewChild,
                args: [Table]
            }] } });

class DspxTabSetComponent {
    constructor(formNavigationService, formConfigurationService, coreService) {
        this.formNavigationService = formNavigationService;
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this._activeTabIndex = 0;
    }
    get activeTabIndex() {
        const activeIndex = this.formNavigationService.getActiveIndex(this.tabsConfig.props.navigationKey);
        if (activeIndex >= 0) {
            this._activeTabIndex = activeIndex;
            return activeIndex;
        }
        return this._activeTabIndex;
    }
    get hasBadgeValue() {
        return this.badgeValue ? this.badgeValue.length > 0 : false;
    }
    hasVisibleChildren() {
        if (this.formNavigationService.isTabType(this.tabsConfig.type.toString()) && this.tabsConfig.props.navigationKey === NavigationKey.PAGE) {
            return this.tabsConfig.fieldGroup.findIndex(fg => this.formNavigationService.isPageType(fg.type.toString()) && fg.props.includeInProgress) >= 0;
        }
        return true;
    }
    onTabChange(event) {
        this.formNavigationService.setActiveIndex(this.tabsConfig.props.navigationKey, event.index);
    }
    isValid(field) {
        if (field.key) {
            return field.formControl.valid;
        }
        return field.fieldGroup.every((f) => this.isValid(f));
    }
    getTabProgress(childTabsConfig) {
        if (childTabsConfig.key.toString() !== 'tabs') {
            const rootFieldGroup = childTabsConfig.parent.parent.parent.fieldGroup; // FieldGroup containing all the tabs.
            const formModel = childTabsConfig.parent.parent.parent.model;
            const progressModel = this.formConfigurationService.getProgressModel(rootFieldGroup, formModel, childTabsConfig);
            return `${progressModel.formProgress[0]?.totalAnswered} / ${progressModel.formProgress[0]?.totalQuestions}`;
        }
    }
    getBadgeValue(childTabsConfig) {
        this.badgeValue = this.coreService.applicationFunctions['getBadgeValue'](childTabsConfig);
        return this.badgeValue;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxTabSetComponent, deps: [{ token: FormNavigationService }, { token: FormConfigurationService }, { token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxTabSetComponent, selector: "dspx-tab-set", inputs: { tabsConfig: "tabsConfig" }, ngImport: i0, template: "<p-tabView [activeIndex]=\"activeTabIndex\" \r\n           [hasVisibleChildren]=\"hasVisibleChildren()\" \r\n           (onChange)=\"onTabChange($event)\">\r\n\r\n  <ng-container *ngFor=\"let childTabsConfig of tabsConfig.fieldGroup\">\r\n\r\n    <p-tabPanel *ngIf=\"childTabsConfig.hide !== true\" [includeInProgress]=\"childTabsConfig.props.includeInProgress\">\r\n\r\n      <ng-template pTemplate=\"header\">\r\n        <div>\r\n          {{childTabsConfig.props.label}}\r\n          <ng-container *ngIf=\"childTabsConfig.props.includeCount\">\r\n            <p-badge class=\"childTabsConfig-progress-badge\" \r\n                     [value]=\"getTabProgress(childTabsConfig)\">\r\n            </p-badge>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"childTabsConfig.props.showBadges\">\r\n            <p-badge [ngClass]=\"{'p-badge-tab': childTabsConfig.type == 'tabs', 'p-badge-page': childTabsConfig.type == 'page'}\"\r\n                     [value]=\"getBadgeValue(childTabsConfig)\"\r\n                     [hidden]=\"!hasBadgeValue\">\r\n            </p-badge>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <formly-field [field]=\"childTabsConfig\"></formly-field>\r\n\r\n    </p-tabPanel>\r\n\r\n  </ng-container>\r\n\r\n</p-tabView>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i3$5.Badge, selector: "p-badge", inputs: ["styleClass", "style", "badgeSize", "severity", "value", "badgeDisabled", "size"] }, { kind: "component", type: TabView, selector: "p-tabView", inputs: ["style", "styleClass", "controlClose", "scrollable", "activeIndex", "selectOnFocus", "nextButtonAriaLabel", "prevButtonAriaLabel", "autoHideButtons", "tabindex", "hasVisibleChildren"], outputs: ["onChange", "onClose", "activeIndexChange"] }, { kind: "component", type: TabPanel, selector: "p-tabPanel", inputs: ["closable", "headerStyle", "headerStyleClass", "cache", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "selected", "disabled", "header", "leftIcon", "rightIcon", "includeInProgress"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxTabSetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-tab-set', encapsulation: ViewEncapsulation.None, template: "<p-tabView [activeIndex]=\"activeTabIndex\" \r\n           [hasVisibleChildren]=\"hasVisibleChildren()\" \r\n           (onChange)=\"onTabChange($event)\">\r\n\r\n  <ng-container *ngFor=\"let childTabsConfig of tabsConfig.fieldGroup\">\r\n\r\n    <p-tabPanel *ngIf=\"childTabsConfig.hide !== true\" [includeInProgress]=\"childTabsConfig.props.includeInProgress\">\r\n\r\n      <ng-template pTemplate=\"header\">\r\n        <div>\r\n          {{childTabsConfig.props.label}}\r\n          <ng-container *ngIf=\"childTabsConfig.props.includeCount\">\r\n            <p-badge class=\"childTabsConfig-progress-badge\" \r\n                     [value]=\"getTabProgress(childTabsConfig)\">\r\n            </p-badge>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"childTabsConfig.props.showBadges\">\r\n            <p-badge [ngClass]=\"{'p-badge-tab': childTabsConfig.type == 'tabs', 'p-badge-page': childTabsConfig.type == 'page'}\"\r\n                     [value]=\"getBadgeValue(childTabsConfig)\"\r\n                     [hidden]=\"!hasBadgeValue\">\r\n            </p-badge>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <formly-field [field]=\"childTabsConfig\"></formly-field>\r\n\r\n    </p-tabPanel>\r\n\r\n  </ng-container>\r\n\r\n</p-tabView>\r\n" }]
        }], ctorParameters: () => [{ type: FormNavigationService }, { type: FormConfigurationService }, { type: CoreService }], propDecorators: { tabsConfig: [{
                type: Input
            }] } });

class DspxDescriptionComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxDescriptionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxDescriptionComponent, selector: "dspx-description", inputs: { text: "text" }, ngImport: i0, template: "<p *ngIf=\"text && text !== ''\" [innerHtml]=\"text\"></p>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxDescriptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-description', template: "<p *ngIf=\"text && text !== ''\" [innerHtml]=\"text\"></p>\r\n" }]
        }], propDecorators: { text: [{
                type: Input
            }] } });

class DspxQuestionsViewModeComponent {
    constructor(coreService) {
        this.coreService = coreService;
        this.getFieldValue = (questionConfig) => this.coreService.getFieldValue(questionConfig) ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxQuestionsViewModeComponent, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxQuestionsViewModeComponent, selector: "dspx-questions-view-mode", inputs: { pageConfig: "pageConfig", sectionConfig: "sectionConfig", sectionIndex: "sectionIndex", questionConfigs: "questionConfigs" }, ngImport: i0, template: "<ng-container *ngIf=\"pageConfig.props.getViewModeCustomHtml; then customViewModeTemplate; else defaultViewModeTemplate\"></ng-container>\r\n\r\n<ng-template #customViewModeTemplate>\r\n  <div [innerHtml]=\"pageConfig.props.getViewModeCustomHtml(pageConfig, sectionConfig, sectionIndex, questionConfigs)\" class=\"grid\"></div>\r\n</ng-template>\r\n\r\n<ng-template #defaultViewModeTemplate>\r\n  <div class=\"grid\">\r\n    <div *ngFor=\"let questionConfig of questionConfigs\" class=\"col-12 md:col-6 lg:col-4\">\r\n      <h5>{{questionConfig.props.label}}</h5>\r\n      <h6>{{getFieldValue(questionConfig)}}</h6>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxQuestionsViewModeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-questions-view-mode', encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"pageConfig.props.getViewModeCustomHtml; then customViewModeTemplate; else defaultViewModeTemplate\"></ng-container>\r\n\r\n<ng-template #customViewModeTemplate>\r\n  <div [innerHtml]=\"pageConfig.props.getViewModeCustomHtml(pageConfig, sectionConfig, sectionIndex, questionConfigs)\" class=\"grid\"></div>\r\n</ng-template>\r\n\r\n<ng-template #defaultViewModeTemplate>\r\n  <div class=\"grid\">\r\n    <div *ngFor=\"let questionConfig of questionConfigs\" class=\"col-12 md:col-6 lg:col-4\">\r\n      <h5>{{questionConfig.props.label}}</h5>\r\n      <h6>{{getFieldValue(questionConfig)}}</h6>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }], propDecorators: { pageConfig: [{
                type: Input
            }], sectionConfig: [{
                type: Input
            }], sectionIndex: [{
                type: Input
            }], questionConfigs: [{
                type: Input
            }] } });

class DspxSectionViewModeComponent {
    constructor(formNavigationService) {
        this.formNavigationService = formNavigationService;
        this.isSectionType = (typeName) => this.formNavigationService.isSectionType(typeName);
        this.isRepeatingSectionType = (typeName) => this.formNavigationService.isRepeatingSectionType(typeName);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSectionViewModeComponent, deps: [{ token: FormNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxSectionViewModeComponent, selector: "dspx-section-view-mode", inputs: { pageConfig: "pageConfig", sectionConfig: "sectionConfig" }, ngImport: i0, template: "<ng-container *ngIf=\"pageConfig.props.isSectionIncludedInViewMode && pageConfig.props.isSectionIncludedInViewMode(pageConfig, sectionConfig)\">\r\n\r\n  <ng-container *ngIf=\"isRepeatingSectionType(sectionConfig.type); then repeatingSectionViewTemplate; else nonRepeatingSectionViewTemplate\"></ng-container>\r\n\r\n  <ng-template #repeatingSectionViewTemplate>\r\n    <dspx-heading [level]=\"sectionConfig.props.headingLevel\" [heading]=\"sectionConfig.props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"sectionConfig.props.description\"></dspx-description>\r\n    <div class=\"repeating-section mt-3 mb-6\" *ngFor=\"let sectionItemConfig of sectionConfig.fieldGroup; let sectionIndex = index\">\r\n      <p-panel>\r\n        <ng-template pTemplate=\"content\">\r\n          <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"sectionIndex\" [questionConfigs]=\"sectionItemConfig.fieldGroup\"></dspx-questions-view-mode>\r\n        </ng-template>\r\n      </p-panel>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #nonRepeatingSectionViewTemplate>\r\n    <div class=\"section\">\r\n      <dspx-heading [level]=\"sectionConfig.props.headingLevel\" [heading]=\"sectionConfig.props.label\"></dspx-heading>\r\n      <dspx-description [text]=\"sectionConfig.props.description\"></dspx-description>\r\n      <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"null\" [questionConfigs]=\"sectionConfig.fieldGroup\"></dspx-questions-view-mode>\r\n    </div>\r\n  </ng-template>\r\n\r\n</ng-container>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: DspxQuestionsViewModeComponent, selector: "dspx-questions-view-mode", inputs: ["pageConfig", "sectionConfig", "sectionIndex", "questionConfigs"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSectionViewModeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section-view-mode', encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"pageConfig.props.isSectionIncludedInViewMode && pageConfig.props.isSectionIncludedInViewMode(pageConfig, sectionConfig)\">\r\n\r\n  <ng-container *ngIf=\"isRepeatingSectionType(sectionConfig.type); then repeatingSectionViewTemplate; else nonRepeatingSectionViewTemplate\"></ng-container>\r\n\r\n  <ng-template #repeatingSectionViewTemplate>\r\n    <dspx-heading [level]=\"sectionConfig.props.headingLevel\" [heading]=\"sectionConfig.props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"sectionConfig.props.description\"></dspx-description>\r\n    <div class=\"repeating-section mt-3 mb-6\" *ngFor=\"let sectionItemConfig of sectionConfig.fieldGroup; let sectionIndex = index\">\r\n      <p-panel>\r\n        <ng-template pTemplate=\"content\">\r\n          <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"sectionIndex\" [questionConfigs]=\"sectionItemConfig.fieldGroup\"></dspx-questions-view-mode>\r\n        </ng-template>\r\n      </p-panel>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #nonRepeatingSectionViewTemplate>\r\n    <div class=\"section\">\r\n      <dspx-heading [level]=\"sectionConfig.props.headingLevel\" [heading]=\"sectionConfig.props.label\"></dspx-heading>\r\n      <dspx-description [text]=\"sectionConfig.props.description\"></dspx-description>\r\n      <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"null\" [questionConfigs]=\"sectionConfig.fieldGroup\"></dspx-questions-view-mode>\r\n    </div>\r\n  </ng-template>\r\n\r\n</ng-container>\r\n" }]
        }], ctorParameters: () => [{ type: FormNavigationService }], propDecorators: { pageConfig: [{
                type: Input
            }], sectionConfig: [{
                type: Input
            }] } });

class DspxCardSectionViewModeComponent extends DspxSectionViewModeComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSectionViewModeComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSectionViewModeComponent, selector: "dspx-card-section-view-mode", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"pageConfig.props.isSectionIncludedInViewMode && pageConfig.props.isSectionIncludedInViewMode(pageConfig, sectionConfig)\">\r\n  <ng-container [ngSwitch]=\"sectionConfig.props.cardSetLayoutOptions?.layoutType || 'card'\">\r\n    \r\n    <ng-container *ngSwitchCase=\"'card'\">\r\n      <p-card [header]=\"sectionConfig.props.label\" [subheader]=\"sectionConfig.props.description\">\r\n        <ng-template pTemplate=\"content\">\r\n          <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n        </ng-template>\r\n      </p-card>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"'plain'\">\r\n      <dspx-heading [level]=\"sectionConfig.props.headingLevel\" [heading]=\"sectionConfig.props.label\"></dspx-heading>\r\n      <dspx-description [text]=\"sectionConfig.props.description\"></dspx-description>\r\n      <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n    </ng-container>\r\n\r\n    <ng-template #layoutTypeContent>\r\n\r\n      <ng-container *ngIf=\"isRepeatingSectionType(sectionConfig.type); then repeatingSectionViewTemplate; else nonRepeatingSectionViewTemplate\"></ng-container>\r\n          \r\n      <ng-template #repeatingSectionViewTemplate>\r\n        <ng-container *ngFor=\"let sectionItemConfig of sectionConfig.fieldGroup; let sectionIndex = index\">\r\n          <div class=\"repeating-section mt-3 mb-6\">\r\n            <p-panel>\r\n              <ng-template pTemplate=\"content\">\r\n                <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"sectionIndex\" [questionConfigs]=\"sectionItemConfig.fieldGroup\"></dspx-questions-view-mode>\r\n              </ng-template>\r\n            </p-panel>\r\n          </div>\r\n        </ng-container>\r\n      </ng-template>\r\n\r\n      <ng-template #nonRepeatingSectionViewTemplate>\r\n        <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"null\" [questionConfigs]=\"sectionConfig.fieldGroup\"></dspx-questions-view-mode>\r\n      </ng-template>\r\n\r\n    </ng-template>\r\n\r\n  </ng-container>\r\n</ng-container>\r\n\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }, { kind: "component", type: i4$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: DspxQuestionsViewModeComponent, selector: "dspx-questions-view-mode", inputs: ["pageConfig", "sectionConfig", "sectionIndex", "questionConfigs"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSectionViewModeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-section-view-mode', encapsulation: ViewEncapsulation.None, template: "<ng-container *ngIf=\"pageConfig.props.isSectionIncludedInViewMode && pageConfig.props.isSectionIncludedInViewMode(pageConfig, sectionConfig)\">\r\n  <ng-container [ngSwitch]=\"sectionConfig.props.cardSetLayoutOptions?.layoutType || 'card'\">\r\n    \r\n    <ng-container *ngSwitchCase=\"'card'\">\r\n      <p-card [header]=\"sectionConfig.props.label\" [subheader]=\"sectionConfig.props.description\">\r\n        <ng-template pTemplate=\"content\">\r\n          <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n        </ng-template>\r\n      </p-card>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"'plain'\">\r\n      <dspx-heading [level]=\"sectionConfig.props.headingLevel\" [heading]=\"sectionConfig.props.label\"></dspx-heading>\r\n      <dspx-description [text]=\"sectionConfig.props.description\"></dspx-description>\r\n      <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n    </ng-container>\r\n\r\n    <ng-template #layoutTypeContent>\r\n\r\n      <ng-container *ngIf=\"isRepeatingSectionType(sectionConfig.type); then repeatingSectionViewTemplate; else nonRepeatingSectionViewTemplate\"></ng-container>\r\n          \r\n      <ng-template #repeatingSectionViewTemplate>\r\n        <ng-container *ngFor=\"let sectionItemConfig of sectionConfig.fieldGroup; let sectionIndex = index\">\r\n          <div class=\"repeating-section mt-3 mb-6\">\r\n            <p-panel>\r\n              <ng-template pTemplate=\"content\">\r\n                <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"sectionIndex\" [questionConfigs]=\"sectionItemConfig.fieldGroup\"></dspx-questions-view-mode>\r\n              </ng-template>\r\n            </p-panel>\r\n          </div>\r\n        </ng-container>\r\n      </ng-template>\r\n\r\n      <ng-template #nonRepeatingSectionViewTemplate>\r\n        <dspx-questions-view-mode [pageConfig]=\"pageConfig\" [sectionConfig]=\"sectionConfig\" [sectionIndex]=\"null\" [questionConfigs]=\"sectionConfig.fieldGroup\"></dspx-questions-view-mode>\r\n      </ng-template>\r\n\r\n    </ng-template>\r\n\r\n  </ng-container>\r\n</ng-container>\r\n\r\n" }]
        }] });

class DspxCardSetBaseFormComponent extends DspxBaseFormCommonComponent {
    constructor(formConfigurationService, coreService, spinnerService) {
        super(formConfigurationService);
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.spinnerService = spinnerService;
    }
    ngOnInit() {
        this.coreService.applicationFunctions['buttonClicked'] =
            (field, event) => {
                this.onButtonClick.emit({ isFormValid: this.form.valid, type: field, event, data: this.getModelAsString() });
            };
        this.coreService.applicationFunctions['actionButtonClicked'] =
            (field, event) => {
                this.onActionButtonClick.emit({ field, event, model: this.getModelAsString() });
            };
        this.coreService.applicationFunctions['filterData'] =
            (field, event) => {
                const filters = field.parent.fieldGroup
                    .filter(f => f.type && (f.type === FieldTypes.SEARCH || f.type === FieldTypes.SELECT))
                    .map(f => ({ name: f.key.toString(), value: f.formControl.value }));
                this.onFilter.emit({ action: event?.action, field, filters });
            };
        this.coreService.applicationFunctions['save'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(false, false));
            };
        this.coreService.applicationFunctions['submit'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(true, true));
            };
        this.coreService.applicationFunctions['saveandclose'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(false, true));
            };
        this.coreService.applicationFunctions['cancel'] =
            () => {
                this.onCancel.emit();
            };
        this.coreService.setActiveFormName(this.formName);
        if (!this.fields) {
            const request = {
                apiEndpointKey: this.formServiceEndpoint,
                templateId: this.templateId,
                versionNo: this.versionNo,
                entityId: this.entityId
            };
            if (request.entityId === undefined || request.entityId === null || request.entityId === ''
                || this.fetchOnlyConfig) {
                this.formConfigurationService
                    .getFormConfig(request, this.mockGetConfigApiCallSettings, this.configCacheTimeoutInSeconds)
                    .pipe(take$1(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = this.convertToCardSetFieldTypes([data.configData.config]);
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response ?? {};
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, null, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = Guid.create().toString();
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
            else {
                this.formConfigurationService
                    .getFormConfigAndResponse(request, this.mockGetConfigApiCallSettings)
                    .pipe(take$1(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = this.convertToCardSetFieldTypes([data.configData.config]);
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response ?? {};
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, null, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = data.formIdentifier;
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetBaseFormComponent, deps: [{ token: FormConfigurationService }, { token: CoreService }, { token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetBaseFormComponent, selector: "dspx-card-set-base-form", usesInheritance: true, ngImport: i0, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n    <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: DspxDialogComponent, selector: "dspx-dialog", outputs: ["onSubmit"] }, { kind: "component", type: DspxSpinnerComponent, selector: "dspx-spinner" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetBaseFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-base-form', encapsulation: ViewEncapsulation.None, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n    <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: CoreService }, { type: SpinnerService }] });

class DspxCardSetBaseFormReadOnlyComponent extends DspxBaseFormCommonComponent {
    constructor(formConfigurationService, coreService, spinnerService) {
        super(formConfigurationService);
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.spinnerService = spinnerService;
    }
    ngOnInit() {
        this.coreService.applicationFunctions['buttonClicked'] =
            (field, event) => {
                this.onButtonClick.emit({ isFormValid: this.form.valid, type: field, event, data: this.getModelAsString() });
            };
        this.coreService.applicationFunctions['actionButtonClicked'] =
            (field, event) => {
                this.onActionButtonClick.emit({ field, event, model: this.getModelAsString() });
            };
        this.coreService.applicationFunctions['filterData'] =
            (field, event) => {
                const filters = field.parent.fieldGroup
                    .filter(f => f.type && (f.type === FieldTypes.SEARCH || f.type === FieldTypes.SELECT))
                    .map(f => ({ name: f.key.toString(), value: f.formControl.value }));
                this.onFilter.emit({ action: event?.action, field, filters });
            };
        this.coreService.applicationFunctions['save'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(false, false));
            };
        this.coreService.applicationFunctions['submit'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(true, true));
            };
        this.coreService.applicationFunctions['saveandclose'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(false, true));
            };
        this.coreService.applicationFunctions['cancel'] =
            () => {
                this.onCancel.emit();
            };
        this.coreService.setActiveFormName(this.formName);
        if (!this.fields) {
            const request = {
                apiEndpointKey: this.formServiceEndpoint,
                templateId: this.templateId,
                versionNo: this.versionNo,
                entityId: this.entityId
            };
            if (request.entityId === undefined || request.entityId === null || request.entityId === ''
                || this.fetchOnlyConfig) {
                this.formConfigurationService
                    .getFormConfig(request, this.mockGetConfigApiCallSettings, this.configCacheTimeoutInSeconds)
                    .pipe(take$1(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = this.convertToCardSetFieldTypes([data.configData.config]);
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response ?? {};
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, null, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = Guid.create().toString();
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
            else {
                this.formConfigurationService
                    .getFormConfigAndResponse(request, this.mockGetConfigApiCallSettings)
                    .pipe(take$1(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = this.convertToCardSetFieldTypes([data.configData.config]);
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response ?? {};
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, null, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = data.formIdentifier;
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetBaseFormReadOnlyComponent, deps: [{ token: FormConfigurationService }, { token: CoreService }, { token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetBaseFormReadOnlyComponent, selector: "dspx-card-set-base-form-read-only", usesInheritance: true, ngImport: i0, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n    <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: DspxDialogComponent, selector: "dspx-dialog", outputs: ["onSubmit"] }, { kind: "component", type: DspxSpinnerComponent, selector: "dspx-spinner" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetBaseFormReadOnlyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-base-form-read-only', encapsulation: ViewEncapsulation.None, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n    <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: CoreService }, { type: SpinnerService }] });

class DspxCardSetFooterComponent {
    constructor(styleConfigService) {
        this.styleConfigService = styleConfigService;
        this.year = (new Date()).getFullYear().toString();
    }
    ngOnInit() {
    }
    getFooterLinkColumnHeaderHtml(cardSetFooterLinkGroup) {
        //This maintains backwards compatibility
        if (this.config?.footerLinkColumnsHeadingLevel === undefined) {
            return `<div class="link-group-heading">${cardSetFooterLinkGroup.heading}</div>`;
        }
        return `<h${this.config.footerLinkColumnsHeadingLevel} class="link-group-heading"> ${cardSetFooterLinkGroup.heading} </h${this.config.footerLinkColumnsHeadingLevel}>`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetFooterComponent, deps: [{ token: StyleConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetFooterComponent, selector: "dspx-card-set-footer", inputs: { config: "config" }, ngImport: i0, template: "<footer>\r\n  <div class=\"layout-footer\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid nested-grid\">\r\n        <!-- Footer link columns -->\r\n        <ng-container *ngFor=\"let column of config?.footerLinkColumns; index as i\">\r\n          <div *ngIf=\"i < 2\" class=\"col-12 sm:col-6 md:col-6 lg:col-4\">\r\n            <div [innerHTML]=\"getFooterLinkColumnHeaderHtml(column)\"></div>\r\n            <ul class=\"footer-link-column\">\r\n              <li *ngFor=\"let link of column.links; index as j\">\r\n                <a href=\"{{ link.url }}\" [title]=\"link.altText !== link.label ? link.altText : undefined\" target=\"_blank\" class=\"footer-link\">{{ link.label }}</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <!-- Government logo column-->\r\n        <div class=\"col government-logo\">\r\n          <span class=\"footer-text-left\">\r\n            <img *ngIf=\"config?.showAppLogo\" [alt]=\"config?.governmentName + ' logo'\" [src]=\"styleConfigService.layoutColor === 'light' ? config?.lightModeAppLogo : config?.darkModeAppLogo\" />\r\n            <img *ngIf=\"styleConfigService.layoutColor === 'light' ? config?.lightModeLogo : config?.darkModeLogo\" [alt]=\"config?.departmentName + ' logo'\" [src]=\"styleConfigService.layoutColor === 'light' ? config?.lightModeLogo : config?.darkModeLogo\" />\r\n          </span>\r\n          <span class=\"footer-text-left\">\r\n            {{config?.departmentName}}\r\n          </span>\r\n          <span class=\"footer-text-left\">\r\n            {{config?.governmentName}}\r\n          </span>\r\n          <span class=\"footer-text-left\">\r\n            &copy; {{year}}\r\n          </span>\r\n        </div>\r\n\r\n        <div class=\"col-12\">\r\n          <div class=\"grid grid-nogutter\">\r\n            <div class=\"col-12\">\r\n              <ul class=\"footer-flags\">\r\n                <li><img class=\"footer-flag\" [src]=\"config?.atsiLogo\" alt=\"Aboriginal and Torres Strait Islander Flag\" /></li>\r\n                <li><img class=\"footer-flag\" [src]=\"config?.prideLogo\" alt=\"Intersex Inclusive Progress Pride Flag\" /></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"col-12\">\r\n              <span class=\"footer-text-left\">\r\n                {{config?.atsiDeclaration}}\r\n              </span>\r\n              <span class=\"footer-text-left\">\r\n                {{config?.prideDeclaration}}\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-footer', encapsulation: ViewEncapsulation.None, template: "<footer>\r\n  <div class=\"layout-footer\">\r\n    <div class=\"p-fluid\">\r\n      <div class=\"grid nested-grid\">\r\n        <!-- Footer link columns -->\r\n        <ng-container *ngFor=\"let column of config?.footerLinkColumns; index as i\">\r\n          <div *ngIf=\"i < 2\" class=\"col-12 sm:col-6 md:col-6 lg:col-4\">\r\n            <div [innerHTML]=\"getFooterLinkColumnHeaderHtml(column)\"></div>\r\n            <ul class=\"footer-link-column\">\r\n              <li *ngFor=\"let link of column.links; index as j\">\r\n                <a href=\"{{ link.url }}\" [title]=\"link.altText !== link.label ? link.altText : undefined\" target=\"_blank\" class=\"footer-link\">{{ link.label }}</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <!-- Government logo column-->\r\n        <div class=\"col government-logo\">\r\n          <span class=\"footer-text-left\">\r\n            <img *ngIf=\"config?.showAppLogo\" [alt]=\"config?.governmentName + ' logo'\" [src]=\"styleConfigService.layoutColor === 'light' ? config?.lightModeAppLogo : config?.darkModeAppLogo\" />\r\n            <img *ngIf=\"styleConfigService.layoutColor === 'light' ? config?.lightModeLogo : config?.darkModeLogo\" [alt]=\"config?.departmentName + ' logo'\" [src]=\"styleConfigService.layoutColor === 'light' ? config?.lightModeLogo : config?.darkModeLogo\" />\r\n          </span>\r\n          <span class=\"footer-text-left\">\r\n            {{config?.departmentName}}\r\n          </span>\r\n          <span class=\"footer-text-left\">\r\n            {{config?.governmentName}}\r\n          </span>\r\n          <span class=\"footer-text-left\">\r\n            &copy; {{year}}\r\n          </span>\r\n        </div>\r\n\r\n        <div class=\"col-12\">\r\n          <div class=\"grid grid-nogutter\">\r\n            <div class=\"col-12\">\r\n              <ul class=\"footer-flags\">\r\n                <li><img class=\"footer-flag\" [src]=\"config?.atsiLogo\" alt=\"Aboriginal and Torres Strait Islander Flag\" /></li>\r\n                <li><img class=\"footer-flag\" [src]=\"config?.prideLogo\" alt=\"Intersex Inclusive Progress Pride Flag\" /></li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"col-12\">\r\n              <span class=\"footer-text-left\">\r\n                {{config?.atsiDeclaration}}\r\n              </span>\r\n              <span class=\"footer-text-left\">\r\n                {{config?.prideDeclaration}}\r\n              </span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>" }]
        }], ctorParameters: () => [{ type: StyleConfigService }], propDecorators: { config: [{
                type: Input
            }] } });

class DspxCardSetHeaderComponent {
    constructor(coreService, formNavigationService, menuConfigService) {
        this.coreService = coreService;
        this.formNavigationService = formNavigationService;
        this.menuConfigService = menuConfigService;
        this.menuOpen = true;
    }
    ngOnInit() {
        this.coreService.setApplicationTitle(`${this.config?.applicationTitle?.label ?? 'Department of Health'} - ${this.config?.applicationSubTitle?.label ?? 'Digital Platform'}`);
        this.formNavigationService.setActivePageTitle();
    }
    onMenuButtonClick($event) {
        this.menuConfigService.onMenuButtonClick($event);
        this.menuOpen = !this.menuOpen;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetHeaderComponent, deps: [{ token: CoreService }, { token: FormNavigationService }, { token: MenuConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetHeaderComponent, selector: "dspx-card-set-header", inputs: { config: "config", selectedContext: "selectedContext" }, ngImport: i0, template: "<header>\r\n\r\n  <div class=\"topbar clearfix\"> \r\n\r\n    <div class=\"topbar-skipnav\">\r\n      <a href=\"javascript:void(0)\" onclick=\"document.getElementById('main_content').focus();\" aria-label=\"Skip to main content\" role=\"button\">Skip to main content</a>\r\n    </div>\r\n\r\n    <div class=\"topbar-left\">\r\n      <a id=\"topbar-left-menu-button\" href=\"#\" (click)=\"onMenuButtonClick($event)\" title=\"Menu button\" role=\"button\" aria-label=\"Menu\" [attr.aria-expanded]=\"menuOpen\">\r\n        <i class=\"pi pi-bars\" aria-hidden=\"true\"></i>\r\n      </a>\r\n\r\n      <div class=\"topbar-logo-container\" *ngIf=\"config?.applicationLogo?.source\">\r\n        <a *ngIf=\"config?.applicationLogo?.link?.url\" [attr.href]=\"config?.applicationLogo?.link?.url\"\r\n          [attr.target]=\"config?.applicationLogo?.link?.target\"\r\n          [attr.title]=\"config?.applicationTitle?.label\"\r\n          [attr.aria-label]=\"config?.applicationTitle?.label\">\r\n          <img class=\"topbar-logo\" [attr.src]=\"config?.applicationLogo?.source\" [attr.alt]=\"config?.applicationLogo?.link?.label\" />\r\n        </a>\r\n        <img *ngIf=\"!config?.applicationLogo?.link?.url\" class=\"topbar-logo\" [attr.src]=\"config?.applicationLogo?.source\" [attr.alt]=\"config?.applicationLogo?.link?.label\" />\r\n      </div>\r\n\r\n      <a [attr.href]=\"config?.applicationTitle?.url\" [attr.target]=\"config?.applicationTitle?.target\"\r\n         [tabIndex]=\"config?.applicationTitle?.url ? 0 : -1\"\r\n         [attr.aria-hidden]=\"config?.applicationTitle?.url ? null : true\"\r\n         class=\"topbar-title\"\r\n         [ngClass]=\"{\r\n            'topbar-title-large': config?.applicationSubTitle?.label == null || config?.applicationSubTitle?.label === '',\r\n            'no-app-logo': config?.applicationLogo?.source == null\r\n          }\">\r\n        {{config?.applicationTitle?.label}}\r\n      </a>\r\n\r\n      <a [attr.href]=\"config?.applicationSubTitle?.url\" [attr.target]=\"config?.applicationSubTitle?.target\"\r\n         [tabIndex]=\"config?.applicationSubTitle?.url ? 0 : -1\"\r\n         [attr.aria-hidden]=\"config?.applicationSubTitle?.url ? null : true\"\r\n         class=\"topbar-subtitle\"\r\n         [ngClass]=\"{'no-app-logo': config?.applicationLogo?.source == null}\">\r\n        {{config?.applicationSubTitle?.label}}\r\n      </a>\r\n\r\n      <div class=\"topbar-miscellaneous-logo-container\" *ngIf=\"config?.miscellaneousLogo?.source\">\r\n        <a [attr.href]=\"config?.miscellaneousLogo?.link?.url\"\r\n           [attr.target]=\"config?.miscellaneousLogo?.link?.target\"\r\n           [attr.title]=\"config?.miscellaneousLogo?.link.label\"\r\n           [attr.aria-label]=\"config?.miscellaneousLogo?.link.label\">\r\n            <img class=\"government-logo\" [attr.src]=\"config?.miscellaneousLogo?.source\" [attr.alt]=\"config?.miscellaneousLogo?.link?.label\"/>\r\n        </a>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"topbar-right\">\r\n\r\n      <a id=\"topbar-menu-button\" href=\"#\" (click)=\"menuConfigService.onTopbarMenuButtonClick($event)\"\r\n         role=\"button\" [attr.aria-expanded]=\"menuConfigService.activeTopbarItem?.id === 'topbar-item-profile'\">\r\n        <img *ngIf=\"config?.loggedInUser?.imageSource && config?.loggedInUser?.imageDescription\"\r\n          class=\"profile-image\"\r\n          [attr.src]=\"config?.loggedInUser?.imageSource\"\r\n          [attr.alt]=\"config?.loggedInUser?.imageDescription\" />\r\n        <div class=\"profile-name-role\">\r\n          <span class=\"topbar-item-name\" [ngClass]=\"{'topbar-item-name-large': config?.loggedInUser?.role == null\r\n                                                                            || config?.loggedInUser?.role === ''}\">\r\n            {{config?.loggedInUser?.name}}\r\n          </span>\r\n          <span class=\"topbar-item-role\">{{config?.loggedInUser?.role}}</span>\r\n        </div>\r\n      </a>\r\n\r\n      <ul class=\"topbar-items fadeInDown\" [ngClass]=\"{'topbar-items-visible': menuConfigService.topbarMenuActive}\">\r\n\r\n        <li #profile\r\n          *ngIf=\"config?.loggedInUser\"\r\n          class=\"profile-item\"\r\n          id=\"topbar-item-profile\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === profile && menuConfigService.activeTopbarItemIndex === 0}\">\r\n\r\n          <a href=\"#\" (click)=\"menuConfigService.onTopbarItemClick($event, profile, 0, config?.loggedInUser?.onClickCustomCallback)\">\r\n            <img *ngIf=\"config?.loggedInUser?.imageSource && config?.loggedInUser?.imageDescription\"\r\n              class=\"profile-image\"\r\n              [attr.src]=\"config?.loggedInUser?.imageSource\"\r\n              [attr.alt]=\"config?.loggedInUser?.imageDescription\" />\r\n            <div>\r\n              <span class=\"topbar-item-name\"\r\n                [ngClass]=\"{'topbar-item-name-large topbar-item-name-only': config?.loggedInUser?.role == null\r\n                                                                             || config?.loggedInUser?.role === ''}\">\r\n                {{config?.loggedInUser?.name}}\r\n              </span>\r\n              <span class=\"topbar-item-role\">{{config?.loggedInUser?.role}}</span>\r\n            </div>\r\n          </a>\r\n\r\n          <ul *ngIf=\"config?.loggedInUser?.menuSubItems?.length\" class=\"layout-menu\" [ngClass]=\"{'fadeInDown': !menuConfigService.isMobile()}\">\r\n            <li *ngFor=\"let subItem of config?.loggedInUser?.menuSubItems\" role=\"menuitem\">\r\n              <a *ngIf=\"!subItem.routerLink\"\r\n                 [attr.href]=\"subItem.url\"\r\n                 [attr.target]=\"subItem.target\"\r\n                 (click)=\"menuConfigService.onClickStopPropagation($event, subItem.onClickCustomCallback)\">\r\n                <i *ngIf=\"subItem.icon\" [attr.class]=\"subItem.icon\"></i>\r\n                <span *ngIf=\"subItem.badgeIcon || subItem.badgeLabel\" class=\"subItem.badgeIcon\">{{subItem.badgeLabel}}</span>\r\n                <span *ngIf=\"subItem.label\">{{subItem.label}}</span>\r\n              </a>\r\n              <a *ngIf=\"subItem.routerLink\"\r\n                 [routerLink]=\"subItem.routerLink\"\r\n                 [attr.href]=\"subItem.url\"\r\n                 [attr.target]=\"subItem.target\"\r\n                 (click)=\"menuConfigService.onTopbarSubItemClick($event, subItem.onClickCustomCallback)\">\r\n                <i *ngIf=\"subItem.icon\" [attr.class]=\"subItem.icon\"></i>\r\n                <span *ngIf=\"subItem.badgeIcon || subItem.badgeLabel\" class=\"subItem.badgeIcon\">{{subItem.badgeLabel}}</span>\r\n                <span *ngIf=\"subItem.label\">{{subItem.label}}</span>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n\r\n        </li>\r\n\r\n        <li #custom\r\n          *ngFor=\"let item of config?.customMenus; let itemIndex = index\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === custom && menuConfigService.activeTopbarItemIndex === itemIndex}\">\r\n\r\n          <a href=\"#\" (click)=\"menuConfigService.onTopbarItemClick($event, custom, itemIndex, item.onClickCustomCallback)\">\r\n            <i [attr.class]=\"item.icon\"></i>\r\n            <span *ngIf=\"item.badgeIcon || item.badgeLabel\" [attr.class]=\"item.badgeIcon\">{{item.badgeLabel}}</span>\r\n            <span class=\"topbar-item-name\">{{item.label}}</span>\r\n          </a>\r\n\r\n          <ul *ngIf=\"item?.subItems?.length\" class=\"layout-menu\" [ngClass]=\"{'fadeInDown': !menuConfigService.isMobile()}\">\r\n            <li *ngFor=\"let subItem of item?.subItems\" role=\"menuitem\">\r\n              <a [routerLink]=\"subItem.routerLink\"\r\n                [attr.href]=\"subItem.url\"\r\n                [attr.target]=\"subItem.target\"\r\n                (click)=\"menuConfigService.onTopbarSubItemClick($event, subItem.onClickCustomCallback)\">\r\n                <i *ngIf=\"subItem.icon\" [attr.class]=\"subItem.icon\"></i>\r\n                <span *ngIf=\"subItem.label\">{{subItem.label}}</span>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n\r\n        </li>\r\n\r\n        <li #contextDropdown\r\n          *ngIf=\"config?.contextDropdown\"\r\n          class=\"context-item\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === contextDropdown && menuConfigService.activeTopbarItemIndex === 0}\">\r\n          <div class=\"topbar-context\">\r\n            <p-dropdown [options]=\"config.contextDropdown.options\" [(ngModel)]=\"selectedContext\"\r\n              [placeholder]=\"config.contextDropdown?.placeholder\" [tooltip]=\"config.contextDropdown?.placeholder\"\r\n              [ariaLabel]=\"config.contextDropdown?.placeholder\"\r\n              (onChange)=\"config.contextDropdown?.onChangeContextDropdownCallback($event)\"\r\n              (click)=\"$event.stopPropagation()\"\r\n              (onClick)=\"config.contextDropdown?.onClickContextDropdownCallback($event)\"\r\n              optionLabel=\"text\" optionValue=\"code\">\r\n            </p-dropdown>\r\n          </div>\r\n        </li>\r\n\r\n        <li #search\r\n          *ngIf=\"config?.search\"\r\n          class=\"search-item\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === search && menuConfigService.activeTopbarItemIndex === 0}\"\r\n          (click)=\"menuConfigService.onTopbarItemClick($event, search, 0, config?.search?.onClickCustomCallback)\">\r\n          <div class=\"topbar-search\">\r\n            <input type=\"text\" placeholder=\"Search\" aria-label=\"Search\" (change)=\"config?.search?.onChangeCustomCallback($event)\" />\r\n            <i class=\"pi pi-search\"></i>\r\n          </div>\r\n        </li>\r\n\r\n      </ul>\r\n\r\n    </div>\r\n\r\n  </div>\r\n\r\n</header>\r\n\r\n<div id=\"main_content\" tabindex=\"-2\"></div>\r\n", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "component", type: i3.Dropdown, selector: "p-dropdown", inputs: ["id", "scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "loadingIcon", "filterPlaceholder", "filterLocale", "variant", "inputId", "dataKey", "filterBy", "filterFields", "autofocus", "resetFilterOnHide", "checkmark", "dropdownIcon", "loading", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "ariaLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "focusOnHover", "selectOnFocus", "autoOptionFocus", "autofocusFilter", "autoShowPanelOnPrintableCharacterKeyDown", "disabled", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "filterValue", "options"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear", "onLazyLoad"] }, { kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-header', encapsulation: ViewEncapsulation.None, template: "<header>\r\n\r\n  <div class=\"topbar clearfix\"> \r\n\r\n    <div class=\"topbar-skipnav\">\r\n      <a href=\"javascript:void(0)\" onclick=\"document.getElementById('main_content').focus();\" aria-label=\"Skip to main content\" role=\"button\">Skip to main content</a>\r\n    </div>\r\n\r\n    <div class=\"topbar-left\">\r\n      <a id=\"topbar-left-menu-button\" href=\"#\" (click)=\"onMenuButtonClick($event)\" title=\"Menu button\" role=\"button\" aria-label=\"Menu\" [attr.aria-expanded]=\"menuOpen\">\r\n        <i class=\"pi pi-bars\" aria-hidden=\"true\"></i>\r\n      </a>\r\n\r\n      <div class=\"topbar-logo-container\" *ngIf=\"config?.applicationLogo?.source\">\r\n        <a *ngIf=\"config?.applicationLogo?.link?.url\" [attr.href]=\"config?.applicationLogo?.link?.url\"\r\n          [attr.target]=\"config?.applicationLogo?.link?.target\"\r\n          [attr.title]=\"config?.applicationTitle?.label\"\r\n          [attr.aria-label]=\"config?.applicationTitle?.label\">\r\n          <img class=\"topbar-logo\" [attr.src]=\"config?.applicationLogo?.source\" [attr.alt]=\"config?.applicationLogo?.link?.label\" />\r\n        </a>\r\n        <img *ngIf=\"!config?.applicationLogo?.link?.url\" class=\"topbar-logo\" [attr.src]=\"config?.applicationLogo?.source\" [attr.alt]=\"config?.applicationLogo?.link?.label\" />\r\n      </div>\r\n\r\n      <a [attr.href]=\"config?.applicationTitle?.url\" [attr.target]=\"config?.applicationTitle?.target\"\r\n         [tabIndex]=\"config?.applicationTitle?.url ? 0 : -1\"\r\n         [attr.aria-hidden]=\"config?.applicationTitle?.url ? null : true\"\r\n         class=\"topbar-title\"\r\n         [ngClass]=\"{\r\n            'topbar-title-large': config?.applicationSubTitle?.label == null || config?.applicationSubTitle?.label === '',\r\n            'no-app-logo': config?.applicationLogo?.source == null\r\n          }\">\r\n        {{config?.applicationTitle?.label}}\r\n      </a>\r\n\r\n      <a [attr.href]=\"config?.applicationSubTitle?.url\" [attr.target]=\"config?.applicationSubTitle?.target\"\r\n         [tabIndex]=\"config?.applicationSubTitle?.url ? 0 : -1\"\r\n         [attr.aria-hidden]=\"config?.applicationSubTitle?.url ? null : true\"\r\n         class=\"topbar-subtitle\"\r\n         [ngClass]=\"{'no-app-logo': config?.applicationLogo?.source == null}\">\r\n        {{config?.applicationSubTitle?.label}}\r\n      </a>\r\n\r\n      <div class=\"topbar-miscellaneous-logo-container\" *ngIf=\"config?.miscellaneousLogo?.source\">\r\n        <a [attr.href]=\"config?.miscellaneousLogo?.link?.url\"\r\n           [attr.target]=\"config?.miscellaneousLogo?.link?.target\"\r\n           [attr.title]=\"config?.miscellaneousLogo?.link.label\"\r\n           [attr.aria-label]=\"config?.miscellaneousLogo?.link.label\">\r\n            <img class=\"government-logo\" [attr.src]=\"config?.miscellaneousLogo?.source\" [attr.alt]=\"config?.miscellaneousLogo?.link?.label\"/>\r\n        </a>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"topbar-right\">\r\n\r\n      <a id=\"topbar-menu-button\" href=\"#\" (click)=\"menuConfigService.onTopbarMenuButtonClick($event)\"\r\n         role=\"button\" [attr.aria-expanded]=\"menuConfigService.activeTopbarItem?.id === 'topbar-item-profile'\">\r\n        <img *ngIf=\"config?.loggedInUser?.imageSource && config?.loggedInUser?.imageDescription\"\r\n          class=\"profile-image\"\r\n          [attr.src]=\"config?.loggedInUser?.imageSource\"\r\n          [attr.alt]=\"config?.loggedInUser?.imageDescription\" />\r\n        <div class=\"profile-name-role\">\r\n          <span class=\"topbar-item-name\" [ngClass]=\"{'topbar-item-name-large': config?.loggedInUser?.role == null\r\n                                                                            || config?.loggedInUser?.role === ''}\">\r\n            {{config?.loggedInUser?.name}}\r\n          </span>\r\n          <span class=\"topbar-item-role\">{{config?.loggedInUser?.role}}</span>\r\n        </div>\r\n      </a>\r\n\r\n      <ul class=\"topbar-items fadeInDown\" [ngClass]=\"{'topbar-items-visible': menuConfigService.topbarMenuActive}\">\r\n\r\n        <li #profile\r\n          *ngIf=\"config?.loggedInUser\"\r\n          class=\"profile-item\"\r\n          id=\"topbar-item-profile\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === profile && menuConfigService.activeTopbarItemIndex === 0}\">\r\n\r\n          <a href=\"#\" (click)=\"menuConfigService.onTopbarItemClick($event, profile, 0, config?.loggedInUser?.onClickCustomCallback)\">\r\n            <img *ngIf=\"config?.loggedInUser?.imageSource && config?.loggedInUser?.imageDescription\"\r\n              class=\"profile-image\"\r\n              [attr.src]=\"config?.loggedInUser?.imageSource\"\r\n              [attr.alt]=\"config?.loggedInUser?.imageDescription\" />\r\n            <div>\r\n              <span class=\"topbar-item-name\"\r\n                [ngClass]=\"{'topbar-item-name-large topbar-item-name-only': config?.loggedInUser?.role == null\r\n                                                                             || config?.loggedInUser?.role === ''}\">\r\n                {{config?.loggedInUser?.name}}\r\n              </span>\r\n              <span class=\"topbar-item-role\">{{config?.loggedInUser?.role}}</span>\r\n            </div>\r\n          </a>\r\n\r\n          <ul *ngIf=\"config?.loggedInUser?.menuSubItems?.length\" class=\"layout-menu\" [ngClass]=\"{'fadeInDown': !menuConfigService.isMobile()}\">\r\n            <li *ngFor=\"let subItem of config?.loggedInUser?.menuSubItems\" role=\"menuitem\">\r\n              <a *ngIf=\"!subItem.routerLink\"\r\n                 [attr.href]=\"subItem.url\"\r\n                 [attr.target]=\"subItem.target\"\r\n                 (click)=\"menuConfigService.onClickStopPropagation($event, subItem.onClickCustomCallback)\">\r\n                <i *ngIf=\"subItem.icon\" [attr.class]=\"subItem.icon\"></i>\r\n                <span *ngIf=\"subItem.badgeIcon || subItem.badgeLabel\" class=\"subItem.badgeIcon\">{{subItem.badgeLabel}}</span>\r\n                <span *ngIf=\"subItem.label\">{{subItem.label}}</span>\r\n              </a>\r\n              <a *ngIf=\"subItem.routerLink\"\r\n                 [routerLink]=\"subItem.routerLink\"\r\n                 [attr.href]=\"subItem.url\"\r\n                 [attr.target]=\"subItem.target\"\r\n                 (click)=\"menuConfigService.onTopbarSubItemClick($event, subItem.onClickCustomCallback)\">\r\n                <i *ngIf=\"subItem.icon\" [attr.class]=\"subItem.icon\"></i>\r\n                <span *ngIf=\"subItem.badgeIcon || subItem.badgeLabel\" class=\"subItem.badgeIcon\">{{subItem.badgeLabel}}</span>\r\n                <span *ngIf=\"subItem.label\">{{subItem.label}}</span>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n\r\n        </li>\r\n\r\n        <li #custom\r\n          *ngFor=\"let item of config?.customMenus; let itemIndex = index\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === custom && menuConfigService.activeTopbarItemIndex === itemIndex}\">\r\n\r\n          <a href=\"#\" (click)=\"menuConfigService.onTopbarItemClick($event, custom, itemIndex, item.onClickCustomCallback)\">\r\n            <i [attr.class]=\"item.icon\"></i>\r\n            <span *ngIf=\"item.badgeIcon || item.badgeLabel\" [attr.class]=\"item.badgeIcon\">{{item.badgeLabel}}</span>\r\n            <span class=\"topbar-item-name\">{{item.label}}</span>\r\n          </a>\r\n\r\n          <ul *ngIf=\"item?.subItems?.length\" class=\"layout-menu\" [ngClass]=\"{'fadeInDown': !menuConfigService.isMobile()}\">\r\n            <li *ngFor=\"let subItem of item?.subItems\" role=\"menuitem\">\r\n              <a [routerLink]=\"subItem.routerLink\"\r\n                [attr.href]=\"subItem.url\"\r\n                [attr.target]=\"subItem.target\"\r\n                (click)=\"menuConfigService.onTopbarSubItemClick($event, subItem.onClickCustomCallback)\">\r\n                <i *ngIf=\"subItem.icon\" [attr.class]=\"subItem.icon\"></i>\r\n                <span *ngIf=\"subItem.label\">{{subItem.label}}</span>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n\r\n        </li>\r\n\r\n        <li #contextDropdown\r\n          *ngIf=\"config?.contextDropdown\"\r\n          class=\"context-item\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === contextDropdown && menuConfigService.activeTopbarItemIndex === 0}\">\r\n          <div class=\"topbar-context\">\r\n            <p-dropdown [options]=\"config.contextDropdown.options\" [(ngModel)]=\"selectedContext\"\r\n              [placeholder]=\"config.contextDropdown?.placeholder\" [tooltip]=\"config.contextDropdown?.placeholder\"\r\n              [ariaLabel]=\"config.contextDropdown?.placeholder\"\r\n              (onChange)=\"config.contextDropdown?.onChangeContextDropdownCallback($event)\"\r\n              (click)=\"$event.stopPropagation()\"\r\n              (onClick)=\"config.contextDropdown?.onClickContextDropdownCallback($event)\"\r\n              optionLabel=\"text\" optionValue=\"code\">\r\n            </p-dropdown>\r\n          </div>\r\n        </li>\r\n\r\n        <li #search\r\n          *ngIf=\"config?.search\"\r\n          class=\"search-item\"\r\n          [ngClass]=\"{'active-top-menu': menuConfigService.activeTopbarItem === search && menuConfigService.activeTopbarItemIndex === 0}\"\r\n          (click)=\"menuConfigService.onTopbarItemClick($event, search, 0, config?.search?.onClickCustomCallback)\">\r\n          <div class=\"topbar-search\">\r\n            <input type=\"text\" placeholder=\"Search\" aria-label=\"Search\" (change)=\"config?.search?.onChangeCustomCallback($event)\" />\r\n            <i class=\"pi pi-search\"></i>\r\n          </div>\r\n        </li>\r\n\r\n      </ul>\r\n\r\n    </div>\r\n\r\n  </div>\r\n\r\n</header>\r\n\r\n<div id=\"main_content\" tabindex=\"-2\"></div>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }, { type: FormNavigationService }, { type: MenuConfigService }], propDecorators: { config: [{
                type: Input
            }], selectedContext: [{
                type: Input
            }] } });

class DspxCardSetMenuItemComponent {
    constructor(router, menuConfigService) {
        this.router = router;
        this.menuConfigService = menuConfigService;
        this.active = false;
        this.menuSourceSubscription = this.menuConfigService.menuService.menuSource$.subscribe(key => {
            // deactivate current active menu
            if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
                this.active = false;
            }
        });
        this.menuResetSubscription = this.menuConfigService.menuService.resetSource$.subscribe(() => {
            this.active = false;
        });
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(params => {
            if (this.menuConfigService.isHorizontal() || this.menuConfigService.isSlim()) {
                this.active = false;
            }
            else {
                if (this.item.routerLink) {
                    this.updateActiveStateFromRoute();
                }
                else {
                    this.active = false;
                }
            }
        });
    }
    ngOnInit() {
        if (!(this.menuConfigService.isHorizontal() || this.menuConfigService.isSlim()) && this.item.routerLink) {
            this.updateActiveStateFromRoute();
        }
        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
    }
    updateActiveStateFromRoute() {
        const commands = (typeof this.item.routerLink === 'string') ? [this.item.routerLink] : this.item.routerLink;
        const urlTree = this.router.createUrlTree(commands);
        const exact = this.item.items ? false : true;
        const active = this.router.isActive(urlTree, exact);
        this.active = active;
    }
    itemClick(event) {
        // avoid processing disabled items
        if (this.item.disabled) {
            event.preventDefault();
            return;
        }
        // If this is just a normal <a href=""> link, nothing more to do here. (This solves a problem: if we
        // do continue processing, then if the item is a link that opens in a new window (by specifying
        // target="_blank"), the window that remains behind gets its menu into an odd state where the
        // previously-active menu item remains highlighted, and the just-clicked menu item ALSO become
        // highlighted)
        if (this.item.url) {
            return;
        }
        // navigate with hover in horizontal mode
        if (this.root) {
            this.menuConfigService.menuHoverActive = !this.menuConfigService.menuHoverActive;
        }
        // notify other items
        this.menuConfigService.menuService.onMenuStateChange(this.key);
        // execute command
        this.item.command?.(event, this.item);
        // toggle active state
        if (this.item.items) {
            this.active = !this.active;
        }
        else {
            // activate item
            this.active = true;
            // hide overlay menus
            if (this.menuConfigService.isMobile()) {
                this.menuConfigService.overlayMenuActive = false;
                this.menuConfigService.staticMenuMobileActive = false;
                this.menuConfigService.rotateMenuButton = false;
            }
            // hide overlay menus
            if (this.menuConfigService.isOverlay()) {
                this.menuConfigService.overlayMenuActive = false;
            }
            // reset horizontal menu
            if (this.menuConfigService.isHorizontal() || this.menuConfigService.isSlim()) {
                this.menuConfigService.menuService.reset();
            }
            this.menuConfigService.menuHoverActive = false;
            const ink = this.getInk(event.currentTarget);
            if (ink) {
                this.removeClass(ink, 'p-ink-active');
            }
        }
    }
    get isMenuActive() {
        return this.menuConfigService.isMenuActive();
    }
    get itemTitle() {
        if (this.item.title?.length > 0 && this.item.label != this.item.title) {
            return this.item.title;
        }
        return '';
    }
    getInk(el) {
        for (let i = 0; i < el.children.length; i++) {
            if (typeof el.children[i].className === 'string' && el.children[i].className.indexOf('p-ink') !== -1) {
                return el.children[i];
            }
        }
        return null;
    }
    removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
    onMouseEnter() {
        // activate item on hover
        if (this.root && this.menuConfigService.menuHoverActive &&
            (this.menuConfigService.isHorizontal() || this.menuConfigService.isSlim()) && this.menuConfigService.isDesktop()) {
            this.menuConfigService.menuService.onMenuStateChange(this.key);
            this.active = true;
        }
    }
    ngOnDestroy() {
        if (this.menuSourceSubscription) {
            this.menuSourceSubscription.unsubscribe();
        }
        if (this.menuResetSubscription) {
            this.menuResetSubscription.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetMenuItemComponent, deps: [{ token: i1$4.Router }, { token: MenuConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetMenuItemComponent, selector: "[dspx-card-set-menu-item]", inputs: { item: "item", index: "index", root: "root", parentKey: "parentKey" }, host: { properties: { "class.layout-root-menuitem": "root", "class.active-menuitem": "active", "class.active-menuitem-notrouter": "active && !item.items" } }, ngImport: i0, template: "<ng-container>\r\n  <div *ngIf=\"root && item.visible !== false\" class=\"layout-menuitem-root-text\">{{item.label}}</div>\r\n  <a [attr.href]=\"item.url\" (click)=\"itemClick($event)\" *ngIf=\"(!item.routerLink || item.items) && item.visible !== false\" [title]=\"itemTitle\" (mouseenter)=\"onMouseEnter()\"\r\n     (keydown.enter)=\"itemClick($event)\" [attr.target]=\"item.target\" [ngClass]=\"item.class\" pRipple\r\n     [attr.tabindex]=\"isMenuActive ? 0 : -1\" [attr.aria-hidden]=\"isMenuActive ? null : true\">\r\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon\" class=\"layout-menuitem-icon\" [attr.aria-hidden]=\"!!item.label\"></i>\r\n      <span *ngIf=\"item.label\">{{item.label}}</span>\r\n      <i class=\"pi pi-fw pi-angle-down menuitem-toggle-icon\" *ngIf=\"item.items\"></i>\r\n      <span *ngIf=\"item.badge\" class=\"menuitem-badge\">{{item.badge}}</span>\r\n  </a>\r\n  <a (click)=\"itemClick($event)\" (mouseenter)=\"onMouseEnter()\" *ngIf=\"(item.routerLink && !item.items) && item.visible !== false\" [title]=\"itemTitle\"\r\n     [routerLink]=\"item.routerLink\" routerLinkActive=\"active-menuitem-routerlink\" [ngClass]=\"item.class\" pRipple\r\n     [routerLinkActiveOptions]=\"{exact: true}\" [attr.target]=\"item.target\" [attr.aria-current]=\"active ? 'page' : null\"\r\n     [attr.tabindex]=\"isMenuActive ? 0 : -1\" [attr.aria-hidden]=\"isMenuActive ? null : true\">\r\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon\" class=\"layout-menuitem-icon\" [attr.aria-hidden]=\"!!item.label\"></i>\r\n      <span *ngIf=\"item.label\">{{item.label}}</span>\r\n      <i class=\"pi pi-fw pi-angle-down menuitem-toggle-icon\" *ngIf=\"item.items\"></i>\r\n      <span *ngIf=\"item.badge\" class=\"menuitem-badge\">{{item.badge}}</span>\r\n  </a>\r\n  <div *ngIf=\"item.label\" class=\"layout-menu-tooltip\">\r\n      <div class=\"layout-menu-tooltip-arrow\"></div>\r\n      <div class=\"layout-menu-tooltip-text\">{{item.label}}</div>\r\n  </div>\r\n  <div class=\"submenu-arrow\" *ngIf=\"item.items && item.visible !== false\"></div>\r\n  <ul *ngIf=\"((item.items && root) || (item.items && active)) && item.visible !== false\"\r\n      [@children]=\"(root ? 'visible' :active ? 'visibleAnimated' : 'hiddenAnimated')\">\r\n      <ng-template ngFor let-child let-i=\"index\" [ngForOf]=\"item.items\">\r\n          <li dspx-card-set-menu-item [item]=\"child\" [index]=\"i\" [parentKey]=\"key\" [class]=\"child.badgeClass\"></li>\r\n      </ng-template>\r\n  </ul>\r\n</ng-container>\r\n", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$4.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "component", type: DspxCardSetMenuItemComponent, selector: "[dspx-card-set-menu-item]", inputs: ["item", "index", "root", "parentKey"] }], animations: [
            trigger('children', [
                state('void', style({ height: '0px' })),
                state('hiddenAnimated', style({ height: '0px' })),
                state('visibleAnimated', style({ height: '*' })),
                state('visible', style({ height: '*', 'z-index': 100 })),
                state('hidden', style({ height: '0px', 'z-index': '*' })),
                transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
                transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
                transition('void => visibleAnimated, visibleAnimated => void', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
            ])
        ], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetMenuItemComponent, decorators: [{
            type: Component,
            args: [{ selector: '[dspx-card-set-menu-item]', encapsulation: ViewEncapsulation.None, host: {
                        '[class.layout-root-menuitem]': 'root',
                        '[class.active-menuitem]': 'active',
                        '[class.active-menuitem-notrouter]': 'active && !item.items'
                    }, animations: [
                        trigger('children', [
                            state('void', style({ height: '0px' })),
                            state('hiddenAnimated', style({ height: '0px' })),
                            state('visibleAnimated', style({ height: '*' })),
                            state('visible', style({ height: '*', 'z-index': 100 })),
                            state('hidden', style({ height: '0px', 'z-index': '*' })),
                            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
                            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
                            transition('void => visibleAnimated, visibleAnimated => void', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
                        ])
                    ], template: "<ng-container>\r\n  <div *ngIf=\"root && item.visible !== false\" class=\"layout-menuitem-root-text\">{{item.label}}</div>\r\n  <a [attr.href]=\"item.url\" (click)=\"itemClick($event)\" *ngIf=\"(!item.routerLink || item.items) && item.visible !== false\" [title]=\"itemTitle\" (mouseenter)=\"onMouseEnter()\"\r\n     (keydown.enter)=\"itemClick($event)\" [attr.target]=\"item.target\" [ngClass]=\"item.class\" pRipple\r\n     [attr.tabindex]=\"isMenuActive ? 0 : -1\" [attr.aria-hidden]=\"isMenuActive ? null : true\">\r\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon\" class=\"layout-menuitem-icon\" [attr.aria-hidden]=\"!!item.label\"></i>\r\n      <span *ngIf=\"item.label\">{{item.label}}</span>\r\n      <i class=\"pi pi-fw pi-angle-down menuitem-toggle-icon\" *ngIf=\"item.items\"></i>\r\n      <span *ngIf=\"item.badge\" class=\"menuitem-badge\">{{item.badge}}</span>\r\n  </a>\r\n  <a (click)=\"itemClick($event)\" (mouseenter)=\"onMouseEnter()\" *ngIf=\"(item.routerLink && !item.items) && item.visible !== false\" [title]=\"itemTitle\"\r\n     [routerLink]=\"item.routerLink\" routerLinkActive=\"active-menuitem-routerlink\" [ngClass]=\"item.class\" pRipple\r\n     [routerLinkActiveOptions]=\"{exact: true}\" [attr.target]=\"item.target\" [attr.aria-current]=\"active ? 'page' : null\"\r\n     [attr.tabindex]=\"isMenuActive ? 0 : -1\" [attr.aria-hidden]=\"isMenuActive ? null : true\">\r\n      <i *ngIf=\"item.icon\" [ngClass]=\"item.icon\" class=\"layout-menuitem-icon\" [attr.aria-hidden]=\"!!item.label\"></i>\r\n      <span *ngIf=\"item.label\">{{item.label}}</span>\r\n      <i class=\"pi pi-fw pi-angle-down menuitem-toggle-icon\" *ngIf=\"item.items\"></i>\r\n      <span *ngIf=\"item.badge\" class=\"menuitem-badge\">{{item.badge}}</span>\r\n  </a>\r\n  <div *ngIf=\"item.label\" class=\"layout-menu-tooltip\">\r\n      <div class=\"layout-menu-tooltip-arrow\"></div>\r\n      <div class=\"layout-menu-tooltip-text\">{{item.label}}</div>\r\n  </div>\r\n  <div class=\"submenu-arrow\" *ngIf=\"item.items && item.visible !== false\"></div>\r\n  <ul *ngIf=\"((item.items && root) || (item.items && active)) && item.visible !== false\"\r\n      [@children]=\"(root ? 'visible' :active ? 'visibleAnimated' : 'hiddenAnimated')\">\r\n      <ng-template ngFor let-child let-i=\"index\" [ngForOf]=\"item.items\">\r\n          <li dspx-card-set-menu-item [item]=\"child\" [index]=\"i\" [parentKey]=\"key\" [class]=\"child.badgeClass\"></li>\r\n      </ng-template>\r\n  </ul>\r\n</ng-container>\r\n" }]
        }], ctorParameters: () => [{ type: i1$4.Router }, { type: MenuConfigService }], propDecorators: { item: [{
                type: Input
            }], index: [{
                type: Input
            }], root: [{
                type: Input
            }], parentKey: [{
                type: Input
            }] } });

class DspxCardSetMenuComponent {
    constructor(menuConfigService) {
        this.menuConfigService = menuConfigService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetMenuComponent, deps: [{ token: MenuConfigService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetMenuComponent, selector: "dspx-card-set-menu", inputs: { config: "config" }, ngImport: i0, template: "<div class=\"layout-menu-container\" [ngClass]=\"{'layout-menu-dark': menuConfigService.styleConfigService.darkMenu}\" (click)=\"menuConfigService.onMenuClick($event)\">\r\n  <ul class=\"layout-menu layout-main-menu clearfix\">\r\n    <li dspx-card-set-menu-item *ngFor=\"let item of config?.items; let i = index;\" [item]=\"item\" [index]=\"i\" [root]=\"true\"></li>\r\n  </ul>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: DspxCardSetMenuItemComponent, selector: "[dspx-card-set-menu-item]", inputs: ["item", "index", "root", "parentKey"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-menu', encapsulation: ViewEncapsulation.None, template: "<div class=\"layout-menu-container\" [ngClass]=\"{'layout-menu-dark': menuConfigService.styleConfigService.darkMenu}\" (click)=\"menuConfigService.onMenuClick($event)\">\r\n  <ul class=\"layout-menu layout-main-menu clearfix\">\r\n    <li dspx-card-set-menu-item *ngFor=\"let item of config?.items; let i = index;\" [item]=\"item\" [index]=\"i\" [root]=\"true\"></li>\r\n  </ul>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: MenuConfigService }], propDecorators: { config: [{
                type: Input
            }] } });

class DspxStatusBarComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxStatusBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxStatusBarComponent, selector: "dspx-status-bar", inputs: { content: "content" }, ngImport: i0, template: "<div class=\"status-bar\" [innerHTML]=\"content\"></div>\r\n", styles: [""], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxStatusBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-status-bar', encapsulation: ViewEncapsulation.None, template: "<div class=\"status-bar\" [innerHTML]=\"content\"></div>\r\n" }]
        }], propDecorators: { content: [{
                type: Input
            }] } });

class DspxSectionCompareBadgeComponent {
    constructor(coreService) {
        this.coreService = coreService;
        this.actualValue = 0;
        this.actualValueChanged = false;
        this.totalValue = -1;
        this.totalValueChanged = false;
    }
    ngOnInit() {
        let valFunc = this.coreService.applicationFunctions["fetchValueFunction"];
        if (valFunc == null || valFunc == undefined)
            console.log("No fetch value function configured in applicationFunctions");
        else {
            let isCompareRequired = this.coreService.applicationFunctions["isCompareRequired"]();
            this.actualValue = this.calculateCounterValues(this.config.responseCounterConfig.counterConfigs, valFunc);
            if (isCompareRequired == true && this.config.responseCounterConfig.hasPrevious == true) {
                let oldActualValue = this.calculateCounterValues(this.config.responseCounterConfig.counterConfigs, valFunc, true);
                if (this.actualValue != oldActualValue)
                    this.actualValueChanged = true;
            }
            this.totalValue = this.calculateCounterValues(this.config.responseCounterConfig.totalCounterConfigs, valFunc);
            if (isCompareRequired == true && this.config.responseCounterConfig.hasPrevious == true) {
                let oldTotalValue = this.calculateCounterValues(this.config.responseCounterConfig.totalCounterConfigs, valFunc, true);
                if (this.totalValue != oldTotalValue)
                    this.totalValueChanged = true;
            }
        }
    }
    calculateCounterValues(counterConfigs, valFunc, forPrevious = false) {
        let countVal = 0;
        if (counterConfigs != null && counterConfigs != undefined) {
            for (let cnt = 0; cnt < counterConfigs.length; cnt++) {
                let v = _.cloneDeep(counterConfigs[cnt]);
                if (forPrevious)
                    v.source += 100;
                try {
                    let val = valFunc(v);
                    if (isNumber(val)) {
                        countVal += val;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
            }
            return countVal;
        }
        else {
            return -1;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSectionCompareBadgeComponent, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxSectionCompareBadgeComponent, selector: "dspx-section-compare-badge", inputs: { config: "config" }, ngImport: i0, template: "<div class=\"progress-counter progress-counter__tooltip\">\r\n   <span>\r\n     <span [ngClass]=\"{'text-changed': (actualValueChanged == true)}\">{{actualValue}}</span>\r\n   </span>\r\n   <span *ngIf=\"totalValue >= 0\" class=\"separator\">/</span>\r\n   <span *ngIf=\"totalValue >= 0\" class=\"total\">\r\n     <span [ngClass]=\"{'text-changed': (totalValueChanged == true)}\">{{totalValue}}</span>\r\n   </span>\r\n </div>", styles: [".progress-counter{font-weight:700;color:#8b8b8b;margin:0;padding:0;font-size:0}.progress-counter span{font-size:26px}.progress-counter .total{color:#4a4a4a;width:100px;word-break:break-all}.progress-counter__tooltip{display:inline-block;color:#3e248a}.progress-counter__tooltip span{font-size:36px}.progress-counter__tooltip .separator,.progress-counter__tooltip .total{color:#b3b3b3}@media (min-width: 768px){.progress-counter{position:absolute;top:5px;font-size:0}.progress-counter span{font-size:40px}.progress-counter__tooltip{position:relative;top:0}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxSectionCompareBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section-compare-badge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"progress-counter progress-counter__tooltip\">\r\n   <span>\r\n     <span [ngClass]=\"{'text-changed': (actualValueChanged == true)}\">{{actualValue}}</span>\r\n   </span>\r\n   <span *ngIf=\"totalValue >= 0\" class=\"separator\">/</span>\r\n   <span *ngIf=\"totalValue >= 0\" class=\"total\">\r\n     <span [ngClass]=\"{'text-changed': (totalValueChanged == true)}\">{{totalValue}}</span>\r\n   </span>\r\n </div>", styles: [".progress-counter{font-weight:700;color:#8b8b8b;margin:0;padding:0;font-size:0}.progress-counter span{font-size:26px}.progress-counter .total{color:#4a4a4a;width:100px;word-break:break-all}.progress-counter__tooltip{display:inline-block;color:#3e248a}.progress-counter__tooltip span{font-size:36px}.progress-counter__tooltip .separator,.progress-counter__tooltip .total{color:#b3b3b3}@media (min-width: 768px){.progress-counter{position:absolute;top:5px;font-size:0}.progress-counter span{font-size:40px}.progress-counter__tooltip{position:relative;top:0}}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }], propDecorators: { config: [{
                type: Input
            }] } });

class DspxValidationSummaryComponent {
    ngOnInit() {
    }
    getId() {
        return `validation-error-${this.pageField.parent.key.toString()}-${this.pageField.key.toString()}`;
    }
    getValidationErrorTextForPage() {
        if (this.pageField.key.toString() !== 'form') {
            let tabKey = this.pageField.parent.key.toString();
            let pageKey = this.pageField.key.toString();
            let sections;
            let isRepeatingPage;
            let isRepeatingSection;
            let tabsModel = this.pageField.parent.parent.model;
            let pageErrors = [];
            if (this.pageField.fieldArray) {
                //This is a repeating page.
                sections = this.pageField.fieldArray.fieldGroup;
                isRepeatingPage = true;
            }
            else {
                sections = this.pageField.fieldGroup;
                isRepeatingPage = false;
            }
            //Allow for page level errors
            if (this.pageField.formControl?.errors) {
                Object.keys(this.pageField.formControl?.errors).forEach(errorKey => {
                    if (this.pageField.validation?.messages[errorKey]) {
                        pageErrors.push(this.pageField.validation?.messages[errorKey].toString());
                    }
                });
            }
            sections.forEach(section => {
                let sectionKey = section.key.toString();
                let questions;
                if (section.fieldArray) {
                    //This is a repeating section.
                    questions = section.fieldArray.fieldGroup;
                    isRepeatingSection = true;
                }
                else {
                    questions = section.fieldGroup;
                    isRepeatingSection = false;
                }
                questions.forEach(question => {
                    if (question.hide == null || question.hide === false) {
                        if (isRepeatingPage === true && isRepeatingSection === true) {
                            //Question is in a repeating page AND is in a repeating section.
                            let pageInstanceCount = tabsModel[tabKey]?.[pageKey]?.length;
                            pageInstanceCount = pageInstanceCount == null ? 0 : pageInstanceCount;
                            for (let pageIndex = 0; pageIndex < pageInstanceCount; pageIndex++) {
                                let sectionInstanceCount = tabsModel[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.length;
                                sectionInstanceCount = sectionInstanceCount == null ? 0 : sectionInstanceCount;
                                for (let sectionIndex = 0; sectionIndex < sectionInstanceCount; sectionIndex++) {
                                    const questionError = this.getValidationErrorTextForQuestion(section, question, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                                    if (!isNullOrWhitespaceOnly(questionError)) {
                                        pageErrors = [...new Set([...pageErrors, questionError])];
                                    }
                                }
                            }
                        }
                        else if (isRepeatingPage === true && isRepeatingSection === false) {
                            //Question is in a repeating page but not in a repeating section.
                            let pageInstanceCount = tabsModel[tabKey]?.[pageKey]?.length;
                            pageInstanceCount = pageInstanceCount == null ? 0 : pageInstanceCount;
                            for (let pageIndex = 0; pageIndex < pageInstanceCount; pageIndex++) {
                                const questionError = this.getValidationErrorTextForQuestion(section, question, tabKey, pageKey, pageIndex, sectionKey, -1);
                                if (!isNullOrWhitespaceOnly(questionError)) {
                                    pageErrors = [...new Set([...pageErrors, questionError])];
                                }
                            }
                        }
                        else if (isRepeatingPage === false && isRepeatingSection === true) {
                            //Question is not in a repeating page but is in a repeating section.
                            let sectionInstanceCount = tabsModel[tabKey]?.[pageKey]?.[sectionKey]?.length;
                            sectionInstanceCount = sectionInstanceCount == null ? 0 : sectionInstanceCount;
                            for (let sectionIndex = 0; sectionIndex < sectionInstanceCount; sectionIndex++) {
                                const questionError = this.getValidationErrorTextForQuestion(section, question, tabKey, pageKey, -1, sectionKey, sectionIndex);
                                if (!isNullOrWhitespaceOnly(questionError)) {
                                    pageErrors = [...new Set([...pageErrors, questionError])];
                                }
                            }
                        }
                        else {
                            //Question is not in a repeating page and not in a repeating section.
                            const questionError = this.getValidationErrorTextForQuestion(section, question, tabKey, pageKey, -1, sectionKey, -1);
                            if (!isNullOrWhitespaceOnly(questionError)) {
                                pageErrors = [...new Set([...pageErrors, questionError])];
                            }
                        }
                    }
                });
            });
            return pageErrors;
        }
    }
    getValidationErrorTextForQuestion(sectionConfig, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let errorText = '';
        let validationErrors;
        if (questionConfig.formControl != null && questionConfig.formControl.errors != null) {
            validationErrors = questionConfig.formControl.errors;
        }
        else {
            //let rootField = this.pageField.parent.parent.parent.parent.parent.parent.fieldGroup;
            let rootField = this.pageField.parent.parent.parent.parent.fieldGroup;
            let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
            if (formControl != null) {
                validationErrors = formControl.errors;
            }
        }
        if (validationErrors != null) {
            const errorKeys = Object.keys(validationErrors);
            if (errorKeys.length > 0) {
                const errorKey = errorKeys[0];
                const errorKeyValidationSummary = `${errorKey}-summary`;
                const seperator = questionConfig.props.label.endsWith(':') ? ' ' : ': ';
                if (errorKey === 'required' && validationErrors[errorKey] === true
                    && questionConfig.validation != null && questionConfig.validation.messages[errorKeyValidationSummary] != null) {
                    errorText = `${questionConfig.props.label}${seperator}${questionConfig.validation.messages[errorKeyValidationSummary].toString()}`;
                }
                else if (typeof validationErrors[errorKey] === 'object') {
                    if (questionConfig.validation?.messages[errorKeyValidationSummary] != null) {
                        errorText = `${questionConfig.props.label}${seperator}${questionConfig.validation?.messages[errorKeyValidationSummary].toString()}`;
                    }
                    else if (sectionConfig.validation?.messages[errorKeyValidationSummary] != null) {
                        errorText = `${questionConfig.props.label}${seperator}${sectionConfig.validation?.messages[errorKeyValidationSummary].toString()}`;
                    }
                    else if (validationErrors[errorKey]?.message != null) {
                        errorText = `${questionConfig.props.label}${seperator}${validationErrors[errorKey].message}`;
                    }
                    else if (errorText.length === 0) {
                        errorText = `${questionConfig.props.label}`;
                    }
                }
                else {
                    errorText = `${questionConfig.props.label}: ${errorKey}`;
                }
            }
        }
        return errorText;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxValidationSummaryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: { pageField: "pageField" }, ngImport: i0, template: "<div *ngIf=\"pageField.formControl.valid === false\" class=\"validation-summary\" role=\"alert\">\r\n  <h2 [id]=\"getId()\" tabindex=\"-1\">Please correct the following issues.</h2>\r\n  <ul>\r\n    <li *ngFor=\"let error of getValidationErrorTextForPage(); let errorIndex = index; let lastError = last\">\r\n      <i class=\"fas fa-circle\" aria-hidden=\"true\"></i> {{ error }}\r\n    </li>\r\n  </ul>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxValidationSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-validation-summary', template: "<div *ngIf=\"pageField.formControl.valid === false\" class=\"validation-summary\" role=\"alert\">\r\n  <h2 [id]=\"getId()\" tabindex=\"-1\">Please correct the following issues.</h2>\r\n  <ul>\r\n    <li *ngFor=\"let error of getValidationErrorTextForPage(); let errorIndex = index; let lastError = last\">\r\n      <i class=\"fas fa-circle\" aria-hidden=\"true\"></i> {{ error }}\r\n    </li>\r\n  </ul>\r\n</div>\r\n" }]
        }], propDecorators: { pageField: [{
                type: Input
            }] } });

class DspxShowHideTextComponent {
    constructor() {
        this.text = '';
        this.showMoreButton = false;
        this.hideText = true;
    }
    ngOnInit() {
        this.checkState();
    }
    ngOnChanges(changes) {
        this.checkState();
    }
    checkState() {
        this.showMoreButton = false;
        this.hideText = true;
        const maxTextLength = window.innerWidth > 768 ? 400 : 100;
        if (this.text != undefined && this.text.length > maxTextLength) {
            this.showMoreButton = true;
        }
        else {
            this.hideText = false;
        }
    }
    showMore(event) {
        this.hideText = !this.hideText;
        this.scrollIntoParent(event.target);
    }
    /** If contents are exorbitant then while collapsing these, focus will scroll back to its parent.
     */
    scrollIntoParent(element) {
        if (this.hideText && !this.isParentTopLeftCornerVisible(element)) {
            element.parentElement.scrollIntoView();
        }
    }
    isParentTopLeftCornerVisible(element) {
        const rect = element.parentElement.getBoundingClientRect();
        return this.isTopLeftCornerVisible(rect);
    }
    isTopLeftCornerVisible(rect) {
        return rect.top >= 0 &&
            rect.left >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxShowHideTextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxShowHideTextComponent, selector: "dspx-show-hide-text", inputs: { text: "text" }, usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"hideText ? 'hideOverflow' : 'showOverflow'\">\r\n    <div>{{text}}</div>\r\n</div>\r\n<ng-container *ngIf=\"showMoreButton == true\">\r\n    <button type=\"button\" pButton pRipple class=\"p-button-text p-button-plain\"\r\n        [icon]=\"hideText ? 'p-button-icon-left pi pi-chevron-down' : 'p-button-icon-left pi pi-chevron-up'\"\r\n        title=\"{{hideText ? 'Show more' : 'Show less'}}\" [attr.aria-expanded]=\"hideText ? false : true\" \r\n        (click)=\"showMore($event)\">{{hideText ? 'Show more' : 'Show less'}}</button>\r\n</ng-container>", styles: [".hideOverflow{overflow:hidden;text-overflow:ellipsis;max-height:60px;white-space:pre-line}.showOverflow{overflow:visible;white-space:pre-line}@media (max-width: 768px){.hideOverflow{max-height:110px}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxShowHideTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-show-hide-text', template: "<div [ngClass]=\"hideText ? 'hideOverflow' : 'showOverflow'\">\r\n    <div>{{text}}</div>\r\n</div>\r\n<ng-container *ngIf=\"showMoreButton == true\">\r\n    <button type=\"button\" pButton pRipple class=\"p-button-text p-button-plain\"\r\n        [icon]=\"hideText ? 'p-button-icon-left pi pi-chevron-down' : 'p-button-icon-left pi pi-chevron-up'\"\r\n        title=\"{{hideText ? 'Show more' : 'Show less'}}\" [attr.aria-expanded]=\"hideText ? false : true\" \r\n        (click)=\"showMore($event)\">{{hideText ? 'Show more' : 'Show less'}}</button>\r\n</ng-container>", styles: [".hideOverflow{overflow:hidden;text-overflow:ellipsis;max-height:60px;white-space:pre-line}.showOverflow{overflow:visible;white-space:pre-line}@media (max-width: 768px){.hideOverflow{max-height:110px}}\n"] }]
        }], propDecorators: { text: [{
                type: Input
            }] } });

class DspxFormHeaderComponent {
    getBadgeClasses() {
        let badgeThemeClass = 'text-600 surface-200';
        if (this.formHeaderModel.badgeThemeClass) {
            badgeThemeClass = this.formHeaderModel.badgeThemeClass;
        }
        return `flex-order-3 ${badgeThemeClass} p-2 border-round`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxFormHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxFormHeaderComponent, selector: "dspx-form-header-base", inputs: { formHeaderModel: "formHeaderModel" }, ngImport: i0, template: " <div class=\"grid pl-2 md:pb-0 pb-3 align-items-center\">\r\n  <dspx-heading [heading]=\"formHeaderModel.header\" [level]=\"formHeaderModel.headerTitleLevel\" class=\"flex-order-1 pt-3\"></dspx-heading>\r\n  <div  *ngIf=\"formHeaderModel.badgeText\" class=\"flex-order-2 w-2 hidden sm:block\">\r\n    <div class=\"flex relative align-items-center justify-content-center mx-3 py-3 min-h-full\">\r\n      <div class=\"border-left-1 surface-border top-0 left-50 absolute h-full\"></div>\r\n    </div>\r\n  </div>\r\n  <span *ngIf=\"formHeaderModel.badgeText\" [ngClass]=\"getBadgeClasses()\">{{formHeaderModel.badgeText}}</span>\r\n</div>\r\n  <div class=\"text-600\">\r\n    <dspx-heading [heading]=\"formHeaderModel.subtitle\" [level]=\"formHeaderModel.subtitleLevel\"></dspx-heading>\r\n  </div>\r\n  <dl class=\"grid pl-2\">\r\n    <div *ngFor=\"let question of formHeaderModel.questions;\" class=\"grid\">\r\n      <div class=\"col pt-3 pb-3 pr-6\">\r\n        <dt class=\"text-600\">{{question.label}}</dt>\r\n        <dd class=\"ml-0 font-bold\">{{question.value}}</dd>\r\n      </div>\r\n    </div>\r\n  </dl>\r\n\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxFormHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-header-base', template: " <div class=\"grid pl-2 md:pb-0 pb-3 align-items-center\">\r\n  <dspx-heading [heading]=\"formHeaderModel.header\" [level]=\"formHeaderModel.headerTitleLevel\" class=\"flex-order-1 pt-3\"></dspx-heading>\r\n  <div  *ngIf=\"formHeaderModel.badgeText\" class=\"flex-order-2 w-2 hidden sm:block\">\r\n    <div class=\"flex relative align-items-center justify-content-center mx-3 py-3 min-h-full\">\r\n      <div class=\"border-left-1 surface-border top-0 left-50 absolute h-full\"></div>\r\n    </div>\r\n  </div>\r\n  <span *ngIf=\"formHeaderModel.badgeText\" [ngClass]=\"getBadgeClasses()\">{{formHeaderModel.badgeText}}</span>\r\n</div>\r\n  <div class=\"text-600\">\r\n    <dspx-heading [heading]=\"formHeaderModel.subtitle\" [level]=\"formHeaderModel.subtitleLevel\"></dspx-heading>\r\n  </div>\r\n  <dl class=\"grid pl-2\">\r\n    <div *ngFor=\"let question of formHeaderModel.questions;\" class=\"grid\">\r\n      <div class=\"col pt-3 pb-3 pr-6\">\r\n        <dt class=\"text-600\">{{question.label}}</dt>\r\n        <dd class=\"ml-0 font-bold\">{{question.value}}</dd>\r\n      </div>\r\n    </div>\r\n  </dl>\r\n\r\n" }]
        }], propDecorators: { formHeaderModel: [{
                type: Input
            }] } });

class DspxCardSetBaseFormWithHeaderComponent extends DspxBaseFormCommonComponent {
    constructor(formConfigurationService, coreService, spinnerService) {
        super(formConfigurationService);
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.spinnerService = spinnerService;
    }
    ngOnInit() {
        this.coreService.applicationFunctions['buttonClicked'] =
            (field, event) => {
                this.onButtonClick.emit({ isFormValid: this.form.valid, type: field, event, data: this.getModelAsString() });
            };
        this.coreService.applicationFunctions['actionButtonClicked'] =
            (field, event) => {
                this.onActionButtonClick.emit({ field, event, model: this.getModelAsString() });
            };
        this.coreService.applicationFunctions['filterData'] =
            (field, event) => {
                const filters = field.parent.fieldGroup
                    .filter(f => f.type && (f.type === FieldTypes.SEARCH || f.type === FieldTypes.SELECT))
                    .map(f => ({ name: f.key.toString(), value: f.formControl.value }));
                this.onFilter.emit({ action: event?.action, field, filters });
            };
        this.coreService.applicationFunctions['save'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(false, false));
            };
        this.coreService.applicationFunctions['submit'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(true, true));
            };
        this.coreService.applicationFunctions['saveandclose'] =
            () => {
                this.onSave.emit(this.getSaveFormEvent(false, true));
            };
        this.coreService.applicationFunctions['cancel'] =
            () => {
                this.onCancel.emit();
            };
        this.coreService.setActiveFormName(this.formName);
        if (!this.fields) {
            const request = {
                apiEndpointKey: this.formServiceEndpoint,
                templateId: this.templateId,
                versionNo: this.versionNo,
                entityId: this.entityId
            };
            if (request.entityId === undefined || request.entityId === null || request.entityId === ''
                || this.fetchOnlyConfig) {
                this.formConfigurationService
                    .getFormConfig(request, this.mockGetConfigApiCallSettings, this.configCacheTimeoutInSeconds)
                    .pipe(take$1(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = this.convertToCardSetFieldTypes([data.configData.config]);
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response ?? {};
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, null, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = Guid.create().toString();
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
            else {
                this.formConfigurationService
                    .getFormConfigAndResponse(request, this.mockGetConfigApiCallSettings)
                    .pipe(take$1(1))
                    .subscribe(data => {
                    this.spinnerService.showSpinner();
                    this.fields = this.convertToCardSetFieldTypes([data.configData.config]);
                    this.optionSets = data.configData.optionSets;
                    this.model = data.response ?? {};
                    this.popups = data.configData.popups;
                    this.notifications = data.configData.notifications;
                    this.lastUpdatedTime = data.lastUpdatedTime;
                    this.formConfigurationService.extendFieldConfig(this.fields, this.model, this.optionSets, data.isFormEditable, null, this.verticalNavigationSettings);
                    this.formConfigurationService.setupDialogs(this.popups, this.notifications);
                    this.formIdentifier = data.formIdentifier;
                    GridDataHelpers.ParseDatesInGrids(data.configData, this.model);
                    this.onFormLoad.emit(data);
                    this.spinnerService.hideSpinner();
                });
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetBaseFormWithHeaderComponent, deps: [{ token: FormConfigurationService }, { token: CoreService }, { token: SpinnerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxCardSetBaseFormWithHeaderComponent, selector: "dspx-card-set-base-with-header-form", inputs: { formHeaderModel: "formHeaderModel" }, usesInheritance: true, ngImport: i0, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<div class=\"p-fluid field pt-3\">\r\n  <div class=\"surface-card p-0 border-round shadow-1\">\r\n    <div class=\"px-4 py-5 md:px-6 lg:px-8\">\r\n      <dspx-form-header-base\r\n        [formHeaderModel] = \"formHeaderModel\">\r\n      </dspx-form-header-base>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n    <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: DspxDialogComponent, selector: "dspx-dialog", outputs: ["onSubmit"] }, { kind: "component", type: DspxSpinnerComponent, selector: "dspx-spinner" }, { kind: "component", type: DspxFormHeaderComponent, selector: "dspx-form-header-base", inputs: ["formHeaderModel"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCardSetBaseFormWithHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-base-with-header-form', encapsulation: ViewEncapsulation.None, template: "<dspx-dialog (onSubmit)=\"dialogSubmitted($event)\"></dspx-dialog>\r\n<dspx-spinner></dspx-spinner>\r\n<div class=\"p-fluid field pt-3\">\r\n  <div class=\"surface-card p-0 border-round shadow-1\">\r\n    <div class=\"px-4 py-5 md:px-6 lg:px-8\">\r\n      <dspx-form-header-base\r\n        [formHeaderModel] = \"formHeaderModel\">\r\n      </dspx-form-header-base>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<form id=\"dspx-form\" [formGroup]=\"form\" class=\"baseform\">\r\n    <formly-form [form]=\"form\" [fields]=\"fields\" [model]=\"model\" (modelChange)=\"modelChanged()\"></formly-form>\r\n</form>\r\n" }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: CoreService }, { type: SpinnerService }], propDecorators: { formHeaderModel: [{
                type: Input
            }] } });

class GlobalErrorHandler {
    constructor(dialogService, zone) {
        this.dialogService = dialogService;
        this.zone = zone;
    }
    handleError(error) {
        this.zone.run(() => {
            if (error instanceof HttpErrorResponse) {
                if (!navigator.onLine) {
                    return this.dialogService.showDialog(Dialogs.NETWORK_ERROR);
                }
                else {
                    switch (error.status) {
                        case 401:
                        case 403:
                            {
                                return this.dialogService.showDialog(Dialogs.UNAUTHORISED);
                            }
                        case 0: {
                            if (error.name === 'HttpErrorResponse') {
                                return this.dialogService.showDialog(Dialogs.SESSION_TIMEOUT);
                            }
                            break;
                        }
                        case 500: {
                            return this.dialogService.showDialog(Dialogs.SERVER_ERROR);
                        }
                        case 400: {
                            switch (error.error.status) {
                                case "NoMatchingRow":
                                case 1:
                                    return this.dialogService.showDialog(Dialogs.NO_MATCHING_RECORD);
                                case "UpdatedSinceReadTime":
                                case 2:
                                    return this.dialogService.showDialog(Dialogs.CONCURRENCY);
                                case "DuplicateRow":
                                case 6:
                                    return this.dialogService.showDialog(Dialogs.DUPLICATE);
                            }
                            return this.dialogService.showDialog(Dialogs.CLIENT_ERROR);
                        }
                        default: {
                            console.error(error);
                        }
                    }
                }
            }
            else {
                console.error(error);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GlobalErrorHandler, deps: [{ token: DialogService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GlobalErrorHandler, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: GlobalErrorHandler, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: DialogService }, { type: i0.NgZone }] });

class HttpErrorInterceptor {
    constructor(dialogService, spinnerService, appSettings) {
        this.dialogService = dialogService;
        this.spinnerService = spinnerService;
        this.appSettings = appSettings;
        this._count = 0;
    }
    intercept(request, next) {
        const isMaintenanceOrAddressRequest = request.url.includes('api/errors') ||
            request.url.includes('api/Address/Search') ||
            (this.appSettings.addressApiBaseUrl && request.url.includes(this.appSettings.addressApiBaseUrl));
        if (!isMaintenanceOrAddressRequest) {
            this._count++;
            if (this._count === 1) {
                // show loading spinner
                this.spinnerService.showSpinner();
            }
        }
        return next.handle(request).pipe(
        // Error handling is done via GlobalErrorHandler. Below is an example of how to handle http errors via this interceptor
        // catchError((error: HttpErrorResponse) => {
        //   console.error("Error from error interceptor", error);
        //   // show dialog for error message
        //   this.dialogService.showDialog(error.message ?? JSON.stringify(error), error.status);
        //   return throwError(error);
        // }),
        finalize(() => {
            if (!isMaintenanceOrAddressRequest) {
                this._count--;
                if (!this._count) {
                    // hide loading spinner
                    this.spinnerService.hideSpinner();
                }
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HttpErrorInterceptor, deps: [{ token: DialogService }, { token: SpinnerService }, { token: ApplicationSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HttpErrorInterceptor, providedIn: 'platform' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HttpErrorInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'platform'
                }]
        }], ctorParameters: () => [{ type: DialogService }, { type: SpinnerService }, { type: ApplicationSettings }] });

class SwitchFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SwitchFieldType, selector: "dspx-switch", usesInheritance: true, ngImport: i0, template: "<!-- <div class=\"field\">\r\n  <label>{{ props.label }}<span *ngIf=\"props.required\" class=\"text-danger\"> *</span></label> -->\r\n  <p-inputSwitch\r\n    [inputId]=\"id + '-input'\"\r\n    [formControl]=\"formControl\"\r\n    [formlyAttributes]=\"field\"\r\n    (onBlur)=\"onBlur($event)\"\r\n    [ariaLabel]=\"props.label\"\r\n    [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n    [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  </p-inputSwitch>\r\n<!-- </div> -->\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$6.InputSwitch, selector: "p-inputSwitch", inputs: ["style", "styleClass", "tabindex", "inputId", "name", "disabled", "readonly", "trueValue", "falseValue", "ariaLabel", "ariaLabelledBy", "autofocus"], outputs: ["onChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-switch', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- <div class=\"field\">\r\n  <label>{{ props.label }}<span *ngIf=\"props.required\" class=\"text-danger\"> *</span></label> -->\r\n  <p-inputSwitch\r\n    [inputId]=\"id + '-input'\"\r\n    [formControl]=\"formControl\"\r\n    [formlyAttributes]=\"field\"\r\n    (onBlur)=\"onBlur($event)\"\r\n    [ariaLabel]=\"props.label\"\r\n    [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n    [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  </p-inputSwitch>\r\n<!-- </div> -->\r\n" }]
        }] });

class CheckboxFieldType extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckboxFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CheckboxFieldType, selector: "dspx-checkbox", usesInheritance: true, ngImport: i0, template: "<div class=\"field-checkbox\" *ngFor=\"let v of props.options; let i = index\">\r\n  <p-checkbox\r\n    [name]=\"field.key\"\r\n    [value]=\"props.valueProp ? v[props.valueProp] : v.value\"\r\n    [formControl]=\"formControl\"\r\n    [inputId]=\"id + '_' + i\"\r\n    checkboxIcon=\"fas fa-check\" \r\n    [required]=\"props.required ? 'true' : undefined\"  \r\n  ></p-checkbox>\r\n  <label [for]=\"id + '_' + i\">{{props.labelProp ? v[props.labelProp] : v.label}}</label>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: Checkbox, selector: "p-checkbox", inputs: ["value", "name", "disabled", "binary", "label", "ariaLabelledBy", "ariaLabel", "tabindex", "inputId", "style", "styleClass", "labelStyleClass", "formControl", "checkboxIcon", "readonly", "required", "trueValue", "falseValue"], outputs: ["onChange", "onFocus", "onBlur"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckboxFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"field-checkbox\" *ngFor=\"let v of props.options; let i = index\">\r\n  <p-checkbox\r\n    [name]=\"field.key\"\r\n    [value]=\"props.valueProp ? v[props.valueProp] : v.value\"\r\n    [formControl]=\"formControl\"\r\n    [inputId]=\"id + '_' + i\"\r\n    checkboxIcon=\"fas fa-check\" \r\n    [required]=\"props.required ? 'true' : undefined\"  \r\n  ></p-checkbox>\r\n  <label [for]=\"id + '_' + i\">{{props.labelProp ? v[props.labelProp] : v.label}}</label>\r\n</div>\r\n" }]
        }] });

class ButtonFieldType extends FieldType {
    onClick($event) {
        if (this.props.onClick && !this.props.disabled) {
            this.props.onClick($event, this.model, this.field, this.props.onClickArguments);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ButtonFieldType, selector: "dspx-button", usesInheritance: true, ngImport: i0, template: "<p-button\r\n    type=\"button\"\r\n    [label]=\"props.label\"\r\n    [id]=\"field.name\"\r\n    (click)=\"onClick($event)\"\r\n    [disabled]=\"props.disabled\"\r\n    [attr.aria-disabled]=\"props.disabled ? 'true' : undefined\"\r\n></p-button>\r\n", dependencies: [{ kind: "component", type: i3$1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ButtonFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-button', template: "<p-button\r\n    type=\"button\"\r\n    [label]=\"props.label\"\r\n    [id]=\"field.name\"\r\n    (click)=\"onClick($event)\"\r\n    [disabled]=\"props.disabled\"\r\n    [attr.aria-disabled]=\"props.disabled ? 'true' : undefined\"\r\n></p-button>\r\n" }]
        }] });

class DateFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.minDate = new Date(1900, 0, 1); // Set min date to 01/01/1900 to prevent entering date prior year 1900. month 0 = January
        this.yearRange = '1900:' + new Date().getFullYear().toString();
    }
    ngOnInit() {
        this.yearRange = '1900:' + (this.props.maxYear ? this.props.maxYear.toString() : new Date().getFullYear().toString());
        let fieldKey = this.field.key.toString();
        if (this.field.props.selectionMode === 'multiple' || this.field.props.selectionMode === 'range') {
            //If the selection mode is "multiple" or "range" and data exists in the model for this date control,
            //we must convert the array of date strings to an array of Date objects in order for the date control to
            //display the dates selected.
            //
            //The dates stored in the response are in dd/mm/yyyy format, e.g.
            //"multiDate": [
            //  "08/02/2023",
            //  "15/02/2023",
            //  "22/02/2023"
            //],
            let dates = this.field.model?.[fieldKey];
            if (dates != null) {
                this.internalModel = [];
                for (let dateString of dates) {
                    let newDate;
                    let dateComponents = dateString.split('/');
                    newDate = new Date(dateComponents[2], parseInt(dateComponents[1]) - 1, dateComponents[0]);
                    this.internalModel.push(newDate);
                }
            }
        }
    }
    ngAfterViewInit() {
        //This hack is a workaround due to a bug/deficiency in the PrimeNg Calendar control.
        //On initial load of the calendar control where selectionMode is multiple or range, the model needs to contain
        //Date objects. The code above in OnInit satifies this requirement by converting the date strings in the model
        //to Date objects. However, the Date objects remain in the model and will get serialised as ISO date strings
        //(e.g. "2023-03-21T13:00:00.000Z") if the user never makes a change to the selected dates (which causes the
        //PrimeNg calendar control to format the date strings using the format specified in the dateFormat attribute).
        //To compensate for this, we explicitly update the model of the calendar after the form loads if there was an
        //existing value in the model.
        setTimeout(() => {
            if ((this.field.props.selectionMode === 'multiple' || this.field.props.selectionMode === 'range')
                && this.internalModel != null) {
                this.formControl.setValue(this.internalModel);
                this.calendar.updateModel(this.calendar.value);
            }
        });
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DateFieldType, selector: "dspx-date", viewQueries: [{ propertyName: "calendar", first: true, predicate: ["calendar"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<p-calendar [inputId]=\"id + '-input'\"\r\n            type=\"date\"\r\n            [selectionMode]=\"props.selectionMode ?? 'single'\"\r\n            [maxDateCount]=\"props.selectionMode === 'multiple' ? (props.maxDateCount ?? undefined) : undefined\"\r\n            [name]=\"field.name\"\r\n            autocomplete=\"off\"\r\n            dateFormat=\"dd/mm/yy\"\r\n            [placeholder]=\"props.selectionMode === 'multiple' ? 'DD/MM/YYYY, DD/MM/YYYY, ...' : (props.selectionMode === 'range' ? 'DD/MM/YYYY - DD/MM/YYYY' : 'DD/MM/YYYY')\"\r\n            [keepInvalid]=\"true\"\r\n            [showIcon]=\"true\"\r\n            [readonlyInput]=\"props.selectionMode === 'multiple' || props.selectionMode === 'range'\"\r\n            [formControl]=\"formControl\"\r\n            [formlyAttributes]=\"field\"\r\n            (onBlur)=\"onBlur($event)\"\r\n            [minDate]=\"minDate\"\r\n            monthNavigator=\"true\"\r\n            yearNavigator=\"true\"\r\n            [yearRange]=\"yearRange\"\r\n            appendTo=\"body\"\r\n            dataType=\"string\"\r\n            icon=\"fas fa-calendar-alt\"\r\n            [ariaLabel]=\"props.label\"\r\n            iconAriaLabel=\"Select date\"\r\n            [required]=\"props.required ? 'true' : undefined\"\r\n            [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n            #calendar>\r\n</p-calendar>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$3.Calendar, selector: "p-calendar", inputs: ["iconDisplay", "style", "styleClass", "inputStyle", "inputId", "name", "inputStyleClass", "placeholder", "ariaLabelledBy", "ariaLabel", "iconAriaLabel", "disabled", "dateFormat", "multipleSeparator", "rangeSeparator", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "monthNavigator", "yearNavigator", "hourFormat", "timeOnly", "stepYearPicker", "stepHour", "stepMinute", "stepSecond", "showSeconds", "required", "showOnFocus", "showWeek", "startWeekFromFirstDayOfYear", "showClear", "dataType", "selectionMode", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "autofocus", "autoZIndex", "baseZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "touchUI", "timeSeparator", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "tabindex", "variant", "minDate", "maxDate", "disabledDates", "disabledDays", "yearRange", "showTime", "responsiveOptions", "numberOfMonths", "firstDayOfWeek", "locale", "view", "defaultDate"], outputs: ["onFocus", "onBlur", "onClose", "onSelect", "onClear", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange", "onClickOutside", "onShow"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-calendar [inputId]=\"id + '-input'\"\r\n            type=\"date\"\r\n            [selectionMode]=\"props.selectionMode ?? 'single'\"\r\n            [maxDateCount]=\"props.selectionMode === 'multiple' ? (props.maxDateCount ?? undefined) : undefined\"\r\n            [name]=\"field.name\"\r\n            autocomplete=\"off\"\r\n            dateFormat=\"dd/mm/yy\"\r\n            [placeholder]=\"props.selectionMode === 'multiple' ? 'DD/MM/YYYY, DD/MM/YYYY, ...' : (props.selectionMode === 'range' ? 'DD/MM/YYYY - DD/MM/YYYY' : 'DD/MM/YYYY')\"\r\n            [keepInvalid]=\"true\"\r\n            [showIcon]=\"true\"\r\n            [readonlyInput]=\"props.selectionMode === 'multiple' || props.selectionMode === 'range'\"\r\n            [formControl]=\"formControl\"\r\n            [formlyAttributes]=\"field\"\r\n            (onBlur)=\"onBlur($event)\"\r\n            [minDate]=\"minDate\"\r\n            monthNavigator=\"true\"\r\n            yearNavigator=\"true\"\r\n            [yearRange]=\"yearRange\"\r\n            appendTo=\"body\"\r\n            dataType=\"string\"\r\n            icon=\"fas fa-calendar-alt\"\r\n            [ariaLabel]=\"props.label\"\r\n            iconAriaLabel=\"Select date\"\r\n            [required]=\"props.required ? 'true' : undefined\"\r\n            [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n            #calendar>\r\n</p-calendar>\r\n" }]
        }], propDecorators: { calendar: [{
                type: ViewChild,
                args: ['calendar']
            }] } });

class DateTimeFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.minDate = new Date(1900, 0, 1); // Set min date to 01/01/1900 to prevent entering date prior year 1900. month 0 = January
        this.yearRange = '1900:' + new Date().getFullYear().toString();
    }
    ngOnInit() {
        this.yearRange = '1900:' + (this.props.maxYear ? this.props.maxYear.toString() : new Date().getFullYear().toString());
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateTimeFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DateTimeFieldType, selector: "dspx-datetime", usesInheritance: true, ngImport: i0, template: "<p-calendar [inputId]=\"id + '-input'\"\r\n            type=\"datetime\"\r\n            [name]=\"field.name\"\r\n            [formlyAttributes]=\"field\"\r\n            (onBlur)=\"onBlur($event)\"\r\n            autocomplete=\"off\"\r\n            showTime=\"true\"\r\n            hourFormat=\"12\"\r\n            dateFormat=\"dd/mm/yy\"\r\n            placeholder=\"DD/MM/YYYY\"\r\n            [readonlyInput]=\"true\"\r\n            [showIcon]=\"true\"\r\n            [keepInvalid]=\"true\"\r\n            [minDate]=\"minDate\"\r\n            monthNavigator=\"true\"\r\n            yearNavigator=\"true\"\r\n            [yearRange]=\"yearRange\"\r\n            appendTo=\"body\"\r\n            [formControl]=\"formControl\"\r\n            dataType=\"string\"\r\n            iconAriaLabel=\"Select date and time\"\r\n            [ariaLabel]=\"props.label\"\r\n            [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n            [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-calendar>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$3.Calendar, selector: "p-calendar", inputs: ["iconDisplay", "style", "styleClass", "inputStyle", "inputId", "name", "inputStyleClass", "placeholder", "ariaLabelledBy", "ariaLabel", "iconAriaLabel", "disabled", "dateFormat", "multipleSeparator", "rangeSeparator", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "monthNavigator", "yearNavigator", "hourFormat", "timeOnly", "stepYearPicker", "stepHour", "stepMinute", "stepSecond", "showSeconds", "required", "showOnFocus", "showWeek", "startWeekFromFirstDayOfYear", "showClear", "dataType", "selectionMode", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "autofocus", "autoZIndex", "baseZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "touchUI", "timeSeparator", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "tabindex", "variant", "minDate", "maxDate", "disabledDates", "disabledDays", "yearRange", "showTime", "responsiveOptions", "numberOfMonths", "firstDayOfWeek", "locale", "view", "defaultDate"], outputs: ["onFocus", "onBlur", "onClose", "onSelect", "onClear", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange", "onClickOutside", "onShow"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DateTimeFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-datetime', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-calendar [inputId]=\"id + '-input'\"\r\n            type=\"datetime\"\r\n            [name]=\"field.name\"\r\n            [formlyAttributes]=\"field\"\r\n            (onBlur)=\"onBlur($event)\"\r\n            autocomplete=\"off\"\r\n            showTime=\"true\"\r\n            hourFormat=\"12\"\r\n            dateFormat=\"dd/mm/yy\"\r\n            placeholder=\"DD/MM/YYYY\"\r\n            [readonlyInput]=\"true\"\r\n            [showIcon]=\"true\"\r\n            [keepInvalid]=\"true\"\r\n            [minDate]=\"minDate\"\r\n            monthNavigator=\"true\"\r\n            yearNavigator=\"true\"\r\n            [yearRange]=\"yearRange\"\r\n            appendTo=\"body\"\r\n            [formControl]=\"formControl\"\r\n            dataType=\"string\"\r\n            iconAriaLabel=\"Select date and time\"\r\n            [ariaLabel]=\"props.label\"\r\n            [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n            [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-calendar>\r\n" }]
        }] });

class FileUploadFieldType extends FieldType {
    constructor(appSettings, coreService, fileService, fileSaverService, spinnerService, cd, imageCompress) {
        super();
        this.appSettings = appSettings;
        this.coreService = coreService;
        this.fileService = fileService;
        this.fileSaverService = fileSaverService;
        this.spinnerService = spinnerService;
        this.cd = cd;
        this.imageCompress = imageCompress;
        this.uploadedFiles = [];
        this.newlyAddedFiles = [];
        this.acceptedFileTypes = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,image/*,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
        this.invalidFileTypeMessageDetail = 'Supported file types are MS Word Documents, MS Excel Workbooks, MS PowerPoint Presentations, PDFs, and Images.';
        this.showDownloadButton = true;
        this.showRemoveButton = true;
        this.onlyNewFilesCanBeRemoved = false;
        //Example of how the file info is stored in the model/response:
        //"dhhs-framework-v3.PNG:9B7DE023-3AC0-4EEC-AD5D-341A75F0F07D|dependency-injection.png:9B7DE023-3AC0-4EEC-AD5D-341A75F0F07D"
        //<file_name>:<file_id>|<file_name>:<file_id>|...
        this.fileInfoSeparator1 = '|';
        this.fileInfoSeparator2 = ':';
    }
    ngOnInit() {
        let fieldKey = this.field.key.toString();
        this.formIdentifier = this.coreService.fileUploadFormIdentifiers[fieldKey];
        if (this.props.fileUploadOptions) {
            this.fileLimit = this.props.fileUploadOptions.fileLimit
                ? this.props.fileUploadOptions.fileLimit
                : undefined;
            this.maxFileSize = this.props.fileUploadOptions.maxFileSize
                ? this.props.fileUploadOptions.maxFileSize
                : 10485760;
            this.auto = !!this.props.fileUploadOptions.auto;
            this.acceptedFileTypes = this.props.fileUploadOptions.acceptedFileTypes
                ? this.props.fileUploadOptions.acceptedFileTypes
                : this.acceptedFileTypes;
            this.invalidFileTypeMessageDetail = this.props.fileUploadOptions.invalidFileTypeMessage
                ? this.props.fileUploadOptions.invalidFileTypeMessage
                : this.invalidFileTypeMessageDetail;
            this.showDownloadButton = this.props.fileUploadOptions.showDownloadButton != null
                ? this.props.fileUploadOptions.showDownloadButton
                : this.showDownloadButton;
            this.showRemoveButton = this.props.fileUploadOptions.showRemoveButton != null
                ? this.props.fileUploadOptions.showRemoveButton
                : this.showRemoveButton;
            this.onlyNewFilesCanBeRemoved = this.props.fileUploadOptions.onlyNewFilesCanBeRemoved != null
                ? this.props.fileUploadOptions.onlyNewFilesCanBeRemoved
                : this.onlyNewFilesCanBeRemoved;
        }
        if (this.field.model != null && this.field.model[fieldKey] != null && this.field.model[fieldKey] !== '') {
            let fileInfoList = this.field.model[fieldKey].split(this.fileInfoSeparator1);
            for (let fileInfoText of fileInfoList) {
                this.uploadedFiles.push(this.getFileInfo(fileInfoText));
            }
        }
    }
    uploadFiles($event) {
        if ($event?.files != null) {
            const compressImages = this.field.props.fileUploadOptions?.compressImages ?? false;
            const compressImageRatio = this.field.props.fileUploadOptions?.compressImageRatio ?? 100;
            const compressImageJpgQuality = this.field.props.fileUploadOptions?.compressImageJpgQuality ?? 50;
            const compressImageMaxWidth = this.field.props.fileUploadOptions?.compressImageMaxWidth ?? 0;
            const compressImageMaxHeight = this.field.props.fileUploadOptions?.compressImageMaxHeight ?? 0;
            for (let file of $event.files) {
                // This showSpinner() is balanced out by a call to hideSpinner() which is inside this.uploadFile().
                // this.uploadFile() is called directly below if we're NOT compressing this file. If we ARE compressing
                // this file, it gets called indirectly after we've compressed it, then gotten its content.
                //
                // There might be a case where hideSpinner() doesn't get called if compression fails.
                this.spinnerService.showSpinner();
                if ((file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp')
                    && compressImages) {
                    const reader = new FileReader();
                    // This looks like a race condition, because we set the completion handler (onloadend) AFTER we trigger
                    // the load event. So in theory maybe readAsDataURL could complete before we've set the completion handler.
                    // But in practice (a) we haven't seen that happen and (b) seems unlikely that it would happen.
                    reader.readAsDataURL(file);
                    reader.onloadend = () => {
                        let originalDataUrl = reader.result.toString();
                        this.imageCompress
                            .compressFile(originalDataUrl, DOC_ORIENTATION.Default, compressImageRatio, compressImageJpgQuality, compressImageMaxWidth, compressImageMaxHeight)
                            .then(async (compressedDataUrl) => {
                            this.createFileThenUpload(compressedDataUrl, file.name);
                        });
                    };
                }
                //Not an image file that can be compressed, just upload.
                else {
                    this.uploadFile(file);
                }
            }
        }
    }
    removeFile(file) {
        const fileUploadOnBeforeRemoveCallBackMethod = this.field.props.fileUploadOptions?.fileUploadOnBeforeRemove;
        if (fileUploadOnBeforeRemoveCallBackMethod != null) {
            this.coreService.applicationFunctions[fileUploadOnBeforeRemoveCallBackMethod](file, (cancel) => {
                if (!cancel) {
                    this.completeRemoveFile(file);
                }
            });
        }
        else {
            this.completeRemoveFile(file);
        }
    }
    completeRemoveFile(file) {
        let fieldKey = this.field.key.toString();
        if (file != null && this.field.model != null && this.field.model[fieldKey] != null) {
            let fileInfoList = this.field.model[fieldKey].split(this.fileInfoSeparator1);
            let fileInfoTextToRemove;
            let fileId = '';
            for (let fileInfoText of fileInfoList) {
                let fileInfo = this.getFileInfo(fileInfoText);
                if (fileInfo.name === file.name) {
                    fileId = fileInfo.id;
                    fileInfoTextToRemove = fileInfoText;
                    break;
                }
            }
            if (fileId !== '') {
                this.fileService.remove(this.formIdentifier, fileId)
                    .pipe(take(1))
                    .subscribe((response) => {
                    //Model management
                    this.field.model[fieldKey] = this.field.model[fieldKey]
                        .replace(fileInfoTextToRemove, '')
                        .replace(this.fileInfoSeparator1 + this.fileInfoSeparator1, this.fileInfoSeparator1)
                        .trim();
                    if (this.field.model[fieldKey].startsWith(this.fileInfoSeparator1)) {
                        this.field.model[fieldKey] = this.field.model[fieldKey].substring(this.fileInfoSeparator1.length);
                    }
                    if (this.field.model[fieldKey].endsWith(this.fileInfoSeparator1)) {
                        this.field.model[fieldKey] = this.field.model[fieldKey].slice(0, -this.fileInfoSeparator1.length);
                    }
                    this.field.formControl.setValue(this.field.model[fieldKey]);
                    //Uploaded file info management
                    let indexOfUploadedFile = this.uploadedFiles.findIndex(x => x.name === file.name);
                    if (indexOfUploadedFile !== -1) {
                        this.uploadedFiles.splice(indexOfUploadedFile, 1);
                    }
                    let indexOfNewlyAddedFile = this.newlyAddedFiles.findIndex(x => x.name === file.name);
                    if (indexOfNewlyAddedFile !== -1) {
                        this.newlyAddedFiles.splice(indexOfNewlyAddedFile, 1);
                    }
                    this.cd.markForCheck();
                }, (error) => {
                    console.log('File remove error: ', error);
                }, () => {
                    this.spinnerService.hideSpinner();
                });
            }
        }
    }
    downloadFile(file) {
        if (file != null && this.showDownloadButton) {
            this.fileService.download(this.formIdentifier, file.id)
                .pipe(take(1))
                .subscribe((response) => {
                const dispositionHeader = response.headers.get('content-disposition');
                if (!dispositionHeader) {
                    throw new Error('content-disposition header is not found');
                }
                const fileName = file.name != null
                    ? file.name
                    : this.getContentFileName(dispositionHeader);
                this.fileSaverService.save(response.body, fileName);
            }, (error) => {
                console.log('File download error: ', error);
            });
        }
    }
    downloadFileViaKeyboard(event, file) {
        this.downloadFile(file);
        event.preventDefault();
    }
    onError($event) {
        this.spinnerService.hideSpinner();
    }
    async createFileThenUpload(dataUrl, fileName) {
        const blob = await (await fetch(dataUrl)).blob();
        const file = new File([blob], fileName);
        this.uploadFile(file);
    }
    uploadFile(file) {
        this.fileService.upload(this.formIdentifier, file, undefined, this.field.key.toString())
            .pipe(take(1), map(id => {
            return {
                id,
                file,
                thumbnailUrl: this.generateFileImageThumbnailUrl(file.name, id)
            };
        }))
            .subscribe((fileData) => {
            if (fileData != null) {
                const fileUploadOnCompleteCallBackMethod = this.field.props.fileUploadOptions?.fileUploadOnComplete;
                if (fileUploadOnCompleteCallBackMethod != null) {
                    var result = this.coreService.applicationFunctions[fileUploadOnCompleteCallBackMethod](file, fileData.id);
                    if (result instanceof Observable) {
                        result.subscribe((data) => {
                            fileData.extraInfoHtml = this.EncodeHtml(data?.html);
                            this.updateModelAndUploadedFilesWith(fileData);
                        });
                    }
                    else {
                        fileData.extraInfoHtml = this.EncodeHtml(result);
                        this.updateModelAndUploadedFilesWith(fileData);
                    }
                }
                else {
                    this.updateModelAndUploadedFilesWith(fileData);
                }
                ;
            }
        }, (error) => {
            console.log(`${file.name} upload error: `, error);
        }, () => {
            this.spinnerService.hideSpinner();
        });
    }
    generateFileImageThumbnailUrl(fileName, fileId) {
        let fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
        if (fileExtension === 'jpg' || fileExtension === 'jpeg'
            || fileExtension === 'png' || fileExtension === 'gif' || fileExtension === 'bmp') {
            return this.props.fileUploadOptions.thumbnailUrlTemplate != null
                ? this.props.fileUploadOptions.thumbnailUrlTemplate
                    .replace('{baseUrl}', this.appSettings.apiUrl)
                    .replace('{formIdentifier}', this.formIdentifier)
                    .replace('{id}', fileId)
                    .replaceAll('//', '/')
                : '';
        }
        else {
            return '';
        }
    }
    updateModelAndUploadedFilesWith(fileData) {
        //fileData should contain an Id of the record in the database for this file.
        let fieldKey = this.field.key.toString();
        let fileInfoFound = false;
        let newFileInfo = fileData.file.name + this.fileInfoSeparator2 + fileData.id;
        if (fileData.extraInfoHtml != null) {
            newFileInfo = newFileInfo + this.fileInfoSeparator2 + fileData.extraInfoHtml;
        }
        if (this.field.model != null
            && this.field.model[fieldKey] != null
            && this.field.model[fieldKey] !== '') {
            //Model management
            let fileInfoList = this.field.model[fieldKey].split(this.fileInfoSeparator1);
            for (let fileInfoText of fileInfoList) {
                let oldFileInfo = fileInfoText;
                let fileInfo = this.getFileInfo(fileInfoText);
                if (fileInfo.name === fileData.file.name) {
                    this.field.model[fieldKey] = this.field.model[fieldKey].replace(oldFileInfo, newFileInfo);
                    fileInfoFound = true;
                    break;
                }
            }
            if (fileInfoFound === false) {
                this.field.model[fieldKey] =
                    this.field.model[fieldKey] + this.fileInfoSeparator1 + newFileInfo;
            }
            this.field.formControl.setValue(this.field.model[fieldKey]);
            //Uploaded file info management
            let uploadedFileInfo = this.uploadedFiles.find(x => x.name === fileData.file.name);
            if (uploadedFileInfo != null) {
                uploadedFileInfo.id = fileData.id;
                let newlyAddedFileInfo = this.newlyAddedFiles.find(x => x.name === fileData.file.name);
                if (newlyAddedFileInfo != null) {
                    newlyAddedFileInfo.id = fileData.id;
                }
            }
            else {
                this.uploadedFiles.push({ name: fileData.file.name, id: fileData.id, thumbnailUrl: fileData.thumbnailUrl, extraInfoHtml: fileData.extraInfoHtml });
                this.newlyAddedFiles.push({ name: fileData.file.name, id: fileData.id });
            }
        }
        else {
            //Model management
            this.field.formControl.setValue(newFileInfo);
            //Uploaded file info management
            this.uploadedFiles.push({ name: fileData.file.name, id: fileData.id, thumbnailUrl: fileData.thumbnailUrl, extraInfoHtml: fileData.extraInfoHtml });
            this.newlyAddedFiles.push({ name: fileData.file.name, id: fileData.id });
        }
        this.cd.markForCheck();
    }
    getFileInfo(fileInfoText) {
        const fileInfoSplit = fileInfoText.split(this.fileInfoSeparator2);
        return {
            name: fileInfoSplit[0],
            id: fileInfoSplit[1],
            extraInfoHtml: fileInfoSplit[2],
            thumbnailUrl: this.generateFileImageThumbnailUrl(fileInfoSplit[0], fileInfoSplit[1])
        };
    }
    EncodeHtml(html) {
        if (html) {
            return btoa(unescape(encodeURIComponent(html)));
        }
        return null;
    }
    DecodeHtml(base64Html) {
        if (base64Html) {
            return decodeURIComponent(escape(atob(base64Html)));
        }
        return null;
    }
    getContentFileName(contentDispositionHeader) {
        const parts = contentDispositionHeader.split(';');
        const filename = parts[1].split('=')[1];
        return filename.replace(/['"]+/g, '');
    }
    isNewlyAddedFile(fileId) {
        return this.newlyAddedFiles.findIndex(x => x.id === fileId) !== -1;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadFieldType, deps: [{ token: ApplicationSettings }, { token: CoreService }, { token: FileService }, { token: i2$4.FileSaverService }, { token: SpinnerService }, { token: i0.ChangeDetectorRef }, { token: i4$5.NgxImageCompressService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FileUploadFieldType, selector: "dspx-fileupload", usesInheritance: true, ngImport: i0, template: "<p-fileUpload [id]=\"id\"\r\n              [name]=\"field.name\"\r\n              multiple=\"multiple\"\r\n              [accept]=\"acceptedFileTypes\"\r\n              [invalidFileTypeMessageDetail]=\"invalidFileTypeMessageDetail\"\r\n              [maxFileSize]=\"maxFileSize\"\r\n              [fileLimit]=\"fileLimit\"\r\n              [auto]=\"auto\"\r\n              [uploadedFiles]=\"uploadedFiles\"\r\n              customUpload=\"true\"\r\n              (uploadHandler)=\"uploadFiles($event)\"\r\n              (onError)=\"onError($event)\"\r\n              chooseIcon=\"fas fa-plus\"\r\n              uploadIcon=\"fas fa-upload\"\r\n              cancelIcon=\"fas fa-times\"\r\n              [disabled]=\"props.disabled\"\r\n              [attr.aria-disabled]=\"props.disabled ? 'true' : undefined\"\r\n              [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n              [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  <ng-template pTemplate=\"content\" let-files>\r\n    <div class=\"grid\">\r\n      <ng-container *ngFor=\"let file of uploadedFiles\">\r\n        <div *ngIf=\"props.fileUploadOptions?.displayThumbnails\" class=\" col-12 sm:col-4 md:col-3 lg:col-2 xl:col-1\">\r\n          <p-image *ngIf=\"file.thumbnailUrl !== ''\" src=\"{{ file.thumbnailUrl }}\" width=\"100%\" [alt]=\"file.name\"\r\n                   [preview]=\"true\" class=\"thumbnail\"></p-image>\r\n          <div *ngIf=\"file.thumbnailUrl === ''\" class=\"nopreview\">\r\n            <br />\r\n            No preview available\r\n            <br />\r\n            &nbsp;\r\n          </div>\r\n        </div>\r\n        <div class=\"col-12\" [ngClass]=\"{'sm:col-8 md:col-9 lg:col-10 xl:col-11': props.fileUploadOptions?.displayThumbnails,\r\n                                        'md:col-12 lg:col-12 file-no-thumbnail': !props.fileUploadOptions?.displayThumbnails}\">\r\n          <div class=\"filename\"\r\n               (click)=\"downloadFile(file)\"\r\n               (keydown.enter)=\"downloadFileViaKeyboard($event, file)\"\r\n               (keydown.space)=\"downloadFileViaKeyboard($event, file)\"\r\n               role=\"link\" tabindex=\"0\" [id]=\"'button-' + file.name\"\r\n               [aria-label]=\"'Click here to download ' + file.name\">\r\n            {{ file.name }}\r\n          </div>\r\n          <div *ngIf=\"file.extraInfoHtml\">\r\n            <p innerHtml=\"{{DecodeHtml(file.extraInfoHtml)}}\"></p>\r\n          </div>\r\n\r\n          <div class=\"button-container\">\r\n            <button *ngIf=\"showDownloadButton\" pButton type=\"button\" class=\"p-button-secondary\"\r\n                    label=\"Download\" title=\"Download\" icon=\"fas fa-download\" (click)=\"downloadFile(file)\"></button>\r\n            <button *ngIf=\"showRemoveButton\r\n                      && (!onlyNewFilesCanBeRemoved || (onlyNewFilesCanBeRemoved && isNewlyAddedFile(file.id)))\"\r\n                    pButton type=\"button\" class=\"p-button-secondary\"\r\n                    label=\"Remove\" title=\"Remove\" icon=\"fas fa-times\" [disabled]=\"props.disabled\"\r\n                    (click)=\"removeFile(file)\"></button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n</p-fileUpload>\r\n", styles: [".p-button-secondary{border-color:transparent}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: FileUpload, selector: "p-fileUpload", inputs: ["name", "url", "method", "multiple", "accept", "disabled", "auto", "withCredentials", "maxFileSize", "invalidFileSizeMessageSummary", "invalidFileSizeMessageDetail", "invalidFileTypeMessageSummary", "invalidFileTypeMessageDetail", "invalidFileLimitMessageDetail", "invalidFileLimitMessageSummary", "style", "styleClass", "previewWidth", "chooseLabel", "uploadLabel", "cancelLabel", "chooseIcon", "uploadIcon", "cancelIcon", "showUploadButton", "showCancelButton", "mode", "headers", "customUpload", "fileLimit", "uploadStyleClass", "cancelStyleClass", "removeStyleClass", "chooseStyleClass", "uploadedFiles", "files"], outputs: ["onBeforeUpload", "onSend", "onUpload", "onError", "onClear", "onRemove", "onSelect", "onProgress", "uploadHandler", "onImageError"] }, { kind: "component", type: i9$1.Image, selector: "p-image", inputs: ["imageClass", "imageStyle", "styleClass", "style", "src", "srcSet", "sizes", "previewImageSrc", "previewImageSrcSet", "previewImageSizes", "alt", "width", "height", "loading", "appendTo", "preview", "showTransitionOptions", "hideTransitionOptions"], outputs: ["onShow", "onHide", "onImageError"] }], changeDetection: i0.ChangeDetectionStrategy.Default }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-fileupload', changeDetection: ChangeDetectionStrategy.Default, template: "<p-fileUpload [id]=\"id\"\r\n              [name]=\"field.name\"\r\n              multiple=\"multiple\"\r\n              [accept]=\"acceptedFileTypes\"\r\n              [invalidFileTypeMessageDetail]=\"invalidFileTypeMessageDetail\"\r\n              [maxFileSize]=\"maxFileSize\"\r\n              [fileLimit]=\"fileLimit\"\r\n              [auto]=\"auto\"\r\n              [uploadedFiles]=\"uploadedFiles\"\r\n              customUpload=\"true\"\r\n              (uploadHandler)=\"uploadFiles($event)\"\r\n              (onError)=\"onError($event)\"\r\n              chooseIcon=\"fas fa-plus\"\r\n              uploadIcon=\"fas fa-upload\"\r\n              cancelIcon=\"fas fa-times\"\r\n              [disabled]=\"props.disabled\"\r\n              [attr.aria-disabled]=\"props.disabled ? 'true' : undefined\"\r\n              [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n              [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  <ng-template pTemplate=\"content\" let-files>\r\n    <div class=\"grid\">\r\n      <ng-container *ngFor=\"let file of uploadedFiles\">\r\n        <div *ngIf=\"props.fileUploadOptions?.displayThumbnails\" class=\" col-12 sm:col-4 md:col-3 lg:col-2 xl:col-1\">\r\n          <p-image *ngIf=\"file.thumbnailUrl !== ''\" src=\"{{ file.thumbnailUrl }}\" width=\"100%\" [alt]=\"file.name\"\r\n                   [preview]=\"true\" class=\"thumbnail\"></p-image>\r\n          <div *ngIf=\"file.thumbnailUrl === ''\" class=\"nopreview\">\r\n            <br />\r\n            No preview available\r\n            <br />\r\n            &nbsp;\r\n          </div>\r\n        </div>\r\n        <div class=\"col-12\" [ngClass]=\"{'sm:col-8 md:col-9 lg:col-10 xl:col-11': props.fileUploadOptions?.displayThumbnails,\r\n                                        'md:col-12 lg:col-12 file-no-thumbnail': !props.fileUploadOptions?.displayThumbnails}\">\r\n          <div class=\"filename\"\r\n               (click)=\"downloadFile(file)\"\r\n               (keydown.enter)=\"downloadFileViaKeyboard($event, file)\"\r\n               (keydown.space)=\"downloadFileViaKeyboard($event, file)\"\r\n               role=\"link\" tabindex=\"0\" [id]=\"'button-' + file.name\"\r\n               [aria-label]=\"'Click here to download ' + file.name\">\r\n            {{ file.name }}\r\n          </div>\r\n          <div *ngIf=\"file.extraInfoHtml\">\r\n            <p innerHtml=\"{{DecodeHtml(file.extraInfoHtml)}}\"></p>\r\n          </div>\r\n\r\n          <div class=\"button-container\">\r\n            <button *ngIf=\"showDownloadButton\" pButton type=\"button\" class=\"p-button-secondary\"\r\n                    label=\"Download\" title=\"Download\" icon=\"fas fa-download\" (click)=\"downloadFile(file)\"></button>\r\n            <button *ngIf=\"showRemoveButton\r\n                      && (!onlyNewFilesCanBeRemoved || (onlyNewFilesCanBeRemoved && isNewlyAddedFile(file.id)))\"\r\n                    pButton type=\"button\" class=\"p-button-secondary\"\r\n                    label=\"Remove\" title=\"Remove\" icon=\"fas fa-times\" [disabled]=\"props.disabled\"\r\n                    (click)=\"removeFile(file)\"></button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n</p-fileUpload>\r\n", styles: [".p-button-secondary{border-color:transparent}\n"] }]
        }], ctorParameters: () => [{ type: ApplicationSettings }, { type: CoreService }, { type: FileService }, { type: i2$4.FileSaverService }, { type: SpinnerService }, { type: i0.ChangeDetectorRef }, { type: i4$5.NgxImageCompressService }] });

/** Used in optionSet.source to specify that this typeahead should retrieve its options by calling a server
 *  api to retrieve a filtered set of options. Equals "filteredApi". */
const FilteredApiSourceSpecifier = "filteredApi";
class AutoCompleteFieldType extends FieldType {
    constructor(http, changeDetector) {
        super();
        this.http = http;
        this.changeDetector = changeDetector;
        this.filteredList = [];
        this.completeOnFocus = undefined;
        this.filterCallCount = 0;
        this.highestReceivedFilterCallResponse = -1;
        this.activeButtonIndex = null;
    }
    ngOnInit() {
        this.filteredList = this.props.options;
        if (typeof this.props.typeaheadOptions?.completeOnFocus === 'boolean') {
            this.completeOnFocus = this.props.typeaheadOptions?.completeOnFocus;
        }
        else {
            if (typeof this.props.typeaheadOptions?.showDropdown === 'boolean') {
                this.completeOnFocus = this.props.typeaheadOptions?.showDropdown;
            }
        }
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    filter($event) {
        // If we're configured to get our options from an API that filters based on a query string
        if (this.props.optionSet.source === FilteredApiSourceSpecifier) {
            this.filterViaApi($event);
            return;
        }
        // Otherwise, our options have been pre-loaded and are available in this.props.option - we just filter those
        if (this.props.options) {
            let filtered = [];
            let query = $event.query;
            this.props.options.forEach(item => {
                // If the query text appears in the option's label (case-insensitive), offer the option
                if (item[this.props.labelProp ? this.props.labelProp : 'label'].toLowerCase().indexOf(query.toLowerCase()) == 0) {
                    filtered.push(item);
                }
            });
            this.filteredList = filtered;
            return;
        }
        throw `${this.field.key} could not handle filter event because no options were available (in this.props.options) and props.optionSet.source is not '${FilteredApiSourceSpecifier}'.`;
    }
    selectQuickOption($event) {
        if (!!$event.value) {
            const selectedOption = this.props.quickSelectionOptions.find(option => option[this.props.valueProp] === $event.value);
            this.field.formControl.setValue(selectedOption);
        }
        else {
            this.field.formControl.setValue($event.value);
        }
    }
    filterViaApi($event) {
        if (!this.props.optionSet.apiEndpoint) {
            throw `${this.field.key} if props.optionSet.source is '${FilteredApiSourceSpecifier}', then props.optionSet.apiEndpoint must be specified`;
        }
        // Call the server to get the options
        this.getApiFilterResponse($event.query)
            .subscribe(response => {
            // Guard against out-of-order processing of responses. This is to ensure that if we receive a response for request 1 AFTER we
            // receive the response for request 2, we discard the response to request 1.
            if (response.filterCallNumber > this.highestReceivedFilterCallResponse) {
                this.highestReceivedFilterCallResponse = response.filterCallNumber;
                this.filteredList = response.httpResponse;
                this.changeDetector.detectChanges();
            }
            else {
                console.debug(`${this.field.key} Discarded server response because its filterCallNumber of ${response.filterCallNumber} is not higher than the most recent one we've processed, ${this.highestReceivedFilterCallResponse}`);
            }
        });
    }
    getApiFilterResponse(query) {
        // Assign this request a filter call number - the first time we call the server, this will be 0, second time, this will be 1, etc.
        // This will be used to ensure that if we receive responses out of order (e.g. due to uneven network latency or server response
        // time, we don't overwrite newer response data with older response data).
        let filterCallNumber = this.filterCallCount++;
        // Uncomment for production
        let request = { optionSetName: this.props.optionSet.name, query: query };
        let responseObservable = this.http.post(this.props.optionSet.apiEndpoint, request);
        // Wrap the raw response in an object that includes the filterCallNumber so the caller can decide whether this info is fresher
        // than whatever they've already processed.
        return responseObservable.pipe(map$1(response => { return { httpResponse: response, filterCallNumber: filterCallNumber }; }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteFieldType, deps: [{ token: i1.HttpClient }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AutoCompleteFieldType, selector: "dspx-autocomplete", usesInheritance: true, ngImport: i0, template: "<div class=\"field-autoComplete\">\r\n    <p-autoComplete [inputId]=\"id + '-input'\"\r\n                    [suggestions]=\"filteredList\"\r\n                    (completeMethod)=\"filter($event)\"\r\n                    [minLength]=\"1\"\r\n                    [field]=\"props.labelProp ? props.labelProp : 'label' \"\r\n                    [forceSelection]=\"true\"\r\n                    [showClear]=\"true\"\r\n                    [dropdown]=\"props.typeaheadOptions?.showDropdown\"\r\n                    [completeOnFocus]=\"completeOnFocus\"\r\n                    [placeholder]=\"props.typeaheadOptions?.hidePlaceholder ? undefined : props.label\"\r\n                    [formControl]=\"formControl\"\r\n                    [formlyAttributes]=\"field\"\r\n                    (onBlur)=\"onBlur($event)\"\r\n                    [class.is-invalid]=\"showError\"\r\n                    [dropdownAriaLabel]=\"props.label + ' options'\"\r\n                    [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n                    [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  </p-autoComplete>\r\n</div>\r\n<div *ngIf=\"props.typeaheadOptions?.showQuickSelection\" class=\"typeAhead-pill-block\" [id]=\"id + '-help'\">\r\n  <div class=\"typeAhead-pill flex mt-2\">\r\n    <span class=\"typeAhead-pill-label mr-4 mb-2\">{{props.typeaheadOptions?.quickSelectionLabel}}</span>\r\n    <p-selectButton [id]=\"id + '_pill'\"\r\n                    [options]=\"props.quickSelectionOptions.slice(0, props.typeaheadOptions?.quickSelectionLimit)\"\r\n                    [multiple]=\"false\"\r\n                    [optionLabel]=\"props.labelProp ? props.labelProp : 'text' \"\r\n                    [optionValue]=\"props.valueProp ? props.valueProp : 'code' \"\r\n                    (onChange)=\"selectQuickOption($event)\" />\r\n  </div>\r\n</div>\r\n", styles: [":host ::ng-deep .p-autocomplete-clear-icon{right:10px}\n"], dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i5.AutoComplete, selector: "p-autoComplete", inputs: ["minLength", "delay", "style", "panelStyle", "styleClass", "panelStyleClass", "inputStyle", "inputId", "inputStyleClass", "placeholder", "readonly", "disabled", "scrollHeight", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "maxlength", "name", "required", "size", "appendTo", "autoHighlight", "forceSelection", "type", "autoZIndex", "baseZIndex", "ariaLabel", "dropdownAriaLabel", "ariaLabelledBy", "dropdownIcon", "unique", "group", "completeOnFocus", "showClear", "field", "dropdown", "showEmptyMessage", "dropdownMode", "multiple", "tabindex", "dataKey", "emptyMessage", "showTransitionOptions", "hideTransitionOptions", "autofocus", "autocomplete", "optionGroupChildren", "optionGroupLabel", "overlayOptions", "suggestions", "itemSize", "optionLabel", "optionValue", "id", "searchMessage", "emptySelectionMessage", "selectionMessage", "autoOptionFocus", "selectOnFocus", "searchLocale", "optionDisabled", "focusOnHover", "variant"], outputs: ["completeMethod", "onSelect", "onUnselect", "onFocus", "onBlur", "onDropdownClick", "onClear", "onKeyUp", "onShow", "onHide", "onLazyLoad"] }, { kind: "component", type: i6$2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "unselectable", "tabindex", "multiple", "allowEmpty", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey", "autofocus"], outputs: ["onOptionClick", "onChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AutoCompleteFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-autocomplete', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"field-autoComplete\">\r\n    <p-autoComplete [inputId]=\"id + '-input'\"\r\n                    [suggestions]=\"filteredList\"\r\n                    (completeMethod)=\"filter($event)\"\r\n                    [minLength]=\"1\"\r\n                    [field]=\"props.labelProp ? props.labelProp : 'label' \"\r\n                    [forceSelection]=\"true\"\r\n                    [showClear]=\"true\"\r\n                    [dropdown]=\"props.typeaheadOptions?.showDropdown\"\r\n                    [completeOnFocus]=\"completeOnFocus\"\r\n                    [placeholder]=\"props.typeaheadOptions?.hidePlaceholder ? undefined : props.label\"\r\n                    [formControl]=\"formControl\"\r\n                    [formlyAttributes]=\"field\"\r\n                    (onBlur)=\"onBlur($event)\"\r\n                    [class.is-invalid]=\"showError\"\r\n                    [dropdownAriaLabel]=\"props.label + ' options'\"\r\n                    [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n                    [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  </p-autoComplete>\r\n</div>\r\n<div *ngIf=\"props.typeaheadOptions?.showQuickSelection\" class=\"typeAhead-pill-block\" [id]=\"id + '-help'\">\r\n  <div class=\"typeAhead-pill flex mt-2\">\r\n    <span class=\"typeAhead-pill-label mr-4 mb-2\">{{props.typeaheadOptions?.quickSelectionLabel}}</span>\r\n    <p-selectButton [id]=\"id + '_pill'\"\r\n                    [options]=\"props.quickSelectionOptions.slice(0, props.typeaheadOptions?.quickSelectionLimit)\"\r\n                    [multiple]=\"false\"\r\n                    [optionLabel]=\"props.labelProp ? props.labelProp : 'text' \"\r\n                    [optionValue]=\"props.valueProp ? props.valueProp : 'code' \"\r\n                    (onChange)=\"selectQuickOption($event)\" />\r\n  </div>\r\n</div>\r\n", styles: [":host ::ng-deep .p-autocomplete-clear-icon{right:10px}\n"] }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i0.ChangeDetectorRef }] });

class AddressFieldType extends FieldType {
    constructor(addressService, changeDetector) {
        super();
        this.addressService = addressService;
        this.changeDetector = changeDetector;
        this.filteredList = [];
        this.displayList = [];
    }
    ngOnInit() {
        this.filteredList = [];
        this.displayList = [];
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    filter($event) {
        let query = $event.query;
        let matches = [];
        let matchesDisplay = [];
        this.addressService.search(query)
            .pipe(take(1))
            .subscribe((data) => {
            data.forEach(address => {
                matches.push(address);
                matchesDisplay.push(address['display']);
            });
            this.filteredList = matches;
            this.displayList = matchesDisplay;
            this.changeDetector.detectChanges();
        });
    }
    addressSelected(field) {
        let addressFieldKey = field.key.toString();
        let model = field.model;
        let formControl = field.formControl;
        let autoStreetFieldKey = `${addressFieldKey}-autoStreetNumberName`;
        let autoSuburbFieldKey = `${addressFieldKey}-autoSuburb`;
        let autoStateFieldKey = `${addressFieldKey}-autoState`;
        let autoPostcodeFieldKey = `${addressFieldKey}-autoPostCode`;
        let autoLatitude = `${addressFieldKey}-autoLatitude`;
        let autoLongitude = `${addressFieldKey}-autoLongitude`;
        let manualStreetFieldKey = `${addressFieldKey}-streetNumberName`;
        let manualSuburbFieldKey = `${addressFieldKey}-suburb`;
        let manualStateFieldKey = `${addressFieldKey}-state`;
        let manualPostcodeFieldKey = `${addressFieldKey}-postCode`;
        if (!isNullOrWhitespaceOnly(formControl.value)) {
            model[addressFieldKey] = formControl.value;
            let address = this.filteredList.find(address => address.display === formControl.value);
            if (address != null) {
                model[autoStreetFieldKey] = address.addressDetails.addressLine;
                model[autoSuburbFieldKey] = address.addressDetails.locality;
                model[autoStateFieldKey] = address.addressDetails.state;
                model[autoPostcodeFieldKey] = address.addressDetails.postcode;
                model[autoLatitude] = address.location.latitude;
                model[autoLongitude] = address.location.longitude;
                //Adding the address detail values to form control values since the actual controls are of type empty the model value is not mapped to the control value.
                let controls = formControl.parent.controls;
                if (controls[autoStreetFieldKey] != null) {
                    controls[autoStreetFieldKey].value = address.addressDetails.addressLine;
                }
                if (controls[autoSuburbFieldKey] != null) {
                    controls[autoSuburbFieldKey].value = address.addressDetails.locality;
                }
                if (controls[autoStateFieldKey] != null) {
                    controls[autoStateFieldKey].value = address.addressDetails.state;
                }
                if (controls[autoPostcodeFieldKey] != null) {
                    controls[autoPostcodeFieldKey].value = address.addressDetails.postcode;
                }
                if (controls[autoLatitude] != null) {
                    controls[autoLatitude].value = address.location.latitude;
                }
                if (controls[autoLongitude] != null) {
                    controls[autoLongitude].value = address.location.longitude;
                }
                delete model[manualStreetFieldKey];
                delete model[manualSuburbFieldKey];
                delete model[manualStateFieldKey];
                delete model[manualPostcodeFieldKey];
                //There is the option to automatically set the response to a question for Local Government Area by calling the
                //address microservice and retrieving the LGA based on the address selected.
                //It is assumed that the LGA question is in the same section as the address question.
                if (field.props.retrieveLga === true && field.props.lgaQuestionCode != null) {
                    this.addressService.searchLga(address.location.latitude, address.location.longitude)
                        .pipe(take(1))
                        .subscribe(data => {
                        if (data != null && data['lga_official_name'] != null) {
                            let lgaQuestionKey = field.props.lgaQuestionCode;
                            let response = (field.formControl.parent.controls[lgaQuestionKey]._fields[0].type === 'input'
                                || field.formControl.parent.controls[lgaQuestionKey]._fields[0].type === 'text')
                                ? data['lga_official_name'].toString()
                                : data['abs_lga_code'].toString();
                            if (field.formControl.parent.controls[lgaQuestionKey]._fields[0].type === 'multiselect'
                                || field.formControl.parent.controls[lgaQuestionKey]._fields[0].type === 'multicheckbox') {
                                let responseArray = field.formControl.parent.controls[lgaQuestionKey].value;
                                if (responseArray != null) {
                                    responseArray.push(response);
                                    field.formControl.parent.controls[lgaQuestionKey].patchValue(responseArray);
                                }
                                else {
                                    field.formControl.parent.controls[lgaQuestionKey].patchValue([response]);
                                }
                            }
                            else {
                                field.formControl.parent.controls[lgaQuestionKey].patchValue(response);
                            }
                        }
                    });
                }
            }
        }
        else {
            delete model[addressFieldKey];
            delete model[autoStreetFieldKey];
            delete model[autoSuburbFieldKey];
            delete model[autoStateFieldKey];
            delete model[autoPostcodeFieldKey];
            delete model[manualStreetFieldKey];
            delete model[manualSuburbFieldKey];
            delete model[manualStateFieldKey];
            delete model[manualPostcodeFieldKey];
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressFieldType, deps: [{ token: AddressService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: AddressFieldType, selector: "dspx-address", usesInheritance: true, ngImport: i0, template: "<p-autoComplete [inputId]=\"id + '-input'\"\r\n                [suggestions]=\"displayList\"\r\n                (completeMethod)=\"filter($event)\"\r\n                [minLength]=\"1\"\r\n                [showClear]=\"true\"\r\n                [forceSelection]=\"true\"\r\n                placeholder=\"Start typing an address\"\r\n                [formControl]=\"formControl\"\r\n                [formlyAttributes]=\"field\"\r\n                (onBlur)=\"onBlur($event)\"\r\n                (onSelect)=\"addressSelected(this.field)\"\r\n                [required]=\"props.required ? 'true' : undefined\"\r\n                [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-autoComplete>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i5.AutoComplete, selector: "p-autoComplete", inputs: ["minLength", "delay", "style", "panelStyle", "styleClass", "panelStyleClass", "inputStyle", "inputId", "inputStyleClass", "placeholder", "readonly", "disabled", "scrollHeight", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "maxlength", "name", "required", "size", "appendTo", "autoHighlight", "forceSelection", "type", "autoZIndex", "baseZIndex", "ariaLabel", "dropdownAriaLabel", "ariaLabelledBy", "dropdownIcon", "unique", "group", "completeOnFocus", "showClear", "field", "dropdown", "showEmptyMessage", "dropdownMode", "multiple", "tabindex", "dataKey", "emptyMessage", "showTransitionOptions", "hideTransitionOptions", "autofocus", "autocomplete", "optionGroupChildren", "optionGroupLabel", "overlayOptions", "suggestions", "itemSize", "optionLabel", "optionValue", "id", "searchMessage", "emptySelectionMessage", "selectionMessage", "autoOptionFocus", "selectOnFocus", "searchLocale", "optionDisabled", "focusOnHover", "variant"], outputs: ["completeMethod", "onSelect", "onUnselect", "onFocus", "onBlur", "onDropdownClick", "onClear", "onKeyUp", "onShow", "onHide", "onLazyLoad"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AddressFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-address', template: "<p-autoComplete [inputId]=\"id + '-input'\"\r\n                [suggestions]=\"displayList\"\r\n                (completeMethod)=\"filter($event)\"\r\n                [minLength]=\"1\"\r\n                [showClear]=\"true\"\r\n                [forceSelection]=\"true\"\r\n                placeholder=\"Start typing an address\"\r\n                [formControl]=\"formControl\"\r\n                [formlyAttributes]=\"field\"\r\n                (onBlur)=\"onBlur($event)\"\r\n                (onSelect)=\"addressSelected(this.field)\"\r\n                [required]=\"props.required ? 'true' : undefined\"\r\n                [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-autoComplete>\r\n" }]
        }], ctorParameters: () => [{ type: AddressService }, { type: i0.ChangeDetectorRef }] });

class MaskedInputFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MaskedInputFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: MaskedInputFieldType, selector: "dspx-masked-input", usesInheritance: true, ngImport: i0, template: "<p-inputMask\r\n  [inputId]=\"id\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [mask]=\"props.maskedInputOptions?.inputMask\"\r\n  [placeholder] = \"props.maskedInputOptions?.placeholder\"\r\n  [characterPattern]=\"props.maskedInputOptions?.characterPattern\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-inputMask>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$7.InputMask, selector: "p-inputMask", inputs: ["type", "slotChar", "autoClear", "showClear", "style", "inputId", "styleClass", "placeholder", "size", "maxlength", "tabindex", "title", "variant", "ariaLabel", "ariaLabelledBy", "ariaRequired", "disabled", "readonly", "unmask", "name", "required", "characterPattern", "autofocus", "autoFocus", "autocomplete", "keepBuffer", "mask"], outputs: ["onComplete", "onFocus", "onBlur", "onInput", "onKeydown", "onClear"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MaskedInputFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-masked-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-inputMask\r\n  [inputId]=\"id\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [mask]=\"props.maskedInputOptions?.inputMask\"\r\n  [placeholder] = \"props.maskedInputOptions?.placeholder\"\r\n  [characterPattern]=\"props.maskedInputOptions?.characterPattern\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-inputMask>\r\n" }]
        }] });

class TextAreaFieldType extends FieldType {
    ngOnInit() {
        if (this.field.props.maxLength) {
            this.formControl.valueChanges.subscribe((value) => {
                this.remainingCharacters = value ? this.field.props.maxLength - value.length : this.field.props.maxLength;
            });
            this.formControl.updateValueAndValidity({
                onlySelf: true,
                emitEvent: true
            });
        }
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextAreaFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TextAreaFieldType, selector: "dspx-textarea", usesInheritance: true, ngImport: i0, template: "<textarea\r\n  [id]=\"id\"\r\n  [rows]=\"5\"\r\n  [cols]=\"30\"\r\n  pInputTextarea\r\n  [formControl] = \"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [spellcheck]=\"props.spellCheck\"\r\n  [ngClass]=\"{'allow-scroll': props.disabled}\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</textarea>\r\n<p *ngIf=\"field.props.maxLength && remainingCharacters\">{{remainingCharacters}} characters left</p>\r\n", styles: [".allow-scroll{overflow-y:scroll}\n"], dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i4$6.InputTextarea, selector: "[pInputTextarea]", inputs: ["autoResize", "variant"], outputs: ["onResize"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextAreaFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-textarea', changeDetection: ChangeDetectionStrategy.OnPush, template: "<textarea\r\n  [id]=\"id\"\r\n  [rows]=\"5\"\r\n  [cols]=\"30\"\r\n  pInputTextarea\r\n  [formControl] = \"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [spellcheck]=\"props.spellCheck\"\r\n  [ngClass]=\"{'allow-scroll': props.disabled}\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</textarea>\r\n<p *ngIf=\"field.props.maxLength && remainingCharacters\">{{remainingCharacters}} characters left</p>\r\n", styles: [".allow-scroll{overflow-y:scroll}\n"] }]
        }] });

class MultiselectFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: MultiselectFieldType, selector: "dspx-multiselect", usesInheritance: true, ngImport: i0, template: "<p-multiSelect\r\n  [inputId]=\"id + '-input'\"\r\n  [options]=\"props.options\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (onBlur)=\"onBlur($event)\"\r\n  [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n  [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n  [ariaLabel]=\"'Type to filter options below'\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-multiSelect>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$8.MultiSelect, selector: "p-multiSelect", inputs: ["id", "ariaLabel", "style", "styleClass", "panelStyle", "panelStyleClass", "inputId", "disabled", "readonly", "group", "filter", "filterPlaceHolder", "filterLocale", "overlayVisible", "tabindex", "variant", "appendTo", "dataKey", "name", "ariaLabelledBy", "displaySelectedLabel", "maxSelectedLabels", "selectionLimit", "selectedItemsLabel", "showToggleAll", "emptyFilterMessage", "emptyMessage", "resetFilterOnHide", "dropdownIcon", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "showHeader", "filterBy", "scrollHeight", "lazy", "virtualScroll", "loading", "virtualScrollItemSize", "loadingIcon", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "filterMatchMode", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "autofocusFilter", "display", "autocomplete", "showClear", "autofocus", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "defaultLabel", "placeholder", "options", "filterValue", "itemSize", "selectAll", "focusOnHover", "filterFields", "selectOnFocus", "autoOptionFocus"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onClear", "onPanelShow", "onPanelHide", "onLazyLoad", "onRemove", "onSelectAllChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-multiselect', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-multiSelect\r\n  [inputId]=\"id + '-input'\"\r\n  [options]=\"props.options\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (onBlur)=\"onBlur($event)\"\r\n  [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n  [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n  [ariaLabel]=\"'Type to filter options below'\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-multiSelect>\r\n" }]
        }] });

class MultiselectPillFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectPillFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: MultiselectPillFieldType, selector: "dspx-multi-select-pill", usesInheritance: true, ngImport: i0, template: "<div class=\"multi-select-pill\">\r\n    <p-selectButton\r\n        [id]=\"id\"\r\n        [options]=\"props.options\"\r\n        [formControl]=\"formControl\"\r\n        [formlyAttributes]=\"field\"\r\n        (onBlur)=\"onBlur($event)\"\r\n        [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n        [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n        [multiple]=\"true\"\r\n        [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n        [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n        [ngStyle]=\"{'max-width': props.pillOptions.maxWidth}\"\r\n        [ngClass]=\"['columns-' + props.pillOptions.columnCount]\"\r\n    />\r\n</div>\r\n", styles: [":host ::ng-deep .multi-select-pill .p-element{display:block}:host ::ng-deep .multi-select-pill .p-element .p-selectbutton{display:grid;gap:1rem}:host ::ng-deep .multi-select-pill .columns-1 .p-component{grid-template-columns:repeat(1,1fr)}:host ::ng-deep .multi-select-pill .columns-2 .p-component{grid-template-columns:repeat(2,1fr)}:host ::ng-deep .multi-select-pill .columns-3 .p-component{grid-template-columns:repeat(3,1fr)}:host ::ng-deep .multi-select-pill .columns-4 .p-component{grid-template-columns:repeat(4,1fr)}:host ::ng-deep .multi-select-pill .columns-5 .p-component{grid-template-columns:repeat(5,1fr)}:host ::ng-deep .multi-select-pill .columns-6 .p-component{grid-template-columns:repeat(6,1fr)}:host ::ng-deep .multi-select-pill .columns-7 .p-component{grid-template-columns:repeat(7,1fr)}:host ::ng-deep .multi-select-pill .columns-8 .p-component{grid-template-columns:repeat(8,1fr)}:host ::ng-deep .multi-select-pill .columns-9 .p-component{grid-template-columns:repeat(9,1fr)}:host ::ng-deep .multi-select-pill .columns-10 .p-component{grid-template-columns:repeat(10,1fr)}:host ::ng-deep .multi-select-pill .columns-11 .p-component{grid-template-columns:repeat(11,1fr)}:host ::ng-deep .multi-select-pill .columns-12 .p-component{grid-template-columns:repeat(12,1fr)}\n"], dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i6$2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "unselectable", "tabindex", "multiple", "allowEmpty", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey", "autofocus"], outputs: ["onOptionClick", "onChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MultiselectPillFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-multi-select-pill', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"multi-select-pill\">\r\n    <p-selectButton\r\n        [id]=\"id\"\r\n        [options]=\"props.options\"\r\n        [formControl]=\"formControl\"\r\n        [formlyAttributes]=\"field\"\r\n        (onBlur)=\"onBlur($event)\"\r\n        [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n        [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n        [multiple]=\"true\"\r\n        [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n        [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n        [ngStyle]=\"{'max-width': props.pillOptions.maxWidth}\"\r\n        [ngClass]=\"['columns-' + props.pillOptions.columnCount]\"\r\n    />\r\n</div>\r\n", styles: [":host ::ng-deep .multi-select-pill .p-element{display:block}:host ::ng-deep .multi-select-pill .p-element .p-selectbutton{display:grid;gap:1rem}:host ::ng-deep .multi-select-pill .columns-1 .p-component{grid-template-columns:repeat(1,1fr)}:host ::ng-deep .multi-select-pill .columns-2 .p-component{grid-template-columns:repeat(2,1fr)}:host ::ng-deep .multi-select-pill .columns-3 .p-component{grid-template-columns:repeat(3,1fr)}:host ::ng-deep .multi-select-pill .columns-4 .p-component{grid-template-columns:repeat(4,1fr)}:host ::ng-deep .multi-select-pill .columns-5 .p-component{grid-template-columns:repeat(5,1fr)}:host ::ng-deep .multi-select-pill .columns-6 .p-component{grid-template-columns:repeat(6,1fr)}:host ::ng-deep .multi-select-pill .columns-7 .p-component{grid-template-columns:repeat(7,1fr)}:host ::ng-deep .multi-select-pill .columns-8 .p-component{grid-template-columns:repeat(8,1fr)}:host ::ng-deep .multi-select-pill .columns-9 .p-component{grid-template-columns:repeat(9,1fr)}:host ::ng-deep .multi-select-pill .columns-10 .p-component{grid-template-columns:repeat(10,1fr)}:host ::ng-deep .multi-select-pill .columns-11 .p-component{grid-template-columns:repeat(11,1fr)}:host ::ng-deep .multi-select-pill .columns-12 .p-component{grid-template-columns:repeat(12,1fr)}\n"] }]
        }] });

class ParagraphFieldType extends FieldType {
    getParagraphHtml() {
        let paragraphHtml = this.field.props.label;
        //Tokens within the paragraph text are expected to be in this format: {{<tabKey>,<pageKey>,<pageIndex>,<sectionKey>,<sectionIndex>,<questionKey>}}
        //e.g. {{tab1,page1,-1,client,-1,firstName}}
        let tokens = paragraphHtml.match(/\{{(.*?)}}/g);
        if (tokens != null) {
            //Loop through each token and retrieve the response for the question referenced by the token from the model.
            //Then replace the token in the paragraph text with the response value.
            for (let token of tokens) {
                let tokenComponents = token.replace('{{', '').replace('}}', '').split(',');
                let tabKey = tokenComponents[0].trim();
                let pageKey = tokenComponents[1].trim();
                let pageIndex = +tokenComponents[2].trim();
                let sectionKey = tokenComponents[3].trim();
                let sectionIndex = +tokenComponents[4].trim();
                let questionKey = tokenComponents[5].trim();
                let response = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionKey);
                //Check if the token field is an address and then check if it is a manual address.
                //If it's a manual address, we must retrieve the manual address components and concatenate them.
                let tabNumber = +tabKey.replace('tab', '');
                let pageNumber = +pageKey.replace('page', '');
                let page = this.field.parent.parent.parent.parent.fieldGroup[tabNumber - 1].fieldGroup[pageNumber - 1];
                let sections = page.fieldGroup != null
                    ? page.fieldGroup
                    : page.fieldArray.fieldGroup;
                let section = sections.find(f => f.key === sectionKey);
                if (section != null) {
                    let questions = section.fieldGroup != null
                        ? section.fieldGroup
                        : section.fieldArray.fieldGroup;
                    let question = questions.find(f => f.key === questionKey);
                    if (question != null && question.type === 'address') {
                        let isManualAddress = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, `${questionKey}-manualAddress`);
                        if (isManualAddress === 'true') {
                            let streetAddress = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, `${questionKey}-streetNumberName`);
                            let suburb = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, `${questionKey}-suburb`);
                            let state = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, `${questionKey}-state`);
                            let postCode = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, `${questionKey}-postCode`);
                            response = `${streetAddress != null ? streetAddress : ''}, ${suburb != null ? suburb : ''}, ${state != null ? state : ''}, ${postCode != null ? postCode : ''}`;
                        }
                    }
                }
                response = response != null ? response : '';
                paragraphHtml = paragraphHtml.replace(token, response);
            }
            return paragraphHtml;
        }
        else {
            return this.field.props.label;
        }
    }
    getModel() {
        let model = this.field.parent.parent.parent.parent.model;
        return (model === undefined || model === null) ? {} : model;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ParagraphFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ParagraphFieldType, selector: "dspx-paragraph", usesInheritance: true, ngImport: i0, template: "<p innerHtml=\"{{getParagraphHtml()}}\"></p>\r\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ParagraphFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-paragraph', template: "<p innerHtml=\"{{getParagraphHtml()}}\"></p>\r\n" }]
        }] });

class PasswordFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PasswordFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PasswordFieldType, selector: "dspx-password", usesInheritance: true, ngImport: i0, template: "<input\r\n  [id]=\"id\"\r\n  type=\"password\"\r\n  pPassword\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n  [feedback]=\"false\"/>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$9.PasswordDirective, selector: "[pPassword]", inputs: ["promptLabel", "weakLabel", "mediumLabel", "strongLabel", "feedback", "showPassword", "variant"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PasswordFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-password', changeDetection: ChangeDetectionStrategy.OnPush, template: "<input\r\n  [id]=\"id\"\r\n  type=\"password\"\r\n  pPassword\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n  [feedback]=\"false\"/>\r\n" }]
        }] });

class StepsFieldType extends FieldType {
    constructor(formNavigationService) {
        super();
        this.formNavigationService = formNavigationService;
        this.steps = [];
        this.activeIndex = 0;
    }
    ngOnInit() {
        if (this.field.fieldGroup) {
            this.field.fieldGroup.forEach(f => {
                this.steps.push({
                    label: f.props.label
                });
            });
        }
        this.formNavigationService.onNavigation().subscribe(fne => {
            if (this.activeIndex != this.formNavigationService.currentTabIndex) {
                this.activeIndex = this.formNavigationService.currentTabIndex;
            }
        });
    }
    isValid(field) {
        if (field.key) {
            return field.formControl.valid;
        }
        return field.fieldGroup.every((f) => this.isValid(f));
    }
    onActiveIndexChange(event) {
        this.activeIndex = event;
    }
    getActiveFormGroup() {
        return this.field.fieldGroup && this.field.fieldGroup[this.activeIndex] ? this.field.fieldGroup[this.activeIndex] : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepsFieldType, deps: [{ token: FormNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: StepsFieldType, selector: "dspx-steps", usesInheritance: true, ngImport: i0, template: "<p-steps [model]=\"steps\" [readonly]=\"false\" [activeIndex]=\"activeIndex\" (activeIndexChange)=\"onActiveIndexChange($event)\"></p-steps>\r\n<div>\r\n  <formly-field [field]=\"getActiveFormGroup()\"></formly-field>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "component", type: i3$a.Steps, selector: "p-steps", inputs: ["activeIndex", "model", "readonly", "style", "styleClass", "exact"], outputs: ["activeIndexChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: StepsFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-steps', template: "<p-steps [model]=\"steps\" [readonly]=\"false\" [activeIndex]=\"activeIndex\" (activeIndexChange)=\"onActiveIndexChange($event)\"></p-steps>\r\n<div>\r\n  <formly-field [field]=\"getActiveFormGroup()\"></formly-field>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: FormNavigationService }] });

class TabsFieldType extends FieldType {
    constructor(formNavigationService, changeDetector) {
        super();
        this.formNavigationService = formNavigationService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.formNavigationService.onNavigation().subscribe(fne => {
            this.changeDetector.detectChanges();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabsFieldType, deps: [{ token: FormNavigationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TabsFieldType, selector: "dspx-tabs", usesInheritance: true, ngImport: i0, template: "<dspx-tab-set [tabsConfig]=\"field\"></dspx-tab-set>", styles: [".hidden{visibility:hidden}.visible{visibility:visible}.tab-progress-badge{margin-left:5px}\n"], dependencies: [{ kind: "component", type: DspxTabSetComponent, selector: "dspx-tab-set", inputs: ["tabsConfig"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TabsFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-tabs', template: "<dspx-tab-set [tabsConfig]=\"field\"></dspx-tab-set>", styles: [".hidden{visibility:hidden}.visible{visibility:visible}.tab-progress-badge{margin-left:5px}\n"] }]
        }], ctorParameters: () => [{ type: FormNavigationService }, { type: i0.ChangeDetectorRef }] });

class VerticalStepperFieldType extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VerticalStepperFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: VerticalStepperFieldType, selector: "dspx-vertical-stepper", usesInheritance: true, ngImport: i0, template: "<dspx-sequential-navigation [tabsConfig]=\"field\" [sticky]=\"props.stickyLayout\" [pageNavigationForTab]=\"props.pageNavigationFor\" [headerBarContent]=\"props.headerBarContent\" [headerBarSticky]=\"props.headerBarSticky\" [headerBarStickySettings]=\"props.headerBarStickySettings\"></dspx-sequential-navigation>\r\n", dependencies: [{ kind: "component", type: DspxSequentialNavigationComponent, selector: "dspx-sequential-navigation", inputs: ["sticky", "tabsConfig", "pageNavigationForTab", "controlClose", "hasVisibleChildren", "isVerticalNavigation", "headerBarContent", "headerBarSticky", "headerBarStickySettings", "activeIndex"], outputs: ["onChange", "onClose", "activeIndexChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: VerticalStepperFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-vertical-stepper', template: "<dspx-sequential-navigation [tabsConfig]=\"field\" [sticky]=\"props.stickyLayout\" [pageNavigationForTab]=\"props.pageNavigationFor\" [headerBarContent]=\"props.headerBarContent\" [headerBarSticky]=\"props.headerBarSticky\" [headerBarStickySettings]=\"props.headerBarStickySettings\"></dspx-sequential-navigation>\r\n" }]
        }] });

class HorizontalStepperFieldType extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HorizontalStepperFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HorizontalStepperFieldType, selector: "dspx-horizontal-stepper", usesInheritance: true, ngImport: i0, template: "<dspx-sequential-navigation [tabsConfig]=\"field\" [sticky]=\"props.stickyLayout\" [pageNavigationForTab]=\"props.pageNavigationFor\" [headerBarContent]=\"props.headerBarContent\" [headerBarSticky]=\"props.headerBarSticky\" [headerBarStickySettings]=\"props.headerBarStickySettings\" [isVerticalNavigation]=\"false\"></dspx-sequential-navigation>\r\n\r\n", dependencies: [{ kind: "component", type: DspxSequentialNavigationComponent, selector: "dspx-sequential-navigation", inputs: ["sticky", "tabsConfig", "pageNavigationForTab", "controlClose", "hasVisibleChildren", "isVerticalNavigation", "headerBarContent", "headerBarSticky", "headerBarStickySettings", "activeIndex"], outputs: ["onChange", "onClose", "activeIndexChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HorizontalStepperFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-horizontal-stepper', template: "<dspx-sequential-navigation [tabsConfig]=\"field\" [sticky]=\"props.stickyLayout\" [pageNavigationForTab]=\"props.pageNavigationFor\" [headerBarContent]=\"props.headerBarContent\" [headerBarSticky]=\"props.headerBarSticky\" [headerBarStickySettings]=\"props.headerBarStickySettings\" [isVerticalNavigation]=\"false\"></dspx-sequential-navigation>\r\n\r\n" }]
        }] });

class FormNavigationFieldType extends FieldType {
    isNotEmpty() {
        return this.requiresCancelButton ||
            (this.canNavigateBack(this) && this.requiresBackButton) ||
            (this.canNavigateNext(this) && this.requiresNextButton) ||
            (this.actionButtons && this.evalCondition(this.actionButtons.condition)) ||
            this.actionButtons?.buttonGroupItems?.some(item => item && this.evalCondition(item.condition));
    }
    getButtonTitle(title, label) {
        return title === label ? '' : title;
    }
    getBackButtonLabel() { return this.backButtonLabel || "Back"; }
    ;
    getNextButtonLabel() { return this.nextButtonLabel || "Next"; }
    ;
    getCancelButtonLabel() { return this.cancelButtonLabel || "Cancel"; }
    ;
    constructor(formNavigationService) {
        super();
        this.formNavigationService = formNavigationService;
        this.topDividerDisplay = 'always';
        this.bottomDividerDisplay = 'never';
        this.getBackButtonTitle = () => this.getButtonTitle(this.backButtonTitle || "Go to previous page", this.getBackButtonLabel());
        this.getNextButtonTitle = () => this.getButtonTitle(this.nextButtonTitle || "Go to next page", this.getNextButtonLabel());
        this.getCancelButtonTitle = () => this.getButtonTitle(this.cancelButtonTitle || "Cancel", this.getCancelButtonLabel());
        this.navigationGroupKey = '';
    }
    ngOnInit() {
        // this.component = this;
        // this.navigationGroupKey = this.formNavigationService.register(this.field);
    }
    get isValid() {
        if (this.field.key) {
            return this.field.formControl.valid;
        }
        return this.field.fieldGroup.every((f) => this.isValid(f));
    }
    canNavigateNext(component) {
        if (component && component.formNavigationService) {
            return component.formNavigationService.canNavigateNext();
        }
        return false;
    }
    canNavigateBack(component) {
        if (component && component.formNavigationService) {
            return component.formNavigationService.canNavigateBack();
        }
        return false;
    }
    evalCondition(expression) {
        if (expression === null || expression === undefined) {
            return true;
        }
        if (typeof expression === 'function') {
            return expression.apply(null, null);
        }
        else if (typeof expression === 'string') {
            return Function(null, `return ${expression};`);
        }
        else {
            return expression ? true : false;
        }
    }
    cancel(component) {
        component.formNavigationService.cancel();
    }
    buttonGroupClick(buttonGroupItem) {
        if (buttonGroupItem.requiresValidation) {
            this.pageField.props.showValidationSummary = false;
            if (this.pageField.formControl.valid === false && this.pageField.props["isEditable"] === true) {
                this.pageField.props.showValidationSummary = true;
                markChildControlsAsTouched(this.pageField.formControl);
                this.navigateToError();
            }
        }
        buttonGroupItem.command();
    }
    actionButtonClick(actionButton) {
        if (actionButton.requiresValidation) {
            this.pageField.props.showValidationSummary = false;
            if (this.pageField.formControl.valid === false && this.pageField.props["isEditable"] === true) {
                this.pageField.props.showValidationSummary = true;
                markChildControlsAsTouched(this.pageField.formControl);
                this.navigateToError();
            }
        }
        actionButton.onClick();
    }
    moveNext(component) {
        //Check navigateWithoutValidation
        if (this.pageField.props['navigateWithoutValidation'] === false && this.pageField.formControl.valid === false
            && this.pageField.props['isEditable'] === true) {
            markChildControlsAsTouched(this.pageField.formControl);
            this.pageField.props.showValidationSummary = true;
            if (this.pageField.formControl.valid === false) {
                this.navigateToError();
            }
            else if (this.pageField.formControl.valid) {
                this.pageField.props.showValidationSummary = false;
                component.formNavigationService.moveNext();
            }
        }
        else {
            this.pageField.props.showValidationSummary = false;
            component.formNavigationService.moveNext();
        }
    }
    moveBack(component) {
        component.formNavigationService.moveBack();
    }
    navigateToError() {
        var validationErrorElementId = `validation-error-${this.pageField.parent.key.toString()}-${this.pageField.key.toString()}`;
        setTimeout(() => {
            if (document.getElementById(validationErrorElementId) != null) {
                document.getElementById(validationErrorElementId).scrollIntoView();
                document.getElementById(validationErrorElementId).focus();
            }
        }, 200);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormNavigationFieldType, deps: [{ token: FormNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormNavigationFieldType, selector: "dspx-form-navigation", inputs: { actionButtons: "actionButtons", requiresBackButton: "requiresBackButton", backButtonLabel: "backButtonLabel", backButtonTitle: "backButtonTitle", requiresNextButton: "requiresNextButton", nextButtonLabel: "nextButtonLabel", nextButtonTitle: "nextButtonTitle", requiresCancelButton: "requiresCancelButton", cancelButtonLabel: "cancelButtonLabel", cancelButtonTitle: "cancelButtonTitle", pageField: "pageField", topDividerDisplay: "topDividerDisplay", bottomDividerDisplay: "bottomDividerDisplay" }, usesInheritance: true, ngImport: i0, template: "<p-divider *ngIf=\"topDividerDisplay === 'always' || (topDividerDisplay === 'auto' && isNotEmpty())\"></p-divider>\r\n<div class=\"form-navigation\">\r\n  <div class=\"leftButtons\" *ngIf=\"(canNavigateBack(this) && requiresBackButton) || requiresCancelButton\">\r\n    <button pButton\r\n            *ngIf=\"canNavigateBack(this) && requiresBackButton\"\r\n            type=\"button\"\r\n            class=\"p-button-secondary\"\r\n            label=\"{{getBackButtonLabel()}}\"\r\n            icon=\"fas fa-chevron-left\"\r\n            iconPos=\"left\"\r\n            title=\"{{getBackButtonTitle()}}\"\r\n            (click)=\"moveBack(this)\">\r\n    </button>\r\n    <button pButton\r\n            *ngIf=\"requiresCancelButton\"\r\n            type=\"button\"\r\n            class=\"p-button-secondary\"\r\n            label=\"{{getCancelButtonLabel()}}\"\r\n            title=\"{{getCancelButtonTitle()}}\"\r\n            icon=\"fas fa-times-circle\"\r\n            iconPos=\"right\"\r\n            (click)=\"cancel(this)\">\r\n    </button>\r\n  </div>\r\n  <div *ngIf=\"actionButtons\"\r\n       class=\"middleButtons\" [ngClass]=\"{'noRightButtons': !canNavigateNext(this) || !requiresNextButton}\">\r\n    <ng-container *ngFor=\"let bgi of actionButtons.buttonGroupItems\">\r\n      <button pButton\r\n              *ngIf=\"evalCondition(bgi.condition)\"\r\n              type=\"button\"\r\n              class=\"p-button-secondary\"\r\n              label=\"{{bgi.label}}\"\r\n              title=\"{{bgi.label}}\"\r\n              icon=\"{{bgi.icon}}\"\r\n              [disabled]=\"actionButtons.disabled\"\r\n              (click)=\"buttonGroupClick(bgi)\"\r\n              id=\"{{pageField.key}}-{{bgi.code}}\">\r\n      </button>\r\n    </ng-container>\r\n    <button pButton\r\n            *ngIf=\"evalCondition(actionButtons.condition)\"\r\n            type=\"button\"\r\n            label=\"{{actionButtons.label}}\"\r\n            title=\"{{actionButtons.label}}\"\r\n            icon=\"{{actionButtons.icon}}\"\r\n            iconPos=\"{{actionButtons.iconPosition}}\"\r\n            [disabled]=\"actionButtons.disabled\"\r\n            (click)=\"actionButtonClick(actionButtons)\"\r\n            id=\"{{pageField.key}}-{{actionButtons.code}}\">\r\n    </button>\r\n  </div>\r\n  <button pButton\r\n          *ngIf=\"canNavigateNext(this) && requiresNextButton\"\r\n          class=\"rightButtons mr-0\"\r\n          type=\"button\"\r\n          label=\"{{getNextButtonLabel()}}\"\r\n          title=\"{{getNextButtonTitle()}}\"\r\n          icon=\"fas fa-chevron-right\"\r\n          iconPos=\"right\"\r\n          (click)=\"moveNext(this)\">\r\n  </button>\r\n</div>\r\n<p-divider *ngIf=\"bottomDividerDisplay === 'always' || (bottomDividerDisplay === 'auto' && isNotEmpty())\"></p-divider>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i2$3.Divider, selector: "p-divider", inputs: ["style", "styleClass", "layout", "type", "align"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormNavigationFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-navigation', template: "<p-divider *ngIf=\"topDividerDisplay === 'always' || (topDividerDisplay === 'auto' && isNotEmpty())\"></p-divider>\r\n<div class=\"form-navigation\">\r\n  <div class=\"leftButtons\" *ngIf=\"(canNavigateBack(this) && requiresBackButton) || requiresCancelButton\">\r\n    <button pButton\r\n            *ngIf=\"canNavigateBack(this) && requiresBackButton\"\r\n            type=\"button\"\r\n            class=\"p-button-secondary\"\r\n            label=\"{{getBackButtonLabel()}}\"\r\n            icon=\"fas fa-chevron-left\"\r\n            iconPos=\"left\"\r\n            title=\"{{getBackButtonTitle()}}\"\r\n            (click)=\"moveBack(this)\">\r\n    </button>\r\n    <button pButton\r\n            *ngIf=\"requiresCancelButton\"\r\n            type=\"button\"\r\n            class=\"p-button-secondary\"\r\n            label=\"{{getCancelButtonLabel()}}\"\r\n            title=\"{{getCancelButtonTitle()}}\"\r\n            icon=\"fas fa-times-circle\"\r\n            iconPos=\"right\"\r\n            (click)=\"cancel(this)\">\r\n    </button>\r\n  </div>\r\n  <div *ngIf=\"actionButtons\"\r\n       class=\"middleButtons\" [ngClass]=\"{'noRightButtons': !canNavigateNext(this) || !requiresNextButton}\">\r\n    <ng-container *ngFor=\"let bgi of actionButtons.buttonGroupItems\">\r\n      <button pButton\r\n              *ngIf=\"evalCondition(bgi.condition)\"\r\n              type=\"button\"\r\n              class=\"p-button-secondary\"\r\n              label=\"{{bgi.label}}\"\r\n              title=\"{{bgi.label}}\"\r\n              icon=\"{{bgi.icon}}\"\r\n              [disabled]=\"actionButtons.disabled\"\r\n              (click)=\"buttonGroupClick(bgi)\"\r\n              id=\"{{pageField.key}}-{{bgi.code}}\">\r\n      </button>\r\n    </ng-container>\r\n    <button pButton\r\n            *ngIf=\"evalCondition(actionButtons.condition)\"\r\n            type=\"button\"\r\n            label=\"{{actionButtons.label}}\"\r\n            title=\"{{actionButtons.label}}\"\r\n            icon=\"{{actionButtons.icon}}\"\r\n            iconPos=\"{{actionButtons.iconPosition}}\"\r\n            [disabled]=\"actionButtons.disabled\"\r\n            (click)=\"actionButtonClick(actionButtons)\"\r\n            id=\"{{pageField.key}}-{{actionButtons.code}}\">\r\n    </button>\r\n  </div>\r\n  <button pButton\r\n          *ngIf=\"canNavigateNext(this) && requiresNextButton\"\r\n          class=\"rightButtons mr-0\"\r\n          type=\"button\"\r\n          label=\"{{getNextButtonLabel()}}\"\r\n          title=\"{{getNextButtonTitle()}}\"\r\n          icon=\"fas fa-chevron-right\"\r\n          iconPos=\"right\"\r\n          (click)=\"moveNext(this)\">\r\n  </button>\r\n</div>\r\n<p-divider *ngIf=\"bottomDividerDisplay === 'always' || (bottomDividerDisplay === 'auto' && isNotEmpty())\"></p-divider>\r\n" }]
        }], ctorParameters: () => [{ type: FormNavigationService }], propDecorators: { actionButtons: [{
                type: Input
            }], requiresBackButton: [{
                type: Input
            }], backButtonLabel: [{
                type: Input
            }], backButtonTitle: [{
                type: Input
            }], requiresNextButton: [{
                type: Input
            }], nextButtonLabel: [{
                type: Input
            }], nextButtonTitle: [{
                type: Input
            }], requiresCancelButton: [{
                type: Input
            }], cancelButtonLabel: [{
                type: Input
            }], cancelButtonTitle: [{
                type: Input
            }], pageField: [{
                type: Input
            }], topDividerDisplay: [{
                type: Input
            }], bottomDividerDisplay: [{
                type: Input
            }] } });

class PageFieldType extends FieldType {
    ngOnInit() {
        this.field.props.showValidationSummary = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageFieldType, selector: "dspx-page", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field.key === 'form'; then formTemplate; else pageTemplate\"></ng-container>\r\n\r\n<ng-template #formTemplate>\r\n  <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n  <dspx-description [text]=\"props.description\"></dspx-description>\r\n  <div *ngFor=\"let tabs of field.fieldGroup\">\r\n    <formly-field [field]=\"tabs\"></formly-field>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #pageTemplate>\r\n  <dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n  <dspx-header-bar *ngIf=\"props.headerBarContent\" [content]=\"props.headerBarContent\" [sticky]=\"props.headerBarSticky\" [stickySettings]=\"{'container': 'dspx-page'}\"></dspx-header-bar>\r\n  <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n  <dspx-description [text]=\"props.description\"></dspx-description>\r\n  <dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n  <ng-container *ngIf=\"!props.hideContent\">\r\n    <div *ngFor=\"let section of field.fieldGroup\">\r\n\r\n      <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n\r\n      <ng-template #viewTemplate>\r\n        <dspx-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\"></dspx-section-view-mode>\r\n      </ng-template>\r\n\r\n      <ng-template #editTemplate>\r\n        <formly-field [field]=\"section\"></formly-field>\r\n      </ng-template>\r\n\r\n    </div>\r\n  </ng-container>\r\n  <dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                        [requiresBackButton]=\"props.requiresBackButton\"\r\n                        [backButtonLabel]=\"props.backButtonLabel\"\r\n                        [backButtonTitle]=\"props.backButtonTitle\"\r\n                        [requiresNextButton]=\"props.requiresNextButton\"\r\n                        [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                        [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                        [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                        [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                        [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                        [pageField]=\"field\">\r\n  </dspx-form-navigation>\r\n</ng-template>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: FormNavigationFieldType, selector: "dspx-form-navigation", inputs: ["actionButtons", "requiresBackButton", "backButtonLabel", "backButtonTitle", "requiresNextButton", "nextButtonLabel", "nextButtonTitle", "requiresCancelButton", "cancelButtonLabel", "cancelButtonTitle", "pageField", "topDividerDisplay", "bottomDividerDisplay"] }, { kind: "component", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: ["pageField"] }, { kind: "component", type: DspxStatusBarComponent, selector: "dspx-status-bar", inputs: ["content"] }, { kind: "component", type: DspxHeaderBarComponent, selector: "dspx-header-bar", inputs: ["content", "sticky", "stickySettings"] }, { kind: "component", type: DspxSectionViewModeComponent, selector: "dspx-section-view-mode", inputs: ["pageConfig", "sectionConfig"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-page', template: "<ng-container *ngIf=\"field.key === 'form'; then formTemplate; else pageTemplate\"></ng-container>\r\n\r\n<ng-template #formTemplate>\r\n  <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n  <dspx-description [text]=\"props.description\"></dspx-description>\r\n  <div *ngFor=\"let tabs of field.fieldGroup\">\r\n    <formly-field [field]=\"tabs\"></formly-field>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #pageTemplate>\r\n  <dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n  <dspx-header-bar *ngIf=\"props.headerBarContent\" [content]=\"props.headerBarContent\" [sticky]=\"props.headerBarSticky\" [stickySettings]=\"{'container': 'dspx-page'}\"></dspx-header-bar>\r\n  <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n  <dspx-description [text]=\"props.description\"></dspx-description>\r\n  <dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n  <ng-container *ngIf=\"!props.hideContent\">\r\n    <div *ngFor=\"let section of field.fieldGroup\">\r\n\r\n      <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n\r\n      <ng-template #viewTemplate>\r\n        <dspx-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\"></dspx-section-view-mode>\r\n      </ng-template>\r\n\r\n      <ng-template #editTemplate>\r\n        <formly-field [field]=\"section\"></formly-field>\r\n      </ng-template>\r\n\r\n    </div>\r\n  </ng-container>\r\n  <dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                        [requiresBackButton]=\"props.requiresBackButton\"\r\n                        [backButtonLabel]=\"props.backButtonLabel\"\r\n                        [backButtonTitle]=\"props.backButtonTitle\"\r\n                        [requiresNextButton]=\"props.requiresNextButton\"\r\n                        [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                        [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                        [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                        [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                        [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                        [pageField]=\"field\">\r\n  </dspx-form-navigation>\r\n</ng-template>\r\n" }]
        }] });

class PageRepeatingFieldType extends DspxBasePanelRepeaterComponent {
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, changeDetector) {
        super(coreService, spinnerService, repeaterRegistryService, repeaterService, repeaterService.getPageRepeaterExtraSettings(), changeDetector);
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.initialise();
        this.field.props.showValidationSummary = false;
    }
    ngOnDestroy() {
        this.destroy();
    }
    get htmlHeadingLevelBase() {
        return 3;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageRepeatingFieldType, deps: [{ token: CoreService }, { token: SpinnerService }, { token: RepeaterRegistryService }, { token: RepeaterService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageRepeatingFieldType, selector: "dspx-page-repeating", usesInheritance: true, ngImport: i0, template: "<dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n<dspx-header-bar *ngIf=\"props.headerBarContent\" [content]=\"props.headerBarContent\" [sticky]=\"props.headerBarSticky\" [stickySettings]=\"{'container': 'dspx-page-repeating'}\"></dspx-header-bar>\r\n<dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n<dspx-description [text]=\"props.description\"></dspx-description>\r\n<dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n<ng-container *ngIf=\"!props.hideContent\">\r\n  <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n  <ng-template #viewTemplate>\r\n    <div class=\"repeating-page mt-3 mb-6\" *ngFor=\"let itemConfig of field.fieldGroup; let itemIndex = index\">\r\n      <p-panel>\r\n        <ng-template pTemplate=\"content\">\r\n          <div [id]=\"getElementId(RepeaterElementType.TopOfItemContent, itemIndex)\"></div>\r\n          <dspx-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\" *ngFor=\"let section of itemConfig.fieldGroup\"></dspx-section-view-mode>\r\n        </ng-template>\r\n      </p-panel>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #editTemplate>\r\n    <dspx-panel-repeater [repeater]=\"basePanelRepeater\" [cssClassName]=\"'repeating-page'\" [htmlHeadingLevelBase]=\"repeaterHeadingLevelBase\"></dspx-panel-repeater>\r\n  </ng-template>\r\n</ng-container>\r\n<dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                      [requiresBackButton]=\"props.requiresBackButton\"\r\n                      [backButtonLabel]=\"props.backButtonLabel\"\r\n                      [backButtonTitle]=\"props.backButtonTitle\"\r\n                      [requiresNextButton]=\"props.requiresNextButton\"\r\n                      [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                      [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                      [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                      [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                      [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                      [pageField]=\"field\">\r\n</dspx-form-navigation>\r\n", styles: [".page-header{margin:5px}.header-row .h3{font-weight:700}.sub-header-row .h4{font-weight:400}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: FormNavigationFieldType, selector: "dspx-form-navigation", inputs: ["actionButtons", "requiresBackButton", "backButtonLabel", "backButtonTitle", "requiresNextButton", "nextButtonLabel", "nextButtonTitle", "requiresCancelButton", "cancelButtonLabel", "cancelButtonTitle", "pageField", "topDividerDisplay", "bottomDividerDisplay"] }, { kind: "component", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: ["pageField"] }, { kind: "component", type: DspxStatusBarComponent, selector: "dspx-status-bar", inputs: ["content"] }, { kind: "component", type: DspxHeaderBarComponent, selector: "dspx-header-bar", inputs: ["content", "sticky", "stickySettings"] }, { kind: "component", type: DspxPanelRepeaterComponent, selector: "dspx-panel-repeater", inputs: ["repeater", "cssClassName", "htmlHeadingLevelBase"] }, { kind: "component", type: DspxSectionViewModeComponent, selector: "dspx-section-view-mode", inputs: ["pageConfig", "sectionConfig"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageRepeatingFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-page-repeating', template: "<dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n<dspx-header-bar *ngIf=\"props.headerBarContent\" [content]=\"props.headerBarContent\" [sticky]=\"props.headerBarSticky\" [stickySettings]=\"{'container': 'dspx-page-repeating'}\"></dspx-header-bar>\r\n<dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n<dspx-description [text]=\"props.description\"></dspx-description>\r\n<dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n<ng-container *ngIf=\"!props.hideContent\">\r\n  <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n  <ng-template #viewTemplate>\r\n    <div class=\"repeating-page mt-3 mb-6\" *ngFor=\"let itemConfig of field.fieldGroup; let itemIndex = index\">\r\n      <p-panel>\r\n        <ng-template pTemplate=\"content\">\r\n          <div [id]=\"getElementId(RepeaterElementType.TopOfItemContent, itemIndex)\"></div>\r\n          <dspx-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\" *ngFor=\"let section of itemConfig.fieldGroup\"></dspx-section-view-mode>\r\n        </ng-template>\r\n      </p-panel>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #editTemplate>\r\n    <dspx-panel-repeater [repeater]=\"basePanelRepeater\" [cssClassName]=\"'repeating-page'\" [htmlHeadingLevelBase]=\"repeaterHeadingLevelBase\"></dspx-panel-repeater>\r\n  </ng-template>\r\n</ng-container>\r\n<dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                      [requiresBackButton]=\"props.requiresBackButton\"\r\n                      [backButtonLabel]=\"props.backButtonLabel\"\r\n                      [backButtonTitle]=\"props.backButtonTitle\"\r\n                      [requiresNextButton]=\"props.requiresNextButton\"\r\n                      [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                      [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                      [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                      [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                      [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                      [pageField]=\"field\">\r\n</dspx-form-navigation>\r\n", styles: [".page-header{margin:5px}.header-row .h3{font-weight:700}.sub-header-row .h4{font-weight:400}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: SpinnerService }, { type: RepeaterRegistryService }, { type: RepeaterService }, { type: i0.ChangeDetectorRef }] });

class SectionFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.getQuestionLayoutStyleClass = (question) => {
            return (question.props.columnLayout && question.props.columnLayout == 'split') ? 'col-6 md:col-6' :
                (question.props.columnLayout != null ? question.props.columnLayout : 'col-12 md:col-12');
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionFieldType, selector: "dspx-section", usesInheritance: true, ngImport: i0, template: "<div class=\"section\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <!-- <div class=\"question\" *ngFor=\"let question of field.fieldGroup\">\r\n        <formly-field [field]=\"question\"></formly-field>\r\n    </div> -->\r\n\r\n    <div class=\"grid\">       \r\n        <ng-container *ngFor=\"let question of field.fieldGroup\">\r\n            <ng-container *ngIf=\"question.hide != true && question.type != null ; else noStyle\">\r\n                <div class=\"{{getQuestionLayoutStyleClass(question)}}\" >                                 \r\n                    <formly-field [field]=\"question\"></formly-field>\r\n                </div>  \r\n            </ng-container>  \r\n            \r\n            <ng-template #noStyle>\r\n                <formly-field [field]=\"question\"></formly-field>\r\n            </ng-template>\r\n                     \r\n        </ng-container>\r\n    </div>  \r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section', template: "<div class=\"section\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <!-- <div class=\"question\" *ngFor=\"let question of field.fieldGroup\">\r\n        <formly-field [field]=\"question\"></formly-field>\r\n    </div> -->\r\n\r\n    <div class=\"grid\">       \r\n        <ng-container *ngFor=\"let question of field.fieldGroup\">\r\n            <ng-container *ngIf=\"question.hide != true && question.type != null ; else noStyle\">\r\n                <div class=\"{{getQuestionLayoutStyleClass(question)}}\" >                                 \r\n                    <formly-field [field]=\"question\"></formly-field>\r\n                </div>  \r\n            </ng-container>  \r\n            \r\n            <ng-template #noStyle>\r\n                <formly-field [field]=\"question\"></formly-field>\r\n            </ng-template>\r\n                     \r\n        </ng-container>\r\n    </div>  \r\n</div>\r\n" }]
        }] });

class SectionRepeatingFieldType extends DspxBasePanelRepeaterComponent {
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, changeDetector) {
        super(coreService, spinnerService, repeaterRegistryService, repeaterService, repeaterService.getSectionRepeaterExtraSettings(), changeDetector);
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.initialise();
    }
    ngOnDestroy() {
        this.destroy();
    }
    get htmlHeadingLevelBase() {
        return 3;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionRepeatingFieldType, deps: [{ token: CoreService }, { token: SpinnerService }, { token: RepeaterRegistryService }, { token: RepeaterService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionRepeatingFieldType, selector: "dspx-section-repeating", usesInheritance: true, ngImport: i0, template: "<dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n<dspx-description [text]=\"props.description\"></dspx-description>\r\n<dspx-panel-repeater [repeater]=\"basePanelRepeater\" [cssClassName]=\"'repeating-section'\" [htmlHeadingLevelBase]=\"repeaterHeadingLevelBase\"></dspx-panel-repeater>\r\n", styles: [".section-header{margin:5px}.header-row .h4{font-weight:700}.sub-header-row .h5{font-weight:400}\n"], dependencies: [{ kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: DspxPanelRepeaterComponent, selector: "dspx-panel-repeater", inputs: ["repeater", "cssClassName", "htmlHeadingLevelBase"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionRepeatingFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section-repeating', template: "<dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n<dspx-description [text]=\"props.description\"></dspx-description>\r\n<dspx-panel-repeater [repeater]=\"basePanelRepeater\" [cssClassName]=\"'repeating-section'\" [htmlHeadingLevelBase]=\"repeaterHeadingLevelBase\"></dspx-panel-repeater>\r\n", styles: [".section-header{margin:5px}.header-row .h4{font-weight:700}.sub-header-row .h5{font-weight:400}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: SpinnerService }, { type: RepeaterRegistryService }, { type: RepeaterService }, { type: i0.ChangeDetectorRef }] });

class SectionCompareFieldType extends FieldType {
    constructor(reportDataService) {
        super();
        this.reportDataService = reportDataService;
        this.defaultTableRows = 10;
        this.defaultTableRowOptions = [3, 10, 25];
        this.parentSectionCode = undefined;
        this.showSection = false;
        this.showBadge = false;
        this.showMore = 'Show More';
        this.getKeyValue = _.memoize(function (sAnswer) {
            let list = [];
            Object.keys(sAnswer).forEach(function (key) {
                if (key.indexOf("rpt") == 0) {
                    let isChanged = this.checkValueChanged(sAnswer.gNo, key, sAnswer.level, sAnswer.gNoForChild, undefined);
                    let itemObject = { 'value': sAnswer[key], 'isChanged': isChanged };
                    list.push(itemObject);
                }
            }, this);
            return list;
        });
        // This function will return boolean for grand children sections
        // So, grand child section don't appear as normal.
        this.isSectionGrandChild = function () {
            let sectionCode = this.parentSectionCode;
            return (_.filter(this.sectionSourceList, function (o) { return o.parentSection && o.sectionName == sectionCode; }).length > 0);
        };
        this.compareTextDiff = function (groupNo, qCode, level, gNoForChild, source, elementId, value, createElement, section) {
            let finalModel = this.reportModel.finalModel;
            var changedObject = this.returnValueChangedObject(finalModel, groupNo, qCode, level, gNoForChild, source);
            // IF changed object or value is null or undefined don't do comparision
            if (changedObject && changedObject.value) {
                if (changedObject.oldValue == changedObject.value) {
                    // if sources or group are changed but value is not changed for text area we don't have to highlight changes
                    return value;
                }
                else {
                    // UtilityServices.textDiff(changedObject.oldValue, changedObject.value, elementId, Constants.textDiffDel, Constants.textDiffIns, Constants.textDiffIsDeleteRequired);       
                    let del = 'del';
                    let ins = 'ins';
                    //let textDiffIsDeleteRequired: false,
                    let result = document.getElementById(elementId);
                    if (result) {
                        var diff = jsdiff.diffWords(changedObject.oldValue, changedObject.value);
                        if (createElement) {
                            var fragment = document.createDocumentFragment();
                            for (var i = 0; i < diff.length; i++) {
                                if (diff[i].added && diff[i + 1] && diff[i + 1].removed) {
                                    var swap = diff[i];
                                    diff[i] = diff[i + 1];
                                    diff[i + 1] = swap;
                                }
                                var node;
                                if (diff[i].removed) {
                                    // if (isDeleteRequired) {
                                    node = document.createElement(del);
                                    node.appendChild(document.createTextNode(diff[i].value));
                                    //}
                                }
                                else if (diff[i].added) {
                                    node = document.createElement(ins);
                                    node.appendChild(document.createTextNode(diff[i].value));
                                }
                                else {
                                    node = document.createTextNode(diff[i].value);
                                }
                                if (node)
                                    fragment.appendChild(node);
                            }
                            result.textContent = '';
                            result.appendChild(fragment);
                        }
                    }
                    return "Old:" + changedObject.oldValue + "New:" + changedObject.value;
                }
            }
            else {
                // if (section == $scope.reportSettings.alerts && value == Constants.noResponseText) {
                //   return "";
                // } else {
                //   return value;
                // }
                if (value == undefined || value == "") {
                    return '';
                }
                else {
                    return value;
                }
            }
        };
        this.returnValueChangedObject = function (finalModel, groupNo, qCode, level, gNoForChild, source) {
            var result = null;
            if (source !== undefined) {
                if (gNoForChild == undefined) {
                    result = _.find(finalModel, function (a) {
                        return a.gNo == groupNo
                            && a.rptCode == qCode
                            && a.level == level
                            && (_.intersection(a.source, source).length > 0 || a.source == undefined)
                            && a.isChanged == true;
                    });
                }
                else {
                    result = _.find(finalModel, function (a) {
                        return a.gNo == groupNo
                            && a.rptCode == qCode
                            && a.level == level
                            && a.gNoForChild == gNoForChild
                            && (_.intersection(a.source, source).length > 0 || a.source == undefined)
                            && a.isChanged == true;
                    });
                }
            }
            else {
                if (gNoForChild == undefined) {
                    result = _.find(finalModel, function (a) {
                        return a.gNo == groupNo
                            && a.rptCode == qCode
                            && a.level == level
                            && a.isChanged == true;
                    });
                }
                else {
                    result = _.find(finalModel, function (a) {
                        return a.gNo == groupNo
                            && a.gNoForChild == gNoForChild
                            && a.rptCode == qCode
                            && a.level == level
                            && a.isChanged == true;
                    });
                }
            }
            return result;
        };
    }
    ngOnInit() {
        this.reportModel = this.reportDataService.formReportModel;
        this.sectionSourceList = this.reportDataService.sectionSourceList;
        this.sectionList = this.getSections();
        // check if the section have data from report model
        //if ((this.sectionList.indexOf(this.field.key.toString()) > -1) && !(this.field.props?.parentSection)) {
        this.parentSectionCode = this.field.key.toString();
        this.headerAnswersAll = this.getHeaderAnswer(this.parentSectionCode);
        this.showSection = this.isDataForSection();
        this.showBadge = !!this.props.sectionBadge;
        this.headerAnswers = this.headerAnswersAll?.filter(u => u.level == 0);
        // add Children data
        let idx = 0;
        this.headerAnswers?.forEach(element => {
            element.idx = idx++;
            if (element.level == 0) {
                element.children = this.getChildrenAnswers(element.gNo);
            }
        });
        //}  
    }
    getSections() {
        let _sdata = [];
        let sectionList = this.reportModel.sectionHeaderList;
        sectionList.forEach(element => {
            _sdata.push(element.sectionName);
        });
        return _sdata;
    }
    getHeading(sectionCode) {
        let sectionList = this.reportModel.sectionHeaderList;
        let returnVal;
        // set table data
        if (_.filter(sectionList, ['sectionName', sectionCode]).length == 1) {
            returnVal = _.find(sectionList, ['sectionName', sectionCode]).questions;
        }
        return returnVal;
    }
    ;
    getHeaderAnswer(sectionCode) {
        let sectionAnswerList = this.reportModel.sectionQuestionAnswerList;
        if (_.filter(sectionAnswerList, ['section', sectionCode]).length > 0) {
            let _dataTable = _.find(sectionAnswerList, ['section', sectionCode]).sData;
            let iCount = 1;
            _dataTable.forEach(element => {
                element.id = iCount;
                iCount = iCount + 1;
            });
            return _dataTable;
        }
    }
    ;
    getChildrenAnswers(gNo) {
        let filteredData = this.headerAnswersAll.filter(u => u.gNo == gNo && u.level == 1);
        if (filteredData != undefined && filteredData.length > 0) {
            let _dataTable = filteredData[0].data;
            if (_dataTable != undefined) {
                let iCount = 1;
                _dataTable.forEach(element => {
                    element.id = iCount;
                    iCount = iCount + 1;
                });
                return _dataTable;
            }
        }
        return null;
    }
    getLevelOneAnswers() {
        let filteredData = this.headerAnswersAll?.filter(u => u.level == 1);
        if (filteredData != undefined && filteredData.length > 0) {
            let _dataTable = filteredData[0].data;
            if (_dataTable != undefined) {
                let iCount = 1;
                _dataTable.forEach(element => {
                    element.id = iCount;
                    iCount = iCount + 1;
                });
                return _dataTable;
            }
        }
        return null;
    }
    getColumnCount(record) {
        let keyVaule = this.getKeyValue(record).length;
        return keyVaule + 2;
    }
    checkSourceType(source, type) {
        let isOfType = source.indexOf(type) !== -1;
        return isOfType;
    }
    getChildSections() {
        let sectionSourceList = this.sectionSourceList;
        let childSections_ = sectionSourceList.filter(t => t.parentSection == this.parentSectionCode);
        return _.uniqBy(childSections_, 'sectionName');
    }
    getReportSectionName(sCode) {
        return _.find(this.sectionList, ['code', sCode]).heading;
    }
    checkLineWraps(controlType) {
        if (controlType == 'tabledetailMultiline' || controlType == 'tablerowdetail') {
            return "col-12";
        }
        return "col-4";
    }
    getChildHeaderAnswer(sectionCode, gNo) {
        // To Do Use the gNo to link with the parent table
        let sectionAnswerList = this.reportModel.sectionQuestionAnswerList.filter(i => i.section == sectionCode);
        if (sectionAnswerList.length > 0) {
            let sdata = sectionAnswerList[0].sData;
            let cDataGroupBy = _.groupBy(sdata.filter(j => j.gNo == gNo), item => item == item.gNoForChild);
            let cData = _.sortBy(cDataGroupBy, function (gNoForChild) {
                return sdata.indexOf(gNoForChild[0]);
            });
            let _sdata = [];
            _.forEach(cData, function (p) {
                _sdata.push(_.sortBy(p, function (i) { return i.level; }));
            });
            let flattenSData = _.flatten(_sdata);
            let returnSData = flattenSData.filter(i => i.level == 2);
            returnSData?.forEach(element => {
                let childData = flattenSData.filter(u => u.level == 3 && u.gNoForChild == element.gNoForChild);
                if (childData != null && childData.length > 0) {
                    element.children = childData[0].data;
                }
            });
            return returnSData;
        }
        else {
            return [];
        }
    }
    ;
    isDataForSection() {
        //todo: add this logic later
        // Skip this check for Correction HIstory section
        // if (section == $scope.reportSettings.correctionsHistory) {
        //     return true;
        // }
        let sectionData = _.filter(this.reportModel.finalModel, ['section', this.parentSectionCode]);
        if (sectionData && sectionData.length > 0) {
            for (let index = 0; index < sectionData.length; index++) {
                let s = sectionData[index];
                if (s && s.value && s.value.toString().trim().length > 0) {
                    return true;
                }
            }
        }
        return false;
    }
    ;
    isDataForChildSection(section, gNo) {
        if (_.filter(this.reportModel.finalModel, function (i) { return i.level == 2 && i.section == section && i.gNo == gNo; }).length > 0) {
            return true;
        }
        return false;
    }
    ;
    ifDateFormat(value, qd) {
        let checkDate;
        // Numbers are also convertible to date e.g. new Date(12) so extra check is required.
        if (value && isNaN(value.toString())) {
            checkDate = DateTime.fromISO(value, { zone: 'utc' });
            if (checkDate.isValid) {
                return checkDate.toFormat('dd/MM/yyyy', { locale: 'en-AU' });
            }
        }
        //Commenting this part out for now as the regex below does not work in Safari.
        //https://caniuse.com/js-regexp-lookbehind
        //CIP team to fix this.
        //if (this.isWrapText(value, qd)) {
        //  value = value.replace(/(?<!\([^\)]*)(\,)/g, ",\n");
        //}
        return value;
    }
    isWrapText(value, qd) {
        return (qd && qd.controlType == 'tablerowdetail' && value && value.indexOf(",") >= 0);
    }
    checkValueChanged(groupNo, qCode, level, gNoForChild, source) {
        let finalModel = this.reportModel.finalModel;
        let result = null;
        if (source !== undefined) {
            if (gNoForChild == undefined) {
                result = _.some(finalModel, function (a) {
                    return a.gNo == groupNo
                        && a.rptCode == qCode
                        && a.level == level
                        && _.isEqual(_.sortBy(a.source), _.sortBy(source.s))
                        && a.isChanged == true;
                });
            }
            else {
                result = _.some(finalModel, function (a) {
                    return a.gNo == groupNo
                        && a.rptCode == qCode
                        && a.level == level
                        && a.gNoForChild == gNoForChild
                        && _.isEqual(_.sortBy(a.source), _.sortBy(source.s))
                        && a.isChanged == true;
                });
            }
        }
        else {
            if (gNoForChild == undefined) {
                result = _.some(finalModel, function (a) {
                    return a.gNo == groupNo
                        && a.rptCode == qCode
                        && a.level == level
                        && a.isChanged == true;
                });
            }
            else {
                result = _.some(finalModel, function (a) {
                    return a.gNo == groupNo
                        && a.gNoForChild == gNoForChild
                        && a.rptCode == qCode
                        && a.level == level
                        && a.isChanged == true;
                });
            }
        }
        return result;
    }
    ;
    getCallouts(fields) {
        return fields.filter(x => x.type == "callOut");
    }
    showMoreButton(value) {
        const maxTextLength = window.innerWidth > 768 ? 390 : 100;
        return value.length > maxTextLength;
    }
    onShowMoreClick(event$) {
        const showLess = 'Show Less';
        if (event$.target.innerText.includes(this.showMore)) {
            this.setTabledetailMultilinePara(event$, 'showLessText', 'showMoreText');
            this.setShowMoreButtonChildren(event$, this.showMore, showLess, 'pi pi-chevron-right');
        }
        else if (event$.target.innerText.includes(showLess)) {
            this.setTabledetailMultilinePara(event$, 'showMoreText', 'showLessText');
            this.setShowMoreButtonChildren(event$, showLess, this.showMore, 'pi pi-chevron-down');
        }
    }
    setTabledetailMultilinePara(event$, removeClass, addClass) {
        const parentId = event$.currentTarget.getAttribute('data-parentid');
        const para = document.getElementById(parentId);
        para.classList.remove(removeClass);
        para.classList.add(addClass);
    }
    setShowMoreButtonChildren(event$, searchText, replacementText, icon) {
        let children = event$.currentTarget.children;
        for (let i = 0; i < children.length; i++) {
            if (children[i].nodeName.toLowerCase() == 'span') {
                if (children[i].innerText.includes(searchText)) {
                    children[i].innerText = replacementText;
                }
            }
            else if (children[i].nodeName.toLowerCase() == 'i') {
                children[i].setAttribute('class', icon);
            }
        }
    }
    getTabledetailMultilineId(data, index) {
        if (data.level === 1) {
            return `${data.rptCode}${index}-${data.gNo}`;
        }
        else {
            return `${data.rptCode}${index}-${data.gNo}-${data.gNoForChild}`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionCompareFieldType, deps: [{ token: ReportDataService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionCompareFieldType, selector: "dspx-section-compare", usesInheritance: true, ngImport: i0, template: "<div class=\"section mb-1\">\r\n   <ng-container *ngIf=\"!isSectionGrandChild()\">\r\n      <div class=\"grid\">\r\n         <dspx-heading class=\"md:col-7\" [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n         <dspx-section-compare-badge *ngIf=\"showBadge\" [config]=\"props.sectionBadge\" class=\"md:col-5 pull-right\">\r\n         </dspx-section-compare-badge>\r\n      </div>\r\n      <h3 class=\"section-compare-description\">{{props.description}}</h3>\r\n      <div class=\"question\" *ngFor=\"let question of getCallouts(field.fieldGroup)\">\r\n         <formly-field [field]=\"question\"></formly-field>\r\n      </div>\r\n      <ng-container *ngIf=\"showSection == false; else showResults\">\r\n         <div> No response </div>\r\n      </ng-container>\r\n      <ng-template #showResults>\r\n         <ng-container *ngIf=\"headerAnswers != undefined && headerAnswers.length > 0\">\r\n            <ng-container\r\n               *ngTemplateOutlet=\"dtbl; context {$implicit: getHeading(parentSectionCode), tableData: headerAnswers}\">\r\n            </ng-container>\r\n         </ng-container>\r\n\r\n         <ng-container *ngIf=\"headerAnswers == undefined || headerAnswers.length == 0\">\r\n            <ng-container *ngTemplateOutlet=\"cardbl; context {$implicit: getLevelOneAnswers()}\">\r\n            </ng-container>\r\n         </ng-container>\r\n      </ng-template>\r\n   </ng-container>\r\n</div>\r\n\r\n<ng-template #dtbl let-columns let-tableData=\"tableData\">\r\n   <p-table [value]=\"tableData\" dataKey=\"id\" [paginator]=\"(tableData.length > defaultTableRows)\" [rows]=\"defaultTableRows\" [showCurrentPageReport]=\"true\"\r\n      responsiveLayout=\"scroll\" currentPageReportTemplate=\"Showing {first} to {last} of {totalRecords} entries\"\r\n      [rowsPerPageOptions]=\"defaultTableRowOptions\" styleClass=\"section-compare-table-striped\" id=\"expandableTable-{{parentSectionCode}}\">\r\n      <ng-template pTemplate=\"header\">\r\n         <tr>\r\n            <th style=\"width:1rem\"></th>\r\n            <ng-container *ngFor=\"let col of columns\">\r\n               <th pSortableColumn=\"col.props?.label\">{{col.props?.label}}</th>\r\n            </ng-container>\r\n            <th>Source</th>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-record let-expanded=\"expanded\">\r\n         <tr *ngIf=\"record.level == 0\" id=\"{{record.id}}-{{record.gNo}}-{{record.level}}\" [ngClass]=\"{'odd-row': (record.idx % 2 == 0)}\">\r\n            <td>\r\n               <button type=\"button\" pButton pRipple [pRowToggler]=\"record\" id=\"expandLink-0-{{record.gNo}}\"\r\n                  aria-expanded=\"false\"\r\n                  class=\"p-button-text p-button-rounded p-button-plain\"\r\n                  [icon]=\"expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"\r\n                  *ngIf=\"record.children != undefined && record.children.length\"></button>\r\n            </td>\r\n            <td *ngFor=\"let answer of getKeyValue(record)\" class=\"table-column\">\r\n               <span [ngClass]=\"{'text-changed': (answer.isChanged == true), 'text-style' : isWrapText(answer.value)}\">\r\n                  {{ifDateFormat(answer.value)}}</span>\r\n            </td>\r\n            <td>\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,1)\" class=\"small-icon\" alt=\"VicPol\"\r\n                  src=\"/assets/images/blue-diamond.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,5)\" class=\"small-icon\" alt=\"Court\"\r\n                  src=\"/assets/images/orange-circle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,4)\" class=\"small-icon\" alt=\"Corrections\"\r\n                  src=\"/assets/images/green-triangle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,6)\" class=\"small-icon\" alt=\"DHHS\"\r\n                  src=\"/assets/images/purple-square.svg\">\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"rowexpansion\" let-record>\r\n         <tr [ngClass]=\"{'odd-row': (record.idx % 2 == 0)}\">\r\n            <td [attr.colspan]=\"getColumnCount(record)\" class=\"pb-0\">\r\n               <ng-container *ngTemplateOutlet=\"cardbl; context {$implicit: record.children, parent: record}\">\r\n               </ng-container>\r\n\r\n               <ng-container *ngTemplateOutlet=\"childtable; context {$implicit: record}\">\r\n               </ng-container>\r\n\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"emptymessage\">\r\n         <tr>\r\n            <td colspan=\"8\">No Records found</td>\r\n         </tr>\r\n      </ng-template>\r\n   </p-table>\r\n</ng-template>\r\n\r\n<ng-template #childtable let-record>\r\n   <div class=\"grid\">\r\n      <ng-container *ngFor=\"let childSection of getChildSections()\">\r\n         <ng-container *ngIf=\"isDataForChildSection(childSection.sectionName, record.gNo)\">\r\n            <h3 class=\"child-table\">{{childSection.sectionNameLabel}}</h3>\r\n            <ng-container\r\n               *ngTemplateOutlet=\"childdtbl; context {$implicit: getHeading(childSection.sectionName), childSectionName: childSection.sectionName, tableData: getChildHeaderAnswer(childSection.sectionName, record.gNo)}\">\r\n            </ng-container>\r\n         </ng-container>\r\n      </ng-container>\r\n   </div>\r\n</ng-template>\r\n\r\n<ng-template #childdtbl let-columns let-tableData=\"tableData\" let-childSectionName=\"childSectionName\">\r\n   <p-table [value]=\"tableData\" dataKey=\"id\" [paginator]=\"(tableData.length > defaultTableRows)\" [rows]=\"defaultTableRows\" [showCurrentPageReport]=\"true\"\r\n      id=\"expandableTable-{{childSectionName}}\" responsiveLayout=\"scroll\"\r\n      currentPageReportTemplate=\"Showing {first} to {last} of {totalRecords} entries\" [rowsPerPageOptions]=\"defaultTableRowOptions\"\r\n      styleClass=\"section-compare-table-striped\">\r\n      <ng-template pTemplate=\"header\">\r\n         <tr>\r\n            <th style=\"width:1rem\"></th>\r\n            <ng-container *ngFor=\"let col of columns\">\r\n               <th pSortableColumn=\"col.props?.label\">{{col.props?.label}}</th>\r\n            </ng-container>\r\n            <th>Source</th>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-record let-expanded=\"expanded\">\r\n         <tr *ngIf=\"record.level == 2\" id=\"{{childSectionName}}-{{record.gNoForChild}}-{{record.level}}\">\r\n            <td>\r\n               <button type=\"button\" pButton pRipple [pRowToggler]=\"record\"\r\n                  id=\"expandLink-2-{{record.gNo}}-{{record.gNoForChild}}\"\r\n                  class=\"p-button-text p-button-rounded p-button-plain\"\r\n                  [icon]=\"expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"\r\n                  *ngIf=\"record.children != undefined && record.children.length\"></button>\r\n            </td>\r\n            <td *ngFor=\"let answer of getKeyValue(record)\" class=\"table-column\">\r\n               <span [ngClass]=\"{'text-changed': (answer.isChanged == true), 'text-style' : isWrapText(answer.value)}\">\r\n                  {{ifDateFormat(answer.value)}}</span>\r\n            </td>\r\n            <td>\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,1)\" class=\"small-icon\" alt=\"VicPol\"\r\n                  src=\"/assets/images/blue-diamond.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,5)\" class=\"small-icon\" alt=\"Court\"\r\n                  src=\"/assets/images/orange-circle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,4)\" class=\"small-icon\" alt=\"Corrections\"\r\n                  src=\"/assets/images/green-triangle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,6)\" class=\"small-icon\" alt=\"DHHS\"\r\n                  src=\"/assets/images/purple-square.svg\">\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"rowexpansion\" let-record>\r\n         <tr>\r\n            <td [attr.colspan]=\"getColumnCount(record)\" class=\"pb-1\">\r\n               <ng-container *ngTemplateOutlet=\"cardbl; context {$implicit: record.children}\">\r\n               </ng-container>\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"emptymessage\">\r\n         <tr>\r\n            <td colspan=\"8\">No Records found</td>\r\n         </tr>\r\n      </ng-template>\r\n   </p-table>\r\n</ng-template>\r\n\r\n\r\n<ng-template #cardbl let-records let-parent>\r\n   <div class=\"grid\">\r\n      <ng-container *ngFor=\"let data of records\">\r\n         <div [ngClass]=\"checkLineWraps(data.controlType)\" class=\"p-1\">\r\n            <div class=\"grid\">\r\n               <div style=\"width:80px\" class=\"p-1\"></div>\r\n                  <div class=\"col p-1\"><strong>{{data.questionText}}</strong>\r\n                     <div *ngIf=\"data.additionalInformations\" class=\"info-block\" >\r\n                        <div *ngFor=\"let info of data.additionalInformations\" [innerHtml]=\"info.text\"></div>\r\n                     </div>\r\n                  </div>\r\n               </div>\r\n            <div class=\"grid\" *ngFor=\"let aSubItem of data.multiData; let index = index\">\r\n               <div class=\"col-fixed p-1\" style=\"width:80px\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,1)\" class=\"small-icon\" alt=\"VicPol\"\r\n                     src=\"/assets/images/blue-diamond.svg\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,5)\" class=\"small-icon\" alt=\"Court\"\r\n                     src=\"/assets/images/orange-circle.svg\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,4)\" class=\"small-icon\" alt=\"Corrections\"\r\n                     src=\"/assets/images/green-triangle.svg\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,6)\" class=\"small-icon\" alt=\"DHHS\"\r\n                     src=\"/assets/images/purple-square.svg\">\r\n               </div>\r\n               <div class=\"col p-1\">\r\n                  <ng-container *ngIf=\"data.level === 1;else levelTwoCheck\">\r\n                     <ng-container *ngIf=\"data.controlType !== 'tabledetailMultiline'\">\r\n                        <p [ngClass]=\"{'text-changed': checkValueChanged(data.gNo , data.rptCode, data.level, undefined, aSubItem), 'text-style' : isWrapText(aSubItem.v,data) }\">\r\n                           {{ifDateFormat(aSubItem.v,data)}}</p>\r\n                     </ng-container>\r\n                     <ng-container *ngIf=\"data.controlType === 'tabledetailMultiline'\">\r\n                        <input type=\"hidden\" #compareTextDifference [ngModel] = \"compareTextDiff(data.gNo , data.rptCode, data.level, undefined, aSubItem.s,data.rptCode + index + '-' + data.gNo, aSubItem.v, false)\">\r\n                        <p [id]=\"getTabledetailMultilineId(data, index)\" class=\"summary__textwrap\" [ngClass]=\"showMoreButton(compareTextDifference.value) ? 'showLessText': 'showMoreText'\">\r\n                           {{compareTextDiff(data.gNo , data.rptCode, data.level, undefined, aSubItem.s,data.rptCode +\r\n                           index + \"-\" + data.gNo, aSubItem.v, true)}}\r\n                        </p>\r\n                        <ng-container *ngIf=\"showMoreButton(compareTextDifference.value)\">\r\n                           <button type=\"button\" pButton pRipple class=\"p-button-text p-button-plain\" [attr.data-parentid] = \"getTabledetailMultilineId(data, index)\"\r\n                                   (click)=\"onShowMoreClick($event)\"> <span>{{showMore}} </span><i class=\"pi pi-chevron-down\"></i>\r\n                           </button>\r\n                         </ng-container>\r\n                     </ng-container>\r\n                  </ng-container>\r\n                  <ng-template #levelTwoCheck>\r\n                     <ng-container *ngIf=\"data.controlType !== 'tabledetailMultiline'\">\r\n                        <p [ngClass]=\"{'text-changed': checkValueChanged(data.gNo , data.rptCode, data.level, data.gNoForChild, aSubItem), 'text-style' : isWrapText(aSubItem.v,data)}\">\r\n                           {{ifDateFormat(aSubItem.v,data)}}</p>\r\n                     </ng-container>\r\n                     <ng-container *ngIf=\"data.controlType === 'tabledetailMultiline'\">\r\n                        <input type=\"hidden\" #compareTextDifference [ngModel] = \"compareTextDiff(data.gNo , data.rptCode, data.level, data.gNoForChild, aSubItem.s,data.rptCode + index + '-' + data.gNo + '-' + data.gNoForChild, aSubItem.v, false)\">\r\n                           <p [id]=\"getTabledetailMultilineId(data, index)\" class=\"summary__textwrap\" [ngClass]=\"showMoreButton(compareTextDifference.value) ? 'showLessText': 'showMoreText'\">\r\n                              {{compareTextDiff(data.gNo , data.rptCode, data.level, data.gNoForChild,\r\n                              aSubItem.s,data.rptCode + index + \"-\" + data.gNo + \"-\" + data.gNoForChild, aSubItem.v, true)}}\r\n                           </p>\r\n\r\n                        <ng-container *ngIf=\"showMoreButton(compareTextDifference.value)\">\r\n                           <button type=\"button\" pButton pRipple class=\"p-button-text p-button-plain\" [attr.data-parentid] = \"getTabledetailMultilineId(data, index)\"\r\n                                   (click)=\"onShowMoreClick($event)\"> <span>{{showMore}} </span><i class=\"pi pi-chevron-down\"></i>\r\n                           </button>\r\n                         </ng-container>\r\n                     </ng-container>\r\n                  </ng-template>\r\n               </div>\r\n            </div>\r\n         </div>\r\n      </ng-container>\r\n   </div>\r\n</ng-template>\r\n\r\n", styles: ["p-fieldset{padding:5px 15px}ins{color:#00f;text-decoration:none;text-decoration-color:#00f}.text-changed{color:#00f!important}.text-style{white-space:pre-wrap}.pull-right{float:right;text-align:right;margin-left:auto}.summary__textwrap{white-space:pre;white-space:-moz-pre-wrap;white-space:pre-wrap}.showLessText{overflow:hidden;text-overflow:ellipsis;max-height:60px}.showMoreText{overflow:visible}.small-icon{vertical-align:middle}@media (max-width: 720px){.hideOverflow{overflow:hidden;text-overflow:ellipsis;max-height:110px}}:host ::ng-deep .section-compare-table-striped.p-datatable .p-datatable-thead>tr>th{background:transparent}:host ::ng-deep .section-compare-table-striped.p-datatable .p-datatable-tbody>tr{background:transparent}:host ::ng-deep .section-compare-table-striped.p-datatable .p-datatable-tbody>tr.odd-row{background:#f3f3f3}:host ::ng-deep h3.section-compare-description{font-size:1rem}:host ::ng-deep h3.child-table{font-size:1rem;margin:.5rem 1rem}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: Table, selector: "p-table", inputs: ["frozenColumns", "frozenValue", "style", "styleClass", "tableStyle", "tableStyleClass", "paginator", "pageLinks", "rowsPerPageOptions", "alwaysShowPaginator", "paginatorPosition", "paginatorStyleClass", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showFirstLastIcon", "showPageLinks", "defaultSortOrder", "sortMode", "resetPageOnSort", "selectionMode", "selectionPageOnly", "contextMenuSelection", "contextMenuSelectionMode", "dataKey", "metaKeySelection", "rowSelectable", "rowTrackBy", "lazy", "lazyLoadOnInit", "compareSelectionBy", "csvSeparator", "exportFilename", "filters", "globalFilterFields", "filterDelay", "filterLocale", "expandedRowKeys", "editingRowKeys", "rowExpandMode", "scrollable", "scrollDirection", "rowGroupMode", "scrollHeight", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "frozenWidth", "responsive", "contextMenu", "resizableColumns", "columnResizeMode", "reorderableColumns", "loading", "loadingIcon", "showLoader", "rowHover", "customSort", "showInitialSortBadge", "autoLayout", "exportFunction", "exportHeader", "stateKey", "stateStorage", "editMode", "groupRowsBy", "groupRowsByOrder", "responsiveLayout", "breakpoint", "paginatorLocale", "value", "columns", "first", "rows", "totalRecords", "sortField", "sortOrder", "multiSortMeta", "selection", "selectAll", "virtualRowHeight"], outputs: ["contextMenuSelectionChange", "selectAllChange", "selectionChange", "onRowSelect", "onRowUnselect", "onPage", "onSort", "onFilter", "onLazyLoad", "onRowExpand", "onRowCollapse", "onContextMenuSelect", "onColResize", "onColReorder", "onRowReorder", "onEditInit", "onEditComplete", "onEditCancel", "onHeaderCheckboxToggle", "sortFunction", "firstChange", "rowsChange", "onStateSave", "onStateRestore"] }, { kind: "directive", type: SortableColumn, selector: "[pSortableColumn]", inputs: ["pSortableColumn", "pSortableColumnDisabled"] }, { kind: "directive", type: RowToggler, selector: "[pRowToggler]", inputs: ["pRowToggler", "pRowTogglerDisabled"] }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: DspxSectionCompareBadgeComponent, selector: "dspx-section-compare-badge", inputs: ["config"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionCompareFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section-compare', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"section mb-1\">\r\n   <ng-container *ngIf=\"!isSectionGrandChild()\">\r\n      <div class=\"grid\">\r\n         <dspx-heading class=\"md:col-7\" [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n         <dspx-section-compare-badge *ngIf=\"showBadge\" [config]=\"props.sectionBadge\" class=\"md:col-5 pull-right\">\r\n         </dspx-section-compare-badge>\r\n      </div>\r\n      <h3 class=\"section-compare-description\">{{props.description}}</h3>\r\n      <div class=\"question\" *ngFor=\"let question of getCallouts(field.fieldGroup)\">\r\n         <formly-field [field]=\"question\"></formly-field>\r\n      </div>\r\n      <ng-container *ngIf=\"showSection == false; else showResults\">\r\n         <div> No response </div>\r\n      </ng-container>\r\n      <ng-template #showResults>\r\n         <ng-container *ngIf=\"headerAnswers != undefined && headerAnswers.length > 0\">\r\n            <ng-container\r\n               *ngTemplateOutlet=\"dtbl; context {$implicit: getHeading(parentSectionCode), tableData: headerAnswers}\">\r\n            </ng-container>\r\n         </ng-container>\r\n\r\n         <ng-container *ngIf=\"headerAnswers == undefined || headerAnswers.length == 0\">\r\n            <ng-container *ngTemplateOutlet=\"cardbl; context {$implicit: getLevelOneAnswers()}\">\r\n            </ng-container>\r\n         </ng-container>\r\n      </ng-template>\r\n   </ng-container>\r\n</div>\r\n\r\n<ng-template #dtbl let-columns let-tableData=\"tableData\">\r\n   <p-table [value]=\"tableData\" dataKey=\"id\" [paginator]=\"(tableData.length > defaultTableRows)\" [rows]=\"defaultTableRows\" [showCurrentPageReport]=\"true\"\r\n      responsiveLayout=\"scroll\" currentPageReportTemplate=\"Showing {first} to {last} of {totalRecords} entries\"\r\n      [rowsPerPageOptions]=\"defaultTableRowOptions\" styleClass=\"section-compare-table-striped\" id=\"expandableTable-{{parentSectionCode}}\">\r\n      <ng-template pTemplate=\"header\">\r\n         <tr>\r\n            <th style=\"width:1rem\"></th>\r\n            <ng-container *ngFor=\"let col of columns\">\r\n               <th pSortableColumn=\"col.props?.label\">{{col.props?.label}}</th>\r\n            </ng-container>\r\n            <th>Source</th>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-record let-expanded=\"expanded\">\r\n         <tr *ngIf=\"record.level == 0\" id=\"{{record.id}}-{{record.gNo}}-{{record.level}}\" [ngClass]=\"{'odd-row': (record.idx % 2 == 0)}\">\r\n            <td>\r\n               <button type=\"button\" pButton pRipple [pRowToggler]=\"record\" id=\"expandLink-0-{{record.gNo}}\"\r\n                  aria-expanded=\"false\"\r\n                  class=\"p-button-text p-button-rounded p-button-plain\"\r\n                  [icon]=\"expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"\r\n                  *ngIf=\"record.children != undefined && record.children.length\"></button>\r\n            </td>\r\n            <td *ngFor=\"let answer of getKeyValue(record)\" class=\"table-column\">\r\n               <span [ngClass]=\"{'text-changed': (answer.isChanged == true), 'text-style' : isWrapText(answer.value)}\">\r\n                  {{ifDateFormat(answer.value)}}</span>\r\n            </td>\r\n            <td>\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,1)\" class=\"small-icon\" alt=\"VicPol\"\r\n                  src=\"/assets/images/blue-diamond.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,5)\" class=\"small-icon\" alt=\"Court\"\r\n                  src=\"/assets/images/orange-circle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,4)\" class=\"small-icon\" alt=\"Corrections\"\r\n                  src=\"/assets/images/green-triangle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,6)\" class=\"small-icon\" alt=\"DHHS\"\r\n                  src=\"/assets/images/purple-square.svg\">\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"rowexpansion\" let-record>\r\n         <tr [ngClass]=\"{'odd-row': (record.idx % 2 == 0)}\">\r\n            <td [attr.colspan]=\"getColumnCount(record)\" class=\"pb-0\">\r\n               <ng-container *ngTemplateOutlet=\"cardbl; context {$implicit: record.children, parent: record}\">\r\n               </ng-container>\r\n\r\n               <ng-container *ngTemplateOutlet=\"childtable; context {$implicit: record}\">\r\n               </ng-container>\r\n\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"emptymessage\">\r\n         <tr>\r\n            <td colspan=\"8\">No Records found</td>\r\n         </tr>\r\n      </ng-template>\r\n   </p-table>\r\n</ng-template>\r\n\r\n<ng-template #childtable let-record>\r\n   <div class=\"grid\">\r\n      <ng-container *ngFor=\"let childSection of getChildSections()\">\r\n         <ng-container *ngIf=\"isDataForChildSection(childSection.sectionName, record.gNo)\">\r\n            <h3 class=\"child-table\">{{childSection.sectionNameLabel}}</h3>\r\n            <ng-container\r\n               *ngTemplateOutlet=\"childdtbl; context {$implicit: getHeading(childSection.sectionName), childSectionName: childSection.sectionName, tableData: getChildHeaderAnswer(childSection.sectionName, record.gNo)}\">\r\n            </ng-container>\r\n         </ng-container>\r\n      </ng-container>\r\n   </div>\r\n</ng-template>\r\n\r\n<ng-template #childdtbl let-columns let-tableData=\"tableData\" let-childSectionName=\"childSectionName\">\r\n   <p-table [value]=\"tableData\" dataKey=\"id\" [paginator]=\"(tableData.length > defaultTableRows)\" [rows]=\"defaultTableRows\" [showCurrentPageReport]=\"true\"\r\n      id=\"expandableTable-{{childSectionName}}\" responsiveLayout=\"scroll\"\r\n      currentPageReportTemplate=\"Showing {first} to {last} of {totalRecords} entries\" [rowsPerPageOptions]=\"defaultTableRowOptions\"\r\n      styleClass=\"section-compare-table-striped\">\r\n      <ng-template pTemplate=\"header\">\r\n         <tr>\r\n            <th style=\"width:1rem\"></th>\r\n            <ng-container *ngFor=\"let col of columns\">\r\n               <th pSortableColumn=\"col.props?.label\">{{col.props?.label}}</th>\r\n            </ng-container>\r\n            <th>Source</th>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"body\" let-record let-expanded=\"expanded\">\r\n         <tr *ngIf=\"record.level == 2\" id=\"{{childSectionName}}-{{record.gNoForChild}}-{{record.level}}\">\r\n            <td>\r\n               <button type=\"button\" pButton pRipple [pRowToggler]=\"record\"\r\n                  id=\"expandLink-2-{{record.gNo}}-{{record.gNoForChild}}\"\r\n                  class=\"p-button-text p-button-rounded p-button-plain\"\r\n                  [icon]=\"expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"\r\n                  *ngIf=\"record.children != undefined && record.children.length\"></button>\r\n            </td>\r\n            <td *ngFor=\"let answer of getKeyValue(record)\" class=\"table-column\">\r\n               <span [ngClass]=\"{'text-changed': (answer.isChanged == true), 'text-style' : isWrapText(answer.value)}\">\r\n                  {{ifDateFormat(answer.value)}}</span>\r\n            </td>\r\n            <td>\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,1)\" class=\"small-icon\" alt=\"VicPol\"\r\n                  src=\"/assets/images/blue-diamond.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,5)\" class=\"small-icon\" alt=\"Court\"\r\n                  src=\"/assets/images/orange-circle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,4)\" class=\"small-icon\" alt=\"Corrections\"\r\n                  src=\"/assets/images/green-triangle.svg\">\r\n               <img tabindex=\"0\" *ngIf=\"checkSourceType(record.source,6)\" class=\"small-icon\" alt=\"DHHS\"\r\n                  src=\"/assets/images/purple-square.svg\">\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"rowexpansion\" let-record>\r\n         <tr>\r\n            <td [attr.colspan]=\"getColumnCount(record)\" class=\"pb-1\">\r\n               <ng-container *ngTemplateOutlet=\"cardbl; context {$implicit: record.children}\">\r\n               </ng-container>\r\n            </td>\r\n         </tr>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"emptymessage\">\r\n         <tr>\r\n            <td colspan=\"8\">No Records found</td>\r\n         </tr>\r\n      </ng-template>\r\n   </p-table>\r\n</ng-template>\r\n\r\n\r\n<ng-template #cardbl let-records let-parent>\r\n   <div class=\"grid\">\r\n      <ng-container *ngFor=\"let data of records\">\r\n         <div [ngClass]=\"checkLineWraps(data.controlType)\" class=\"p-1\">\r\n            <div class=\"grid\">\r\n               <div style=\"width:80px\" class=\"p-1\"></div>\r\n                  <div class=\"col p-1\"><strong>{{data.questionText}}</strong>\r\n                     <div *ngIf=\"data.additionalInformations\" class=\"info-block\" >\r\n                        <div *ngFor=\"let info of data.additionalInformations\" [innerHtml]=\"info.text\"></div>\r\n                     </div>\r\n                  </div>\r\n               </div>\r\n            <div class=\"grid\" *ngFor=\"let aSubItem of data.multiData; let index = index\">\r\n               <div class=\"col-fixed p-1\" style=\"width:80px\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,1)\" class=\"small-icon\" alt=\"VicPol\"\r\n                     src=\"/assets/images/blue-diamond.svg\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,5)\" class=\"small-icon\" alt=\"Court\"\r\n                     src=\"/assets/images/orange-circle.svg\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,4)\" class=\"small-icon\" alt=\"Corrections\"\r\n                     src=\"/assets/images/green-triangle.svg\">\r\n                  <img tabindex=\"0\" *ngIf=\"checkSourceType(aSubItem.s,6)\" class=\"small-icon\" alt=\"DHHS\"\r\n                     src=\"/assets/images/purple-square.svg\">\r\n               </div>\r\n               <div class=\"col p-1\">\r\n                  <ng-container *ngIf=\"data.level === 1;else levelTwoCheck\">\r\n                     <ng-container *ngIf=\"data.controlType !== 'tabledetailMultiline'\">\r\n                        <p [ngClass]=\"{'text-changed': checkValueChanged(data.gNo , data.rptCode, data.level, undefined, aSubItem), 'text-style' : isWrapText(aSubItem.v,data) }\">\r\n                           {{ifDateFormat(aSubItem.v,data)}}</p>\r\n                     </ng-container>\r\n                     <ng-container *ngIf=\"data.controlType === 'tabledetailMultiline'\">\r\n                        <input type=\"hidden\" #compareTextDifference [ngModel] = \"compareTextDiff(data.gNo , data.rptCode, data.level, undefined, aSubItem.s,data.rptCode + index + '-' + data.gNo, aSubItem.v, false)\">\r\n                        <p [id]=\"getTabledetailMultilineId(data, index)\" class=\"summary__textwrap\" [ngClass]=\"showMoreButton(compareTextDifference.value) ? 'showLessText': 'showMoreText'\">\r\n                           {{compareTextDiff(data.gNo , data.rptCode, data.level, undefined, aSubItem.s,data.rptCode +\r\n                           index + \"-\" + data.gNo, aSubItem.v, true)}}\r\n                        </p>\r\n                        <ng-container *ngIf=\"showMoreButton(compareTextDifference.value)\">\r\n                           <button type=\"button\" pButton pRipple class=\"p-button-text p-button-plain\" [attr.data-parentid] = \"getTabledetailMultilineId(data, index)\"\r\n                                   (click)=\"onShowMoreClick($event)\"> <span>{{showMore}} </span><i class=\"pi pi-chevron-down\"></i>\r\n                           </button>\r\n                         </ng-container>\r\n                     </ng-container>\r\n                  </ng-container>\r\n                  <ng-template #levelTwoCheck>\r\n                     <ng-container *ngIf=\"data.controlType !== 'tabledetailMultiline'\">\r\n                        <p [ngClass]=\"{'text-changed': checkValueChanged(data.gNo , data.rptCode, data.level, data.gNoForChild, aSubItem), 'text-style' : isWrapText(aSubItem.v,data)}\">\r\n                           {{ifDateFormat(aSubItem.v,data)}}</p>\r\n                     </ng-container>\r\n                     <ng-container *ngIf=\"data.controlType === 'tabledetailMultiline'\">\r\n                        <input type=\"hidden\" #compareTextDifference [ngModel] = \"compareTextDiff(data.gNo , data.rptCode, data.level, data.gNoForChild, aSubItem.s,data.rptCode + index + '-' + data.gNo + '-' + data.gNoForChild, aSubItem.v, false)\">\r\n                           <p [id]=\"getTabledetailMultilineId(data, index)\" class=\"summary__textwrap\" [ngClass]=\"showMoreButton(compareTextDifference.value) ? 'showLessText': 'showMoreText'\">\r\n                              {{compareTextDiff(data.gNo , data.rptCode, data.level, data.gNoForChild,\r\n                              aSubItem.s,data.rptCode + index + \"-\" + data.gNo + \"-\" + data.gNoForChild, aSubItem.v, true)}}\r\n                           </p>\r\n\r\n                        <ng-container *ngIf=\"showMoreButton(compareTextDifference.value)\">\r\n                           <button type=\"button\" pButton pRipple class=\"p-button-text p-button-plain\" [attr.data-parentid] = \"getTabledetailMultilineId(data, index)\"\r\n                                   (click)=\"onShowMoreClick($event)\"> <span>{{showMore}} </span><i class=\"pi pi-chevron-down\"></i>\r\n                           </button>\r\n                         </ng-container>\r\n                     </ng-container>\r\n                  </ng-template>\r\n               </div>\r\n            </div>\r\n         </div>\r\n      </ng-container>\r\n   </div>\r\n</ng-template>\r\n\r\n", styles: ["p-fieldset{padding:5px 15px}ins{color:#00f;text-decoration:none;text-decoration-color:#00f}.text-changed{color:#00f!important}.text-style{white-space:pre-wrap}.pull-right{float:right;text-align:right;margin-left:auto}.summary__textwrap{white-space:pre;white-space:-moz-pre-wrap;white-space:pre-wrap}.showLessText{overflow:hidden;text-overflow:ellipsis;max-height:60px}.showMoreText{overflow:visible}.small-icon{vertical-align:middle}@media (max-width: 720px){.hideOverflow{overflow:hidden;text-overflow:ellipsis;max-height:110px}}:host ::ng-deep .section-compare-table-striped.p-datatable .p-datatable-thead>tr>th{background:transparent}:host ::ng-deep .section-compare-table-striped.p-datatable .p-datatable-tbody>tr{background:transparent}:host ::ng-deep .section-compare-table-striped.p-datatable .p-datatable-tbody>tr.odd-row{background:#f3f3f3}:host ::ng-deep h3.section-compare-description{font-size:1rem}:host ::ng-deep h3.child-table{font-size:1rem;margin:.5rem 1rem}\n"] }]
        }], ctorParameters: () => [{ type: ReportDataService }] });

class SectionRepeatingInformationFieldType extends FieldArrayType {
    constructor(coreService) {
        super();
        this.coreService = coreService;
        this.isEditing = false;
        this.oldValue = {};
        this.showAllNotes = false;
        this.isEmpty = false;
    }
    ngOnInit() {
        this.initialise();
    }
    ngDoCheck() {
        this.initialise();
    }
    initialise() {
        this.isEmpty = false;
        if (this.field.model == null) {
            this.isEmpty = true;
        }
        else if (this.field.model != null && this.field.model.length <= 0) {
            if (this.props.repeatingItemRequired)
                this.addItem();
            else {
                this.isEmpty = true;
            }
        }
    }
    getFormGroups() {
        let fieldGroup = this.field.fieldGroup;
        if (this.showAllNotes != undefined && this.showAllNotes) {
            return fieldGroup;
        }
        let sectionGroups = [];
        for (let index = 0; index < fieldGroup.length; index++) {
            if (this.props.repeatingLimit > index)
                sectionGroups.push(fieldGroup[index]);
        }
        return sectionGroups;
    }
    addItem() {
        this.add(null, { isEditing: true }, { markAsDirty: true });
    }
    showMoreNotes() {
        console.log("showMoreNotes");
        this.showAllNotes = !this.showAllNotes;
    }
    showMoreNotesButton() {
        return this.field.fieldGroup?.length > this.props.repeatingLimit;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionRepeatingInformationFieldType, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionRepeatingInformationFieldType, selector: "section-repeating-information", usesInheritance: true, ngImport: i0, template: "<dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n<dspx-description [text]=\"props.description\"></dspx-description>\r\n\r\n<div class=\"mt-3 mb-4\"\r\n    *ngFor=\"let questions of getFormGroups();\">\r\n    <formly-field class=\"col\" [field]=\"questions\"></formly-field>\r\n</div>\r\n<ng-container *ngIf=\"showMoreNotesButton()\">\r\n    <div>\r\n        <button type=\"button\" pButton pRipple [icon]=\"showAllNotes ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"\r\n            (click)=\"showMoreNotes()\">\r\n            {{showAllNotes ? ' Show Less' : ' Show More'}} {{props.label}}</button>\r\n    </div>\r\n</ng-container>\r\n<div class=\"mb-4\" *ngIf=\"isEmpty == true\">\r\n    {{this.props.noRepeatingItemsText ? this.props.noRepeatingItemsText : 'No response'}}\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionRepeatingInformationFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'section-repeating-information', changeDetection: ChangeDetectionStrategy.OnPush, template: "<dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n<dspx-description [text]=\"props.description\"></dspx-description>\r\n\r\n<div class=\"mt-3 mb-4\"\r\n    *ngFor=\"let questions of getFormGroups();\">\r\n    <formly-field class=\"col\" [field]=\"questions\"></formly-field>\r\n</div>\r\n<ng-container *ngIf=\"showMoreNotesButton()\">\r\n    <div>\r\n        <button type=\"button\" pButton pRipple [icon]=\"showAllNotes ? 'pi pi-chevron-down' : 'pi pi-chevron-right'\"\r\n            (click)=\"showMoreNotes()\">\r\n            {{showAllNotes ? ' Show Less' : ' Show More'}} {{props.label}}</button>\r\n    </div>\r\n</ng-container>\r\n<div class=\"mb-4\" *ngIf=\"isEmpty == true\">\r\n    {{this.props.noRepeatingItemsText ? this.props.noRepeatingItemsText : 'No response'}}\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }] });

class TableFieldType extends FieldArrayType {
    constructor(coreService, dataService) {
        super();
        this.coreService = coreService;
        this.dataService = dataService;
        this.loading = false;
        this.records = [];
        this.selectedRecords = [];
        this.visibleColumns = [];
        this.globalFilter = false;
        this.globalFilterColumns = [];
        this.inlineFilters = false;
        this.exportButtonGroup = [];
        this.exportColumns = [];
        this.exportHeaders = [];
        this.customButtonsLeft = [];
        this.customButtonsRight = [];
        this.hideableColumns = [];
    }
    ngOnInit() {
        this.props.componentInstance = this;
        this.props.dashboardOptions.cols.forEach(col => {
            if (col.visible) {
                this.visibleColumns.push(col);
            }
            if (col.hideable) {
                this.hideableColumns.push(col);
            }
            if (col.includeInGlobalSearch) {
                this.globalFilterColumns.push(col.field);
            }
            if (col.sortable && col.visible) {
                if (!this.sortMode || this.sortMode === undefined || this.sortMode === null) {
                    this.sortMode = 'single';
                }
                else if (this.sortMode === 'single') {
                    this.sortMode = 'multiple';
                }
            }
        });
        //set the columns to be included in the export
        this.exportColumns = this.visibleColumns.filter((x) => { return x.includeInExport === true; }).map(item => {
            return item.field;
        });
        this.exportHeaders = this.visibleColumns.filter((x) => { return x.includeInExport === true; }).map(item => {
            return item.header;
        });
        this.globalFilter = this.globalFilterColumns.length > 0;
        this.inlineFilters = this.props.dashboardOptions.inlineFilters;
        if (this.props.dashboardOptions.allowCsvExport) {
            this.defaultExportButtonLabel = 'Export to CSV';
            this.defaultExportButtonIcon = "fas fa-file-download";
            this.exportButtonGroup.push({
                code: 'exportToCsv',
                label: 'Export to CSV',
                icon: 'fas fa-file-excel',
                iconPosition: 'left',
                type: "csv"
            });
        }
        if (this.props.dashboardOptions.allowExcelExport) {
            this.defaultExportButtonLabel = 'Export to Excel';
            this.defaultExportButtonIcon = "fas fa-file-excel";
            this.exportButtonGroup.push({
                code: 'exportToExcel',
                label: 'Export to Excel',
                icon: 'fas fa-file-excel',
                iconPosition: 'left',
                type: "excel"
            });
        }
        if (this.props.dashboardOptions.allowPdfExport) {
            this.defaultExportButtonLabel = 'Export to Pdf';
            this.defaultExportButtonIcon = "fas fa-file-pdf";
            this.exportButtonGroup.push({
                code: 'exportToPdf',
                label: 'Export to Pdf',
                icon: 'fas fa-file-pdf',
                iconPosition: 'left',
                type: "pdf"
            });
        }
        if (this.props.dashboardOptions?.buttons?.length > 0) {
            this.customButtonsLeft = this.props.dashboardOptions.buttons.filter(x => x.align === 'left');
            this.customButtonsRight = this.props.dashboardOptions.buttons.filter(x => x.align !== 'left');
        }
    }
    exportButtonClicked(button) {
        switch (button?.type) {
            case "csv": {
                this.exportCsv();
                break;
            }
            case "excel": {
                this.exportExcel();
                break;
            }
            case "pdf": {
                this.exportPdf();
                break;
            }
            default: {
                break;
            }
        }
    }
    getRenderedColumnsCount(table) {
        const tableEl = table.el;
        return tableEl.nativeElement.querySelectorAll('thead tr:first-child th').length;
    }
    getActionButtonsMenu(record) {
        const customActionButtons = this.props.dashboardOptions.actionButtons ? this.props.dashboardOptions.actionButtons.map(actionButton => ({
            visible: this.isActionButtonVisible(record, actionButton),
            label: actionButton.label,
            title: this.getActionButtonTitle(actionButton.label, record),
            icon: actionButton.icon,
            disabled: this.isReadonly(),
            command: () => this.actionButtonClicked(actionButton.type, record)
        })) : [];
        return [{
                visible: this.props.dashboardOptions.allowEdit && record.canEdit,
                label: 'Edit',
                title: this.getActionButtonTitle('Edit', record),
                icon: 'fas fa-pen',
                command: () => this.editButtonClicked(record)
            },
            {
                visible: this.props.dashboardOptions.allowView && record.canView,
                label: 'View',
                title: this.getActionButtonTitle('View', record),
                icon: 'fas fa-eye',
                command: () => this.viewButtonClicked(record)
            },
            {
                visible: this.props.dashboardOptions.allowPrint && record.canPrint,
                label: 'Print',
                title: this.getActionButtonTitle('Print', record),
                icon: 'fas fa-pen',
                command: () => this.printButtonClicked(record)
            },
            ...customActionButtons];
    }
    exportExcel() {
        this.exportModel = this.getExportFields();
        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.json_to_sheet([]);
        xlsx.utils.sheet_add_aoa(worksheet, [this.exportHeaders]);
        xlsx.utils.sheet_add_json(worksheet, this.exportModel, { origin: 'A2', skipHeader: true });
        xlsx.utils.book_append_sheet(workbook, worksheet, 'Data');
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "data", '.xlsx');
    }
    exportCsv() {
        this.exportModel = this.getExportFields();
        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.json_to_sheet([]);
        xlsx.utils.sheet_add_aoa(worksheet, [this.exportHeaders]);
        xlsx.utils.sheet_add_json(worksheet, this.exportModel, { origin: 'A2', skipHeader: true });
        xlsx.utils.book_append_sheet(workbook, worksheet, 'Data');
        const excelBuffer = xlsx.write(workbook, { bookType: 'csv', type: 'string' });
        this.saveAsExcelFile(excelBuffer, "data", '.csv');
    }
    getExportFields() {
        return this.model.map(item => {
            const returnValue = {};
            this.exportColumns.forEach(key => {
                returnValue[key] = item[key];
            });
            return returnValue;
        });
    }
    saveAsExcelFile(buffer, fileName, excelExtension) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        fileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + excelExtension);
    }
    exportPdf() {
        const pdfDoc = new jsPDF();
        const exportColumns = this.props.dashboardOptions.cols.map(col => ({ title: col.header, dataKey: col.field }));
        autoTable(pdfDoc, { columns: exportColumns, body: this.model });
        pdfDoc.save('export.pdf');
    }
    hasCaption() {
        return this.hasExportButton() || this.hasNewButton() || this.globalFilter || this.hasCustomButtons() || this.hasHideableColumns();
    }
    hasNewButton() {
        let allowAdd;
        if (this.props.dashboardOptions.allowAddFunctionName != null
            && this.props.dashboardOptions.allowAddFunctionName !== ''
            && this.coreService.conditionFunctions[this.props.dashboardOptions.allowAddFunctionName] != null) {
            allowAdd = this.coreService.conditionFunctions[this.props.dashboardOptions.allowAddFunctionName]();
        }
        else {
            allowAdd = this.props.dashboardOptions.allowAdd;
        }
        return allowAdd
            && !this.isReadonly();
    }
    hasExportButton() {
        return ((this.props.dashboardOptions.allowCsvExport
            || this.props.dashboardOptions.allowExcelExport
            || this.props.dashboardOptions.allowPdfExport)
            && !this.isReadonly());
    }
    hasCustomButtons() {
        return this.props.dashboardOptions?.buttons?.length > 0;
    }
    hasHideableColumns() {
        return this.props.dashboardOptions.hideableColumns === true;
    }
    isReadonly() {
        return (this.props.access && this.props.access === 'R');
    }
    isActionButtonVisible(record, actionButton) {
        return record.actions
            && record.actions[actionButton.type] !== null
            && record.actions[actionButton.type] !== undefined
            && record.actions[actionButton.type] === true;
    }
    hasActionButtons() {
        return ((this.props.dashboardOptions.actionButtons && this.props.dashboardOptions.actionButtons.length > 0)
            || this.props.dashboardOptions.allowView
            || this.props.dashboardOptions.allowEdit
            || this.props.dashboardOptions.allowPrint);
    }
    hasFilters() {
        return (this.visibleColumns &&
            this.visibleColumns.length > 0 &&
            this.visibleColumns.some(col => col.showFilter));
    }
    onDblClick($event) {
        if (this.props.actionButtonClick) {
            var actionButtonEvent = {
                type: ButtonType.doubleClick,
                data: $event.data
            };
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    lazyLoad($event) {
        this.coreService.applicationFunctions['lazyLoad']($event, this.field);
    }
    getValue(record, fieldName, col) {
        var fieldHierarchy = fieldName.split(".");
        if (fieldHierarchy && fieldHierarchy.length === 1) {
            return this.formatColValue(record[fieldName], col);
        }
        else {
            var object = record;
            for (var i = 0; i < fieldHierarchy.length - 1; i++) {
                object = object[fieldHierarchy[i]];
            }
            return this.formatColValue(object[fieldHierarchy[fieldHierarchy.length - 1]], col);
        }
    }
    formatColValue(obj, col) {
        // Handle dates
        if (obj && isNaN(obj.toString()) && col.dataType == 'date' && col.displayFormat) {
            // We handle two cases: where the column's value is internally a Date object, and when it's a string.
            // First, we make sure we have a Luxon DateTime to work with.
            var date = (obj instanceof Date) ? DateTime.fromJSDate(obj) : DateTime.fromISO(obj);
            // Now, format it
            if (date && date.isValid) {
                return date.toFormat(col.displayFormat);
            }
        }
        // Just pass through non-dates, as well as anything that looks like a date, but couldn't be handled
        return obj;
    }
    buttonClicked(button) {
        var actionButtonEvent = {
            type: ButtonType.custom,
            data: {
                buttonType: button.type,
                selectedItems: this.selectedRecords,
                allItems: this.model,
                table: this.tableInstance
            }
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    addNew() {
        if (this.props.actionButtonClick) {
            var actionButtonEvent = {
                type: ButtonType.new,
                data: null
            };
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    actionButtonClicked(buttonType, record) {
        var actionButtonEvent = {
            type: buttonType,
            data: record
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    colLinkClicked(record, colName) {
        var actionButtonEvent = {
            type: ButtonType.colLink,
            data: record,
            colName: colName,
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    editButtonClicked(record) {
        var actionButtonEvent = {
            type: ButtonType.edit,
            data: record
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    viewButtonClicked(record) {
        var actionButtonEvent = {
            type: ButtonType.view,
            data: record
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    printButtonClicked(record) {
        var actionButtonEvent = {
            type: ButtonType.print,
            data: record
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    getActionButtonTitle(actionName, record) {
        let actionButtonTitle = actionName;
        if (this.props.dashboardOptions.buttonTitleText) {
            const buttonTitleText = this.props.dashboardOptions.buttonTitleText.toLowerCase();
            actionButtonTitle = actionButtonTitle + ' ' + buttonTitleText;
        }
        if (record && this.props.dashboardOptions.buttonTitleKey && this.props.dashboardOptions.buttonTitleKey.length > 0) {
            let buttonTitleValue = '';
            this.props.dashboardOptions.buttonTitleKey.forEach(key => {
                let val = this.getValue(record, key, null);
                if (val !== null && val !== undefined) {
                    buttonTitleValue = buttonTitleValue + val + ' ';
                }
            });
            actionButtonTitle = actionButtonTitle + ' ' + buttonTitleValue;
        }
        return actionButtonTitle.trim();
    }
    get selectedColumns() {
        return this.visibleColumns;
    }
    set selectedColumns(selectedColumns) {
        this.visibleColumns = [];
        for (const col of this.props.dashboardOptions.cols) {
            if (col.hideable) {
                col.visible = selectedColumns.some(x => x.field === col.field);
            }
            if (col.visible) {
                this.visibleColumns.push(col);
            }
        }
        const onHideableColumnChangeFunction = this.coreService.applicationFunctions['onHideableColumnChange'];
        if (onHideableColumnChangeFunction != null) {
            let hiddenColumns = this.hideableColumns.filter((col) => !selectedColumns.includes(col));
            onHideableColumnChangeFunction(hiddenColumns);
        }
    }
    getTotalRecords() {
        let totalRecords = '';
        let key = `${this.field.key}-totalRecords`;
        if (this.field?.parent?.model?.[key] != null) {
            totalRecords = this.field.parent.model[key];
        }
        return totalRecords;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableFieldType, deps: [{ token: CoreService }, { token: DataService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableFieldType, selector: "dspx-table", viewQueries: [{ propertyName: "tableInstance", first: true, predicate: ["dt"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<p-table #dt\r\n  [value]=\"model\"\r\n  [(selection)]=\"selectedRecords\"\r\n  [dataKey]=\"props.dashboardOptions.key\"\r\n  [styleClass]=\"props.dashboardOptions.styleClass\"\r\n  [rowHover]=\"props.dashboardOptions.rowHover\"\r\n  [rows]=\"props.dashboardOptions.rowsPerPage\"\r\n  [showCurrentPageReport]=\"props.dashboardOptions.showCurrentPageReport\"\r\n  [rowsPerPageOptions]=\"props.dashboardOptions.rowsPerPageOptions\"\r\n  [loading]=\"loading\"\r\n  [paginator]=\"props.dashboardOptions.paginator\"\r\n  [autoLayout]=\"props.dashboardOptions.autoLayout\"\r\n  [resizableColumns]=\"props.dashboardOptions.allowColumResize\"\r\n  [currentPageReportTemplate]=\"props.dashboardOptions.currentPageReportTemplate\"\r\n  [filterDelay]=\"props.dashboardOptions.filterDelay\"\r\n  [globalFilterFields]=\"globalFilterColumns\"\r\n  [sortMode]=\"sortMode ? sortMode : undefined\"\r\n  [selectionMode] = \"props.dashboardOptions.checkboxSelection ? 'multiple' : 'single'\"\r\n  [virtualScroll]=\"props.dashboardOptions.virtualScroll\"\r\n  [virtualScrollOptions]=\"props.dashboardOptions.virtualScroll ? { numToleratedItems: 20, scrollHeight: '350px', delay: 1000 } : undefined\"\r\n  [lazy]=\"props.dashboardOptions.lazy ? true : false\"\r\n  [stateKey]=\"props.dashboardOptions.stateKey\"\r\n  [stateStorage]=\"props.dashboardOptions.stateStorage\"\r\n  [totalRecords] = \"getTotalRecords()\"\r\n  (onRowSelect)=\"onDblClick($event)\"\r\n  (onLazyLoad)=\"lazyLoad($event)\"\r\n  pSelectableRowDblClick\r\n  [ngClass]=\"{'caption-is-empty': !hasCaption()}\"\r\n  responsiveLayout=\"scroll\">\r\n    <ng-template pTemplate=\"caption\">\r\n        <div *ngIf=\"hasCaption()\" class=\"table-header\">\r\n          <span class=\"action-buttons\">\r\n            <button\r\n              pButton\r\n              pRipple\r\n              type=\"button\"\r\n              *ngIf=\"hasNewButton()\"\r\n              label=\"Add New\"\r\n              class=\"p-button-sm\"\r\n              icon=\"fas fa-plus\"\r\n              iconPos = \"left\"\r\n              [pTooltip]=\"getActionButtonTitle('Add new', null)\"\r\n              tooltipPosition=\"bottom\"\r\n              (click)=\"addNew()\"\r\n              [title]=\"getActionButtonTitle('Add new', null)\">\r\n            </button>\r\n            <ng-container *ngFor=\"let btn of customButtonsLeft\">\r\n              <button\r\n                pButton\r\n                pRipple\r\n                type=\"button\"\r\n                [label]=\"btn.label\"\r\n                class=\"p-button-sm {{btn.styleClass}}\"\r\n                [icon]=\"btn.icon\"\r\n                iconPos = \"left\"\r\n                [pTooltip]=\"btn.tooltip\"\r\n                tooltipPosition=\"bottom\"\r\n                (click)=\"buttonClicked(btn)\"\r\n                [title]=\"btn.title\">\r\n              </button>\r\n            </ng-container>\r\n          </span>\r\n          <span class=\"action-buttons\">\r\n            <ng-container>\r\n              <ng-container *ngFor=\"let btn of customButtonsRight\">\r\n                <button\r\n                  pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  [label]=\"btn.label\"\r\n                  class=\"p-button-sm {{btn.styleClass}}\"\r\n                  [icon]=\"btn.icon\"\r\n                  iconPos = \"left\"\r\n                  [pTooltip]=\"btn.tooltip\"\r\n                  tooltipPosition=\"bottom\"\r\n                  (click)=\"buttonClicked(btn)\"\r\n                  [title]=\"btn.title\">\r\n                </button>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"hasExportButton()\">\r\n                <ng-container *ngFor=\"let exportButton of exportButtonGroup\">\r\n                  <button\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    [label]=\"exportButton.label\"\r\n                    class=\"p-button-sm\"\r\n                    [icon]=\"exportButton.icon\"\r\n                    [iconPos] = \"exportButton.iconPosition ?? 'left'\"\r\n                    [pTooltip]=\"exportButton.label\"\r\n                    tooltipPosition=\"bottom\"\r\n                    (click)=\"exportButtonClicked(exportButton)\"\r\n                    [title]=\"exportButton.title\">\r\n                  </button>\r\n                </ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </span>\r\n          <span *ngIf=\"globalFilter\" class=\"p-input-icon-left\">\r\n              <i class=\"fas fa-search\" aria-hidden=\"true\" role=\"img\"></i>\r\n              <input pInputText type=\"text\" (input)=\"dt.filterGlobal($event.target.value, 'contains')\"\r\n                [placeholder]=\"props.dashboardOptions.globalFilterPlaceHolder\"\r\n                [attr.aria-label]=\"props.dashboardOptions.globalFilterPlaceHolder\" />\r\n          </span>\r\n          <span *ngIf=\"hasHideableColumns()\">\r\n            <p-multiSelect [options]=\"hideableColumns\" [(ngModel)]=\"selectedColumns\" optionLabel=\"header\"\r\n            [maxSelectedLabels]=\"0\" selectedItemsLabel=\"Selected Columns\" placeholder=\"Choose Columns\">\r\n            </p-multiSelect>\r\n          </span>\r\n        </div>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"header\">\r\n        <tr>\r\n            <td *ngIf=\"props.dashboardOptions.checkboxSelection\" class=\"checkbox-header\">\r\n                <p-tableHeaderCheckbox ariaLabel=\"Select all rows\"></p-tableHeaderCheckbox>\r\n            </td>\r\n            <th *ngFor=\"let col of visibleColumns\"\r\n              [pSortableColumn]=\"col.sortable ? col.field : undefined\"\r\n              [pResizableColumn] = \"props.dashboardOptions.allowColumResize\"\r\n              [style.width]=\"col.width ? col.width : undefined\">\r\n              <div>\r\n                <span style=\"max-width:70%;\">{{col.header}}</span>\r\n                <p-sortIcon *ngIf=\"col.sortable\" [field]=\"col.field\"></p-sortIcon>\r\n                <p-columnFilter *ngIf=\"col.showFilter && !props.dashboardOptions.inlineFilters && col.dataType != 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" display=\"menu\" class=\"ml-auto\" [ariaLabel]=\"'Filter '+col.header\"></p-columnFilter>\r\n                <p-columnFilter *ngIf=\"col.showFilter && !props.dashboardOptions.inlineFilters && col.dataType == 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" display=\"menu\" class=\"ml-auto\" [ariaLabel]=\"'Filter '+col.header\">\r\n                  <ng-template pTemplate=\"filter\" let-value let-filter=\"filterCallback\">\r\n                    <p-calendar [ngModel]=\"value\" (ngModelChange)=\"filter($event)\" [appendTo]=\"dt\" dateFormat=\"dd/mm/yy\" [ariaLabel]=\"'Filter date'\"></p-calendar>\r\n                  </ng-template>\r\n                </p-columnFilter>\r\n              </div>\r\n            </th>\r\n            <td *ngIf=\"hasActionButtons()\" class=\"action-button-column\" [ngClass]=\"{'action-button-column-collapsed': props.dashboardOptions.collapseActionButtons}\">\r\n              {{props.dashboardOptions.collapseActionButtons ? '' : props.dashboardOptions.actionButtonColumnHeading}}\r\n            </td>\r\n        </tr>\r\n        <tr *ngIf=\"props.dashboardOptions.inlineFilters && hasFilters()\">\r\n          <td *ngIf=\"props.dashboardOptions.checkboxSelection\">\r\n          </td>\r\n          <td *ngFor=\"let col of visibleColumns\">\r\n            <p-columnFilter *ngIf=\"col.showFilter && col.dataType == 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" [showClearButton]=\"false\"  [ariaLabel]=\"'Filter '+col.header\">\r\n              <ng-template pTemplate=\"filter\" let-value let-filter=\"filterCallback\">\r\n                <p-calendar [ngModel]=\"value\" (ngModelChange)=\"filter($event)\" [appendTo]=\"dt\" dateFormat=\"dd/mm/yy\" [ariaLabel]=\"'Filter date'\"></p-calendar>\r\n              </ng-template>\r\n            </p-columnFilter>\r\n            <p-columnFilter *ngIf=\"col.showFilter && col.dataType != 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" [showClearButton]=\"false\"  [ariaLabel]=\"'Filter '+col.header\"></p-columnFilter>\r\n\r\n          </td>\r\n          <td *ngIf=\"hasActionButtons()\">\r\n          </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-record let-rowIndex=\"recordIndex\">\r\n        <tr [ngClass]=\"record.dspxTableRowClass\">\r\n            <td class=\"checkbox-header\" *ngIf=\"props.dashboardOptions.checkboxSelection\">\r\n                <p-tableCheckbox [value]=\"record\" ariaLabel=\"Select row\"></p-tableCheckbox>\r\n            </td>\r\n            <td *ngFor=\"let col of visibleColumns\"\r\n              class=\"table-column\"\r\n              [style.width]=\"col.width ? col.width : undefined\"\r\n              [style.max-width]=\"col.width ? col.width: undefined\">\r\n              <a *ngIf=\"col.isLink\" role=\"button\" href=\"javascript:void(0)\" [title]=\"col.linkTooltip ?? ''\" (click)=\"colLinkClicked(record,col.field)\">\r\n                {{ getValue(record,col.field, col) }}\r\n              </a>\r\n              <div *ngIf=\"col.isIcon\">\r\n                <i *ngFor=\"let config of getValue(record,col.field, col)\" [attr.class]=\"config.iconClass\" [title]=\"config.tooltip ?? ''\">{{config.label}}</i>\r\n              </div>\r\n              <div *ngIf=\"!col.isLink && !col.isIcon\">\r\n                {{ getValue(record,col.field, col) }}\r\n              </div>\r\n            </td>\r\n            <td *ngIf=\"hasActionButtons() && !props.dashboardOptions.collapseActionButtons\" class=\"align-items-center action-button-column\">\r\n              <button *ngIf=\"props.dashboardOptions.allowEdit && record.canEdit\" [title]=\"getActionButtonTitle('Edit',record)\" pButton pRipple type=\"button\" class=\"p-button-rounded p-button-secondary\" icon=\"fas fa-pen\" (click)=\"editButtonClicked(record)\"></button>\r\n              <button *ngIf=\"props.dashboardOptions.allowView && record.canView\" [title]=\"getActionButtonTitle('View',record)\" pButton pRipple type=\"button\" class=\"p-button-rounded p-button-secondary\" icon=\"fas fa-eye\" (click)=\"viewButtonClicked(record)\"></button>\r\n              <button *ngIf=\"props.dashboardOptions.allowPrint && record.canPrint\" [title]=\"getActionButtonTitle('Print',record)\" pButton pRipple type=\"button\" class=\"p-button-rounded p-button-secondary\" icon=\"fas fa-print\" (click)=\"printButtonClicked(record)\"></button>\r\n              <span *ngFor=\"let actionButton of props.dashboardOptions.actionButtons\" >\r\n                <button *ngIf=isActionButtonVisible(record,actionButton) pButton pRipple type=\"button\" [title]=\"getActionButtonTitle(actionButton.label,record)\" [disabled] = \"isReadonly()\" class=\"p-button-rounded p-button-secondary\" [icon]=\"actionButton.icon\" (click)=\"actionButtonClicked(actionButton.type, record)\"></button>\r\n              </span>\r\n            </td>\r\n            <td *ngIf=\"hasActionButtons() && props.dashboardOptions.collapseActionButtons\" class=\"align-items-center action-button-column action-button-column-collapsed\">\r\n              <button type=\"button\" pButton pRipple style=\"float: right\" class=\"p-button-rounded p-button-secondary\" icon=\"pi pi-ellipsis-v\" (click)=\"actionButtonsMenu.toggle($event)\" title=\"Actions\"></button>\r\n              <p-menu #actionButtonsMenu [popup]=\"true\" [appendTo]=\"dt\" [model]=\"getActionButtonsMenu(record)\"></p-menu>\r\n            </td>\r\n        </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"emptymessage\">\r\n        <tr>\r\n            <td [attr.colspan]=\"getRenderedColumnsCount(dt)\" [innerHtml]=\"props.dashboardOptions.noRecordFoundMessage\"></td>\r\n        </tr>\r\n    </ng-template>\r\n</p-table>\r\n", styles: [":host ::ng-deep p-table.caption-is-empty .p-datatable-header{display:none}:host ::ng-deep .p-paginator .p-paginator-current{margin-left:auto}:host ::ng-deep .p-progressbar{height:.5rem;background-color:#d8dadc}:host ::ng-deep .p-progressbar .p-progressbar-value{background-color:#607d8b}:host ::ng-deep .table-header{display:flex;justify-content:space-between}:host ::ng-deep .table-header .action-buttons{display:flex}:host ::ng-deep .table-column{overflow:hidden}:host ::ng-deep .table-column>a{cursor:pointer}:host ::ng-deep .checkbox-header{width:2rem}:host ::ng-deep .action-button-column{width:10rem;white-space:nowrap}:host ::ng-deep .action-button-column-collapsed{width:3rem}:host ::ng-deep .action-button-column .p-button-secondary{border-color:transparent}:host ::ng-deep .p-calendar .p-datepicker{min-width:25rem}:host ::ng-deep .p-calendar .p-datepicker td{font-weight:400}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-header{padding:1rem;text-align:left;font-size:1.5rem}:host ::ng-deep .p-datatable.p-datatable-dspx .p-paginator{padding:1rem}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>th,:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>td{text-align:left}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td{cursor:auto;overflow:hidden}:host ::ng-deep .p-datatable.p-datatable-dspx .p-dropdown-label:not(.p-placeholder){text-transform:uppercase}:host ::ng-deep .p-datatable-dspx .p-datatable-tbody>tr>td .p-column-title{display:none}:host ::ng-deep .p-datatable-thead>tr>th .p-column-filter-row .p-column-filter-clear-button,:host ::ng-deep .p-datatable-thead>tr>td .p-column-filter-row .p-column-filter-clear-button{display:none}@media screen and (max-width: 960px){:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>th,:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>td,:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tfoot>tr>td{display:none!important}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr{border-bottom:1px solid var(--layer-2)}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td{text-align:left;display:block;border:0 none!important;width:100%!important;float:left;clear:left;border:0 none}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td .p-column-title{padding:.4rem;min-width:30%;display:inline-block;margin:-.4rem 1rem -.4rem -.4rem;font-weight:700}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td .p-progressbar{margin-top:.5rem}}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.InputText, selector: "[pInputText]", inputs: ["variant"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i3$3.Calendar, selector: "p-calendar", inputs: ["iconDisplay", "style", "styleClass", "inputStyle", "inputId", "name", "inputStyleClass", "placeholder", "ariaLabelledBy", "ariaLabel", "iconAriaLabel", "disabled", "dateFormat", "multipleSeparator", "rangeSeparator", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "monthNavigator", "yearNavigator", "hourFormat", "timeOnly", "stepYearPicker", "stepHour", "stepMinute", "stepSecond", "showSeconds", "required", "showOnFocus", "showWeek", "startWeekFromFirstDayOfYear", "showClear", "dataType", "selectionMode", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "autofocus", "autoZIndex", "baseZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "touchUI", "timeSeparator", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "tabindex", "variant", "minDate", "maxDate", "disabledDates", "disabledDays", "yearRange", "showTime", "responsiveOptions", "numberOfMonths", "firstDayOfWeek", "locale", "view", "defaultDate"], outputs: ["onFocus", "onBlur", "onClose", "onSelect", "onClear", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange", "onClickOutside", "onShow"] }, { kind: "component", type: i3$8.MultiSelect, selector: "p-multiSelect", inputs: ["id", "ariaLabel", "style", "styleClass", "panelStyle", "panelStyleClass", "inputId", "disabled", "readonly", "group", "filter", "filterPlaceHolder", "filterLocale", "overlayVisible", "tabindex", "variant", "appendTo", "dataKey", "name", "ariaLabelledBy", "displaySelectedLabel", "maxSelectedLabels", "selectionLimit", "selectedItemsLabel", "showToggleAll", "emptyFilterMessage", "emptyMessage", "resetFilterOnHide", "dropdownIcon", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "showHeader", "filterBy", "scrollHeight", "lazy", "virtualScroll", "loading", "virtualScrollItemSize", "loadingIcon", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "filterMatchMode", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "autofocusFilter", "display", "autocomplete", "showClear", "autofocus", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "defaultLabel", "placeholder", "options", "filterValue", "itemSize", "selectAll", "focusOnHover", "filterFields", "selectOnFocus", "autoOptionFocus"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onClear", "onPanelShow", "onPanelHide", "onLazyLoad", "onRemove", "onSelectAllChange"] }, { kind: "directive", type: i2$1.Tooltip, selector: "[pTooltip]", inputs: ["tooltipPosition", "tooltipEvent", "appendTo", "positionStyle", "tooltipStyleClass", "tooltipZIndex", "escape", "showDelay", "hideDelay", "life", "positionTop", "positionLeft", "autoHide", "fitContent", "hideOnEscape", "pTooltip", "tooltipDisabled", "tooltipOptions"] }, { kind: "component", type: Table, selector: "p-table", inputs: ["frozenColumns", "frozenValue", "style", "styleClass", "tableStyle", "tableStyleClass", "paginator", "pageLinks", "rowsPerPageOptions", "alwaysShowPaginator", "paginatorPosition", "paginatorStyleClass", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showFirstLastIcon", "showPageLinks", "defaultSortOrder", "sortMode", "resetPageOnSort", "selectionMode", "selectionPageOnly", "contextMenuSelection", "contextMenuSelectionMode", "dataKey", "metaKeySelection", "rowSelectable", "rowTrackBy", "lazy", "lazyLoadOnInit", "compareSelectionBy", "csvSeparator", "exportFilename", "filters", "globalFilterFields", "filterDelay", "filterLocale", "expandedRowKeys", "editingRowKeys", "rowExpandMode", "scrollable", "scrollDirection", "rowGroupMode", "scrollHeight", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "frozenWidth", "responsive", "contextMenu", "resizableColumns", "columnResizeMode", "reorderableColumns", "loading", "loadingIcon", "showLoader", "rowHover", "customSort", "showInitialSortBadge", "autoLayout", "exportFunction", "exportHeader", "stateKey", "stateStorage", "editMode", "groupRowsBy", "groupRowsByOrder", "responsiveLayout", "breakpoint", "paginatorLocale", "value", "columns", "first", "rows", "totalRecords", "sortField", "sortOrder", "multiSortMeta", "selection", "selectAll", "virtualRowHeight"], outputs: ["contextMenuSelectionChange", "selectAllChange", "selectionChange", "onRowSelect", "onRowUnselect", "onPage", "onSort", "onFilter", "onLazyLoad", "onRowExpand", "onRowCollapse", "onContextMenuSelect", "onColResize", "onColReorder", "onRowReorder", "onEditInit", "onEditComplete", "onEditCancel", "onHeaderCheckboxToggle", "sortFunction", "firstChange", "rowsChange", "onStateSave", "onStateRestore"] }, { kind: "directive", type: SortableColumn, selector: "[pSortableColumn]", inputs: ["pSortableColumn", "pSortableColumnDisabled"] }, { kind: "directive", type: ResizableColumn, selector: "[pResizableColumn]", inputs: ["pResizableColumnDisabled"] }, { kind: "component", type: SortIcon, selector: "p-sortIcon", inputs: ["field"] }, { kind: "component", type: TableCheckbox, selector: "p-tableCheckbox", inputs: ["disabled", "value", "index", "inputId", "name", "required", "ariaLabel"] }, { kind: "component", type: TableHeaderCheckbox, selector: "p-tableHeaderCheckbox", inputs: ["disabled", "inputId", "name", "ariaLabel"] }, { kind: "directive", type: SelectableRowDblClick, selector: "[pSelectableRowDblClick]", inputs: ["pSelectableRowDblClick", "pSelectableRowIndex", "pSelectableRowDisabled"] }, { kind: "component", type: ColumnFilter, selector: "p-columnFilter", inputs: ["field", "type", "display", "showMenu", "matchMode", "operator", "showOperator", "showMenuButtonAriaLabel", "showMenuButtonWhenFilterAppliedAriaLabel", "showClearButton", "showApplyButton", "showMatchModes", "showAddButton", "hideOnClear", "placeholder", "matchModeOptions", "maxConstraints", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping", "showButtons"] }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i4$2.Menu, selector: "p-menu", inputs: ["model", "popup", "style", "styleClass", "appendTo", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "ariaLabel", "ariaLabelledBy", "id", "tabindex"], outputs: ["onShow", "onHide", "onBlur", "onFocus"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-table', template: "<p-table #dt\r\n  [value]=\"model\"\r\n  [(selection)]=\"selectedRecords\"\r\n  [dataKey]=\"props.dashboardOptions.key\"\r\n  [styleClass]=\"props.dashboardOptions.styleClass\"\r\n  [rowHover]=\"props.dashboardOptions.rowHover\"\r\n  [rows]=\"props.dashboardOptions.rowsPerPage\"\r\n  [showCurrentPageReport]=\"props.dashboardOptions.showCurrentPageReport\"\r\n  [rowsPerPageOptions]=\"props.dashboardOptions.rowsPerPageOptions\"\r\n  [loading]=\"loading\"\r\n  [paginator]=\"props.dashboardOptions.paginator\"\r\n  [autoLayout]=\"props.dashboardOptions.autoLayout\"\r\n  [resizableColumns]=\"props.dashboardOptions.allowColumResize\"\r\n  [currentPageReportTemplate]=\"props.dashboardOptions.currentPageReportTemplate\"\r\n  [filterDelay]=\"props.dashboardOptions.filterDelay\"\r\n  [globalFilterFields]=\"globalFilterColumns\"\r\n  [sortMode]=\"sortMode ? sortMode : undefined\"\r\n  [selectionMode] = \"props.dashboardOptions.checkboxSelection ? 'multiple' : 'single'\"\r\n  [virtualScroll]=\"props.dashboardOptions.virtualScroll\"\r\n  [virtualScrollOptions]=\"props.dashboardOptions.virtualScroll ? { numToleratedItems: 20, scrollHeight: '350px', delay: 1000 } : undefined\"\r\n  [lazy]=\"props.dashboardOptions.lazy ? true : false\"\r\n  [stateKey]=\"props.dashboardOptions.stateKey\"\r\n  [stateStorage]=\"props.dashboardOptions.stateStorage\"\r\n  [totalRecords] = \"getTotalRecords()\"\r\n  (onRowSelect)=\"onDblClick($event)\"\r\n  (onLazyLoad)=\"lazyLoad($event)\"\r\n  pSelectableRowDblClick\r\n  [ngClass]=\"{'caption-is-empty': !hasCaption()}\"\r\n  responsiveLayout=\"scroll\">\r\n    <ng-template pTemplate=\"caption\">\r\n        <div *ngIf=\"hasCaption()\" class=\"table-header\">\r\n          <span class=\"action-buttons\">\r\n            <button\r\n              pButton\r\n              pRipple\r\n              type=\"button\"\r\n              *ngIf=\"hasNewButton()\"\r\n              label=\"Add New\"\r\n              class=\"p-button-sm\"\r\n              icon=\"fas fa-plus\"\r\n              iconPos = \"left\"\r\n              [pTooltip]=\"getActionButtonTitle('Add new', null)\"\r\n              tooltipPosition=\"bottom\"\r\n              (click)=\"addNew()\"\r\n              [title]=\"getActionButtonTitle('Add new', null)\">\r\n            </button>\r\n            <ng-container *ngFor=\"let btn of customButtonsLeft\">\r\n              <button\r\n                pButton\r\n                pRipple\r\n                type=\"button\"\r\n                [label]=\"btn.label\"\r\n                class=\"p-button-sm {{btn.styleClass}}\"\r\n                [icon]=\"btn.icon\"\r\n                iconPos = \"left\"\r\n                [pTooltip]=\"btn.tooltip\"\r\n                tooltipPosition=\"bottom\"\r\n                (click)=\"buttonClicked(btn)\"\r\n                [title]=\"btn.title\">\r\n              </button>\r\n            </ng-container>\r\n          </span>\r\n          <span class=\"action-buttons\">\r\n            <ng-container>\r\n              <ng-container *ngFor=\"let btn of customButtonsRight\">\r\n                <button\r\n                  pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  [label]=\"btn.label\"\r\n                  class=\"p-button-sm {{btn.styleClass}}\"\r\n                  [icon]=\"btn.icon\"\r\n                  iconPos = \"left\"\r\n                  [pTooltip]=\"btn.tooltip\"\r\n                  tooltipPosition=\"bottom\"\r\n                  (click)=\"buttonClicked(btn)\"\r\n                  [title]=\"btn.title\">\r\n                </button>\r\n              </ng-container>\r\n              <ng-container *ngIf=\"hasExportButton()\">\r\n                <ng-container *ngFor=\"let exportButton of exportButtonGroup\">\r\n                  <button\r\n                    pButton\r\n                    pRipple\r\n                    type=\"button\"\r\n                    [label]=\"exportButton.label\"\r\n                    class=\"p-button-sm\"\r\n                    [icon]=\"exportButton.icon\"\r\n                    [iconPos] = \"exportButton.iconPosition ?? 'left'\"\r\n                    [pTooltip]=\"exportButton.label\"\r\n                    tooltipPosition=\"bottom\"\r\n                    (click)=\"exportButtonClicked(exportButton)\"\r\n                    [title]=\"exportButton.title\">\r\n                  </button>\r\n                </ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </span>\r\n          <span *ngIf=\"globalFilter\" class=\"p-input-icon-left\">\r\n              <i class=\"fas fa-search\" aria-hidden=\"true\" role=\"img\"></i>\r\n              <input pInputText type=\"text\" (input)=\"dt.filterGlobal($event.target.value, 'contains')\"\r\n                [placeholder]=\"props.dashboardOptions.globalFilterPlaceHolder\"\r\n                [attr.aria-label]=\"props.dashboardOptions.globalFilterPlaceHolder\" />\r\n          </span>\r\n          <span *ngIf=\"hasHideableColumns()\">\r\n            <p-multiSelect [options]=\"hideableColumns\" [(ngModel)]=\"selectedColumns\" optionLabel=\"header\"\r\n            [maxSelectedLabels]=\"0\" selectedItemsLabel=\"Selected Columns\" placeholder=\"Choose Columns\">\r\n            </p-multiSelect>\r\n          </span>\r\n        </div>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"header\">\r\n        <tr>\r\n            <td *ngIf=\"props.dashboardOptions.checkboxSelection\" class=\"checkbox-header\">\r\n                <p-tableHeaderCheckbox ariaLabel=\"Select all rows\"></p-tableHeaderCheckbox>\r\n            </td>\r\n            <th *ngFor=\"let col of visibleColumns\"\r\n              [pSortableColumn]=\"col.sortable ? col.field : undefined\"\r\n              [pResizableColumn] = \"props.dashboardOptions.allowColumResize\"\r\n              [style.width]=\"col.width ? col.width : undefined\">\r\n              <div>\r\n                <span style=\"max-width:70%;\">{{col.header}}</span>\r\n                <p-sortIcon *ngIf=\"col.sortable\" [field]=\"col.field\"></p-sortIcon>\r\n                <p-columnFilter *ngIf=\"col.showFilter && !props.dashboardOptions.inlineFilters && col.dataType != 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" display=\"menu\" class=\"ml-auto\" [ariaLabel]=\"'Filter '+col.header\"></p-columnFilter>\r\n                <p-columnFilter *ngIf=\"col.showFilter && !props.dashboardOptions.inlineFilters && col.dataType == 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" display=\"menu\" class=\"ml-auto\" [ariaLabel]=\"'Filter '+col.header\">\r\n                  <ng-template pTemplate=\"filter\" let-value let-filter=\"filterCallback\">\r\n                    <p-calendar [ngModel]=\"value\" (ngModelChange)=\"filter($event)\" [appendTo]=\"dt\" dateFormat=\"dd/mm/yy\" [ariaLabel]=\"'Filter date'\"></p-calendar>\r\n                  </ng-template>\r\n                </p-columnFilter>\r\n              </div>\r\n            </th>\r\n            <td *ngIf=\"hasActionButtons()\" class=\"action-button-column\" [ngClass]=\"{'action-button-column-collapsed': props.dashboardOptions.collapseActionButtons}\">\r\n              {{props.dashboardOptions.collapseActionButtons ? '' : props.dashboardOptions.actionButtonColumnHeading}}\r\n            </td>\r\n        </tr>\r\n        <tr *ngIf=\"props.dashboardOptions.inlineFilters && hasFilters()\">\r\n          <td *ngIf=\"props.dashboardOptions.checkboxSelection\">\r\n          </td>\r\n          <td *ngFor=\"let col of visibleColumns\">\r\n            <p-columnFilter *ngIf=\"col.showFilter && col.dataType == 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" [showClearButton]=\"false\"  [ariaLabel]=\"'Filter '+col.header\">\r\n              <ng-template pTemplate=\"filter\" let-value let-filter=\"filterCallback\">\r\n                <p-calendar [ngModel]=\"value\" (ngModelChange)=\"filter($event)\" [appendTo]=\"dt\" dateFormat=\"dd/mm/yy\" [ariaLabel]=\"'Filter date'\"></p-calendar>\r\n              </ng-template>\r\n            </p-columnFilter>\r\n            <p-columnFilter *ngIf=\"col.showFilter && col.dataType != 'date'\" [type]=\"col.dataType\" [field]=\"col.field\" [showClearButton]=\"false\"  [ariaLabel]=\"'Filter '+col.header\"></p-columnFilter>\r\n\r\n          </td>\r\n          <td *ngIf=\"hasActionButtons()\">\r\n          </td>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-record let-rowIndex=\"recordIndex\">\r\n        <tr [ngClass]=\"record.dspxTableRowClass\">\r\n            <td class=\"checkbox-header\" *ngIf=\"props.dashboardOptions.checkboxSelection\">\r\n                <p-tableCheckbox [value]=\"record\" ariaLabel=\"Select row\"></p-tableCheckbox>\r\n            </td>\r\n            <td *ngFor=\"let col of visibleColumns\"\r\n              class=\"table-column\"\r\n              [style.width]=\"col.width ? col.width : undefined\"\r\n              [style.max-width]=\"col.width ? col.width: undefined\">\r\n              <a *ngIf=\"col.isLink\" role=\"button\" href=\"javascript:void(0)\" [title]=\"col.linkTooltip ?? ''\" (click)=\"colLinkClicked(record,col.field)\">\r\n                {{ getValue(record,col.field, col) }}\r\n              </a>\r\n              <div *ngIf=\"col.isIcon\">\r\n                <i *ngFor=\"let config of getValue(record,col.field, col)\" [attr.class]=\"config.iconClass\" [title]=\"config.tooltip ?? ''\">{{config.label}}</i>\r\n              </div>\r\n              <div *ngIf=\"!col.isLink && !col.isIcon\">\r\n                {{ getValue(record,col.field, col) }}\r\n              </div>\r\n            </td>\r\n            <td *ngIf=\"hasActionButtons() && !props.dashboardOptions.collapseActionButtons\" class=\"align-items-center action-button-column\">\r\n              <button *ngIf=\"props.dashboardOptions.allowEdit && record.canEdit\" [title]=\"getActionButtonTitle('Edit',record)\" pButton pRipple type=\"button\" class=\"p-button-rounded p-button-secondary\" icon=\"fas fa-pen\" (click)=\"editButtonClicked(record)\"></button>\r\n              <button *ngIf=\"props.dashboardOptions.allowView && record.canView\" [title]=\"getActionButtonTitle('View',record)\" pButton pRipple type=\"button\" class=\"p-button-rounded p-button-secondary\" icon=\"fas fa-eye\" (click)=\"viewButtonClicked(record)\"></button>\r\n              <button *ngIf=\"props.dashboardOptions.allowPrint && record.canPrint\" [title]=\"getActionButtonTitle('Print',record)\" pButton pRipple type=\"button\" class=\"p-button-rounded p-button-secondary\" icon=\"fas fa-print\" (click)=\"printButtonClicked(record)\"></button>\r\n              <span *ngFor=\"let actionButton of props.dashboardOptions.actionButtons\" >\r\n                <button *ngIf=isActionButtonVisible(record,actionButton) pButton pRipple type=\"button\" [title]=\"getActionButtonTitle(actionButton.label,record)\" [disabled] = \"isReadonly()\" class=\"p-button-rounded p-button-secondary\" [icon]=\"actionButton.icon\" (click)=\"actionButtonClicked(actionButton.type, record)\"></button>\r\n              </span>\r\n            </td>\r\n            <td *ngIf=\"hasActionButtons() && props.dashboardOptions.collapseActionButtons\" class=\"align-items-center action-button-column action-button-column-collapsed\">\r\n              <button type=\"button\" pButton pRipple style=\"float: right\" class=\"p-button-rounded p-button-secondary\" icon=\"pi pi-ellipsis-v\" (click)=\"actionButtonsMenu.toggle($event)\" title=\"Actions\"></button>\r\n              <p-menu #actionButtonsMenu [popup]=\"true\" [appendTo]=\"dt\" [model]=\"getActionButtonsMenu(record)\"></p-menu>\r\n            </td>\r\n        </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"emptymessage\">\r\n        <tr>\r\n            <td [attr.colspan]=\"getRenderedColumnsCount(dt)\" [innerHtml]=\"props.dashboardOptions.noRecordFoundMessage\"></td>\r\n        </tr>\r\n    </ng-template>\r\n</p-table>\r\n", styles: [":host ::ng-deep p-table.caption-is-empty .p-datatable-header{display:none}:host ::ng-deep .p-paginator .p-paginator-current{margin-left:auto}:host ::ng-deep .p-progressbar{height:.5rem;background-color:#d8dadc}:host ::ng-deep .p-progressbar .p-progressbar-value{background-color:#607d8b}:host ::ng-deep .table-header{display:flex;justify-content:space-between}:host ::ng-deep .table-header .action-buttons{display:flex}:host ::ng-deep .table-column{overflow:hidden}:host ::ng-deep .table-column>a{cursor:pointer}:host ::ng-deep .checkbox-header{width:2rem}:host ::ng-deep .action-button-column{width:10rem;white-space:nowrap}:host ::ng-deep .action-button-column-collapsed{width:3rem}:host ::ng-deep .action-button-column .p-button-secondary{border-color:transparent}:host ::ng-deep .p-calendar .p-datepicker{min-width:25rem}:host ::ng-deep .p-calendar .p-datepicker td{font-weight:400}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-header{padding:1rem;text-align:left;font-size:1.5rem}:host ::ng-deep .p-datatable.p-datatable-dspx .p-paginator{padding:1rem}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>th,:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>td{text-align:left}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td{cursor:auto;overflow:hidden}:host ::ng-deep .p-datatable.p-datatable-dspx .p-dropdown-label:not(.p-placeholder){text-transform:uppercase}:host ::ng-deep .p-datatable-dspx .p-datatable-tbody>tr>td .p-column-title{display:none}:host ::ng-deep .p-datatable-thead>tr>th .p-column-filter-row .p-column-filter-clear-button,:host ::ng-deep .p-datatable-thead>tr>td .p-column-filter-row .p-column-filter-clear-button{display:none}@media screen and (max-width: 960px){:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>th,:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-thead>tr>td,:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tfoot>tr>td{display:none!important}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr{border-bottom:1px solid var(--layer-2)}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td{text-align:left;display:block;border:0 none!important;width:100%!important;float:left;clear:left;border:0 none}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td .p-column-title{padding:.4rem;min-width:30%;display:inline-block;margin:-.4rem 1rem -.4rem -.4rem;font-weight:700}:host ::ng-deep .p-datatable.p-datatable-dspx .p-datatable-tbody>tr>td .p-progressbar{margin-top:.5rem}}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: DataService }], propDecorators: { tableInstance: [{
                type: ViewChild,
                args: ['dt']
            }] } });

class TableEditorFieldType extends FieldArrayType {
    constructor(dialogService) {
        super();
        this.dialogService = dialogService;
    }
    get columnFields() {
        return this.field.fieldArray.fieldGroup;
    }
    ngOnInit() {
        this.props.componentInstance = this;
    }
    getCellField(rowIndex, field, col) {
        const rowField = field.fieldGroup[rowIndex].fieldGroup.find(f => f.key === col.key);
        return rowField;
    }
    rowHasError(rowIndex, field) {
        const fc = field.fieldGroup[rowIndex].formControl;
        return fc.touched && !fc.valid;
    }
    getButtonConfig(type, prop, defaultValue = undefined) {
        return this.props?.tableEditorOptions?.buttons?.[type]?.[prop] ?? defaultValue;
    }
    handleToolTipClick(field) {
        this.currentTooltip = this.currentTooltip == field ? undefined : field;
    }
    showToolTip(field) {
        return this.currentTooltip == field;
    }
    addRow() {
        this.add(undefined, { ...this.props?.tableEditorOptions?.initialModel ?? {} }, { markAsDirty: true });
        const newField = this.field.fieldGroup[this.field.fieldGroup.length - 1];
        newField.formControl.markAllAsTouched();
    }
    removeRow(rowIndex) {
        if (this.props?.tableEditorOptions?.confirmRemovePopupCode) {
            this.dialogService.showConfirm(this.props?.tableEditorOptions?.confirmRemovePopupCode)
                .pipe(take$1(1))
                .subscribe(result => {
                if (result === DialogResult.ACCEPTED) {
                    this.remove(rowIndex);
                }
            });
        }
        else {
            this.remove(rowIndex);
        }
    }
    isAddButtonDisabled() {
        return (this.props?.tableEditorOptions?.maxRows ? this.model?.length >= this.props?.tableEditorOptions?.maxRows : false);
    }
    isRemoveButtonDisabled() {
        return (this.props?.tableEditorOptions?.minRows ? this.model?.length <= this.props?.tableEditorOptions?.minRows : false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableEditorFieldType, deps: [{ token: DialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TableEditorFieldType, selector: "dspx-table-editor", usesInheritance: true, ngImport: i0, template: "<dspx-heading [level]=\"4\" [heading]=\"props.label\"></dspx-heading>\r\n<div *ngIf=\"props.additionalInformations\" class=\"info-block\" >\r\n  <div *ngFor=\"let info of props.additionalInformations\" [innerHtml]=\"info.text\"></div>\r\n</div>\r\n<p-table #dt [value]=\"model\" [columns]=\"columnFields\" [responsive]=\"true\" [ngClass]=\"{'caption-is-empty': props.disabled}\">\r\n  <ng-template pTemplate=\"caption\">\r\n    <div class=\"table-header\">\r\n      <span class=\"action-buttons\">\r\n        <button\r\n          pButton\r\n          pRipple\r\n          type=\"button\"\r\n          [label]=\"getButtonConfig('add', 'title', 'Add')\"\r\n          class=\"p-button-sm\"\r\n          [icon]=\"'fas ' + getButtonConfig('add', 'icon', 'fa-plus')\"\r\n          iconPos = \"left\"\r\n          (click)=\"addRow()\"\r\n          [pTooltip]=\"getButtonConfig('add', 'title', 'Add')\"\r\n          tooltipPosition=\"bottom\"\r\n          [title]=\"getButtonConfig('add', 'title', 'Add')\"\r\n          [disabled]=\"isAddButtonDisabled()\"\r\n          *ngIf=\"!props.disabled\"\r\n        ></button>\r\n      </span>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"header\" let-columns>\r\n    <tr>\r\n      <th \r\n        [style.width]=\"col.props.width ? col.props.width : undefined\"\r\n        [pResizableColumn] = \"col.props.allowColumResize\"\r\n        *ngFor=\"let col of columns\">\r\n          {{col.props.label}} \r\n          <span class=\"required-marker\" *ngIf=\"!props.disabled && col.props.required && col.props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      \r\n          <button *ngIf=\"col.props.toolTips && col.props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n            [title]=\"'Show help for ' + col.props.label\"\r\n            [attr.aria-label]=\"'Show help for ' + col.props.label\"\r\n            [attr.aria-expanded]=\"showToolTip(col)\"\r\n            class=\"p-button-rounded p-button-text tooltip-button\"\r\n            icon=\"fas fa-question-circle\"\r\n            (click)=\"handleToolTipClick(col)\"\r\n            ></button>\r\n                \r\n          <div [ngClass]=\"{'p-hidden': !showToolTip(col)}\" class=\"tooltip-block\">\r\n            <div *ngFor=\"let tooltip of col.props.toolTips\">\r\n              <div [innerHtml]=\"tooltip.text\"></div>\r\n            </div>\r\n          </div>\r\n        </th>\r\n      <td class=\"action-button-column\"></td>\r\n    </tr>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"body\" let-row let-rowIndex=\"rowIndex\" let-columns=\"columns\">\r\n    <tr [ngClass]=\"{'has-error': rowHasError(rowIndex, field)}\">\r\n      <td *ngFor=\"let col of columns\"\r\n        class=\"table-column\"\r\n        [style.width]=\"col.props.width ? col.props.width : undefined\"\r\n        [style.max-width]=\"col.props.width ? col.props.width : undefined\"> \r\n        <formly-field #cellField [field]=\"getCellField(rowIndex, field, col)\"></formly-field>\r\n      </td>\r\n      <td class=\"action-button-column\">\r\n        <button\r\n          pButton\r\n          pRipple\r\n          type=\"button\"\r\n          [label]=\"getButtonConfig('remove', 'title', 'Delete')\"\r\n          class=\"p-button-rounded p-button-secondary\"\r\n          [icon]=\"'fas ' + getButtonConfig('remove', 'icon', 'fa-times')\"\r\n          iconPos=\"left\"\r\n          (click)=\"removeRow(rowIndex)\"\r\n          [pTooltip]=\"getButtonConfig('remove', 'title', 'Delete')\"\r\n          tooltipPosition=\"bottom\"\r\n          [title]=\"getButtonConfig('remove', 'title', 'Delete')\"\r\n          [disabled]=\"isRemoveButtonDisabled()\"\r\n          *ngIf=\"!props.disabled\"\r\n        ></button>\r\n      </td>\r\n    </tr>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"emptymessage\" let-columns>\r\n    <tr>\r\n      <td [attr.colspan]=\"columns.length + 1\">\r\n        <div class=\"no-rows-container\">\r\n          <div class=\"no-rows-message\" *ngIf=\"props.tableEditorOptions.noRowsMessage\" [innerHtml]=\"props.tableEditorOptions.noRowsMessage\"></div>\r\n          <button\r\n            *ngIf=\"!props.disabled && !props.tableEditorOptions.noRowsAddButton\"\r\n            pButton\r\n            pRipple\r\n            type=\"button\"\r\n            [label]=\"getButtonConfig('add', 'title', 'Add')\"\r\n            class=\"p-button-sm\"\r\n            [icon]=\"'fas ' + getButtonConfig('add', 'icon', 'fa-plus')\"\r\n            iconPos = \"left\"\r\n            (click)=\"addRow()\"\r\n            [pTooltip]=\"getButtonConfig('add', 'title', 'Add')\"\r\n            tooltipPosition=\"bottom\"\r\n            [title]=\"getButtonConfig('add', 'title', 'Add')\"\r\n            [disabled]=\"isAddButtonDisabled()\"\r\n          ></button>\r\n        </div>\r\n      </td>\r\n    </tr>\r\n  </ng-template>\r\n</p-table>", styles: [":host ::ng-deep p-table.caption-is-empty .p-datatable-header{display:none}:host ::ng-deep .table-header{display:flex;justify-content:space-between}:host ::ng-deep .table-header .action-buttons{display:flex}:host ::ng-deep .action-button-column{width:10rem;white-space:nowrap}:host ::ng-deep .action-button-column-collapsed{width:3rem}:host ::ng-deep .p-datatable-tbody>tr.has-error>td{vertical-align:top}:host ::ng-deep .p-datatable-thead>tr>th{vertical-align:top}:host ::ng-deep .p-datatable-thead>tr>th .tooltip-button{padding:0;margin:0;height:1rem;margin-left:.5rem;width:1rem}:host ::ng-deep .p-datatable-thead>tr>th .tooltip-block{margin-bottom:0;margin-top:.6rem}:host ::ng-deep .p-datatable .no-rows-container{display:flex;align-items:center}:host ::ng-deep .p-datatable .no-rows-container .no-rows-message{margin-right:1rem}:host ::ng-deep .p-calendar .p-datepicker{min-width:25rem}:host ::ng-deep .p-calendar .p-datepicker td{font-weight:400}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "directive", type: i2$1.Tooltip, selector: "[pTooltip]", inputs: ["tooltipPosition", "tooltipEvent", "appendTo", "positionStyle", "tooltipStyleClass", "tooltipZIndex", "escape", "showDelay", "hideDelay", "life", "positionTop", "positionLeft", "autoHide", "fitContent", "hideOnEscape", "pTooltip", "tooltipDisabled", "tooltipOptions"] }, { kind: "component", type: Table, selector: "p-table", inputs: ["frozenColumns", "frozenValue", "style", "styleClass", "tableStyle", "tableStyleClass", "paginator", "pageLinks", "rowsPerPageOptions", "alwaysShowPaginator", "paginatorPosition", "paginatorStyleClass", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showFirstLastIcon", "showPageLinks", "defaultSortOrder", "sortMode", "resetPageOnSort", "selectionMode", "selectionPageOnly", "contextMenuSelection", "contextMenuSelectionMode", "dataKey", "metaKeySelection", "rowSelectable", "rowTrackBy", "lazy", "lazyLoadOnInit", "compareSelectionBy", "csvSeparator", "exportFilename", "filters", "globalFilterFields", "filterDelay", "filterLocale", "expandedRowKeys", "editingRowKeys", "rowExpandMode", "scrollable", "scrollDirection", "rowGroupMode", "scrollHeight", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "frozenWidth", "responsive", "contextMenu", "resizableColumns", "columnResizeMode", "reorderableColumns", "loading", "loadingIcon", "showLoader", "rowHover", "customSort", "showInitialSortBadge", "autoLayout", "exportFunction", "exportHeader", "stateKey", "stateStorage", "editMode", "groupRowsBy", "groupRowsByOrder", "responsiveLayout", "breakpoint", "paginatorLocale", "value", "columns", "first", "rows", "totalRecords", "sortField", "sortOrder", "multiSortMeta", "selection", "selectAll", "virtualRowHeight"], outputs: ["contextMenuSelectionChange", "selectAllChange", "selectionChange", "onRowSelect", "onRowUnselect", "onPage", "onSort", "onFilter", "onLazyLoad", "onRowExpand", "onRowCollapse", "onContextMenuSelect", "onColResize", "onColReorder", "onRowReorder", "onEditInit", "onEditComplete", "onEditCancel", "onHeaderCheckboxToggle", "sortFunction", "firstChange", "rowsChange", "onStateSave", "onStateRestore"] }, { kind: "directive", type: ResizableColumn, selector: "[pResizableColumn]", inputs: ["pResizableColumnDisabled"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TableEditorFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-table-editor', template: "<dspx-heading [level]=\"4\" [heading]=\"props.label\"></dspx-heading>\r\n<div *ngIf=\"props.additionalInformations\" class=\"info-block\" >\r\n  <div *ngFor=\"let info of props.additionalInformations\" [innerHtml]=\"info.text\"></div>\r\n</div>\r\n<p-table #dt [value]=\"model\" [columns]=\"columnFields\" [responsive]=\"true\" [ngClass]=\"{'caption-is-empty': props.disabled}\">\r\n  <ng-template pTemplate=\"caption\">\r\n    <div class=\"table-header\">\r\n      <span class=\"action-buttons\">\r\n        <button\r\n          pButton\r\n          pRipple\r\n          type=\"button\"\r\n          [label]=\"getButtonConfig('add', 'title', 'Add')\"\r\n          class=\"p-button-sm\"\r\n          [icon]=\"'fas ' + getButtonConfig('add', 'icon', 'fa-plus')\"\r\n          iconPos = \"left\"\r\n          (click)=\"addRow()\"\r\n          [pTooltip]=\"getButtonConfig('add', 'title', 'Add')\"\r\n          tooltipPosition=\"bottom\"\r\n          [title]=\"getButtonConfig('add', 'title', 'Add')\"\r\n          [disabled]=\"isAddButtonDisabled()\"\r\n          *ngIf=\"!props.disabled\"\r\n        ></button>\r\n      </span>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"header\" let-columns>\r\n    <tr>\r\n      <th \r\n        [style.width]=\"col.props.width ? col.props.width : undefined\"\r\n        [pResizableColumn] = \"col.props.allowColumResize\"\r\n        *ngFor=\"let col of columns\">\r\n          {{col.props.label}} \r\n          <span class=\"required-marker\" *ngIf=\"!props.disabled && col.props.required && col.props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      \r\n          <button *ngIf=\"col.props.toolTips && col.props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n            [title]=\"'Show help for ' + col.props.label\"\r\n            [attr.aria-label]=\"'Show help for ' + col.props.label\"\r\n            [attr.aria-expanded]=\"showToolTip(col)\"\r\n            class=\"p-button-rounded p-button-text tooltip-button\"\r\n            icon=\"fas fa-question-circle\"\r\n            (click)=\"handleToolTipClick(col)\"\r\n            ></button>\r\n                \r\n          <div [ngClass]=\"{'p-hidden': !showToolTip(col)}\" class=\"tooltip-block\">\r\n            <div *ngFor=\"let tooltip of col.props.toolTips\">\r\n              <div [innerHtml]=\"tooltip.text\"></div>\r\n            </div>\r\n          </div>\r\n        </th>\r\n      <td class=\"action-button-column\"></td>\r\n    </tr>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"body\" let-row let-rowIndex=\"rowIndex\" let-columns=\"columns\">\r\n    <tr [ngClass]=\"{'has-error': rowHasError(rowIndex, field)}\">\r\n      <td *ngFor=\"let col of columns\"\r\n        class=\"table-column\"\r\n        [style.width]=\"col.props.width ? col.props.width : undefined\"\r\n        [style.max-width]=\"col.props.width ? col.props.width : undefined\"> \r\n        <formly-field #cellField [field]=\"getCellField(rowIndex, field, col)\"></formly-field>\r\n      </td>\r\n      <td class=\"action-button-column\">\r\n        <button\r\n          pButton\r\n          pRipple\r\n          type=\"button\"\r\n          [label]=\"getButtonConfig('remove', 'title', 'Delete')\"\r\n          class=\"p-button-rounded p-button-secondary\"\r\n          [icon]=\"'fas ' + getButtonConfig('remove', 'icon', 'fa-times')\"\r\n          iconPos=\"left\"\r\n          (click)=\"removeRow(rowIndex)\"\r\n          [pTooltip]=\"getButtonConfig('remove', 'title', 'Delete')\"\r\n          tooltipPosition=\"bottom\"\r\n          [title]=\"getButtonConfig('remove', 'title', 'Delete')\"\r\n          [disabled]=\"isRemoveButtonDisabled()\"\r\n          *ngIf=\"!props.disabled\"\r\n        ></button>\r\n      </td>\r\n    </tr>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"emptymessage\" let-columns>\r\n    <tr>\r\n      <td [attr.colspan]=\"columns.length + 1\">\r\n        <div class=\"no-rows-container\">\r\n          <div class=\"no-rows-message\" *ngIf=\"props.tableEditorOptions.noRowsMessage\" [innerHtml]=\"props.tableEditorOptions.noRowsMessage\"></div>\r\n          <button\r\n            *ngIf=\"!props.disabled && !props.tableEditorOptions.noRowsAddButton\"\r\n            pButton\r\n            pRipple\r\n            type=\"button\"\r\n            [label]=\"getButtonConfig('add', 'title', 'Add')\"\r\n            class=\"p-button-sm\"\r\n            [icon]=\"'fas ' + getButtonConfig('add', 'icon', 'fa-plus')\"\r\n            iconPos = \"left\"\r\n            (click)=\"addRow()\"\r\n            [pTooltip]=\"getButtonConfig('add', 'title', 'Add')\"\r\n            tooltipPosition=\"bottom\"\r\n            [title]=\"getButtonConfig('add', 'title', 'Add')\"\r\n            [disabled]=\"isAddButtonDisabled()\"\r\n          ></button>\r\n        </div>\r\n      </td>\r\n    </tr>\r\n  </ng-template>\r\n</p-table>", styles: [":host ::ng-deep p-table.caption-is-empty .p-datatable-header{display:none}:host ::ng-deep .table-header{display:flex;justify-content:space-between}:host ::ng-deep .table-header .action-buttons{display:flex}:host ::ng-deep .action-button-column{width:10rem;white-space:nowrap}:host ::ng-deep .action-button-column-collapsed{width:3rem}:host ::ng-deep .p-datatable-tbody>tr.has-error>td{vertical-align:top}:host ::ng-deep .p-datatable-thead>tr>th{vertical-align:top}:host ::ng-deep .p-datatable-thead>tr>th .tooltip-button{padding:0;margin:0;height:1rem;margin-left:.5rem;width:1rem}:host ::ng-deep .p-datatable-thead>tr>th .tooltip-block{margin-bottom:0;margin-top:.6rem}:host ::ng-deep .p-datatable .no-rows-container{display:flex;align-items:center}:host ::ng-deep .p-datatable .no-rows-container .no-rows-message{margin-right:1rem}:host ::ng-deep .p-calendar .p-datepicker{min-width:25rem}:host ::ng-deep .p-calendar .p-datepicker td{font-weight:400}\n"] }]
        }], ctorParameters: () => [{ type: DialogService }] });

class SearchBoxFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultWidth = '120px';
    }
    onKeyUp() {
        if (this.props.change) {
            let event = {
                action: 'search',
                model: this.model
            };
            this.props.change(this.field, event);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SearchBoxFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SearchBoxFieldType, selector: "dspx-searchbox", usesInheritance: true, ngImport: i0, template: "<div class=\"p-inputgroup\">\r\n  <input [id]=\"id\" type=\"text\" pInputText [placeholder]=\"props.label\" [formControl]=\"formControl\" [name]=\"field.name || id\" [attr.aria-label]=\"props.label\" (keyup.enter)=\"onKeyUp()\">\r\n  <button type=\"button\" pButton pRipple label=\"Search\" (click)=\"onKeyUp()\" [style.max-width]=\"defaultWidth\"></button>\r\n</div>\r\n", styles: [".search-button{width:100px}\n"], dependencies: [{ kind: "directive", type: i3$2.InputText, selector: "[pInputText]", inputs: ["variant"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SearchBoxFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-searchbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"p-inputgroup\">\r\n  <input [id]=\"id\" type=\"text\" pInputText [placeholder]=\"props.label\" [formControl]=\"formControl\" [name]=\"field.name || id\" [attr.aria-label]=\"props.label\" (keyup.enter)=\"onKeyUp()\">\r\n  <button type=\"button\" pButton pRipple label=\"Search\" (click)=\"onKeyUp()\" [style.max-width]=\"defaultWidth\"></button>\r\n</div>\r\n", styles: [".search-button{width:100px}\n"] }]
        }] });

class FormSummaryFieldType extends FieldType {
    constructor(formNavigationService, optionSetService, coreService, fileSaverService, fileService) {
        super();
        this.formNavigationService = formNavigationService;
        this.optionSetService = optionSetService;
        this.coreService = coreService;
        this.fileSaverService = fileSaverService;
        this.fileService = fileService;
        this.isPageType = (typeName) => this.formNavigationService.isPageType(typeName);
        this.isRepeatingPageType = (typeName) => this.formNavigationService.isRepeatingPageType(typeName);
        this.isSectionType = (typeName) => this.formNavigationService.isSectionType(typeName);
        this.isRepeatingSectionType = (typeName) => this.formNavigationService.isRepeatingSectionType(typeName);
        this.showQuickEditPopup = false;
        this.quickEditForm = new UntypedFormGroup({});
    }
    getFormConfig() {
        return this.field.parent.parent.parent.parent.fieldGroup.filter(tab => tab.fieldGroup.findIndex(p => this.showPageInSummary(p)) >= 0);
    }
    getModel() {
        let model = this.field.parent.parent.parent.parent.model;
        return (model === undefined || model === null) ? {} : model;
    }
    getPageInstanceArray(tabKey, pageKey) {
        let model = this.getModel();
        let instanceCount = model?.[tabKey]?.[pageKey]?.length;
        instanceCount = instanceCount == null ? 0 : instanceCount;
        return Array(instanceCount).fill(0).map((x, i) => i);
    }
    getSectionInstanceArray(tabKey, pageKey, pageIndex, sectionKey) {
        let model = this.getModel();
        let instance = pageIndex > -1
            ? model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]
            : model?.[tabKey]?.[pageKey]?.[sectionKey];
        const selfContainedIndexArray = instance.map((element, index) => {
            return { index, element };
        });
        return selfContainedIndexArray;
    }
    getFieldGroup(field) {
        if (this.isRepeatingPageType(field.type.toString()) || this.isRepeatingSectionType(field.type.toString())) {
            return field.fieldArray.fieldGroup;
        }
        else {
            return field.fieldGroup;
        }
    }
    getRepeatingPageHeaderText(config, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        var pageHeader = '';
        var allFieldsInPageHeader = [];
        config.fieldGroup.forEach(f => {
            if (f.props.includeInRepeatingPageHeader && f.props.includeInRepeatingPageHeader === true) {
                allFieldsInPageHeader.push(f);
            }
        });
        if (allFieldsInPageHeader && allFieldsInPageHeader.length > 0) {
            allFieldsInPageHeader.sort(f => f.props.repeatingPageHeaderOrder).forEach(f => {
                var fieldValue = this.getResponse(f, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                pageHeader = pageHeader + fieldValue + ' ';
            });
        }
        return pageHeader.trim();
    }
    getRepeatingSectionHeaderText(config, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        var sectionHeader = '';
        var allFieldsInSectionHeader = [];
        config.fieldGroup.forEach(f => {
            if (f.props.includeInRepeatingSectionHeader && f.props.includeInRepeatingSectionHeader === true) {
                allFieldsInSectionHeader.push(f);
            }
        });
        if (allFieldsInSectionHeader && allFieldsInSectionHeader.length > 0) {
            allFieldsInSectionHeader.sort(f => f.props.repeatingSectionHeaderOrder).forEach(f => {
                var fieldValue = this.getResponse(f, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                sectionHeader = sectionHeader + fieldValue + ' ';
            });
        }
        return sectionHeader.trim();
    }
    getResponse(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let response = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionConfig.key.toString());
        //If question uses option sets, convert the response into the text of the option.
        if (questionConfig.props != null && questionConfig.props.optionSet != null
            && questionConfig.props.optionSet.name != null && response != null) {
            let optionSetName = questionConfig.props.optionSet.name;
            //If question uses a dependent option set, determine the option set name.
            let parentQuestionKey = questionConfig.props.optionSet?.parentQuestionKey;
            let parentQuestionResponse = null;
            if (parentQuestionKey) {
                //Note: Dependent option set functionality currently assumes that parent question field is in the same section as the child question field.
                parentQuestionResponse = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, parentQuestionKey);
                optionSetName = optionSetName + '-' + parentQuestionKey + '-' + parentQuestionResponse;
            }
            //If the response contains commas, the question is a multi select type field. So we need to concatenate the option text.
            if (response.includes(',')) {
                let responseSplit = response.split(',');
                response = '';
                responseSplit.forEach(optionCode => {
                    response = `${response}${response === '' ? '' : ', '} ${this.optionSetService.getOptionText(optionSetName, optionCode.trim())}`;
                });
            }
            else {
                response = this.optionSetService.getOptionText(optionSetName, response);
            }
        }
        if (questionConfig.type === 'file' && response != null) {
            // Split the string based on ":" E.g. "myimage.png:0e1b61d7-b469-4716-ad1b-7d861d725c54"
            const nameIdPair = response.split(":");
            if (nameIdPair.length > 1) {
                response = nameIdPair[0];
            }
        }
        //For single checkbox type questions.
        response = response === 'true' ? 'Yes' : response;
        response = response === 'false' ? 'No' : response;
        return response;
    }
    getFieldVisibility(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
        let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        return formControl != null;
    }
    getSectionVisibility(sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        if (sectionConfig.type !== "section-verification") {
            return true;
        }
        if (sectionConfig?.hide === false) {
            return true;
        }
        let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
        let formControl = getSectionFormControl(rootField, sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        return formControl === null || formControl === undefined ? false : true;
    }
    getValidationErrorText(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let errorText = '';
        let validationErrors;
        if (questionConfig.formControl != null && questionConfig.formControl.errors != null) {
            validationErrors = questionConfig.formControl.errors;
        }
        else {
            let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
            let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
            if (formControl != null) {
                validationErrors = formControl.errors;
            }
        }
        if (validationErrors != null) {
            const errorKeys = Object.keys(validationErrors);
            const labelPrefix = this.props.hideQuestionLabelInError ? '' : `${questionConfig.props.label}: `;
            if (errorKeys.length > 0) {
                const errorKey = errorKeys[0];
                if (errorKey === 'required' && validationErrors[errorKey] === true
                    && questionConfig.validation != null && questionConfig.validation.messages[errorKey] != null) {
                    errorText = `${labelPrefix}${questionConfig.validation.messages[errorKey].toString()}`;
                }
                else if (typeof validationErrors[errorKey] === 'object') {
                    if (questionConfig.validation?.messages[errorKey] != null) {
                        errorText = `${labelPrefix}${questionConfig.validation?.messages[errorKey].toString()}`;
                    }
                    else if (validationErrors[errorKey]?.message != null) {
                        errorText = `${labelPrefix}${validationErrors[errorKey].message}`;
                    }
                    else if (errorText.length === 0) {
                        errorText = `${questionConfig.props.label}`;
                    }
                }
                else {
                    errorText = `${labelPrefix}${errorKey}`;
                }
            }
        }
        return errorText;
    }
    getPageLinkLabel(page) {
        if (page.props['isEditable'] === true) {
            return this.props.pageEditLabel || "Edit your answers";
        }
        else {
            return this.props.pageViewLabel || "Navigate to answers";
        }
    }
    getPageLinkIcon(page) {
        if (page.props['isEditable'] === true) {
            return this.props.pageEditIcon || "fas fa-pen";
        }
        else {
            return this.props.pageViewIcon || "fas fa-eye";
        }
    }
    goToPage(tab, page) {
        this.formNavigationService.setActiveNumber(ElementType.TAB, tab.props.number);
        if (page) {
            this.formNavigationService.setActiveNumber(ElementType.PAGE, page.props.number);
        }
    }
    hidePage(page, tabIndex, pageIndex) {
        page.props.summaryHidden = true;
        let element = document.getElementById("form-summary-" + tabIndex + "-" + pageIndex);
        element.scrollIntoView({ block: 'nearest' });
        element.focus();
    }
    getNonRepeatingItemLayout() { return this.props.nonRepeatingItemLayout || "col-12 md:col-6 mb-3"; }
    ;
    getRepeatingPageItemLayout() { return this.props.repeatingPageItemLayout || "col-12 md:col-6 mb-3"; }
    ;
    getRepeatingSectionItemLayout() { return this.props.repeatingSectionItemLayout || "col-12 md:col-6 mb-3"; }
    ;
    getRepeatingPageAndSectionItemLayout() { return this.props.repeatingPageAndSectionItemLayout || "col-12 md:col-6 mb-3"; }
    ;
    showPageInSummary(page) {
        return page.type !== 'summary-page' && page.hide !== true &&
            this.getFieldGroup(page).findIndex(p => this.getFieldGroup(p).findIndex(q => q.props.hideOnSummary !== true) >= 0) >= 0;
    }
    getPageHeadingLevel() { return this.props.showPageLink ? 3 : 2; }
    ;
    isQuickEditEnabled(questionField) {
        return this.props.isQuickEditEnabled && questionField.type != null && !questionField.props.disabled && questionField.props.access !== 'R';
    }
    showQuickEdit(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        this.showQuickEditPopup = true;
        let quickEditField = cloneDeep(questionConfig);
        quickEditField.props.tabKey = tabKey;
        quickEditField.props.pageKey = pageKey;
        quickEditField.props.pageIndex = pageIndex;
        quickEditField.props.sectionKey = sectionKey;
        quickEditField.props.sectionIndex = sectionIndex;
        this.quickEditQuestions = [quickEditField];
        this.quickEditModel = {};
        this.quickEditModel[questionConfig.key.toString()] = getResponseValue(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionConfig.key.toString());
    }
    updateQuickEditField() {
        if (this.quickEditForm.valid) {
            this.showQuickEditPopup = false;
            let quickEditField = this.quickEditQuestions[0];
            let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
            let questionValue = this.quickEditModel[quickEditField.key.toString()];
            let formControl = getFormControl(rootField, quickEditField, quickEditField.props.tabKey, quickEditField.props.pageKey, quickEditField.props.pageIndex, quickEditField.props.sectionKey, quickEditField.props.sectionIndex);
            setResponseValue(this.getModel(), quickEditField.props.tabKey, quickEditField.props.pageKey, quickEditField.props.pageIndex, quickEditField.props.sectionKey, quickEditField.props.sectionIndex, quickEditField.key.toString(), questionValue);
            formControl.setValue(questionValue);
            formControl.markAsDirty();
            this.quickEditModel = {};
        }
        else {
            markChildControlsAsTouched(this.quickEditForm);
        }
    }
    closeQuickEditPopup() {
        this.showQuickEditPopup = false;
        this.quickEditModel = {};
    }
    getQuickEditPopupLabel() {
        return this.props.quickEditPopupLabel ?? "Quick In-line Edit";
    }
    getUploadedFiles(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let files = this.getResponse(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        if (files) {
            let filesArray = files.split('|');
            return filesArray.map(file => {
                let fileDetails = file.split(':');
                const uploadedFile = new UploadedFile();
                uploadedFile.name = fileDetails[0];
                uploadedFile.id = fileDetails[1];
                return uploadedFile;
            });
        }
        return null;
    }
    downloadFile(file, questionKey) {
        let formIdentifier = this.coreService.fileUploadFormIdentifiers[questionKey];
        if (file != null) {
            this.fileService.download(formIdentifier, file.id)
                .pipe(take$1(1))
                .subscribe((response) => {
                const dispositionHeader = response.headers.get('content-disposition');
                if (!dispositionHeader) {
                    throw new Error('content-disposition header is not found');
                }
                const fileName = file.name != null
                    ? file.name
                    : this.getContentFileName(dispositionHeader);
                this.fileSaverService.save(response.body, fileName);
            }, (error) => {
                console.log('File download error: ', error);
            });
        }
    }
    getContentFileName(contentDispositionHeader) {
        const parts = contentDispositionHeader.split(';');
        const filename = parts[1].split('=')[1];
        return filename.replace(/['"]+/g, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormSummaryFieldType, deps: [{ token: FormNavigationService }, { token: OptionSetService }, { token: CoreService }, { token: i2$4.FileSaverService }, { token: FileService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: FormSummaryFieldType, selector: "dspx-form-summary", usesInheritance: true, ngImport: i0, template: "<h1>{{ field.parent.parent.parent.props.label }}</h1> <!-- Tab title to which the form summary field belongs -->\r\n<div *ngIf=\"field.parent.parent.parent.props.formSummaryDescription != null\">\r\n  {{ field.parent.parent.parent.props.formSummaryDescription }}\r\n  <!-- Tab formSummaryDescription to which the form summary field belongs -->\r\n</div>\r\n<div class=\"summary-section mt-6\" *ngFor=\"let tab of getFormConfig(); let tabIndex = index\">\r\n  <hr>\r\n  <dspx-heading *ngIf=\"props.showPageLink\" [level]=\"2\" [heading]=\"tab.props.label\"></dspx-heading>  \r\n  <div *ngFor=\"let page of tab.fieldGroup; let pageIndex = index;\">\r\n    <ng-container *ngIf=\"showPageInSummary(page)\">\r\n      <div class=\"flex\">       \r\n        <button *ngIf=\"props.showPageLink\" type=\"button\" pButton pRipple [attr.aria-expanded]=\"page.props.summaryHidden ? false : true\" (click)=\"page.props.summaryHidden = !page.props.summaryHidden\"\r\n          class=\"my-0 p-button-text p-button-rounded p-button-plain\" id=\"form-summary-{{tabIndex}}-{{pageIndex}}\"\r\n          [icon]=\"page.props.summaryHidden ? 'pi pi-chevron-right' : 'pi pi-chevron-down'\">\r\n          <span class=\"sr-only\">{{tab.props.label}}</span>\r\n        </button>\r\n        <dspx-heading [level]=\"getPageHeadingLevel()\" [heading]=\"page.props.label\"></dspx-heading>\r\n        <a *ngIf=\"props.showPageLink\" role=\"button\" tabindex=\"0\" class=\"page-link\" title=\"{{getPageLinkLabel(page)}}\"\r\n          (click)=\"goToPage(tab, page)\">\r\n          <i [ngClass]=\"getPageLinkIcon(page)\"></i>\r\n          <span>{{getPageLinkLabel(page)}}</span>\r\n        </a>\r\n      </div>\r\n      <div *ngIf=\"page.props.summaryHidden !== true\">\r\n        <div *ngIf=\"page.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n          {{ page.props.formSummaryDescription }}\r\n        </div>\r\n        <dspx-validation-summary *ngIf=\"page.props?.isEditable && props.showValidationSummary\" [pageField]=\"page\"></dspx-validation-summary>\r\n        <div *ngFor=\"let section of getFieldGroup(page); let sectionIndex = index\">\r\n          <ng-container *ngIf=\"section.hide !== true\">\r\n            <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, pageIndex, section.key, -1) !== false; else sectionHeading\">\r\n              <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n            </ng-container>\r\n            <ng-template #sectionHeading>\r\n              <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type !== 'section-verification'\">\r\n                <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n              </ng-container>\r\n            </ng-template>\r\n\r\n            <div *ngIf=\"section.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n              {{ section.props.formSummaryDescription }}\r\n            </div>\r\n\r\n            <!--Non-repeating page and non-repeating section-->\r\n            <dl *ngIf=\"isPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"grid\">\r\n              <div *ngFor=\"let question of getFieldGroup(section);\" [ngClass]=\"{\r\n                          'display-none': question.props.hideOnSummary === true ||\r\n                                          getFieldVisibility(question, tab.key, page.key, -1, section.key, -1) === false ||\r\n                                          question.type === 'paragraph' ||\r\n                                          question.type === 'information' ||\r\n                                          question.type === 'summary' ||\r\n                                          question.props.label == null,\r\n                          'col-12 md:col-12 mb-6': question.type === 'checkbox',\r\n                          'col-12 md:col-6 mb-3': question.type !== 'checkbox'\r\n                        }\">\r\n                <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                <dd class=\"ml-0\">{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}</dd>\r\n                <div class=\"p-invalid\">\r\n                  {{ getValidationErrorText(question, tab.key, page.key, -1, section.key, -1) }}\r\n                </div>\r\n              </div>\r\n              <p-divider></p-divider>\r\n            </dl>\r\n\r\n            <!--Repeating page only-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"grid\">\r\n              <ng-container *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\">\r\n                <ng-container *ngIf=\"section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; then repPageSection; else repPageSectionHeading\">\r\n                </ng-container>\r\n                <ng-template #repPageSectionHeading>\r\n                  <ng-container *ngIf=\"section.type !== 'section-verification'; then repPageSection\">\r\n                  </ng-container>\r\n                </ng-template>\r\n                <ng-template #repPageSection>\r\n                  <div class=\"col-12\">\r\n                    <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n                    <ng-container *ngIf=\"getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1)\">\r\n                      <dspx-heading [level]=\"4\"\r\n                                    heading=\"{{ getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1) }}\"></dspx-heading>\r\n                    </ng-container>\r\n                    <div class=\"grid\">\r\n                      <div *ngFor=\"let question of getFieldGroup(section);\"\r\n                           [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                  || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false\r\n                                  || question.type === 'paragraph'\r\n                                  || question.type === 'information'\r\n                                  || question.type === 'summary'\r\n                                  || question.props.label == null,\r\n                                  'col-12 md:col-12 mb-6': question.type === 'checkbox',\r\n                                  'col-12 md:col-6 mb-3': question.type !== 'checkbox'\r\n                                }\">\r\n                        <div class=\"col pt-3 pb-3\">\r\n                          <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                          <dd class=\"ml-0\">{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}</dd>\r\n                          <div class=\"p-invalid\">\r\n                            {{ getValidationErrorText(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </ng-template>\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating section only-->\r\n            <dl *ngIf=\"isPageType(page.type) && isRepeatingSectionType(section.type)\">\r\n              <ng-container *ngTemplateOutlet=\"repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, -1, section.key), tab: tab, page: page, pageindex: -1, section: section}\">\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating page and repeating section-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && isRepeatingSectionType(section.type)\" class=\"grid\">\r\n              <div *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\" class=\"col-12\">\r\n                <ng-container *ngTemplateOutlet=\"repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section.key), tab: tab, page: page, pageindex: repeatingPageIndex, section: section}\">\r\n                </ng-container>\r\n              </div>\r\n            </dl>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"props.showPageLink\" class=\"mb-3\">\r\n          <button type=\"button\" pButton pRipple class=\"p-button-primary p-button-text\" tabindex=\"0\" title=\"Hide answers\" \r\n          (click)=\"hidePage(page, tabIndex, pageIndex)\"  icon=\"pi pi-chevron-up\" label=\"Hide answers\"></button>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n<ng-template #sectionQuestions let-class=\"class\" let-containerClass=\"containerClass\" let-section=\"section\"  let-tabKey=\"tabKey\" let-pageKey=\"pageKey\" let-repeatingPageIndex=\"repeatingPageIndex\" let-sectionKey=\"sectionKey\" let-repeatingSectionIndex=\"repeatingSectionIndex\">\r\n  <div *ngFor=\"let question of getFieldGroup(section);\"\r\n        class=\"{{class}}\"\r\n        [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                  || getFieldVisibility(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) === false\r\n                                  || question.type === 'paragraph'\r\n                                  || question.type === 'information'\r\n                                  || question.type === 'summary'\r\n                                  || question.props.label == null}\">\r\n    <div class=\"{{containerClass}}\">\r\n      <dt class=\"label mb-2\">{{ question.props.label }}\r\n        <span *ngIf=\"question.props.required && question.props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n        <button *ngIf=\"isQuickEditEnabled(question)\" type=\"button\" pButton pRipple\r\n                (click)=\"showQuickEdit(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)\"\r\n                class=\"p-button-text p-button-rounded quick-edit-button\" icon=\"fas fa-pen\"></button>\r\n      </dt>\r\n      <dd class=\"ml-0\">\r\n        <dspx-show-hide-text text=\"{{getResponse(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)}}\"></dspx-show-hide-text>\r\n       </dd>\r\n      <div class=\"p-invalid\">\r\n        {{ getValidationErrorText(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<ng-template #repeatingSections let-questions let-tableData=\"tableData\" let-tab=\"tab\" let-page=\"page\" let-pageindex=\"pageindex\" let-section=\"section\">\r\n  <p-table [value]=\"tableData\">\r\n    <ng-template pTemplate=\"header\">\r\n      <tr>\r\n        <ng-container *ngFor=\"let col of questions\">\r\n          <th [ngClass]=\"{'display-none': col.props.hideOnSummary === true\r\n             || getFieldVisibility(col, tab.key, page.key, pageindex, section.key, 0) === false\r\n             || col.type === 'paragraph'\r\n             || col.type === 'information'\r\n             || col.type === 'summary'\r\n             || col.props.label == null}\">\r\n            {{col.props?.label}}\r\n          </th>\r\n        </ng-container>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-record>\r\n      <tr>\r\n        <ng-container *ngFor=\"let col of questions\">\r\n          <td [ngClass]=\"{'display-none': col.props.hideOnSummary === true\r\n              || getFieldVisibility(col, tab.key, page.key, pageindex, section.key, record.index) === false\r\n              || col.type === 'paragraph'\r\n              || col.type === 'information'\r\n              || col.type === 'summary'\r\n              || col.props.label == null}\">\r\n            @if (col.type !== 'file'){\r\n            {{getResponse(col, tab.key, page.key, pageindex, section.key, record.index)}}\r\n            <div class=\"p-invalid\">\r\n              {{ getValidationErrorText(col, tab.key, page.key, pageindex, section.key, record.index) }}\r\n            </div>\r\n            }\r\n            @else {\r\n            <ng-container *ngTemplateOutlet=\"uploadFilesDownloadLinks; context {$implicit: getUploadedFiles(col, tab.key, page.key, pageindex, section.key, record.index), question: col}\">\r\n            </ng-container>\r\n            }\r\n          </td>\r\n        </ng-container>\r\n      </tr>\r\n    </ng-template>\r\n  </p-table>\r\n</ng-template>\r\n<ng-template #uploadFilesDownloadLinks let-data let-question=\"question\">\r\n  <!--show download link-->\r\n  <ng-container *ngIf=\"data\">\r\n    <ng-container *ngFor=\"let file of data\">\r\n      <div class=\"col-12\">\r\n        <div class=\"filename\" (click)=\"downloadFile(file, question.key)\" role=\"button\" [id]=\"'button-' + file\"\r\n             [aria-label]=\"'Click here to download ' + file\">\r\n          {{ file.name }}\r\n        </div>\r\n        <div class=\"button-container\">\r\n          <button pButton type=\"button\" class=\"p-button-primary p-button-text\"\r\n                  label=\"Download\" title=\"Download\" icon=\"fas fa-download\" (click)=\"downloadFile(file, question.key)\"></button>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n<p-dialog *ngIf=\"showQuickEditPopup\" [(visible)]=\"showQuickEditPopup\"\r\n  modal=\"true\" styleClass=\"dialog\"\r\n  [baseZIndex]=\"10000\"\r\n  focusTrap=\"true\"\r\n  closeAriaLabel=\"Close\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 class=\"p-dialog-title\" tabindex=\"-1\" autofocus>{{getQuickEditPopupLabel()}}</h2>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"content\">\r\n    <div class=\"dialog-form\">\r\n      <form [formGroup]=\"quickEditForm\">\r\n        <formly-form [form]=\"quickEditForm\" [fields]=\"quickEditQuestions\" [model]=\"quickEditModel\"></formly-form>\r\n      </form>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"footer\">\r\n    <p-button (click)=\"updateQuickEditField()\" label=\"Ok\" title=\"Ok\" styleClass=\"p-button-conversion\"></p-button>\r\n    <p-button (click)=\"closeQuickEditPopup()\" label=\"Cancel\" title=\"Cancel\" styleClass=\"p-button-secondary\"></p-button>\r\n  </ng-template>\r\n</p-dialog>\r\n", styles: [".page-link{cursor:pointer;float:right;text-align:right;margin-left:auto}.page-link i{margin-right:.5rem}.quick-edit-button{top:5px;margin:0 .5em}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i3$1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "component", type: Table, selector: "p-table", inputs: ["frozenColumns", "frozenValue", "style", "styleClass", "tableStyle", "tableStyleClass", "paginator", "pageLinks", "rowsPerPageOptions", "alwaysShowPaginator", "paginatorPosition", "paginatorStyleClass", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showFirstLastIcon", "showPageLinks", "defaultSortOrder", "sortMode", "resetPageOnSort", "selectionMode", "selectionPageOnly", "contextMenuSelection", "contextMenuSelectionMode", "dataKey", "metaKeySelection", "rowSelectable", "rowTrackBy", "lazy", "lazyLoadOnInit", "compareSelectionBy", "csvSeparator", "exportFilename", "filters", "globalFilterFields", "filterDelay", "filterLocale", "expandedRowKeys", "editingRowKeys", "rowExpandMode", "scrollable", "scrollDirection", "rowGroupMode", "scrollHeight", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "virtualScrollDelay", "frozenWidth", "responsive", "contextMenu", "resizableColumns", "columnResizeMode", "reorderableColumns", "loading", "loadingIcon", "showLoader", "rowHover", "customSort", "showInitialSortBadge", "autoLayout", "exportFunction", "exportHeader", "stateKey", "stateStorage", "editMode", "groupRowsBy", "groupRowsByOrder", "responsiveLayout", "breakpoint", "paginatorLocale", "value", "columns", "first", "rows", "totalRecords", "sortField", "sortOrder", "multiSortMeta", "selection", "selectAll", "virtualRowHeight"], outputs: ["contextMenuSelectionChange", "selectAllChange", "selectionChange", "onRowSelect", "onRowUnselect", "onPage", "onSort", "onFilter", "onLazyLoad", "onRowExpand", "onRowCollapse", "onContextMenuSelect", "onColResize", "onColReorder", "onRowReorder", "onEditInit", "onEditComplete", "onEditCancel", "onHeaderCheckboxToggle", "sortFunction", "firstChange", "rowsChange", "onStateSave", "onStateRestore"] }, { kind: "component", type: i8.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "maskStyle", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }, { kind: "component", type: i2$3.Divider, selector: "p-divider", inputs: ["style", "styleClass", "layout", "type", "align"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: ["pageField"] }, { kind: "component", type: DspxShowHideTextComponent, selector: "dspx-show-hide-text", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormSummaryFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-summary', template: "<h1>{{ field.parent.parent.parent.props.label }}</h1> <!-- Tab title to which the form summary field belongs -->\r\n<div *ngIf=\"field.parent.parent.parent.props.formSummaryDescription != null\">\r\n  {{ field.parent.parent.parent.props.formSummaryDescription }}\r\n  <!-- Tab formSummaryDescription to which the form summary field belongs -->\r\n</div>\r\n<div class=\"summary-section mt-6\" *ngFor=\"let tab of getFormConfig(); let tabIndex = index\">\r\n  <hr>\r\n  <dspx-heading *ngIf=\"props.showPageLink\" [level]=\"2\" [heading]=\"tab.props.label\"></dspx-heading>  \r\n  <div *ngFor=\"let page of tab.fieldGroup; let pageIndex = index;\">\r\n    <ng-container *ngIf=\"showPageInSummary(page)\">\r\n      <div class=\"flex\">       \r\n        <button *ngIf=\"props.showPageLink\" type=\"button\" pButton pRipple [attr.aria-expanded]=\"page.props.summaryHidden ? false : true\" (click)=\"page.props.summaryHidden = !page.props.summaryHidden\"\r\n          class=\"my-0 p-button-text p-button-rounded p-button-plain\" id=\"form-summary-{{tabIndex}}-{{pageIndex}}\"\r\n          [icon]=\"page.props.summaryHidden ? 'pi pi-chevron-right' : 'pi pi-chevron-down'\">\r\n          <span class=\"sr-only\">{{tab.props.label}}</span>\r\n        </button>\r\n        <dspx-heading [level]=\"getPageHeadingLevel()\" [heading]=\"page.props.label\"></dspx-heading>\r\n        <a *ngIf=\"props.showPageLink\" role=\"button\" tabindex=\"0\" class=\"page-link\" title=\"{{getPageLinkLabel(page)}}\"\r\n          (click)=\"goToPage(tab, page)\">\r\n          <i [ngClass]=\"getPageLinkIcon(page)\"></i>\r\n          <span>{{getPageLinkLabel(page)}}</span>\r\n        </a>\r\n      </div>\r\n      <div *ngIf=\"page.props.summaryHidden !== true\">\r\n        <div *ngIf=\"page.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n          {{ page.props.formSummaryDescription }}\r\n        </div>\r\n        <dspx-validation-summary *ngIf=\"page.props?.isEditable && props.showValidationSummary\" [pageField]=\"page\"></dspx-validation-summary>\r\n        <div *ngFor=\"let section of getFieldGroup(page); let sectionIndex = index\">\r\n          <ng-container *ngIf=\"section.hide !== true\">\r\n            <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, pageIndex, section.key, -1) !== false; else sectionHeading\">\r\n              <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n            </ng-container>\r\n            <ng-template #sectionHeading>\r\n              <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type !== 'section-verification'\">\r\n                <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n              </ng-container>\r\n            </ng-template>\r\n\r\n            <div *ngIf=\"section.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n              {{ section.props.formSummaryDescription }}\r\n            </div>\r\n\r\n            <!--Non-repeating page and non-repeating section-->\r\n            <dl *ngIf=\"isPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"grid\">\r\n              <div *ngFor=\"let question of getFieldGroup(section);\" [ngClass]=\"{\r\n                          'display-none': question.props.hideOnSummary === true ||\r\n                                          getFieldVisibility(question, tab.key, page.key, -1, section.key, -1) === false ||\r\n                                          question.type === 'paragraph' ||\r\n                                          question.type === 'information' ||\r\n                                          question.type === 'summary' ||\r\n                                          question.props.label == null,\r\n                          'col-12 md:col-12 mb-6': question.type === 'checkbox',\r\n                          'col-12 md:col-6 mb-3': question.type !== 'checkbox'\r\n                        }\">\r\n                <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                <dd class=\"ml-0\">{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}</dd>\r\n                <div class=\"p-invalid\">\r\n                  {{ getValidationErrorText(question, tab.key, page.key, -1, section.key, -1) }}\r\n                </div>\r\n              </div>\r\n              <p-divider></p-divider>\r\n            </dl>\r\n\r\n            <!--Repeating page only-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"grid\">\r\n              <ng-container *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\">\r\n                <ng-container *ngIf=\"section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; then repPageSection; else repPageSectionHeading\">\r\n                </ng-container>\r\n                <ng-template #repPageSectionHeading>\r\n                  <ng-container *ngIf=\"section.type !== 'section-verification'; then repPageSection\">\r\n                  </ng-container>\r\n                </ng-template>\r\n                <ng-template #repPageSection>\r\n                  <div class=\"col-12\">\r\n                    <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n                    <ng-container *ngIf=\"getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1)\">\r\n                      <dspx-heading [level]=\"4\"\r\n                                    heading=\"{{ getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1) }}\"></dspx-heading>\r\n                    </ng-container>\r\n                    <div class=\"grid\">\r\n                      <div *ngFor=\"let question of getFieldGroup(section);\"\r\n                           [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                  || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false\r\n                                  || question.type === 'paragraph'\r\n                                  || question.type === 'information'\r\n                                  || question.type === 'summary'\r\n                                  || question.props.label == null,\r\n                                  'col-12 md:col-12 mb-6': question.type === 'checkbox',\r\n                                  'col-12 md:col-6 mb-3': question.type !== 'checkbox'\r\n                                }\">\r\n                        <div class=\"col pt-3 pb-3\">\r\n                          <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                          <dd class=\"ml-0\">{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}</dd>\r\n                          <div class=\"p-invalid\">\r\n                            {{ getValidationErrorText(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </ng-template>\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating section only-->\r\n            <dl *ngIf=\"isPageType(page.type) && isRepeatingSectionType(section.type)\">\r\n              <ng-container *ngTemplateOutlet=\"repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, -1, section.key), tab: tab, page: page, pageindex: -1, section: section}\">\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating page and repeating section-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && isRepeatingSectionType(section.type)\" class=\"grid\">\r\n              <div *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\" class=\"col-12\">\r\n                <ng-container *ngTemplateOutlet=\"repeatingSections; context {$implicit: getFieldGroup(section), tableData: getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section.key), tab: tab, page: page, pageindex: repeatingPageIndex, section: section}\">\r\n                </ng-container>\r\n              </div>\r\n            </dl>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"props.showPageLink\" class=\"mb-3\">\r\n          <button type=\"button\" pButton pRipple class=\"p-button-primary p-button-text\" tabindex=\"0\" title=\"Hide answers\" \r\n          (click)=\"hidePage(page, tabIndex, pageIndex)\"  icon=\"pi pi-chevron-up\" label=\"Hide answers\"></button>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n<ng-template #sectionQuestions let-class=\"class\" let-containerClass=\"containerClass\" let-section=\"section\"  let-tabKey=\"tabKey\" let-pageKey=\"pageKey\" let-repeatingPageIndex=\"repeatingPageIndex\" let-sectionKey=\"sectionKey\" let-repeatingSectionIndex=\"repeatingSectionIndex\">\r\n  <div *ngFor=\"let question of getFieldGroup(section);\"\r\n        class=\"{{class}}\"\r\n        [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                  || getFieldVisibility(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) === false\r\n                                  || question.type === 'paragraph'\r\n                                  || question.type === 'information'\r\n                                  || question.type === 'summary'\r\n                                  || question.props.label == null}\">\r\n    <div class=\"{{containerClass}}\">\r\n      <dt class=\"label mb-2\">{{ question.props.label }}\r\n        <span *ngIf=\"question.props.required && question.props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n        <button *ngIf=\"isQuickEditEnabled(question)\" type=\"button\" pButton pRipple\r\n                (click)=\"showQuickEdit(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)\"\r\n                class=\"p-button-text p-button-rounded quick-edit-button\" icon=\"fas fa-pen\"></button>\r\n      </dt>\r\n      <dd class=\"ml-0\">\r\n        <dspx-show-hide-text text=\"{{getResponse(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)}}\"></dspx-show-hide-text>\r\n       </dd>\r\n      <div class=\"p-invalid\">\r\n        {{ getValidationErrorText(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<ng-template #repeatingSections let-questions let-tableData=\"tableData\" let-tab=\"tab\" let-page=\"page\" let-pageindex=\"pageindex\" let-section=\"section\">\r\n  <p-table [value]=\"tableData\">\r\n    <ng-template pTemplate=\"header\">\r\n      <tr>\r\n        <ng-container *ngFor=\"let col of questions\">\r\n          <th [ngClass]=\"{'display-none': col.props.hideOnSummary === true\r\n             || getFieldVisibility(col, tab.key, page.key, pageindex, section.key, 0) === false\r\n             || col.type === 'paragraph'\r\n             || col.type === 'information'\r\n             || col.type === 'summary'\r\n             || col.props.label == null}\">\r\n            {{col.props?.label}}\r\n          </th>\r\n        </ng-container>\r\n      </tr>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"body\" let-record>\r\n      <tr>\r\n        <ng-container *ngFor=\"let col of questions\">\r\n          <td [ngClass]=\"{'display-none': col.props.hideOnSummary === true\r\n              || getFieldVisibility(col, tab.key, page.key, pageindex, section.key, record.index) === false\r\n              || col.type === 'paragraph'\r\n              || col.type === 'information'\r\n              || col.type === 'summary'\r\n              || col.props.label == null}\">\r\n            @if (col.type !== 'file'){\r\n            {{getResponse(col, tab.key, page.key, pageindex, section.key, record.index)}}\r\n            <div class=\"p-invalid\">\r\n              {{ getValidationErrorText(col, tab.key, page.key, pageindex, section.key, record.index) }}\r\n            </div>\r\n            }\r\n            @else {\r\n            <ng-container *ngTemplateOutlet=\"uploadFilesDownloadLinks; context {$implicit: getUploadedFiles(col, tab.key, page.key, pageindex, section.key, record.index), question: col}\">\r\n            </ng-container>\r\n            }\r\n          </td>\r\n        </ng-container>\r\n      </tr>\r\n    </ng-template>\r\n  </p-table>\r\n</ng-template>\r\n<ng-template #uploadFilesDownloadLinks let-data let-question=\"question\">\r\n  <!--show download link-->\r\n  <ng-container *ngIf=\"data\">\r\n    <ng-container *ngFor=\"let file of data\">\r\n      <div class=\"col-12\">\r\n        <div class=\"filename\" (click)=\"downloadFile(file, question.key)\" role=\"button\" [id]=\"'button-' + file\"\r\n             [aria-label]=\"'Click here to download ' + file\">\r\n          {{ file.name }}\r\n        </div>\r\n        <div class=\"button-container\">\r\n          <button pButton type=\"button\" class=\"p-button-primary p-button-text\"\r\n                  label=\"Download\" title=\"Download\" icon=\"fas fa-download\" (click)=\"downloadFile(file, question.key)\"></button>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n<p-dialog *ngIf=\"showQuickEditPopup\" [(visible)]=\"showQuickEditPopup\"\r\n  modal=\"true\" styleClass=\"dialog\"\r\n  [baseZIndex]=\"10000\"\r\n  focusTrap=\"true\"\r\n  closeAriaLabel=\"Close\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 class=\"p-dialog-title\" tabindex=\"-1\" autofocus>{{getQuickEditPopupLabel()}}</h2>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"content\">\r\n    <div class=\"dialog-form\">\r\n      <form [formGroup]=\"quickEditForm\">\r\n        <formly-form [form]=\"quickEditForm\" [fields]=\"quickEditQuestions\" [model]=\"quickEditModel\"></formly-form>\r\n      </form>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"footer\">\r\n    <p-button (click)=\"updateQuickEditField()\" label=\"Ok\" title=\"Ok\" styleClass=\"p-button-conversion\"></p-button>\r\n    <p-button (click)=\"closeQuickEditPopup()\" label=\"Cancel\" title=\"Cancel\" styleClass=\"p-button-secondary\"></p-button>\r\n  </ng-template>\r\n</p-dialog>\r\n", styles: [".page-link{cursor:pointer;float:right;text-align:right;margin-left:auto}.page-link i{margin-right:.5rem}.quick-edit-button{top:5px;margin:0 .5em}\n"] }]
        }], ctorParameters: () => [{ type: FormNavigationService }, { type: OptionSetService }, { type: CoreService }, { type: i2$4.FileSaverService }, { type: FileService }] });

/**
 * IMPORTANT: This form summary type is used by TRAM only.
 */
class FormSummaryV2FieldType extends FieldType {
    constructor(formNavigationService, formConfigurationService, coreService, optionSetService, changeDetector) {
        super();
        this.formNavigationService = formNavigationService;
        this.formConfigurationService = formConfigurationService;
        this.coreService = coreService;
        this.optionSetService = optionSetService;
        this.changeDetector = changeDetector;
        this.isPageType = (typeName) => this.formNavigationService.isPageType(typeName);
        this.isRepeatingPageType = (typeName) => this.formNavigationService.isRepeatingPageType(typeName);
        this.isSectionType = (typeName) => this.formNavigationService.isSectionType(typeName);
        this.isRepeatingSectionType = (typeName) => this.formNavigationService.isRepeatingSectionType(typeName);
        this.showQuickEditPopup = false;
        this.quickEditForm = new UntypedFormGroup({});
    }
    getFormConfig() {
        return this.field.parent.parent.parent.parent.fieldGroup.filter(tab => tab.fieldGroup.findIndex(p => this.showPageInSummary(p)) >= 0);
    }
    getModel() {
        let model = this.field.parent.parent.parent.parent.model;
        return (model === undefined || model === null) ? {} : model;
    }
    getPageInstanceArray(tabKey, pageKey) {
        let model = this.getModel();
        let instanceCount = model?.[tabKey]?.[pageKey]?.length;
        instanceCount = instanceCount == null ? 0 : instanceCount;
        return Array(instanceCount).fill(0).map((x, i) => i);
    }
    getSectionInstanceArray(tabKey, pageKey, pageIndex, sectionKey) {
        let model = this.getModel();
        let instanceCount = pageIndex > -1
            ? model?.[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.length
            : model?.[tabKey]?.[pageKey]?.[sectionKey]?.length;
        instanceCount = instanceCount == null ? 0 : instanceCount;
        return Array(instanceCount).fill(0).map((x, i) => i);
    }
    getFieldGroup(field) {
        if (this.isRepeatingPageType(field.type.toString()) || this.isRepeatingSectionType(field.type.toString())) {
            return field.fieldArray.fieldGroup;
        }
        else {
            return field.fieldGroup;
        }
    }
    getRepeatingPageHeaderText(config, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        var pageHeader = '';
        var allFieldsInPageHeader = [];
        config.fieldGroup.forEach(f => {
            if (f.props.includeInRepeatingPageHeader && f.props.includeInRepeatingPageHeader === true) {
                allFieldsInPageHeader.push(f);
            }
        });
        if (allFieldsInPageHeader && allFieldsInPageHeader.length > 0) {
            allFieldsInPageHeader.sort(f => f.props.repeatingPageHeaderOrder).forEach(f => {
                var fieldValue = this.getResponse(f, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                pageHeader = pageHeader + fieldValue + ' ';
            });
        }
        return pageHeader.trim();
    }
    getRepeatingSectionHeaderText(config, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        var sectionHeader = '';
        var allFieldsInSectionHeader = [];
        config.fieldGroup.forEach(f => {
            if (f.props.includeInRepeatingSectionHeader && f.props.includeInRepeatingSectionHeader === true) {
                allFieldsInSectionHeader.push(f);
            }
        });
        if (allFieldsInSectionHeader && allFieldsInSectionHeader.length > 0) {
            allFieldsInSectionHeader.sort(f => f.props.repeatingSectionHeaderOrder).forEach(f => {
                var fieldValue = this.getResponse(f, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                sectionHeader = sectionHeader + fieldValue + ' ';
            });
        }
        return sectionHeader.trim();
    }
    getResponse(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let response = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionConfig.key.toString());
        //If question uses option sets, convert the response into the text of the option.
        if (questionConfig.props != null && questionConfig.props.optionSet != null
            && questionConfig.props.optionSet.name != null && response != null) {
            let optionSetName = questionConfig.props.optionSet.name;
            //If question uses a dependent option set, determine the option set name.
            let parentQuestionKey = questionConfig.props.optionSet?.parentQuestionKey;
            let parentQuestionResponse = null;
            if (parentQuestionKey) {
                //Note: Dependent option set functionality currently assumes that parent question field is in the same section as the child question field.
                parentQuestionResponse = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, parentQuestionKey);
                optionSetName = optionSetName + '-' + parentQuestionKey + '-' + parentQuestionResponse;
            }
            //If the response contains commas, the question is a multi select type field. So we need to concatenate the option text.
            if (response.includes(',')) {
                let responseSplit = response.split(',');
                response = '';
                responseSplit.forEach(optionCode => {
                    response = `${response}${response === '' ? '' : ', '} ${this.optionSetService.getOptionText(optionSetName, optionCode.trim())}`;
                });
            }
            else {
                response = this.optionSetService.getOptionText(optionSetName, response);
            }
        }
        //For single checkbox type questions.
        response = response === 'true' ? 'Yes' : response;
        response = response === 'false' ? 'No' : response;
        if (questionConfig.props.showRelatedQuestionsResponse && questionConfig.props.relatedQuestions != null) {
            let formFields = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
            questionConfig.props.relatedQuestions.forEach(qCode => {
                let relatedField = findQuestionConfig(formFields, tabKey, pageKey, sectionKey, qCode);
                const resp = this.getResponse(relatedField, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                if (resp) {
                    if (response == null) {
                        response = '';
                    }
                    response += '\n' + resp;
                }
            });
        }
        return response;
    }
    getFieldVisibility(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
        let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        return formControl != null;
    }
    getSectionVisibility(sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        if (sectionConfig.type !== "section-verification") {
            return true;
        }
        if (sectionConfig?.hide === false) {
            return true;
        }
        let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
        let formControl = getSectionFormControl(rootField, sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        return formControl === null || formControl === undefined ? false : true;
    }
    getValidationErrorText(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let errorText = '';
        let validationErrors;
        if (questionConfig.formControl != null && questionConfig.formControl.errors != null) {
            validationErrors = questionConfig.formControl.errors;
        }
        else {
            let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
            let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
            if (formControl != null) {
                validationErrors = formControl.errors;
            }
        }
        if (validationErrors != null) {
            const errorKeys = Object.keys(validationErrors);
            const labelPrefix = this.props.hideQuestionLabelInError ? '' : `${questionConfig.props.label}: `;
            if (errorKeys.length > 0) {
                const errorKey = errorKeys[0];
                if (errorKey === 'required' && validationErrors[errorKey] === true
                    && questionConfig.validation != null && questionConfig.validation.messages[errorKey] != null) {
                    errorText = `${labelPrefix}${questionConfig.validation.messages[errorKey].toString()}`;
                }
                else if (typeof validationErrors[errorKey] === 'object') {
                    if (questionConfig.validation?.messages[errorKey] != null) {
                        errorText = `${labelPrefix}${questionConfig.validation?.messages[errorKey].toString()}`;
                    }
                    else if (validationErrors[errorKey]?.message != null) {
                        errorText = `${labelPrefix}${validationErrors[errorKey].message}`;
                    }
                    else if (errorText.length === 0) {
                        errorText = `${questionConfig.props.label}`;
                    }
                }
                else {
                    errorText = `${labelPrefix}${errorKey}`;
                }
            }
        }
        return errorText;
    }
    getPageLinkLabel(page) {
        if (page.props['isEditable'] === true) {
            return this.props.pageEditLabel || "Edit your answers";
        }
        else {
            return this.props.pageViewLabel || "Navigate to answers";
        }
    }
    getPageLinkIcon(page) {
        if (page.props['isEditable'] === true) {
            return this.props.pageEditIcon || "fas fa-pen";
        }
        else {
            return this.props.pageViewIcon || "fas fa-eye";
        }
    }
    goToPage(tab, page) {
        this.formNavigationService.setActiveNumber(ElementType.TAB, tab.props.number);
        if (page) {
            this.formNavigationService.setActiveNumber(ElementType.PAGE, page.props.number);
        }
    }
    hidePage(page, tabIndex, pageIndex) {
        page.props.summaryHidden = true;
        document.getElementById("form-summary-" + tabIndex + "-" + pageIndex).scrollIntoView({ block: 'nearest' });
    }
    getNonRepeatingItemLayout() { return this.props.nonRepeatingItemLayout || "p-col-12 p-md-6 p-mb-3"; }
    ;
    getRepeatingPageItemLayout() { return this.props.repeatingPageItemLayout || "p-col-12 p-md-6 p-mb-3"; }
    ;
    getRepeatingSectionItemLayout() { return this.props.repeatingSectionItemLayout || "p-col-12 p-md-6 p-mb-3"; }
    ;
    getRepeatingPageAndSectionItemLayout() { return this.props.repeatingPageAndSectionItemLayout || "p-col-12 p-md-6 p-mb-3"; }
    ;
    showPageInSummary(page) {
        return page.type !== 'summary-page' && page.hide !== true &&
            this.getFieldGroup(page).findIndex(p => this.getFieldGroup(p).findIndex(q => q.props.hideOnSummary !== true) >= 0) >= 0;
    }
    getPageHeadingLevel() { return this.props.showPageLink ? 3 : 2; }
    ;
    isQuickEditEnabled(questionField) {
        return this.props.isQuickEditEnabled && this.coreService.isFormEditable && questionField.type != null && !questionField.props.disabled && questionField.props.access !== 'R';
    }
    showQuickEdit(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        this.showQuickEditPopup = true;
        this.quickEditQuestions = [this.getQuickEditField(questionConfig.key.toString(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex)];
        this.quickEditFormModel = cloneDeep(this.field.parent.parent.parent.parent.parent.parent.model);
        this.quickEditModel = getSectionValue(this.quickEditFormModel.form.tabs, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        if (questionConfig.props.relatedQuestions != null) {
            questionConfig.props.relatedQuestions.forEach(qCode => {
                this.quickEditQuestions.push(this.getQuickEditField(qCode, tabKey, pageKey, pageIndex, sectionKey, sectionIndex));
            });
        }
    }
    getQuickEditField(qCode, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let formFields = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
        let quickEditField = cloneDeep(findQuestionConfig(formFields, tabKey, pageKey, sectionKey, qCode));
        quickEditField.id = 'qe-' + quickEditField.id;
        quickEditField.props.tabKey = tabKey;
        quickEditField.props.pageKey = pageKey;
        quickEditField.props.pageIndex = pageIndex;
        quickEditField.props.sectionKey = sectionKey;
        quickEditField.props.sectionIndex = sectionIndex;
        quickEditField.hideExpression = () => { return this.formConfigurationService.hideField(this.quickEditFormModel, quickEditField, pageIndex, sectionIndex); };
        return quickEditField;
    }
    updateQuickEditField() {
        if (this.quickEditForm.valid) {
            this.showQuickEditPopup = false;
            this.quickEditQuestions.forEach(quickEditField => {
                let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
                let questionValue = this.quickEditModel[quickEditField.key.toString()];
                let formControl = getFormControl(rootField, quickEditField, quickEditField.props.tabKey, quickEditField.props.pageKey, quickEditField.props.pageIndex, quickEditField.props.sectionKey, quickEditField.props.sectionIndex);
                setResponseValue(this.getModel(), quickEditField.props.tabKey, quickEditField.props.pageKey, quickEditField.props.pageIndex, quickEditField.props.sectionKey, quickEditField.props.sectionIndex, quickEditField.key.toString(), questionValue);
                formControl.setValue(questionValue);
                formControl.markAsDirty();
            });
            this.changeDetector.detectChanges();
            this.quickEditModel = {};
            this.quickEditFormModel = {};
        }
        else {
            markChildControlsAsTouched(this.quickEditForm);
        }
    }
    closeQuickEditPopup() {
        this.showQuickEditPopup = false;
        this.quickEditModel = {};
    }
    getQuickEditPopupLabel() {
        return this.props.quickEditPopupLabel ?? "Quick In-line Edit";
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormSummaryV2FieldType, deps: [{ token: FormNavigationService }, { token: FormConfigurationService }, { token: CoreService }, { token: OptionSetService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FormSummaryV2FieldType, selector: "dspx-form-summary-v2", usesInheritance: true, ngImport: i0, template: "<h1>{{ field.parent.parent.parent.props.label }}</h1> <!-- Tab title to which the form summary field belongs -->\r\n<div *ngIf=\"field.parent.parent.parent.props.formSummaryDescription != null\">\r\n  {{ field.parent.parent.parent.props.formSummaryDescription }}\r\n  <!-- Tab formSummaryDescription to which the form summary field belongs -->\r\n</div>\r\n<div class=\"summary-section p-mt-6\" *ngFor=\"let tab of getFormConfig(); let tabIndex = index\">\r\n  <dspx-heading *ngIf=\"props.showPageLink\" [level]=\"2\" [heading]=\"tab.props.label\"></dspx-heading>\r\n  <div *ngFor=\"let page of tab.fieldGroup; let pageIndex = index;\">\r\n    <ng-container *ngIf=\"showPageInSummary(page)\">\r\n      <p-divider></p-divider>\r\n      <div class=\"p-d-flex\">\r\n        <button *ngIf=\"props.showPageLink\" type=\"button\" pButton pRipple [attr.aria-expanded]=\"page.props.summaryHidden ? false : true\" (click)=\"page.props.summaryHidden = !page.props.summaryHidden\"\r\n          class=\"p-my-0 p-button-text p-button-rounded p-button-plain\" id=\"form-summary-{{tabIndex}}-{{pageIndex}}\"\r\n          [icon]=\"page.props.summaryHidden ? 'pi pi-chevron-right' : 'pi pi-chevron-down'\"\r\n          title=\"Toggle summary\"></button>\r\n        <dspx-heading [level]=\"getPageHeadingLevel()\" [heading]=\"page.props.label\"></dspx-heading>\r\n        <a *ngIf=\"props.showPageLink\" role=\"button\" tabindex=\"0\" class=\"page-link\"\r\n          (click)=\"goToPage(tab, page)\">\r\n          <i [ngClass]=\"getPageLinkIcon(page)\"></i>\r\n          <span>{{getPageLinkLabel(page)}}</span>\r\n        </a>\r\n      </div>\r\n      <div *ngIf=\"page.props.summaryHidden !== true\">\r\n        <div *ngIf=\"page.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n          {{ page.props.formSummaryDescription }}\r\n        </div>\r\n        <dspx-validation-summary *ngIf=\"page.props?.isEditable && props.showValidationSummary\" [pageField]=\"page\"></dspx-validation-summary>\r\n        <div *ngFor=\"let section of getFieldGroup(page); let sectionIndex = index\">\r\n          <ng-container *ngIf=\"section.hide !== true\">\r\n            <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, pageIndex, section.key, -1) !== false; else sectionHeading\">\r\n              <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n            </ng-container>\r\n            <ng-template #sectionHeading>\r\n              <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type !== 'section-verification'\">\r\n                <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n              </ng-container>\r\n            </ng-template>\r\n\r\n            <div *ngIf=\"section.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n              {{ section.props.formSummaryDescription }}\r\n            </div>\r\n\r\n            <!--Non-repeating page and non-repeating section-->\r\n            <dl *ngIf=\"isPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"p-grid\">\r\n              <ng-container\r\n                *ngTemplateOutlet=\"sectionQuestions; context { class: getNonRepeatingItemLayout(), containerClass:'', section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: -1, sectionKey: section.key, repeatingSectionIndex: -1 }\">\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating page only-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"p-grid\">\r\n              <ng-container *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\">\r\n                <ng-container *ngIf=\"section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; then repPageSection; else repPageSectionHeading\">\r\n                </ng-container>\r\n                <ng-template #repPageSectionHeading>\r\n                  <ng-container *ngIf=\"section.type !== 'section-verification'; then repPageSection\">\r\n                  </ng-container>\r\n                </ng-template>\r\n                <ng-template #repPageSection>\r\n                  <div class=\"{{getRepeatingPageItemLayout()}}\">\r\n                    <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n                    <dspx-heading [level]=\"4\" heading=\"{{ getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1) }}\"></dspx-heading>\r\n                    <ng-container\r\n                      *ngTemplateOutlet=\"sectionQuestions; context { class: 'p-grid', containerClass: 'p-col p-pt-3 p-pb-3', section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: repeatingPageIndex, sectionKey: section.key, repeatingSectionIndex: -1 }\">\r\n                    </ng-container>\r\n                  </div>\r\n                </ng-template>\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating section only-->\r\n            <dl *ngIf=\"isPageType(page.type) && isRepeatingSectionType(section.type)\" class=\"p-grid\">\r\n              <div *ngFor=\"let repeatingSectionIndex of getSectionInstanceArray(tab.key, page.key, -1, section.key);\" class=\"{{getRepeatingSectionItemLayout()}}\">\r\n                <dspx-heading [level]=\"4\" heading=\"{{ getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, -1, section.key, repeatingSectionIndex) }}\"></dspx-heading>\r\n                <ng-container\r\n                  *ngTemplateOutlet=\"sectionQuestions; context { class: 'p-grid', containerClass: 'p-col p-pt-3 p-pb-3',section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: -1, sectionKey: section.key, repeatingSectionIndex: repeatingSectionIndex }\">\r\n                </ng-container>\r\n              </div>\r\n            </dl>\r\n\r\n            <!--Repeating page and repeating section-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && isRepeatingSectionType(section.type)\" class=\"p-grid\">\r\n              <div *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\" class=\"{{getRepeatingPageAndSectionItemLayout()}}\">\r\n                <div *ngFor=\"let repeatingSectionIndex of getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section.key);\">\r\n                  <dspx-heading [level]=\"4\" heading=\"{{ getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex) }}\"></dspx-heading>\r\n                  <ng-container\r\n                  *ngTemplateOutlet=\"sectionQuestions; context { class: 'p-grid', containerClass: 'p-col p-pt-3 p-pb-3', section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: repeatingPageIndex, sectionKey: section.key, repeatingSectionIndex: repeatingSectionIndex }\">\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n            </dl>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"props.showPageLink\" class=\"p-mb-3\">\r\n          <a role=\"button\" class=\"pointer\" tabindex=\"0\" (click)=\"hidePage(page, tabIndex, pageIndex)\">\r\n            <i class=\"pi pi-chevron-up p-pr-2\"></i>\r\n            <span>Hide answers</span>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </ng-container> \r\n  </div>\r\n</div>\r\n<ng-template #sectionQuestions let-class=\"class\" let-containerClass=\"containerClass\" let-section=\"section\"  let-tabKey=\"tabKey\" let-pageKey=\"pageKey\" let-repeatingPageIndex=\"repeatingPageIndex\" let-sectionKey=\"sectionKey\" let-repeatingSectionIndex=\"repeatingSectionIndex\">\r\n  <div *ngFor=\"let question of getFieldGroup(section);\" \r\n        class=\"{{class}}\"\r\n        [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                  || getFieldVisibility(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) === false\r\n                                  || question.type === 'paragraph'\r\n                                  || question.type === 'information'\r\n                                  || question.type === 'summary'\r\n                                  || question.props.label == null}\">\r\n    <div class=\"{{containerClass}}\">\r\n      <dt class=\"label p-mb-2\">{{ question.props.label }}\r\n        <span class=\"{{question.props.suffixClass}}\" *ngIf=\"question.props.suffix && question.props.suffix.length > 0\" aria-hidden=\"true\">{{question.props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"question.props.required && question.props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n        <button *ngIf=\"isQuickEditEnabled(question)\" type=\"button\" pButton pRipple \r\n                (click)=\"showQuickEdit(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)\"\r\n                class=\"p-button-text p-button-rounded quick-edit-button\" icon=\"fas fa-pen\"\r\n                title=\"Quick Edit\"\r\n                ></button>\r\n      </dt>\r\n      <dd class=\"p-ml-0\">\r\n        <dspx-show-hide-text text=\"{{getResponse(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)}}\"></dspx-show-hide-text>\r\n       </dd> \r\n      <div class=\"p-invalid\">\r\n        {{ getValidationErrorText(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<p-dialog *ngIf=\"showQuickEditPopup\" [(visible)]=\"showQuickEditPopup\"\r\n  modal=\"true\" styleClass=\"dialog\"\r\n  [baseZIndex]=\"10000\"\r\n  focusTrap=\"true\"\r\n  closeAriaLabel=\"Close\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 class=\"p-dialog-title\" tabindex=\"-1\" autofocus>{{getQuickEditPopupLabel()}}</h2>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"content\">\r\n    <div class=\"dialog-form\">\r\n      <form [formGroup]=\"quickEditForm\">\r\n        <formly-form [form]=\"quickEditForm\" [fields]=\"quickEditQuestions\" [model]=\"quickEditModel\"></formly-form>\r\n      </form>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"footer\">\r\n    <p-button (click)=\"updateQuickEditField()\" label=\"Ok\" title=\"Ok\" styleClass=\"p-button-conversion\"></p-button>\r\n    <p-button (click)=\"closeQuickEditPopup()\" label=\"Cancel\" title=\"Cancel\" styleClass=\"p-button-secondary\"></p-button>\r\n  </ng-template>\r\n</p-dialog>", styles: [".page-link{cursor:pointer;float:right;text-align:right;margin-left:auto}.page-link i{margin-right:.5rem}.quick-edit-button{top:5px;margin:0 .5em}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i3$1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "component", type: i8.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "maskStyle", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }, { kind: "component", type: i2$3.Divider, selector: "p-divider", inputs: ["style", "styleClass", "layout", "type", "align"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: ["pageField"] }, { kind: "component", type: DspxShowHideTextComponent, selector: "dspx-show-hide-text", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FormSummaryV2FieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-summary-v2', template: "<h1>{{ field.parent.parent.parent.props.label }}</h1> <!-- Tab title to which the form summary field belongs -->\r\n<div *ngIf=\"field.parent.parent.parent.props.formSummaryDescription != null\">\r\n  {{ field.parent.parent.parent.props.formSummaryDescription }}\r\n  <!-- Tab formSummaryDescription to which the form summary field belongs -->\r\n</div>\r\n<div class=\"summary-section p-mt-6\" *ngFor=\"let tab of getFormConfig(); let tabIndex = index\">\r\n  <dspx-heading *ngIf=\"props.showPageLink\" [level]=\"2\" [heading]=\"tab.props.label\"></dspx-heading>\r\n  <div *ngFor=\"let page of tab.fieldGroup; let pageIndex = index;\">\r\n    <ng-container *ngIf=\"showPageInSummary(page)\">\r\n      <p-divider></p-divider>\r\n      <div class=\"p-d-flex\">\r\n        <button *ngIf=\"props.showPageLink\" type=\"button\" pButton pRipple [attr.aria-expanded]=\"page.props.summaryHidden ? false : true\" (click)=\"page.props.summaryHidden = !page.props.summaryHidden\"\r\n          class=\"p-my-0 p-button-text p-button-rounded p-button-plain\" id=\"form-summary-{{tabIndex}}-{{pageIndex}}\"\r\n          [icon]=\"page.props.summaryHidden ? 'pi pi-chevron-right' : 'pi pi-chevron-down'\"\r\n          title=\"Toggle summary\"></button>\r\n        <dspx-heading [level]=\"getPageHeadingLevel()\" [heading]=\"page.props.label\"></dspx-heading>\r\n        <a *ngIf=\"props.showPageLink\" role=\"button\" tabindex=\"0\" class=\"page-link\"\r\n          (click)=\"goToPage(tab, page)\">\r\n          <i [ngClass]=\"getPageLinkIcon(page)\"></i>\r\n          <span>{{getPageLinkLabel(page)}}</span>\r\n        </a>\r\n      </div>\r\n      <div *ngIf=\"page.props.summaryHidden !== true\">\r\n        <div *ngIf=\"page.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n          {{ page.props.formSummaryDescription }}\r\n        </div>\r\n        <dspx-validation-summary *ngIf=\"page.props?.isEditable && props.showValidationSummary\" [pageField]=\"page\"></dspx-validation-summary>\r\n        <div *ngFor=\"let section of getFieldGroup(page); let sectionIndex = index\">\r\n          <ng-container *ngIf=\"section.hide !== true\">\r\n            <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, pageIndex, section.key, -1) !== false; else sectionHeading\">\r\n              <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n            </ng-container>\r\n            <ng-template #sectionHeading>\r\n              <ng-container *ngIf=\"isRepeatingPageType(page.type) && section.type !== 'section-verification'\">\r\n                <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n              </ng-container>\r\n            </ng-template>\r\n\r\n            <div *ngIf=\"section.props.formSummaryDescription != null\" class=\"summary-paragraph\">\r\n              {{ section.props.formSummaryDescription }}\r\n            </div>\r\n\r\n            <!--Non-repeating page and non-repeating section-->\r\n            <dl *ngIf=\"isPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"p-grid\">\r\n              <ng-container\r\n                *ngTemplateOutlet=\"sectionQuestions; context { class: getNonRepeatingItemLayout(), containerClass:'', section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: -1, sectionKey: section.key, repeatingSectionIndex: -1 }\">\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating page only-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && (isSectionType(section.type) || section.type === 'section-verification')\" class=\"p-grid\">\r\n              <ng-container *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\">\r\n                <ng-container *ngIf=\"section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; then repPageSection; else repPageSectionHeading\">\r\n                </ng-container>\r\n                <ng-template #repPageSectionHeading>\r\n                  <ng-container *ngIf=\"section.type !== 'section-verification'; then repPageSection\">\r\n                  </ng-container>\r\n                </ng-template>\r\n                <ng-template #repPageSection>\r\n                  <div class=\"{{getRepeatingPageItemLayout()}}\">\r\n                    <dspx-heading [level]=\"3\" [heading]=\"section.props.label\"></dspx-heading>\r\n                    <dspx-heading [level]=\"4\" heading=\"{{ getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1) }}\"></dspx-heading>\r\n                    <ng-container\r\n                      *ngTemplateOutlet=\"sectionQuestions; context { class: 'p-grid', containerClass: 'p-col p-pt-3 p-pb-3', section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: repeatingPageIndex, sectionKey: section.key, repeatingSectionIndex: -1 }\">\r\n                    </ng-container>\r\n                  </div>\r\n                </ng-template>\r\n              </ng-container>\r\n            </dl>\r\n\r\n            <!--Repeating section only-->\r\n            <dl *ngIf=\"isPageType(page.type) && isRepeatingSectionType(section.type)\" class=\"p-grid\">\r\n              <div *ngFor=\"let repeatingSectionIndex of getSectionInstanceArray(tab.key, page.key, -1, section.key);\" class=\"{{getRepeatingSectionItemLayout()}}\">\r\n                <dspx-heading [level]=\"4\" heading=\"{{ getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, -1, section.key, repeatingSectionIndex) }}\"></dspx-heading>\r\n                <ng-container\r\n                  *ngTemplateOutlet=\"sectionQuestions; context { class: 'p-grid', containerClass: 'p-col p-pt-3 p-pb-3',section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: -1, sectionKey: section.key, repeatingSectionIndex: repeatingSectionIndex }\">\r\n                </ng-container>\r\n              </div>\r\n            </dl>\r\n\r\n            <!--Repeating page and repeating section-->\r\n            <dl *ngIf=\"isRepeatingPageType(page.type) && isRepeatingSectionType(section.type)\" class=\"p-grid\">\r\n              <div *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\" class=\"{{getRepeatingPageAndSectionItemLayout()}}\">\r\n                <div *ngFor=\"let repeatingSectionIndex of getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section.key);\">\r\n                  <dspx-heading [level]=\"4\" heading=\"{{ getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex) }}\"></dspx-heading>\r\n                  <ng-container\r\n                  *ngTemplateOutlet=\"sectionQuestions; context { class: 'p-grid', containerClass: 'p-col p-pt-3 p-pb-3', section: section, tabKey: tab.key, pageKey: page.key, repeatingPageIndex: repeatingPageIndex, sectionKey: section.key, repeatingSectionIndex: repeatingSectionIndex }\">\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n            </dl>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"props.showPageLink\" class=\"p-mb-3\">\r\n          <a role=\"button\" class=\"pointer\" tabindex=\"0\" (click)=\"hidePage(page, tabIndex, pageIndex)\">\r\n            <i class=\"pi pi-chevron-up p-pr-2\"></i>\r\n            <span>Hide answers</span>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </ng-container> \r\n  </div>\r\n</div>\r\n<ng-template #sectionQuestions let-class=\"class\" let-containerClass=\"containerClass\" let-section=\"section\"  let-tabKey=\"tabKey\" let-pageKey=\"pageKey\" let-repeatingPageIndex=\"repeatingPageIndex\" let-sectionKey=\"sectionKey\" let-repeatingSectionIndex=\"repeatingSectionIndex\">\r\n  <div *ngFor=\"let question of getFieldGroup(section);\" \r\n        class=\"{{class}}\"\r\n        [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                  || getFieldVisibility(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) === false\r\n                                  || question.type === 'paragraph'\r\n                                  || question.type === 'information'\r\n                                  || question.type === 'summary'\r\n                                  || question.props.label == null}\">\r\n    <div class=\"{{containerClass}}\">\r\n      <dt class=\"label p-mb-2\">{{ question.props.label }}\r\n        <span class=\"{{question.props.suffixClass}}\" *ngIf=\"question.props.suffix && question.props.suffix.length > 0\" aria-hidden=\"true\">{{question.props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"question.props.required && question.props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n        <button *ngIf=\"isQuickEditEnabled(question)\" type=\"button\" pButton pRipple \r\n                (click)=\"showQuickEdit(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)\"\r\n                class=\"p-button-text p-button-rounded quick-edit-button\" icon=\"fas fa-pen\"\r\n                title=\"Quick Edit\"\r\n                ></button>\r\n      </dt>\r\n      <dd class=\"p-ml-0\">\r\n        <dspx-show-hide-text text=\"{{getResponse(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex)}}\"></dspx-show-hide-text>\r\n       </dd> \r\n      <div class=\"p-invalid\">\r\n        {{ getValidationErrorText(question, tabKey, pageKey, repeatingPageIndex, sectionKey, repeatingSectionIndex) }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<p-dialog *ngIf=\"showQuickEditPopup\" [(visible)]=\"showQuickEditPopup\"\r\n  modal=\"true\" styleClass=\"dialog\"\r\n  [baseZIndex]=\"10000\"\r\n  focusTrap=\"true\"\r\n  closeAriaLabel=\"Close\">\r\n  <ng-template pTemplate=\"header\">\r\n    <h2 class=\"p-dialog-title\" tabindex=\"-1\" autofocus>{{getQuickEditPopupLabel()}}</h2>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"content\">\r\n    <div class=\"dialog-form\">\r\n      <form [formGroup]=\"quickEditForm\">\r\n        <formly-form [form]=\"quickEditForm\" [fields]=\"quickEditQuestions\" [model]=\"quickEditModel\"></formly-form>\r\n      </form>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"footer\">\r\n    <p-button (click)=\"updateQuickEditField()\" label=\"Ok\" title=\"Ok\" styleClass=\"p-button-conversion\"></p-button>\r\n    <p-button (click)=\"closeQuickEditPopup()\" label=\"Cancel\" title=\"Cancel\" styleClass=\"p-button-secondary\"></p-button>\r\n  </ng-template>\r\n</p-dialog>", styles: [".page-link{cursor:pointer;float:right;text-align:right;margin-left:auto}.page-link i{margin-right:.5rem}.quick-edit-button{top:5px;margin:0 .5em}\n"] }]
        }], ctorParameters: () => [{ type: FormNavigationService }, { type: FormConfigurationService }, { type: CoreService }, { type: OptionSetService }, { type: i0.ChangeDetectorRef }] });

class TimeFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TimeFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TimeFieldType, selector: "dspx-time", usesInheritance: true, ngImport: i0, template: "<p-calendar [id]=\"id\"\r\n            type=\"time\"\r\n            [name]=\"field.name\"\r\n            autocomplete=\"off\"\r\n            timeOnly=\"true\"\r\n            placeholder=\"HH:MM AM/PM\"\r\n            [keepInvalid]=\"true\"\r\n            [showIcon]=\"true\"\r\n            hourFormat=\"12\"\r\n            [readonlyInput]=\"true\"\r\n            icon=\"fas fa-clock\"\r\n            [formControl]=\"formControl\"\r\n            [formlyAttributes]=\"field\"\r\n            (onBlur)=\"onBlur($event)\"\r\n            dataType=\"string\"\r\n            iconAriaLabel=\"Select time\"\r\n            [ariaLabelledBy]=\"id + '-label'\"\r\n            [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n            [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-calendar>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3$3.Calendar, selector: "p-calendar", inputs: ["iconDisplay", "style", "styleClass", "inputStyle", "inputId", "name", "inputStyleClass", "placeholder", "ariaLabelledBy", "ariaLabel", "iconAriaLabel", "disabled", "dateFormat", "multipleSeparator", "rangeSeparator", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "monthNavigator", "yearNavigator", "hourFormat", "timeOnly", "stepYearPicker", "stepHour", "stepMinute", "stepSecond", "showSeconds", "required", "showOnFocus", "showWeek", "startWeekFromFirstDayOfYear", "showClear", "dataType", "selectionMode", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "autofocus", "autoZIndex", "baseZIndex", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "touchUI", "timeSeparator", "focusTrap", "showTransitionOptions", "hideTransitionOptions", "tabindex", "variant", "minDate", "maxDate", "disabledDates", "disabledDays", "yearRange", "showTime", "responsiveOptions", "numberOfMonths", "firstDayOfWeek", "locale", "view", "defaultDate"], outputs: ["onFocus", "onBlur", "onClose", "onSelect", "onClear", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange", "onClickOutside", "onShow"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TimeFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-time', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-calendar [id]=\"id\"\r\n            type=\"time\"\r\n            [name]=\"field.name\"\r\n            autocomplete=\"off\"\r\n            timeOnly=\"true\"\r\n            placeholder=\"HH:MM AM/PM\"\r\n            [keepInvalid]=\"true\"\r\n            [showIcon]=\"true\"\r\n            hourFormat=\"12\"\r\n            [readonlyInput]=\"true\"\r\n            icon=\"fas fa-clock\"\r\n            [formControl]=\"formControl\"\r\n            [formlyAttributes]=\"field\"\r\n            (onBlur)=\"onBlur($event)\"\r\n            dataType=\"string\"\r\n            iconAriaLabel=\"Select time\"\r\n            [ariaLabelledBy]=\"id + '-label'\"\r\n            [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n            [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-calendar>\r\n" }]
        }] });

class RadioFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            props: { options: [] },
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RadioFieldType, selector: "dspx-radio", usesInheritance: true, ngImport: i0, template: "<div class=\"field-checkbox\" *ngFor=\"let option of props.options | formlySelectOptions: field | async; let i = index\">\r\n  <p-radioButton\r\n    [inputId]=\"id + '_' + i\"\r\n    [name]=\"field.name || id\"\r\n    [formControl]=\"formControl\"\r\n    [value]=\"option.value\">\r\n  </p-radioButton>\r\n  <label class=\"p-radiobutton-label\" [for]=\"id + '_' + i\">{{option.label}}</label>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: RadioButton, selector: "p-radioButton", inputs: ["value", "formControlName", "name", "disabled", "label", "tabindex", "inputId", "ariaLabelledBy", "ariaLabel", "style", "styleClass", "labelStyleClass"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "pipe", type: i4$7.FormlySelectOptionsPipe, name: "formlySelectOptions" }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RadioFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-radio', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"field-checkbox\" *ngFor=\"let option of props.options | formlySelectOptions: field | async; let i = index\">\r\n  <p-radioButton\r\n    [inputId]=\"id + '_' + i\"\r\n    [name]=\"field.name || id\"\r\n    [formControl]=\"formControl\"\r\n    [value]=\"option.value\">\r\n  </p-radioButton>\r\n  <label class=\"p-radiobutton-label\" [for]=\"id + '_' + i\">{{option.label}}</label>\r\n</div>\r\n" }]
        }] });

class SingleCheckboxFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            props: {
                hideLabel: true,
            },
        };
        this.showToolTip = false;
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    handleCheckboxToolTipClick() {
        this.showToolTip = !this.showToolTip;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SingleCheckboxFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SingleCheckboxFieldType, selector: "dspx-single-checkbox", usesInheritance: true, ngImport: i0, template: "<div class=\"field-checkbox\">\r\n  <p-checkbox\r\n    [inputId]=\"id + '-input'\"\r\n    binary=\"true\"\r\n    [label]=\"props.label\"\r\n    [formControl]=\"formControl\"\r\n    [formlyAttributes]=\"field\"\r\n    (onBlur)=\"onBlur($event)\"\r\n    [required]=\"props.required\"\r\n    checkboxIcon=\"fas fa-check\"\r\n    (onChange)=\"props.change && props.change(field, $event)\"\r\n    [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n    [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  </p-checkbox>\r\n  <span class=\"required-marker field-checkbox-required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n  <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n    [title]=\"'Show help for ' + props.label\"\r\n    [attr.aria-label]=\"'Show help for ' + props.label\"\r\n    [attr.aria-expanded]=\"showToolTip\"\r\n    class=\"p-button-rounded p-button-text checkbox-tooltip-button\"\r\n    icon=\"fas fa-question-circle\"\r\n    (click)=\"handleCheckboxToolTipClick()\"></button>\r\n  <!-- <div class=\"tooltip-icon\">\r\n    <i *ngIf=\"props.toolTips && props.toolTips.length > 0\" class=\"fas fa-question-circle\" (click)=\"handleCheckboxToolTipClick()\"></i>\r\n  </div> -->\r\n</div>\r\n<div *ngIf=\"showToolTip\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n  <div *ngFor=\"let tooltip of props.toolTips\">\r\n  <div [innerHtml]=\"tooltip.text\"></div>\r\n  </div>\r\n</div>\r\n", styles: [".field-checkbox-required-marker{margin-bottom:10px;font-weight:700}\n"], dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: Checkbox, selector: "p-checkbox", inputs: ["value", "name", "disabled", "binary", "label", "ariaLabelledBy", "ariaLabel", "tabindex", "inputId", "style", "styleClass", "labelStyleClass", "formControl", "checkboxIcon", "readonly", "required", "trueValue", "falseValue"], outputs: ["onChange", "onFocus", "onBlur"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SingleCheckboxFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-single-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"field-checkbox\">\r\n  <p-checkbox\r\n    [inputId]=\"id + '-input'\"\r\n    binary=\"true\"\r\n    [label]=\"props.label\"\r\n    [formControl]=\"formControl\"\r\n    [formlyAttributes]=\"field\"\r\n    (onBlur)=\"onBlur($event)\"\r\n    [required]=\"props.required\"\r\n    checkboxIcon=\"fas fa-check\"\r\n    (onChange)=\"props.change && props.change(field, $event)\"\r\n    [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n    [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n  </p-checkbox>\r\n  <span class=\"required-marker field-checkbox-required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n  <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n    [title]=\"'Show help for ' + props.label\"\r\n    [attr.aria-label]=\"'Show help for ' + props.label\"\r\n    [attr.aria-expanded]=\"showToolTip\"\r\n    class=\"p-button-rounded p-button-text checkbox-tooltip-button\"\r\n    icon=\"fas fa-question-circle\"\r\n    (click)=\"handleCheckboxToolTipClick()\"></button>\r\n  <!-- <div class=\"tooltip-icon\">\r\n    <i *ngIf=\"props.toolTips && props.toolTips.length > 0\" class=\"fas fa-question-circle\" (click)=\"handleCheckboxToolTipClick()\"></i>\r\n  </div> -->\r\n</div>\r\n<div *ngIf=\"showToolTip\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n  <div *ngFor=\"let tooltip of props.toolTips\">\r\n  <div [innerHtml]=\"tooltip.text\"></div>\r\n  </div>\r\n</div>\r\n", styles: [".field-checkbox-required-marker{margin-bottom:10px;font-weight:700}\n"] }]
        }] });

class PBIEmbeddedFieldType extends FieldType {
    constructor(powerBiService) {
        super();
        this.powerBiService = powerBiService;
    }
    ngAfterViewInit() {
        console.log('afterViewInit');
        console.log('report container', this.reportContainer);
        let settings = {
            panes: {
                bookmarks: {
                    visible: false
                },
                fields: {
                    visible: this.props.pbiOptions.fieldsVisible,
                    expanded: this.props.pbiOptions.fieldsExpanded
                },
                filters: {
                    visible: this.props.pbiOptions.filtersVisible,
                    expanded: this.props.pbiOptions.filtersExpanded
                },
                pageNavigation: {
                    visible: this.props.pbiOptions.pageNavigationVisible
                },
                selection: {
                    visible: this.props.pbiOptions.selectionVisible
                },
                syncSlicers: {
                    visible: this.props.pbiOptions.syncSlicersVisible
                },
                visualizations: {
                    expanded: this.props.pbiOptions.visualisationsExpanded,
                    visible: this.props.pbiOptions.visualisationsVisible
                }
            },
            background: pbi.models.BackgroundType.Transparent,
            localeSettings: {
                language: 'en',
                formatLocale: 'AU'
            }
        };
        if (this.props.isDevelopment) {
            let embedParams = {
                type: this.props.pbiOptions.type,
                embedToken: {
                    tokenId: this.props.pbiOptions.tokenId,
                    token: this.props.pbiOptions.embedToken,
                    expiration: this.props.pbiOptions.expiration
                },
                embedReport: [{
                        reportId: this.props.pbiOptions.reportId,
                        embedUrl: this.props.pbiOptions.embedUrl,
                        reportName: this.props.pbiOptions.reportName
                    }]
            };
            this.launchReport(embedParams, settings);
        }
        else {
            this.powerBiService.getEmbedToken(this.props.pbiOptions.workspaceId, this.props.pbiOptions.reportId)
                .pipe(take(1))
                .subscribe(data => {
                if (data) {
                    this.launchReport(data, settings);
                }
            });
        }
    }
    ngOnInit() {
        console.log('onInit - start');
        console.log('report container', this.reportContainer);
    }
    launchReport(embedParams, settings) {
        let config = this.getEmbedConfig(embedParams, settings);
        let reportContainer = this.reportContainer.nativeElement;
        let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        this.report = powerbi.embed(reportContainer, config);
        // Clear any other loaded handler events
        this.report.off("loaded");
        // Triggers when a report schema is successfully loaded
        this.report.on("loaded", function () {
            console.log("Report load successful");
        });
        // Clear any other rendered handler events
        this.report.off("rendered");
        // Triggers when a report is successfully embedded in UI
        this.report.on("rendered", function () {
            console.log("Report render successful");
        });
        // Clear any other error handler events
        this.report.off("error");
        // Handle embed errors
        this.report.on("error", function (event) {
            var errorMsg = event.detail;
            // Use errorMsg variable to log error in any destination of choice
            console.error(errorMsg);
            return;
        });
    }
    getEmbedConfig(embedParams, settings) {
        switch (this.props.pbiOptions.embedType) {
            case 'report':
            default: {
                let reportConfig = {
                    accessToken: embedParams.embedToken.token,
                    type: this.props.pbiOptions.embedType,
                    tokenType: pbi.models.TokenType.Embed,
                    embedUrl: embedParams.embedReport[0].embedUrl,
                    filters: [],
                    settings: settings,
                    pageName: this.props.pbiOptions.pageName
                };
                return reportConfig;
            }
            case 'dashboard': {
                let dashboardConfig = {
                    accessToken: embedParams.embedToken.token,
                    type: this.props.pbiOptions.embedType,
                    tokenType: pbi.models.TokenType.Embed,
                    embedUrl: embedParams.embedReport[0].embedUrl
                };
                return dashboardConfig;
            }
            case 'visual': {
                let visualConfig = {
                    accessToken: embedParams.embedToken.token,
                    type: this.props.pbiOptions.embedType,
                    tokenType: pbi.models.TokenType.Embed,
                    embedUrl: embedParams.embedReport[0].embedUrl,
                    visualName: this.props.pbiOptions.visualName,
                    pageName: this.props.pbiOptions.pageName,
                    settings: settings,
                    filters: []
                };
                return visualConfig;
            }
            // Not supported for now. Need to understand the capability a bit more before introducing this feature
            // case 'qna': {
            //   let qnaConfig: pbi.IQnaEmbedConfiguration = {
            //     accessToken: embedParams.embedToken.token,
            //     type: this.props.pbiOptions.embedType,
            //     tokenType: pbi.models.TokenType.Embed,
            //     embedUrl: embedParams.embedReport[0].embedUrl,
            //     viewMode: pbi.models.QnaMode.Interactive,
            //     datasetIds: [this.props.pbiOptions.datasetId]
            //   };
            //   break;
            // }
            case 'tile': {
                let tileConfig = {
                    accessToken: embedParams.embedToken.token,
                    type: this.props.pbiOptions.embedType,
                    tokenType: pbi.models.TokenType.Embed,
                    embedUrl: embedParams.embedReport[0].embedUrl,
                    dashboardId: this.props.pbiOptions.dashboardId,
                    id: this.props.pbiOptions.tileId
                };
                return tileConfig;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PBIEmbeddedFieldType, deps: [{ token: PowerBiService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PBIEmbeddedFieldType, selector: "dspx-pbi-embedded", viewQueries: [{ propertyName: "reportContainer", first: true, predicate: ["reportContainer"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #reportContainer style=\"width: 100%; height: calc(0.5625 * 61vw);\"></div>\r\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PBIEmbeddedFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-pbi-embedded', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #reportContainer style=\"width: 100%; height: calc(0.5625 * 61vw);\"></div>\r\n" }]
        }], ctorParameters: () => [{ type: PowerBiService }], propDecorators: { reportContainer: [{
                type: ViewChild,
                args: ['reportContainer']
            }] } });

class SelectButtonFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectButtonFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SelectButtonFieldType, selector: "dspx-select-button", usesInheritance: true, ngImport: i0, template: "<p-selectButton\r\n  [id]=\"id\"\r\n  [options]=\"props.options\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (onBlur)=\"onBlur($event)\"\r\n  [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n  [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n  [multiple]=\"false\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-selectButton>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i6$2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "unselectable", "tabindex", "multiple", "allowEmpty", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey", "autofocus"], outputs: ["onOptionClick", "onChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectButtonFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-select-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-selectButton\r\n  [id]=\"id\"\r\n  [options]=\"props.options\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (onBlur)=\"onBlur($event)\"\r\n  [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n  [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n  [multiple]=\"false\"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-selectButton>\r\n" }]
        }] });

class FilterFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.showFilters = false;
        this.buttonIcon = "fas fa-chevron-down";
        this.applyLabel = "Apply filters";
        this.applyTitle = "Apply selected filters";
        this.clearLabel = "Clear filters";
        this.clearTitle = "Clear selected filters";
        this.collapsable = true;
    }
    ngOnInit() {
        this.collapsable = typeof this.props.filterOptions?.collapsable == 'undefined' ? this.collapsable : this.props.filterOptions.collapsable;
        this.applyLabel = typeof this.props.filterOptions?.applyLabel == 'undefined' ? this.applyLabel : this.props.filterOptions.applyLabel;
        this.applyTitle = typeof this.props.filterOptions?.applyTitle == 'undefined' ? this.applyTitle : this.props.filterOptions.applyTitle;
        this.clearLabel = typeof this.props.filterOptions?.clearLabel == 'undefined' ? this.clearLabel : this.props.filterOptions.clearLabel;
        this.clearTitle = typeof this.props.filterOptions?.clearTitle == 'undefined' ? this.clearTitle : this.props.filterOptions.clearTitle;
        this.showFilters = typeof this.props.filterOptions?.showFiltersExpanded == 'undefined' ? this.showFilters : this.props.filterOptions.showFiltersExpanded;
    }
    toggleFilters() {
        this.showFilters = !this.showFilters;
        this.buttonIcon = this.showFilters ? "fas fa-chevron-up" : "fas fa-chevron-down";
    }
    applyFilters() {
        if (this.props.change) {
            let event = {
                action: 'applyFilters',
                model: this.model
            };
            this.props.change(this.field, event);
        }
    }
    clearFilters() {
        for (let filterField of this.field.fieldGroup) {
            filterField.formControl.reset(null);
        }
        if (this.props.change) {
            let event = {
                action: 'clearFilters',
                model: this.model
            };
            this.props.change(this.field, event);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FilterFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FilterFieldType, selector: "dspx-filter", usesInheritance: true, ngImport: i0, template: "<div *ngIf=\"collapsable\" align=\"left\" type=\"solid\">\r\n  <div class=\"inline-flex align-items-center\">\r\n      <button type=\"button\" pButton pRipple class=\"p-button-rounded p-button-text mr-2\"\r\n        [icon]=\"buttonIcon\"\r\n        [title]=\"props.label\"\r\n        [attr.aria-label]=\"props.label\"\r\n        [attr.aria-expanded]=\"showFilters ? 'true' : 'false'\"\r\n        (click)=\"toggleFilters()\"></button>\r\n      <b>{{props.label}}</b>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"collapsable ? showFilters : true\">\r\n    <div class=\"advanced-filter grid flex\">\r\n        <ng-container *ngFor=\"let filterItem of field.fieldGroup;\">\r\n          <formly-field class=\"col-12 col-sm-6 md:col-4 lg:col-3 filter-field\" [field]=\"filterItem\" (keyup.enter)=\"applyFilters()\"></formly-field>\r\n        </ng-container>\r\n    </div>\r\n    <div class=\"col grid justify-content-end\">\r\n      <span class=\"flex\">\r\n        <button type=\"button\" pButton class=\"p-button-sm flex-order-2\" [title]=\"applyTitle\" [label]=\"applyLabel\" (click)=\"applyFilters()\"></button>\r\n        <button type=\"button\" pButton class=\"p-button-secondary p-button-sm flex-order-1\" [title]=\"clearTitle\" [label]=\"clearLabel\" (click)=\"clearFilters()\"></button>\r\n      </span>\r\n    </div>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FilterFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-filter', template: "<div *ngIf=\"collapsable\" align=\"left\" type=\"solid\">\r\n  <div class=\"inline-flex align-items-center\">\r\n      <button type=\"button\" pButton pRipple class=\"p-button-rounded p-button-text mr-2\"\r\n        [icon]=\"buttonIcon\"\r\n        [title]=\"props.label\"\r\n        [attr.aria-label]=\"props.label\"\r\n        [attr.aria-expanded]=\"showFilters ? 'true' : 'false'\"\r\n        (click)=\"toggleFilters()\"></button>\r\n      <b>{{props.label}}</b>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"collapsable ? showFilters : true\">\r\n    <div class=\"advanced-filter grid flex\">\r\n        <ng-container *ngFor=\"let filterItem of field.fieldGroup;\">\r\n          <formly-field class=\"col-12 col-sm-6 md:col-4 lg:col-3 filter-field\" [field]=\"filterItem\" (keyup.enter)=\"applyFilters()\"></formly-field>\r\n        </ng-container>\r\n    </div>\r\n    <div class=\"col grid justify-content-end\">\r\n      <span class=\"flex\">\r\n        <button type=\"button\" pButton class=\"p-button-sm flex-order-2\" [title]=\"applyTitle\" [label]=\"applyLabel\" (click)=\"applyFilters()\"></button>\r\n        <button type=\"button\" pButton class=\"p-button-secondary p-button-sm flex-order-1\" [title]=\"clearTitle\" [label]=\"clearLabel\" (click)=\"clearFilters()\"></button>\r\n      </span>\r\n    </div>\r\n</div>\r\n" }]
        }] });

class InputFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InputFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: InputFieldType, selector: "dspx-input", usesInheritance: true, ngImport: i0, template: "<input *ngIf=\"props.type !== 'number'; else numberTmp\"\r\n      pInputText\r\n      [id]=\"id\"\r\n      [type]=\"props.type || 'text'\"\r\n      [formControl]=\"formControl\"\r\n      [formlyAttributes]=\"field\"\r\n      (blur)=\"onBlur($event)\"\r\n      [attr.autocomplete]=\"props.autoComplete ? props.autoComplete : undefined\"\r\n      [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n      [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n      [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"/>\r\n    <ng-template #numberTmp>\r\n      <input type=\"number\"\r\n        pInputText\r\n        [id]=\"id\"\r\n        [formControl]=\"formControl\"\r\n        [formlyAttributes]=\"field\"\r\n        (blur)=\"onBlur($event)\"\r\n        [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n        [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n        [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"/>\r\n    </ng-template>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.InputText, selector: "[pInputText]", inputs: ["variant"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: InputFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<input *ngIf=\"props.type !== 'number'; else numberTmp\"\r\n      pInputText\r\n      [id]=\"id\"\r\n      [type]=\"props.type || 'text'\"\r\n      [formControl]=\"formControl\"\r\n      [formlyAttributes]=\"field\"\r\n      (blur)=\"onBlur($event)\"\r\n      [attr.autocomplete]=\"props.autoComplete ? props.autoComplete : undefined\"\r\n      [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n      [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n      [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"/>\r\n    <ng-template #numberTmp>\r\n      <input type=\"number\"\r\n        pInputText\r\n        [id]=\"id\"\r\n        [formControl]=\"formControl\"\r\n        [formlyAttributes]=\"field\"\r\n        (blur)=\"onBlur($event)\"\r\n        [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n        [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n        [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"/>\r\n    </ng-template>\r\n" }]
        }] });

class DecimalFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DecimalFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DecimalFieldType, selector: "dspx-decimal", usesInheritance: true, ngImport: i0, template: "<p-inputNumber\r\n               [inputId]=\"id + '-input'\"\r\n               mode=\"decimal\"\r\n               [formControl]=\"formControl\"\r\n               [formlyAttributes]=\"field\"\r\n               (blur)=\"onBlur($event)\"\r\n               [min]=\"props.min\"\r\n               [max]=\"props.max\"\r\n               [minFractionDigits]=\"props.minFractionDigits\"\r\n               [maxFractionDigits]=\"props.maxFractionDigits\"\r\n               [ariaLabel]=\"props.label\"\r\n               [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n               [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-inputNumber>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "component", type: i4.InputNumber, selector: "p-inputNumber", inputs: ["showButtons", "format", "buttonLayout", "inputId", "styleClass", "style", "placeholder", "size", "maxlength", "tabindex", "title", "ariaLabelledBy", "ariaLabel", "ariaRequired", "name", "required", "autocomplete", "min", "max", "incrementButtonClass", "decrementButtonClass", "incrementButtonIcon", "decrementButtonIcon", "readonly", "step", "allowEmpty", "locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "variant", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "inputStyle", "inputStyleClass", "showClear", "autofocus", "disabled"], outputs: ["onInput", "onFocus", "onBlur", "onKeyDown", "onClear"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DecimalFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-decimal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-inputNumber\r\n               [inputId]=\"id + '-input'\"\r\n               mode=\"decimal\"\r\n               [formControl]=\"formControl\"\r\n               [formlyAttributes]=\"field\"\r\n               (blur)=\"onBlur($event)\"\r\n               [min]=\"props.min\"\r\n               [max]=\"props.max\"\r\n               [minFractionDigits]=\"props.minFractionDigits\"\r\n               [maxFractionDigits]=\"props.maxFractionDigits\"\r\n               [ariaLabel]=\"props.label\"\r\n               [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n               [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</p-inputNumber>\r\n" }]
        }] });

class EditorFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.editorContent = '';
        this.showEditor = true;
        this.toolbar = [
            ['bold', 'italic'],
            ['underline', 'strike'],
            ['code', 'blockquote'],
            ['ordered_list', 'bullet_list'],
            [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
            ['link', 'image'],
            ['text_color', 'background_color'],
            ['align_left', 'align_center', 'align_right', 'align_justify'],
        ];
    }
    ngOnInit() {
        this.editorContent = (this.model !== undefined || this.model !== null) ? this.model : '';
        this.editor = new Editor({
            content: this.editorContent,
            history: true,
            keyboardShortcuts: true,
            inputRules: true,
            plugins: [],
            schema,
            nodeViews: {}
        });
    }
    ngOnDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
    }
    onChange(data) {
        this.editorContent = toHTML(data);
        this.formControl.setValue(this.editorContent);
    }
    toggleEditor(isEditor) {
        if (isEditor) {
            // Update the editor's content to reflect the (maybe updated) content from the HTML textarea
            this.editor.setContent(this.formControl.value);
        }
        this.showEditor = isEditor;
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditorFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: EditorFieldType, selector: "dspx-editor", usesInheritance: true, ngImport: i0, template: "<div class=\"flex justify-content-end\">\r\n  <button pButton pRipple type=\"button\" label=\"Editor\" title=\"Show Editor\" class=\"p-button-conversion p-button-sm\" (click)=\"toggleEditor(true)\"></button>\r\n  <button pButton pRipple type=\"button\" label=\"HTML\" title=\"Show HTML\" class=\"p-button-conversion p-button-sm\" (click)=\"toggleEditor(false)\"></button>\r\n</div>\r\n<div class=\"NgxEditor__Wrapper\" [ngStyle]=\"{display: showEditor ? 'block' : 'none'}\">\r\n  <ngx-editor-menu [editor]=\"editor\" [toolbar]=\"toolbar\"></ngx-editor-menu>\r\n  <ngx-editor [editor]=\"editor\" [ngModel]=\"model\" (ngModelChange)=\"onChange($event)\"></ngx-editor>\r\n</div>\r\n<div *ngIf=\"!showEditor\">\r\n  <textarea\r\n  [id]=\"id\"\r\n  [rows]=\"10\"\r\n  [cols]=\"30\"\r\n  pInputTextarea\r\n  autoResize=\"autoResize\"\r\n  [formControl] = \"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</textarea>\r\n</div>\r\n", styles: [".p-button{margin-left:.2rem}.NgxEditor__Wrapper{margin-top:.2rem}\n"], dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "component", type: i2$5.NgxEditorComponent, selector: "ngx-editor", inputs: ["editor", "outputFormat", "placeholder"], outputs: ["focusOut", "focusIn"] }, { kind: "component", type: i2$5.MenuComponent, selector: "ngx-editor-menu", inputs: ["toolbar", "colorPresets", "disabled", "editor", "customMenuRef", "dropdownPlacement"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "directive", type: i4$6.InputTextarea, selector: "[pInputTextarea]", inputs: ["autoResize", "variant"], outputs: ["onResize"] }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EditorFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-editor', template: "<div class=\"flex justify-content-end\">\r\n  <button pButton pRipple type=\"button\" label=\"Editor\" title=\"Show Editor\" class=\"p-button-conversion p-button-sm\" (click)=\"toggleEditor(true)\"></button>\r\n  <button pButton pRipple type=\"button\" label=\"HTML\" title=\"Show HTML\" class=\"p-button-conversion p-button-sm\" (click)=\"toggleEditor(false)\"></button>\r\n</div>\r\n<div class=\"NgxEditor__Wrapper\" [ngStyle]=\"{display: showEditor ? 'block' : 'none'}\">\r\n  <ngx-editor-menu [editor]=\"editor\" [toolbar]=\"toolbar\"></ngx-editor-menu>\r\n  <ngx-editor [editor]=\"editor\" [ngModel]=\"model\" (ngModelChange)=\"onChange($event)\"></ngx-editor>\r\n</div>\r\n<div *ngIf=\"!showEditor\">\r\n  <textarea\r\n  [id]=\"id\"\r\n  [rows]=\"10\"\r\n  [cols]=\"30\"\r\n  pInputTextarea\r\n  autoResize=\"autoResize\"\r\n  [formControl] = \"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (blur)=\"onBlur($event)\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n</textarea>\r\n</div>\r\n", styles: [".p-button{margin-left:.2rem}.NgxEditor__Wrapper{margin-top:.2rem}\n"] }]
        }] });

class HeaderFieldType extends FieldType {
    ngOnInit() {
        this.formHeaderModel = {
            header: this.props.label,
            headerTitleLevel: this.props.titleLevel,
            badgeText: this.field.props.badgeText,
            badgeThemeClass: this.props.badgeThemeClass,
            subtitle: this.props.subtitle,
            subtitleLevel: this.props.subtitleLevel,
            questions: this.getHeaderFieldItems()
        };
    }
    getHeaderFieldItems() {
        return [...this.field.model[this.field.key.toString()]];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HeaderFieldType, selector: "dspx-form-header", usesInheritance: true, ngImport: i0, template: "<dspx-form-header-base\r\n  [formHeaderModel] = \"formHeaderModel\"\r\n  >\r\n</dspx-form-header-base>\r\n", styles: [""], dependencies: [{ kind: "component", type: DspxFormHeaderComponent, selector: "dspx-form-header-base", inputs: ["formHeaderModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HeaderFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-header', template: "<dspx-form-header-base\r\n  [formHeaderModel] = \"formHeaderModel\"\r\n  >\r\n</dspx-form-header-base>\r\n" }]
        }] });

class HtmlHeadingFieldType extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HtmlHeadingFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: HtmlHeadingFieldType, selector: "dspx-html-heading", usesInheritance: true, ngImport: i0, template: "<dspx-heading [heading]=\"props.label\" [level]=\"props.level\"></dspx-heading>\r\n", dependencies: [{ kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HtmlHeadingFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-html-heading', template: "<dspx-heading [heading]=\"props.label\" [level]=\"props.level\"></dspx-heading>\r\n" }]
        }] });

class SectionVerificationFieldType extends FieldType {
    constructor(coreService, idVerificationService, dialogService) {
        super();
        this.coreService = coreService;
        this.idVerificationService = idVerificationService;
        this.dialogService = dialogService;
        this.status = 'New';
        this.severity = 'error';
        this.canVerify = true;
    }
    ngOnInit() {
        var isVerified = false;
        if (this.field.model && this.field.model[this.props.statusControlId] && this.field.model[this.props.statusControlId]) {
            isVerified = this.field.model[this.props.statusControlId] === IdVerificationStatus.Y;
            this.status = isVerified ? "Success" : "Error";
        }
        this.severity = this.getSeverityFromStatus();
        this.canVerify = !isVerified;
    }
    verify() {
        markChildControlsAsTouched(this.field.formControl);
        if (this.field.formControl.valid) {
            this.idVerificationService.verify(this.props.renderType, this.model)
                .pipe(take(1))
                .subscribe(result => {
                if (result) {
                    this.field.model[this.props.statusControlId] = result.status;
                    switch (result.status) {
                        case IdVerificationStatus.D:
                        case IdVerificationStatus.N:
                        case IdVerificationStatus.S: {
                            this.status = "Error";
                            break;
                        }
                        case IdVerificationStatus.Y: {
                            this.status = "Success";
                            this.canVerify = false;
                            break;
                        }
                    }
                    this.severity = this.getSeverityFromStatus();
                    this.showDialog(result.status);
                }
            });
        }
    }
    getSeverityFromStatus() {
        switch (this.status) {
            case 'New': {
                return 'error';
            }
            case 'Pending': {
                return 'warning';
            }
            case 'Success': {
                return 'success';
            }
            case 'Error': {
                return 'error';
            }
            default: {
                return 'error';
            }
        }
    }
    showDialog(status) {
        var popupCode;
        switch (status) {
            case IdVerificationStatus.D: {
                popupCode = 'idDocumentError';
                break;
            }
            case IdVerificationStatus.N: {
                popupCode = 'idNotMatched';
                break;
            }
            case IdVerificationStatus.S: {
                popupCode = 'idVerificationError';
                break;
            }
            case IdVerificationStatus.Y: {
                popupCode = 'idMatched';
                break;
            }
        }
        this.dialogService.showDialog(popupCode);
    }
    getButtonId() {
        var baseButtonId = this.field.id + '_Verify';
        return baseButtonId;
    }
    getButtonTitle() {
        return 'Verify ' + this.props.label;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionVerificationFieldType, deps: [{ token: CoreService }, { token: IdVerificationService }, { token: DialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionVerificationFieldType, selector: "dspx-section-verification", usesInheritance: true, ngImport: i0, template: "<div class=\"verification-section mt-3 mb-6\">\r\n  <p-panel>\r\n    <ng-template pTemplate=\"header\">\r\n      <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"icons\">\r\n      <p-badge [value]=\"status\" [severity]=\"severity\" size=\"large\"></p-badge>\r\n    </ng-template>\r\n    <div>\r\n      <dspx-description [text]=\"props.description\"></dspx-description>\r\n      <div class=\"question\" *ngFor=\"let question of field.fieldGroup; let questionIndex = index; let lastQuestion = last\">\r\n        <formly-field [field]=\"question\"></formly-field>\r\n      </div>\r\n      <div class=\"flex justify-content-end\">\r\n        <button pButton type=\"button\" (click)=\"verify()\" label=\"Verify\" [title]=\"getButtonTitle()\" [id]=\"getButtonId()\" [disabled]=\"!canVerify\"></button>\r\n      </div>\r\n    </div>\r\n  </p-panel>\r\n</div>\r\n", styles: [".section-header{margin:5px}.header-row .h4{font-weight:700}.sub-header-row .h5{font-weight:400}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i3$5.Badge, selector: "p-badge", inputs: ["styleClass", "style", "badgeSize", "severity", "value", "badgeDisabled", "size"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionVerificationFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section-verification', template: "<div class=\"verification-section mt-3 mb-6\">\r\n  <p-panel>\r\n    <ng-template pTemplate=\"header\">\r\n      <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    </ng-template>\r\n    <ng-template pTemplate=\"icons\">\r\n      <p-badge [value]=\"status\" [severity]=\"severity\" size=\"large\"></p-badge>\r\n    </ng-template>\r\n    <div>\r\n      <dspx-description [text]=\"props.description\"></dspx-description>\r\n      <div class=\"question\" *ngFor=\"let question of field.fieldGroup; let questionIndex = index; let lastQuestion = last\">\r\n        <formly-field [field]=\"question\"></formly-field>\r\n      </div>\r\n      <div class=\"flex justify-content-end\">\r\n        <button pButton type=\"button\" (click)=\"verify()\" label=\"Verify\" [title]=\"getButtonTitle()\" [id]=\"getButtonId()\" [disabled]=\"!canVerify\"></button>\r\n      </div>\r\n    </div>\r\n  </p-panel>\r\n</div>\r\n", styles: [".section-header{margin:5px}.header-row .h4{font-weight:700}.sub-header-row .h5{font-weight:400}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: IdVerificationService }, { type: DialogService }] });

class ImageFieldType extends FieldType {
    getImageUrlFromConfig() {
        if (this.props.imageOptions) {
            if (this.props.imageOptions.imageUrl) {
                return this.props.imageOptions.imageUrl;
            }
            if (this.props.imageFunction) {
                return this.props.imageFunction(this.field);
            }
        }
        return '';
    }
    getImageAltTextFromConfig() {
        if (this.props.imageOptions) {
            if (this.props.imageOptions.altText) {
                return this.props.imageOptions.altText;
            }
            if (this.props.altTextFunction) {
                return this.props.altTextFunction(this.field);
            }
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ImageFieldType, selector: "dspx-image", usesInheritance: true, ngImport: i0, template: "<img class=\"image\" [src]=\"getImageUrlFromConfig()\" [attr.height]=\"props.imageOptions.height\" [alt]=\"getImageAltTextFromConfig()\">\r\n", styles: [".image{margin:auto}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-image', template: "<img class=\"image\" [src]=\"getImageUrlFromConfig()\" [attr.height]=\"props.imageOptions.height\" [alt]=\"getImageAltTextFromConfig()\">\r\n", styles: [".image{margin:auto}\n"] }]
        }] });

class SectionLoginFieldType extends FieldType {
    constructor(coreService, idVerificationService) {
        super();
        this.coreService = coreService;
        this.idVerificationService = idVerificationService;
        this.status = 'New';
        this.severity = 'error';
    }
    login() {
    }
    getButtonId(buttonType) {
        var baseButtonId = this.field.id + '_' + buttonType;
        return baseButtonId;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionLoginFieldType, deps: [{ token: CoreService }, { token: IdVerificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SectionLoginFieldType, selector: "dspx-section-login", usesInheritance: true, ngImport: i0, template: "<div class=\"verification-section mt-3 mb-6\">\r\n  <p-card styleClass=\"p-card-shadow\">\r\n    <ng-template pTemplate=\"title\">\r\n      <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    </ng-template>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <div class=\"question\" *ngFor=\"let question of field.fieldGroup; let questionIndex = index; let lastQuestion = last\">\r\n      <formly-field [field]=\"question\"></formly-field>\r\n    </div>\r\n    <!-- <div class=\"flex justify-content-end\">\r\n      <button pButton type=\"button\" (click)=\"login()\" label=\"Login\" title=\"Login\" [id]=\"getButtonId('L')\"></button>\r\n    </div> -->\r\n  </p-card>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SectionLoginFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-section-login', template: "<div class=\"verification-section mt-3 mb-6\">\r\n  <p-card styleClass=\"p-card-shadow\">\r\n    <ng-template pTemplate=\"title\">\r\n      <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    </ng-template>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <div class=\"question\" *ngFor=\"let question of field.fieldGroup; let questionIndex = index; let lastQuestion = last\">\r\n      <formly-field [field]=\"question\"></formly-field>\r\n    </div>\r\n    <!-- <div class=\"flex justify-content-end\">\r\n      <button pButton type=\"button\" (click)=\"login()\" label=\"Login\" title=\"Login\" [id]=\"getButtonId('L')\"></button>\r\n    </div> -->\r\n  </p-card>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }, { type: IdVerificationService }] });

class SelectFieldType extends FieldType {
    constructor() {
        super(...arguments);
        this.defaultOptions = {
            props: { options: [] },
        };
    }
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SelectFieldType, selector: "dspx-select", usesInheritance: true, ngImport: i0, template: "<p-dropdown\r\n      [inputId]=\"id + '-input'\"\r\n      [placeholder]=\"props.placeholder\"\r\n      [options]=\"props.options | formlySelectOptions: field | async\"\r\n      [formControl]=\"formControl\"\r\n      [formlyAttributes]=\"field\"\r\n      (onBlur)=\"onBlur($event)\"\r\n      [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n      [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n      [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n      [showClear]=\"!props.required\"\r\n      (onChange)=\"props.change && props.change(field, $event)\"\r\n      [ariaLabel]=\"props.label\"\r\n      [ariaFilterLabel]=\"props.label + ' filter'\">\r\n</p-dropdown>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i3.Dropdown, selector: "p-dropdown", inputs: ["id", "scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "loadingIcon", "filterPlaceholder", "filterLocale", "variant", "inputId", "dataKey", "filterBy", "filterFields", "autofocus", "resetFilterOnHide", "checkmark", "dropdownIcon", "loading", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "ariaLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "focusOnHover", "selectOnFocus", "autoOptionFocus", "autofocusFilter", "autoShowPanelOnPrintableCharacterKeyDown", "disabled", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "filterValue", "options"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear", "onLazyLoad"] }, { kind: "pipe", type: i4$7.FormlySelectOptionsPipe, name: "formlySelectOptions" }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-select', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-dropdown\r\n      [inputId]=\"id + '-input'\"\r\n      [placeholder]=\"props.placeholder\"\r\n      [options]=\"props.options | formlySelectOptions: field | async\"\r\n      [formControl]=\"formControl\"\r\n      [formlyAttributes]=\"field\"\r\n      (onBlur)=\"onBlur($event)\"\r\n      [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n      [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n      [attr.aria-describedby]=\"id + '-err ' + id + '-help'\"\r\n      [showClear]=\"!props.required\"\r\n      (onChange)=\"props.change && props.change(field, $event)\"\r\n      [ariaLabel]=\"props.label\"\r\n      [ariaFilterLabel]=\"props.label + ' filter'\">\r\n</p-dropdown>\r\n" }]
        }] });

class ExcelFileUploadType extends FieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExcelFileUploadType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ExcelFileUploadType, selector: "dspx-excel-file-upload", usesInheritance: true, ngImport: i0, template: "<dspx-excel-file-upload-component [id]=\"field.key\"\r\n                     [modelContainer]=\"model\"\r\n                     [uploadWorkSheet]=\"field.props.dataImportOptions.uploadWorkSheet\"\r\n                     [downloadWorkSheet]=\"field.props.dataImportOptions.downloadWorkSheet\"\r\n                     [uploadMultipleWorkSheets]=\"field.props.dataImportOptions.uploadMultipleWorkSheets\"\r\n                     [previewEnabled]=\"field.props.dataImportOptions.previewEnabled\"\r\n                     [expectedWorkSheetName]=\"field.props.dataImportOptions.expectedWorkSheetName\"\r\n                     [documentSource]=\"field.props.dataImportOptions.documentSource\"\r\n                     [initialiseDocumentUploadEndpoint]=\"field.props.dataImportOptions.initialiseDocumentUploadEndpoint\"\r\n                     [uploadDocumentChunkEndpoint]=\"field.props.dataImportOptions.uploadDocumentChunkEndpoint\"\r\n                     [finaliseDocumentUploadEndpoint]=\"field.props.dataImportOptions.finaliseDocumentUploadEndpoint\"\r\n                     [downloadDocumentEndpoint]=\"field.props.dataImportOptions.downloadDocumentEndpoint\"\r\n                     [customErrorSummaries]=\"field.props.dataImportOptions.customErrorSummaries\"\r\n                     [disabled]=\"field.props.disabled\">\r\n</dspx-excel-file-upload-component>\r\n", dependencies: [{ kind: "component", type: DspxExcelFileUploadComponent, selector: "dspx-excel-file-upload-component", inputs: ["id", "modelContainer", "uploadWorkSheet", "downloadWorkSheet", "uploadMultipleWorkSheets", "previewEnabled", "expectedWorkSheetName", "documentSource", "initialiseDocumentUploadEndpoint", "uploadDocumentChunkEndpoint", "finaliseDocumentUploadEndpoint", "downloadDocumentEndpoint", "customErrorSummaries", "disabled"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExcelFileUploadType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-excel-file-upload', template: "<dspx-excel-file-upload-component [id]=\"field.key\"\r\n                     [modelContainer]=\"model\"\r\n                     [uploadWorkSheet]=\"field.props.dataImportOptions.uploadWorkSheet\"\r\n                     [downloadWorkSheet]=\"field.props.dataImportOptions.downloadWorkSheet\"\r\n                     [uploadMultipleWorkSheets]=\"field.props.dataImportOptions.uploadMultipleWorkSheets\"\r\n                     [previewEnabled]=\"field.props.dataImportOptions.previewEnabled\"\r\n                     [expectedWorkSheetName]=\"field.props.dataImportOptions.expectedWorkSheetName\"\r\n                     [documentSource]=\"field.props.dataImportOptions.documentSource\"\r\n                     [initialiseDocumentUploadEndpoint]=\"field.props.dataImportOptions.initialiseDocumentUploadEndpoint\"\r\n                     [uploadDocumentChunkEndpoint]=\"field.props.dataImportOptions.uploadDocumentChunkEndpoint\"\r\n                     [finaliseDocumentUploadEndpoint]=\"field.props.dataImportOptions.finaliseDocumentUploadEndpoint\"\r\n                     [downloadDocumentEndpoint]=\"field.props.dataImportOptions.downloadDocumentEndpoint\"\r\n                     [customErrorSummaries]=\"field.props.dataImportOptions.customErrorSummaries\"\r\n                     [disabled]=\"field.props.disabled\">\r\n</dspx-excel-file-upload-component>\r\n" }]
        }] });

class CardSectionFieldType extends SectionFieldType {
    constructor() {
        super(...arguments);
        this.getQuestionLayoutStyleClass = (question) => {
            return (question.props.columnLayout && question.props.columnLayout == 'split') ? 'col-6 md:col-6' :
                (question.props.columnLayout != null ? question.props.columnLayout : 'col-12 question');
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSectionFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSectionFieldType, selector: "dspx-card-section", usesInheritance: true, ngImport: i0, template: "<ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'card'\">\r\n\r\n  <ng-container *ngSwitchCase=\"'card'\">\r\n    <p-card [header]=\"props.label\" [subheader]=\"props.description\">\r\n      <ng-template pTemplate=\"content\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n      </ng-template>\r\n    </p-card>\r\n  </ng-container>\r\n\r\n  <ng-container *ngSwitchCase=\"'plain'\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n  </ng-container>\r\n\r\n  <ng-template #layoutTypeContent>\r\n    <div class=\"grid\">\r\n      <ng-container *ngFor=\"let question of field.fieldGroup\">\r\n        <ng-container *ngIf=\"question.hide != true && question.type != null ; else noStyle\">\r\n          <div class=\"{{getQuestionLayoutStyleClass(question)}}\">\r\n            <formly-field [field]=\"question\"></formly-field>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #noStyle>\r\n          <formly-field [field]=\"question\"></formly-field>\r\n        </ng-template>\r\n\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n\r\n</ng-container>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSectionFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-section', template: "<ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'card'\">\r\n\r\n  <ng-container *ngSwitchCase=\"'card'\">\r\n    <p-card [header]=\"props.label\" [subheader]=\"props.description\">\r\n      <ng-template pTemplate=\"content\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n      </ng-template>\r\n    </p-card>\r\n  </ng-container>\r\n\r\n  <ng-container *ngSwitchCase=\"'plain'\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n  </ng-container>\r\n\r\n  <ng-template #layoutTypeContent>\r\n    <div class=\"grid\">\r\n      <ng-container *ngFor=\"let question of field.fieldGroup\">\r\n        <ng-container *ngIf=\"question.hide != true && question.type != null ; else noStyle\">\r\n          <div class=\"{{getQuestionLayoutStyleClass(question)}}\">\r\n            <formly-field [field]=\"question\"></formly-field>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #noStyle>\r\n          <formly-field [field]=\"question\"></formly-field>\r\n        </ng-template>\r\n\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n\r\n</ng-container>\r\n" }]
        }] });

class CardSectionRepeatingFieldType extends DspxBaseTableRepeaterComponent {
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, changeDetector) {
        super(coreService, spinnerService, repeaterRegistryService, repeaterService, repeaterService.getSectionRepeaterExtraSettings(), changeDetector);
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.initialise();
    }
    ngOnDestroy() {
        this.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSectionRepeatingFieldType, deps: [{ token: CoreService }, { token: SpinnerService }, { token: RepeaterRegistryService }, { token: RepeaterService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSectionRepeatingFieldType, selector: "dspx-card-section-repeating", usesInheritance: true, ngImport: i0, template: "<ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'card'\">\r\n  <ng-container *ngSwitchCase=\"'card'\">\r\n    <p-card [header]=\"props.label\" [subheader]=\"props.description\">\r\n      <ng-template pTemplate=\"content\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n      </ng-template>\r\n    </p-card>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'plain'\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n  </ng-container>\r\n  <ng-template #layoutTypeContent>\r\n    <dspx-table-repeater [repeater]=\"baseTableRepeater\" [renderItemsAsSeparateFieldTypes]=\"false\" (onInitialiseCompleted)=\"onTableRepeaterInitialised($event)\" [repeaterLayout]=\"props.cardSetLayoutOptions?.repeaterLayout\"></dspx-table-repeater>\r\n  </ng-template>\r\n</ng-container>\r\n", dependencies: [{ kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: DspxTableRepeaterComponent, selector: "dspx-table-repeater", inputs: ["repeater", "renderItemsAsSeparateFieldTypes", "repeaterLayout"], outputs: ["onInitialiseCompleted"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSectionRepeatingFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-section-repeating', template: "<ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'card'\">\r\n  <ng-container *ngSwitchCase=\"'card'\">\r\n    <p-card [header]=\"props.label\" [subheader]=\"props.description\">\r\n      <ng-template pTemplate=\"content\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n      </ng-template>\r\n    </p-card>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'plain'\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.label\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n  </ng-container>\r\n  <ng-template #layoutTypeContent>\r\n    <dspx-table-repeater [repeater]=\"baseTableRepeater\" [renderItemsAsSeparateFieldTypes]=\"false\" (onInitialiseCompleted)=\"onTableRepeaterInitialised($event)\" [repeaterLayout]=\"props.cardSetLayoutOptions?.repeaterLayout\"></dspx-table-repeater>\r\n  </ng-template>\r\n</ng-container>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }, { type: SpinnerService }, { type: RepeaterRegistryService }, { type: RepeaterService }, { type: i0.ChangeDetectorRef }] });

class CardSetPageFieldType extends PageFieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetPageFieldType, selector: "dspx-card-set-page", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field.key === 'form'; then formTemplate; else pageTemplate\"></ng-container>\r\n\r\n<ng-template #formTemplate>\r\n  <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n  <dspx-description [text]=\"props.description\"></dspx-description>\r\n  <div *ngFor=\"let tabs of field.fieldGroup\">\r\n    <formly-field [field]=\"tabs\"></formly-field>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #pageTemplate>\r\n\r\n  <ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'plain'\">\r\n\r\n    <ng-container *ngSwitchCase=\"'card'\">\r\n      <p-card [header]=\"props.heading\" [subheader]=\"props.description\">\r\n        <ng-template pTemplate=\"header\">\r\n          <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n          <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n        </ng-template>\r\n      </p-card>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"'plain'\">\r\n      <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n      <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n      <dspx-description [text]=\"props.description\"></dspx-description>\r\n      <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n    </ng-container>\r\n\r\n    <ng-template #layoutTypeHeader>\r\n      <div class=\"p-card-header-content\">\r\n        <dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n      </div>\r\n    </ng-template>\r\n\r\n    <ng-template #layoutTypeContent>\r\n      <dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n      <ng-container *ngIf=\"!props.hideContent\">\r\n        <div class=\"grid\">\r\n          <div [class]=\"section.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let section of field.fieldGroup\">\r\n\r\n            <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n\r\n            <ng-template #viewTemplate>\r\n              <dspx-card-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\"></dspx-card-section-view-mode>\r\n            </ng-template>\r\n\r\n            <ng-template #editTemplate>\r\n              <formly-field [field]=\"section\"></formly-field>\r\n            </ng-template>\r\n\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      <dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                              [requiresBackButton]=\"props.requiresBackButton\"\r\n                              [backButtonLabel]=\"props.backButtonLabel\"\r\n                              [backButtonTitle]=\"props.backButtonTitle\"\r\n                              [requiresNextButton]=\"props.requiresNextButton\"\r\n                              [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                              [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                              [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                              [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                              [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                              [pageField]=\"field\"\r\n                              [topDividerDisplay]=\"'never'\"\r\n                              [bottomDividerDisplay]=\"'auto'\">\r\n        </dspx-form-navigation>\r\n    </ng-template>\r\n\r\n  </ng-container>\r\n\r\n</ng-template>\r\n\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: FormNavigationFieldType, selector: "dspx-form-navigation", inputs: ["actionButtons", "requiresBackButton", "backButtonLabel", "backButtonTitle", "requiresNextButton", "nextButtonLabel", "nextButtonTitle", "requiresCancelButton", "cancelButtonLabel", "cancelButtonTitle", "pageField", "topDividerDisplay", "bottomDividerDisplay"] }, { kind: "component", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: ["pageField"] }, { kind: "component", type: DspxStatusBarComponent, selector: "dspx-status-bar", inputs: ["content"] }, { kind: "component", type: DspxCardSectionViewModeComponent, selector: "dspx-card-section-view-mode" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-page', template: "<ng-container *ngIf=\"field.key === 'form'; then formTemplate; else pageTemplate\"></ng-container>\r\n\r\n<ng-template #formTemplate>\r\n  <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n  <dspx-description [text]=\"props.description\"></dspx-description>\r\n  <div *ngFor=\"let tabs of field.fieldGroup\">\r\n    <formly-field [field]=\"tabs\"></formly-field>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #pageTemplate>\r\n\r\n  <ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'plain'\">\r\n\r\n    <ng-container *ngSwitchCase=\"'card'\">\r\n      <p-card [header]=\"props.heading\" [subheader]=\"props.description\">\r\n        <ng-template pTemplate=\"header\">\r\n          <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n          <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n        </ng-template>\r\n      </p-card>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"'plain'\">\r\n      <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n      <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n      <dspx-description [text]=\"props.description\"></dspx-description>\r\n      <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n    </ng-container>\r\n\r\n    <ng-template #layoutTypeHeader>\r\n      <div class=\"p-card-header-content\">\r\n        <dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n      </div>\r\n    </ng-template>\r\n\r\n    <ng-template #layoutTypeContent>\r\n      <dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n      <ng-container *ngIf=\"!props.hideContent\">\r\n        <div class=\"grid\">\r\n          <div [class]=\"section.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let section of field.fieldGroup\">\r\n\r\n            <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n\r\n            <ng-template #viewTemplate>\r\n              <dspx-card-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\"></dspx-card-section-view-mode>\r\n            </ng-template>\r\n\r\n            <ng-template #editTemplate>\r\n              <formly-field [field]=\"section\"></formly-field>\r\n            </ng-template>\r\n\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      <dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                              [requiresBackButton]=\"props.requiresBackButton\"\r\n                              [backButtonLabel]=\"props.backButtonLabel\"\r\n                              [backButtonTitle]=\"props.backButtonTitle\"\r\n                              [requiresNextButton]=\"props.requiresNextButton\"\r\n                              [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                              [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                              [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                              [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                              [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                              [pageField]=\"field\"\r\n                              [topDividerDisplay]=\"'never'\"\r\n                              [bottomDividerDisplay]=\"'auto'\">\r\n        </dspx-form-navigation>\r\n    </ng-template>\r\n\r\n  </ng-container>\r\n\r\n</ng-template>\r\n\r\n" }]
        }] });

class CardSetPageRepeatingFieldType extends DspxBaseTableRepeaterComponent {
    constructor(coreService, spinnerService, repeaterRegistryService, repeaterService, changeDetector) {
        super(coreService, spinnerService, repeaterRegistryService, repeaterService, repeaterService.getPageRepeaterExtraSettings(), changeDetector);
        this.coreService = coreService;
        this.spinnerService = spinnerService;
        this.repeaterRegistryService = repeaterRegistryService;
        this.repeaterService = repeaterService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        this.initialise();
        this.field.props.showValidationSummary = false;
    }
    ngOnDestroy() {
        this.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageRepeatingFieldType, deps: [{ token: CoreService }, { token: SpinnerService }, { token: RepeaterRegistryService }, { token: RepeaterService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetPageRepeatingFieldType, selector: "dspx-card-set-page-repeating", usesInheritance: true, ngImport: i0, template: "<ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'plain'\">\r\n  <ng-container *ngSwitchCase=\"'card'\">\r\n    <p-card [header]=\"props.heading\" [subheader]=\"props.description\">\r\n      <ng-template pTemplate=\"header\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"content\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n      </ng-template>\r\n    </p-card>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'plain'\">\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n  </ng-container>\r\n  <ng-template #layoutTypeHeader>\r\n    <div class=\"p-card-header-content\">\r\n      <dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #layoutTypeContent>\r\n    <dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n    <ng-container *ngIf=\"!props.hideContent\">\r\n      <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n      <ng-template #viewTemplate>\r\n        <ng-container *ngFor=\"let sections of field.fieldGroup; let pageIndex = index\">\r\n          <div class=\"repeating-page mt-3 mb-6\">\r\n            <p-panel>\r\n              <ng-template pTemplate=\"content\">\r\n                <div [id]=\"getElementId(RepeaterElementType.TopOfItemContent, pageIndex)\"></div>\r\n                <div class=\"grid\">\r\n                  <div [class]=\"section.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let section of sections.fieldGroup\">\r\n                    <dspx-card-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\"></dspx-card-section-view-mode>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n            </p-panel>\r\n          </div>\r\n        </ng-container>\r\n      </ng-template>\r\n      <ng-template #editTemplate>\r\n        <dspx-table-repeater [repeater]=\"baseTableRepeater\" [renderItemsAsSeparateFieldTypes]=\"true\" (onInitialiseCompleted)=\"onTableRepeaterInitialised($event)\" [repeaterLayout]=\"props.cardSetLayoutOptions?.repeaterLayout\"></dspx-table-repeater>\r\n      </ng-template>\r\n    </ng-container>\r\n    <dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                            [requiresBackButton]=\"props.requiresBackButton\"\r\n                            [backButtonLabel]=\"props.backButtonLabel\"\r\n                            [backButtonTitle]=\"props.backButtonTitle\"\r\n                            [requiresNextButton]=\"props.requiresNextButton\"\r\n                            [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                            [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                            [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                            [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                            [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                            [pageField]=\"field\"\r\n                            [topDividerDisplay]=\"'never'\"\r\n                            [bottomDividerDisplay]=\"'auto'\">\r\n      </dspx-form-navigation>\r\n  </ng-template>\r\n</ng-container>\r\n\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }, { kind: "component", type: i4$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }, { kind: "component", type: FormNavigationFieldType, selector: "dspx-form-navigation", inputs: ["actionButtons", "requiresBackButton", "backButtonLabel", "backButtonTitle", "requiresNextButton", "nextButtonLabel", "nextButtonTitle", "requiresCancelButton", "cancelButtonLabel", "cancelButtonTitle", "pageField", "topDividerDisplay", "bottomDividerDisplay"] }, { kind: "component", type: DspxValidationSummaryComponent, selector: "dspx-validation-summary", inputs: ["pageField"] }, { kind: "component", type: DspxStatusBarComponent, selector: "dspx-status-bar", inputs: ["content"] }, { kind: "component", type: DspxTableRepeaterComponent, selector: "dspx-table-repeater", inputs: ["repeater", "renderItemsAsSeparateFieldTypes", "repeaterLayout"], outputs: ["onInitialiseCompleted"] }, { kind: "component", type: DspxCardSectionViewModeComponent, selector: "dspx-card-section-view-mode" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageRepeatingFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-page-repeating', template: "<ng-container [ngSwitch]=\"props.cardSetLayoutOptions?.layoutType || 'plain'\">\r\n  <ng-container *ngSwitchCase=\"'card'\">\r\n    <p-card [header]=\"props.heading\" [subheader]=\"props.description\">\r\n      <ng-template pTemplate=\"header\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n      </ng-template>\r\n      <ng-template pTemplate=\"content\">\r\n        <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n      </ng-template>\r\n    </p-card>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'plain'\">\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeHeader\"></ng-container>\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n    <dspx-description [text]=\"props.description\"></dspx-description>\r\n    <ng-container *ngTemplateOutlet=\"layoutTypeContent\"></ng-container>\r\n  </ng-container>\r\n  <ng-template #layoutTypeHeader>\r\n    <div class=\"p-card-header-content\">\r\n      <dspx-status-bar *ngIf=\"props.statusBarContent\" [content]=\"props.statusBarContent\"></dspx-status-bar>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #layoutTypeContent>\r\n    <dspx-validation-summary *ngIf=\"props.showValidationSummary\" [pageField]=\"field\"></dspx-validation-summary>\r\n    <ng-container *ngIf=\"!props.hideContent\">\r\n      <ng-container *ngIf=\"props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate\"></ng-container>\r\n      <ng-template #viewTemplate>\r\n        <ng-container *ngFor=\"let sections of field.fieldGroup; let pageIndex = index\">\r\n          <div class=\"repeating-page mt-3 mb-6\">\r\n            <p-panel>\r\n              <ng-template pTemplate=\"content\">\r\n                <div [id]=\"getElementId(RepeaterElementType.TopOfItemContent, pageIndex)\"></div>\r\n                <div class=\"grid\">\r\n                  <div [class]=\"section.props.cardSetLayoutOptions?.gridLayoutStyleClass\" *ngFor=\"let section of sections.fieldGroup\">\r\n                    <dspx-card-section-view-mode [pageConfig]=\"field\" [sectionConfig]=\"section\"></dspx-card-section-view-mode>\r\n                  </div>\r\n                </div>\r\n              </ng-template>\r\n            </p-panel>\r\n          </div>\r\n        </ng-container>\r\n      </ng-template>\r\n      <ng-template #editTemplate>\r\n        <dspx-table-repeater [repeater]=\"baseTableRepeater\" [renderItemsAsSeparateFieldTypes]=\"true\" (onInitialiseCompleted)=\"onTableRepeaterInitialised($event)\" [repeaterLayout]=\"props.cardSetLayoutOptions?.repeaterLayout\"></dspx-table-repeater>\r\n      </ng-template>\r\n    </ng-container>\r\n    <dspx-form-navigation [actionButtons]=\"props.actionButtons\"\r\n                            [requiresBackButton]=\"props.requiresBackButton\"\r\n                            [backButtonLabel]=\"props.backButtonLabel\"\r\n                            [backButtonTitle]=\"props.backButtonTitle\"\r\n                            [requiresNextButton]=\"props.requiresNextButton\"\r\n                            [nextButtonLabel]=\"props.nextButtonLabel\"\r\n                            [nextButtonTitle]=\"props.nextButtonTitle\"\r\n                            [requiresCancelButton]=\"props.requiresCancelButton\"\r\n                            [cancelButtonLabel]=\"props.cancelButtonLabel\"\r\n                            [cancelButtonTitle]=\"props.cancelButtonTitle\"\r\n                            [pageField]=\"field\"\r\n                            [topDividerDisplay]=\"'never'\"\r\n                            [bottomDividerDisplay]=\"'auto'\">\r\n      </dspx-form-navigation>\r\n  </ng-template>\r\n</ng-container>\r\n\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }, { type: SpinnerService }, { type: RepeaterRegistryService }, { type: RepeaterService }, { type: i0.ChangeDetectorRef }] });

class CardSetTabsFieldType extends TabsFieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTabsFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetTabsFieldType, selector: "dspx-card-set-tabs", usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"field.fieldGroup.length === 1; then singleTabTemplate; else multiTabTemplate\"></ng-container>\r\n\r\n<ng-template #singleTabTemplate>\r\n  <formly-field [field]=\"field.fieldGroup[0]\"></formly-field>\r\n</ng-template>\r\n\r\n<ng-template #multiTabTemplate>\r\n  <dspx-tab-set [tabsConfig]=\"field\"></dspx-tab-set>\r\n</ng-template>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxTabSetComponent, selector: "dspx-tab-set", inputs: ["tabsConfig"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTabsFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-tabs', template: "<ng-container *ngIf=\"field.fieldGroup.length === 1; then singleTabTemplate; else multiTabTemplate\"></ng-container>\r\n\r\n<ng-template #singleTabTemplate>\r\n  <formly-field [field]=\"field.fieldGroup[0]\"></formly-field>\r\n</ng-template>\r\n\r\n<ng-template #multiTabTemplate>\r\n  <dspx-tab-set [tabsConfig]=\"field\"></dspx-tab-set>\r\n</ng-template>\r\n" }]
        }] });

class CardSetTabsFlatFieldType extends FieldType {
    constructor(formNavigationService) {
        super();
        this.formNavigationService = formNavigationService;
    }
    getPageConfigs(childConfigs) {
        // Flatten the two-level structure of tabs->subtabs into a one-level array of pages
        const pageConfigs = this.getFlatArrayOfPages(childConfigs);
        // Ensure all pages have no Back/Next buttons, because they are not relevant in this flattened layout
        for (const pageConfig of pageConfigs) {
            pageConfig.props.requiresNextButton = false;
            pageConfig.props.requiresBackButton = false;
        }
        return pageConfigs;
    }
    getFlatArrayOfPages(childConfigs) {
        if (childConfigs.some(childConfig => this.formNavigationService.isTabType(childConfig.type.toString()))) {
            // Child field is a "tab" type => flatten the list of pages under each subtab
            return childConfigs
                .filter(childConfig => childConfig.props.includeInProgress)
                .map(childConfig => childConfig.fieldGroup)
                .reduce((previousGrandChildConfigs, currentGrandChildConfigs) => previousGrandChildConfigs.concat(currentGrandChildConfigs), []);
        }
        else {
            // Child field is a "page" type => just return the list of pages
            return childConfigs;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTabsFlatFieldType, deps: [{ token: FormNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetTabsFlatFieldType, selector: "dspx-card-set-tabs-flat", usesInheritance: true, ngImport: i0, template: "<div class=\"grid\">\r\n  <ng-container *ngFor=\"let pageConfig of getPageConfigs(field.fieldGroup)\">\r\n    <div [class]=\"pageConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass\">\r\n      <formly-field [field]=\"pageConfig\"></formly-field>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetTabsFlatFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-tabs-flat', template: "<div class=\"grid\">\r\n  <ng-container *ngFor=\"let pageConfig of getPageConfigs(field.fieldGroup)\">\r\n    <div [class]=\"pageConfig.props.cardSetLayoutOptions?.gridLayoutStyleClass\">\r\n      <formly-field [field]=\"pageConfig\"></formly-field>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: FormNavigationService }] });

class RelatedEntitySummaryFieldType extends FieldType {
    constructor(formConfigurationService, reportDataService) {
        super();
        this.formConfigurationService = formConfigurationService;
        this.reportDataService = reportDataService;
    }
    getFormConfig() {
        let _tabs = this.reportDataService.requestConfigData.config.fieldGroup[0].fieldGroup;
        return _tabs.filter(i => i.props?.includeInProgress == true);
        // return this.field.parent.parent.parent.parent.fieldGroup;
    }
    getModel() {
        return this.reportDataService.requestResponse.form.tabs;
        //return this.field.parent.parent.parent.parent.model;
    }
    getPageInstanceArray(tabKey, pageKey) {
        let model = this.getModel();
        let instanceCount = model[tabKey]?.[pageKey]?.length;
        instanceCount = instanceCount == null ? 1 : instanceCount;
        return Array(instanceCount).fill(0).map((x, i) => i);
    }
    getSectionInstanceArray(tabKey, pageKey, pageIndex, section) {
        let sectionKey = section.key.toString();
        let model = this.getModel();
        let instanceCount = pageIndex > -1
            ? model[tabKey]?.[pageKey]?.[pageIndex]?.[sectionKey]?.length
            : model[tabKey]?.[pageKey]?.[sectionKey]?.length;
        instanceCount = instanceCount == null ? 1 : instanceCount;
        var sections = Array(instanceCount).fill(0).map((x, i) => i);
        return sections;
    }
    getFieldGroup(page, section) {
        let questions = [];
        let field = section == null ? page : section;
        let recordCount = section == null ? 1 : 6;
        if (field.type === 'page-repeating' || field.type === 'section-repeating') {
            questions = field.fieldArray.fieldGroup;
        }
        else {
            questions = field.fieldGroup;
        }
        if (page["viewDetails"] === "" || page["viewDetails"] === undefined || page["viewDetails"] === false) {
            return questions.slice(0, recordCount);
        }
        return questions;
    }
    showMoreAnswers(page) {
        let sections = [];
        let questions = [];
        const maxSections = 1;
        const maxQuestions = 6;
        if (page.type === 'page-repeating') {
            sections = page.fieldArray.fieldGroup;
        }
        else {
            sections = page.fieldGroup;
        }
        if (sections.length > maxSections) {
            return true;
        }
        for (let s = 0; s < sections.length; s++) {
            if (sections[s].type === 'section-repeating') {
                questions = sections[s].fieldArray.fieldGroup;
            }
            else {
                questions = sections[s].fieldGroup;
            }
            if (questions.length > maxQuestions) {
                return true;
            }
        }
        return false;
    }
    getRepeatingPageHeaderText(config, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        var pageHeader = '';
        var allFieldsInPageHeader = [];
        config.fieldGroup.forEach(f => {
            if (f.props.includeInRepeatingPageHeader && f.props.includeInRepeatingPageHeader === true) {
                allFieldsInPageHeader.push(f);
            }
        });
        if (allFieldsInPageHeader && allFieldsInPageHeader.length > 0) {
            allFieldsInPageHeader.sort(f => f.props.repeatingPageHeaderOrder).forEach(f => {
                var fieldValue = this.getResponse(f, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                pageHeader = pageHeader + fieldValue + ' ';
            });
        }
        return pageHeader == null ? "(No Response)" : pageHeader.trim();
    }
    getRepeatingSectionHeaderText(config, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        var sectionHeader = '';
        var allFieldsInSectionHeader = [];
        config.fieldGroup.forEach(f => {
            if (f.props.includeInRepeatingSectionHeader && f.props.includeInRepeatingSectionHeader === true) {
                allFieldsInSectionHeader.push(f);
            }
        });
        if (allFieldsInSectionHeader && allFieldsInSectionHeader.length > 0) {
            allFieldsInSectionHeader.sort(f => f.props.repeatingSectionHeaderOrder).forEach(f => {
                var fieldValue = this.getResponse(f, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
                sectionHeader = sectionHeader + fieldValue + ' ';
            });
        }
        return sectionHeader.trim();
    }
    getResponse(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let response = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, questionConfig.key.toString());
        //If question uses option sets, convert the response into the text of the option.
        if (questionConfig.props != null && questionConfig.props.optionSet != null
            && questionConfig.props.optionSet.name != null && response != null) {
            let optionSetName = questionConfig.props.optionSet.name;
            //If question uses a dependent option set, determine the option set name.
            let parentQuestionKey = questionConfig.props.optionSet?.parentQuestionKey;
            let parentQuestionResponse = null;
            if (parentQuestionKey) {
                //Note: Dependent option set functionality currently assumes that parent question field is in the same section as the child question field.
                parentQuestionResponse = getRawResponse(this.getModel(), tabKey, pageKey, pageIndex, sectionKey, sectionIndex, parentQuestionKey);
                optionSetName = optionSetName + '-' + parentQuestionKey + '-' + parentQuestionResponse;
            }
            //If the response contains commas and the question is a multi select type field. So we need to concatenate the option text.
            if (response.includes(',') && questionConfig.type == "multiselect") {
                let responseSplit = response.split(',');
                response = '';
                responseSplit.forEach(optionCode => {
                    response = `${response}${response === '' ? '' : ', '} ${this.getOptionText(optionSetName, optionCode.trim())}`;
                });
            }
            else {
                response = this.getOptionText(optionSetName, response);
            }
        }
        //For single checkbox type questions.
        response = response === 'true' ? 'Yes' : response;
        response = response === 'false' ? 'No' : response;
        if (!this.hasResponse(response)) {
            return "(No response)";
        }
        return response;
    }
    /* Checks whether response is emtpy or not
    */
    hasResponse(response) {
        if (typeof response === "boolean") {
            return true;
        }
        else {
            if (((Array.isArray(response) && response.length > 0) || (response && Array.isArray(response) == false))) {
                return true;
            }
        }
        return false;
    }
    getFieldVisibility(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        return !(this.formConfigurationService.hideField(this.reportDataService.requestResponse, questionConfig, pageIndex, sectionIndex));
        // let rootField = this.getFormConfig();
        // let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        // return formControl != null;
    }
    getSectionVisibility(sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        if (sectionConfig.type !== "section-verification") {
            return true;
        }
        if (sectionConfig?.hide === false) {
            return true;
        }
        let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
        let formControl = getSectionFormControl(rootField, sectionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
        return formControl === null || formControl === undefined ? false : true;
    }
    getValidationErrorText(questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex) {
        let errorText = '';
        let validationErrors;
        if (questionConfig.formControl != null && questionConfig.formControl.errors != null) {
            validationErrors = questionConfig.formControl.errors;
        }
        else {
            let rootField = this.field.parent.parent.parent.parent.parent.parent.fieldGroup;
            let formControl = getFormControl(rootField, questionConfig, tabKey, pageKey, pageIndex, sectionKey, sectionIndex);
            if (formControl != null) {
                validationErrors = formControl.errors;
            }
        }
        if (validationErrors != null) {
            const errorKeys = Object.keys(validationErrors);
            if (errorKeys.length > 0) {
                const errorKey = errorKeys[0];
                if (errorKey === 'required' && validationErrors[errorKey] === true
                    && questionConfig.validation != null && questionConfig.validation.messages[errorKey] != null) {
                    errorText = `${questionConfig.props.label}: ${questionConfig.validation.messages[errorKey].toString()}`;
                }
                else if (typeof validationErrors[errorKey] === 'object') {
                    if (questionConfig.validation?.messages[errorKey] != null) {
                        errorText = `${questionConfig.props.label}: ${questionConfig.validation?.messages[errorKey].toString()}`;
                    }
                    else if (validationErrors[errorKey]?.message != null) {
                        errorText = `${questionConfig.props.label}: ${validationErrors[errorKey].message}`;
                    }
                    else if (errorText.length === 0) {
                        errorText = `${questionConfig.props.label}`;
                    }
                }
                else {
                    errorText = `${questionConfig.props.label}: ${errorKey}`;
                }
            }
        }
        return errorText;
    }
    getOptionText(optionSetName, code) {
        let optionText = '';
        let optionSets = this.reportDataService.requestConfigData.optionSets;
        if (optionSets !== null && optionSets !== undefined && optionSetName !== null && optionSetName !== undefined && optionSetName !== ''
            && optionSets[optionSetName] !== undefined && optionSets[optionSetName] !== null) {
            let optionSet = optionSets[optionSetName];
            let option = optionSet.find(o => o.code === code);
            if (option === undefined) {
                optionText = '';
            }
            else {
                optionText = option.text;
            }
        }
        return optionText;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RelatedEntitySummaryFieldType, deps: [{ token: FormConfigurationService }, { token: ReportDataService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RelatedEntitySummaryFieldType, selector: "dspx-form-related-entity-summary", usesInheritance: true, ngImport: i0, template: "  <div class=\"summary-section mt-6\" *ngFor=\"let tab of getFormConfig(); let tabIndex = index; let lastTab = last\">\r\n    <dspx-heading [level]=\"2\" [heading]=\"(tabIndex+1) + '.' + tab.props.label\"></dspx-heading>\r\n    <!-- Page Iteration -->\r\n    <div *ngFor=\"let page of tab.fieldGroup; let lastPage = last\" id=\"summaryPage-{{tab.key}}-{{page.key}}\">\r\n     <ng-container *ngIf=\"page.type !== 'summary-page'\">\r\n      <dspx-heading *ngIf=\"(page.type !== 'summary-page')\" [level]=\"3\" [heading]=\"page.props.label\"></dspx-heading>\r\n     <!-- Page Responses Iteration -->\r\n     <ng-container *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\">\r\n        <!-- Section Iteration -->\r\n        <div *ngFor=\"let section of getFieldGroup(page, null); let lastSection = last\">\r\n          <!-- Section Responses Iteration -->\r\n          <ng-container *ngFor=\"let repeatingSectionIndex of getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section);\">\r\n            <!-- <pre style=\"font-size: 16px\">{{section | json}}</pre> -->\r\n            <ng-container *ngIf=\"section.hide !== true\">\r\n              <ng-container\r\n                *ngIf=\"page.type !== 'page-repeating' && section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; else sectionHeading\">\r\n                <dspx-heading [level]=\"4\" [heading]=\"section.props.label\"></dspx-heading>\r\n              </ng-container>\r\n              <ng-template #sectionHeading>\r\n                <ng-container *ngIf=\"page.type !== 'page-repeating' && section.type !== 'section-verification'\">\r\n                  <dspx-heading [level]=\"4\" [heading]=\"section.props.label\"></dspx-heading>\r\n                  <dspx-description [text]=\"section.props.description\"></dspx-description>\r\n                </ng-container>\r\n              </ng-template>\r\n\r\n              <!--Non-repeating page and non-repeating section-->\r\n              <dl *ngIf=\"page.type === 'page' && (section.type === 'section' || section.type === 'section-verification')\"\r\n                class=\"grid\">\r\n                <div *ngFor=\"let question of getFieldGroup(page,section);\" \r\n                class=\"col-12 md:col-4 mb-3\" [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                      || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false\r\n                      || question.type === 'paragraph'\r\n                      || question.type === 'information'\r\n                      || question.type === 'summary'\r\n                      || question.props.label == null}\">\r\n                  <div>\r\n                    <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                    <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}</dd>\r\n                  </div>\r\n                </div>\r\n              </dl>\r\n\r\n              <!--Repeating page only-->\r\n              <dl\r\n                *ngIf=\"page.type === 'page-repeating' && (section.type === 'section' || section.type === 'section-verification')\"\r\n                class=\"grid\">\r\n                  <ng-container\r\n                    *ngIf=\"section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; then repPageSection; else repPageSectionHeading\">\r\n                  </ng-container>\r\n                  <ng-template #repPageSectionHeading>\r\n                    <ng-container *ngIf=\"section.type !== 'section-verification'; then repPageSection\">\r\n                    </ng-container>\r\n                  </ng-template>\r\n                  <ng-template #repPageSection>\r\n                    <dspx-heading [level]=\"4\" [heading]=\"section.props.label\" class=\"col-12\"></dspx-heading>\r\n                    <ng-container *ngIf=\"{ text: getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1)} as heading\">\r\n                      <dspx-heading *ngIf=\"heading.text.length > 0\" [level]=\"4\" [heading]=\"heading.text\" class=\"col-12\"></dspx-heading>\r\n                    </ng-container>\r\n                    <div *ngFor=\"let question of getFieldGroup(page, section);\" class=\"grid\" [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                                        || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false\r\n                                                        || question.type === 'paragraph'\r\n                                                        || question.type === 'information'\r\n                                                        || question.type === 'summary'\r\n                                                        || question.props.label == null}\" class=\"col-12 md:col-4 mb-3\">\r\n                      <div>\r\n                        <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                        <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}</dd>\r\n                      </div>\r\n                    </div>\r\n                  </ng-template>\r\n              </dl>\r\n\r\n              <!--Repeating section only-->\r\n              <dl *ngIf=\"page.type === 'page' && section.type === 'section-repeating'\" class=\"grid\">\r\n                <ng-container *ngIf=\"{ text: getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, -1, section.key, repeatingSectionIndex)} as heading\">\r\n                  <dspx-heading *ngIf=\"heading.text.length > 0\" [level]=\"4\" [heading]=\"heading.text\" class=\"col-12\"></dspx-heading>\r\n                </ng-container>\r\n                  <div *ngFor=\"let question of getFieldGroup(page,section);\" class=\"col-12 md:col-4 mb-3\" [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                                        || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex) === false \r\n                                                        || question.type === 'paragraph'\r\n                                                        || question.type === 'information'\r\n                                                        || question.type === 'summary'\r\n                                                        || question.props.label == null}\">\r\n                    <div>\r\n                      <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                      <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, -1, section.key, repeatingSectionIndex) }}</dd>\r\n                    </div>\r\n                  </div>\r\n              </dl>\r\n\r\n              <!--Repeating page and repeating section-->\r\n              <dl *ngIf=\"page.type === 'page-repeating' && section.type === 'section-repeating'\" class=\"grid\">\r\n                <dspx-heading [level]=\"4\" [heading]=\"section.props.label\" class=\"col-12\"></dspx-heading>\r\n                    <ng-container *ngIf=\"{ text: getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex)} as heading\">\r\n                      <dspx-heading *ngIf=\"heading.text.length > 0\" [level]=\"4\" [heading]=\"heading.text\" class=\"col-12\"></dspx-heading>\r\n                    </ng-container>\r\n                    <div *ngFor=\"let question of getFieldGroup(page,section);\"class=\"col-12 md:col-4 mb-3\"\r\n                    [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                                          || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex) === false\r\n                                                          || question.type === 'paragraph'\r\n                                                          || question.type === 'information'\r\n                                                          || question.type === 'summary'\r\n                                                          || question.props.label == null}\">\r\n                      <div> \r\n                        <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                        <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key,repeatingSectionIndex) }}</dd>\r\n                      </div>\r\n                    </div>\r\n              </dl>\r\n          </ng-container>\r\n        </ng-container>\r\n        </div>\r\n     </ng-container>  \r\n      <ng-container *ngIf=\"showMoreAnswers(page)\">\r\n        <ng-container *ngTemplateOutlet=\"extensiontemplate\"></ng-container>\r\n      </ng-container>\r\n      <ng-template #extensiontemplate>\r\n        <dl  class=\"grid\">\r\n          <div class=\"col-12\">\r\n            <p-button \r\n              (click)=\"page.viewDetails = !page.viewDetails\" \r\n              [icon]=\"page.viewDetails ? 'pi pi-chevron-up' : 'pi pi-chevron-down'\"\r\n              [label]=\"(page.viewDetails ? 'Hide answers' : 'Show all answers')\"\r\n              [title]=\"(page.viewDetails ? 'Hide answers' : 'Show all answers')\"\r\n              styleClass=\"p-button-secondary\"></p-button>\r\n          </div>\r\n        </dl>\r\n        </ng-template>\r\n\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n\r\n\r\n\r\n", styles: [".p-button{width:100%;margin-bottom:0;padding:0}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i3$1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "raised", "rounded", "text", "plain", "severity", "outlined", "link", "tabindex", "size", "style", "styleClass", "badgeClass", "ariaLabel", "autofocus"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }, { kind: "component", type: DspxDescriptionComponent, selector: "dspx-description", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RelatedEntitySummaryFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-related-entity-summary', template: "  <div class=\"summary-section mt-6\" *ngFor=\"let tab of getFormConfig(); let tabIndex = index; let lastTab = last\">\r\n    <dspx-heading [level]=\"2\" [heading]=\"(tabIndex+1) + '.' + tab.props.label\"></dspx-heading>\r\n    <!-- Page Iteration -->\r\n    <div *ngFor=\"let page of tab.fieldGroup; let lastPage = last\" id=\"summaryPage-{{tab.key}}-{{page.key}}\">\r\n     <ng-container *ngIf=\"page.type !== 'summary-page'\">\r\n      <dspx-heading *ngIf=\"(page.type !== 'summary-page')\" [level]=\"3\" [heading]=\"page.props.label\"></dspx-heading>\r\n     <!-- Page Responses Iteration -->\r\n     <ng-container *ngFor=\"let repeatingPageIndex of getPageInstanceArray(tab.key, page.key);\">\r\n        <!-- Section Iteration -->\r\n        <div *ngFor=\"let section of getFieldGroup(page, null); let lastSection = last\">\r\n          <!-- Section Responses Iteration -->\r\n          <ng-container *ngFor=\"let repeatingSectionIndex of getSectionInstanceArray(tab.key, page.key, repeatingPageIndex, section);\">\r\n            <!-- <pre style=\"font-size: 16px\">{{section | json}}</pre> -->\r\n            <ng-container *ngIf=\"section.hide !== true\">\r\n              <ng-container\r\n                *ngIf=\"page.type !== 'page-repeating' && section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; else sectionHeading\">\r\n                <dspx-heading [level]=\"4\" [heading]=\"section.props.label\"></dspx-heading>\r\n              </ng-container>\r\n              <ng-template #sectionHeading>\r\n                <ng-container *ngIf=\"page.type !== 'page-repeating' && section.type !== 'section-verification'\">\r\n                  <dspx-heading [level]=\"4\" [heading]=\"section.props.label\"></dspx-heading>\r\n                  <dspx-description [text]=\"section.props.description\"></dspx-description>\r\n                </ng-container>\r\n              </ng-template>\r\n\r\n              <!--Non-repeating page and non-repeating section-->\r\n              <dl *ngIf=\"page.type === 'page' && (section.type === 'section' || section.type === 'section-verification')\"\r\n                class=\"grid\">\r\n                <div *ngFor=\"let question of getFieldGroup(page,section);\" \r\n                class=\"col-12 md:col-4 mb-3\" [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                      || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false\r\n                      || question.type === 'paragraph'\r\n                      || question.type === 'information'\r\n                      || question.type === 'summary'\r\n                      || question.props.label == null}\">\r\n                  <div>\r\n                    <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                    <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, -1, section.key, -1) }}</dd>\r\n                  </div>\r\n                </div>\r\n              </dl>\r\n\r\n              <!--Repeating page only-->\r\n              <dl\r\n                *ngIf=\"page.type === 'page-repeating' && (section.type === 'section' || section.type === 'section-verification')\"\r\n                class=\"grid\">\r\n                  <ng-container\r\n                    *ngIf=\"section.type === 'section-verification' && getSectionVisibility(section, tab.key, page.key, repeatingPageIndex, section.key, -1) !== false; then repPageSection; else repPageSectionHeading\">\r\n                  </ng-container>\r\n                  <ng-template #repPageSectionHeading>\r\n                    <ng-container *ngIf=\"section.type !== 'section-verification'; then repPageSection\">\r\n                    </ng-container>\r\n                  </ng-template>\r\n                  <ng-template #repPageSection>\r\n                    <dspx-heading [level]=\"4\" [heading]=\"section.props.label\" class=\"col-12\"></dspx-heading>\r\n                    <ng-container *ngIf=\"{ text: getRepeatingPageHeaderText(section, tab.key, page.key, repeatingPageIndex, section.key, -1)} as heading\">\r\n                      <dspx-heading *ngIf=\"heading.text.length > 0\" [level]=\"4\" [heading]=\"heading.text\" class=\"col-12\"></dspx-heading>\r\n                    </ng-container>\r\n                    <div *ngFor=\"let question of getFieldGroup(page, section);\" class=\"grid\" [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                                        || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, -1) === false\r\n                                                        || question.type === 'paragraph'\r\n                                                        || question.type === 'information'\r\n                                                        || question.type === 'summary'\r\n                                                        || question.props.label == null}\" class=\"col-12 md:col-4 mb-3\">\r\n                      <div>\r\n                        <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                        <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key, -1) }}</dd>\r\n                      </div>\r\n                    </div>\r\n                  </ng-template>\r\n              </dl>\r\n\r\n              <!--Repeating section only-->\r\n              <dl *ngIf=\"page.type === 'page' && section.type === 'section-repeating'\" class=\"grid\">\r\n                <ng-container *ngIf=\"{ text: getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, -1, section.key, repeatingSectionIndex)} as heading\">\r\n                  <dspx-heading *ngIf=\"heading.text.length > 0\" [level]=\"4\" [heading]=\"heading.text\" class=\"col-12\"></dspx-heading>\r\n                </ng-container>\r\n                  <div *ngFor=\"let question of getFieldGroup(page,section);\" class=\"col-12 md:col-4 mb-3\" [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                                        || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex) === false \r\n                                                        || question.type === 'paragraph'\r\n                                                        || question.type === 'information'\r\n                                                        || question.type === 'summary'\r\n                                                        || question.props.label == null}\">\r\n                    <div>\r\n                      <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                      <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, -1, section.key, repeatingSectionIndex) }}</dd>\r\n                    </div>\r\n                  </div>\r\n              </dl>\r\n\r\n              <!--Repeating page and repeating section-->\r\n              <dl *ngIf=\"page.type === 'page-repeating' && section.type === 'section-repeating'\" class=\"grid\">\r\n                <dspx-heading [level]=\"4\" [heading]=\"section.props.label\" class=\"col-12\"></dspx-heading>\r\n                    <ng-container *ngIf=\"{ text: getRepeatingSectionHeaderText(section.fieldArray, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex)} as heading\">\r\n                      <dspx-heading *ngIf=\"heading.text.length > 0\" [level]=\"4\" [heading]=\"heading.text\" class=\"col-12\"></dspx-heading>\r\n                    </ng-container>\r\n                    <div *ngFor=\"let question of getFieldGroup(page,section);\"class=\"col-12 md:col-4 mb-3\"\r\n                    [ngClass]=\"{'display-none': question.props.hideOnSummary === true\r\n                                                          || getFieldVisibility(question, tab.key, page.key, repeatingPageIndex, section.key, repeatingSectionIndex) === false\r\n                                                          || question.type === 'paragraph'\r\n                                                          || question.type === 'information'\r\n                                                          || question.type === 'summary'\r\n                                                          || question.props.label == null}\">\r\n                      <div> \r\n                        <dt class=\"label mb-2\">{{ question.props.label }}</dt>\r\n                        <dd class=\"ml-0 label_wrapper\">{{ getResponse(question, tab.key, page.key, repeatingPageIndex, section.key,repeatingSectionIndex) }}</dd>\r\n                      </div>\r\n                    </div>\r\n              </dl>\r\n          </ng-container>\r\n        </ng-container>\r\n        </div>\r\n     </ng-container>  \r\n      <ng-container *ngIf=\"showMoreAnswers(page)\">\r\n        <ng-container *ngTemplateOutlet=\"extensiontemplate\"></ng-container>\r\n      </ng-container>\r\n      <ng-template #extensiontemplate>\r\n        <dl  class=\"grid\">\r\n          <div class=\"col-12\">\r\n            <p-button \r\n              (click)=\"page.viewDetails = !page.viewDetails\" \r\n              [icon]=\"page.viewDetails ? 'pi pi-chevron-up' : 'pi pi-chevron-down'\"\r\n              [label]=\"(page.viewDetails ? 'Hide answers' : 'Show all answers')\"\r\n              [title]=\"(page.viewDetails ? 'Hide answers' : 'Show all answers')\"\r\n              styleClass=\"p-button-secondary\"></p-button>\r\n          </div>\r\n        </dl>\r\n        </ng-template>\r\n\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n\r\n\r\n\r\n", styles: [".p-button{width:100%;margin-bottom:0;padding:0}\n"] }]
        }], ctorParameters: () => [{ type: FormConfigurationService }, { type: ReportDataService }] });

class LabelFieldType extends FieldType {
    constructor(coreService) {
        super();
        this.coreService = coreService;
    }
    ngOnInit() {
        this.questionValue = this.coreService.getFieldValue(this.field);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LabelFieldType, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: LabelFieldType, selector: "dspx-label", usesInheritance: true, ngImport: i0, template: "<div id=\"{{field.id}}\">{{questionValue}}</div>", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: LabelFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div id=\"{{field.id}}\">{{questionValue}}</div>" }]
        }], ctorParameters: () => [{ type: CoreService }] });

class CardSectionOverviewFieldType extends SectionFieldType {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSectionOverviewFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSectionOverviewFieldType, selector: "dspx-card-section-overview", usesInheritance: true, ngImport: i0, template: "<dspx-heading *ngIf=\"props.label !== ''\" [level]=\"props.headingLevel\" [heading]=\"props.label\" class=\"pt-4\"></dspx-heading>\r\n<div class=\"grid\">\r\n  <ng-container *ngFor=\"let question of field.fieldGroup\">\r\n    <div [class]=\"props.cardSetLayoutOptions?.gridLayoutStyleClass\">\r\n      <div class=\"message\">\r\n        <formly-field [field]=\"question\"></formly-field>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSectionOverviewFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-section-overview', template: "<dspx-heading *ngIf=\"props.label !== ''\" [level]=\"props.headingLevel\" [heading]=\"props.label\" class=\"pt-4\"></dspx-heading>\r\n<div class=\"grid\">\r\n  <ng-container *ngFor=\"let question of field.fieldGroup\">\r\n    <div [class]=\"props.cardSetLayoutOptions?.gridLayoutStyleClass\">\r\n      <div class=\"message\">\r\n        <formly-field [field]=\"question\"></formly-field>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n" }]
        }] });

class CardSetPageInfoFieldType extends PageFieldType {
    actionButtonClick(actionButton) {
        actionButton.onClick();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageInfoFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetPageInfoFieldType, selector: "dspx-card-set-page-info", usesInheritance: true, ngImport: i0, template: "<p-messages [severity]=\"props.severity\">\r\n  <ng-template pTemplate>\r\n    <div class=\"flex md:justify-content-between align-items-center\" style=\"width: 100%\">\r\n      <div class=\"font-bold\" style=\"font-size: medium;\"><i class=\"pi pi-fw pi-info-circle mr-2\"></i>{{props.description}}</div>\r\n      <ng-container *ngIf=\"props.actionButtons\">\r\n        <button pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  class=\"p-button-rounded p-butotn-text\"\r\n                  [label]=\"props.actionButtons.label\"\r\n                  [title]=\"props.actionButtons.label\"\r\n                  [icon]=\"props.actionButtons.icon\"\r\n                  [disabled]=\"props.actionButtons.disabled\"\r\n                  (click)=\"actionButtonClick(props.actionButtons)\"\r\n                  [id]=\"field.key + '-' + props.actionButtons.code\">\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n</p-messages>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: Messages, selector: "p-messages", inputs: ["value", "closable", "style", "styleClass", "enableService", "key", "escape", "severity", "showTransitionOptions", "hideTransitionOptions"], outputs: ["valueChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageInfoFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-page-info', template: "<p-messages [severity]=\"props.severity\">\r\n  <ng-template pTemplate>\r\n    <div class=\"flex md:justify-content-between align-items-center\" style=\"width: 100%\">\r\n      <div class=\"font-bold\" style=\"font-size: medium;\"><i class=\"pi pi-fw pi-info-circle mr-2\"></i>{{props.description}}</div>\r\n      <ng-container *ngIf=\"props.actionButtons\">\r\n        <button pButton\r\n                  pRipple\r\n                  type=\"button\"\r\n                  class=\"p-button-rounded p-butotn-text\"\r\n                  [label]=\"props.actionButtons.label\"\r\n                  [title]=\"props.actionButtons.label\"\r\n                  [icon]=\"props.actionButtons.icon\"\r\n                  [disabled]=\"props.actionButtons.disabled\"\r\n                  (click)=\"actionButtonClick(props.actionButtons)\"\r\n                  [id]=\"field.key + '-' + props.actionButtons.code\">\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n</p-messages>\r\n" }]
        }] });

class CardSetPageListFieldType extends PageFieldType {
    buttonGroupClick(buttonGroupItem) {
        buttonGroupItem.command();
    }
    actionButtonClick(actionButton) {
        actionButton.onClick();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageListFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetPageListFieldType, selector: "dspx-card-set-page-list", usesInheritance: true, ngImport: i0, template: "<div class=\"card widget-contacts\" style=\"height: 100%\">\r\n  <div class=\"flex align-items-center justify-content-between mb-4\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n    <ng-container *ngIf=\"props.actionButtons\">\r\n      <button pButton\r\n                pRipple\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"props.actionButtons.label\"\r\n                [title]=\"props.actionButtons.label\"\r\n                [icon]=\"props.actionButtons.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"actionButtonClick(props.actionButtons)\"\r\n                [id]=\"field.key + '-' + props.actionButtons.code\">\r\n      </button>\r\n      <ng-container *ngFor=\"let bgi of props.actionButtons.buttonGroupItems\">\r\n        <button pButton\r\n                pRipple\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"bgi.label\"\r\n                [title]=\"bgi.label\"\r\n                [icon]=\"bgi.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"buttonGroupClick(bgi)\"\r\n                [id]=\"field.key + '-' + bgi.code\">\r\n        </button>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n  <div *ngFor=\"let section of field.fieldGroup\">\r\n    <formly-field [field]=\"section\"></formly-field>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-page-list', template: "<div class=\"card widget-contacts\" style=\"height: 100%\">\r\n  <div class=\"flex align-items-center justify-content-between mb-4\">\r\n    <dspx-heading [level]=\"props.headingLevel\" [heading]=\"props.heading\"></dspx-heading>\r\n    <ng-container *ngIf=\"props.actionButtons\">\r\n      <button pButton\r\n                pRipple\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"props.actionButtons.label\"\r\n                [title]=\"props.actionButtons.label\"\r\n                [icon]=\"props.actionButtons.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"actionButtonClick(props.actionButtons)\"\r\n                [id]=\"field.key + '-' + props.actionButtons.code\">\r\n      </button>\r\n      <ng-container *ngFor=\"let bgi of props.actionButtons.buttonGroupItems\">\r\n        <button pButton\r\n                pRipple\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"bgi.label\"\r\n                [title]=\"bgi.label\"\r\n                [icon]=\"bgi.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"buttonGroupClick(bgi)\"\r\n                [id]=\"field.key + '-' + bgi.code\">\r\n        </button>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n  <div *ngFor=\"let section of field.fieldGroup\">\r\n    <formly-field [field]=\"section\"></formly-field>\r\n  </div>\r\n</div>\r\n" }]
        }] });

class CardSetPageOverviewFieldType extends PageFieldType {
    evalCondition(expression) {
        if (expression === null || expression === undefined) {
            return true;
        }
        if (typeof expression === 'function') {
            return expression.apply(null, null);
        }
        else if (typeof expression === 'string') {
            return Function(null, `return ${expression};`);
        }
        else {
            return expression ? true : false;
        }
    }
    buttonGroupClick(buttonGroupItem) {
        buttonGroupItem.command();
    }
    actionButtonClick(actionButton) {
        actionButton.onClick();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageOverviewFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardSetPageOverviewFieldType, selector: "dspx-card-set-page-overview", usesInheritance: true, ngImport: i0, template: "<div class=\"card widget-messages\" style=\"height: 100%\">\r\n  <div class=\"flex align-items-center justify-content-between mb-4\">\r\n    <dspx-heading *ngIf=\"props.heading !== ''\" [level]=\"props.headingLevel\" [heading]=\"props.heading\" class=\"pt-4\"></dspx-heading>\r\n    <div *ngIf=\"props.actionButtons\">\r\n      <button pButton\r\n                pRipple\r\n                *ngIf=\"evalCondition(props.actionButtons.condition)\"\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"props.actionButtons.label\"\r\n                [title]=\"props.actionButtons.label\"\r\n                [icon]=\"props.actionButtons.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"actionButtonClick(props.actionButtons)\"\r\n                [id]=\"field.key + '-' + props.actionButtons.code\">\r\n      </button>\r\n      <ng-container *ngFor=\"let bgi of props.actionButtons.buttonGroupItems\">\r\n        <button pButton\r\n                pRipple\r\n                *ngIf=\"evalCondition(bgi.condition)\"\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"bgi.label\"\r\n                [title]=\"bgi.label\"\r\n                [icon]=\"bgi.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"buttonGroupClick(bgi)\"\r\n                [id]=\"field.key + '-' + bgi.code\">\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n  <div *ngFor=\"let section of field.fieldGroup; let firstSection = first; let lastSection = last;\">\r\n    <formly-field [field]=\"section\"></formly-field>\r\n    <div *ngIf=\"!lastSection\">\r\n      <hr />\r\n    </div>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i1$3.FormlyField, selector: "formly-field", inputs: ["field"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: DspxHeadingComponent, selector: "dspx-heading", inputs: ["heading", "level"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSetPageOverviewFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-card-set-page-overview', template: "<div class=\"card widget-messages\" style=\"height: 100%\">\r\n  <div class=\"flex align-items-center justify-content-between mb-4\">\r\n    <dspx-heading *ngIf=\"props.heading !== ''\" [level]=\"props.headingLevel\" [heading]=\"props.heading\" class=\"pt-4\"></dspx-heading>\r\n    <div *ngIf=\"props.actionButtons\">\r\n      <button pButton\r\n                pRipple\r\n                *ngIf=\"evalCondition(props.actionButtons.condition)\"\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"props.actionButtons.label\"\r\n                [title]=\"props.actionButtons.label\"\r\n                [icon]=\"props.actionButtons.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"actionButtonClick(props.actionButtons)\"\r\n                [id]=\"field.key + '-' + props.actionButtons.code\">\r\n      </button>\r\n      <ng-container *ngFor=\"let bgi of props.actionButtons.buttonGroupItems\">\r\n        <button pButton\r\n                pRipple\r\n                *ngIf=\"evalCondition(bgi.condition)\"\r\n                type=\"button\"\r\n                class=\"p-button-rounded p-button-outlined\"\r\n                [label]=\"bgi.label\"\r\n                [title]=\"bgi.label\"\r\n                [icon]=\"bgi.icon\"\r\n                [disabled]=\"props.actionButtons.disabled\"\r\n                (click)=\"buttonGroupClick(bgi)\"\r\n                [id]=\"field.key + '-' + bgi.code\">\r\n        </button>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n  <div *ngFor=\"let section of field.fieldGroup; let firstSection = first; let lastSection = last;\">\r\n    <formly-field [field]=\"section\"></formly-field>\r\n    <div *ngIf=\"!lastSection\">\r\n      <hr />\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
        }] });

class ListFieldType extends FieldArrayType {
    isReadonly() {
        return (this.props.access && this.props.access === 'R');
    }
    getActionButtonTitle(label, record) {
        return label + ' ' + record.text;
    }
    isActionButtonVisible(record, actionButton) {
        return record.actions
            && record.actions[actionButton.type] !== null
            && record.actions[actionButton.type] !== undefined
            && record.actions[actionButton.type] === true;
    }
    actionButtonClicked(buttonType, record) {
        var actionButtonEvent = {
            field: this.field,
            type: buttonType,
            data: record
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(actionButtonEvent);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ListFieldType, selector: "dspx-list", usesInheritance: true, ngImport: i0, template: "<ul>\r\n    <li *ngFor=\"let item of model\" class=\"clearfix\">\r\n        <div class=\"contact-info\">\r\n            <span class=\"name\">{{item.text}}</span>\r\n            <span class=\"location\">{{item.description}}</span>\r\n        </div>\r\n        <div class=\"contact-actions\">\r\n            <span class=\"connection-status\">{{item.status}}</span>\r\n            <ng-container *ngFor=\"let actionButton of props.actionButtons\" >\r\n              <button *ngIf=isActionButtonVisible(item,actionButton) pButton pRipple type=\"button\" [title]=\"getActionButtonTitle(actionButton.label,item)\" [disabled] = \"isReadonly()\" class=\"p-button-rounded p-button-text pull-right\" [icon]=\"actionButton.icon\" (click)=\"actionButtonClicked(actionButton.type, item)\"></button>\r\n            </ng-container>\r\n        </div>\r\n    </li>\r\n</ul>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul>\r\n    <li *ngFor=\"let item of model\" class=\"clearfix\">\r\n        <div class=\"contact-info\">\r\n            <span class=\"name\">{{item.text}}</span>\r\n            <span class=\"location\">{{item.description}}</span>\r\n        </div>\r\n        <div class=\"contact-actions\">\r\n            <span class=\"connection-status\">{{item.status}}</span>\r\n            <ng-container *ngFor=\"let actionButton of props.actionButtons\" >\r\n              <button *ngIf=isActionButtonVisible(item,actionButton) pButton pRipple type=\"button\" [title]=\"getActionButtonTitle(actionButton.label,item)\" [disabled] = \"isReadonly()\" class=\"p-button-rounded p-button-text pull-right\" [icon]=\"actionButton.icon\" (click)=\"actionButtonClicked(actionButton.type, item)\"></button>\r\n            </ng-container>\r\n        </div>\r\n    </li>\r\n</ul>\r\n" }]
        }] });

class MessageListFieldType extends FieldArrayType {
    isReadonly() {
        return (this.props.access && this.props.access === 'R');
    }
    isActionButtonVisible(record, actionButton) {
        return record.actions
            && record.actions[actionButton.type] !== null
            && record.actions[actionButton.type] !== undefined
            && record.actions[actionButton.type] === true;
    }
    getActionButtonTitle(label, record) {
        return label + ' message from ' + record.from + ' sent on ' + record.date;
    }
    actionButtonClicked(buttonType, record) {
        var actionButtonEvent = {
            field: this.field,
            type: buttonType,
            data: record
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(actionButtonEvent);
        }
    }
    getIcon(record) {
        return record.isRead ? 'pi pi-bookmark' : 'pi pi-bookmark-fill';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MessageListFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: MessageListFieldType, selector: "dspx-message-list", usesInheritance: true, ngImport: i0, template: "<div class=\"flex-row\">\r\n    <div *ngFor=\"let item of model\" class=\"message-box\">\r\n        <div class=\"message\">\r\n\r\n            <p-avatar [icon]=\"getIcon(item)\" size=\"large\" shape=\"circle\" class=\"messager-img\"></p-avatar>\r\n\r\n            <div class=\"messager\">{{item.from}}\r\n                <!-- <i class=\"pi pi-clock offline\"></i> -->\r\n                <span class=\"date pull-right\">{{item.date | date: longDate}}</span>\r\n            </div>\r\n\r\n            <div class=\"message-text\">{{item.shortMessage}}\r\n              <!-- <button pButton class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-directions\"></button>\r\n              <button pButton class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-trash\"></button> -->\r\n              <ng-container *ngFor=\"let actionButton of props.actionButtons\" >\r\n                <button *ngIf=isActionButtonVisible(item,actionButton) pButton pRipple type=\"button\" [title]=\"getActionButtonTitle(actionButton.label,item)\" [disabled] = \"isReadonly()\" class=\"p-button-rounded p-button-text pull-right\" [icon]=\"actionButton.icon\" (click)=\"actionButtonClicked(actionButton.type, item)\"></button>\r\n              </ng-container>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n    </div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i3$b.Avatar, selector: "p-avatar", inputs: ["label", "icon", "image", "size", "shape", "style", "styleClass", "ariaLabel", "ariaLabelledBy"], outputs: ["onImageError"] }, { kind: "pipe", type: i2.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: MessageListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-message-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flex-row\">\r\n    <div *ngFor=\"let item of model\" class=\"message-box\">\r\n        <div class=\"message\">\r\n\r\n            <p-avatar [icon]=\"getIcon(item)\" size=\"large\" shape=\"circle\" class=\"messager-img\"></p-avatar>\r\n\r\n            <div class=\"messager\">{{item.from}}\r\n                <!-- <i class=\"pi pi-clock offline\"></i> -->\r\n                <span class=\"date pull-right\">{{item.date | date: longDate}}</span>\r\n            </div>\r\n\r\n            <div class=\"message-text\">{{item.shortMessage}}\r\n              <!-- <button pButton class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-directions\"></button>\r\n              <button pButton class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-trash\"></button> -->\r\n              <ng-container *ngFor=\"let actionButton of props.actionButtons\" >\r\n                <button *ngIf=isActionButtonVisible(item,actionButton) pButton pRipple type=\"button\" [title]=\"getActionButtonTitle(actionButton.label,item)\" [disabled] = \"isReadonly()\" class=\"p-button-rounded p-button-text pull-right\" [icon]=\"actionButton.icon\" (click)=\"actionButtonClicked(actionButton.type, item)\"></button>\r\n              </ng-container>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n    </div>\r\n</div>\r\n" }]
        }] });

class DisplayFieldType extends FieldType {
    constructor(coreService) {
        super();
        this.coreService = coreService;
    }
    ngOnInit() {
        this.questionValue = this.coreService.getFieldValue(this.field);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisplayFieldType, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DisplayFieldType, selector: "dspx-display", usesInheritance: true, ngImport: i0, template: "<div class=\"message-text\">{{props.label}}</div>\r\n<div class=\"messager\">{{questionValue}}</div>\r\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DisplayFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-display', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"message-text\">{{props.label}}</div>\r\n<div class=\"messager\">{{questionValue}}</div>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }] });

class DocumentListFieldType extends FieldArrayType {
    constructor(coreService, fileService, fileSaverService, dataService, spinnerService, dialogService, zone, cd, imageCompress) {
        super();
        this.coreService = coreService;
        this.fileService = fileService;
        this.fileSaverService = fileSaverService;
        this.dataService = dataService;
        this.spinnerService = spinnerService;
        this.dialogService = dialogService;
        this.zone = zone;
        this.cd = cd;
        this.imageCompress = imageCompress;
        this.dialogClass = 'dialog';
        this.newlyAddedFiles = [];
        this.emptyMessageText = 'No documents found.';
        this.acceptedFileTypes = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,image/*,.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
        this.invalidFileTypeMessageDetail = 'Supported file types are MS Word Documents, MS Excel Workbooks, MS PowerPoint Presentations, PDFs, and Images.';
        this.fileLimit = null;
        this.showDownloadButton = true;
        this.showRemoveButton = true;
        this.onlyNewFilesCanBeRemoved = false;
        this.titlePlaceholder = 'Please enter a title';
        this.enableTitle = false;
        this.titleRequired = false;
        this.titleForm = new FormGroup({});
        this.title = {};
        this.titleOptions = {};
        this.titleFormFields = [];
    }
    ngOnInit() {
        this.setModelForDataView();
        this.fieldKey = this.field.key.toString();
        this.formIdentifier = this.coreService.fileUploadFormIdentifiers[this.fieldKey];
        this.titleFieldKey = this.fieldKey + '_documentListTitle';
        if (this.props.listOptions) {
            this.enableTitle = this.props.listOptions.enableTitle
                ? this.props.listOptions.enableTitle
                : false;
            this.titleRequired = this.props.listOptions.titleRequired
                ? this.props.listOptions.titleRequired
                : false;
        }
        if (this.enableTitle) {
            this.uploadText = 'Upload File';
            this.dropFileText = 'Drop or select file';
        }
        else {
            this.uploadText = 'Upload Files';
            this.dropFileText = 'Drop or select files';
        }
        if (this.props.fileUploadOptions) {
            this.fileLimit = this.props.fileUploadOptions.fileLimit
                ? this.props.fileUploadOptions.fileLimit
                : undefined;
            this.maxFileSize = this.props.fileUploadOptions.maxFileSize
                ? this.props.fileUploadOptions.maxFileSize
                : 10485760;
            this.auto = !!this.props.fileUploadOptions.auto;
            this.acceptedFileTypes = this.props.fileUploadOptions.acceptedFileTypes
                ? this.props.fileUploadOptions.acceptedFileTypes
                : this.acceptedFileTypes;
            this.invalidFileTypeMessageDetail = this.props.fileUploadOptions.invalidFileTypeMessage
                ? this.props.fileUploadOptions.invalidFileTypeMessage
                : this.invalidFileTypeMessageDetail;
            this.showDownloadButton = this.props.fileUploadOptions.showDownloadButton != null
                ? this.props.fileUploadOptions.showDownloadButton
                : this.showDownloadButton;
            this.showRemoveButton = this.props.fileUploadOptions.showRemoveButton != null
                ? this.props.fileUploadOptions.showRemoveButton
                : this.showRemoveButton;
            this.onlyNewFilesCanBeRemoved = this.props.fileUploadOptions.onlyNewFilesCanBeRemoved != null
                ? this.props.fileUploadOptions.onlyNewFilesCanBeRemoved
                : this.onlyNewFilesCanBeRemoved;
        }
        this.titleFormFields.push({
            key: this.titleFieldKey,
            type: 'input',
            props: {
                label: 'Title',
                placeholder: 'Please enter a title for the document',
                description: 'Title',
                required: this.titleRequired,
            },
            validation: {
                messages: {
                    required: 'Please enter a title for the document.'
                }
            }
        });
    }
    getDocumentIcon(file) {
        const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'bmp':
                return 'pi pi-image';
            case 'doc':
            case 'docx':
                return 'pi pi-file-word';
            case 'xls':
            case 'xlsx':
            case 'csv':
                return 'pi pi-file-excel';
            case 'pdf':
                return 'pi pi-file-pdf';
            default:
                return 'pi pi-file';
        }
    }
    downloadButtonClicked(file) {
        if (file != null && file.canDownload) {
            this.fileService.download(this.formIdentifier, file.id)
                .pipe(take(1))
                .subscribe({
                next: (response) => {
                    const dispositionHeader = response.headers.get('content-disposition');
                    if (!dispositionHeader) {
                        throw new Error('content-disposition header is not found');
                    }
                    const fileName = file.name != null
                        ? file.name
                        : this.getContentFileName(dispositionHeader);
                    this.fileSaverService.save(response.body, fileName);
                },
                error: (error) => {
                    console.log('File download error: ', error);
                },
                complete: () => {
                    console.log('File download completed');
                },
            });
        }
    }
    removeButtonClicked(file) {
        if (file != null && this.field.model != null) {
            if (!!file.id) {
                this.fileToDelete = file;
                this.activeDialog = 'confirmDocumentDeletion';
                this.dialogService
                    .showConfirm('confirmDocumentDeletion')
                    .pipe(take(1))
                    .subscribe(data => {
                    switch (data) {
                        case DialogResult.ACCEPTED: {
                            console.log('DialogResult.ACCEPTED');
                            this.spinnerService.showSpinner();
                            this.deleteDialogSubmitted(file);
                            break;
                        }
                        case DialogResult.REJECTED: {
                            console.log('DialogResult.REJECTED');
                            break;
                        }
                    }
                });
            }
        }
    }
    isReadonly() {
        return (this.props.access && this.props.access === 'R');
    }
    isActionButtonVisible(file, actionButton) {
        return file.actions
            && file.actions[actionButton.type] !== null
            && file.actions[actionButton.type] !== undefined
            && file.actions[actionButton.type] === true;
    }
    getActionButtonTitle(label, file) {
        return label + ' ' + file.name;
    }
    actionButtonClicked(buttonType, file) {
        const actionButtonEvent = {
            type: buttonType,
            data: file
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(this.field, actionButtonEvent);
        }
    }
    uploadFiles($event) {
        if (this.titleRequired && !this.title[this.titleFieldKey]) {
            this.titleFormFields.forEach(field => {
                markChildControlsAsTouched(field.formControl);
            });
        }
        else {
            if ($event?.files != null) {
                const compressImages = this.field.props.fileUploadOptions?.compressImages ?? false;
                const compressImageRatio = this.field.props.fileUploadOptions?.compressImageRatio ?? 100;
                const compressImageJpgQuality = this.field.props.fileUploadOptions?.compressImageJpgQuality ?? 50;
                const compressImageMaxWidth = this.field.props.fileUploadOptions?.compressImageMaxWidth ?? 0;
                const compressImageMaxHeight = this.field.props.fileUploadOptions?.compressImageMaxHeight ?? 0;
                for (const file of $event.files) {
                    this.spinnerService.showSpinner();
                    if ((file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp')
                        && compressImages) {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            const originalDataUrl = reader.result.toString();
                            this.imageCompress
                                .compressFile(originalDataUrl, DOC_ORIENTATION.Default, compressImageRatio, compressImageJpgQuality, compressImageMaxWidth, compressImageMaxHeight)
                                .then(async (compressedDataUrl) => {
                                this.createFileThenUpload(compressedDataUrl, file.name);
                            });
                        };
                    }
                    // Not an image file that can be compressed, just upload.
                    else {
                        this.uploadFile(file);
                    }
                }
            }
        }
    }
    isNewlyAddedFile(fileId) {
        return this.newlyAddedFiles.findIndex(x => x.id === fileId) !== -1;
    }
    getContentFileName(contentDispositionHeader) {
        const parts = contentDispositionHeader.split(';');
        const filename = parts[1].split('=')[1];
        return filename.replace(/['"]+/g, '');
    }
    deleteDialogSubmitted(file) {
        switch (this.activeDialog) {
            case 'confirmDocumentDeletion':
                this.fileService.remove(this.formIdentifier, this.fileToDelete.id)
                    .pipe(take(1))
                    .subscribe({
                    next: (response) => {
                        // Model management
                        const indexOfRemovedFile = this.model.findIndex(x => x.id === this.fileToDelete.id);
                        this.remove(indexOfRemovedFile);
                        this.setModelForDataView();
                        this.dialogService.showDialog('documentDeletionSuccess');
                    },
                    error: (error) => {
                        this.spinnerService.hideSpinner();
                        console.log('File remove error: ', error);
                    },
                    complete: () => {
                        this.spinnerService.hideSpinner();
                    }
                });
                break;
        }
    }
    async createFileThenUpload(dataUrl, fileName) {
        const blob = await (await fetch(dataUrl)).blob();
        const file = new File([blob], fileName);
        this.uploadFile(file);
    }
    uploadFile(file) {
        this.fileService.upload(this.formIdentifier, file, this.title[this.titleFieldKey], this.field.key.toString())
            .pipe(take(1), map(id => {
            return {
                id,
                file
            };
        }))
            .subscribe({
            next: (fileData) => {
                if (fileData != null) {
                    const fileUploadOnCompleteCallBackMethod = this.field.props.fileUploadOptions?.fileUploadOnComplete;
                    if (fileUploadOnCompleteCallBackMethod != null) {
                        var result = this.coreService.applicationFunctions[fileUploadOnCompleteCallBackMethod](file, fileData.id);
                        if (result instanceof Observable) {
                            result.subscribe((data) => {
                                this.updateModelAndUploadedFilesWith(fileData);
                            });
                        }
                        else {
                            this.updateModelAndUploadedFilesWith(fileData);
                        }
                    }
                    else {
                        this.updateModelAndUploadedFilesWith(fileData);
                    }
                    ;
                }
            },
            error: (error) => {
                this.spinnerService.hideSpinner();
                console.log(`${file.name} upload error: `, error);
            },
            complete: () => {
                this.spinnerService.hideSpinner();
            }
        });
    }
    updateModelAndUploadedFilesWith(fileData) {
        let hasCustomActionButton = false;
        if (this.props.actionButtons) {
            hasCustomActionButton = this.props.actionButtons.findIndex(x => x.type === "custom") > -1;
        }
        this.add(null, {
            name: fileData.file.name,
            title: this.title[this.titleFieldKey],
            id: fileData.id,
            canDownload: this.showDownloadButton,
            canDelete: this.showRemoveButton,
            isNewlyUploaded: true,
            actions: {
                custom: hasCustomActionButton
            }
        });
        this.setModelForDataView();
        this.newlyAddedFiles.push({ name: fileData.file.name, id: fileData.id });
    }
    setModelForDataView() {
        if (this.model != undefined) {
            //Setting this fires change detection
            this.modelForDataview = [...this.model];
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DocumentListFieldType, deps: [{ token: CoreService }, { token: FileService }, { token: i2$4.FileSaverService }, { token: DataService }, { token: SpinnerService }, { token: DialogService }, { token: i0.NgZone }, { token: i0.ChangeDetectorRef }, { token: i4$5.NgxImageCompressService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DocumentListFieldType, selector: "dspx-document-list", usesInheritance: true, ngImport: i0, template: "<p-dataView #dv [value]=\"modelForDataview\" [rows]=\"props.listOptions.rowsPerPage\"\r\n  [rowsPerPageOptions]=\"props.listOptions.rowsPerPageOptions\" [paginator]=\"props.listOptions.paginator\"\r\n  [emptyMessage]=\"emptyMessageText\">\r\n  <ng-template *ngIf=\"props.listOptions.allowUpload\" pTemplate=\"header\">\r\n    <ng-container *ngIf=\"props.listOptions.allowUpload\">\r\n      <p-fileUpload #fileUploader name=\"demo[]\" url=\"./upload.php\" [accept]=\"acceptedFileTypes\"\r\n        (onUpload)=\"uploadFiles($event)\" [customUpload]=\"true\"\r\n        [invalidFileTypeMessageDetail]=\"invalidFileTypeMessageDetail\" [maxFileSize]=\"maxFileSize\"\r\n        [fileLimit]=\"props.listOptions.enableTitle ? 1 : fileLimit\" [multiple]=\"!props.listOptions.enableTitle\"\r\n        (onSelect)=\"uploadFiles($event)\" [showUploadButton]=\"false\" [showCancelButton]=\"false\" [auto]=\"auto\"\r\n        class=\"w-full\">\r\n        <ng-template pTemplate=\"content\">\r\n          <div *ngIf=\"props.listOptions.enableTitle\" class=\"flex flex-column gap-2\">\r\n            <form [formGroup]=\"titleForm\">\r\n              <formly-form [model]=\"title\" [fields]=\"titleFormFields\" [options]=\"titleOptions\"\r\n                [form]=\"titleForm\"></formly-form>\r\n            </form>\r\n          </div>\r\n          <div class=\"w-full py-3\" style=\"cursor: copy\" (click)=\"fileUploader.advancedFileInput.nativeElement.click()\">\r\n            <div class=\"h-full flex flex-column justify-content-center align-items-center\">\r\n              <i class=\"pi pi-upload text-900 text-2xl mb-3\"></i>\r\n              <span class=\"font-bold text-900 text-xl mb-3\">{{uploadText}}</span>\r\n              <span class=\"font-medium text-600 text-md text-center\">{{dropFileText}}</span>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </p-fileUpload>\r\n    </ng-container>\r\n    <div class=\"clearfix\"></div>\r\n  </ng-template>\r\n  <ng-template *ngIf=\"!props.listOptions.isCompactMode\" let-files pTemplate=\"list\">\r\n    <div *ngFor=\"let file of files\" class=\"message\">\r\n      <p-avatar [icon]=\"getDocumentIcon(file)\" size=\"large\" class=\"messager-img\"></p-avatar>\r\n      <div class=\"messager\">{{this.enableTitle ? (file.title!== undefined ? file.title + \" \" : \"\") +\"(\"+file.name+\")\" :\r\n        file.name }}\r\n        <span *ngIf=\"file.createdDate || file.createdBy\" class=\"date pull-right\">\r\n          {{file.createdBy}} {{file.createdDate && file.createdBy ? ' (' : '' }}\r\n          {{file.createdDate | date: longDate}} {{file.createdDate && file.createdBy ? ')' : '' }}</span>\r\n      </div>\r\n      <div class=\"message-text\">{{file.shortMessage}}\r\n        <button *ngIf=\"file.canDownload\" [title]=\"getActionButtonTitle('Download',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-download\"\r\n          (click)=\"downloadButtonClicked(file)\"></button>\r\n        <button *ngIf=\"file.canDelete\" [title]=\"getActionButtonTitle('Delete',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-trash\"\r\n          (click)=\"removeButtonClicked(file)\"></button>\r\n        <ng-container *ngFor=\"let actionButton of props.actionButtons\">\r\n          <button *ngIf=isActionButtonVisible(file,actionButton) pButton pRipple type=\"button\"\r\n            [title]=\"getActionButtonTitle(actionButton.label,file)\" [disabled]=\"isReadonly()\"\r\n            class=\"p-button-rounded p-button-text pull-right\" [icon]=\"actionButton.icon\"\r\n            (click)=\"actionButtonClicked(actionButton.type, file)\"></button>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </ng-template>\r\n\r\n  <ng-template *ngIf=\"props.listOptions.isCompactMode\" let-files pTemplate=\"list\">\r\n    <div *ngFor=\"let file of files\" class=\"message border-1 mb-3 compact\">\r\n      <p-avatar [icon]=\"getDocumentIcon(file)\" size=\"large\" class=\"messager-img\"></p-avatar>\r\n      <div class=\"messager\">{{file.name}}</div>\r\n      <div *ngIf=\"file.createdDate\" class=\"message-text\">\r\n        {{file.createdDate | date: longDate}}\r\n      </div>\r\n      <div class=\"message-text\">\r\n        <button *ngIf=\"file.canDownload\" [title]=\"getActionButtonTitle('Download',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text\" icon=\"pi pi-download\" (click)=\"downloadButtonClicked(file)\"></button>\r\n        <button *ngIf=\"file.canDelete\" [title]=\"getActionButtonTitle('Delete',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text\" icon=\"pi pi-trash\" (click)=\"removeButtonClicked(file)\"></button>\r\n        <ng-container *ngFor=\"let actionButton of props.actionButtons\">\r\n          <button *ngIf=isActionButtonVisible(file,actionButton) pButton pRipple type=\"button\"\r\n            [title]=\"getActionButtonTitle(actionButton.label,file)\" [disabled]=\"isReadonly()\"\r\n            class=\"p-button-rounded p-button-text\" [icon]=\"actionButton.icon\"\r\n            (click)=\"actionButtonClicked(actionButton.type, file)\"></button>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n  </ng-template>\r\n  <ng-template #emptyListTemplate>\r\n    <div class=\"message-box\">\r\n      <div class=\"messager\">No documents found.</div>\r\n    </div>\r\n  </ng-template>\r\n</p-dataView>", styles: [":host ::ng-deep .p-fileupload-buttonbar{display:none}:host ::ng-deep .p-fileupload-files{display:none}:host ::ng-deep .w-full{width:100%!important}:host ::ng-deep .py-3{padding-top:1rem!important;padding-bottom:1rem!important}:host ::ng-deep .h-full{height:100%!important}:host ::ng-deep .align-items-center{align-items:center!important}:host ::ng-deep .justify-content-center{justify-content:center!important}:host ::ng-deep .flex-column{flex-direction:column!important}:host ::ng-deep .flex{display:flex!important}:host ::ng-deep .p-dataview-content .message{padding-top:.8rem;margin-top:5px;margin-bottom:0;border:1px solid #dee2e6;border-width:0 0 1px 0}:host ::ng-deep .p-dataview-content .compact{padding-left:.8rem;border-radius:10px}\n"], dependencies: [{ kind: "component", type: i1$3.FormlyForm, selector: "formly-form", inputs: ["form", "model", "fields", "options"], outputs: ["modelChange"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i3$c.DataView, selector: "p-dataView", inputs: ["paginator", "rows", "totalRecords", "pageLinks", "rowsPerPageOptions", "paginatorPosition", "paginatorStyleClass", "alwaysShowPaginator", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showFirstLastIcon", "showPageLinks", "lazy", "lazyLoadOnInit", "emptyMessage", "style", "styleClass", "gridStyleClass", "trackBy", "filterBy", "filterLocale", "loading", "loadingIcon", "first", "sortField", "sortOrder", "value", "layout"], outputs: ["onLazyLoad", "onPage", "onSort", "onChangeLayout"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: FileUpload, selector: "p-fileUpload", inputs: ["name", "url", "method", "multiple", "accept", "disabled", "auto", "withCredentials", "maxFileSize", "invalidFileSizeMessageSummary", "invalidFileSizeMessageDetail", "invalidFileTypeMessageSummary", "invalidFileTypeMessageDetail", "invalidFileLimitMessageDetail", "invalidFileLimitMessageSummary", "style", "styleClass", "previewWidth", "chooseLabel", "uploadLabel", "cancelLabel", "chooseIcon", "uploadIcon", "cancelIcon", "showUploadButton", "showCancelButton", "mode", "headers", "customUpload", "fileLimit", "uploadStyleClass", "cancelStyleClass", "removeStyleClass", "chooseStyleClass", "uploadedFiles", "files"], outputs: ["onBeforeUpload", "onSend", "onUpload", "onError", "onClear", "onRemove", "onSelect", "onProgress", "uploadHandler", "onImageError"] }, { kind: "component", type: i3$b.Avatar, selector: "p-avatar", inputs: ["label", "icon", "image", "size", "shape", "style", "styleClass", "ariaLabel", "ariaLabelledBy"], outputs: ["onImageError"] }, { kind: "pipe", type: i2.DatePipe, name: "date" }], changeDetection: i0.ChangeDetectionStrategy.Default }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DocumentListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-document-list', changeDetection: ChangeDetectionStrategy.Default, template: "<p-dataView #dv [value]=\"modelForDataview\" [rows]=\"props.listOptions.rowsPerPage\"\r\n  [rowsPerPageOptions]=\"props.listOptions.rowsPerPageOptions\" [paginator]=\"props.listOptions.paginator\"\r\n  [emptyMessage]=\"emptyMessageText\">\r\n  <ng-template *ngIf=\"props.listOptions.allowUpload\" pTemplate=\"header\">\r\n    <ng-container *ngIf=\"props.listOptions.allowUpload\">\r\n      <p-fileUpload #fileUploader name=\"demo[]\" url=\"./upload.php\" [accept]=\"acceptedFileTypes\"\r\n        (onUpload)=\"uploadFiles($event)\" [customUpload]=\"true\"\r\n        [invalidFileTypeMessageDetail]=\"invalidFileTypeMessageDetail\" [maxFileSize]=\"maxFileSize\"\r\n        [fileLimit]=\"props.listOptions.enableTitle ? 1 : fileLimit\" [multiple]=\"!props.listOptions.enableTitle\"\r\n        (onSelect)=\"uploadFiles($event)\" [showUploadButton]=\"false\" [showCancelButton]=\"false\" [auto]=\"auto\"\r\n        class=\"w-full\">\r\n        <ng-template pTemplate=\"content\">\r\n          <div *ngIf=\"props.listOptions.enableTitle\" class=\"flex flex-column gap-2\">\r\n            <form [formGroup]=\"titleForm\">\r\n              <formly-form [model]=\"title\" [fields]=\"titleFormFields\" [options]=\"titleOptions\"\r\n                [form]=\"titleForm\"></formly-form>\r\n            </form>\r\n          </div>\r\n          <div class=\"w-full py-3\" style=\"cursor: copy\" (click)=\"fileUploader.advancedFileInput.nativeElement.click()\">\r\n            <div class=\"h-full flex flex-column justify-content-center align-items-center\">\r\n              <i class=\"pi pi-upload text-900 text-2xl mb-3\"></i>\r\n              <span class=\"font-bold text-900 text-xl mb-3\">{{uploadText}}</span>\r\n              <span class=\"font-medium text-600 text-md text-center\">{{dropFileText}}</span>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </p-fileUpload>\r\n    </ng-container>\r\n    <div class=\"clearfix\"></div>\r\n  </ng-template>\r\n  <ng-template *ngIf=\"!props.listOptions.isCompactMode\" let-files pTemplate=\"list\">\r\n    <div *ngFor=\"let file of files\" class=\"message\">\r\n      <p-avatar [icon]=\"getDocumentIcon(file)\" size=\"large\" class=\"messager-img\"></p-avatar>\r\n      <div class=\"messager\">{{this.enableTitle ? (file.title!== undefined ? file.title + \" \" : \"\") +\"(\"+file.name+\")\" :\r\n        file.name }}\r\n        <span *ngIf=\"file.createdDate || file.createdBy\" class=\"date pull-right\">\r\n          {{file.createdBy}} {{file.createdDate && file.createdBy ? ' (' : '' }}\r\n          {{file.createdDate | date: longDate}} {{file.createdDate && file.createdBy ? ')' : '' }}</span>\r\n      </div>\r\n      <div class=\"message-text\">{{file.shortMessage}}\r\n        <button *ngIf=\"file.canDownload\" [title]=\"getActionButtonTitle('Download',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-download\"\r\n          (click)=\"downloadButtonClicked(file)\"></button>\r\n        <button *ngIf=\"file.canDelete\" [title]=\"getActionButtonTitle('Delete',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text pull-right\" icon=\"pi pi-trash\"\r\n          (click)=\"removeButtonClicked(file)\"></button>\r\n        <ng-container *ngFor=\"let actionButton of props.actionButtons\">\r\n          <button *ngIf=isActionButtonVisible(file,actionButton) pButton pRipple type=\"button\"\r\n            [title]=\"getActionButtonTitle(actionButton.label,file)\" [disabled]=\"isReadonly()\"\r\n            class=\"p-button-rounded p-button-text pull-right\" [icon]=\"actionButton.icon\"\r\n            (click)=\"actionButtonClicked(actionButton.type, file)\"></button>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </ng-template>\r\n\r\n  <ng-template *ngIf=\"props.listOptions.isCompactMode\" let-files pTemplate=\"list\">\r\n    <div *ngFor=\"let file of files\" class=\"message border-1 mb-3 compact\">\r\n      <p-avatar [icon]=\"getDocumentIcon(file)\" size=\"large\" class=\"messager-img\"></p-avatar>\r\n      <div class=\"messager\">{{file.name}}</div>\r\n      <div *ngIf=\"file.createdDate\" class=\"message-text\">\r\n        {{file.createdDate | date: longDate}}\r\n      </div>\r\n      <div class=\"message-text\">\r\n        <button *ngIf=\"file.canDownload\" [title]=\"getActionButtonTitle('Download',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text\" icon=\"pi pi-download\" (click)=\"downloadButtonClicked(file)\"></button>\r\n        <button *ngIf=\"file.canDelete\" [title]=\"getActionButtonTitle('Delete',file)\" pButton pRipple type=\"button\"\r\n          class=\"p-button-rounded p-button-text\" icon=\"pi pi-trash\" (click)=\"removeButtonClicked(file)\"></button>\r\n        <ng-container *ngFor=\"let actionButton of props.actionButtons\">\r\n          <button *ngIf=isActionButtonVisible(file,actionButton) pButton pRipple type=\"button\"\r\n            [title]=\"getActionButtonTitle(actionButton.label,file)\" [disabled]=\"isReadonly()\"\r\n            class=\"p-button-rounded p-button-text\" [icon]=\"actionButton.icon\"\r\n            (click)=\"actionButtonClicked(actionButton.type, file)\"></button>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n  </ng-template>\r\n  <ng-template #emptyListTemplate>\r\n    <div class=\"message-box\">\r\n      <div class=\"messager\">No documents found.</div>\r\n    </div>\r\n  </ng-template>\r\n</p-dataView>", styles: [":host ::ng-deep .p-fileupload-buttonbar{display:none}:host ::ng-deep .p-fileupload-files{display:none}:host ::ng-deep .w-full{width:100%!important}:host ::ng-deep .py-3{padding-top:1rem!important;padding-bottom:1rem!important}:host ::ng-deep .h-full{height:100%!important}:host ::ng-deep .align-items-center{align-items:center!important}:host ::ng-deep .justify-content-center{justify-content:center!important}:host ::ng-deep .flex-column{flex-direction:column!important}:host ::ng-deep .flex{display:flex!important}:host ::ng-deep .p-dataview-content .message{padding-top:.8rem;margin-top:5px;margin-bottom:0;border:1px solid #dee2e6;border-width:0 0 1px 0}:host ::ng-deep .p-dataview-content .compact{padding-left:.8rem;border-radius:10px}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: FileService }, { type: i2$4.FileSaverService }, { type: DataService }, { type: SpinnerService }, { type: DialogService }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: i4$5.NgxImageCompressService }] });

class ListboxFieldType extends FieldType {
    onBlur($event) {
        this.formControl.markAsDirty();
        this.props.blur?.(this.field, $event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListboxFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ListboxFieldType, selector: "dspx-listbox", usesInheritance: true, ngImport: i0, template: "\r\n<p-listbox\r\n  [id]=\"id\"\r\n  [options]=\"props.options\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (onBlur)=\"onBlur($event)\"\r\n  [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n  [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n    <ng-template let-option pTemplate=\"item\">\r\n      <ng-container [ngSwitch]=\"props.displayStyle || 'text'\">\r\n        <ng-container *ngSwitchCase=\"'image'\">\r\n          <i [class]=\"option[props.valueProp ?? 'value']\"></i>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'text'\">\r\n          {{option[props.labelProp ?? 'label']}}\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'chip'\">\r\n          <p-chip [label]=\"option[props.labelProp ?? 'label']\"></p-chip>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'imagewithchip'\">\r\n          <p-chip [label]=\"option[props.labelProp ?? 'label']\" [icon]=\"option[props.valueProp ?? 'value']\"></p-chip>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'imagewithtext'\">\r\n          <span> <i [class]=\"option[props.valueProp ?? 'value']\"></i> {{option[props.labelProp ?? 'label']}} </span>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-template>\r\n</p-listbox>\r\n", dependencies: [{ kind: "directive", type: i1$3.ɵFormlyAttributes, selector: "[formlyAttributes]", inputs: ["formlyAttributes", "id"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i5$1.Listbox, selector: "p-listbox", inputs: ["id", "searchMessage", "emptySelectionMessage", "selectionMessage", "autoOptionFocus", "ariaLabel", "selectOnFocus", "searchLocale", "focusOnHover", "filterMessage", "filterFields", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "scrollHeight", "tabindex", "multiple", "style", "styleClass", "listStyle", "listStyleClass", "readonly", "disabled", "checkbox", "filter", "filterBy", "filterMatchMode", "filterLocale", "metaKeySelection", "dataKey", "showToggleAll", "optionLabel", "optionValue", "optionGroupChildren", "optionGroupLabel", "optionDisabled", "ariaFilterLabel", "filterPlaceHolder", "emptyFilterMessage", "emptyMessage", "group", "options", "filterValue", "selectAll"], outputs: ["onChange", "onClick", "onDblClick", "onFilter", "onFocus", "onBlur", "onSelectAllChange"] }, { kind: "component", type: i6$3.Chip, selector: "p-chip", inputs: ["label", "icon", "image", "alt", "style", "styleClass", "removable", "removeIcon"], outputs: ["onRemove", "onImageError"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ListboxFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-listbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "\r\n<p-listbox\r\n  [id]=\"id\"\r\n  [options]=\"props.options\"\r\n  [formControl]=\"formControl\"\r\n  [formlyAttributes]=\"field\"\r\n  (onBlur)=\"onBlur($event)\"\r\n  [optionLabel]=\"props.labelProp ? props.labelProp : 'label' \"\r\n  [optionValue]=\"props.valueProp ? props.valueProp : 'value' \"\r\n  [attr.aria-required]=\"props.required ? 'true' : undefined\"\r\n  [attr.aria-describedby]=\"id + '-err ' + id + '-help'\">\r\n    <ng-template let-option pTemplate=\"item\">\r\n      <ng-container [ngSwitch]=\"props.displayStyle || 'text'\">\r\n        <ng-container *ngSwitchCase=\"'image'\">\r\n          <i [class]=\"option[props.valueProp ?? 'value']\"></i>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'text'\">\r\n          {{option[props.labelProp ?? 'label']}}\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'chip'\">\r\n          <p-chip [label]=\"option[props.labelProp ?? 'label']\"></p-chip>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'imagewithchip'\">\r\n          <p-chip [label]=\"option[props.labelProp ?? 'label']\" [icon]=\"option[props.valueProp ?? 'value']\"></p-chip>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'imagewithtext'\">\r\n          <span> <i [class]=\"option[props.valueProp ?? 'value']\"></i> {{option[props.labelProp ?? 'label']}} </span>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-template>\r\n</p-listbox>\r\n" }]
        }] });

class DataListFieldType extends FieldArrayType {
    constructor() {
        super(...arguments);
        this.emptyListButtons = [];
        this.listButtons = [];
        this.listItemButtons = [];
    }
    ngOnInit() {
        if (this.props.actionButtons) {
            this.props.actionButtons.forEach(btn => {
                if (btn.type === ButtonType.empty) {
                    this.emptyListButtons.push(btn);
                }
                else if (btn.type === ButtonType.listItem) {
                    this.listItemButtons.push(btn);
                }
                else {
                    this.listButtons.push(btn);
                }
            });
        }
    }
    isReadonly() {
        return (this.props.access && this.props.access === 'R');
    }
    getActionButtonTitle(label, record) {
        var title = label;
        if (record) {
            title = title + ' ' + record.text;
        }
        return title;
    }
    isActionButtonVisible(record, actionButton) {
        return record.actions
            && record.actions[actionButton.type] !== null
            && record.actions[actionButton.type] !== undefined
            && record.actions[actionButton.type] === true;
    }
    actionButtonClicked(index, btn, record) {
        var actionButtonEvent = {
            field: this.field,
            event: {
                index: index,
                type: btn.type,
                label: btn.label,
                data: record
            }
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(actionButtonEvent);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DataListFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DataListFieldType, selector: "dspx-data-list", usesInheritance: true, ngImport: i0, template: "<p-dataView #dv [value]=\"model\">\r\n  <ng-template pTemplate=\"header\">\r\n    <ng-container *ngIf=\"model && model.length > 0\">\r\n      <h3>{{props.messages.header}}</h3>\r\n      <div *ngFor=\"let btn of listButtons\" class=\"text-center col-12\">\r\n        <button pButton\r\n          type=\"button\"\r\n          [title]=\"getActionButtonTitle(btn.label)\"\r\n          class=\"p-button-lg dataview-button\"\r\n          [disabled] = \"isReadonly()\"\r\n          [label]=\"btn.label\"\r\n          [icon]=\"btn.icon\"\r\n          (click)=\"actionButtonClicked(null, btn, null)\"></button>\r\n      </div>\r\n      <h4>{{props.messages.listItemHeader}}</h4>\r\n      <h5 *ngIf=\"props.messages.listItemSubHeader\">{{props.messages.listItemSubHeader}}</h5>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!model || model.length <= 0\">\r\n      <h3>{{props.messages.emptyHeader}}</h3>\r\n    </ng-container>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"empty\">\r\n    <div *ngFor=\"let btn of emptyListButtons\" class=\"text-center col-12\">\r\n      <button pButton\r\n        type=\"button\"\r\n        [title]=\"getActionButtonTitle(btn.label)\"\r\n        class=\"p-button-lg dataview-button\"\r\n        [disabled] = \"isReadonly()\"\r\n        [label]=\"btn.label\"\r\n        [icon]=\"btn.icon\"\r\n        (click)=\"actionButtonClicked(null, btn, null)\"></button>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template let-item pTemplate=\"listItem\" let-index=\"rowIndex\">\r\n      <div class=\"col-12\">\r\n        <div class=\"mt-1 mb-1 grid\">\r\n          <div class=\"col-3 sm:col-2 md:col-1 text-center\">\r\n            <i [ngClass]=\"item.icon\"></i>\r\n          </div>\r\n          <div class=\"col-7 sm:col-9 md:col-10 p-text-left\">\r\n            <strong>{{item.title}}</strong>\r\n            <br>\r\n            {{item.subTitle}}\r\n          </div>\r\n          <div class=\"col-2 sm:col-1 md:col-1 text-right\">\r\n            <ng-container *ngFor=\"let actionButton of listItemButtons\" >\r\n              <button pButton pRipple\r\n                type=\"button\"\r\n                [title]=\"getActionButtonTitle(actionButton.label,item)\"\r\n                [disabled] = \"isReadonly()\"\r\n                class=\"p-button-rounded p-button-text pull-right\"\r\n                [icon]=\"actionButton.icon\"\r\n                (click)=\"actionButtonClicked(index, actionButton, item)\"></button>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  </ng-template>\r\n</p-dataView>\r\n", styles: [".dataview-button{width:auto}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i3$c.DataView, selector: "p-dataView", inputs: ["paginator", "rows", "totalRecords", "pageLinks", "rowsPerPageOptions", "paginatorPosition", "paginatorStyleClass", "alwaysShowPaginator", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showFirstLastIcon", "showPageLinks", "lazy", "lazyLoadOnInit", "emptyMessage", "style", "styleClass", "gridStyleClass", "trackBy", "filterBy", "filterLocale", "loading", "loadingIcon", "first", "sortField", "sortOrder", "value", "layout"], outputs: ["onLazyLoad", "onPage", "onSort", "onChangeLayout"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DataListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-data-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p-dataView #dv [value]=\"model\">\r\n  <ng-template pTemplate=\"header\">\r\n    <ng-container *ngIf=\"model && model.length > 0\">\r\n      <h3>{{props.messages.header}}</h3>\r\n      <div *ngFor=\"let btn of listButtons\" class=\"text-center col-12\">\r\n        <button pButton\r\n          type=\"button\"\r\n          [title]=\"getActionButtonTitle(btn.label)\"\r\n          class=\"p-button-lg dataview-button\"\r\n          [disabled] = \"isReadonly()\"\r\n          [label]=\"btn.label\"\r\n          [icon]=\"btn.icon\"\r\n          (click)=\"actionButtonClicked(null, btn, null)\"></button>\r\n      </div>\r\n      <h4>{{props.messages.listItemHeader}}</h4>\r\n      <h5 *ngIf=\"props.messages.listItemSubHeader\">{{props.messages.listItemSubHeader}}</h5>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!model || model.length <= 0\">\r\n      <h3>{{props.messages.emptyHeader}}</h3>\r\n    </ng-container>\r\n  </ng-template>\r\n  <ng-template pTemplate=\"empty\">\r\n    <div *ngFor=\"let btn of emptyListButtons\" class=\"text-center col-12\">\r\n      <button pButton\r\n        type=\"button\"\r\n        [title]=\"getActionButtonTitle(btn.label)\"\r\n        class=\"p-button-lg dataview-button\"\r\n        [disabled] = \"isReadonly()\"\r\n        [label]=\"btn.label\"\r\n        [icon]=\"btn.icon\"\r\n        (click)=\"actionButtonClicked(null, btn, null)\"></button>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template let-item pTemplate=\"listItem\" let-index=\"rowIndex\">\r\n      <div class=\"col-12\">\r\n        <div class=\"mt-1 mb-1 grid\">\r\n          <div class=\"col-3 sm:col-2 md:col-1 text-center\">\r\n            <i [ngClass]=\"item.icon\"></i>\r\n          </div>\r\n          <div class=\"col-7 sm:col-9 md:col-10 p-text-left\">\r\n            <strong>{{item.title}}</strong>\r\n            <br>\r\n            {{item.subTitle}}\r\n          </div>\r\n          <div class=\"col-2 sm:col-1 md:col-1 text-right\">\r\n            <ng-container *ngFor=\"let actionButton of listItemButtons\" >\r\n              <button pButton pRipple\r\n                type=\"button\"\r\n                [title]=\"getActionButtonTitle(actionButton.label,item)\"\r\n                [disabled] = \"isReadonly()\"\r\n                class=\"p-button-rounded p-button-text pull-right\"\r\n                [icon]=\"actionButton.icon\"\r\n                (click)=\"actionButtonClicked(index, actionButton, item)\"></button>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  </ng-template>\r\n</p-dataView>\r\n", styles: [".dataview-button{width:auto}\n"] }]
        }] });

class CheckedListBoxType extends FieldType {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        this.groupedOptions = [];
    }
    ngOnInit() {
        if (this.field.props?.options) {
            this.field.props.options
                .reduce((previousValue, currentValue) => {
                let existingEntry = this.groupedOptions.find(v => v.code === currentValue.code);
                if (!existingEntry) {
                    existingEntry = {
                        code: currentValue.code,
                        values: [currentValue.text]
                    };
                    this.groupedOptions.push(existingEntry);
                }
                else {
                    existingEntry.values.push(currentValue.text);
                }
                return previousValue;
            }, this.groupedOptions);
            this.cdr.detectChanges();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckedListBoxType, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CheckedListBoxType, selector: "dspx-checked-list-box", usesInheritance: true, ngImport: i0, template: "<ng-container *ngFor=\"let kv of groupedOptions; let outerIndex = index\">\r\n  <div class=\"checkboxes-container\">\r\n    <span class=\"checkbox-label\">{{kv.code | titlecase}}</span>\r\n    <div class=\"checkboxes\">\r\n      <ng-container *ngFor=\"let v of kv.values; let innerIndex = index\">\r\n        <p-checkbox\r\n          [name]=\"field.key\"\r\n          [value]=\"kv.code+v\"\r\n          [formControl]=\"formControl\"\r\n          [inputId]=\"kv.code+v + '_' + (outerIndex+ innerIndex)\"\r\n          checkboxIcon=\"fas fa-check\"\r\n          class=\"checkbox\"\r\n          label=\"{{ v }}\">\r\n        </p-checkbox>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".checkboxes-container{display:flex;align-items:center;margin-bottom:10px}.checkbox-label{display:inline-block;max-width:100px;width:80px}.checkboxes{margin-left:5%}.checkbox{margin-left:20px}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: Checkbox, selector: "p-checkbox", inputs: ["value", "name", "disabled", "binary", "label", "ariaLabelledBy", "ariaLabel", "tabindex", "inputId", "style", "styleClass", "labelStyleClass", "formControl", "checkboxIcon", "readonly", "required", "trueValue", "falseValue"], outputs: ["onChange", "onFocus", "onBlur"] }, { kind: "pipe", type: i2.TitleCasePipe, name: "titlecase" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CheckedListBoxType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-checked-list-box', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let kv of groupedOptions; let outerIndex = index\">\r\n  <div class=\"checkboxes-container\">\r\n    <span class=\"checkbox-label\">{{kv.code | titlecase}}</span>\r\n    <div class=\"checkboxes\">\r\n      <ng-container *ngFor=\"let v of kv.values; let innerIndex = index\">\r\n        <p-checkbox\r\n          [name]=\"field.key\"\r\n          [value]=\"kv.code+v\"\r\n          [formControl]=\"formControl\"\r\n          [inputId]=\"kv.code+v + '_' + (outerIndex+ innerIndex)\"\r\n          checkboxIcon=\"fas fa-check\"\r\n          class=\"checkbox\"\r\n          label=\"{{ v }}\">\r\n        </p-checkbox>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".checkboxes-container{display:flex;align-items:center;margin-bottom:10px}.checkbox-label{display:inline-block;max-width:100px;width:80px}.checkboxes{margin-left:5%}.checkbox{margin-left:20px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }] });

class ChartFieldType extends FieldType {
    constructor(coreService) {
        super();
        this.coreService = coreService;
        this.plugins = [ChartDataLabels];
    }
    ngOnInit() {
        let labelColor = this.labelColor;
        let showLegend = this.showLegend;
        this.chartOptions = {
            maintainAspectRatio: false,
            responsive: true,
            layout: {
                padding: {
                    left: 2,
                    right: 50,
                    top: 2,
                    bottom: 2
                }
            },
            maxBarThickness: 50,
            indexAxis: 'y',
            interaction: {
                mode: 'index',
                axis: 'y'
            },
            onClick: (e) => {
                this.onClick(e);
            },
            plugins: {
                legend: {
                    display: showLegend,
                    labels: {
                        font: {
                            size: 14
                        }
                    },
                    // onClick: (e) => {
                    //   this.onLegendClick(e);
                    // }
                },
                datalabels: {
                    align: 'end',
                    anchor: 'end',
                    color: function (context) {
                        return context.dataset?.backgroundColor || 'black';
                    },
                    font: {
                        weight: 'bold',
                        size: 15
                    },
                    padding: {
                        left: 10,
                        right: 5
                    }
                }
            },
            scales: {
                x: {
                    display: false,
                },
                y: {
                    ticks: {
                        font: {
                            size: 18
                        },
                        color: labelColor
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };
    }
    onClick(event) {
        let eventData = {};
        eventData['key'] = this.field.key;
        eventData['x'] = event['x'];
        eventData['y'] = event['y'];
        const points = event.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);
        let index = null, datasetIndex = null;
        if (points && points[0]) {
            index = points[0]['index'];
            datasetIndex = points[0]['datasetIndex'];
        }
        eventData['index'] = index;
        eventData['datasetIndex'] = datasetIndex;
        if (datasetIndex >= 0) {
            let data = this.data?.datasets[datasetIndex];
            eventData['data'] = data?.data;
            eventData['source'] = data?.source;
            eventData['group'] = this.groups[datasetIndex];
        }
        if (index >= 0) {
            eventData['label'] = this.labels[index];
        }
        let appFunctions = this.coreService.applicationFunctions;
        if (appFunctions && appFunctions.chartClick) {
            appFunctions.chartClick(this, eventData);
        }
    }
    get data() {
        let modelData = this.model;
        let chartKey = `${this.field.key}`;
        let chartData = {
            labels: this.labelTexts,
            datasets: []
        };
        if (modelData && modelData[chartKey]) {
            chartData = modelData[chartKey];
            if (!chartData.labels) {
                chartData.labels = this.labelTexts;
            }
            if (!chartData.datasets) {
                chartData.datasets = [];
            }
            else {
                chartData.datasets.forEach((val, index) => {
                    if (!val.backgroundColor) {
                        val.backgroundColor = this.groups[index]?.color;
                    }
                    if (!val.label) {
                        val.label = this.groups[index]?.text;
                    }
                });
            }
        }
        return chartData;
    }
    showHideDataSetsOnly(labels, show) {
        this.data.datasets.forEach(ds => {
            if (!labels) {
                labels = [];
            }
            ds.hidden = true;
            if (labels.indexOf(ds.label) >= 0) {
                ds.hidden = !show;
            }
        });
    }
    get chartType() {
        return this.field?.props?.chartOptions?.type || "bar";
    }
    get showLegend() {
        return this.field?.props?.chartOptions?.showLegend == true;
    }
    get heading() {
        return this.field?.props?.chartOptions?.label || "";
    }
    get labelColor() {
        return this.field?.props?.chartOptions?.labelColor || "#000";
    }
    get labels() {
        return this.field?.props?.chartOptions?.labels || [];
    }
    get labelTexts() {
        return this.labels.map(l => l.text);
    }
    get labelCodes() {
        return this.labels.map(l => l.code);
    }
    get groups() {
        return this.field?.props?.chartOptions?.groups || [];
    }
    get height() {
        let h = this.field?.props?.chartOptions?.height || 0;
        if (h <= 0) {
            let labelCount = this.labels.length;
            if (labelCount == 0) {
                labelCount = 4;
            }
            let groupCount = Math.max(this.groups?.length, 1);
            h = labelCount * (groupCount <= 1 ? 50 : 30) * groupCount;
        }
        return h + "px";
    }
    get width() {
        let w = this.field?.props?.chartOptions?.width || 0;
        if (w <= 0) {
            w = 650;
        }
        return w + "px";
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChartFieldType, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ChartFieldType, selector: "chart", viewQueries: [{ propertyName: "chart", first: true, predicate: UIChart, descendants: true }], usesInheritance: true, ngImport: i0, template: "<p-chart [type]=\"chartType\" [data]=\"data\" [options]=\"chartOptions\" [plugins]=\"plugins\" [height]=\"height\"></p-chart>", styles: [":host ::ng-deep .chart-container{max-width:800px}:host ::ng-deep .chart-filter{margin-top:1rem;margin-bottom:1rem}\n"], dependencies: [{ kind: "component", type: i2$6.UIChart, selector: "p-chart", inputs: ["type", "plugins", "width", "height", "responsive", "ariaLabel", "ariaLabelledBy", "data", "options"], outputs: ["onDataSelect"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ChartFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'chart', template: "<p-chart [type]=\"chartType\" [data]=\"data\" [options]=\"chartOptions\" [plugins]=\"plugins\" [height]=\"height\"></p-chart>", styles: [":host ::ng-deep .chart-container{max-width:800px}:host ::ng-deep .chart-filter{margin-top:1rem;margin-bottom:1rem}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }], propDecorators: { chart: [{
                type: ViewChild,
                args: [UIChart]
            }] } });

class TimelineFieldType extends FieldType {
    ngOnInit() {
        let key = this.key.toString();
        this.values = this.model[key].map((step) => ({
            title: step.title,
            description: step.description,
            backgroundColor: (step.backgroundColor && step.backgroundColor != '') ? step.backgroundColor : '#6c757d',
            icon: (step.icon && step.icon != '') ? step.icon : "pi pi-arrow-right",
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TimelineFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: TimelineFieldType, selector: "dspx-timeline", usesInheritance: true, ngImport: i0, template: "<div>\r\n  <section class=\"px-4 py-5 md:px-6 lg:px-8\">\r\n    <ul class=\"list-none flex flex-column gap-3 lg:flex-row justify-content-between p-0\">\r\n        <li *ngFor=\"let value of values; let last = last; let first = first\"\r\n          class=\"flex align-items-center flex-column gap-3 relative w-full\">\r\n\r\n            <div class=\"flex justify-content-center align-items-center border-circle  text-white w-3rem h-3rem z-1\"\r\n              [ngStyle]=\"{'background-color': value.backgroundColor}\">\r\n              <i [class]=\"value.icon ?? ''\" class=\"text-xl\"></i>\r\n            </div>\r\n\r\n            <div *ngIf=\"!first\" class=\"w-full hidden lg:block absolute right-50 hidden\" [ngStyle]=\"{'background-color': value.backgroundColor}\" style=\"transform: translateY(-50%); height: 2px; top: 25%\"></div>\r\n            <div *ngIf=\"!last\" class=\"w-full hidden lg:block absolute left-50 hidden\" [ngStyle]=\"{'background-color': value.backgroundColor}\" style=\"transform: translateY(-50%); height: 2px; top: 25%\"></div>\r\n\r\n            <div class=\"flex flex-column align-items-center\">\r\n              <span *ngIf=\"value.title\" class=\"text-600 text-base text-center\">{{ value.title  }}</span>\r\n              <h1 *ngIf=\"value.description\" class=\"m-0 font-medium text-primary text-base text-center\">{{ value.description }}</h1>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n  </section>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TimelineFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-timeline', template: "<div>\r\n  <section class=\"px-4 py-5 md:px-6 lg:px-8\">\r\n    <ul class=\"list-none flex flex-column gap-3 lg:flex-row justify-content-between p-0\">\r\n        <li *ngFor=\"let value of values; let last = last; let first = first\"\r\n          class=\"flex align-items-center flex-column gap-3 relative w-full\">\r\n\r\n            <div class=\"flex justify-content-center align-items-center border-circle  text-white w-3rem h-3rem z-1\"\r\n              [ngStyle]=\"{'background-color': value.backgroundColor}\">\r\n              <i [class]=\"value.icon ?? ''\" class=\"text-xl\"></i>\r\n            </div>\r\n\r\n            <div *ngIf=\"!first\" class=\"w-full hidden lg:block absolute right-50 hidden\" [ngStyle]=\"{'background-color': value.backgroundColor}\" style=\"transform: translateY(-50%); height: 2px; top: 25%\"></div>\r\n            <div *ngIf=\"!last\" class=\"w-full hidden lg:block absolute left-50 hidden\" [ngStyle]=\"{'background-color': value.backgroundColor}\" style=\"transform: translateY(-50%); height: 2px; top: 25%\"></div>\r\n\r\n            <div class=\"flex flex-column align-items-center\">\r\n              <span *ngIf=\"value.title\" class=\"text-600 text-base text-center\">{{ value.title  }}</span>\r\n              <h1 *ngIf=\"value.description\" class=\"m-0 font-medium text-primary text-base text-center\">{{ value.description }}</h1>\r\n            </div>\r\n        </li>\r\n    </ul>\r\n  </section>\r\n</div>\r\n" }]
        }] });

class NoteListFieldType extends FieldArrayType {
    isReadonly() {
        return (this.props.access && this.props.access === 'R');
    }
    actionButtonClicked() {
        var actionButtonEvent = {
            field: this.field,
            type: ButtonType.save,
            data: this.newNoteText
        };
        if (this.props.actionButtonClick) {
            this.props.actionButtonClick(actionButtonEvent);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NoteListFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: NoteListFieldType, selector: "dspx-note-list", usesInheritance: true, ngImport: i0, template: "<ul class=\"list-none p-0 m-0\">\r\n  <li class=\"py-3 border-bottom-1 surface-border\" *ngFor=\"let item of model; let first = first; let last = last;\">\r\n    <div class=\"font-medium text-900 mb-2\">{{item.title}}</div>\r\n    <div class=\"line-height-3 text-600\" style=\"max-width: 30rem\">{{item.content}}</div>\r\n  </li>\r\n</ul>\r\n<!-- Text box and Add button for adding new Notes -->\r\n<div class=\"flex justify-content-between pt-3\" *ngIf=\"props.noteListOptions?.canAddNote == true\">\r\n  <input id=\"newNote\" type=\"text\" class=\"p-inputtext w-8\" [(ngModel)]=\"newNoteText\" [disabled] = \"isReadonly()\">\r\n  <button pButton pRipple [label]=\"props.noteListOptions?.addButtonText == null ? 'Add' : props.noteListOptions.addButtonText\"\r\n          [title]=\"props.noteListOptions?.addButtonTitle == null ? '' : props.noteListOptions.addButtonTitle\"\r\n          [icon]=\"props.noteListOptions?.addButtonIcon\"\r\n          class=\"w-4 ml-2\"\r\n          (click)=\"actionButtonClicked()\"\r\n          [disabled] = \"isReadonly()\"></button>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NoteListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-note-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"list-none p-0 m-0\">\r\n  <li class=\"py-3 border-bottom-1 surface-border\" *ngFor=\"let item of model; let first = first; let last = last;\">\r\n    <div class=\"font-medium text-900 mb-2\">{{item.title}}</div>\r\n    <div class=\"line-height-3 text-600\" style=\"max-width: 30rem\">{{item.content}}</div>\r\n  </li>\r\n</ul>\r\n<!-- Text box and Add button for adding new Notes -->\r\n<div class=\"flex justify-content-between pt-3\" *ngIf=\"props.noteListOptions?.canAddNote == true\">\r\n  <input id=\"newNote\" type=\"text\" class=\"p-inputtext w-8\" [(ngModel)]=\"newNoteText\" [disabled] = \"isReadonly()\">\r\n  <button pButton pRipple [label]=\"props.noteListOptions?.addButtonText == null ? 'Add' : props.noteListOptions.addButtonText\"\r\n          [title]=\"props.noteListOptions?.addButtonTitle == null ? '' : props.noteListOptions.addButtonTitle\"\r\n          [icon]=\"props.noteListOptions?.addButtonIcon\"\r\n          class=\"w-4 ml-2\"\r\n          (click)=\"actionButtonClicked()\"\r\n          [disabled] = \"isReadonly()\"></button>\r\n</div>\r\n" }]
        }] });

class QuickHelpFieldType extends FieldType {
    ngOnInit() {
        this.setModelForDataView();
    }
    setModelForDataView() {
        this.modelForDataview = this.props.quickHelpOptions;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickHelpFieldType, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: QuickHelpFieldType, selector: "dspx-quick-help", usesInheritance: true, ngImport: i0, template: "<div class=\"quickHelp\" *ngIf=\"modelForDataview?.length\">\r\n    <h3>{{ props.label }}</h3>\r\n    <p-dataView #dv [value]=\"modelForDataview\">\r\n        <ng-template *ngIf=\"true\" let-helpContent pTemplate=\"list\">\r\n            <div *ngFor=\"let item of helpContent\" [style.backgroundColor]=\"props.listOptions.quickHelpBackgroundColor\"\r\n                class=\"p-3 border-round-lg mb-3\">\r\n                <div *ngIf=\"item.linkUrl; else noLink\">\r\n                    <a [href]=\"item.linkUrl\" target=\"_blank\">\r\n                        <p-panel [header]=\"item.helpTitle\" [toggleable]=\"props.listOptions.quickHelpToggleable\" [collapsed]=\"props.listOptions.quickHelpCollapsed\" toggler=\"header\">\r\n                            <ng-template pTemplate=\"headericons\">\r\n                                <button pButton type=\"button\" [icon]=\"props.listOptions.quickHelpIcon\" class=\"p-panel-header-icon\"\r\n                                    title=\"Icon\"></button>\r\n                            </ng-template>\r\n                            <div [innerHTML]=\"item.helpContent\"></div>\r\n                        </p-panel>\r\n                    </a>\r\n                </div>\r\n                <ng-template #noLink>\r\n                    <p-panel [header]=\"item.helpTitle\" [toggleable]=\"props.toggleable\" [collapsed]=\"props.collapsed\" toggler=\"header\">\r\n                        <ng-template pTemplate=\"headericons\">\r\n                            <button pButton type=\"button\" [icon]=\"props.icon\" class=\"p-panel-header-icon\"\r\n                                title=\"Icon\"></button>\r\n                        </ng-template>\r\n                        <div [innerHTML]=\"item.helpContent\"></div>\r\n                    </p-panel>\r\n                </ng-template>\r\n            </div>\r\n        </ng-template>\r\n    </p-dataView>\r\n</div>", styles: [":host ::ng-deep .quickHelp h3{font-size:18px}:host ::ng-deep .quickHelp .p-panel-header{background:none;border:none;padding:0}:host ::ng-deep .quickHelp .p-panel-header .p-panel-title{color:#000;font-weight:600}:host ::ng-deep .quickHelp .p-panel-header .p-panel-header-icon:focus{box-shadow:none!important}:host ::ng-deep .quickHelp .p-panel-content{background:none;padding:0;border:none;margin-top:6px}:host ::ng-deep .quickHelp .p-panel-content p{color:#000;font-weight:400;margin:0}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i3$c.DataView, selector: "p-dataView", inputs: ["paginator", "rows", "totalRecords", "pageLinks", "rowsPerPageOptions", "paginatorPosition", "paginatorStyleClass", "alwaysShowPaginator", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showFirstLastIcon", "showPageLinks", "lazy", "lazyLoadOnInit", "emptyMessage", "style", "styleClass", "gridStyleClass", "trackBy", "filterBy", "filterLocale", "loading", "loadingIcon", "first", "sortField", "sortOrder", "value", "layout"], outputs: ["onLazyLoad", "onPage", "onSort", "onChangeLayout"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }, { kind: "component", type: i4$3.Panel, selector: "p-panel", inputs: ["toggleable", "header", "collapsed", "style", "styleClass", "iconPos", "expandIcon", "collapseIcon", "showHeader", "toggler", "transitionOptions"], outputs: ["collapsedChange", "onBeforeToggle", "onAfterToggle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuickHelpFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-quick-help', template: "<div class=\"quickHelp\" *ngIf=\"modelForDataview?.length\">\r\n    <h3>{{ props.label }}</h3>\r\n    <p-dataView #dv [value]=\"modelForDataview\">\r\n        <ng-template *ngIf=\"true\" let-helpContent pTemplate=\"list\">\r\n            <div *ngFor=\"let item of helpContent\" [style.backgroundColor]=\"props.listOptions.quickHelpBackgroundColor\"\r\n                class=\"p-3 border-round-lg mb-3\">\r\n                <div *ngIf=\"item.linkUrl; else noLink\">\r\n                    <a [href]=\"item.linkUrl\" target=\"_blank\">\r\n                        <p-panel [header]=\"item.helpTitle\" [toggleable]=\"props.listOptions.quickHelpToggleable\" [collapsed]=\"props.listOptions.quickHelpCollapsed\" toggler=\"header\">\r\n                            <ng-template pTemplate=\"headericons\">\r\n                                <button pButton type=\"button\" [icon]=\"props.listOptions.quickHelpIcon\" class=\"p-panel-header-icon\"\r\n                                    title=\"Icon\"></button>\r\n                            </ng-template>\r\n                            <div [innerHTML]=\"item.helpContent\"></div>\r\n                        </p-panel>\r\n                    </a>\r\n                </div>\r\n                <ng-template #noLink>\r\n                    <p-panel [header]=\"item.helpTitle\" [toggleable]=\"props.toggleable\" [collapsed]=\"props.collapsed\" toggler=\"header\">\r\n                        <ng-template pTemplate=\"headericons\">\r\n                            <button pButton type=\"button\" [icon]=\"props.icon\" class=\"p-panel-header-icon\"\r\n                                title=\"Icon\"></button>\r\n                        </ng-template>\r\n                        <div [innerHTML]=\"item.helpContent\"></div>\r\n                    </p-panel>\r\n                </ng-template>\r\n            </div>\r\n        </ng-template>\r\n    </p-dataView>\r\n</div>", styles: [":host ::ng-deep .quickHelp h3{font-size:18px}:host ::ng-deep .quickHelp .p-panel-header{background:none;border:none;padding:0}:host ::ng-deep .quickHelp .p-panel-header .p-panel-title{color:#000;font-weight:600}:host ::ng-deep .quickHelp .p-panel-header .p-panel-header-icon:focus{box-shadow:none!important}:host ::ng-deep .quickHelp .p-panel-content{background:none;padding:0;border:none;margin-top:6px}:host ::ng-deep .quickHelp .p-panel-content p{color:#000;font-weight:400;margin:0}\n"] }]
        }] });

class CustomListFieldType extends FieldType {
    // Helper methods to set hover state
    onMouseOver(index) {
        this.hoverStates[index] = true;
    }
    onMouseOut(index) {
        this.hoverStates[index] = false;
    }
    constructor(sanitizer) {
        super();
        this.sanitizer = sanitizer;
        this.customListBackgroundColor = '#000';
        this.emptyMessageText = 'No items found.';
        this.hoverStates = [];
    }
    ngOnInit() {
        this.setModelForDataView();
        this.hoverStates = Array(this.modelForDataview.length).fill(false);
    }
    setModelForDataView() {
        this.customListBackgroundColor = this.props.listOptions.customListBackgroundColor;
        if (this.model != undefined) {
            let key = this.key.toString();
            // Setting this fires change detection
            this.modelForDataview = [...this.model[key]].map(option => ({
                ...option,
                rightHandHtmlContent: this.sanitizeHTML(option.rightHandHtmlContent),
                leftHandHtmlContent: this.sanitizeHTML(option.leftHandHtmlContent),
            }));
        }
    }
    sanitizeHTML(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
    darkenColor(color, percent) {
        // Expand 3-digit hex to 6-digit hex if necessary
        if (color.length === 4) {
            color = `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
        }
        // Parse the color string to an integer
        const hex = color.replace('#', ''); // Remove the '#' symbol
        const num = parseInt(hex, 16);
        // Helper function to clamp a value between 0 and 255
        const clamp = (value) => Math.max(0, Math.min(255, value));
        // Darken a single component
        const darken = (component) => clamp(component - (255 * percent) / 100);
        // Extract RGB components
        const r = darken((num >> 16) & 0xff); // Extract and darken red component
        const g = darken((num >> 8) & 0xff); // Extract and darken green component
        const b = darken(num & 0xff); // Extract and darken blue component
        // Return the final RGB color string
        return `rgb(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)})`;
    }
    // Get the darkened version of the background color
    getDarkenedColor() {
        return this.darkenColor(this.customListBackgroundColor, 5); // Darken by 10%
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CustomListFieldType, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CustomListFieldType, selector: "dspx-custom-list", inputs: { customListBackgroundColor: "customListBackgroundColor" }, usesInheritance: true, ngImport: i0, template: "<div class=\"contentList\">\r\n    <p-dataView #dv [value]=\"modelForDataview\" [rows]=\"props.listOptions.rowsPerPage\"\r\n    [rowsPerPageOptions]=\"props.listOptions.rowsPerPageOptions\" [paginator]=\"props.listOptions.paginator\"\r\n    [emptyMessage]=\"emptyMessageText\">\r\n        <ng-template let-itemContent pTemplate=\"list\">\r\n            <div *ngFor=\"let item of modelForDataview; let i = index\" \r\n                [ngStyle]=\"{ 'background-color': hoverStates[i] ? getDarkenedColor() : customListBackgroundColor }\"\r\n                (mouseover)=\"onMouseOver(i)\"\r\n                (mouseout)=\"onMouseOut(i)\"\r\n                class=\"border-round-lg p-3 mb-2 custom-list-item\">\r\n                <a [href]=\"item.linkUrl\">\r\n                    <div class=\"flex align-items-center justify-content-between flex-wrap\">\r\n                        <div [innerHTML]=\"item.leftHandHtmlContent\"></div>\r\n                        <div class=\"flex align-items-center\" [innerHTML]=\"item.rightHandHtmlContent\"></div>\r\n                    </div>\r\n                </a>\r\n            </div>\r\n        </ng-template>\r\n    </p-dataView>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i3$c.DataView, selector: "p-dataView", inputs: ["paginator", "rows", "totalRecords", "pageLinks", "rowsPerPageOptions", "paginatorPosition", "paginatorStyleClass", "alwaysShowPaginator", "paginatorDropdownAppendTo", "paginatorDropdownScrollHeight", "currentPageReportTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showFirstLastIcon", "showPageLinks", "lazy", "lazyLoadOnInit", "emptyMessage", "style", "styleClass", "gridStyleClass", "trackBy", "filterBy", "filterLocale", "loading", "loadingIcon", "first", "sortField", "sortOrder", "value", "layout"], outputs: ["onLazyLoad", "onPage", "onSort", "onChangeLayout"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CustomListFieldType, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-custom-list', template: "<div class=\"contentList\">\r\n    <p-dataView #dv [value]=\"modelForDataview\" [rows]=\"props.listOptions.rowsPerPage\"\r\n    [rowsPerPageOptions]=\"props.listOptions.rowsPerPageOptions\" [paginator]=\"props.listOptions.paginator\"\r\n    [emptyMessage]=\"emptyMessageText\">\r\n        <ng-template let-itemContent pTemplate=\"list\">\r\n            <div *ngFor=\"let item of modelForDataview; let i = index\" \r\n                [ngStyle]=\"{ 'background-color': hoverStates[i] ? getDarkenedColor() : customListBackgroundColor }\"\r\n                (mouseover)=\"onMouseOver(i)\"\r\n                (mouseout)=\"onMouseOut(i)\"\r\n                class=\"border-round-lg p-3 mb-2 custom-list-item\">\r\n                <a [href]=\"item.linkUrl\">\r\n                    <div class=\"flex align-items-center justify-content-between flex-wrap\">\r\n                        <div [innerHTML]=\"item.leftHandHtmlContent\"></div>\r\n                        <div class=\"flex align-items-center\" [innerHTML]=\"item.rightHandHtmlContent\"></div>\r\n                    </div>\r\n                </a>\r\n            </div>\r\n        </ng-template>\r\n    </p-dataView>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1$2.DomSanitizer }], propDecorators: { customListBackgroundColor: [{
                type: Input
            }] } });

class DspxWrapperFormField extends FieldWrapper {
    constructor() {
        super(...arguments);
        this.showToolTip = false;
    }
    handleToolTipClick() {
        this.showToolTip = !this.showToolTip;
    }
    getLabel() {
        switch (this.field.type) {
            case 'date': {
                switch (this.props.selectionMode) {
                    case 'multiple':
                        return this.props.label + ' (DD/MM/YYYY, DD/MM/YYYY, ...)';
                    case 'range':
                        return this.props.label + ' (DD/MM/YYYY - DD/MM/YYYY)';
                    default:
                        return this.props.label + ' (DD/MM/YYYY)';
                }
            }
            case 'time': {
                return this.props.label + ' (HH:MM AM/PM)';
            }
            case 'datetime': {
                return this.props.label + ' (DD/MM/YYYY HH:MM AM/PM)';
            }
            default: {
                return this.props.label;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperFormField, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxWrapperFormField, selector: "dspx-form-field", usesInheritance: true, ngImport: i0, template: "<div class=\"p-fluid\">\r\n  <div class=\"field\" [attr.aria-required] = \"props.required ? 'true' : undefined\"  >\r\n    <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"ui-widget field-label\">\r\n      <label [for]=\"id\" [id]=\"id + '-label'\">\r\n        {{ getLabel() }}\r\n        <span class=\"{{props.suffixClass}}\" *ngIf=\"props.suffix && props.suffix.length > 0\" aria-hidden=\"true\">{{props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      </label>\r\n      <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n              [title]=\"'Show help for ' + props.label\"\r\n              [attr.aria-label]=\"'Show help for ' + props.label\"\r\n              [attr.aria-expanded]=\"showToolTip\"\r\n              class=\"p-button-rounded p-button-text tooltip-button\"\r\n              icon=\"fas fa-question-circle\"\r\n              (click)=\"handleToolTipClick()\"></button>\r\n    </div>\r\n    <div [ngClass]=\"{'p-hidden': !showToolTip}\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n      <div *ngFor=\"let tooltip of props.toolTips\">\r\n        <div [innerHtml]=\"tooltip.text\"></div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"props.additionalInformations\" class=\"info-block\" >\r\n      <div *ngFor=\"let info of props.additionalInformations\" [innerHtml]=\"info.text\"></div>\r\n    </div>\r\n    <ng-container #fieldComponent></ng-container>\r\n    <div class=\"p-error\" [ngClass]=\"{'p-hidden': !showError}\" [id]=\"id + '-err'\">\r\n      <formly-validation-message class=\"ui-message-text\" [field]=\"field\"></formly-validation-message>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "component", type: i1$3.ɵFormlyValidationMessage, selector: "formly-validation-message", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperFormField, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-form-field', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, template: "<div class=\"p-fluid\">\r\n  <div class=\"field\" [attr.aria-required] = \"props.required ? 'true' : undefined\"  >\r\n    <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"ui-widget field-label\">\r\n      <label [for]=\"id\" [id]=\"id + '-label'\">\r\n        {{ getLabel() }}\r\n        <span class=\"{{props.suffixClass}}\" *ngIf=\"props.suffix && props.suffix.length > 0\" aria-hidden=\"true\">{{props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      </label>\r\n      <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n              [title]=\"'Show help for ' + props.label\"\r\n              [attr.aria-label]=\"'Show help for ' + props.label\"\r\n              [attr.aria-expanded]=\"showToolTip\"\r\n              class=\"p-button-rounded p-button-text tooltip-button\"\r\n              icon=\"fas fa-question-circle\"\r\n              (click)=\"handleToolTipClick()\"></button>\r\n    </div>\r\n    <div [ngClass]=\"{'p-hidden': !showToolTip}\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n      <div *ngFor=\"let tooltip of props.toolTips\">\r\n        <div [innerHtml]=\"tooltip.text\"></div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"props.additionalInformations\" class=\"info-block\" >\r\n      <div *ngFor=\"let info of props.additionalInformations\" [innerHtml]=\"info.text\"></div>\r\n    </div>\r\n    <ng-container #fieldComponent></ng-container>\r\n    <div class=\"p-error\" [ngClass]=\"{'p-hidden': !showError}\" [id]=\"id + '-err'\">\r\n      <formly-validation-message class=\"ui-message-text\" [field]=\"field\"></formly-validation-message>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
        }] });

class DspxRadioWrapperFormField extends FieldWrapper {
    constructor() {
        super(...arguments);
        this.showToolTip = false;
    }
    handleToolTipClick() {
        this.showToolTip = !this.showToolTip;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxRadioWrapperFormField, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxRadioWrapperFormField, selector: "dspx-radio-wrapper", usesInheritance: true, ngImport: i0, template: "<div class=\"p-fluid\">\r\n  <fieldset\r\n    class=\"field\"\r\n    [attr.aria-required] = \"props.required ? 'true' : undefined\"\r\n    [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n    [attr.aria-describedby]=\"showError ? id + '-err' : undefined\"  >\r\n    <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"ui-widget field-label\">\r\n      <legend [for]=\"id\">\r\n        {{ props.label }}\r\n        <span class=\"{{props.suffixClass}}\" *ngIf=\"props.suffix && props.suffix.length > 0\" aria-hidden=\"true\">{{props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      </legend>\r\n      <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n              [title]=\"'Show help for ' + props.label\"\r\n              [attr.aria-label]=\"'Show help for ' + props.label\"\r\n              [attr.aria-expanded]=\"showToolTip\"\r\n              class=\"p-button-rounded p-button-text tooltip-button\"\r\n              icon=\"fas fa-question-circle\"\r\n              (click)=\"handleToolTipClick()\"></button>\r\n    </div>\r\n    <div [ngClass]=\"{'p-hidden': !showToolTip}\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n      <div *ngFor=\"let tooltip of props.toolTips\">\r\n      <div [innerHtml]=\"tooltip.text\"></div>\r\n      </div>\r\n    </div>\r\n    <ng-container #fieldComponent></ng-container>\r\n    <div class=\"p-error\" [ngClass]=\"{'p-hidden': !showError}\" [id]=\"id + '-err'\">\r\n      <formly-validation-message class=\"ui-message-text\" [field]=\"field\"></formly-validation-message>\r\n    </div>\r\n  </fieldset>\r\n</div>\r\n", styles: ["fieldset{border-width:0;padding-left:0;margin-left:0}\n"], dependencies: [{ kind: "component", type: i1$3.ɵFormlyValidationMessage, selector: "formly-validation-message", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxRadioWrapperFormField, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-radio-wrapper', template: "<div class=\"p-fluid\">\r\n  <fieldset\r\n    class=\"field\"\r\n    [attr.aria-required] = \"props.required ? 'true' : undefined\"\r\n    [attr.aria-invalid]=\"showError ? 'true' : undefined\"\r\n    [attr.aria-describedby]=\"showError ? id + '-err' : undefined\"  >\r\n    <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"ui-widget field-label\">\r\n      <legend [for]=\"id\">\r\n        {{ props.label }}\r\n        <span class=\"{{props.suffixClass}}\" *ngIf=\"props.suffix && props.suffix.length > 0\" aria-hidden=\"true\">{{props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      </legend>\r\n      <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n              [title]=\"'Show help for ' + props.label\"\r\n              [attr.aria-label]=\"'Show help for ' + props.label\"\r\n              [attr.aria-expanded]=\"showToolTip\"\r\n              class=\"p-button-rounded p-button-text tooltip-button\"\r\n              icon=\"fas fa-question-circle\"\r\n              (click)=\"handleToolTipClick()\"></button>\r\n    </div>\r\n    <div [ngClass]=\"{'p-hidden': !showToolTip}\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n      <div *ngFor=\"let tooltip of props.toolTips\">\r\n      <div [innerHtml]=\"tooltip.text\"></div>\r\n      </div>\r\n    </div>\r\n    <ng-container #fieldComponent></ng-container>\r\n    <div class=\"p-error\" [ngClass]=\"{'p-hidden': !showError}\" [id]=\"id + '-err'\">\r\n      <formly-validation-message class=\"ui-message-text\" [field]=\"field\"></formly-validation-message>\r\n    </div>\r\n  </fieldset>\r\n</div>\r\n", styles: ["fieldset{border-width:0;padding-left:0;margin-left:0}\n"] }]
        }] });

class DspxWrapperContainer extends FieldWrapper {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperContainer, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxWrapperContainer, selector: "dspx-container", usesInheritance: true, ngImport: i0, template: "<div class=\"p-fluid\">\r\n  <div class=\"field\">\r\n    <ng-container #fieldComponent></ng-container>\r\n  </div>\r\n</div>\r\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperContainer, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-container', template: "<div class=\"p-fluid\">\r\n  <div class=\"field\">\r\n    <ng-container #fieldComponent></ng-container>\r\n  </div>\r\n</div>\r\n" }]
        }] });

class DspxWrapperFilter extends FieldWrapper {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperFilter, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxWrapperFilter, selector: "dspx-filter", usesInheritance: true, ngImport: i0, template: "<div class=\"col\">\r\n  <label [for]=\"id\">{{ props.label }}</label>\r\n  <div class=\"p-hidden\" [id]=\"id + '-label'\">{{ props.label }}</div>\r\n  <ng-container #fieldComponent></ng-container>\r\n  <div class=\"p-hidden\" [id]=\"id + '-err'\"></div>\r\n</div>\r\n\r\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperFilter, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-filter', template: "<div class=\"col\">\r\n  <label [for]=\"id\">{{ props.label }}</label>\r\n  <div class=\"p-hidden\" [id]=\"id + '-label'\">{{ props.label }}</div>\r\n  <ng-container #fieldComponent></ng-container>\r\n  <div class=\"p-hidden\" [id]=\"id + '-err'\"></div>\r\n</div>\r\n\r\n" }]
        }] });

class DspxFileUploadWrapper extends FieldWrapper {
    constructor() {
        super(...arguments);
        this.showToolTip = false;
    }
    handleToolTipClick() {
        this.showToolTip = !this.showToolTip;
    }
    getLabel() {
        switch (this.field.type) {
            case 'date': {
                return this.props.label + ' (DD/MM/YYYY)';
            }
            case 'time': {
                return this.props.label + ' (HH:MM AM/PM)';
            }
            case 'datetime': {
                return this.props.label + ' (DD/MM/YYYY HH:MM AM/PM)';
            }
            default: {
                return this.props.label;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxFileUploadWrapper, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxFileUploadWrapper, selector: "dspx-fileupload-wrapper", usesInheritance: true, ngImport: i0, template: "<div class=\"p-fluid\">\r\n  <div class=\"field field-upload\" [attr.aria-required] = \"props.required ? 'true' : undefined\"  >\r\n    <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"ui-widget field-label\">\r\n      <h3>\r\n        {{ props.label }}\r\n        <span class=\"{{props.suffixClass}}\" *ngIf=\"props.suffix && props.suffix.length > 0\" aria-hidden=\"true\">{{props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      </h3>\r\n      <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n              [title]=\"'Show help for ' + props.label\"\r\n              [attr.aria-label]=\"'Show help for ' + props.label\"\r\n              [attr.aria-expanded]=\"showToolTip\"\r\n              class=\"p-button-rounded p-button-text tooltip-button\"\r\n              icon=\"fas fa-question-circle\"\r\n              (click)=\"handleToolTipClick()\"></button>\r\n    </div>\r\n    <div [ngClass]=\"{'p-hidden': !showToolTip}\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n      <div *ngFor=\"let tooltip of props.toolTips\">\r\n      <div [innerHtml]=\"tooltip.text\"></div>\r\n      </div>\r\n    </div>\r\n    <ng-container #fieldComponent></ng-container>\r\n    <div class=\"p-error\" [ngClass]=\"{'p-hidden': !showError}\" [id]=\"id + '-err'\">\r\n      <formly-validation-message class=\"ui-message-text\" [field]=\"field\"></formly-validation-message>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".field-upload h3{margin-bottom:0}\n"], dependencies: [{ kind: "component", type: i1$3.ɵFormlyValidationMessage, selector: "formly-validation-message", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.ButtonDirective, selector: "[pButton]", inputs: ["iconPos", "loadingIcon", "label", "icon", "loading", "severity", "raised", "rounded", "text", "outlined", "size", "plain"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxFileUploadWrapper, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-fileupload-wrapper', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, template: "<div class=\"p-fluid\">\r\n  <div class=\"field field-upload\" [attr.aria-required] = \"props.required ? 'true' : undefined\"  >\r\n    <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"ui-widget field-label\">\r\n      <h3>\r\n        {{ props.label }}\r\n        <span class=\"{{props.suffixClass}}\" *ngIf=\"props.suffix && props.suffix.length > 0\" aria-hidden=\"true\">{{props.suffix}}</span>\r\n        <span class=\"required-marker\" *ngIf=\"props.required && props.hideRequiredMarker !== true\" aria-hidden=\"true\">*</span>\r\n      </h3>\r\n      <button *ngIf=\"props.toolTips && props.toolTips.length > 0\" pButton pRipple type=\"button\"\r\n              [title]=\"'Show help for ' + props.label\"\r\n              [attr.aria-label]=\"'Show help for ' + props.label\"\r\n              [attr.aria-expanded]=\"showToolTip\"\r\n              class=\"p-button-rounded p-button-text tooltip-button\"\r\n              icon=\"fas fa-question-circle\"\r\n              (click)=\"handleToolTipClick()\"></button>\r\n    </div>\r\n    <div [ngClass]=\"{'p-hidden': !showToolTip}\" class=\"tooltip-block\" [id]=\"id + '-help'\">\r\n      <div *ngFor=\"let tooltip of props.toolTips\">\r\n      <div [innerHtml]=\"tooltip.text\"></div>\r\n      </div>\r\n    </div>\r\n    <ng-container #fieldComponent></ng-container>\r\n    <div class=\"p-error\" [ngClass]=\"{'p-hidden': !showError}\" [id]=\"id + '-err'\">\r\n      <formly-validation-message class=\"ui-message-text\" [field]=\"field\"></formly-validation-message>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".field-upload h3{margin-bottom:0}\n"] }]
        }] });

class DspxLabelWrapperFormField extends FieldWrapper {
    constructor(coreService) {
        super();
        this.coreService = coreService;
        this.questionValue = '';
    }
    ngOnInit() {
        this.questionValue = this.coreService.getFieldValue(this.field);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxLabelWrapperFormField, deps: [{ token: CoreService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxLabelWrapperFormField, selector: "dspx-label-wrapper", usesInheritance: true, ngImport: i0, template: "<div class=\"p-fluid formgrid grid\">\r\n  <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"field col-2 md:col-3\">\r\n    <legend [for]=\"id\">{{ props.label }}</legend>\r\n  </div>\r\n  <div class=\"field col-10 md:col-9\">\r\n    <dspx-show-hide-text text=\"{{questionValue}}\"></dspx-show-hide-text>\r\n  </div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: DspxShowHideTextComponent, selector: "dspx-show-hide-text", inputs: ["text"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxLabelWrapperFormField, decorators: [{
            type: Component,
            args: [{ selector: 'dspx-label-wrapper', template: "<div class=\"p-fluid formgrid grid\">\r\n  <div *ngIf=\"props.label && props.hideLabel !== true\" class=\"field col-2 md:col-3\">\r\n    <legend [for]=\"id\">{{ props.label }}</legend>\r\n  </div>\r\n  <div class=\"field col-10 md:col-9\">\r\n    <dspx-show-hide-text text=\"{{questionValue}}\"></dspx-show-hide-text>\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: CoreService }] });

class DspxWrapperTableCell extends FieldWrapper {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperTableCell, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DspxWrapperTableCell, selector: "dspx-table-cell", viewQueries: [{ propertyName: "fieldComponent", first: true, predicate: ["fieldComponent"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: `
    <ng-container #fieldComponent></ng-container>
    
    <div class="p-error" [ngClass]="{'p-hidden': !showError}" [id]="id + '-err'">
       <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
    </div>
`, isInline: true, dependencies: [{ kind: "component", type: i1$3.ɵFormlyValidationMessage, selector: "formly-validation-message", inputs: ["field"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxWrapperTableCell, decorators: [{
            type: Component,
            args: [{
                    selector: 'dspx-table-cell',
                    template: `
    <ng-container #fieldComponent></ng-container>
    
    <div class="p-error" [ngClass]="{'p-hidden': !showError}" [id]="id + '-err'">
       <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
    </div>
`,
                }]
        }], propDecorators: { fieldComponent: [{
                type: ViewChild,
                args: ['fieldComponent', { read: ViewContainerRef }]
            }] } });

// Angular imports
function init_app(appService, dialogService) {
    var x = () => {
        appService.loadAppConfigAsync();
        dialogService.initCommonDialogs();
    };
    return x;
}
function getAppSettings(appService) {
    var x = appService.getAppSettings();
    return x;
}
class DspxCoreModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreModule, declarations: [DspxCoreComponent,
            DspxBaseFormComponent,
            DspxBaseFormReportComponent,
            InputFieldType,
            SwitchFieldType,
            CheckboxFieldType,
            SingleCheckboxFieldType,
            ButtonFieldType,
            DateFieldType,
            DateTimeFieldType,
            FileUploadFieldType,
            AutoCompleteFieldType,
            AddressFieldType,
            MaskedInputFieldType,
            TextAreaFieldType,
            MultiselectFieldType,
            MultiselectPillFieldType,
            QuickHelpFieldType,
            CustomListFieldType,
            ParagraphFieldType,
            PasswordFieldType,
            StepsFieldType,
            TabsFieldType,
            PageFieldType,
            PageRepeatingFieldType,
            SectionFieldType,
            SectionRepeatingFieldType,
            SectionRepeatingInformationFieldType,
            SectionCompareFieldType,
            DspxSectionCompareBadgeComponent,
            SectionVerificationFieldType,
            VerticalStepperFieldType,
            HorizontalStepperFieldType,
            SectionLoginFieldType,
            DspxHeadingComponent,
            HeaderFieldType,
            HtmlHeadingFieldType,
            DspxDescriptionComponent,
            TableFieldType,
            TableEditorFieldType,
            DspxWrapperTableCell,
            FormNavigationFieldType,
            SearchBoxFieldType,
            DspxDialogComponent,
            DspxDashboardComponent,
            DspxHeaderComponent,
            DspxFooterComponent,
            DspxWrapperFormField,
            DspxWrapperContainer,
            DspxWrapperFilter,
            DspxFileUploadWrapper,
            DspxLabelWrapperFormField,
            FormSummaryFieldType,
            FormSummaryV2FieldType,
            TimeFieldType,
            RadioFieldType,
            PBIEmbeddedFieldType,
            DspxSpinnerComponent,
            DspxValidationSummaryComponent,
            DspxShowHideTextComponent,
            DspxStatusBarComponent,
            DspxFormHeaderComponent,
            DspxHeaderBarComponent,
            SelectButtonFieldType,
            FilterFieldType,
            DspxRadioWrapperFormField,
            TabView,
            TabPanel,
            Checkbox,
            DspxMobileMenuTriggerComponent,
            DspxMobileMenuComponent,
            DspxSecondaryNavigationComponent,
            DspxBreadcrumbComponent,
            DecimalFieldType,
            DspxLogoutComponent,
            EditorFieldType,
            ImageFieldType,
            SelectFieldType,
            ListFieldType,
            MessageListFieldType,
            NoteListFieldType,
            DisplayFieldType,
            DspxEnvironmentBannerComponent,
            DspxExcelFileUploadComponent,
            ExcelFileUploadType,
            DspxPanelRepeaterComponent,
            DspxTableRepeaterComponent,
            DspxTabSetComponent,
            DspxSequentialNavigationComponent,
            DspxSequentialNavigationPanelComponent,
            DspxQuestionsViewModeComponent,
            DspxSectionViewModeComponent,
            DspxCardSectionViewModeComponent,
            DspxCardSetBaseFormComponent,
            DspxCardSetBaseFormWithHeaderComponent,
            DspxCardSetBaseFormReadOnlyComponent,
            DspxCardSetFooterComponent,
            DspxCardSetHeaderComponent,
            DspxCardSetMenuComponent,
            DspxCardSetMenuItemComponent,
            CardSectionFieldType,
            CardSectionRepeatingFieldType,
            CardSetPageFieldType,
            CardSetPageRepeatingFieldType,
            CardSetTabsFieldType,
            CardSetTabsFlatFieldType,
            CardSectionOverviewFieldType,
            CardSetPageOverviewFieldType,
            CardSetPageInfoFieldType,
            CardSetPageListFieldType,
            RelatedEntitySummaryFieldType,
            LabelFieldType,
            StickyElementDirective,
            DocumentListFieldType,
            ListboxFieldType,
            CheckedListBoxType,
            DataListFieldType,
            ChartFieldType,
            TimelineFieldType], imports: [FormlyModule,
            FormlyPrimeNGModule, i2$5.NgxEditorModule, FormlySelectModule,
            CommonModule,
            InputTextModule,
            InputNumberModule,
            ReactiveFormsModule,
            BrowserModule,
            BrowserAnimationsModule,
            InputSwitchModule,
            //CheckboxModule,
            DataViewModule,
            ListboxModule,
            ChipModule,
            ButtonModule,
            CalendarModule,
            AutoCompleteModule,
            DropdownModule,
            InputMaskModule,
            InputTextareaModule,
            MultiSelectModule,
            PasswordModule,
            RadioButtonModule,
            FileUploadModule,
            StepsModule,
            //TabViewModule,
            TableModule,
            InputTextModule,
            FormsModule,
            HttpClientModule,
            ToastModule,
            SplitButtonModule,
            DialogModule,
            DynamicDialogModule,
            ConfirmDialogModule,
            DividerModule,
            ProgressSpinnerModule,
            BlockUIModule,
            BadgeModule,
            SelectButtonModule,
            PanelModule,
            MenuModule,
            CardModule,
            ToolbarModule,
            ImageModule,
            AvatarModule,
            ChartModule,
            ToggleButtonModule], exports: [DspxCoreComponent,
            Checkbox,
            TabView,
            TabPanel,
            DspxBaseFormComponent,
            DspxBaseFormReportComponent,
            InputFieldType,
            SwitchFieldType,
            CheckboxFieldType,
            SingleCheckboxFieldType,
            ButtonFieldType,
            DateFieldType,
            DateTimeFieldType,
            FileUploadFieldType,
            AutoCompleteFieldType,
            AddressFieldType,
            MaskedInputFieldType,
            TextAreaFieldType,
            MultiselectFieldType,
            MultiselectPillFieldType,
            QuickHelpFieldType,
            CustomListFieldType,
            ParagraphFieldType,
            PasswordFieldType,
            StepsFieldType,
            TabsFieldType,
            PageFieldType,
            PageRepeatingFieldType,
            SectionFieldType,
            SectionRepeatingFieldType,
            SectionRepeatingInformationFieldType,
            SectionCompareFieldType,
            SectionVerificationFieldType,
            SectionLoginFieldType,
            DspxHeadingComponent,
            HeaderFieldType,
            HtmlHeadingFieldType,
            DspxDescriptionComponent,
            TableFieldType,
            TableEditorFieldType,
            DspxWrapperTableCell,
            FormNavigationFieldType,
            SearchBoxFieldType,
            FilterFieldType,
            DspxDialogComponent,
            DspxDashboardComponent,
            DspxHeaderComponent,
            DspxFooterComponent,
            DspxSecondaryNavigationComponent,
            VerticalStepperFieldType,
            HorizontalStepperFieldType,
            DspxSequentialNavigationComponent,
            DspxSequentialNavigationPanelComponent,
            DspxWrapperFormField,
            DspxWrapperContainer,
            DspxRadioWrapperFormField,
            DspxWrapperFilter,
            DspxFileUploadWrapper,
            DspxLabelWrapperFormField,
            FormSummaryFieldType,
            FormSummaryV2FieldType,
            TimeFieldType,
            RadioFieldType,
            PBIEmbeddedFieldType,
            DspxSpinnerComponent,
            DspxValidationSummaryComponent,
            DspxShowHideTextComponent,
            DspxStatusBarComponent,
            DspxFormHeaderComponent,
            DspxHeaderBarComponent,
            SelectButtonFieldType,
            DspxBreadcrumbComponent,
            DecimalFieldType,
            DspxLogoutComponent,
            EditorFieldType,
            ImageFieldType,
            SelectFieldType,
            ListFieldType,
            MessageListFieldType,
            NoteListFieldType,
            DisplayFieldType,
            DspxEnvironmentBannerComponent,
            DspxExcelFileUploadComponent,
            ExcelFileUploadType,
            DspxPanelRepeaterComponent,
            DspxTableRepeaterComponent,
            DspxTabSetComponent,
            DspxQuestionsViewModeComponent,
            DspxSectionViewModeComponent,
            DspxCardSectionViewModeComponent,
            DspxCardSetBaseFormComponent,
            DspxCardSetBaseFormWithHeaderComponent,
            DspxCardSetBaseFormReadOnlyComponent,
            DspxCardSetFooterComponent,
            DspxCardSetHeaderComponent,
            DspxCardSetMenuComponent,
            DspxCardSetMenuItemComponent,
            CardSectionFieldType,
            CardSectionRepeatingFieldType,
            CardSetPageFieldType,
            CardSetPageRepeatingFieldType,
            CardSetTabsFieldType,
            CardSetTabsFlatFieldType,
            CardSectionOverviewFieldType,
            CardSetPageOverviewFieldType,
            CardSetPageInfoFieldType,
            CardSetPageListFieldType,
            RelatedEntitySummaryFieldType,
            LabelFieldType,
            StickyElementDirective,
            DocumentListFieldType,
            ListboxFieldType,
            CheckedListBoxType,
            DataListFieldType,
            ChartFieldType,
            TimelineFieldType] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreModule, providers: [
            ApplicationSettingsService,
            DialogService,
            {
                provide: APP_INITIALIZER,
                multi: true,
                useFactory: init_app,
                deps: [ApplicationSettingsService, DialogService],
            },
            {
                provide: ApplicationSettings,
                useFactory: getAppSettings,
                deps: [ApplicationSettingsService],
            },
            {
                // processes all errors
                provide: ErrorHandler,
                useClass: GlobalErrorHandler
            },
            {
                // interceptor for HTTP errors
                provide: HTTP_INTERCEPTORS,
                useClass: HttpErrorInterceptor,
                multi: true // multiple interceptors are possible
            },
            TestingDataService,
            CoreService,
            ReportDataService,
            FormConfigurationService,
            FormNavigationService,
            MessageService,
            ConfirmationService,
            OptionSetService,
            AddressService,
            DataService,
            UserService,
            SpinnerService,
            PowerBiService,
            BreadcrumbService,
            Title,
            FileService,
            IdVerificationService,
            OptionsSearchService,
            CardSetTransformationService,
            MenuConfigService,
            MenuService,
            HeaderService,
            StyleConfigService,
            StickyElementService
        ], imports: [FormlyModule,
            FormlyPrimeNGModule,
            NgxEditorModule.forRoot({
                locals: {
                    // menu
                    bold: 'Bold',
                    italic: 'Italic',
                    code: 'Code',
                    blockquote: 'Blockquote',
                    underline: 'Underline',
                    strike: 'Strike',
                    bullet_list: 'Bullet List',
                    ordered_list: 'Ordered List',
                    heading: 'Heading',
                    h1: 'Header 1',
                    h2: 'Header 2',
                    h3: 'Header 3',
                    h4: 'Header 4',
                    h5: 'Header 5',
                    h6: 'Header 6',
                    align_left: 'Left Align',
                    align_center: 'Center Align',
                    align_right: 'Right Align',
                    align_justify: 'Justify',
                    text_color: 'Text Color',
                    background_color: 'Background Color',
                    // popups, forms, others...
                    url: 'URL',
                    text: 'Text',
                    openInNewTab: 'Open in new tab',
                    insert: 'Insert',
                    altText: 'Alt Text',
                    title: 'Title',
                    remove: 'Remove',
                },
            }),
            FormlySelectModule,
            CommonModule,
            InputTextModule,
            InputNumberModule,
            ReactiveFormsModule,
            BrowserModule,
            BrowserAnimationsModule,
            InputSwitchModule,
            //CheckboxModule,
            DataViewModule,
            ListboxModule,
            ChipModule,
            ButtonModule,
            CalendarModule,
            AutoCompleteModule,
            DropdownModule,
            InputMaskModule,
            InputTextareaModule,
            MultiSelectModule,
            PasswordModule,
            RadioButtonModule,
            FileUploadModule,
            StepsModule,
            //TabViewModule,
            TableModule,
            InputTextModule,
            FormsModule,
            HttpClientModule,
            ToastModule,
            SplitButtonModule,
            DialogModule,
            DynamicDialogModule,
            ConfirmDialogModule,
            DividerModule,
            ProgressSpinnerModule,
            BlockUIModule,
            BadgeModule,
            SelectButtonModule,
            PanelModule,
            MenuModule,
            CardModule,
            ToolbarModule,
            ImageModule,
            AvatarModule,
            ChartModule,
            ToggleButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DspxCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DspxCoreComponent,
                        DspxBaseFormComponent,
                        DspxBaseFormReportComponent,
                        InputFieldType,
                        SwitchFieldType,
                        CheckboxFieldType,
                        SingleCheckboxFieldType,
                        ButtonFieldType,
                        DateFieldType,
                        DateTimeFieldType,
                        FileUploadFieldType,
                        AutoCompleteFieldType,
                        AddressFieldType,
                        MaskedInputFieldType,
                        TextAreaFieldType,
                        MultiselectFieldType,
                        MultiselectPillFieldType,
                        QuickHelpFieldType,
                        CustomListFieldType,
                        ParagraphFieldType,
                        PasswordFieldType,
                        StepsFieldType,
                        TabsFieldType,
                        PageFieldType,
                        PageRepeatingFieldType,
                        SectionFieldType,
                        SectionRepeatingFieldType,
                        SectionRepeatingInformationFieldType,
                        SectionCompareFieldType,
                        DspxSectionCompareBadgeComponent,
                        SectionVerificationFieldType,
                        VerticalStepperFieldType,
                        HorizontalStepperFieldType,
                        SectionLoginFieldType,
                        DspxHeadingComponent,
                        HeaderFieldType,
                        HtmlHeadingFieldType,
                        DspxDescriptionComponent,
                        TableFieldType,
                        TableEditorFieldType,
                        DspxWrapperTableCell,
                        FormNavigationFieldType,
                        SearchBoxFieldType,
                        DspxDialogComponent,
                        DspxDashboardComponent,
                        DspxHeaderComponent,
                        DspxFooterComponent,
                        DspxWrapperFormField,
                        DspxWrapperContainer,
                        DspxWrapperFilter,
                        DspxFileUploadWrapper,
                        DspxLabelWrapperFormField,
                        FormSummaryFieldType,
                        FormSummaryV2FieldType,
                        TimeFieldType,
                        RadioFieldType,
                        PBIEmbeddedFieldType,
                        DspxSpinnerComponent,
                        DspxValidationSummaryComponent,
                        DspxShowHideTextComponent,
                        DspxStatusBarComponent,
                        DspxFormHeaderComponent,
                        DspxHeaderBarComponent,
                        SelectButtonFieldType,
                        FilterFieldType,
                        DspxRadioWrapperFormField,
                        TabView,
                        TabPanel,
                        Checkbox,
                        DspxMobileMenuTriggerComponent,
                        DspxMobileMenuComponent,
                        DspxSecondaryNavigationComponent,
                        DspxBreadcrumbComponent,
                        DecimalFieldType,
                        DspxLogoutComponent,
                        EditorFieldType,
                        ImageFieldType,
                        SelectFieldType,
                        ListFieldType,
                        MessageListFieldType,
                        NoteListFieldType,
                        DisplayFieldType,
                        DspxEnvironmentBannerComponent,
                        DspxExcelFileUploadComponent,
                        ExcelFileUploadType,
                        DspxPanelRepeaterComponent,
                        DspxTableRepeaterComponent,
                        DspxTabSetComponent,
                        DspxSequentialNavigationComponent,
                        DspxSequentialNavigationPanelComponent,
                        DspxQuestionsViewModeComponent,
                        DspxSectionViewModeComponent,
                        DspxCardSectionViewModeComponent,
                        DspxCardSetBaseFormComponent,
                        DspxCardSetBaseFormWithHeaderComponent,
                        DspxCardSetBaseFormReadOnlyComponent,
                        DspxCardSetFooterComponent,
                        DspxCardSetHeaderComponent,
                        DspxCardSetMenuComponent,
                        DspxCardSetMenuItemComponent,
                        CardSectionFieldType,
                        CardSectionRepeatingFieldType,
                        CardSetPageFieldType,
                        CardSetPageRepeatingFieldType,
                        CardSetTabsFieldType,
                        CardSetTabsFlatFieldType,
                        CardSectionOverviewFieldType,
                        CardSetPageOverviewFieldType,
                        CardSetPageInfoFieldType,
                        CardSetPageListFieldType,
                        RelatedEntitySummaryFieldType,
                        LabelFieldType,
                        StickyElementDirective,
                        DocumentListFieldType,
                        ListboxFieldType,
                        CheckedListBoxType,
                        DataListFieldType,
                        ChartFieldType,
                        TimelineFieldType
                    ],
                    imports: [
                        FormlyModule,
                        FormlyPrimeNGModule,
                        NgxEditorModule.forRoot({
                            locals: {
                                // menu
                                bold: 'Bold',
                                italic: 'Italic',
                                code: 'Code',
                                blockquote: 'Blockquote',
                                underline: 'Underline',
                                strike: 'Strike',
                                bullet_list: 'Bullet List',
                                ordered_list: 'Ordered List',
                                heading: 'Heading',
                                h1: 'Header 1',
                                h2: 'Header 2',
                                h3: 'Header 3',
                                h4: 'Header 4',
                                h5: 'Header 5',
                                h6: 'Header 6',
                                align_left: 'Left Align',
                                align_center: 'Center Align',
                                align_right: 'Right Align',
                                align_justify: 'Justify',
                                text_color: 'Text Color',
                                background_color: 'Background Color',
                                // popups, forms, others...
                                url: 'URL',
                                text: 'Text',
                                openInNewTab: 'Open in new tab',
                                insert: 'Insert',
                                altText: 'Alt Text',
                                title: 'Title',
                                remove: 'Remove',
                            },
                        }),
                        FormlySelectModule,
                        CommonModule,
                        InputTextModule,
                        InputNumberModule,
                        ReactiveFormsModule,
                        BrowserModule,
                        BrowserAnimationsModule,
                        InputSwitchModule,
                        //CheckboxModule,
                        DataViewModule,
                        ListboxModule,
                        ChipModule,
                        ButtonModule,
                        CalendarModule,
                        AutoCompleteModule,
                        DropdownModule,
                        InputMaskModule,
                        InputTextareaModule,
                        MultiSelectModule,
                        PasswordModule,
                        RadioButtonModule,
                        FileUploadModule,
                        StepsModule,
                        //TabViewModule,
                        TableModule,
                        InputTextModule,
                        FormsModule,
                        HttpClientModule,
                        ToastModule,
                        SplitButtonModule,
                        DialogModule,
                        DynamicDialogModule,
                        ConfirmDialogModule,
                        DividerModule,
                        ProgressSpinnerModule,
                        BlockUIModule,
                        BadgeModule,
                        SelectButtonModule,
                        PanelModule,
                        MenuModule,
                        CardModule,
                        ToolbarModule,
                        ImageModule,
                        AvatarModule,
                        ChartModule,
                        ToggleButtonModule
                    ],
                    exports: [
                        DspxCoreComponent,
                        Checkbox,
                        TabView,
                        TabPanel,
                        DspxBaseFormComponent,
                        DspxBaseFormReportComponent,
                        InputFieldType,
                        SwitchFieldType,
                        CheckboxFieldType,
                        SingleCheckboxFieldType,
                        ButtonFieldType,
                        DateFieldType,
                        DateTimeFieldType,
                        FileUploadFieldType,
                        AutoCompleteFieldType,
                        AddressFieldType,
                        MaskedInputFieldType,
                        TextAreaFieldType,
                        MultiselectFieldType,
                        MultiselectPillFieldType,
                        QuickHelpFieldType,
                        CustomListFieldType,
                        ParagraphFieldType,
                        PasswordFieldType,
                        StepsFieldType,
                        TabsFieldType,
                        PageFieldType,
                        PageRepeatingFieldType,
                        SectionFieldType,
                        SectionRepeatingFieldType,
                        SectionRepeatingInformationFieldType,
                        SectionCompareFieldType,
                        SectionVerificationFieldType,
                        SectionLoginFieldType,
                        DspxHeadingComponent,
                        HeaderFieldType,
                        HtmlHeadingFieldType,
                        DspxDescriptionComponent,
                        TableFieldType,
                        TableEditorFieldType,
                        DspxWrapperTableCell,
                        FormNavigationFieldType,
                        SearchBoxFieldType,
                        FilterFieldType,
                        DspxDialogComponent,
                        DspxDashboardComponent,
                        DspxHeaderComponent,
                        DspxFooterComponent,
                        DspxSecondaryNavigationComponent,
                        VerticalStepperFieldType,
                        HorizontalStepperFieldType,
                        DspxSequentialNavigationComponent,
                        DspxSequentialNavigationPanelComponent,
                        DspxWrapperFormField,
                        DspxWrapperContainer,
                        DspxRadioWrapperFormField,
                        DspxWrapperFilter,
                        DspxFileUploadWrapper,
                        DspxLabelWrapperFormField,
                        FormSummaryFieldType,
                        FormSummaryV2FieldType,
                        TimeFieldType,
                        RadioFieldType,
                        PBIEmbeddedFieldType,
                        DspxSpinnerComponent,
                        DspxValidationSummaryComponent,
                        DspxShowHideTextComponent,
                        DspxStatusBarComponent,
                        DspxFormHeaderComponent,
                        DspxHeaderBarComponent,
                        SelectButtonFieldType,
                        DspxBreadcrumbComponent,
                        DecimalFieldType,
                        DspxLogoutComponent,
                        EditorFieldType,
                        ImageFieldType,
                        SelectFieldType,
                        ListFieldType,
                        MessageListFieldType,
                        NoteListFieldType,
                        DisplayFieldType,
                        DspxEnvironmentBannerComponent,
                        DspxExcelFileUploadComponent,
                        ExcelFileUploadType,
                        DspxPanelRepeaterComponent,
                        DspxTableRepeaterComponent,
                        DspxTabSetComponent,
                        DspxQuestionsViewModeComponent,
                        DspxSectionViewModeComponent,
                        DspxCardSectionViewModeComponent,
                        DspxCardSetBaseFormComponent,
                        DspxCardSetBaseFormWithHeaderComponent,
                        DspxCardSetBaseFormReadOnlyComponent,
                        DspxCardSetFooterComponent,
                        DspxCardSetHeaderComponent,
                        DspxCardSetMenuComponent,
                        DspxCardSetMenuItemComponent,
                        CardSectionFieldType,
                        CardSectionRepeatingFieldType,
                        CardSetPageFieldType,
                        CardSetPageRepeatingFieldType,
                        CardSetTabsFieldType,
                        CardSetTabsFlatFieldType,
                        CardSectionOverviewFieldType,
                        CardSetPageOverviewFieldType,
                        CardSetPageInfoFieldType,
                        CardSetPageListFieldType,
                        RelatedEntitySummaryFieldType,
                        LabelFieldType,
                        StickyElementDirective,
                        DocumentListFieldType,
                        ListboxFieldType,
                        CheckedListBoxType,
                        DataListFieldType,
                        ChartFieldType,
                        TimelineFieldType
                    ],
                    providers: [
                        ApplicationSettingsService,
                        DialogService,
                        {
                            provide: APP_INITIALIZER,
                            multi: true,
                            useFactory: init_app,
                            deps: [ApplicationSettingsService, DialogService],
                        },
                        {
                            provide: ApplicationSettings,
                            useFactory: getAppSettings,
                            deps: [ApplicationSettingsService],
                        },
                        {
                            // processes all errors
                            provide: ErrorHandler,
                            useClass: GlobalErrorHandler
                        },
                        {
                            // interceptor for HTTP errors
                            provide: HTTP_INTERCEPTORS,
                            useClass: HttpErrorInterceptor,
                            multi: true // multiple interceptors are possible
                        },
                        TestingDataService,
                        CoreService,
                        ReportDataService,
                        FormConfigurationService,
                        FormNavigationService,
                        MessageService,
                        ConfirmationService,
                        OptionSetService,
                        AddressService,
                        DataService,
                        UserService,
                        SpinnerService,
                        PowerBiService,
                        BreadcrumbService,
                        Title,
                        FileService,
                        IdVerificationService,
                        OptionsSearchService,
                        CardSetTransformationService,
                        MenuConfigService,
                        MenuService,
                        HeaderService,
                        StyleConfigService,
                        StickyElementService
                    ],
                }]
        }] });

function dspxRequiredValidator(control, field, options) {
    if (control.value === undefined || control.value === null || isNullOrWhitespaceOnly(control.value)) {
        let errorMessage = field.validation.messages['dspxRequired'].toString();
        if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
            errorMessage = `${field.props.label} required`;
        }
        return {
            dspxRequired: { message: errorMessage }
        };
    }
    else {
        return null;
    }
}

function whitespaceValidator(control, field, options) {
    if (control.value === undefined || control.value === null || isNullOrWhitespaceOnly(control.value)) {
        let errorMessage = field.validation.messages['whitespace'].toString();
        if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
            errorMessage = `${field.props.label} cannot only contain whitespace`;
        }
        return {
            whitespace: { message: errorMessage }
        };
    }
    else {
        return null;
    }
}

// Get dates from control and options objects. If options object
// does not provide a date in 'compareTo' variable it'll default
// to current date. If any of the dates are invalid function will
// return 'undefined'. If both dates are valid function will return
// object { datesValidated: DateTime|DateTime[], dateToCompareAgainst: DateTime }.
// - datesValidated contains date(s) provided in the control and
// - dateToCompareAgainst contains date provided in options.
function getDatesForComparison(control, field, options) {
    if (!control || !control.value || control === undefined || control.value === undefined || control.value === null) {
        return undefined;
    }
    let datesValidated;
    const dateTimeFormat = 'dd/MM/yyyy hh:mm a'; // E.g.: "25/10/2024 03:55 PM"
    if (field.props.selectionMode === 'multiple' || field.props.selectionMode === 'range') {
        datesValidated = [];
        const regex = /^(\d{2})(\/)(\d{2})(\/)(\d{4})$/i; //Regex for 'dd/MM/yyyy'
        for (let dateString of control.value) {
            if (regex.test(dateString)) {
                let dateToBeValidated = DateTime.fromFormat(dateString, 'dd/MM/yyyy', { locale: 'en-AU' });
                datesValidated.push(dateToBeValidated);
            }
            else {
                //Bail out if we encounter date strings that are not in the required format.
                //This can occur when our Formly date field is in the initialisation stage and the PrimeNg calendar control
                //within it has still got Date objects in its model, which would result is date strings like:
                //'Wed Feb 08 2023 00:00:00 GMT+1100 (Australian Eastern Daylight Time)'
                return undefined;
            }
        }
    }
    else {
        datesValidated = DateTime.fromFormat(control.value, 'dd/MM/yyyy', { locale: 'en-AU' });
        if (!datesValidated.isValid) {
            datesValidated = DateTime.fromFormat(control.value, dateTimeFormat, { locale: 'en-AU' });
        }
    }
    let dateToCompareAgainst;
    if ((options === undefined) || (options && (options['compareTo'] === undefined || options['compareTo'] === null))) {
        dateToCompareAgainst = DateTime.now().reconfigure({ locale: 'en-AU' });
    }
    else if (options && options['compareTo']) {
        switch (options['compareTo']) {
            case 'utility.getFyStartDate()': {
                dateToCompareAgainst = getFYDate(true);
                break;
            }
            case 'utility.getFyEndDate()': {
                dateToCompareAgainst = getFYDate(false);
                break;
            }
            case 'utility.getCyStartDate()': {
                dateToCompareAgainst = getCYDate(true);
                break;
            }
            case 'utility.getCyEndDate()': {
                dateToCompareAgainst = getCYDate(false);
                break;
            }
            case 'utility.checkEighteenYears()': {
                dateToCompareAgainst = getEighteenYears();
                break;
            }
            case 'utility.getDateRelativeToCurrentDate()': {
                dateToCompareAgainst = getDateRelativeToCurrentDate(options['dateUnit'], options['dateValue']);
                break;
            }
            default: {
                var isRepeatingPage = field.props.isRepeatingPage;
                var isRepeatingSection = field.props.isRepeatingSection;
                var isPopupQuestion = field.props.isPopupQuestion;
                var model = null;
                if (isPopupQuestion) {
                    model = field.parent.model;
                }
                else {
                    model = field.parent.parent.parent.parent.model;
                }
                if (isRepeatingPage && isRepeatingSection) {
                    model = field.parent.parent.parent.parent.parent.parent.model;
                }
                else if (isRepeatingPage || isRepeatingSection) {
                    model = field.parent.parent.parent.parent.parent.model;
                }
                if (!!model) {
                    const compareValue = findKey(model, options['compareTo']);
                    if (compareValue) {
                        dateToCompareAgainst = DateTime.fromFormat(compareValue, 'dd/MM/yyyy', { locale: 'en-AU' });
                        if (!dateToCompareAgainst.isValid) {
                            dateToCompareAgainst = DateTime.fromFormat(compareValue, dateTimeFormat, { locale: 'en-AU' });
                        }
                    }
                    else {
                        return undefined;
                    }
                }
                else {
                    return undefined;
                }
                break;
            }
        }
    }
    else {
        return undefined;
    }
    if (Array.isArray(datesValidated)) {
        for (const dateTime of datesValidated) {
            if (!dateTime.isValid) {
                return undefined;
            }
        }
    }
    else if ((datesValidated instanceof DateTime && !datesValidated.isValid)
        || !dateToCompareAgainst.isValid) {
        return undefined;
    }
    // Remove the time components from dates returned by formly.
    // (Formly field values can include time components even when the control is of type 'date').
    // dspx-core versions prior to 14.2.5 had a bug here: on iOS, the code to strip the time
    // component could fail for dates in months 1-9.
    if (field.type === 'date') {
        if (Array.isArray(datesValidated)) {
            for (let i = 0; i < datesValidated.length; i++) {
                datesValidated[i] = getDateComponent(datesValidated[i]);
            }
        }
        else {
            datesValidated = getDateComponent(datesValidated);
        }
        dateToCompareAgainst = getDateComponent(dateToCompareAgainst);
    }
    return { datesValidated, dateToCompareAgainst };
}
/** Given a Luxon DateTime, returns a new Luxon DateTime containing only the year, month and date
 *  components (i.e. discards the time components.)
 */
function getDateComponent(d) {
    return DateTime.local(d.year, d.month, d.day);
}
function findKey(obj, key) {
    for (const [k, v] of Object.entries(obj)) {
        if (k == key)
            return v;
        if (typeof v === 'object' && v !== null) {
            let found = findKey(v, key);
            if (found)
                return found;
        }
    }
}
// Gets the section from the form model for a given field.
function getSectionFromModel(field) {
    var isRepeatingPage = field.props.isRepeatingPage;
    var isRepeatingSection = field.props.isRepeatingSection;
    var tabKey = field.parent.parent.parent.key.toString();
    var pageKey = field.parent.parent.key.toString();
    var sectionCode = field.parent.key.toString();
    var model = field.parent.parent.parent.parent.model;
    if (isRepeatingPage && isRepeatingSection) {
        model = field.parent.parent.parent.parent.parent.parent.model;
        tabKey = field.parent.parent.parent.parent.parent.key.toString();
        pageKey = field.parent.parent.parent.parent.key.toString();
    }
    else if (isRepeatingPage || isRepeatingSection) {
        model = field.parent.parent.parent.parent.parent.model;
        tabKey = field.parent.parent.parent.parent.key.toString();
        pageKey = field.parent.parent.parent.key.toString();
    }
    if (isRepeatingSection) {
        sectionCode = field.parent.parent.key.toString();
    }
    if (model
        && model[tabKey]
        && model[tabKey][pageKey]) {
        let pageIndex;
        let sectionIndex;
        var pageObject = model[tabKey][pageKey];
        if (isRepeatingPage) {
            if (isRepeatingSection) {
                pageIndex = parseInt(field.parent.parent.parent.key.toString());
            }
            else {
                pageIndex = parseInt(field.parent.parent.key.toString());
            }
            pageObject = model[tabKey][pageKey][pageIndex];
        }
        if (pageObject && pageObject[sectionCode]) {
            var sectionObject = pageObject[sectionCode];
            if (isRepeatingSection) {
                sectionIndex = parseInt(field.parent.key.toString());
                sectionObject = pageObject[sectionCode][sectionIndex];
            }
            return sectionObject;
        }
    }
    return null;
}
// Gets the response for a question (based on a given question key) in the same tab-page-section as
// the reference field.
function getQuestionResponse(questionKey, referenceField) {
    var section = getSectionFromModel(referenceField);
    if (section && section[questionKey]) {
        return section[questionKey];
    }
    return null;
}
// Gets FY Dates
function getFYDate(startOfFy) {
    const today = DateTime.now().reconfigure({ locale: 'en-AU' });
    if (today.month < 7) {
        return startOfFy
            ? DateTime.fromObject({ year: today.year - 1, month: 7, day: 1, zone: today.zoneName }).reconfigure({ locale: 'en-AU' })
            : DateTime.fromObject({ year: today.year, month: 6, day: 30, zone: today.zoneName }).reconfigure({ locale: 'en-AU' });
    }
    else {
        return startOfFy
            ? DateTime.fromObject({ year: today.year, month: 7, day: 1, zone: today.zoneName }).reconfigure({ locale: 'en-AU' })
            : DateTime.fromObject({ year: today.year + 1, month: 6, day: 30, zone: today.zoneName }).reconfigure({ locale: 'en-AU' });
    }
}
// Gets CY Dates
function getCYDate(startOfCy) {
    const today = DateTime.now().reconfigure({ locale: 'en-AU' });
    return startOfCy
        ? DateTime.fromObject({ year: today.year, month: 1, day: 1, zone: today.zoneName }).reconfigure({ locale: 'en-AU' })
        : DateTime.fromObject({ year: today.year, month: 12, day: 31, zone: today.zoneName }).reconfigure({ locale: 'en-AU' });
}
// Gets Eighteen year date
function getEighteenYears() {
    const today = DateTime.now().reconfigure({ locale: 'en-AU' });
    return DateTime.fromObject({ year: today.year - 18, month: today.month, day: today.day, zone: today.zoneName }).reconfigure({ locale: 'en-AU' });
}
/**
 * Gets date relative to current date.
 * @param {string} dateUnit - Duration type. Possible values "year", "month", "day".
 * @param {number} value - Relative value. Example -1, 10, 5 etc.
 */
function getDateRelativeToCurrentDate(dateUnit, value) {
    const today = DateTime.now().reconfigure({ locale: 'en-AU' });
    const duration = {};
    switch (dateUnit) {
        case 'year': {
            duration.years = value;
            break;
        }
        case 'month': {
            duration.months = value;
            break;
        }
        case 'day': {
            duration.days = value;
            break;
        }
    }
    return today.plus(duration).setZone(today.zoneName).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).reconfigure({ locale: 'en-AU' });
}

//Note: this implementation of the 'same as' validator is working but not ideal.
//      - it does not support parent fields in a different section to the child field.
//      - it does not update child field validation message if the error is corrected in the parent field value.
//      E.g. Given that you have:
//        - Parent field
//        - Child field (whose value must be the same as the parent field)
//      If you enter 'aa' in the parent field, and then 'a' in the child field, the validation error will be returned.
//      If you then change the parent field value to 'a', the validation error is not removed from the child field.
//      A possible solution for this is to get the formConfigurationService.extendFieldConfig function to add an
//      an expressProperty to fields that require the 'same as' validator. This expression property will be use to
//      execute a function that forces the validation message to hide if the state is now valid.
function sameAsValidator(control, field, options) {
    // Below is the implementation for this validator at section level. This is correct way of implementing this validator
    // Ref#
    // Angular: https://angular.io/guide/form-validation#cross-field-validation
    // Formly: https://formly.dev/examples/validation/matching-two-fields
    // var areResponseMatching: boolean = true;
    // if (field.model){
    //   var questionKeys = options.dependentOnQuestionKeys; // Array of strings
    //   var previousQuestionAnswer: any = null;
    //   questionKeys.forEach((questionKey: string) => {
    //     var answerForQuestion = field.model[questionKey];
    //     if (answerForQuestion !== undefined && answerForQuestion !== null) {
    //       if (previousQuestionAnswer != null) {
    //         areResponseMatching = areResponseMatching && (previousQuestionAnswer === answerForQuestion)
    //       } else {
    //         previousQuestionAnswer = answerForQuestion;
    //       }
    //     }
    //   });
    // }
    // if (!areResponseMatching){
    //   let errorMessage = field.validation.messages['sameAs'].toString();
    //   if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
    //     errorMessage = `${field.props.label} not the same as ${options.dependentOnQuestionKey.toString()}`;
    //   }
    //   return {
    //     sameAs: { message: errorMessage }
    //   };
    // }
    // else {
    //   return null;
    // }
    // Below is the implementation for this validator at question level
    var response = getQuestionResponse(options.dependentOnQuestionKeys[0].toString(), field);
    if (response != control.value) {
        let errorMessage = field.validation.messages['sameAs'].toString();
        if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
            errorMessage = `${field.props.label} not the same as ${options.dependentOnQuestionKeys[0].toString()}`;
        }
        return {
            sameAs: { message: errorMessage }
        };
    }
    else {
        return null;
    }
}

//Note: this implementation of the 'different to' validator is working but not ideal.
//      - it does not support parent fields in a different section to the child field.
//      - it does not update child field validation message if the error is corrected in the parent field value.
//      E.g. Given that you have:
//        - Parent field
//        - Child field (whose value must be different to the parent field)
//      If you enter 'aa' in the parent field, and then 'a' in the child field, the validation error will be returned.
//      If you then change the parent field value to 'a', the validation error is not removed from the child field.
//      A possible solution for this is to get the formConfigurationService.extendFieldConfig function to add an
//      an expressProperty to fields that require the 'different to' validator. This expression property will be use to
//      execute a function that forces the validation message to hide if the state is now valid.
function differentToValidator(control, field, options) {
    // Below is the implementation for this validator at section level. This is correct way of implementing this validator
    // Ref#
    // Angular: https://angular.io/guide/form-validation#cross-field-validation
    // Formly: https://formly.dev/examples/validation/matching-two-fields
    // var areResponseDifferent: boolean = true;
    // if (field.model){
    //   var questionKeys = options.dependentOnQuestionKeys; // Array of strings
    //   var previousQuestionAnswer: any = null;
    //   questionKeys.forEach((questionKey: string) => {
    //     var answerForQuestion = field.model[questionKey];
    //     if (answerForQuestion !== undefined && answerForQuestion !== null) {
    //       if (previousQuestionAnswer != null) {
    //         areResponseDifferent = areResponseDifferent && (previousQuestionAnswer !== answerForQuestion)
    //       } else {
    //         previousQuestionAnswer = answerForQuestion;
    //       }
    //     }
    //   });
    // }
    // if (!areResponseDifferent){
    //   let errorMessage = field.validation.messages['differentTo'].toString();
    //   if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
    //     errorMessage = `${field.props.label} not different to ${options.dependentOnQuestionKey.toString()}`;
    //   }
    //   return {
    //     differentTo: { message: errorMessage }
    //   };
    // }
    // else {
    //   return null;
    // }
    // Below is the implementation for this validator at question level
    var response = getQuestionResponse(options.dependentOnQuestionKeys[0].toString(), field);
    if (response == control.value) {
        let errorMessage = field.validation.messages['differentTo'].toString();
        if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
            errorMessage = `${field.props.label} not different to ${options.dependentOnQuestionKeys[0].toString()}`;
        }
        return {
            differentTo: { message: errorMessage }
        };
    }
    else {
        return null;
    }
}

//Note: this implementation of the 'either mandatory' validator is working but not ideal.
//      - it does not support dependent on fields in a different section to the child field.
function eitherMandatoryValidator(control, field, options) {
    // Ref#
    // Angular: https://angular.io/guide/form-validation#cross-field-validation
    // Formly: https://formly.dev/examples/validation/matching-two-fields
    let atLeastOneFieldHasValue = false;
    let atLeastOneFieldIsVisible = false;
    if (field.model) {
        var questionKeys = options.dependentOnQuestionKeys; // Array of strings
        questionKeys.forEach((questionKey) => {
            // Check if the field is visible or not
            var questionField = field.fieldGroup.find(f => f.key === questionKey);
            if (questionField && questionField.hide === false) {
                atLeastOneFieldIsVisible = true;
                var answerForQuestion = field.model[questionKey];
                if (answerForQuestion !== undefined && answerForQuestion !== null && answerForQuestion !== '' && !isNullOrWhitespaceOnly(answerForQuestion)) {
                    atLeastOneFieldHasValue = true;
                }
            }
        });
    }
    if (!atLeastOneFieldIsVisible) {
        return null;
    }
    if (!atLeastOneFieldHasValue) {
        let errorMessage = options && options.messageKey ? field.validation.messages[options.messageKey].toString() : field.validation.messages['eitherMandatory'].toString();
        if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
            var questionKeys = options.dependentOnQuestionKeys.join(", ");
            errorMessage = `At least one of these fields must have a value: ${field.props.label}, ${questionKeys}`;
        }
        return {
            eitherMandatory: { message: errorMessage }
        };
    }
    else {
        return null;
    }
}

function dateValidator(control, field, options) {
    if (control.value === null || control.value === undefined) {
        if (field && field.props.required === true) {
            return { date: { message: 'Invalid date' } };
        }
        return null;
    }
    let date = DateTime.fromFormat(control.value, 'dd/MM/yyyy');
    if (date.isValid) {
        return null;
    }
    let errorMessage = field.validation.messages['date'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        errorMessage = `${field.props.label} is not a valid date`;
    }
    return {
        date: { message: errorMessage }
    };
}

function dateLessThanValidator(control, field, options) {
    const dates = getDatesForComparison(control, field, options);
    if (dates === undefined) {
        if (field && field.props.required === true) {
            return { dateLessThan: { message: 'Invalid date' } };
        }
        return null;
    }
    const { datesValidated, dateToCompareAgainst } = dates;
    if (datesValidated === null || datesValidated === undefined) {
        return null;
    }
    if (Array.isArray(datesValidated)) {
        let hasAllValidDates = true;
        for (const date of datesValidated) {
            if (date >= dateToCompareAgainst) {
                hasAllValidDates = false;
            }
        }
        if (hasAllValidDates) {
            return null;
        }
    }
    else if (datesValidated < dateToCompareAgainst) {
        return null;
    }
    let errorMessage = field.validation.messages['dateLessThan'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        if (options && options.compareTo) {
            errorMessage = `${field.props.label} is not less than ${options.compareTo.toString()}`;
        }
        else {
            errorMessage = `${field.props.label} is not less than today`;
        }
    }
    return {
        dateLessThan: { message: errorMessage }
    };
}

function dateLessThanOrEqualToValidator(control, field, options) {
    const dates = getDatesForComparison(control, field, options);
    if (dates === undefined) {
        if (field && field.props.required === true) {
            return { dateLessThanOrEqualTo: { message: 'Invalid date' } };
        }
        return null;
    }
    const { datesValidated, dateToCompareAgainst } = dates;
    if (datesValidated === null || datesValidated === undefined) {
        return null;
    }
    if (Array.isArray(datesValidated)) {
        let hasAllValidDates = true;
        for (const date of datesValidated) {
            if (date > dateToCompareAgainst) {
                hasAllValidDates = false;
            }
        }
        if (hasAllValidDates) {
            return null;
        }
    }
    else if (datesValidated <= dateToCompareAgainst) {
        return null;
    }
    let errorMessage = field.validation.messages['dateLessThanOrEqualTo'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        if (options && options.compareTo) {
            errorMessage = `${field.props.label} is not less than or equal to ${options.compareTo.toString()}`;
        }
        else {
            errorMessage = `${field.props.label} is not less than or equal to today`;
        }
    }
    return {
        dateLessThanOrEqualTo: { message: errorMessage }
    };
}

function dateGreaterThanValidator(control, field, options) {
    const dates = getDatesForComparison(control, field, options);
    if (dates === undefined) {
        if (field && field.props.required === true) {
            return { dateGreaterThan: { message: 'Invalid date' } };
        }
        return null;
    }
    const { datesValidated, dateToCompareAgainst } = dates;
    if (datesValidated === null || datesValidated === undefined) {
        return null;
    }
    if (Array.isArray(datesValidated)) {
        let hasAllValidDates = true;
        for (const date of datesValidated) {
            if (date <= dateToCompareAgainst) {
                hasAllValidDates = false;
            }
        }
        if (hasAllValidDates) {
            return null;
        }
    }
    else if (datesValidated > dateToCompareAgainst) {
        return null;
    }
    let errorMessage = field.validation.messages['dateGreaterThan'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        if (options && options.compareTo) {
            errorMessage = `${field.props.label} is not greater than ${options.compareTo.toString()}`;
        }
        else {
            errorMessage = `${field.props.label} is not greater than today`;
        }
    }
    return {
        dateGreaterThan: { message: errorMessage }
    };
}

function dateGreaterThanOrEqualToValidator(control, field, options) {
    const dates = getDatesForComparison(control, field, options);
    if (dates === undefined) {
        if (field && field.props.required === true) {
            return { dateGreaterThanOrEqualTo: { message: 'Invalid date' } };
        }
        return null;
    }
    const { datesValidated, dateToCompareAgainst } = dates;
    if (datesValidated === null || datesValidated === undefined) {
        return null;
    }
    if (Array.isArray(datesValidated)) {
        let hasAllValidDates = true;
        for (const date of datesValidated) {
            if (date < dateToCompareAgainst) {
                hasAllValidDates = false;
            }
        }
        if (hasAllValidDates) {
            return null;
        }
    }
    else if (datesValidated >= dateToCompareAgainst) {
        return null;
    }
    let errorMessage = field.validation.messages['dateGreaterThanOrEqualTo'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        if (options && options.compareTo) {
            errorMessage = `${field.props.label} is not greater than or equal to ${options.compareTo.toString()}`;
        }
        else {
            errorMessage = `${field.props.label} is not greater than or equal to today`;
        }
    }
    return {
        dateGreaterThanOrEqualTo: { message: errorMessage }
    };
}

function numberGreaterThanValidator(control, field, options) {
    if (options && options.compareTo != null && !isNullOrWhitespaceOnly(control.value) &&
        control.value > options.compareTo) {
        return null;
    }
    let errorMessage = field.validation.messages['numberGreaterThan'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        if (options && options.compareTo != null) {
            errorMessage = `${field.props.label} is not greater than ${options.compareTo.toString()}`;
        }
        else {
            errorMessage = `${field.props.label} is not greater than ?`;
        }
    }
    return {
        numberGreaterThan: { message: errorMessage }
    };
}

function numberLessThanValidator(control, field, options) {
    if (options && options.compareTo != null && !isNullOrWhitespaceOnly(control.value) &&
        control.value < options.compareTo) {
        return null;
    }
    let errorMessage = field.validation.messages['numberLessThan'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        if (options && options.compareTo != null) {
            errorMessage = `${field.props.label} is not less than ${options.compareTo.toString()}`;
        }
        else {
            errorMessage = `${field.props.label} is not less than ?`;
        }
    }
    return {
        numberLessThan: { message: errorMessage }
    };
}

function verificationRequiredValidator(control, field, options) {
    if (field.model && field.props.statusControlId) {
        if (field.model[field.props.statusControlId] && field.model[field.props.statusControlId] === IdVerificationStatus.Y) {
            return null;
        }
    }
    let errorMessage = field.validation.messages['verificationRequired'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        errorMessage = `${field.props.label} is not verified}`;
    }
    return {
        verificationRequired: { message: errorMessage }
    };
}

function timeValidator(control, field, options) {
    if (control.value === null || control.value === undefined) {
        if (field && field.props.required === true) {
            return { time: { message: 'Invalid time' } };
        }
        return null;
    }
    console.log(control.value);
    // Examples of acceptable values: '01:09 PM', '10:11 AM'.
    let timeStringSplit = control.value.split(' ');
    let timeSplit = timeStringSplit[0].split(':');
    let strHour = timeSplit[0];
    let strMinute = timeSplit[1];
    let meridiem = timeStringSplit.pop();
    let hour = parseInt(strHour, 10);
    let minute = parseInt(strMinute, 10);
    let regexNumeric = /^\d+$/;
    if (regexNumeric.test(strHour) && regexNumeric.test(strMinute)
        && hour >= 1 && hour <= 12
        && minute >= 0 && minute <= 59
        && (meridiem === 'AM' || meridiem === 'PM')) {
        return null;
    }
    let errorMessage = field.validation.messages['time'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        errorMessage = `${field.props.label} is not a valid time`;
    }
    return {
        time: { message: errorMessage }
    };
}

function urlValidator(control, field, options) {
    if (control.value != null && control.value !== '' && /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(control.value) === false) {
        let errorMessage = field.validation.messages['url'].toString();
        if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
            errorMessage = `${field.props.label} is not a valid URL`;
        }
        return {
            whitespace: { message: errorMessage }
        };
    }
    else {
        return null;
    }
}

function customValidator(control, field, options) {
    if (options.function === true) {
        return null;
    }
    let errorMessage = field.validation.messages['custom'].toString();
    if (errorMessage === undefined || errorMessage === null || errorMessage === '') {
        errorMessage = `${field.props.label} failed custom validation`;
    }
    return {
        custom: { message: errorMessage }
    };
}

/*
 * Public API Surface of dspx-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressFieldType, AddressService, ApiService, ApplicationSettings, ApplicationSettingsService, ArrayService, AutoCompleteFieldType, BreadcrumbService, ButtonFieldType, ButtonType, CHECKBOX_VALUE_ACCESSOR, CancelEditableRow, CardSectionFieldType, CardSectionOverviewFieldType, CardSectionRepeatingFieldType, CardSetPageFieldType, CardSetPageInfoFieldType, CardSetPageListFieldType, CardSetPageOverviewFieldType, CardSetPageRepeatingFieldType, CardSetTabsFieldType, CardSetTabsFlatFieldType, CardSetTransformationService, CellEditor, ChartFieldType, Checkbox, CheckboxFieldType, CheckedListBoxType, ColumnFilter, ColumnFilterFormElement, ContextMenuRow, CoreService, CustomListFieldType, DashboardOptions, DataListFieldType, DataService, DateFieldType, DateTimeFieldType, DecimalFieldType, DialogResult, DialogService, Dialogs, DisplayFieldType, DocumentListFieldType, DocumentService, DspxBaseFormCommonComponent, DspxBaseFormComponent, DspxBaseFormReportComponent, DspxBasePanelRepeaterComponent, DspxBaseRepeaterComponent, DspxBaseTableRepeaterComponent, DspxBreadcrumbComponent, DspxCardSectionViewModeComponent, DspxCardSetBaseFormComponent, DspxCardSetBaseFormReadOnlyComponent, DspxCardSetBaseFormWithHeaderComponent, DspxCardSetFooterComponent, DspxCardSetHeaderComponent, DspxCardSetMenuComponent, DspxCardSetMenuItemComponent, DspxCoreComponent, DspxCoreModule, DspxCoreService, DspxDashboardComponent, DspxDescriptionComponent, DspxDialogComponent, DspxEnvironmentBannerComponent, DspxExcelFileUploadComponent, DspxFileUploadWrapper, DspxFooterComponent, DspxFormHeaderComponent, DspxHeaderBarComponent, DspxHeaderComponent, DspxHeadingComponent, DspxLabelWrapperFormField, DspxLogoutComponent, DspxMobileMenuComponent, DspxMobileMenuTriggerComponent, DspxPanelRepeaterComponent, DspxQuestionsViewModeComponent, DspxRadioWrapperFormField, DspxSecondaryNavigationComponent, DspxSectionCompareBadgeComponent, DspxSectionViewModeComponent, DspxSequentialNavigationComponent, DspxSequentialNavigationPanelComponent, DspxShowHideTextComponent, DspxSpinnerComponent, DspxStatusBarComponent, DspxTabSetComponent, DspxTableRepeaterComponent, DspxValidationSummaryComponent, DspxWrapperContainer, DspxWrapperFilter, DspxWrapperFormField, DspxWrapperTableCell, EditableColumn, EditableRow, EditorFieldType, ElementType, ExcelFileUploadType, ExcelService, FeatureUpdate, FileService, FileUpload, FileUploadFieldType, FileUploadModule, FilterFieldType, FormConfigurationService, FormNavigationFieldType, FormNavigationService, FormSummaryFieldType, FormSummaryV2FieldType, FrozenColumn, GlobalErrorHandler, GridDataHelpers, HeaderFieldType, HeaderService, HorizontalStepperFieldType, HtmlHeadingFieldType, HttpErrorInterceptor, IdVerificationService, ImageFieldType, InitEditableRow, InputFieldType, LabelFieldType, ListFieldType, ListboxFieldType, MapService, MaskedInputFieldType, MenuConfigService, MenuService, MessageListFieldType, MessageSeverity, Messages, MessagesModule, MultiselectFieldType, MultiselectPillFieldType, NavigationKey, NoteListFieldType, NotificationType, Option, OptionSetService, OptionsSearchService, PBIEmbeddedFieldType, PageFieldType, PageRepeatingFieldType, Paginator, PaginatorModule, ParagraphFieldType, PasswordFieldType, PopupType, PowerBiService, QuickHelpFieldType, RADIO_VALUE_ACCESSOR, RadioButton, RadioButtonModule, RadioControlRegistry, RadioFieldType, RelatedEntitySummaryFieldType, ReorderableColumn, ReorderableRow, ReorderableRowHandle, RepeaterButtonTypes, RepeaterCustomButtonSubTypes, RepeaterElementType, RepeaterItemChangeType, RepeaterRegistryService, RepeaterService, RepeaterStandardButtonSubTypes, ReportDataService, ResizableColumn, RowGroupHeader, RowToggler, SaveEditableRow, SearchBoxFieldType, SectionCompareFieldType, SectionFieldType, SectionLoginFieldType, SectionRepeatingFieldType, SectionRepeatingInformationFieldType, SectionVerificationFieldType, SelectButtonFieldType, SelectFieldType, SelectableRow, SelectableRowDblClick, SingleCheckboxFieldType, SortIcon, SortableColumn, SpinnerService, StepsFieldType, StickyElementDirective, StickyElementService, StringService, StyleConfigService, SupportedNavigationTargetTypes, SwitchFieldType, TabPanel, TabView, Table, TableBody, TableCheckbox, TableColumn, TableEditorFieldType, TableFieldType, TableHeaderCheckbox, TableModule, TableRadioButton, TableService, TabsFieldType, TestingDataService, TextAreaFieldType, TimeFieldType, TimelineFieldType, UploadedFile, UserService, VerticalStepperFieldType, customValidator, dateGreaterThanOrEqualToValidator, dateGreaterThanValidator, dateLessThanOrEqualToValidator, dateLessThanValidator, dateValidator, differentToValidator, dspxRequiredValidator, eitherMandatoryValidator, getAppSettings, init_app, numberGreaterThanValidator, numberLessThanValidator, sameAsValidator, timeValidator, urlValidator, verificationRequiredValidator, whitespaceValidator };
